(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6XFBA", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $511886b7d9d0362d$export$ffb0004e005737fa; }, function (v) { return $511886b7d9d0362d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $511886b7d9d0362d$export$34b9dba7ce09269b; }, function (v) { return $511886b7d9d0362d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $511886b7d9d0362d$export$25062201e9e25d76; }, function (v) { return $511886b7d9d0362d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $511886b7d9d0362d$export$ffb0004e005737fa;
var $511886b7d9d0362d$export$34b9dba7ce09269b;
var $511886b7d9d0362d$export$25062201e9e25d76;
'use strict';

var $9nZCP = parcelRequire("9nZCP");
var $511886b7d9d0362d$var$k = Symbol.for("react.element"), $511886b7d9d0362d$var$l = Symbol.for("react.fragment"), $511886b7d9d0362d$var$m = Object.prototype.hasOwnProperty, $511886b7d9d0362d$var$n = $9nZCP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $511886b7d9d0362d$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $511886b7d9d0362d$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$511886b7d9d0362d$var$m.call(a, b) && !$511886b7d9d0362d$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $511886b7d9d0362d$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $511886b7d9d0362d$var$n.current
    };
}
$511886b7d9d0362d$export$ffb0004e005737fa = $511886b7d9d0362d$var$l;
$511886b7d9d0362d$export$34b9dba7ce09269b = $511886b7d9d0362d$var$q;
$511886b7d9d0362d$export$25062201e9e25d76 = $511886b7d9d0362d$var$q;

});
parcelRegister("9nZCP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("346v6"));

});
parcelRegister("346v6", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $23b6c9b94a5b5dc9$export$dca3b0875bd9a954; }, function (v) { return $23b6c9b94a5b5dc9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $23b6c9b94a5b5dc9$export$16fa2f45be04daa8; }, function (v) { return $23b6c9b94a5b5dc9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $23b6c9b94a5b5dc9$export$ffb0004e005737fa; }, function (v) { return $23b6c9b94a5b5dc9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $23b6c9b94a5b5dc9$export$e2c29f18771995cb; }, function (v) { return $23b6c9b94a5b5dc9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $23b6c9b94a5b5dc9$export$221d75b3f55bb0bd; }, function (v) { return $23b6c9b94a5b5dc9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $23b6c9b94a5b5dc9$export$5f8d39834fd61797; }, function (v) { return $23b6c9b94a5b5dc9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $23b6c9b94a5b5dc9$export$74bf444e3cd11ea5; }, function (v) { return $23b6c9b94a5b5dc9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $23b6c9b94a5b5dc9$export$ae55be85d98224ed; }, function (v) { return $23b6c9b94a5b5dc9$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $23b6c9b94a5b5dc9$export$3ba232387fd5d6dd; }, function (v) { return $23b6c9b94a5b5dc9$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $23b6c9b94a5b5dc9$export$e530037191fcd5d7; }, function (v) { return $23b6c9b94a5b5dc9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $23b6c9b94a5b5dc9$export$fd42f52fd3ae1109; }, function (v) { return $23b6c9b94a5b5dc9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $23b6c9b94a5b5dc9$export$c8a8987d4410bf2d; }, function (v) { return $23b6c9b94a5b5dc9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $23b6c9b94a5b5dc9$export$d38cd72104c1f0e9; }, function (v) { return $23b6c9b94a5b5dc9$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $23b6c9b94a5b5dc9$export$7d1e3a5e95ceca43; }, function (v) { return $23b6c9b94a5b5dc9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $23b6c9b94a5b5dc9$export$257a8862b851cb5b; }, function (v) { return $23b6c9b94a5b5dc9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $23b6c9b94a5b5dc9$export$a8257692ac88316c; }, function (v) { return $23b6c9b94a5b5dc9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $23b6c9b94a5b5dc9$export$488013bae63b21da; }, function (v) { return $23b6c9b94a5b5dc9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $23b6c9b94a5b5dc9$export$7c73462e0d25e514; }, function (v) { return $23b6c9b94a5b5dc9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $23b6c9b94a5b5dc9$export$7568632d0d33d16d; }, function (v) { return $23b6c9b94a5b5dc9$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $23b6c9b94a5b5dc9$export$88948ce120ea2619; }, function (v) { return $23b6c9b94a5b5dc9$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $23b6c9b94a5b5dc9$export$35808ee640e87ca7; }, function (v) { return $23b6c9b94a5b5dc9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $23b6c9b94a5b5dc9$export$fae74005e78b1a27; }, function (v) { return $23b6c9b94a5b5dc9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $23b6c9b94a5b5dc9$export$dc8fbce3eb94dc1e; }, function (v) { return $23b6c9b94a5b5dc9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $23b6c9b94a5b5dc9$export$6a7bc4e911dc01cf; }, function (v) { return $23b6c9b94a5b5dc9$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $23b6c9b94a5b5dc9$export$6d9c69b0de29b591; }, function (v) { return $23b6c9b94a5b5dc9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $23b6c9b94a5b5dc9$export$f680877a34711e37; }, function (v) { return $23b6c9b94a5b5dc9$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $23b6c9b94a5b5dc9$export$d5a552a76deda3c2; }, function (v) { return $23b6c9b94a5b5dc9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $23b6c9b94a5b5dc9$export$aaabe4eda9ed9969; }, function (v) { return $23b6c9b94a5b5dc9$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $23b6c9b94a5b5dc9$export$e5c5a5f917a5871c; }, function (v) { return $23b6c9b94a5b5dc9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $23b6c9b94a5b5dc9$export$1538c33de8887b59; }, function (v) { return $23b6c9b94a5b5dc9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $23b6c9b94a5b5dc9$export$13e3392192263954; }, function (v) { return $23b6c9b94a5b5dc9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $23b6c9b94a5b5dc9$export$b8f5890fc79d6aca; }, function (v) { return $23b6c9b94a5b5dc9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $23b6c9b94a5b5dc9$export$60241385465d0a34; }, function (v) { return $23b6c9b94a5b5dc9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $23b6c9b94a5b5dc9$export$306c0aa65ff9ec16; }, function (v) { return $23b6c9b94a5b5dc9$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $23b6c9b94a5b5dc9$export$7b286972b8d8ccbf; }, function (v) { return $23b6c9b94a5b5dc9$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $23b6c9b94a5b5dc9$export$83d89fbfd8236492; }, function (v) { return $23b6c9b94a5b5dc9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $23b6c9b94a5b5dc9$export$dca3b0875bd9a954;
var $23b6c9b94a5b5dc9$export$16fa2f45be04daa8;
var $23b6c9b94a5b5dc9$export$ffb0004e005737fa;
var $23b6c9b94a5b5dc9$export$e2c29f18771995cb;
var $23b6c9b94a5b5dc9$export$221d75b3f55bb0bd;
var $23b6c9b94a5b5dc9$export$5f8d39834fd61797;
var $23b6c9b94a5b5dc9$export$74bf444e3cd11ea5;
var $23b6c9b94a5b5dc9$export$ae55be85d98224ed;
var $23b6c9b94a5b5dc9$export$3ba232387fd5d6dd;
var $23b6c9b94a5b5dc9$export$e530037191fcd5d7;
var $23b6c9b94a5b5dc9$export$fd42f52fd3ae1109;
var $23b6c9b94a5b5dc9$export$c8a8987d4410bf2d;
var $23b6c9b94a5b5dc9$export$d38cd72104c1f0e9;
var $23b6c9b94a5b5dc9$export$7d1e3a5e95ceca43;
var $23b6c9b94a5b5dc9$export$257a8862b851cb5b;
var $23b6c9b94a5b5dc9$export$a8257692ac88316c;
var $23b6c9b94a5b5dc9$export$488013bae63b21da;
var $23b6c9b94a5b5dc9$export$7c73462e0d25e514;
var $23b6c9b94a5b5dc9$export$7568632d0d33d16d;
var $23b6c9b94a5b5dc9$export$88948ce120ea2619;
var $23b6c9b94a5b5dc9$export$35808ee640e87ca7;
var $23b6c9b94a5b5dc9$export$fae74005e78b1a27;
var $23b6c9b94a5b5dc9$export$dc8fbce3eb94dc1e;
var $23b6c9b94a5b5dc9$export$6a7bc4e911dc01cf;
var $23b6c9b94a5b5dc9$export$6d9c69b0de29b591;
var $23b6c9b94a5b5dc9$export$f680877a34711e37;
var $23b6c9b94a5b5dc9$export$d5a552a76deda3c2;
var $23b6c9b94a5b5dc9$export$aaabe4eda9ed9969;
var $23b6c9b94a5b5dc9$export$e5c5a5f917a5871c;
var $23b6c9b94a5b5dc9$export$1538c33de8887b59;
var $23b6c9b94a5b5dc9$export$13e3392192263954;
var $23b6c9b94a5b5dc9$export$b8f5890fc79d6aca;
var $23b6c9b94a5b5dc9$export$60241385465d0a34;
var $23b6c9b94a5b5dc9$export$306c0aa65ff9ec16;
var $23b6c9b94a5b5dc9$export$7b286972b8d8ccbf;
var $23b6c9b94a5b5dc9$export$83d89fbfd8236492;
'use strict';
var $23b6c9b94a5b5dc9$var$l = Symbol.for("react.element"), $23b6c9b94a5b5dc9$var$n = Symbol.for("react.portal"), $23b6c9b94a5b5dc9$var$p = Symbol.for("react.fragment"), $23b6c9b94a5b5dc9$var$q = Symbol.for("react.strict_mode"), $23b6c9b94a5b5dc9$var$r = Symbol.for("react.profiler"), $23b6c9b94a5b5dc9$var$t = Symbol.for("react.provider"), $23b6c9b94a5b5dc9$var$u = Symbol.for("react.context"), $23b6c9b94a5b5dc9$var$v = Symbol.for("react.forward_ref"), $23b6c9b94a5b5dc9$var$w = Symbol.for("react.suspense"), $23b6c9b94a5b5dc9$var$x = Symbol.for("react.memo"), $23b6c9b94a5b5dc9$var$y = Symbol.for("react.lazy"), $23b6c9b94a5b5dc9$var$z = Symbol.iterator;
function $23b6c9b94a5b5dc9$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $23b6c9b94a5b5dc9$var$z && a[$23b6c9b94a5b5dc9$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $23b6c9b94a5b5dc9$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $23b6c9b94a5b5dc9$var$C = Object.assign, $23b6c9b94a5b5dc9$var$D = {};
function $23b6c9b94a5b5dc9$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $23b6c9b94a5b5dc9$var$D;
    this.updater = e || $23b6c9b94a5b5dc9$var$B;
}
$23b6c9b94a5b5dc9$var$E.prototype.isReactComponent = {};
$23b6c9b94a5b5dc9$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$23b6c9b94a5b5dc9$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $23b6c9b94a5b5dc9$var$F() {}
$23b6c9b94a5b5dc9$var$F.prototype = $23b6c9b94a5b5dc9$var$E.prototype;
function $23b6c9b94a5b5dc9$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $23b6c9b94a5b5dc9$var$D;
    this.updater = e || $23b6c9b94a5b5dc9$var$B;
}
var $23b6c9b94a5b5dc9$var$H = $23b6c9b94a5b5dc9$var$G.prototype = new $23b6c9b94a5b5dc9$var$F;
$23b6c9b94a5b5dc9$var$H.constructor = $23b6c9b94a5b5dc9$var$G;
$23b6c9b94a5b5dc9$var$C($23b6c9b94a5b5dc9$var$H, $23b6c9b94a5b5dc9$var$E.prototype);
$23b6c9b94a5b5dc9$var$H.isPureReactComponent = !0;
var $23b6c9b94a5b5dc9$var$I = Array.isArray, $23b6c9b94a5b5dc9$var$J = Object.prototype.hasOwnProperty, $23b6c9b94a5b5dc9$var$K = {
    current: null
}, $23b6c9b94a5b5dc9$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $23b6c9b94a5b5dc9$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$23b6c9b94a5b5dc9$var$J.call(b, d) && !$23b6c9b94a5b5dc9$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $23b6c9b94a5b5dc9$var$K.current
    };
}
function $23b6c9b94a5b5dc9$var$N(a, b) {
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $23b6c9b94a5b5dc9$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $23b6c9b94a5b5dc9$var$l;
}
function $23b6c9b94a5b5dc9$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $23b6c9b94a5b5dc9$var$P = /\/+/g;
function $23b6c9b94a5b5dc9$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $23b6c9b94a5b5dc9$var$escape("" + a.key) : b.toString(36);
}
function $23b6c9b94a5b5dc9$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $23b6c9b94a5b5dc9$var$l:
                case $23b6c9b94a5b5dc9$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $23b6c9b94a5b5dc9$var$Q(h, 0) : d, $23b6c9b94a5b5dc9$var$I(c) ? (e = "", null != a && (e = a.replace($23b6c9b94a5b5dc9$var$P, "$&/") + "/"), $23b6c9b94a5b5dc9$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($23b6c9b94a5b5dc9$var$O(c) && (c = $23b6c9b94a5b5dc9$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($23b6c9b94a5b5dc9$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($23b6c9b94a5b5dc9$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $23b6c9b94a5b5dc9$var$Q(k, g);
        h += $23b6c9b94a5b5dc9$var$R(k, b, e, f, c);
    }
    else if (f = $23b6c9b94a5b5dc9$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $23b6c9b94a5b5dc9$var$Q(k, g++), h += $23b6c9b94a5b5dc9$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $23b6c9b94a5b5dc9$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $23b6c9b94a5b5dc9$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $23b6c9b94a5b5dc9$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $23b6c9b94a5b5dc9$var$U = {
    current: null
}, $23b6c9b94a5b5dc9$var$V = {
    transition: null
}, $23b6c9b94a5b5dc9$var$W = {
    ReactCurrentDispatcher: $23b6c9b94a5b5dc9$var$U,
    ReactCurrentBatchConfig: $23b6c9b94a5b5dc9$var$V,
    ReactCurrentOwner: $23b6c9b94a5b5dc9$var$K
};
function $23b6c9b94a5b5dc9$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$23b6c9b94a5b5dc9$export$dca3b0875bd9a954 = {
    map: $23b6c9b94a5b5dc9$var$S,
    forEach: function(a, b, e) {
        $23b6c9b94a5b5dc9$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $23b6c9b94a5b5dc9$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $23b6c9b94a5b5dc9$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$23b6c9b94a5b5dc9$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$23b6c9b94a5b5dc9$export$16fa2f45be04daa8 = $23b6c9b94a5b5dc9$var$E;
$23b6c9b94a5b5dc9$export$ffb0004e005737fa = $23b6c9b94a5b5dc9$var$p;
$23b6c9b94a5b5dc9$export$e2c29f18771995cb = $23b6c9b94a5b5dc9$var$r;
$23b6c9b94a5b5dc9$export$221d75b3f55bb0bd = $23b6c9b94a5b5dc9$var$G;
$23b6c9b94a5b5dc9$export$5f8d39834fd61797 = $23b6c9b94a5b5dc9$var$q;
$23b6c9b94a5b5dc9$export$74bf444e3cd11ea5 = $23b6c9b94a5b5dc9$var$w;
$23b6c9b94a5b5dc9$export$ae55be85d98224ed = $23b6c9b94a5b5dc9$var$W;
$23b6c9b94a5b5dc9$export$3ba232387fd5d6dd = $23b6c9b94a5b5dc9$var$X;
$23b6c9b94a5b5dc9$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $23b6c9b94a5b5dc9$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $23b6c9b94a5b5dc9$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$23b6c9b94a5b5dc9$var$J.call(b, f) && !$23b6c9b94a5b5dc9$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$23b6c9b94a5b5dc9$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $23b6c9b94a5b5dc9$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $23b6c9b94a5b5dc9$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$23b6c9b94a5b5dc9$export$c8a8987d4410bf2d = $23b6c9b94a5b5dc9$var$M;
$23b6c9b94a5b5dc9$export$d38cd72104c1f0e9 = function(a) {
    var b = $23b6c9b94a5b5dc9$var$M.bind(null, a);
    b.type = a;
    return b;
};
$23b6c9b94a5b5dc9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$23b6c9b94a5b5dc9$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$v,
        render: a
    };
};
$23b6c9b94a5b5dc9$export$a8257692ac88316c = $23b6c9b94a5b5dc9$var$O;
$23b6c9b94a5b5dc9$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $23b6c9b94a5b5dc9$var$T
    };
};
$23b6c9b94a5b5dc9$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $23b6c9b94a5b5dc9$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$23b6c9b94a5b5dc9$export$7568632d0d33d16d = function(a) {
    var b = $23b6c9b94a5b5dc9$var$V.transition;
    $23b6c9b94a5b5dc9$var$V.transition = {};
    try {
        a();
    } finally{
        $23b6c9b94a5b5dc9$var$V.transition = b;
    }
};
$23b6c9b94a5b5dc9$export$88948ce120ea2619 = $23b6c9b94a5b5dc9$var$X;
$23b6c9b94a5b5dc9$export$35808ee640e87ca7 = function(a, b) {
    return $23b6c9b94a5b5dc9$var$U.current.useCallback(a, b);
};
$23b6c9b94a5b5dc9$export$fae74005e78b1a27 = function(a) {
    return $23b6c9b94a5b5dc9$var$U.current.useContext(a);
};
$23b6c9b94a5b5dc9$export$dc8fbce3eb94dc1e = function() {};
$23b6c9b94a5b5dc9$export$6a7bc4e911dc01cf = function(a) {
    return $23b6c9b94a5b5dc9$var$U.current.useDeferredValue(a);
};
$23b6c9b94a5b5dc9$export$6d9c69b0de29b591 = function(a, b) {
    return $23b6c9b94a5b5dc9$var$U.current.useEffect(a, b);
};
$23b6c9b94a5b5dc9$export$f680877a34711e37 = function() {
    return $23b6c9b94a5b5dc9$var$U.current.useId();
};
$23b6c9b94a5b5dc9$export$d5a552a76deda3c2 = function(a, b, e) {
    return $23b6c9b94a5b5dc9$var$U.current.useImperativeHandle(a, b, e);
};
$23b6c9b94a5b5dc9$export$aaabe4eda9ed9969 = function(a, b) {
    return $23b6c9b94a5b5dc9$var$U.current.useInsertionEffect(a, b);
};
$23b6c9b94a5b5dc9$export$e5c5a5f917a5871c = function(a, b) {
    return $23b6c9b94a5b5dc9$var$U.current.useLayoutEffect(a, b);
};
$23b6c9b94a5b5dc9$export$1538c33de8887b59 = function(a, b) {
    return $23b6c9b94a5b5dc9$var$U.current.useMemo(a, b);
};
$23b6c9b94a5b5dc9$export$13e3392192263954 = function(a, b, e) {
    return $23b6c9b94a5b5dc9$var$U.current.useReducer(a, b, e);
};
$23b6c9b94a5b5dc9$export$b8f5890fc79d6aca = function(a) {
    return $23b6c9b94a5b5dc9$var$U.current.useRef(a);
};
$23b6c9b94a5b5dc9$export$60241385465d0a34 = function(a) {
    return $23b6c9b94a5b5dc9$var$U.current.useState(a);
};
$23b6c9b94a5b5dc9$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $23b6c9b94a5b5dc9$var$U.current.useSyncExternalStore(a, b, e);
};
$23b6c9b94a5b5dc9$export$7b286972b8d8ccbf = function() {
    return $23b6c9b94a5b5dc9$var$U.current.useTransition();
};
$23b6c9b94a5b5dc9$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("lNe1g", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $fdd90c8cbe9e299b$export$ae55be85d98224ed; }, function (v) { return $fdd90c8cbe9e299b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $fdd90c8cbe9e299b$export$d39a5bbd09211389; }, function (v) { return $fdd90c8cbe9e299b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $fdd90c8cbe9e299b$export$882461b6382ed46c; }, function (v) { return $fdd90c8cbe9e299b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $fdd90c8cbe9e299b$export$466bfc07425424d5; }, function (v) { return $fdd90c8cbe9e299b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $fdd90c8cbe9e299b$export$cd75ccfd720a3cd4; }, function (v) { return $fdd90c8cbe9e299b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $fdd90c8cbe9e299b$export$fa8d919ba61d84db; }, function (v) { return $fdd90c8cbe9e299b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $fdd90c8cbe9e299b$export$757ceba2d55c277e; }, function (v) { return $fdd90c8cbe9e299b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $fdd90c8cbe9e299b$export$b3890eb0ae9dca99; }, function (v) { return $fdd90c8cbe9e299b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $fdd90c8cbe9e299b$export$502457920280e6be; }, function (v) { return $fdd90c8cbe9e299b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $fdd90c8cbe9e299b$export$c78a37762a8d58e1; }, function (v) { return $fdd90c8cbe9e299b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $fdd90c8cbe9e299b$export$dc54d992c10e8a18; }, function (v) { return $fdd90c8cbe9e299b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $fdd90c8cbe9e299b$export$83d89fbfd8236492; }, function (v) { return $fdd90c8cbe9e299b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $fdd90c8cbe9e299b$export$ae55be85d98224ed;
var $fdd90c8cbe9e299b$export$d39a5bbd09211389;
var $fdd90c8cbe9e299b$export$882461b6382ed46c;
var $fdd90c8cbe9e299b$export$466bfc07425424d5;
var $fdd90c8cbe9e299b$export$cd75ccfd720a3cd4;
var $fdd90c8cbe9e299b$export$fa8d919ba61d84db;
var $fdd90c8cbe9e299b$export$757ceba2d55c277e;
var $fdd90c8cbe9e299b$export$b3890eb0ae9dca99;
var $fdd90c8cbe9e299b$export$502457920280e6be;
var $fdd90c8cbe9e299b$export$c78a37762a8d58e1;
var $fdd90c8cbe9e299b$export$dc54d992c10e8a18;
var $fdd90c8cbe9e299b$export$83d89fbfd8236492;
'use strict';

var $9nZCP = parcelRequire("9nZCP");

var $3tsZj = parcelRequire("3tsZj");
function $fdd90c8cbe9e299b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $fdd90c8cbe9e299b$var$da = new Set, $fdd90c8cbe9e299b$var$ea = {};
function $fdd90c8cbe9e299b$var$fa(a, b) {
    $fdd90c8cbe9e299b$var$ha(a, b);
    $fdd90c8cbe9e299b$var$ha(a + "Capture", b);
}
function $fdd90c8cbe9e299b$var$ha(a, b) {
    $fdd90c8cbe9e299b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$fdd90c8cbe9e299b$var$da.add(b[a]);
}
var $fdd90c8cbe9e299b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $fdd90c8cbe9e299b$var$ja = Object.prototype.hasOwnProperty, $fdd90c8cbe9e299b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $fdd90c8cbe9e299b$var$la = {}, $fdd90c8cbe9e299b$var$ma = {};
function $fdd90c8cbe9e299b$var$oa(a) {
    if ($fdd90c8cbe9e299b$var$ja.call($fdd90c8cbe9e299b$var$ma, a)) return !0;
    if ($fdd90c8cbe9e299b$var$ja.call($fdd90c8cbe9e299b$var$la, a)) return !1;
    if ($fdd90c8cbe9e299b$var$ka.test(a)) return $fdd90c8cbe9e299b$var$ma[a] = !0;
    $fdd90c8cbe9e299b$var$la[a] = !0;
    return !1;
}
function $fdd90c8cbe9e299b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $fdd90c8cbe9e299b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $fdd90c8cbe9e299b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $fdd90c8cbe9e299b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $fdd90c8cbe9e299b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $fdd90c8cbe9e299b$var$z[b] = new $fdd90c8cbe9e299b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $fdd90c8cbe9e299b$var$ra = /[\-:]([a-z])/g;
function $fdd90c8cbe9e299b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($fdd90c8cbe9e299b$var$ra, $fdd90c8cbe9e299b$var$sa);
    $fdd90c8cbe9e299b$var$z[b] = new $fdd90c8cbe9e299b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($fdd90c8cbe9e299b$var$ra, $fdd90c8cbe9e299b$var$sa);
    $fdd90c8cbe9e299b$var$z[b] = new $fdd90c8cbe9e299b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($fdd90c8cbe9e299b$var$ra, $fdd90c8cbe9e299b$var$sa);
    $fdd90c8cbe9e299b$var$z[b] = new $fdd90c8cbe9e299b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$fdd90c8cbe9e299b$var$z.xlinkHref = new $fdd90c8cbe9e299b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $fdd90c8cbe9e299b$var$z[a] = new $fdd90c8cbe9e299b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $fdd90c8cbe9e299b$var$ta(a, b, c, d) {
    var e = $fdd90c8cbe9e299b$var$z.hasOwnProperty(b) ? $fdd90c8cbe9e299b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $fdd90c8cbe9e299b$var$qa(b, c, e, d) && (c = null), d || null === e ? $fdd90c8cbe9e299b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $fdd90c8cbe9e299b$var$ua = $9nZCP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $fdd90c8cbe9e299b$var$va = Symbol.for("react.element"), $fdd90c8cbe9e299b$var$wa = Symbol.for("react.portal"), $fdd90c8cbe9e299b$var$ya = Symbol.for("react.fragment"), $fdd90c8cbe9e299b$var$za = Symbol.for("react.strict_mode"), $fdd90c8cbe9e299b$var$Aa = Symbol.for("react.profiler"), $fdd90c8cbe9e299b$var$Ba = Symbol.for("react.provider"), $fdd90c8cbe9e299b$var$Ca = Symbol.for("react.context"), $fdd90c8cbe9e299b$var$Da = Symbol.for("react.forward_ref"), $fdd90c8cbe9e299b$var$Ea = Symbol.for("react.suspense"), $fdd90c8cbe9e299b$var$Fa = Symbol.for("react.suspense_list"), $fdd90c8cbe9e299b$var$Ga = Symbol.for("react.memo"), $fdd90c8cbe9e299b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $fdd90c8cbe9e299b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $fdd90c8cbe9e299b$var$Ja = Symbol.iterator;
function $fdd90c8cbe9e299b$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $fdd90c8cbe9e299b$var$Ja && a[$fdd90c8cbe9e299b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fdd90c8cbe9e299b$var$A = Object.assign, $fdd90c8cbe9e299b$var$La;
function $fdd90c8cbe9e299b$var$Ma(a) {
    if (void 0 === $fdd90c8cbe9e299b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $fdd90c8cbe9e299b$var$La = b && b[1] || "";
    }
    return "\n" + $fdd90c8cbe9e299b$var$La + a;
}
var $fdd90c8cbe9e299b$var$Na = !1;
function $fdd90c8cbe9e299b$var$Oa(a, b) {
    if (!a || $fdd90c8cbe9e299b$var$Na) return "";
    $fdd90c8cbe9e299b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $fdd90c8cbe9e299b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $fdd90c8cbe9e299b$var$Ma(a) : "";
}
function $fdd90c8cbe9e299b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $fdd90c8cbe9e299b$var$Ma(a.type);
        case 16:
            return $fdd90c8cbe9e299b$var$Ma("Lazy");
        case 13:
            return $fdd90c8cbe9e299b$var$Ma("Suspense");
        case 19:
            return $fdd90c8cbe9e299b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $fdd90c8cbe9e299b$var$Oa(a.type, !1), a;
        case 11:
            return a = $fdd90c8cbe9e299b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $fdd90c8cbe9e299b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $fdd90c8cbe9e299b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $fdd90c8cbe9e299b$var$ya:
            return "Fragment";
        case $fdd90c8cbe9e299b$var$wa:
            return "Portal";
        case $fdd90c8cbe9e299b$var$Aa:
            return "Profiler";
        case $fdd90c8cbe9e299b$var$za:
            return "StrictMode";
        case $fdd90c8cbe9e299b$var$Ea:
            return "Suspense";
        case $fdd90c8cbe9e299b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $fdd90c8cbe9e299b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $fdd90c8cbe9e299b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $fdd90c8cbe9e299b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $fdd90c8cbe9e299b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $fdd90c8cbe9e299b$var$Qa(a.type) || "Memo";
        case $fdd90c8cbe9e299b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $fdd90c8cbe9e299b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $fdd90c8cbe9e299b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $fdd90c8cbe9e299b$var$Qa(b);
        case 8:
            return b === $fdd90c8cbe9e299b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $fdd90c8cbe9e299b$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $fdd90c8cbe9e299b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $fdd90c8cbe9e299b$var$Ua(a) {
    var b = $fdd90c8cbe9e299b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $fdd90c8cbe9e299b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $fdd90c8cbe9e299b$var$Ua(a));
}
function $fdd90c8cbe9e299b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $fdd90c8cbe9e299b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $fdd90c8cbe9e299b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $fdd90c8cbe9e299b$var$Ya(a, b) {
    var c = b.checked;
    return $fdd90c8cbe9e299b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $fdd90c8cbe9e299b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $fdd90c8cbe9e299b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $fdd90c8cbe9e299b$var$ab(a, b) {
    b = b.checked;
    null != b && $fdd90c8cbe9e299b$var$ta(a, "checked", b, !1);
}
function $fdd90c8cbe9e299b$var$bb(a, b) {
    $fdd90c8cbe9e299b$var$ab(a, b);
    var c = $fdd90c8cbe9e299b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $fdd90c8cbe9e299b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $fdd90c8cbe9e299b$var$cb(a, b.type, $fdd90c8cbe9e299b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $fdd90c8cbe9e299b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $fdd90c8cbe9e299b$var$cb(a, b, c) {
    if ("number" !== b || $fdd90c8cbe9e299b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $fdd90c8cbe9e299b$var$eb = Array.isArray;
function $fdd90c8cbe9e299b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $fdd90c8cbe9e299b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $fdd90c8cbe9e299b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($fdd90c8cbe9e299b$var$p(91));
    return $fdd90c8cbe9e299b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $fdd90c8cbe9e299b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($fdd90c8cbe9e299b$var$p(92));
            if ($fdd90c8cbe9e299b$var$eb(c)) {
                if (1 < c.length) throw Error($fdd90c8cbe9e299b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $fdd90c8cbe9e299b$var$Sa(c)
    };
}
function $fdd90c8cbe9e299b$var$ib(a, b) {
    var c = $fdd90c8cbe9e299b$var$Sa(b.value), d = $fdd90c8cbe9e299b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $fdd90c8cbe9e299b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $fdd90c8cbe9e299b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $fdd90c8cbe9e299b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $fdd90c8cbe9e299b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $fdd90c8cbe9e299b$var$mb, $fdd90c8cbe9e299b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $fdd90c8cbe9e299b$var$mb = $fdd90c8cbe9e299b$var$mb || document.createElement("div");
        $fdd90c8cbe9e299b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $fdd90c8cbe9e299b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $fdd90c8cbe9e299b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $fdd90c8cbe9e299b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $fdd90c8cbe9e299b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($fdd90c8cbe9e299b$var$pb).forEach(function(a) {
    $fdd90c8cbe9e299b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $fdd90c8cbe9e299b$var$pb[b] = $fdd90c8cbe9e299b$var$pb[a];
    });
});
function $fdd90c8cbe9e299b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $fdd90c8cbe9e299b$var$pb.hasOwnProperty(a) && $fdd90c8cbe9e299b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $fdd90c8cbe9e299b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $fdd90c8cbe9e299b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $fdd90c8cbe9e299b$var$tb = $fdd90c8cbe9e299b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $fdd90c8cbe9e299b$var$ub(a, b) {
    if (b) {
        if ($fdd90c8cbe9e299b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($fdd90c8cbe9e299b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($fdd90c8cbe9e299b$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($fdd90c8cbe9e299b$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($fdd90c8cbe9e299b$var$p(62));
    }
}
function $fdd90c8cbe9e299b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $fdd90c8cbe9e299b$var$wb = null;
function $fdd90c8cbe9e299b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $fdd90c8cbe9e299b$var$yb = null, $fdd90c8cbe9e299b$var$zb = null, $fdd90c8cbe9e299b$var$Ab = null;
function $fdd90c8cbe9e299b$var$Bb(a) {
    if (a = $fdd90c8cbe9e299b$var$Cb(a)) {
        if ("function" !== typeof $fdd90c8cbe9e299b$var$yb) throw Error($fdd90c8cbe9e299b$var$p(280));
        var b = a.stateNode;
        b && (b = $fdd90c8cbe9e299b$var$Db(b), $fdd90c8cbe9e299b$var$yb(a.stateNode, a.type, b));
    }
}
function $fdd90c8cbe9e299b$var$Eb(a) {
    $fdd90c8cbe9e299b$var$zb ? $fdd90c8cbe9e299b$var$Ab ? $fdd90c8cbe9e299b$var$Ab.push(a) : $fdd90c8cbe9e299b$var$Ab = [
        a
    ] : $fdd90c8cbe9e299b$var$zb = a;
}
function $fdd90c8cbe9e299b$var$Fb() {
    if ($fdd90c8cbe9e299b$var$zb) {
        var a = $fdd90c8cbe9e299b$var$zb, b = $fdd90c8cbe9e299b$var$Ab;
        $fdd90c8cbe9e299b$var$Ab = $fdd90c8cbe9e299b$var$zb = null;
        $fdd90c8cbe9e299b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$fdd90c8cbe9e299b$var$Bb(b[a]);
    }
}
function $fdd90c8cbe9e299b$var$Gb(a, b) {
    return a(b);
}
function $fdd90c8cbe9e299b$var$Hb() {}
var $fdd90c8cbe9e299b$var$Ib = !1;
function $fdd90c8cbe9e299b$var$Jb(a, b, c) {
    if ($fdd90c8cbe9e299b$var$Ib) return a(b, c);
    $fdd90c8cbe9e299b$var$Ib = !0;
    try {
        return $fdd90c8cbe9e299b$var$Gb(a, b, c);
    } finally{
        if ($fdd90c8cbe9e299b$var$Ib = !1, null !== $fdd90c8cbe9e299b$var$zb || null !== $fdd90c8cbe9e299b$var$Ab) $fdd90c8cbe9e299b$var$Hb(), $fdd90c8cbe9e299b$var$Fb();
    }
}
function $fdd90c8cbe9e299b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $fdd90c8cbe9e299b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($fdd90c8cbe9e299b$var$p(231, b, typeof c));
    return c;
}
var $fdd90c8cbe9e299b$var$Lb = !1;
if ($fdd90c8cbe9e299b$var$ia) try {
    var $fdd90c8cbe9e299b$var$Mb = {};
    Object.defineProperty($fdd90c8cbe9e299b$var$Mb, "passive", {
        get: function() {
            $fdd90c8cbe9e299b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $fdd90c8cbe9e299b$var$Mb, $fdd90c8cbe9e299b$var$Mb);
    window.removeEventListener("test", $fdd90c8cbe9e299b$var$Mb, $fdd90c8cbe9e299b$var$Mb);
} catch (a) {
    $fdd90c8cbe9e299b$var$Lb = !1;
}
function $fdd90c8cbe9e299b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $fdd90c8cbe9e299b$var$Ob = !1, $fdd90c8cbe9e299b$var$Pb = null, $fdd90c8cbe9e299b$var$Qb = !1, $fdd90c8cbe9e299b$var$Rb = null, $fdd90c8cbe9e299b$var$Sb = {
    onError: function(a) {
        $fdd90c8cbe9e299b$var$Ob = !0;
        $fdd90c8cbe9e299b$var$Pb = a;
    }
};
function $fdd90c8cbe9e299b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $fdd90c8cbe9e299b$var$Ob = !1;
    $fdd90c8cbe9e299b$var$Pb = null;
    $fdd90c8cbe9e299b$var$Nb.apply($fdd90c8cbe9e299b$var$Sb, arguments);
}
function $fdd90c8cbe9e299b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $fdd90c8cbe9e299b$var$Tb.apply(this, arguments);
    if ($fdd90c8cbe9e299b$var$Ob) {
        if ($fdd90c8cbe9e299b$var$Ob) {
            var l = $fdd90c8cbe9e299b$var$Pb;
            $fdd90c8cbe9e299b$var$Ob = !1;
            $fdd90c8cbe9e299b$var$Pb = null;
        } else throw Error($fdd90c8cbe9e299b$var$p(198));
        $fdd90c8cbe9e299b$var$Qb || ($fdd90c8cbe9e299b$var$Qb = !0, $fdd90c8cbe9e299b$var$Rb = l);
    }
}
function $fdd90c8cbe9e299b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $fdd90c8cbe9e299b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $fdd90c8cbe9e299b$var$Xb(a) {
    if ($fdd90c8cbe9e299b$var$Vb(a) !== a) throw Error($fdd90c8cbe9e299b$var$p(188));
}
function $fdd90c8cbe9e299b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $fdd90c8cbe9e299b$var$Vb(a);
        if (null === b) throw Error($fdd90c8cbe9e299b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $fdd90c8cbe9e299b$var$Xb(e), a;
                if (f === d) return $fdd90c8cbe9e299b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($fdd90c8cbe9e299b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($fdd90c8cbe9e299b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($fdd90c8cbe9e299b$var$p(190));
    }
    if (3 !== c.tag) throw Error($fdd90c8cbe9e299b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $fdd90c8cbe9e299b$var$Zb(a) {
    a = $fdd90c8cbe9e299b$var$Yb(a);
    return null !== a ? $fdd90c8cbe9e299b$var$$b(a) : null;
}
function $fdd90c8cbe9e299b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $fdd90c8cbe9e299b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $fdd90c8cbe9e299b$var$ac = $3tsZj.unstable_scheduleCallback, $fdd90c8cbe9e299b$var$bc = $3tsZj.unstable_cancelCallback, $fdd90c8cbe9e299b$var$cc = $3tsZj.unstable_shouldYield, $fdd90c8cbe9e299b$var$dc = $3tsZj.unstable_requestPaint, $fdd90c8cbe9e299b$var$B = $3tsZj.unstable_now, $fdd90c8cbe9e299b$var$ec = $3tsZj.unstable_getCurrentPriorityLevel, $fdd90c8cbe9e299b$var$fc = $3tsZj.unstable_ImmediatePriority, $fdd90c8cbe9e299b$var$gc = $3tsZj.unstable_UserBlockingPriority, $fdd90c8cbe9e299b$var$hc = $3tsZj.unstable_NormalPriority, $fdd90c8cbe9e299b$var$ic = $3tsZj.unstable_LowPriority, $fdd90c8cbe9e299b$var$jc = $3tsZj.unstable_IdlePriority, $fdd90c8cbe9e299b$var$kc = null, $fdd90c8cbe9e299b$var$lc = null;
function $fdd90c8cbe9e299b$var$mc(a) {
    if ($fdd90c8cbe9e299b$var$lc && "function" === typeof $fdd90c8cbe9e299b$var$lc.onCommitFiberRoot) try {
        $fdd90c8cbe9e299b$var$lc.onCommitFiberRoot($fdd90c8cbe9e299b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $fdd90c8cbe9e299b$var$oc = Math.clz32 ? Math.clz32 : $fdd90c8cbe9e299b$var$nc, $fdd90c8cbe9e299b$var$pc = Math.log, $fdd90c8cbe9e299b$var$qc = Math.LN2;
function $fdd90c8cbe9e299b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($fdd90c8cbe9e299b$var$pc(a) / $fdd90c8cbe9e299b$var$qc | 0) | 0;
}
var $fdd90c8cbe9e299b$var$rc = 64, $fdd90c8cbe9e299b$var$sc = 4194304;
function $fdd90c8cbe9e299b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $fdd90c8cbe9e299b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $fdd90c8cbe9e299b$var$tc(h) : (f &= g, 0 !== f && (d = $fdd90c8cbe9e299b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $fdd90c8cbe9e299b$var$tc(g) : 0 !== f && (d = $fdd90c8cbe9e299b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $fdd90c8cbe9e299b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $fdd90c8cbe9e299b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $fdd90c8cbe9e299b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $fdd90c8cbe9e299b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $fdd90c8cbe9e299b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $fdd90c8cbe9e299b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $fdd90c8cbe9e299b$var$yc() {
    var a = $fdd90c8cbe9e299b$var$rc;
    $fdd90c8cbe9e299b$var$rc <<= 1;
    0 === ($fdd90c8cbe9e299b$var$rc & 4194240) && ($fdd90c8cbe9e299b$var$rc = 64);
    return a;
}
function $fdd90c8cbe9e299b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $fdd90c8cbe9e299b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $fdd90c8cbe9e299b$var$oc(b);
    a[b] = c;
}
function $fdd90c8cbe9e299b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $fdd90c8cbe9e299b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $fdd90c8cbe9e299b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $fdd90c8cbe9e299b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $fdd90c8cbe9e299b$var$C = 0;
function $fdd90c8cbe9e299b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $fdd90c8cbe9e299b$var$Ec, $fdd90c8cbe9e299b$var$Fc, $fdd90c8cbe9e299b$var$Gc, $fdd90c8cbe9e299b$var$Hc, $fdd90c8cbe9e299b$var$Ic, $fdd90c8cbe9e299b$var$Jc = !1, $fdd90c8cbe9e299b$var$Kc = [], $fdd90c8cbe9e299b$var$Lc = null, $fdd90c8cbe9e299b$var$Mc = null, $fdd90c8cbe9e299b$var$Nc = null, $fdd90c8cbe9e299b$var$Oc = new Map, $fdd90c8cbe9e299b$var$Pc = new Map, $fdd90c8cbe9e299b$var$Qc = [], $fdd90c8cbe9e299b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $fdd90c8cbe9e299b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $fdd90c8cbe9e299b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $fdd90c8cbe9e299b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $fdd90c8cbe9e299b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $fdd90c8cbe9e299b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $fdd90c8cbe9e299b$var$Pc.delete(b.pointerId);
    }
}
function $fdd90c8cbe9e299b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $fdd90c8cbe9e299b$var$Cb(b), null !== b && $fdd90c8cbe9e299b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $fdd90c8cbe9e299b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $fdd90c8cbe9e299b$var$Lc = $fdd90c8cbe9e299b$var$Tc($fdd90c8cbe9e299b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $fdd90c8cbe9e299b$var$Mc = $fdd90c8cbe9e299b$var$Tc($fdd90c8cbe9e299b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $fdd90c8cbe9e299b$var$Nc = $fdd90c8cbe9e299b$var$Tc($fdd90c8cbe9e299b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $fdd90c8cbe9e299b$var$Oc.set(f, $fdd90c8cbe9e299b$var$Tc($fdd90c8cbe9e299b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $fdd90c8cbe9e299b$var$Pc.set(f, $fdd90c8cbe9e299b$var$Tc($fdd90c8cbe9e299b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $fdd90c8cbe9e299b$var$Vc(a) {
    var b = $fdd90c8cbe9e299b$var$Wc(a.target);
    if (null !== b) {
        var c = $fdd90c8cbe9e299b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $fdd90c8cbe9e299b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $fdd90c8cbe9e299b$var$Ic(a.priority, function() {
                        $fdd90c8cbe9e299b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $fdd90c8cbe9e299b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $fdd90c8cbe9e299b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $fdd90c8cbe9e299b$var$wb = d;
            c.target.dispatchEvent(d);
            $fdd90c8cbe9e299b$var$wb = null;
        } else return b = $fdd90c8cbe9e299b$var$Cb(c), null !== b && $fdd90c8cbe9e299b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $fdd90c8cbe9e299b$var$Zc(a, b, c) {
    $fdd90c8cbe9e299b$var$Xc(a) && c.delete(b);
}
function $fdd90c8cbe9e299b$var$$c() {
    $fdd90c8cbe9e299b$var$Jc = !1;
    null !== $fdd90c8cbe9e299b$var$Lc && $fdd90c8cbe9e299b$var$Xc($fdd90c8cbe9e299b$var$Lc) && ($fdd90c8cbe9e299b$var$Lc = null);
    null !== $fdd90c8cbe9e299b$var$Mc && $fdd90c8cbe9e299b$var$Xc($fdd90c8cbe9e299b$var$Mc) && ($fdd90c8cbe9e299b$var$Mc = null);
    null !== $fdd90c8cbe9e299b$var$Nc && $fdd90c8cbe9e299b$var$Xc($fdd90c8cbe9e299b$var$Nc) && ($fdd90c8cbe9e299b$var$Nc = null);
    $fdd90c8cbe9e299b$var$Oc.forEach($fdd90c8cbe9e299b$var$Zc);
    $fdd90c8cbe9e299b$var$Pc.forEach($fdd90c8cbe9e299b$var$Zc);
}
function $fdd90c8cbe9e299b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $fdd90c8cbe9e299b$var$Jc || ($fdd90c8cbe9e299b$var$Jc = !0, $3tsZj.unstable_scheduleCallback($3tsZj.unstable_NormalPriority, $fdd90c8cbe9e299b$var$$c)));
}
function $fdd90c8cbe9e299b$var$bd(a) {
    function b(b) {
        return $fdd90c8cbe9e299b$var$ad(b, a);
    }
    if (0 < $fdd90c8cbe9e299b$var$Kc.length) {
        $fdd90c8cbe9e299b$var$ad($fdd90c8cbe9e299b$var$Kc[0], a);
        for(var c = 1; c < $fdd90c8cbe9e299b$var$Kc.length; c++){
            var d = $fdd90c8cbe9e299b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $fdd90c8cbe9e299b$var$Lc && $fdd90c8cbe9e299b$var$ad($fdd90c8cbe9e299b$var$Lc, a);
    null !== $fdd90c8cbe9e299b$var$Mc && $fdd90c8cbe9e299b$var$ad($fdd90c8cbe9e299b$var$Mc, a);
    null !== $fdd90c8cbe9e299b$var$Nc && $fdd90c8cbe9e299b$var$ad($fdd90c8cbe9e299b$var$Nc, a);
    $fdd90c8cbe9e299b$var$Oc.forEach(b);
    $fdd90c8cbe9e299b$var$Pc.forEach(b);
    for(c = 0; c < $fdd90c8cbe9e299b$var$Qc.length; c++)d = $fdd90c8cbe9e299b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $fdd90c8cbe9e299b$var$Qc.length && (c = $fdd90c8cbe9e299b$var$Qc[0], null === c.blockedOn);)$fdd90c8cbe9e299b$var$Vc(c), null === c.blockedOn && $fdd90c8cbe9e299b$var$Qc.shift();
}
var $fdd90c8cbe9e299b$var$cd = $fdd90c8cbe9e299b$var$ua.ReactCurrentBatchConfig, $fdd90c8cbe9e299b$var$dd = !0;
function $fdd90c8cbe9e299b$var$ed(a, b, c, d) {
    var e = $fdd90c8cbe9e299b$var$C, f = $fdd90c8cbe9e299b$var$cd.transition;
    $fdd90c8cbe9e299b$var$cd.transition = null;
    try {
        $fdd90c8cbe9e299b$var$C = 1, $fdd90c8cbe9e299b$var$fd(a, b, c, d);
    } finally{
        $fdd90c8cbe9e299b$var$C = e, $fdd90c8cbe9e299b$var$cd.transition = f;
    }
}
function $fdd90c8cbe9e299b$var$gd(a, b, c, d) {
    var e = $fdd90c8cbe9e299b$var$C, f = $fdd90c8cbe9e299b$var$cd.transition;
    $fdd90c8cbe9e299b$var$cd.transition = null;
    try {
        $fdd90c8cbe9e299b$var$C = 4, $fdd90c8cbe9e299b$var$fd(a, b, c, d);
    } finally{
        $fdd90c8cbe9e299b$var$C = e, $fdd90c8cbe9e299b$var$cd.transition = f;
    }
}
function $fdd90c8cbe9e299b$var$fd(a, b, c, d) {
    if ($fdd90c8cbe9e299b$var$dd) {
        var e = $fdd90c8cbe9e299b$var$Yc(a, b, c, d);
        if (null === e) $fdd90c8cbe9e299b$var$hd(a, b, d, $fdd90c8cbe9e299b$var$id, c), $fdd90c8cbe9e299b$var$Sc(a, d);
        else if ($fdd90c8cbe9e299b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($fdd90c8cbe9e299b$var$Sc(a, d), b & 4 && -1 < $fdd90c8cbe9e299b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $fdd90c8cbe9e299b$var$Cb(e);
                null !== f && $fdd90c8cbe9e299b$var$Ec(f);
                f = $fdd90c8cbe9e299b$var$Yc(a, b, c, d);
                null === f && $fdd90c8cbe9e299b$var$hd(a, b, d, $fdd90c8cbe9e299b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $fdd90c8cbe9e299b$var$hd(a, b, d, null, c);
    }
}
var $fdd90c8cbe9e299b$var$id = null;
function $fdd90c8cbe9e299b$var$Yc(a, b, c, d) {
    $fdd90c8cbe9e299b$var$id = null;
    a = $fdd90c8cbe9e299b$var$xb(d);
    a = $fdd90c8cbe9e299b$var$Wc(a);
    if (null !== a) {
        if (b = $fdd90c8cbe9e299b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $fdd90c8cbe9e299b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $fdd90c8cbe9e299b$var$id = a;
    return null;
}
function $fdd90c8cbe9e299b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($fdd90c8cbe9e299b$var$ec()){
                case $fdd90c8cbe9e299b$var$fc:
                    return 1;
                case $fdd90c8cbe9e299b$var$gc:
                    return 4;
                case $fdd90c8cbe9e299b$var$hc:
                case $fdd90c8cbe9e299b$var$ic:
                    return 16;
                case $fdd90c8cbe9e299b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $fdd90c8cbe9e299b$var$kd = null, $fdd90c8cbe9e299b$var$ld = null, $fdd90c8cbe9e299b$var$md = null;
function $fdd90c8cbe9e299b$var$nd() {
    if ($fdd90c8cbe9e299b$var$md) return $fdd90c8cbe9e299b$var$md;
    var a, b = $fdd90c8cbe9e299b$var$ld, c = b.length, d, e = "value" in $fdd90c8cbe9e299b$var$kd ? $fdd90c8cbe9e299b$var$kd.value : $fdd90c8cbe9e299b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $fdd90c8cbe9e299b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $fdd90c8cbe9e299b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $fdd90c8cbe9e299b$var$pd() {
    return !0;
}
function $fdd90c8cbe9e299b$var$qd() {
    return !1;
}
function $fdd90c8cbe9e299b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $fdd90c8cbe9e299b$var$pd : $fdd90c8cbe9e299b$var$qd;
        this.isPropagationStopped = $fdd90c8cbe9e299b$var$qd;
        return this;
    }
    $fdd90c8cbe9e299b$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $fdd90c8cbe9e299b$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $fdd90c8cbe9e299b$var$pd);
        },
        persist: function() {},
        isPersistent: $fdd90c8cbe9e299b$var$pd
    });
    return b;
}
var $fdd90c8cbe9e299b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $fdd90c8cbe9e299b$var$td = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$sd), $fdd90c8cbe9e299b$var$ud = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$sd, {
    view: 0,
    detail: 0
}), $fdd90c8cbe9e299b$var$vd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$ud), $fdd90c8cbe9e299b$var$wd, $fdd90c8cbe9e299b$var$xd, $fdd90c8cbe9e299b$var$yd, $fdd90c8cbe9e299b$var$Ad = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $fdd90c8cbe9e299b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $fdd90c8cbe9e299b$var$yd && ($fdd90c8cbe9e299b$var$yd && "mousemove" === a.type ? ($fdd90c8cbe9e299b$var$wd = a.screenX - $fdd90c8cbe9e299b$var$yd.screenX, $fdd90c8cbe9e299b$var$xd = a.screenY - $fdd90c8cbe9e299b$var$yd.screenY) : $fdd90c8cbe9e299b$var$xd = $fdd90c8cbe9e299b$var$wd = 0, $fdd90c8cbe9e299b$var$yd = a);
        return $fdd90c8cbe9e299b$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $fdd90c8cbe9e299b$var$xd;
    }
}), $fdd90c8cbe9e299b$var$Bd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Ad), $fdd90c8cbe9e299b$var$Cd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$Ad, {
    dataTransfer: 0
}), $fdd90c8cbe9e299b$var$Dd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Cd), $fdd90c8cbe9e299b$var$Ed = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$ud, {
    relatedTarget: 0
}), $fdd90c8cbe9e299b$var$Fd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Ed), $fdd90c8cbe9e299b$var$Gd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fdd90c8cbe9e299b$var$Hd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Gd), $fdd90c8cbe9e299b$var$Id = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $fdd90c8cbe9e299b$var$Jd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Id), $fdd90c8cbe9e299b$var$Kd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$sd, {
    data: 0
}), $fdd90c8cbe9e299b$var$Ld = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Kd), $fdd90c8cbe9e299b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $fdd90c8cbe9e299b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $fdd90c8cbe9e299b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $fdd90c8cbe9e299b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $fdd90c8cbe9e299b$var$Od[a]) ? !!b[a] : !1;
}
function $fdd90c8cbe9e299b$var$zd() {
    return $fdd90c8cbe9e299b$var$Pd;
}
var $fdd90c8cbe9e299b$var$Qd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $fdd90c8cbe9e299b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $fdd90c8cbe9e299b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $fdd90c8cbe9e299b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $fdd90c8cbe9e299b$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $fdd90c8cbe9e299b$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $fdd90c8cbe9e299b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $fdd90c8cbe9e299b$var$Rd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Qd), $fdd90c8cbe9e299b$var$Sd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $fdd90c8cbe9e299b$var$Td = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Sd), $fdd90c8cbe9e299b$var$Ud = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $fdd90c8cbe9e299b$var$zd
}), $fdd90c8cbe9e299b$var$Vd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Ud), $fdd90c8cbe9e299b$var$Wd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fdd90c8cbe9e299b$var$Xd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Wd), $fdd90c8cbe9e299b$var$Yd = $fdd90c8cbe9e299b$var$A({}, $fdd90c8cbe9e299b$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $fdd90c8cbe9e299b$var$Zd = $fdd90c8cbe9e299b$var$rd($fdd90c8cbe9e299b$var$Yd), $fdd90c8cbe9e299b$var$$d = [
    9,
    13,
    27,
    32
], $fdd90c8cbe9e299b$var$ae = $fdd90c8cbe9e299b$var$ia && "CompositionEvent" in window, $fdd90c8cbe9e299b$var$be = null;
$fdd90c8cbe9e299b$var$ia && "documentMode" in document && ($fdd90c8cbe9e299b$var$be = document.documentMode);
var $fdd90c8cbe9e299b$var$ce = $fdd90c8cbe9e299b$var$ia && "TextEvent" in window && !$fdd90c8cbe9e299b$var$be, $fdd90c8cbe9e299b$var$de = $fdd90c8cbe9e299b$var$ia && (!$fdd90c8cbe9e299b$var$ae || $fdd90c8cbe9e299b$var$be && 8 < $fdd90c8cbe9e299b$var$be && 11 >= $fdd90c8cbe9e299b$var$be), $fdd90c8cbe9e299b$var$ee = String.fromCharCode(32), $fdd90c8cbe9e299b$var$fe = !1;
function $fdd90c8cbe9e299b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $fdd90c8cbe9e299b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $fdd90c8cbe9e299b$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $fdd90c8cbe9e299b$var$ie = !1;
function $fdd90c8cbe9e299b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $fdd90c8cbe9e299b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $fdd90c8cbe9e299b$var$fe = !0;
            return $fdd90c8cbe9e299b$var$ee;
        case "textInput":
            return a = b.data, a === $fdd90c8cbe9e299b$var$ee && $fdd90c8cbe9e299b$var$fe ? null : a;
        default:
            return null;
    }
}
function $fdd90c8cbe9e299b$var$ke(a, b) {
    if ($fdd90c8cbe9e299b$var$ie) return "compositionend" === a || !$fdd90c8cbe9e299b$var$ae && $fdd90c8cbe9e299b$var$ge(a, b) ? (a = $fdd90c8cbe9e299b$var$nd(), $fdd90c8cbe9e299b$var$md = $fdd90c8cbe9e299b$var$ld = $fdd90c8cbe9e299b$var$kd = null, $fdd90c8cbe9e299b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $fdd90c8cbe9e299b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $fdd90c8cbe9e299b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $fdd90c8cbe9e299b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$fdd90c8cbe9e299b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $fdd90c8cbe9e299b$var$ne(a, b, c, d) {
    $fdd90c8cbe9e299b$var$Eb(d);
    b = $fdd90c8cbe9e299b$var$oe(b, "onChange");
    0 < b.length && (c = new $fdd90c8cbe9e299b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $fdd90c8cbe9e299b$var$pe = null, $fdd90c8cbe9e299b$var$qe = null;
function $fdd90c8cbe9e299b$var$re(a) {
    $fdd90c8cbe9e299b$var$se(a, 0);
}
function $fdd90c8cbe9e299b$var$te(a) {
    var b = $fdd90c8cbe9e299b$var$ue(a);
    if ($fdd90c8cbe9e299b$var$Wa(b)) return a;
}
function $fdd90c8cbe9e299b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $fdd90c8cbe9e299b$var$we = !1;
if ($fdd90c8cbe9e299b$var$ia) {
    var $fdd90c8cbe9e299b$var$xe;
    if ($fdd90c8cbe9e299b$var$ia) {
        var $fdd90c8cbe9e299b$var$ye = "oninput" in document;
        if (!$fdd90c8cbe9e299b$var$ye) {
            var $fdd90c8cbe9e299b$var$ze = document.createElement("div");
            $fdd90c8cbe9e299b$var$ze.setAttribute("oninput", "return;");
            $fdd90c8cbe9e299b$var$ye = "function" === typeof $fdd90c8cbe9e299b$var$ze.oninput;
        }
        $fdd90c8cbe9e299b$var$xe = $fdd90c8cbe9e299b$var$ye;
    } else $fdd90c8cbe9e299b$var$xe = !1;
    $fdd90c8cbe9e299b$var$we = $fdd90c8cbe9e299b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $fdd90c8cbe9e299b$var$Ae() {
    $fdd90c8cbe9e299b$var$pe && ($fdd90c8cbe9e299b$var$pe.detachEvent("onpropertychange", $fdd90c8cbe9e299b$var$Be), $fdd90c8cbe9e299b$var$qe = $fdd90c8cbe9e299b$var$pe = null);
}
function $fdd90c8cbe9e299b$var$Be(a) {
    if ("value" === a.propertyName && $fdd90c8cbe9e299b$var$te($fdd90c8cbe9e299b$var$qe)) {
        var b = [];
        $fdd90c8cbe9e299b$var$ne(b, $fdd90c8cbe9e299b$var$qe, a, $fdd90c8cbe9e299b$var$xb(a));
        $fdd90c8cbe9e299b$var$Jb($fdd90c8cbe9e299b$var$re, b);
    }
}
function $fdd90c8cbe9e299b$var$Ce(a, b, c) {
    "focusin" === a ? ($fdd90c8cbe9e299b$var$Ae(), $fdd90c8cbe9e299b$var$pe = b, $fdd90c8cbe9e299b$var$qe = c, $fdd90c8cbe9e299b$var$pe.attachEvent("onpropertychange", $fdd90c8cbe9e299b$var$Be)) : "focusout" === a && $fdd90c8cbe9e299b$var$Ae();
}
function $fdd90c8cbe9e299b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $fdd90c8cbe9e299b$var$te($fdd90c8cbe9e299b$var$qe);
}
function $fdd90c8cbe9e299b$var$Ee(a, b) {
    if ("click" === a) return $fdd90c8cbe9e299b$var$te(b);
}
function $fdd90c8cbe9e299b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $fdd90c8cbe9e299b$var$te(b);
}
function $fdd90c8cbe9e299b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $fdd90c8cbe9e299b$var$He = "function" === typeof Object.is ? Object.is : $fdd90c8cbe9e299b$var$Ge;
function $fdd90c8cbe9e299b$var$Ie(a, b) {
    if ($fdd90c8cbe9e299b$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$fdd90c8cbe9e299b$var$ja.call(b, e) || !$fdd90c8cbe9e299b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $fdd90c8cbe9e299b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $fdd90c8cbe9e299b$var$Ke(a, b) {
    var c = $fdd90c8cbe9e299b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $fdd90c8cbe9e299b$var$Je(c);
    }
}
function $fdd90c8cbe9e299b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $fdd90c8cbe9e299b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $fdd90c8cbe9e299b$var$Me() {
    for(var a = window, b = $fdd90c8cbe9e299b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $fdd90c8cbe9e299b$var$Xa(a.document);
    }
    return b;
}
function $fdd90c8cbe9e299b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $fdd90c8cbe9e299b$var$Oe(a) {
    var b = $fdd90c8cbe9e299b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $fdd90c8cbe9e299b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $fdd90c8cbe9e299b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $fdd90c8cbe9e299b$var$Ke(c, f);
                var g = $fdd90c8cbe9e299b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $fdd90c8cbe9e299b$var$Pe = $fdd90c8cbe9e299b$var$ia && "documentMode" in document && 11 >= document.documentMode, $fdd90c8cbe9e299b$var$Qe = null, $fdd90c8cbe9e299b$var$Re = null, $fdd90c8cbe9e299b$var$Se = null, $fdd90c8cbe9e299b$var$Te = !1;
function $fdd90c8cbe9e299b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $fdd90c8cbe9e299b$var$Te || null == $fdd90c8cbe9e299b$var$Qe || $fdd90c8cbe9e299b$var$Qe !== $fdd90c8cbe9e299b$var$Xa(d) || (d = $fdd90c8cbe9e299b$var$Qe, "selectionStart" in d && $fdd90c8cbe9e299b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $fdd90c8cbe9e299b$var$Se && $fdd90c8cbe9e299b$var$Ie($fdd90c8cbe9e299b$var$Se, d) || ($fdd90c8cbe9e299b$var$Se = d, d = $fdd90c8cbe9e299b$var$oe($fdd90c8cbe9e299b$var$Re, "onSelect"), 0 < d.length && (b = new $fdd90c8cbe9e299b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $fdd90c8cbe9e299b$var$Qe)));
}
function $fdd90c8cbe9e299b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $fdd90c8cbe9e299b$var$We = {
    animationend: $fdd90c8cbe9e299b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $fdd90c8cbe9e299b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $fdd90c8cbe9e299b$var$Ve("Animation", "AnimationStart"),
    transitionend: $fdd90c8cbe9e299b$var$Ve("Transition", "TransitionEnd")
}, $fdd90c8cbe9e299b$var$Xe = {}, $fdd90c8cbe9e299b$var$Ye = {};
$fdd90c8cbe9e299b$var$ia && ($fdd90c8cbe9e299b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $fdd90c8cbe9e299b$var$We.animationend.animation, delete $fdd90c8cbe9e299b$var$We.animationiteration.animation, delete $fdd90c8cbe9e299b$var$We.animationstart.animation), "TransitionEvent" in window || delete $fdd90c8cbe9e299b$var$We.transitionend.transition);
function $fdd90c8cbe9e299b$var$Ze(a) {
    if ($fdd90c8cbe9e299b$var$Xe[a]) return $fdd90c8cbe9e299b$var$Xe[a];
    if (!$fdd90c8cbe9e299b$var$We[a]) return a;
    var b = $fdd90c8cbe9e299b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $fdd90c8cbe9e299b$var$Ye) return $fdd90c8cbe9e299b$var$Xe[a] = b[c];
    return a;
}
var $fdd90c8cbe9e299b$var$$e = $fdd90c8cbe9e299b$var$Ze("animationend"), $fdd90c8cbe9e299b$var$af = $fdd90c8cbe9e299b$var$Ze("animationiteration"), $fdd90c8cbe9e299b$var$bf = $fdd90c8cbe9e299b$var$Ze("animationstart"), $fdd90c8cbe9e299b$var$cf = $fdd90c8cbe9e299b$var$Ze("transitionend"), $fdd90c8cbe9e299b$var$df = new Map, $fdd90c8cbe9e299b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $fdd90c8cbe9e299b$var$ff(a, b) {
    $fdd90c8cbe9e299b$var$df.set(a, b);
    $fdd90c8cbe9e299b$var$fa(b, [
        a
    ]);
}
for(var $fdd90c8cbe9e299b$var$gf = 0; $fdd90c8cbe9e299b$var$gf < $fdd90c8cbe9e299b$var$ef.length; $fdd90c8cbe9e299b$var$gf++){
    var $fdd90c8cbe9e299b$var$hf = $fdd90c8cbe9e299b$var$ef[$fdd90c8cbe9e299b$var$gf], $fdd90c8cbe9e299b$var$jf = $fdd90c8cbe9e299b$var$hf.toLowerCase(), $fdd90c8cbe9e299b$var$kf = $fdd90c8cbe9e299b$var$hf[0].toUpperCase() + $fdd90c8cbe9e299b$var$hf.slice(1);
    $fdd90c8cbe9e299b$var$ff($fdd90c8cbe9e299b$var$jf, "on" + $fdd90c8cbe9e299b$var$kf);
}
$fdd90c8cbe9e299b$var$ff($fdd90c8cbe9e299b$var$$e, "onAnimationEnd");
$fdd90c8cbe9e299b$var$ff($fdd90c8cbe9e299b$var$af, "onAnimationIteration");
$fdd90c8cbe9e299b$var$ff($fdd90c8cbe9e299b$var$bf, "onAnimationStart");
$fdd90c8cbe9e299b$var$ff("dblclick", "onDoubleClick");
$fdd90c8cbe9e299b$var$ff("focusin", "onFocus");
$fdd90c8cbe9e299b$var$ff("focusout", "onBlur");
$fdd90c8cbe9e299b$var$ff($fdd90c8cbe9e299b$var$cf, "onTransitionEnd");
$fdd90c8cbe9e299b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$fdd90c8cbe9e299b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$fdd90c8cbe9e299b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$fdd90c8cbe9e299b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$fdd90c8cbe9e299b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$fdd90c8cbe9e299b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$fdd90c8cbe9e299b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$fdd90c8cbe9e299b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$fdd90c8cbe9e299b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$fdd90c8cbe9e299b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $fdd90c8cbe9e299b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $fdd90c8cbe9e299b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($fdd90c8cbe9e299b$var$lf));
function $fdd90c8cbe9e299b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $fdd90c8cbe9e299b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $fdd90c8cbe9e299b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fdd90c8cbe9e299b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fdd90c8cbe9e299b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($fdd90c8cbe9e299b$var$Qb) throw a = $fdd90c8cbe9e299b$var$Rb, $fdd90c8cbe9e299b$var$Qb = !1, $fdd90c8cbe9e299b$var$Rb = null, a;
}
function $fdd90c8cbe9e299b$var$D(a, b) {
    var c = b[$fdd90c8cbe9e299b$var$of];
    void 0 === c && (c = b[$fdd90c8cbe9e299b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($fdd90c8cbe9e299b$var$pf(b, a, 2, !1), c.add(d));
}
function $fdd90c8cbe9e299b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $fdd90c8cbe9e299b$var$pf(c, a, d, b);
}
var $fdd90c8cbe9e299b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $fdd90c8cbe9e299b$var$sf(a) {
    if (!a[$fdd90c8cbe9e299b$var$rf]) {
        a[$fdd90c8cbe9e299b$var$rf] = !0;
        $fdd90c8cbe9e299b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($fdd90c8cbe9e299b$var$mf.has(b) || $fdd90c8cbe9e299b$var$qf(b, !1, a), $fdd90c8cbe9e299b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$fdd90c8cbe9e299b$var$rf] || (b[$fdd90c8cbe9e299b$var$rf] = !0, $fdd90c8cbe9e299b$var$qf("selectionchange", !1, b));
    }
}
function $fdd90c8cbe9e299b$var$pf(a, b, c, d) {
    switch($fdd90c8cbe9e299b$var$jd(b)){
        case 1:
            var e = $fdd90c8cbe9e299b$var$ed;
            break;
        case 4:
            e = $fdd90c8cbe9e299b$var$gd;
            break;
        default:
            e = $fdd90c8cbe9e299b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$fdd90c8cbe9e299b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $fdd90c8cbe9e299b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $fdd90c8cbe9e299b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $fdd90c8cbe9e299b$var$Jb(function() {
        var d = f, e = $fdd90c8cbe9e299b$var$xb(c), g = [];
        a: {
            var h = $fdd90c8cbe9e299b$var$df.get(a);
            if (void 0 !== h) {
                var k = $fdd90c8cbe9e299b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $fdd90c8cbe9e299b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $fdd90c8cbe9e299b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $fdd90c8cbe9e299b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $fdd90c8cbe9e299b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $fdd90c8cbe9e299b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $fdd90c8cbe9e299b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $fdd90c8cbe9e299b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $fdd90c8cbe9e299b$var$Vd;
                        break;
                    case $fdd90c8cbe9e299b$var$$e:
                    case $fdd90c8cbe9e299b$var$af:
                    case $fdd90c8cbe9e299b$var$bf:
                        k = $fdd90c8cbe9e299b$var$Hd;
                        break;
                    case $fdd90c8cbe9e299b$var$cf:
                        k = $fdd90c8cbe9e299b$var$Xd;
                        break;
                    case "scroll":
                        k = $fdd90c8cbe9e299b$var$vd;
                        break;
                    case "wheel":
                        k = $fdd90c8cbe9e299b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $fdd90c8cbe9e299b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $fdd90c8cbe9e299b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $fdd90c8cbe9e299b$var$Kb(w, x), null != F && t.push($fdd90c8cbe9e299b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $fdd90c8cbe9e299b$var$wb && (n = c.relatedTarget || c.fromElement) && ($fdd90c8cbe9e299b$var$Wc(n) || n[$fdd90c8cbe9e299b$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $fdd90c8cbe9e299b$var$Wc(n) : null, null !== n && (J = $fdd90c8cbe9e299b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $fdd90c8cbe9e299b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $fdd90c8cbe9e299b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $fdd90c8cbe9e299b$var$ue(k);
                        u = null == n ? h : $fdd90c8cbe9e299b$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $fdd90c8cbe9e299b$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $fdd90c8cbe9e299b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $fdd90c8cbe9e299b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $fdd90c8cbe9e299b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $fdd90c8cbe9e299b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $fdd90c8cbe9e299b$var$vf(t);
                                x = $fdd90c8cbe9e299b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $fdd90c8cbe9e299b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $fdd90c8cbe9e299b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $fdd90c8cbe9e299b$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $fdd90c8cbe9e299b$var$ve;
                else if ($fdd90c8cbe9e299b$var$me(h)) {
                    if ($fdd90c8cbe9e299b$var$we) na = $fdd90c8cbe9e299b$var$Fe;
                    else {
                        na = $fdd90c8cbe9e299b$var$De;
                        var xa = $fdd90c8cbe9e299b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $fdd90c8cbe9e299b$var$Ee);
                if (na && (na = na(a, d))) {
                    $fdd90c8cbe9e299b$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $fdd90c8cbe9e299b$var$cb(h, "number", h.value);
            }
            xa = d ? $fdd90c8cbe9e299b$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($fdd90c8cbe9e299b$var$me(xa) || "true" === xa.contentEditable) $fdd90c8cbe9e299b$var$Qe = xa, $fdd90c8cbe9e299b$var$Re = d, $fdd90c8cbe9e299b$var$Se = null;
                    break;
                case "focusout":
                    $fdd90c8cbe9e299b$var$Se = $fdd90c8cbe9e299b$var$Re = $fdd90c8cbe9e299b$var$Qe = null;
                    break;
                case "mousedown":
                    $fdd90c8cbe9e299b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $fdd90c8cbe9e299b$var$Te = !1;
                    $fdd90c8cbe9e299b$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($fdd90c8cbe9e299b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $fdd90c8cbe9e299b$var$Ue(g, c, e);
            }
            var $a;
            if ($fdd90c8cbe9e299b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $fdd90c8cbe9e299b$var$ie ? $fdd90c8cbe9e299b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($fdd90c8cbe9e299b$var$de && "ko" !== c.locale && ($fdd90c8cbe9e299b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $fdd90c8cbe9e299b$var$ie && ($a = $fdd90c8cbe9e299b$var$nd()) : ($fdd90c8cbe9e299b$var$kd = e, $fdd90c8cbe9e299b$var$ld = "value" in $fdd90c8cbe9e299b$var$kd ? $fdd90c8cbe9e299b$var$kd.value : $fdd90c8cbe9e299b$var$kd.textContent, $fdd90c8cbe9e299b$var$ie = !0)), xa = $fdd90c8cbe9e299b$var$oe(d, ba), 0 < xa.length && (ba = new $fdd90c8cbe9e299b$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $fdd90c8cbe9e299b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $fdd90c8cbe9e299b$var$ce ? $fdd90c8cbe9e299b$var$je(a, c) : $fdd90c8cbe9e299b$var$ke(a, c)) d = $fdd90c8cbe9e299b$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $fdd90c8cbe9e299b$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $fdd90c8cbe9e299b$var$se(g, b);
    });
}
function $fdd90c8cbe9e299b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $fdd90c8cbe9e299b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $fdd90c8cbe9e299b$var$Kb(a, c), null != f && d.unshift($fdd90c8cbe9e299b$var$tf(a, f, e)), f = $fdd90c8cbe9e299b$var$Kb(a, b), null != f && d.push($fdd90c8cbe9e299b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $fdd90c8cbe9e299b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $fdd90c8cbe9e299b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $fdd90c8cbe9e299b$var$Kb(c, f), null != k && g.unshift($fdd90c8cbe9e299b$var$tf(c, k, h))) : e || (k = $fdd90c8cbe9e299b$var$Kb(c, f), null != k && g.push($fdd90c8cbe9e299b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $fdd90c8cbe9e299b$var$xf = /\r\n?/g, $fdd90c8cbe9e299b$var$yf = /\u0000|\uFFFD/g;
function $fdd90c8cbe9e299b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($fdd90c8cbe9e299b$var$xf, "\n").replace($fdd90c8cbe9e299b$var$yf, "");
}
function $fdd90c8cbe9e299b$var$Af(a, b, c) {
    b = $fdd90c8cbe9e299b$var$zf(b);
    if ($fdd90c8cbe9e299b$var$zf(a) !== b && c) throw Error($fdd90c8cbe9e299b$var$p(425));
}
function $fdd90c8cbe9e299b$var$Bf() {}
var $fdd90c8cbe9e299b$var$Cf = null, $fdd90c8cbe9e299b$var$Df = null;
function $fdd90c8cbe9e299b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $fdd90c8cbe9e299b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $fdd90c8cbe9e299b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $fdd90c8cbe9e299b$var$Hf = "function" === typeof Promise ? Promise : void 0, $fdd90c8cbe9e299b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $fdd90c8cbe9e299b$var$Hf ? function(a) {
    return $fdd90c8cbe9e299b$var$Hf.resolve(null).then(a).catch($fdd90c8cbe9e299b$var$If);
} : $fdd90c8cbe9e299b$var$Ff;
function $fdd90c8cbe9e299b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $fdd90c8cbe9e299b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $fdd90c8cbe9e299b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $fdd90c8cbe9e299b$var$bd(b);
}
function $fdd90c8cbe9e299b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $fdd90c8cbe9e299b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $fdd90c8cbe9e299b$var$Nf = Math.random().toString(36).slice(2), $fdd90c8cbe9e299b$var$Of = "__reactFiber$" + $fdd90c8cbe9e299b$var$Nf, $fdd90c8cbe9e299b$var$Pf = "__reactProps$" + $fdd90c8cbe9e299b$var$Nf, $fdd90c8cbe9e299b$var$uf = "__reactContainer$" + $fdd90c8cbe9e299b$var$Nf, $fdd90c8cbe9e299b$var$of = "__reactEvents$" + $fdd90c8cbe9e299b$var$Nf, $fdd90c8cbe9e299b$var$Qf = "__reactListeners$" + $fdd90c8cbe9e299b$var$Nf, $fdd90c8cbe9e299b$var$Rf = "__reactHandles$" + $fdd90c8cbe9e299b$var$Nf;
function $fdd90c8cbe9e299b$var$Wc(a) {
    var b = a[$fdd90c8cbe9e299b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$fdd90c8cbe9e299b$var$uf] || c[$fdd90c8cbe9e299b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $fdd90c8cbe9e299b$var$Mf(a); null !== a;){
                if (c = a[$fdd90c8cbe9e299b$var$Of]) return c;
                a = $fdd90c8cbe9e299b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $fdd90c8cbe9e299b$var$Cb(a) {
    a = a[$fdd90c8cbe9e299b$var$Of] || a[$fdd90c8cbe9e299b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $fdd90c8cbe9e299b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($fdd90c8cbe9e299b$var$p(33));
}
function $fdd90c8cbe9e299b$var$Db(a) {
    return a[$fdd90c8cbe9e299b$var$Pf] || null;
}
var $fdd90c8cbe9e299b$var$Sf = [], $fdd90c8cbe9e299b$var$Tf = -1;
function $fdd90c8cbe9e299b$var$Uf(a) {
    return {
        current: a
    };
}
function $fdd90c8cbe9e299b$var$E(a) {
    0 > $fdd90c8cbe9e299b$var$Tf || (a.current = $fdd90c8cbe9e299b$var$Sf[$fdd90c8cbe9e299b$var$Tf], $fdd90c8cbe9e299b$var$Sf[$fdd90c8cbe9e299b$var$Tf] = null, $fdd90c8cbe9e299b$var$Tf--);
}
function $fdd90c8cbe9e299b$var$G(a, b) {
    $fdd90c8cbe9e299b$var$Tf++;
    $fdd90c8cbe9e299b$var$Sf[$fdd90c8cbe9e299b$var$Tf] = a.current;
    a.current = b;
}
var $fdd90c8cbe9e299b$var$Vf = {}, $fdd90c8cbe9e299b$var$H = $fdd90c8cbe9e299b$var$Uf($fdd90c8cbe9e299b$var$Vf), $fdd90c8cbe9e299b$var$Wf = $fdd90c8cbe9e299b$var$Uf(!1), $fdd90c8cbe9e299b$var$Xf = $fdd90c8cbe9e299b$var$Vf;
function $fdd90c8cbe9e299b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $fdd90c8cbe9e299b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $fdd90c8cbe9e299b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $fdd90c8cbe9e299b$var$$f() {
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf);
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$H);
}
function $fdd90c8cbe9e299b$var$ag(a, b, c) {
    if ($fdd90c8cbe9e299b$var$H.current !== $fdd90c8cbe9e299b$var$Vf) throw Error($fdd90c8cbe9e299b$var$p(168));
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$H, b);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Wf, c);
}
function $fdd90c8cbe9e299b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($fdd90c8cbe9e299b$var$p(108, $fdd90c8cbe9e299b$var$Ra(a) || "Unknown", e));
    return $fdd90c8cbe9e299b$var$A({}, c, d);
}
function $fdd90c8cbe9e299b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $fdd90c8cbe9e299b$var$Vf;
    $fdd90c8cbe9e299b$var$Xf = $fdd90c8cbe9e299b$var$H.current;
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$H, a);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Wf, $fdd90c8cbe9e299b$var$Wf.current);
    return !0;
}
function $fdd90c8cbe9e299b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($fdd90c8cbe9e299b$var$p(169));
    c ? (a = $fdd90c8cbe9e299b$var$bg(a, b, $fdd90c8cbe9e299b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf), $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$H), $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$H, a)) : $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Wf, c);
}
var $fdd90c8cbe9e299b$var$eg = null, $fdd90c8cbe9e299b$var$fg = !1, $fdd90c8cbe9e299b$var$gg = !1;
function $fdd90c8cbe9e299b$var$hg(a) {
    null === $fdd90c8cbe9e299b$var$eg ? $fdd90c8cbe9e299b$var$eg = [
        a
    ] : $fdd90c8cbe9e299b$var$eg.push(a);
}
function $fdd90c8cbe9e299b$var$ig(a) {
    $fdd90c8cbe9e299b$var$fg = !0;
    $fdd90c8cbe9e299b$var$hg(a);
}
function $fdd90c8cbe9e299b$var$jg() {
    if (!$fdd90c8cbe9e299b$var$gg && null !== $fdd90c8cbe9e299b$var$eg) {
        $fdd90c8cbe9e299b$var$gg = !0;
        var a = 0, b = $fdd90c8cbe9e299b$var$C;
        try {
            var c = $fdd90c8cbe9e299b$var$eg;
            for($fdd90c8cbe9e299b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $fdd90c8cbe9e299b$var$eg = null;
            $fdd90c8cbe9e299b$var$fg = !1;
        } catch (e) {
            throw null !== $fdd90c8cbe9e299b$var$eg && ($fdd90c8cbe9e299b$var$eg = $fdd90c8cbe9e299b$var$eg.slice(a + 1)), $fdd90c8cbe9e299b$var$ac($fdd90c8cbe9e299b$var$fc, $fdd90c8cbe9e299b$var$jg), e;
        } finally{
            $fdd90c8cbe9e299b$var$C = b, $fdd90c8cbe9e299b$var$gg = !1;
        }
    }
    return null;
}
var $fdd90c8cbe9e299b$var$kg = [], $fdd90c8cbe9e299b$var$lg = 0, $fdd90c8cbe9e299b$var$mg = null, $fdd90c8cbe9e299b$var$ng = 0, $fdd90c8cbe9e299b$var$og = [], $fdd90c8cbe9e299b$var$pg = 0, $fdd90c8cbe9e299b$var$qg = null, $fdd90c8cbe9e299b$var$rg = 1, $fdd90c8cbe9e299b$var$sg = "";
function $fdd90c8cbe9e299b$var$tg(a, b) {
    $fdd90c8cbe9e299b$var$kg[$fdd90c8cbe9e299b$var$lg++] = $fdd90c8cbe9e299b$var$ng;
    $fdd90c8cbe9e299b$var$kg[$fdd90c8cbe9e299b$var$lg++] = $fdd90c8cbe9e299b$var$mg;
    $fdd90c8cbe9e299b$var$mg = a;
    $fdd90c8cbe9e299b$var$ng = b;
}
function $fdd90c8cbe9e299b$var$ug(a, b, c) {
    $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$rg;
    $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$sg;
    $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$qg;
    $fdd90c8cbe9e299b$var$qg = a;
    var d = $fdd90c8cbe9e299b$var$rg;
    a = $fdd90c8cbe9e299b$var$sg;
    var e = 32 - $fdd90c8cbe9e299b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $fdd90c8cbe9e299b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $fdd90c8cbe9e299b$var$rg = 1 << 32 - $fdd90c8cbe9e299b$var$oc(b) + e | c << e | d;
        $fdd90c8cbe9e299b$var$sg = f + a;
    } else $fdd90c8cbe9e299b$var$rg = 1 << f | c << e | d, $fdd90c8cbe9e299b$var$sg = a;
}
function $fdd90c8cbe9e299b$var$vg(a) {
    null !== a.return && ($fdd90c8cbe9e299b$var$tg(a, 1), $fdd90c8cbe9e299b$var$ug(a, 1, 0));
}
function $fdd90c8cbe9e299b$var$wg(a) {
    for(; a === $fdd90c8cbe9e299b$var$mg;)$fdd90c8cbe9e299b$var$mg = $fdd90c8cbe9e299b$var$kg[--$fdd90c8cbe9e299b$var$lg], $fdd90c8cbe9e299b$var$kg[$fdd90c8cbe9e299b$var$lg] = null, $fdd90c8cbe9e299b$var$ng = $fdd90c8cbe9e299b$var$kg[--$fdd90c8cbe9e299b$var$lg], $fdd90c8cbe9e299b$var$kg[$fdd90c8cbe9e299b$var$lg] = null;
    for(; a === $fdd90c8cbe9e299b$var$qg;)$fdd90c8cbe9e299b$var$qg = $fdd90c8cbe9e299b$var$og[--$fdd90c8cbe9e299b$var$pg], $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg] = null, $fdd90c8cbe9e299b$var$sg = $fdd90c8cbe9e299b$var$og[--$fdd90c8cbe9e299b$var$pg], $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg] = null, $fdd90c8cbe9e299b$var$rg = $fdd90c8cbe9e299b$var$og[--$fdd90c8cbe9e299b$var$pg], $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg] = null;
}
var $fdd90c8cbe9e299b$var$xg = null, $fdd90c8cbe9e299b$var$yg = null, $fdd90c8cbe9e299b$var$I = !1, $fdd90c8cbe9e299b$var$zg = null;
function $fdd90c8cbe9e299b$var$Ag(a, b) {
    var c = $fdd90c8cbe9e299b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $fdd90c8cbe9e299b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $fdd90c8cbe9e299b$var$xg = a, $fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $fdd90c8cbe9e299b$var$xg = a, $fdd90c8cbe9e299b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $fdd90c8cbe9e299b$var$qg ? {
                id: $fdd90c8cbe9e299b$var$rg,
                overflow: $fdd90c8cbe9e299b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $fdd90c8cbe9e299b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $fdd90c8cbe9e299b$var$xg = a, $fdd90c8cbe9e299b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $fdd90c8cbe9e299b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $fdd90c8cbe9e299b$var$Eg(a) {
    if ($fdd90c8cbe9e299b$var$I) {
        var b = $fdd90c8cbe9e299b$var$yg;
        if (b) {
            var c = b;
            if (!$fdd90c8cbe9e299b$var$Cg(a, b)) {
                if ($fdd90c8cbe9e299b$var$Dg(a)) throw Error($fdd90c8cbe9e299b$var$p(418));
                b = $fdd90c8cbe9e299b$var$Lf(c.nextSibling);
                var d = $fdd90c8cbe9e299b$var$xg;
                b && $fdd90c8cbe9e299b$var$Cg(a, b) ? $fdd90c8cbe9e299b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $fdd90c8cbe9e299b$var$I = !1, $fdd90c8cbe9e299b$var$xg = a);
            }
        } else {
            if ($fdd90c8cbe9e299b$var$Dg(a)) throw Error($fdd90c8cbe9e299b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $fdd90c8cbe9e299b$var$I = !1;
            $fdd90c8cbe9e299b$var$xg = a;
        }
    }
}
function $fdd90c8cbe9e299b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $fdd90c8cbe9e299b$var$xg = a;
}
function $fdd90c8cbe9e299b$var$Gg(a) {
    if (a !== $fdd90c8cbe9e299b$var$xg) return !1;
    if (!$fdd90c8cbe9e299b$var$I) return $fdd90c8cbe9e299b$var$Fg(a), $fdd90c8cbe9e299b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$fdd90c8cbe9e299b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $fdd90c8cbe9e299b$var$yg)) {
        if ($fdd90c8cbe9e299b$var$Dg(a)) throw $fdd90c8cbe9e299b$var$Hg(), Error($fdd90c8cbe9e299b$var$p(418));
        for(; b;)$fdd90c8cbe9e299b$var$Ag(a, b), b = $fdd90c8cbe9e299b$var$Lf(b.nextSibling);
    }
    $fdd90c8cbe9e299b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($fdd90c8cbe9e299b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $fdd90c8cbe9e299b$var$yg = null;
        }
    } else $fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$xg ? $fdd90c8cbe9e299b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $fdd90c8cbe9e299b$var$Hg() {
    for(var a = $fdd90c8cbe9e299b$var$yg; a;)a = $fdd90c8cbe9e299b$var$Lf(a.nextSibling);
}
function $fdd90c8cbe9e299b$var$Ig() {
    $fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$xg = null;
    $fdd90c8cbe9e299b$var$I = !1;
}
function $fdd90c8cbe9e299b$var$Jg(a) {
    null === $fdd90c8cbe9e299b$var$zg ? $fdd90c8cbe9e299b$var$zg = [
        a
    ] : $fdd90c8cbe9e299b$var$zg.push(a);
}
var $fdd90c8cbe9e299b$var$Kg = $fdd90c8cbe9e299b$var$ua.ReactCurrentBatchConfig;
function $fdd90c8cbe9e299b$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($fdd90c8cbe9e299b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($fdd90c8cbe9e299b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($fdd90c8cbe9e299b$var$p(284));
        if (!c._owner) throw Error($fdd90c8cbe9e299b$var$p(290, a));
    }
    return a;
}
function $fdd90c8cbe9e299b$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($fdd90c8cbe9e299b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $fdd90c8cbe9e299b$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $fdd90c8cbe9e299b$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $fdd90c8cbe9e299b$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $fdd90c8cbe9e299b$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $fdd90c8cbe9e299b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $fdd90c8cbe9e299b$var$Ha && $fdd90c8cbe9e299b$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $fdd90c8cbe9e299b$var$Lg(a, b, c), d.return = a, d;
        d = $fdd90c8cbe9e299b$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $fdd90c8cbe9e299b$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $fdd90c8cbe9e299b$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $fdd90c8cbe9e299b$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $fdd90c8cbe9e299b$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $fdd90c8cbe9e299b$var$va:
                    return c = $fdd90c8cbe9e299b$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $fdd90c8cbe9e299b$var$Lg(a, null, b), c.return = a, c;
                case $fdd90c8cbe9e299b$var$wa:
                    return b = $fdd90c8cbe9e299b$var$Sg(b, a.mode, c), b.return = a, b;
                case $fdd90c8cbe9e299b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($fdd90c8cbe9e299b$var$eb(b) || $fdd90c8cbe9e299b$var$Ka(b)) return b = $fdd90c8cbe9e299b$var$Tg(b, a.mode, c, null), b.return = a, b;
            $fdd90c8cbe9e299b$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $fdd90c8cbe9e299b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $fdd90c8cbe9e299b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $fdd90c8cbe9e299b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($fdd90c8cbe9e299b$var$eb(c) || $fdd90c8cbe9e299b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $fdd90c8cbe9e299b$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $fdd90c8cbe9e299b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $fdd90c8cbe9e299b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $fdd90c8cbe9e299b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($fdd90c8cbe9e299b$var$eb(d) || $fdd90c8cbe9e299b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $fdd90c8cbe9e299b$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $fdd90c8cbe9e299b$var$Ka(h);
        if ("function" !== typeof l) throw Error($fdd90c8cbe9e299b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($fdd90c8cbe9e299b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $fdd90c8cbe9e299b$var$I && $fdd90c8cbe9e299b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $fdd90c8cbe9e299b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $fdd90c8cbe9e299b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $fdd90c8cbe9e299b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $fdd90c8cbe9e299b$var$Ha && $fdd90c8cbe9e299b$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $fdd90c8cbe9e299b$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $fdd90c8cbe9e299b$var$ya ? (d = $fdd90c8cbe9e299b$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $fdd90c8cbe9e299b$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $fdd90c8cbe9e299b$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $fdd90c8cbe9e299b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $fdd90c8cbe9e299b$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $fdd90c8cbe9e299b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($fdd90c8cbe9e299b$var$eb(f)) return n(a, d, f, h);
            if ($fdd90c8cbe9e299b$var$Ka(f)) return t(a, d, f, h);
            $fdd90c8cbe9e299b$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $fdd90c8cbe9e299b$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $fdd90c8cbe9e299b$var$Ug = $fdd90c8cbe9e299b$var$Og(!0), $fdd90c8cbe9e299b$var$Vg = $fdd90c8cbe9e299b$var$Og(!1), $fdd90c8cbe9e299b$var$Wg = $fdd90c8cbe9e299b$var$Uf(null), $fdd90c8cbe9e299b$var$Xg = null, $fdd90c8cbe9e299b$var$Yg = null, $fdd90c8cbe9e299b$var$Zg = null;
function $fdd90c8cbe9e299b$var$$g() {
    $fdd90c8cbe9e299b$var$Zg = $fdd90c8cbe9e299b$var$Yg = $fdd90c8cbe9e299b$var$Xg = null;
}
function $fdd90c8cbe9e299b$var$ah(a) {
    var b = $fdd90c8cbe9e299b$var$Wg.current;
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wg);
    a._currentValue = b;
}
function $fdd90c8cbe9e299b$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $fdd90c8cbe9e299b$var$ch(a, b) {
    $fdd90c8cbe9e299b$var$Xg = a;
    $fdd90c8cbe9e299b$var$Zg = $fdd90c8cbe9e299b$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($fdd90c8cbe9e299b$var$dh = !0), a.firstContext = null);
}
function $fdd90c8cbe9e299b$var$eh(a) {
    var b = a._currentValue;
    if ($fdd90c8cbe9e299b$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $fdd90c8cbe9e299b$var$Yg) {
            if (null === $fdd90c8cbe9e299b$var$Xg) throw Error($fdd90c8cbe9e299b$var$p(308));
            $fdd90c8cbe9e299b$var$Yg = a;
            $fdd90c8cbe9e299b$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $fdd90c8cbe9e299b$var$Yg = $fdd90c8cbe9e299b$var$Yg.next = a;
    }
    return b;
}
var $fdd90c8cbe9e299b$var$fh = null;
function $fdd90c8cbe9e299b$var$gh(a) {
    null === $fdd90c8cbe9e299b$var$fh ? $fdd90c8cbe9e299b$var$fh = [
        a
    ] : $fdd90c8cbe9e299b$var$fh.push(a);
}
function $fdd90c8cbe9e299b$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $fdd90c8cbe9e299b$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $fdd90c8cbe9e299b$var$ih(a, d);
}
function $fdd90c8cbe9e299b$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $fdd90c8cbe9e299b$var$jh = !1;
function $fdd90c8cbe9e299b$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $fdd90c8cbe9e299b$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $fdd90c8cbe9e299b$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $fdd90c8cbe9e299b$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($fdd90c8cbe9e299b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $fdd90c8cbe9e299b$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $fdd90c8cbe9e299b$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $fdd90c8cbe9e299b$var$ih(a, c);
}
function $fdd90c8cbe9e299b$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fdd90c8cbe9e299b$var$Cc(a, c);
    }
}
function $fdd90c8cbe9e299b$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $fdd90c8cbe9e299b$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $fdd90c8cbe9e299b$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $fdd90c8cbe9e299b$var$A({}, q, r);
                            break a;
                        case 2:
                            $fdd90c8cbe9e299b$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $fdd90c8cbe9e299b$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $fdd90c8cbe9e299b$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($fdd90c8cbe9e299b$var$p(191, e));
            e.call(d);
        }
    }
}
var $fdd90c8cbe9e299b$var$th = {}, $fdd90c8cbe9e299b$var$uh = $fdd90c8cbe9e299b$var$Uf($fdd90c8cbe9e299b$var$th), $fdd90c8cbe9e299b$var$vh = $fdd90c8cbe9e299b$var$Uf($fdd90c8cbe9e299b$var$th), $fdd90c8cbe9e299b$var$wh = $fdd90c8cbe9e299b$var$Uf($fdd90c8cbe9e299b$var$th);
function $fdd90c8cbe9e299b$var$xh(a) {
    if (a === $fdd90c8cbe9e299b$var$th) throw Error($fdd90c8cbe9e299b$var$p(174));
    return a;
}
function $fdd90c8cbe9e299b$var$yh(a, b) {
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$wh, b);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$vh, a);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$uh, $fdd90c8cbe9e299b$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $fdd90c8cbe9e299b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $fdd90c8cbe9e299b$var$lb(b, a);
    }
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$uh);
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$uh, b);
}
function $fdd90c8cbe9e299b$var$zh() {
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$uh);
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$vh);
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$wh);
}
function $fdd90c8cbe9e299b$var$Ah(a) {
    $fdd90c8cbe9e299b$var$xh($fdd90c8cbe9e299b$var$wh.current);
    var b = $fdd90c8cbe9e299b$var$xh($fdd90c8cbe9e299b$var$uh.current);
    var c = $fdd90c8cbe9e299b$var$lb(b, a.type);
    b !== c && ($fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$vh, a), $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$uh, c));
}
function $fdd90c8cbe9e299b$var$Bh(a) {
    $fdd90c8cbe9e299b$var$vh.current === a && ($fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$uh), $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$vh));
}
var $fdd90c8cbe9e299b$var$L = $fdd90c8cbe9e299b$var$Uf(0);
function $fdd90c8cbe9e299b$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $fdd90c8cbe9e299b$var$Dh = [];
function $fdd90c8cbe9e299b$var$Eh() {
    for(var a = 0; a < $fdd90c8cbe9e299b$var$Dh.length; a++)$fdd90c8cbe9e299b$var$Dh[a]._workInProgressVersionPrimary = null;
    $fdd90c8cbe9e299b$var$Dh.length = 0;
}
var $fdd90c8cbe9e299b$var$Fh = $fdd90c8cbe9e299b$var$ua.ReactCurrentDispatcher, $fdd90c8cbe9e299b$var$Gh = $fdd90c8cbe9e299b$var$ua.ReactCurrentBatchConfig, $fdd90c8cbe9e299b$var$Hh = 0, $fdd90c8cbe9e299b$var$M = null, $fdd90c8cbe9e299b$var$N = null, $fdd90c8cbe9e299b$var$O = null, $fdd90c8cbe9e299b$var$Ih = !1, $fdd90c8cbe9e299b$var$Jh = !1, $fdd90c8cbe9e299b$var$Kh = 0, $fdd90c8cbe9e299b$var$Lh = 0;
function $fdd90c8cbe9e299b$var$P() {
    throw Error($fdd90c8cbe9e299b$var$p(321));
}
function $fdd90c8cbe9e299b$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$fdd90c8cbe9e299b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $fdd90c8cbe9e299b$var$Nh(a, b, c, d, e, f) {
    $fdd90c8cbe9e299b$var$Hh = f;
    $fdd90c8cbe9e299b$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $fdd90c8cbe9e299b$var$Fh.current = null === a || null === a.memoizedState ? $fdd90c8cbe9e299b$var$Oh : $fdd90c8cbe9e299b$var$Ph;
    a = c(d, e);
    if ($fdd90c8cbe9e299b$var$Jh) {
        f = 0;
        do {
            $fdd90c8cbe9e299b$var$Jh = !1;
            $fdd90c8cbe9e299b$var$Kh = 0;
            if (25 <= f) throw Error($fdd90c8cbe9e299b$var$p(301));
            f += 1;
            $fdd90c8cbe9e299b$var$O = $fdd90c8cbe9e299b$var$N = null;
            b.updateQueue = null;
            $fdd90c8cbe9e299b$var$Fh.current = $fdd90c8cbe9e299b$var$Qh;
            a = c(d, e);
        }while ($fdd90c8cbe9e299b$var$Jh);
    }
    $fdd90c8cbe9e299b$var$Fh.current = $fdd90c8cbe9e299b$var$Rh;
    b = null !== $fdd90c8cbe9e299b$var$N && null !== $fdd90c8cbe9e299b$var$N.next;
    $fdd90c8cbe9e299b$var$Hh = 0;
    $fdd90c8cbe9e299b$var$O = $fdd90c8cbe9e299b$var$N = $fdd90c8cbe9e299b$var$M = null;
    $fdd90c8cbe9e299b$var$Ih = !1;
    if (b) throw Error($fdd90c8cbe9e299b$var$p(300));
    return a;
}
function $fdd90c8cbe9e299b$var$Sh() {
    var a = 0 !== $fdd90c8cbe9e299b$var$Kh;
    $fdd90c8cbe9e299b$var$Kh = 0;
    return a;
}
function $fdd90c8cbe9e299b$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $fdd90c8cbe9e299b$var$O ? $fdd90c8cbe9e299b$var$M.memoizedState = $fdd90c8cbe9e299b$var$O = a : $fdd90c8cbe9e299b$var$O = $fdd90c8cbe9e299b$var$O.next = a;
    return $fdd90c8cbe9e299b$var$O;
}
function $fdd90c8cbe9e299b$var$Uh() {
    if (null === $fdd90c8cbe9e299b$var$N) {
        var a = $fdd90c8cbe9e299b$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $fdd90c8cbe9e299b$var$N.next;
    var b = null === $fdd90c8cbe9e299b$var$O ? $fdd90c8cbe9e299b$var$M.memoizedState : $fdd90c8cbe9e299b$var$O.next;
    if (null !== b) $fdd90c8cbe9e299b$var$O = b, $fdd90c8cbe9e299b$var$N = a;
    else {
        if (null === a) throw Error($fdd90c8cbe9e299b$var$p(310));
        $fdd90c8cbe9e299b$var$N = a;
        a = {
            memoizedState: $fdd90c8cbe9e299b$var$N.memoizedState,
            baseState: $fdd90c8cbe9e299b$var$N.baseState,
            baseQueue: $fdd90c8cbe9e299b$var$N.baseQueue,
            queue: $fdd90c8cbe9e299b$var$N.queue,
            next: null
        };
        null === $fdd90c8cbe9e299b$var$O ? $fdd90c8cbe9e299b$var$M.memoizedState = $fdd90c8cbe9e299b$var$O = a : $fdd90c8cbe9e299b$var$O = $fdd90c8cbe9e299b$var$O.next = a;
    }
    return $fdd90c8cbe9e299b$var$O;
}
function $fdd90c8cbe9e299b$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $fdd90c8cbe9e299b$var$Wh(a) {
    var b = $fdd90c8cbe9e299b$var$Uh(), c = b.queue;
    if (null === c) throw Error($fdd90c8cbe9e299b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $fdd90c8cbe9e299b$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($fdd90c8cbe9e299b$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $fdd90c8cbe9e299b$var$M.lanes |= m;
                $fdd90c8cbe9e299b$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $fdd90c8cbe9e299b$var$He(d, b.memoizedState) || ($fdd90c8cbe9e299b$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $fdd90c8cbe9e299b$var$M.lanes |= f, $fdd90c8cbe9e299b$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $fdd90c8cbe9e299b$var$Xh(a) {
    var b = $fdd90c8cbe9e299b$var$Uh(), c = b.queue;
    if (null === c) throw Error($fdd90c8cbe9e299b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $fdd90c8cbe9e299b$var$He(f, b.memoizedState) || ($fdd90c8cbe9e299b$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $fdd90c8cbe9e299b$var$Yh() {}
function $fdd90c8cbe9e299b$var$Zh(a, b) {
    var c = $fdd90c8cbe9e299b$var$M, d = $fdd90c8cbe9e299b$var$Uh(), e = b(), f = !$fdd90c8cbe9e299b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $fdd90c8cbe9e299b$var$dh = !0);
    d = d.queue;
    $fdd90c8cbe9e299b$var$$h($fdd90c8cbe9e299b$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $fdd90c8cbe9e299b$var$O && $fdd90c8cbe9e299b$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $fdd90c8cbe9e299b$var$bi(9, $fdd90c8cbe9e299b$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $fdd90c8cbe9e299b$var$Q) throw Error($fdd90c8cbe9e299b$var$p(349));
        0 !== ($fdd90c8cbe9e299b$var$Hh & 30) || $fdd90c8cbe9e299b$var$di(c, b, e);
    }
    return e;
}
function $fdd90c8cbe9e299b$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $fdd90c8cbe9e299b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fdd90c8cbe9e299b$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $fdd90c8cbe9e299b$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $fdd90c8cbe9e299b$var$ei(b) && $fdd90c8cbe9e299b$var$fi(a);
}
function $fdd90c8cbe9e299b$var$ai(a, b, c) {
    return c(function() {
        $fdd90c8cbe9e299b$var$ei(b) && $fdd90c8cbe9e299b$var$fi(a);
    });
}
function $fdd90c8cbe9e299b$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$fdd90c8cbe9e299b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $fdd90c8cbe9e299b$var$fi(a) {
    var b = $fdd90c8cbe9e299b$var$ih(a, 1);
    null !== b && $fdd90c8cbe9e299b$var$gi(b, a, 1, -1);
}
function $fdd90c8cbe9e299b$var$hi(a) {
    var b = $fdd90c8cbe9e299b$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fdd90c8cbe9e299b$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $fdd90c8cbe9e299b$var$ii.bind(null, $fdd90c8cbe9e299b$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $fdd90c8cbe9e299b$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $fdd90c8cbe9e299b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fdd90c8cbe9e299b$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $fdd90c8cbe9e299b$var$ji() {
    return $fdd90c8cbe9e299b$var$Uh().memoizedState;
}
function $fdd90c8cbe9e299b$var$ki(a, b, c, d) {
    var e = $fdd90c8cbe9e299b$var$Th();
    $fdd90c8cbe9e299b$var$M.flags |= a;
    e.memoizedState = $fdd90c8cbe9e299b$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $fdd90c8cbe9e299b$var$li(a, b, c, d) {
    var e = $fdd90c8cbe9e299b$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $fdd90c8cbe9e299b$var$N) {
        var g = $fdd90c8cbe9e299b$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $fdd90c8cbe9e299b$var$Mh(d, g.deps)) {
            e.memoizedState = $fdd90c8cbe9e299b$var$bi(b, c, f, d);
            return;
        }
    }
    $fdd90c8cbe9e299b$var$M.flags |= a;
    e.memoizedState = $fdd90c8cbe9e299b$var$bi(1 | b, c, f, d);
}
function $fdd90c8cbe9e299b$var$mi(a, b) {
    return $fdd90c8cbe9e299b$var$ki(8390656, 8, a, b);
}
function $fdd90c8cbe9e299b$var$$h(a, b) {
    return $fdd90c8cbe9e299b$var$li(2048, 8, a, b);
}
function $fdd90c8cbe9e299b$var$ni(a, b) {
    return $fdd90c8cbe9e299b$var$li(4, 2, a, b);
}
function $fdd90c8cbe9e299b$var$oi(a, b) {
    return $fdd90c8cbe9e299b$var$li(4, 4, a, b);
}
function $fdd90c8cbe9e299b$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $fdd90c8cbe9e299b$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $fdd90c8cbe9e299b$var$li(4, 4, $fdd90c8cbe9e299b$var$pi.bind(null, b, a), c);
}
function $fdd90c8cbe9e299b$var$ri() {}
function $fdd90c8cbe9e299b$var$si(a, b) {
    var c = $fdd90c8cbe9e299b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fdd90c8cbe9e299b$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fdd90c8cbe9e299b$var$ti(a, b) {
    var c = $fdd90c8cbe9e299b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fdd90c8cbe9e299b$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fdd90c8cbe9e299b$var$ui(a, b, c) {
    if (0 === ($fdd90c8cbe9e299b$var$Hh & 21)) return a.baseState && (a.baseState = !1, $fdd90c8cbe9e299b$var$dh = !0), a.memoizedState = c;
    $fdd90c8cbe9e299b$var$He(c, b) || (c = $fdd90c8cbe9e299b$var$yc(), $fdd90c8cbe9e299b$var$M.lanes |= c, $fdd90c8cbe9e299b$var$rh |= c, a.baseState = !0);
    return b;
}
function $fdd90c8cbe9e299b$var$vi(a, b) {
    var c = $fdd90c8cbe9e299b$var$C;
    $fdd90c8cbe9e299b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $fdd90c8cbe9e299b$var$Gh.transition;
    $fdd90c8cbe9e299b$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $fdd90c8cbe9e299b$var$C = c, $fdd90c8cbe9e299b$var$Gh.transition = d;
    }
}
function $fdd90c8cbe9e299b$var$wi() {
    return $fdd90c8cbe9e299b$var$Uh().memoizedState;
}
function $fdd90c8cbe9e299b$var$xi(a, b, c) {
    var d = $fdd90c8cbe9e299b$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fdd90c8cbe9e299b$var$zi(a)) $fdd90c8cbe9e299b$var$Ai(b, c);
    else if (c = $fdd90c8cbe9e299b$var$hh(a, b, c, d), null !== c) {
        var e = $fdd90c8cbe9e299b$var$R();
        $fdd90c8cbe9e299b$var$gi(c, a, d, e);
        $fdd90c8cbe9e299b$var$Bi(c, b, d);
    }
}
function $fdd90c8cbe9e299b$var$ii(a, b, c) {
    var d = $fdd90c8cbe9e299b$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fdd90c8cbe9e299b$var$zi(a)) $fdd90c8cbe9e299b$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($fdd90c8cbe9e299b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $fdd90c8cbe9e299b$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $fdd90c8cbe9e299b$var$hh(a, b, e, d);
        null !== c && (e = $fdd90c8cbe9e299b$var$R(), $fdd90c8cbe9e299b$var$gi(c, a, d, e), $fdd90c8cbe9e299b$var$Bi(c, b, d));
    }
}
function $fdd90c8cbe9e299b$var$zi(a) {
    var b = a.alternate;
    return a === $fdd90c8cbe9e299b$var$M || null !== b && b === $fdd90c8cbe9e299b$var$M;
}
function $fdd90c8cbe9e299b$var$Ai(a, b) {
    $fdd90c8cbe9e299b$var$Jh = $fdd90c8cbe9e299b$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $fdd90c8cbe9e299b$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fdd90c8cbe9e299b$var$Cc(a, c);
    }
}
var $fdd90c8cbe9e299b$var$Rh = {
    readContext: $fdd90c8cbe9e299b$var$eh,
    useCallback: $fdd90c8cbe9e299b$var$P,
    useContext: $fdd90c8cbe9e299b$var$P,
    useEffect: $fdd90c8cbe9e299b$var$P,
    useImperativeHandle: $fdd90c8cbe9e299b$var$P,
    useInsertionEffect: $fdd90c8cbe9e299b$var$P,
    useLayoutEffect: $fdd90c8cbe9e299b$var$P,
    useMemo: $fdd90c8cbe9e299b$var$P,
    useReducer: $fdd90c8cbe9e299b$var$P,
    useRef: $fdd90c8cbe9e299b$var$P,
    useState: $fdd90c8cbe9e299b$var$P,
    useDebugValue: $fdd90c8cbe9e299b$var$P,
    useDeferredValue: $fdd90c8cbe9e299b$var$P,
    useTransition: $fdd90c8cbe9e299b$var$P,
    useMutableSource: $fdd90c8cbe9e299b$var$P,
    useSyncExternalStore: $fdd90c8cbe9e299b$var$P,
    useId: $fdd90c8cbe9e299b$var$P,
    unstable_isNewReconciler: !1
}, $fdd90c8cbe9e299b$var$Oh = {
    readContext: $fdd90c8cbe9e299b$var$eh,
    useCallback: function(a, b) {
        $fdd90c8cbe9e299b$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $fdd90c8cbe9e299b$var$eh,
    useEffect: $fdd90c8cbe9e299b$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $fdd90c8cbe9e299b$var$ki(4194308, 4, $fdd90c8cbe9e299b$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $fdd90c8cbe9e299b$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $fdd90c8cbe9e299b$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $fdd90c8cbe9e299b$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $fdd90c8cbe9e299b$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $fdd90c8cbe9e299b$var$xi.bind(null, $fdd90c8cbe9e299b$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $fdd90c8cbe9e299b$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $fdd90c8cbe9e299b$var$hi,
    useDebugValue: $fdd90c8cbe9e299b$var$ri,
    useDeferredValue: function(a) {
        return $fdd90c8cbe9e299b$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $fdd90c8cbe9e299b$var$hi(!1), b = a[0];
        a = $fdd90c8cbe9e299b$var$vi.bind(null, a[1]);
        $fdd90c8cbe9e299b$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $fdd90c8cbe9e299b$var$M, e = $fdd90c8cbe9e299b$var$Th();
        if ($fdd90c8cbe9e299b$var$I) {
            if (void 0 === c) throw Error($fdd90c8cbe9e299b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $fdd90c8cbe9e299b$var$Q) throw Error($fdd90c8cbe9e299b$var$p(349));
            0 !== ($fdd90c8cbe9e299b$var$Hh & 30) || $fdd90c8cbe9e299b$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $fdd90c8cbe9e299b$var$mi($fdd90c8cbe9e299b$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $fdd90c8cbe9e299b$var$bi(9, $fdd90c8cbe9e299b$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $fdd90c8cbe9e299b$var$Th(), b = $fdd90c8cbe9e299b$var$Q.identifierPrefix;
        if ($fdd90c8cbe9e299b$var$I) {
            var c = $fdd90c8cbe9e299b$var$sg;
            var d = $fdd90c8cbe9e299b$var$rg;
            c = (d & ~(1 << 32 - $fdd90c8cbe9e299b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $fdd90c8cbe9e299b$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $fdd90c8cbe9e299b$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $fdd90c8cbe9e299b$var$Ph = {
    readContext: $fdd90c8cbe9e299b$var$eh,
    useCallback: $fdd90c8cbe9e299b$var$si,
    useContext: $fdd90c8cbe9e299b$var$eh,
    useEffect: $fdd90c8cbe9e299b$var$$h,
    useImperativeHandle: $fdd90c8cbe9e299b$var$qi,
    useInsertionEffect: $fdd90c8cbe9e299b$var$ni,
    useLayoutEffect: $fdd90c8cbe9e299b$var$oi,
    useMemo: $fdd90c8cbe9e299b$var$ti,
    useReducer: $fdd90c8cbe9e299b$var$Wh,
    useRef: $fdd90c8cbe9e299b$var$ji,
    useState: function() {
        return $fdd90c8cbe9e299b$var$Wh($fdd90c8cbe9e299b$var$Vh);
    },
    useDebugValue: $fdd90c8cbe9e299b$var$ri,
    useDeferredValue: function(a) {
        var b = $fdd90c8cbe9e299b$var$Uh();
        return $fdd90c8cbe9e299b$var$ui(b, $fdd90c8cbe9e299b$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fdd90c8cbe9e299b$var$Wh($fdd90c8cbe9e299b$var$Vh)[0], b = $fdd90c8cbe9e299b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fdd90c8cbe9e299b$var$Yh,
    useSyncExternalStore: $fdd90c8cbe9e299b$var$Zh,
    useId: $fdd90c8cbe9e299b$var$wi,
    unstable_isNewReconciler: !1
}, $fdd90c8cbe9e299b$var$Qh = {
    readContext: $fdd90c8cbe9e299b$var$eh,
    useCallback: $fdd90c8cbe9e299b$var$si,
    useContext: $fdd90c8cbe9e299b$var$eh,
    useEffect: $fdd90c8cbe9e299b$var$$h,
    useImperativeHandle: $fdd90c8cbe9e299b$var$qi,
    useInsertionEffect: $fdd90c8cbe9e299b$var$ni,
    useLayoutEffect: $fdd90c8cbe9e299b$var$oi,
    useMemo: $fdd90c8cbe9e299b$var$ti,
    useReducer: $fdd90c8cbe9e299b$var$Xh,
    useRef: $fdd90c8cbe9e299b$var$ji,
    useState: function() {
        return $fdd90c8cbe9e299b$var$Xh($fdd90c8cbe9e299b$var$Vh);
    },
    useDebugValue: $fdd90c8cbe9e299b$var$ri,
    useDeferredValue: function(a) {
        var b = $fdd90c8cbe9e299b$var$Uh();
        return null === $fdd90c8cbe9e299b$var$N ? b.memoizedState = a : $fdd90c8cbe9e299b$var$ui(b, $fdd90c8cbe9e299b$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fdd90c8cbe9e299b$var$Xh($fdd90c8cbe9e299b$var$Vh)[0], b = $fdd90c8cbe9e299b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fdd90c8cbe9e299b$var$Yh,
    useSyncExternalStore: $fdd90c8cbe9e299b$var$Zh,
    useId: $fdd90c8cbe9e299b$var$wi,
    unstable_isNewReconciler: !1
};
function $fdd90c8cbe9e299b$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $fdd90c8cbe9e299b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $fdd90c8cbe9e299b$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $fdd90c8cbe9e299b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $fdd90c8cbe9e299b$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $fdd90c8cbe9e299b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fdd90c8cbe9e299b$var$R(), e = $fdd90c8cbe9e299b$var$yi(a), f = $fdd90c8cbe9e299b$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fdd90c8cbe9e299b$var$nh(a, f, e);
        null !== b && ($fdd90c8cbe9e299b$var$gi(b, a, e, d), $fdd90c8cbe9e299b$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fdd90c8cbe9e299b$var$R(), e = $fdd90c8cbe9e299b$var$yi(a), f = $fdd90c8cbe9e299b$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fdd90c8cbe9e299b$var$nh(a, f, e);
        null !== b && ($fdd90c8cbe9e299b$var$gi(b, a, e, d), $fdd90c8cbe9e299b$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $fdd90c8cbe9e299b$var$R(), d = $fdd90c8cbe9e299b$var$yi(a), e = $fdd90c8cbe9e299b$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $fdd90c8cbe9e299b$var$nh(a, e, d);
        null !== b && ($fdd90c8cbe9e299b$var$gi(b, a, d, c), $fdd90c8cbe9e299b$var$oh(b, a, d));
    }
};
function $fdd90c8cbe9e299b$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$fdd90c8cbe9e299b$var$Ie(c, d) || !$fdd90c8cbe9e299b$var$Ie(e, f) : !0;
}
function $fdd90c8cbe9e299b$var$Gi(a, b, c) {
    var d = !1, e = $fdd90c8cbe9e299b$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $fdd90c8cbe9e299b$var$eh(f) : (e = $fdd90c8cbe9e299b$var$Zf(b) ? $fdd90c8cbe9e299b$var$Xf : $fdd90c8cbe9e299b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $fdd90c8cbe9e299b$var$Yf(a, e) : $fdd90c8cbe9e299b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $fdd90c8cbe9e299b$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $fdd90c8cbe9e299b$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $fdd90c8cbe9e299b$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $fdd90c8cbe9e299b$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $fdd90c8cbe9e299b$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $fdd90c8cbe9e299b$var$eh(f) : (f = $fdd90c8cbe9e299b$var$Zf(b) ? $fdd90c8cbe9e299b$var$Xf : $fdd90c8cbe9e299b$var$H.current, e.context = $fdd90c8cbe9e299b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($fdd90c8cbe9e299b$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $fdd90c8cbe9e299b$var$Ei.enqueueReplaceState(e, e.state, null), $fdd90c8cbe9e299b$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $fdd90c8cbe9e299b$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $fdd90c8cbe9e299b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $fdd90c8cbe9e299b$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $fdd90c8cbe9e299b$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $fdd90c8cbe9e299b$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $fdd90c8cbe9e299b$var$Ni(a, b, c) {
    c = $fdd90c8cbe9e299b$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $fdd90c8cbe9e299b$var$Oi || ($fdd90c8cbe9e299b$var$Oi = !0, $fdd90c8cbe9e299b$var$Pi = d);
        $fdd90c8cbe9e299b$var$Li(a, b);
    };
    return c;
}
function $fdd90c8cbe9e299b$var$Qi(a, b, c) {
    c = $fdd90c8cbe9e299b$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $fdd90c8cbe9e299b$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $fdd90c8cbe9e299b$var$Li(a, b);
        "function" !== typeof d && (null === $fdd90c8cbe9e299b$var$Ri ? $fdd90c8cbe9e299b$var$Ri = new Set([
            this
        ]) : $fdd90c8cbe9e299b$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $fdd90c8cbe9e299b$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $fdd90c8cbe9e299b$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $fdd90c8cbe9e299b$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $fdd90c8cbe9e299b$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $fdd90c8cbe9e299b$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $fdd90c8cbe9e299b$var$mh(-1, 1), b.tag = 2, $fdd90c8cbe9e299b$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $fdd90c8cbe9e299b$var$Wi = $fdd90c8cbe9e299b$var$ua.ReactCurrentOwner, $fdd90c8cbe9e299b$var$dh = !1;
function $fdd90c8cbe9e299b$var$Xi(a, b, c, d) {
    b.child = null === a ? $fdd90c8cbe9e299b$var$Vg(b, null, c, d) : $fdd90c8cbe9e299b$var$Ug(b, a.child, c, d);
}
function $fdd90c8cbe9e299b$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $fdd90c8cbe9e299b$var$ch(b, e);
    d = $fdd90c8cbe9e299b$var$Nh(a, b, c, d, f, e);
    c = $fdd90c8cbe9e299b$var$Sh();
    if (null !== a && !$fdd90c8cbe9e299b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fdd90c8cbe9e299b$var$Zi(a, b, e);
    $fdd90c8cbe9e299b$var$I && c && $fdd90c8cbe9e299b$var$vg(b);
    b.flags |= 1;
    $fdd90c8cbe9e299b$var$Xi(a, b, d, e);
    return b.child;
}
function $fdd90c8cbe9e299b$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$fdd90c8cbe9e299b$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $fdd90c8cbe9e299b$var$bj(a, b, f, d, e);
        a = $fdd90c8cbe9e299b$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $fdd90c8cbe9e299b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $fdd90c8cbe9e299b$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $fdd90c8cbe9e299b$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $fdd90c8cbe9e299b$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($fdd90c8cbe9e299b$var$Ie(f, d) && a.ref === b.ref) {
            if ($fdd90c8cbe9e299b$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($fdd90c8cbe9e299b$var$dh = !0);
            else return b.lanes = a.lanes, $fdd90c8cbe9e299b$var$Zi(a, b, e);
        }
    }
    return $fdd90c8cbe9e299b$var$cj(a, b, c, d, e);
}
function $fdd90c8cbe9e299b$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$ej, $fdd90c8cbe9e299b$var$fj), $fdd90c8cbe9e299b$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$ej, $fdd90c8cbe9e299b$var$fj), $fdd90c8cbe9e299b$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$ej, $fdd90c8cbe9e299b$var$fj);
            $fdd90c8cbe9e299b$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$ej, $fdd90c8cbe9e299b$var$fj), $fdd90c8cbe9e299b$var$fj |= d;
    $fdd90c8cbe9e299b$var$Xi(a, b, e, c);
    return b.child;
}
function $fdd90c8cbe9e299b$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $fdd90c8cbe9e299b$var$cj(a, b, c, d, e) {
    var f = $fdd90c8cbe9e299b$var$Zf(c) ? $fdd90c8cbe9e299b$var$Xf : $fdd90c8cbe9e299b$var$H.current;
    f = $fdd90c8cbe9e299b$var$Yf(b, f);
    $fdd90c8cbe9e299b$var$ch(b, e);
    c = $fdd90c8cbe9e299b$var$Nh(a, b, c, d, f, e);
    d = $fdd90c8cbe9e299b$var$Sh();
    if (null !== a && !$fdd90c8cbe9e299b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fdd90c8cbe9e299b$var$Zi(a, b, e);
    $fdd90c8cbe9e299b$var$I && d && $fdd90c8cbe9e299b$var$vg(b);
    b.flags |= 1;
    $fdd90c8cbe9e299b$var$Xi(a, b, c, e);
    return b.child;
}
function $fdd90c8cbe9e299b$var$hj(a, b, c, d, e) {
    if ($fdd90c8cbe9e299b$var$Zf(c)) {
        var f = !0;
        $fdd90c8cbe9e299b$var$cg(b);
    } else f = !1;
    $fdd90c8cbe9e299b$var$ch(b, e);
    if (null === b.stateNode) $fdd90c8cbe9e299b$var$ij(a, b), $fdd90c8cbe9e299b$var$Gi(b, c, d), $fdd90c8cbe9e299b$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $fdd90c8cbe9e299b$var$eh(l) : (l = $fdd90c8cbe9e299b$var$Zf(c) ? $fdd90c8cbe9e299b$var$Xf : $fdd90c8cbe9e299b$var$H.current, l = $fdd90c8cbe9e299b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $fdd90c8cbe9e299b$var$Hi(b, g, d, l);
        $fdd90c8cbe9e299b$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $fdd90c8cbe9e299b$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $fdd90c8cbe9e299b$var$Wf.current || $fdd90c8cbe9e299b$var$jh ? ("function" === typeof m && ($fdd90c8cbe9e299b$var$Di(b, c, m, d), k = b.memoizedState), (h = $fdd90c8cbe9e299b$var$jh || $fdd90c8cbe9e299b$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $fdd90c8cbe9e299b$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $fdd90c8cbe9e299b$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $fdd90c8cbe9e299b$var$eh(k) : (k = $fdd90c8cbe9e299b$var$Zf(c) ? $fdd90c8cbe9e299b$var$Xf : $fdd90c8cbe9e299b$var$H.current, k = $fdd90c8cbe9e299b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $fdd90c8cbe9e299b$var$Hi(b, g, d, k);
        $fdd90c8cbe9e299b$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $fdd90c8cbe9e299b$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $fdd90c8cbe9e299b$var$Wf.current || $fdd90c8cbe9e299b$var$jh ? ("function" === typeof y && ($fdd90c8cbe9e299b$var$Di(b, c, y, d), n = b.memoizedState), (l = $fdd90c8cbe9e299b$var$jh || $fdd90c8cbe9e299b$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $fdd90c8cbe9e299b$var$jj(a, b, c, d, f, e);
}
function $fdd90c8cbe9e299b$var$jj(a, b, c, d, e, f) {
    $fdd90c8cbe9e299b$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $fdd90c8cbe9e299b$var$dg(b, c, !1), $fdd90c8cbe9e299b$var$Zi(a, b, f);
    d = b.stateNode;
    $fdd90c8cbe9e299b$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $fdd90c8cbe9e299b$var$Ug(b, a.child, null, f), b.child = $fdd90c8cbe9e299b$var$Ug(b, null, h, f)) : $fdd90c8cbe9e299b$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $fdd90c8cbe9e299b$var$dg(b, c, !0);
    return b.child;
}
function $fdd90c8cbe9e299b$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $fdd90c8cbe9e299b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $fdd90c8cbe9e299b$var$ag(a, b.context, !1);
    $fdd90c8cbe9e299b$var$yh(a, b.containerInfo);
}
function $fdd90c8cbe9e299b$var$lj(a, b, c, d, e) {
    $fdd90c8cbe9e299b$var$Ig();
    $fdd90c8cbe9e299b$var$Jg(e);
    b.flags |= 256;
    $fdd90c8cbe9e299b$var$Xi(a, b, c, d);
    return b.child;
}
var $fdd90c8cbe9e299b$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $fdd90c8cbe9e299b$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $fdd90c8cbe9e299b$var$oj(a, b, c) {
    var d = b.pendingProps, e = $fdd90c8cbe9e299b$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$L, e & 1);
    if (null === a) {
        $fdd90c8cbe9e299b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $fdd90c8cbe9e299b$var$pj(g, d, 0, null), a = $fdd90c8cbe9e299b$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $fdd90c8cbe9e299b$var$nj(c), b.memoizedState = $fdd90c8cbe9e299b$var$mj, a) : $fdd90c8cbe9e299b$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $fdd90c8cbe9e299b$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $fdd90c8cbe9e299b$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $fdd90c8cbe9e299b$var$Pg(h, f) : (f = $fdd90c8cbe9e299b$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $fdd90c8cbe9e299b$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $fdd90c8cbe9e299b$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $fdd90c8cbe9e299b$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $fdd90c8cbe9e299b$var$qj(a, b) {
    b = $fdd90c8cbe9e299b$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $fdd90c8cbe9e299b$var$sj(a, b, c, d) {
    null !== d && $fdd90c8cbe9e299b$var$Jg(d);
    $fdd90c8cbe9e299b$var$Ug(b, a.child, null, c);
    a = $fdd90c8cbe9e299b$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $fdd90c8cbe9e299b$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $fdd90c8cbe9e299b$var$Ki(Error($fdd90c8cbe9e299b$var$p(422))), $fdd90c8cbe9e299b$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $fdd90c8cbe9e299b$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $fdd90c8cbe9e299b$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $fdd90c8cbe9e299b$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $fdd90c8cbe9e299b$var$nj(g);
        b.memoizedState = $fdd90c8cbe9e299b$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $fdd90c8cbe9e299b$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($fdd90c8cbe9e299b$var$p(419));
        d = $fdd90c8cbe9e299b$var$Ki(f, d, void 0);
        return $fdd90c8cbe9e299b$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($fdd90c8cbe9e299b$var$dh || h) {
        d = $fdd90c8cbe9e299b$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $fdd90c8cbe9e299b$var$ih(a, e), $fdd90c8cbe9e299b$var$gi(d, a, e, -1));
        }
        $fdd90c8cbe9e299b$var$tj();
        d = $fdd90c8cbe9e299b$var$Ki(Error($fdd90c8cbe9e299b$var$p(421)));
        return $fdd90c8cbe9e299b$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $fdd90c8cbe9e299b$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$Lf(e.nextSibling);
    $fdd90c8cbe9e299b$var$xg = b;
    $fdd90c8cbe9e299b$var$I = !0;
    $fdd90c8cbe9e299b$var$zg = null;
    null !== a && ($fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$rg, $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$sg, $fdd90c8cbe9e299b$var$og[$fdd90c8cbe9e299b$var$pg++] = $fdd90c8cbe9e299b$var$qg, $fdd90c8cbe9e299b$var$rg = a.id, $fdd90c8cbe9e299b$var$sg = a.overflow, $fdd90c8cbe9e299b$var$qg = b);
    b = $fdd90c8cbe9e299b$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $fdd90c8cbe9e299b$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $fdd90c8cbe9e299b$var$bh(a.return, b, c);
}
function $fdd90c8cbe9e299b$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $fdd90c8cbe9e299b$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $fdd90c8cbe9e299b$var$Xi(a, b, d.children, c);
    d = $fdd90c8cbe9e299b$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $fdd90c8cbe9e299b$var$vj(a, c, b);
            else if (19 === a.tag) $fdd90c8cbe9e299b$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $fdd90c8cbe9e299b$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $fdd90c8cbe9e299b$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $fdd90c8cbe9e299b$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $fdd90c8cbe9e299b$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $fdd90c8cbe9e299b$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $fdd90c8cbe9e299b$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $fdd90c8cbe9e299b$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $fdd90c8cbe9e299b$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($fdd90c8cbe9e299b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $fdd90c8cbe9e299b$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $fdd90c8cbe9e299b$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $fdd90c8cbe9e299b$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $fdd90c8cbe9e299b$var$kj(b);
            $fdd90c8cbe9e299b$var$Ig();
            break;
        case 5:
            $fdd90c8cbe9e299b$var$Ah(b);
            break;
        case 1:
            $fdd90c8cbe9e299b$var$Zf(b.type) && $fdd90c8cbe9e299b$var$cg(b);
            break;
        case 4:
            $fdd90c8cbe9e299b$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$L, $fdd90c8cbe9e299b$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $fdd90c8cbe9e299b$var$oj(a, b, c);
                $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$L, $fdd90c8cbe9e299b$var$L.current & 1);
                a = $fdd90c8cbe9e299b$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$L, $fdd90c8cbe9e299b$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $fdd90c8cbe9e299b$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$L, $fdd90c8cbe9e299b$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $fdd90c8cbe9e299b$var$dj(a, b, c);
    }
    return $fdd90c8cbe9e299b$var$Zi(a, b, c);
}
var $fdd90c8cbe9e299b$var$zj, $fdd90c8cbe9e299b$var$Aj, $fdd90c8cbe9e299b$var$Bj, $fdd90c8cbe9e299b$var$Cj;
$fdd90c8cbe9e299b$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$fdd90c8cbe9e299b$var$Aj = function() {};
$fdd90c8cbe9e299b$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $fdd90c8cbe9e299b$var$xh($fdd90c8cbe9e299b$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $fdd90c8cbe9e299b$var$Ya(a, e);
                d = $fdd90c8cbe9e299b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $fdd90c8cbe9e299b$var$A({}, e, {
                    value: void 0
                });
                d = $fdd90c8cbe9e299b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $fdd90c8cbe9e299b$var$gb(a, e);
                d = $fdd90c8cbe9e299b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $fdd90c8cbe9e299b$var$Bf);
        }
        $fdd90c8cbe9e299b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($fdd90c8cbe9e299b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($fdd90c8cbe9e299b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $fdd90c8cbe9e299b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$fdd90c8cbe9e299b$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $fdd90c8cbe9e299b$var$Dj(a, b) {
    if (!$fdd90c8cbe9e299b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $fdd90c8cbe9e299b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $fdd90c8cbe9e299b$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $fdd90c8cbe9e299b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $fdd90c8cbe9e299b$var$S(b), null;
        case 1:
            return $fdd90c8cbe9e299b$var$Zf(b.type) && $fdd90c8cbe9e299b$var$$f(), $fdd90c8cbe9e299b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $fdd90c8cbe9e299b$var$zh();
            $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf);
            $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$H);
            $fdd90c8cbe9e299b$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $fdd90c8cbe9e299b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $fdd90c8cbe9e299b$var$zg && ($fdd90c8cbe9e299b$var$Fj($fdd90c8cbe9e299b$var$zg), $fdd90c8cbe9e299b$var$zg = null));
            $fdd90c8cbe9e299b$var$Aj(a, b);
            $fdd90c8cbe9e299b$var$S(b);
            return null;
        case 5:
            $fdd90c8cbe9e299b$var$Bh(b);
            var e = $fdd90c8cbe9e299b$var$xh($fdd90c8cbe9e299b$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $fdd90c8cbe9e299b$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($fdd90c8cbe9e299b$var$p(166));
                    $fdd90c8cbe9e299b$var$S(b);
                    return null;
                }
                a = $fdd90c8cbe9e299b$var$xh($fdd90c8cbe9e299b$var$uh.current);
                if ($fdd90c8cbe9e299b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$fdd90c8cbe9e299b$var$Of] = b;
                    d[$fdd90c8cbe9e299b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $fdd90c8cbe9e299b$var$D("cancel", d);
                            $fdd90c8cbe9e299b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $fdd90c8cbe9e299b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $fdd90c8cbe9e299b$var$lf.length; e++)$fdd90c8cbe9e299b$var$D($fdd90c8cbe9e299b$var$lf[e], d);
                            break;
                        case "source":
                            $fdd90c8cbe9e299b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $fdd90c8cbe9e299b$var$D("error", d);
                            $fdd90c8cbe9e299b$var$D("load", d);
                            break;
                        case "details":
                            $fdd90c8cbe9e299b$var$D("toggle", d);
                            break;
                        case "input":
                            $fdd90c8cbe9e299b$var$Za(d, f);
                            $fdd90c8cbe9e299b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $fdd90c8cbe9e299b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $fdd90c8cbe9e299b$var$hb(d, f), $fdd90c8cbe9e299b$var$D("invalid", d);
                    }
                    $fdd90c8cbe9e299b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $fdd90c8cbe9e299b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $fdd90c8cbe9e299b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $fdd90c8cbe9e299b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $fdd90c8cbe9e299b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $fdd90c8cbe9e299b$var$Va(d);
                            $fdd90c8cbe9e299b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $fdd90c8cbe9e299b$var$Va(d);
                            $fdd90c8cbe9e299b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $fdd90c8cbe9e299b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $fdd90c8cbe9e299b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$fdd90c8cbe9e299b$var$Of] = b;
                    a[$fdd90c8cbe9e299b$var$Pf] = d;
                    $fdd90c8cbe9e299b$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $fdd90c8cbe9e299b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $fdd90c8cbe9e299b$var$D("cancel", a);
                                $fdd90c8cbe9e299b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $fdd90c8cbe9e299b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $fdd90c8cbe9e299b$var$lf.length; e++)$fdd90c8cbe9e299b$var$D($fdd90c8cbe9e299b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $fdd90c8cbe9e299b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $fdd90c8cbe9e299b$var$D("error", a);
                                $fdd90c8cbe9e299b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $fdd90c8cbe9e299b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $fdd90c8cbe9e299b$var$Za(a, d);
                                e = $fdd90c8cbe9e299b$var$Ya(a, d);
                                $fdd90c8cbe9e299b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $fdd90c8cbe9e299b$var$A({}, d, {
                                    value: void 0
                                });
                                $fdd90c8cbe9e299b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $fdd90c8cbe9e299b$var$hb(a, d);
                                e = $fdd90c8cbe9e299b$var$gb(a, d);
                                $fdd90c8cbe9e299b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $fdd90c8cbe9e299b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $fdd90c8cbe9e299b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $fdd90c8cbe9e299b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $fdd90c8cbe9e299b$var$ob(a, k) : "number" === typeof k && $fdd90c8cbe9e299b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($fdd90c8cbe9e299b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $fdd90c8cbe9e299b$var$D("scroll", a) : null != k && $fdd90c8cbe9e299b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $fdd90c8cbe9e299b$var$Va(a);
                                $fdd90c8cbe9e299b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $fdd90c8cbe9e299b$var$Va(a);
                                $fdd90c8cbe9e299b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $fdd90c8cbe9e299b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $fdd90c8cbe9e299b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $fdd90c8cbe9e299b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $fdd90c8cbe9e299b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $fdd90c8cbe9e299b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $fdd90c8cbe9e299b$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($fdd90c8cbe9e299b$var$p(166));
                c = $fdd90c8cbe9e299b$var$xh($fdd90c8cbe9e299b$var$wh.current);
                $fdd90c8cbe9e299b$var$xh($fdd90c8cbe9e299b$var$uh.current);
                if ($fdd90c8cbe9e299b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$fdd90c8cbe9e299b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $fdd90c8cbe9e299b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $fdd90c8cbe9e299b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $fdd90c8cbe9e299b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$fdd90c8cbe9e299b$var$Of] = b, b.stateNode = d;
            }
            $fdd90c8cbe9e299b$var$S(b);
            return null;
        case 13:
            $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($fdd90c8cbe9e299b$var$I && null !== $fdd90c8cbe9e299b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $fdd90c8cbe9e299b$var$Hg(), $fdd90c8cbe9e299b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $fdd90c8cbe9e299b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($fdd90c8cbe9e299b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($fdd90c8cbe9e299b$var$p(317));
                        f[$fdd90c8cbe9e299b$var$Of] = b;
                    } else $fdd90c8cbe9e299b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $fdd90c8cbe9e299b$var$S(b);
                    f = !1;
                } else null !== $fdd90c8cbe9e299b$var$zg && ($fdd90c8cbe9e299b$var$Fj($fdd90c8cbe9e299b$var$zg), $fdd90c8cbe9e299b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($fdd90c8cbe9e299b$var$L.current & 1) ? 0 === $fdd90c8cbe9e299b$var$T && ($fdd90c8cbe9e299b$var$T = 3) : $fdd90c8cbe9e299b$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $fdd90c8cbe9e299b$var$S(b);
            return null;
        case 4:
            return $fdd90c8cbe9e299b$var$zh(), $fdd90c8cbe9e299b$var$Aj(a, b), null === a && $fdd90c8cbe9e299b$var$sf(b.stateNode.containerInfo), $fdd90c8cbe9e299b$var$S(b), null;
        case 10:
            return $fdd90c8cbe9e299b$var$ah(b.type._context), $fdd90c8cbe9e299b$var$S(b), null;
        case 17:
            return $fdd90c8cbe9e299b$var$Zf(b.type) && $fdd90c8cbe9e299b$var$$f(), $fdd90c8cbe9e299b$var$S(b), null;
        case 19:
            $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$L);
            f = b.memoizedState;
            if (null === f) return $fdd90c8cbe9e299b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $fdd90c8cbe9e299b$var$Dj(f, !1);
                else {
                    if (0 !== $fdd90c8cbe9e299b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $fdd90c8cbe9e299b$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $fdd90c8cbe9e299b$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$L, $fdd90c8cbe9e299b$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $fdd90c8cbe9e299b$var$B() > $fdd90c8cbe9e299b$var$Gj && (b.flags |= 128, d = !0, $fdd90c8cbe9e299b$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $fdd90c8cbe9e299b$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $fdd90c8cbe9e299b$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$fdd90c8cbe9e299b$var$I) return $fdd90c8cbe9e299b$var$S(b), null;
                    } else 2 * $fdd90c8cbe9e299b$var$B() - f.renderingStartTime > $fdd90c8cbe9e299b$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $fdd90c8cbe9e299b$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $fdd90c8cbe9e299b$var$B(), b.sibling = null, c = $fdd90c8cbe9e299b$var$L.current, $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$L, d ? c & 1 | 2 : c & 1), b;
            $fdd90c8cbe9e299b$var$S(b);
            return null;
        case 22:
        case 23:
            return $fdd90c8cbe9e299b$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($fdd90c8cbe9e299b$var$fj & 1073741824) && ($fdd90c8cbe9e299b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $fdd90c8cbe9e299b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($fdd90c8cbe9e299b$var$p(156, b.tag));
}
function $fdd90c8cbe9e299b$var$Ij(a, b) {
    $fdd90c8cbe9e299b$var$wg(b);
    switch(b.tag){
        case 1:
            return $fdd90c8cbe9e299b$var$Zf(b.type) && $fdd90c8cbe9e299b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $fdd90c8cbe9e299b$var$zh(), $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf), $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$H), $fdd90c8cbe9e299b$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $fdd90c8cbe9e299b$var$Bh(b), null;
        case 13:
            $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($fdd90c8cbe9e299b$var$p(340));
                $fdd90c8cbe9e299b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$L), null;
        case 4:
            return $fdd90c8cbe9e299b$var$zh(), null;
        case 10:
            return $fdd90c8cbe9e299b$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $fdd90c8cbe9e299b$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $fdd90c8cbe9e299b$var$Jj = !1, $fdd90c8cbe9e299b$var$U = !1, $fdd90c8cbe9e299b$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $fdd90c8cbe9e299b$var$V = null;
function $fdd90c8cbe9e299b$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $fdd90c8cbe9e299b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $fdd90c8cbe9e299b$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $fdd90c8cbe9e299b$var$W(a, b, d);
    }
}
var $fdd90c8cbe9e299b$var$Nj = !1;
function $fdd90c8cbe9e299b$var$Oj(a, b) {
    $fdd90c8cbe9e299b$var$Cf = $fdd90c8cbe9e299b$var$dd;
    a = $fdd90c8cbe9e299b$var$Me();
    if ($fdd90c8cbe9e299b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $fdd90c8cbe9e299b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $fdd90c8cbe9e299b$var$dd = !1;
    for($fdd90c8cbe9e299b$var$V = b; null !== $fdd90c8cbe9e299b$var$V;)if (b = $fdd90c8cbe9e299b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $fdd90c8cbe9e299b$var$V = a;
    else for(; null !== $fdd90c8cbe9e299b$var$V;){
        b = $fdd90c8cbe9e299b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $fdd90c8cbe9e299b$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($fdd90c8cbe9e299b$var$p(163));
            }
        } catch (F) {
            $fdd90c8cbe9e299b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $fdd90c8cbe9e299b$var$V = a;
            break;
        }
        $fdd90c8cbe9e299b$var$V = b.return;
    }
    n = $fdd90c8cbe9e299b$var$Nj;
    $fdd90c8cbe9e299b$var$Nj = !1;
    return n;
}
function $fdd90c8cbe9e299b$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $fdd90c8cbe9e299b$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $fdd90c8cbe9e299b$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $fdd90c8cbe9e299b$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $fdd90c8cbe9e299b$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $fdd90c8cbe9e299b$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$fdd90c8cbe9e299b$var$Of], delete b[$fdd90c8cbe9e299b$var$Pf], delete b[$fdd90c8cbe9e299b$var$of], delete b[$fdd90c8cbe9e299b$var$Qf], delete b[$fdd90c8cbe9e299b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $fdd90c8cbe9e299b$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $fdd90c8cbe9e299b$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $fdd90c8cbe9e299b$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $fdd90c8cbe9e299b$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $fdd90c8cbe9e299b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($fdd90c8cbe9e299b$var$Vj(a, b, c), a = a.sibling; null !== a;)$fdd90c8cbe9e299b$var$Vj(a, b, c), a = a.sibling;
}
function $fdd90c8cbe9e299b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($fdd90c8cbe9e299b$var$Wj(a, b, c), a = a.sibling; null !== a;)$fdd90c8cbe9e299b$var$Wj(a, b, c), a = a.sibling;
}
var $fdd90c8cbe9e299b$var$X = null, $fdd90c8cbe9e299b$var$Xj = !1;
function $fdd90c8cbe9e299b$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$fdd90c8cbe9e299b$var$Zj(a, b, c), c = c.sibling;
}
function $fdd90c8cbe9e299b$var$Zj(a, b, c) {
    if ($fdd90c8cbe9e299b$var$lc && "function" === typeof $fdd90c8cbe9e299b$var$lc.onCommitFiberUnmount) try {
        $fdd90c8cbe9e299b$var$lc.onCommitFiberUnmount($fdd90c8cbe9e299b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $fdd90c8cbe9e299b$var$U || $fdd90c8cbe9e299b$var$Lj(c, b);
        case 6:
            var d = $fdd90c8cbe9e299b$var$X, e = $fdd90c8cbe9e299b$var$Xj;
            $fdd90c8cbe9e299b$var$X = null;
            $fdd90c8cbe9e299b$var$Yj(a, b, c);
            $fdd90c8cbe9e299b$var$X = d;
            $fdd90c8cbe9e299b$var$Xj = e;
            null !== $fdd90c8cbe9e299b$var$X && ($fdd90c8cbe9e299b$var$Xj ? (a = $fdd90c8cbe9e299b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $fdd90c8cbe9e299b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $fdd90c8cbe9e299b$var$X && ($fdd90c8cbe9e299b$var$Xj ? (a = $fdd90c8cbe9e299b$var$X, c = c.stateNode, 8 === a.nodeType ? $fdd90c8cbe9e299b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $fdd90c8cbe9e299b$var$Kf(a, c), $fdd90c8cbe9e299b$var$bd(a)) : $fdd90c8cbe9e299b$var$Kf($fdd90c8cbe9e299b$var$X, c.stateNode));
            break;
        case 4:
            d = $fdd90c8cbe9e299b$var$X;
            e = $fdd90c8cbe9e299b$var$Xj;
            $fdd90c8cbe9e299b$var$X = c.stateNode.containerInfo;
            $fdd90c8cbe9e299b$var$Xj = !0;
            $fdd90c8cbe9e299b$var$Yj(a, b, c);
            $fdd90c8cbe9e299b$var$X = d;
            $fdd90c8cbe9e299b$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$fdd90c8cbe9e299b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $fdd90c8cbe9e299b$var$Mj(c, b, g) : 0 !== (f & 4) && $fdd90c8cbe9e299b$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $fdd90c8cbe9e299b$var$Yj(a, b, c);
            break;
        case 1:
            if (!$fdd90c8cbe9e299b$var$U && ($fdd90c8cbe9e299b$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $fdd90c8cbe9e299b$var$W(c, b, h);
            }
            $fdd90c8cbe9e299b$var$Yj(a, b, c);
            break;
        case 21:
            $fdd90c8cbe9e299b$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($fdd90c8cbe9e299b$var$U = (d = $fdd90c8cbe9e299b$var$U) || null !== c.memoizedState, $fdd90c8cbe9e299b$var$Yj(a, b, c), $fdd90c8cbe9e299b$var$U = d) : $fdd90c8cbe9e299b$var$Yj(a, b, c);
            break;
        default:
            $fdd90c8cbe9e299b$var$Yj(a, b, c);
    }
}
function $fdd90c8cbe9e299b$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $fdd90c8cbe9e299b$var$Kj);
        b.forEach(function(b) {
            var d = $fdd90c8cbe9e299b$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $fdd90c8cbe9e299b$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $fdd90c8cbe9e299b$var$X = h.stateNode;
                        $fdd90c8cbe9e299b$var$Xj = !1;
                        break a;
                    case 3:
                        $fdd90c8cbe9e299b$var$X = h.stateNode.containerInfo;
                        $fdd90c8cbe9e299b$var$Xj = !0;
                        break a;
                    case 4:
                        $fdd90c8cbe9e299b$var$X = h.stateNode.containerInfo;
                        $fdd90c8cbe9e299b$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $fdd90c8cbe9e299b$var$X) throw Error($fdd90c8cbe9e299b$var$p(160));
            $fdd90c8cbe9e299b$var$Zj(f, g, e);
            $fdd90c8cbe9e299b$var$X = null;
            $fdd90c8cbe9e299b$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $fdd90c8cbe9e299b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$fdd90c8cbe9e299b$var$dk(b, a), b = b.sibling;
}
function $fdd90c8cbe9e299b$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $fdd90c8cbe9e299b$var$ck(b, a);
            $fdd90c8cbe9e299b$var$ek(a);
            if (d & 4) {
                try {
                    $fdd90c8cbe9e299b$var$Pj(3, a, a.return), $fdd90c8cbe9e299b$var$Qj(3, a);
                } catch (t) {
                    $fdd90c8cbe9e299b$var$W(a, a.return, t);
                }
                try {
                    $fdd90c8cbe9e299b$var$Pj(5, a, a.return);
                } catch (t) {
                    $fdd90c8cbe9e299b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $fdd90c8cbe9e299b$var$ck(b, a);
            $fdd90c8cbe9e299b$var$ek(a);
            d & 512 && null !== c && $fdd90c8cbe9e299b$var$Lj(c, c.return);
            break;
        case 5:
            $fdd90c8cbe9e299b$var$ck(b, a);
            $fdd90c8cbe9e299b$var$ek(a);
            d & 512 && null !== c && $fdd90c8cbe9e299b$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $fdd90c8cbe9e299b$var$ob(e, "");
                } catch (t) {
                    $fdd90c8cbe9e299b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $fdd90c8cbe9e299b$var$ab(e, f);
                    $fdd90c8cbe9e299b$var$vb(h, g);
                    var l = $fdd90c8cbe9e299b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $fdd90c8cbe9e299b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $fdd90c8cbe9e299b$var$nb(e, q) : "children" === m ? $fdd90c8cbe9e299b$var$ob(e, q) : $fdd90c8cbe9e299b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $fdd90c8cbe9e299b$var$bb(e, f);
                            break;
                        case "textarea":
                            $fdd90c8cbe9e299b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $fdd90c8cbe9e299b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $fdd90c8cbe9e299b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $fdd90c8cbe9e299b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$fdd90c8cbe9e299b$var$Pf] = f;
                } catch (t) {
                    $fdd90c8cbe9e299b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $fdd90c8cbe9e299b$var$ck(b, a);
            $fdd90c8cbe9e299b$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($fdd90c8cbe9e299b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $fdd90c8cbe9e299b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $fdd90c8cbe9e299b$var$ck(b, a);
            $fdd90c8cbe9e299b$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $fdd90c8cbe9e299b$var$bd(b.containerInfo);
            } catch (t) {
                $fdd90c8cbe9e299b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $fdd90c8cbe9e299b$var$ck(b, a);
            $fdd90c8cbe9e299b$var$ek(a);
            break;
        case 13:
            $fdd90c8cbe9e299b$var$ck(b, a);
            $fdd90c8cbe9e299b$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($fdd90c8cbe9e299b$var$fk = $fdd90c8cbe9e299b$var$B()));
            d & 4 && $fdd90c8cbe9e299b$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($fdd90c8cbe9e299b$var$U = (l = $fdd90c8cbe9e299b$var$U) || m, $fdd90c8cbe9e299b$var$ck(b, a), $fdd90c8cbe9e299b$var$U = l) : $fdd90c8cbe9e299b$var$ck(b, a);
            $fdd90c8cbe9e299b$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($fdd90c8cbe9e299b$var$V = a, m = a.child; null !== m;){
                    for(q = $fdd90c8cbe9e299b$var$V = m; null !== $fdd90c8cbe9e299b$var$V;){
                        r = $fdd90c8cbe9e299b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $fdd90c8cbe9e299b$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $fdd90c8cbe9e299b$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $fdd90c8cbe9e299b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $fdd90c8cbe9e299b$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $fdd90c8cbe9e299b$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $fdd90c8cbe9e299b$var$V = y) : $fdd90c8cbe9e299b$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $fdd90c8cbe9e299b$var$rb("display", g));
                            } catch (t) {
                                $fdd90c8cbe9e299b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $fdd90c8cbe9e299b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $fdd90c8cbe9e299b$var$ck(b, a);
            $fdd90c8cbe9e299b$var$ek(a);
            d & 4 && $fdd90c8cbe9e299b$var$ak(a);
            break;
        case 21:
            break;
        default:
            $fdd90c8cbe9e299b$var$ck(b, a), $fdd90c8cbe9e299b$var$ek(a);
    }
}
function $fdd90c8cbe9e299b$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($fdd90c8cbe9e299b$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($fdd90c8cbe9e299b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($fdd90c8cbe9e299b$var$ob(e, ""), d.flags &= -33);
                    var f = $fdd90c8cbe9e299b$var$Uj(a);
                    $fdd90c8cbe9e299b$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $fdd90c8cbe9e299b$var$Uj(a);
                    $fdd90c8cbe9e299b$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($fdd90c8cbe9e299b$var$p(161));
            }
        } catch (k) {
            $fdd90c8cbe9e299b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $fdd90c8cbe9e299b$var$hk(a, b, c) {
    $fdd90c8cbe9e299b$var$V = a;
    $fdd90c8cbe9e299b$var$ik(a, b, c);
}
function $fdd90c8cbe9e299b$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $fdd90c8cbe9e299b$var$V;){
        var e = $fdd90c8cbe9e299b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $fdd90c8cbe9e299b$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $fdd90c8cbe9e299b$var$U;
                h = $fdd90c8cbe9e299b$var$Jj;
                var l = $fdd90c8cbe9e299b$var$U;
                $fdd90c8cbe9e299b$var$Jj = g;
                if (($fdd90c8cbe9e299b$var$U = k) && !l) for($fdd90c8cbe9e299b$var$V = e; null !== $fdd90c8cbe9e299b$var$V;)g = $fdd90c8cbe9e299b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $fdd90c8cbe9e299b$var$jk(e) : null !== k ? (k.return = g, $fdd90c8cbe9e299b$var$V = k) : $fdd90c8cbe9e299b$var$jk(e);
                for(; null !== f;)$fdd90c8cbe9e299b$var$V = f, $fdd90c8cbe9e299b$var$ik(f, b, c), f = f.sibling;
                $fdd90c8cbe9e299b$var$V = e;
                $fdd90c8cbe9e299b$var$Jj = h;
                $fdd90c8cbe9e299b$var$U = l;
            }
            $fdd90c8cbe9e299b$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $fdd90c8cbe9e299b$var$V = f) : $fdd90c8cbe9e299b$var$kk(a, b, c);
    }
}
function $fdd90c8cbe9e299b$var$kk(a) {
    for(; null !== $fdd90c8cbe9e299b$var$V;){
        var b = $fdd90c8cbe9e299b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $fdd90c8cbe9e299b$var$U || $fdd90c8cbe9e299b$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$fdd90c8cbe9e299b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $fdd90c8cbe9e299b$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $fdd90c8cbe9e299b$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $fdd90c8cbe9e299b$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $fdd90c8cbe9e299b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($fdd90c8cbe9e299b$var$p(163));
                }
                $fdd90c8cbe9e299b$var$U || b.flags & 512 && $fdd90c8cbe9e299b$var$Rj(b);
            } catch (r) {
                $fdd90c8cbe9e299b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $fdd90c8cbe9e299b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fdd90c8cbe9e299b$var$V = c;
            break;
        }
        $fdd90c8cbe9e299b$var$V = b.return;
    }
}
function $fdd90c8cbe9e299b$var$gk(a) {
    for(; null !== $fdd90c8cbe9e299b$var$V;){
        var b = $fdd90c8cbe9e299b$var$V;
        if (b === a) {
            $fdd90c8cbe9e299b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fdd90c8cbe9e299b$var$V = c;
            break;
        }
        $fdd90c8cbe9e299b$var$V = b.return;
    }
}
function $fdd90c8cbe9e299b$var$jk(a) {
    for(; null !== $fdd90c8cbe9e299b$var$V;){
        var b = $fdd90c8cbe9e299b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $fdd90c8cbe9e299b$var$Qj(4, b);
                    } catch (k) {
                        $fdd90c8cbe9e299b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $fdd90c8cbe9e299b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $fdd90c8cbe9e299b$var$Rj(b);
                    } catch (k) {
                        $fdd90c8cbe9e299b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $fdd90c8cbe9e299b$var$Rj(b);
                    } catch (k) {
                        $fdd90c8cbe9e299b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $fdd90c8cbe9e299b$var$W(b, b.return, k);
        }
        if (b === a) {
            $fdd90c8cbe9e299b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $fdd90c8cbe9e299b$var$V = h;
            break;
        }
        $fdd90c8cbe9e299b$var$V = b.return;
    }
}
var $fdd90c8cbe9e299b$var$lk = Math.ceil, $fdd90c8cbe9e299b$var$mk = $fdd90c8cbe9e299b$var$ua.ReactCurrentDispatcher, $fdd90c8cbe9e299b$var$nk = $fdd90c8cbe9e299b$var$ua.ReactCurrentOwner, $fdd90c8cbe9e299b$var$ok = $fdd90c8cbe9e299b$var$ua.ReactCurrentBatchConfig, $fdd90c8cbe9e299b$var$K = 0, $fdd90c8cbe9e299b$var$Q = null, $fdd90c8cbe9e299b$var$Y = null, $fdd90c8cbe9e299b$var$Z = 0, $fdd90c8cbe9e299b$var$fj = 0, $fdd90c8cbe9e299b$var$ej = $fdd90c8cbe9e299b$var$Uf(0), $fdd90c8cbe9e299b$var$T = 0, $fdd90c8cbe9e299b$var$pk = null, $fdd90c8cbe9e299b$var$rh = 0, $fdd90c8cbe9e299b$var$qk = 0, $fdd90c8cbe9e299b$var$rk = 0, $fdd90c8cbe9e299b$var$sk = null, $fdd90c8cbe9e299b$var$tk = null, $fdd90c8cbe9e299b$var$fk = 0, $fdd90c8cbe9e299b$var$Gj = Infinity, $fdd90c8cbe9e299b$var$uk = null, $fdd90c8cbe9e299b$var$Oi = !1, $fdd90c8cbe9e299b$var$Pi = null, $fdd90c8cbe9e299b$var$Ri = null, $fdd90c8cbe9e299b$var$vk = !1, $fdd90c8cbe9e299b$var$wk = null, $fdd90c8cbe9e299b$var$xk = 0, $fdd90c8cbe9e299b$var$yk = 0, $fdd90c8cbe9e299b$var$zk = null, $fdd90c8cbe9e299b$var$Ak = -1, $fdd90c8cbe9e299b$var$Bk = 0;
function $fdd90c8cbe9e299b$var$R() {
    return 0 !== ($fdd90c8cbe9e299b$var$K & 6) ? $fdd90c8cbe9e299b$var$B() : -1 !== $fdd90c8cbe9e299b$var$Ak ? $fdd90c8cbe9e299b$var$Ak : $fdd90c8cbe9e299b$var$Ak = $fdd90c8cbe9e299b$var$B();
}
function $fdd90c8cbe9e299b$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($fdd90c8cbe9e299b$var$K & 2) && 0 !== $fdd90c8cbe9e299b$var$Z) return $fdd90c8cbe9e299b$var$Z & -$fdd90c8cbe9e299b$var$Z;
    if (null !== $fdd90c8cbe9e299b$var$Kg.transition) return 0 === $fdd90c8cbe9e299b$var$Bk && ($fdd90c8cbe9e299b$var$Bk = $fdd90c8cbe9e299b$var$yc()), $fdd90c8cbe9e299b$var$Bk;
    a = $fdd90c8cbe9e299b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $fdd90c8cbe9e299b$var$jd(a.type);
    return a;
}
function $fdd90c8cbe9e299b$var$gi(a, b, c, d) {
    if (50 < $fdd90c8cbe9e299b$var$yk) throw $fdd90c8cbe9e299b$var$yk = 0, $fdd90c8cbe9e299b$var$zk = null, Error($fdd90c8cbe9e299b$var$p(185));
    $fdd90c8cbe9e299b$var$Ac(a, c, d);
    if (0 === ($fdd90c8cbe9e299b$var$K & 2) || a !== $fdd90c8cbe9e299b$var$Q) a === $fdd90c8cbe9e299b$var$Q && (0 === ($fdd90c8cbe9e299b$var$K & 2) && ($fdd90c8cbe9e299b$var$qk |= c), 4 === $fdd90c8cbe9e299b$var$T && $fdd90c8cbe9e299b$var$Ck(a, $fdd90c8cbe9e299b$var$Z)), $fdd90c8cbe9e299b$var$Dk(a, d), 1 === c && 0 === $fdd90c8cbe9e299b$var$K && 0 === (b.mode & 1) && ($fdd90c8cbe9e299b$var$Gj = $fdd90c8cbe9e299b$var$B() + 500, $fdd90c8cbe9e299b$var$fg && $fdd90c8cbe9e299b$var$jg());
}
function $fdd90c8cbe9e299b$var$Dk(a, b) {
    var c = a.callbackNode;
    $fdd90c8cbe9e299b$var$wc(a, b);
    var d = $fdd90c8cbe9e299b$var$uc(a, a === $fdd90c8cbe9e299b$var$Q ? $fdd90c8cbe9e299b$var$Z : 0);
    if (0 === d) null !== c && $fdd90c8cbe9e299b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $fdd90c8cbe9e299b$var$bc(c);
        if (1 === b) 0 === a.tag ? $fdd90c8cbe9e299b$var$ig($fdd90c8cbe9e299b$var$Ek.bind(null, a)) : $fdd90c8cbe9e299b$var$hg($fdd90c8cbe9e299b$var$Ek.bind(null, a)), $fdd90c8cbe9e299b$var$Jf(function() {
            0 === ($fdd90c8cbe9e299b$var$K & 6) && $fdd90c8cbe9e299b$var$jg();
        }), c = null;
        else {
            switch($fdd90c8cbe9e299b$var$Dc(d)){
                case 1:
                    c = $fdd90c8cbe9e299b$var$fc;
                    break;
                case 4:
                    c = $fdd90c8cbe9e299b$var$gc;
                    break;
                case 16:
                    c = $fdd90c8cbe9e299b$var$hc;
                    break;
                case 536870912:
                    c = $fdd90c8cbe9e299b$var$jc;
                    break;
                default:
                    c = $fdd90c8cbe9e299b$var$hc;
            }
            c = $fdd90c8cbe9e299b$var$Fk(c, $fdd90c8cbe9e299b$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $fdd90c8cbe9e299b$var$Gk(a, b) {
    $fdd90c8cbe9e299b$var$Ak = -1;
    $fdd90c8cbe9e299b$var$Bk = 0;
    if (0 !== ($fdd90c8cbe9e299b$var$K & 6)) throw Error($fdd90c8cbe9e299b$var$p(327));
    var c = a.callbackNode;
    if ($fdd90c8cbe9e299b$var$Hk() && a.callbackNode !== c) return null;
    var d = $fdd90c8cbe9e299b$var$uc(a, a === $fdd90c8cbe9e299b$var$Q ? $fdd90c8cbe9e299b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $fdd90c8cbe9e299b$var$Ik(a, d);
    else {
        b = d;
        var e = $fdd90c8cbe9e299b$var$K;
        $fdd90c8cbe9e299b$var$K |= 2;
        var f = $fdd90c8cbe9e299b$var$Jk();
        if ($fdd90c8cbe9e299b$var$Q !== a || $fdd90c8cbe9e299b$var$Z !== b) $fdd90c8cbe9e299b$var$uk = null, $fdd90c8cbe9e299b$var$Gj = $fdd90c8cbe9e299b$var$B() + 500, $fdd90c8cbe9e299b$var$Kk(a, b);
        for(;;)try {
            $fdd90c8cbe9e299b$var$Lk();
            break;
        } catch (h) {
            $fdd90c8cbe9e299b$var$Mk(a, h);
        }
        $fdd90c8cbe9e299b$var$$g();
        $fdd90c8cbe9e299b$var$mk.current = f;
        $fdd90c8cbe9e299b$var$K = e;
        null !== $fdd90c8cbe9e299b$var$Y ? b = 0 : ($fdd90c8cbe9e299b$var$Q = null, $fdd90c8cbe9e299b$var$Z = 0, b = $fdd90c8cbe9e299b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $fdd90c8cbe9e299b$var$xc(a), 0 !== e && (d = e, b = $fdd90c8cbe9e299b$var$Nk(a, e)));
        if (1 === b) throw c = $fdd90c8cbe9e299b$var$pk, $fdd90c8cbe9e299b$var$Kk(a, 0), $fdd90c8cbe9e299b$var$Ck(a, d), $fdd90c8cbe9e299b$var$Dk(a, $fdd90c8cbe9e299b$var$B()), c;
        if (6 === b) $fdd90c8cbe9e299b$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$fdd90c8cbe9e299b$var$Ok(e) && (b = $fdd90c8cbe9e299b$var$Ik(a, d), 2 === b && (f = $fdd90c8cbe9e299b$var$xc(a), 0 !== f && (d = f, b = $fdd90c8cbe9e299b$var$Nk(a, f))), 1 === b)) throw c = $fdd90c8cbe9e299b$var$pk, $fdd90c8cbe9e299b$var$Kk(a, 0), $fdd90c8cbe9e299b$var$Ck(a, d), $fdd90c8cbe9e299b$var$Dk(a, $fdd90c8cbe9e299b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($fdd90c8cbe9e299b$var$p(345));
                case 2:
                    $fdd90c8cbe9e299b$var$Pk(a, $fdd90c8cbe9e299b$var$tk, $fdd90c8cbe9e299b$var$uk);
                    break;
                case 3:
                    $fdd90c8cbe9e299b$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $fdd90c8cbe9e299b$var$fk + 500 - $fdd90c8cbe9e299b$var$B(), 10 < b)) {
                        if (0 !== $fdd90c8cbe9e299b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $fdd90c8cbe9e299b$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $fdd90c8cbe9e299b$var$Ff($fdd90c8cbe9e299b$var$Pk.bind(null, a, $fdd90c8cbe9e299b$var$tk, $fdd90c8cbe9e299b$var$uk), b);
                        break;
                    }
                    $fdd90c8cbe9e299b$var$Pk(a, $fdd90c8cbe9e299b$var$tk, $fdd90c8cbe9e299b$var$uk);
                    break;
                case 4:
                    $fdd90c8cbe9e299b$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $fdd90c8cbe9e299b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $fdd90c8cbe9e299b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $fdd90c8cbe9e299b$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $fdd90c8cbe9e299b$var$Ff($fdd90c8cbe9e299b$var$Pk.bind(null, a, $fdd90c8cbe9e299b$var$tk, $fdd90c8cbe9e299b$var$uk), d);
                        break;
                    }
                    $fdd90c8cbe9e299b$var$Pk(a, $fdd90c8cbe9e299b$var$tk, $fdd90c8cbe9e299b$var$uk);
                    break;
                case 5:
                    $fdd90c8cbe9e299b$var$Pk(a, $fdd90c8cbe9e299b$var$tk, $fdd90c8cbe9e299b$var$uk);
                    break;
                default:
                    throw Error($fdd90c8cbe9e299b$var$p(329));
            }
        }
    }
    $fdd90c8cbe9e299b$var$Dk(a, $fdd90c8cbe9e299b$var$B());
    return a.callbackNode === c ? $fdd90c8cbe9e299b$var$Gk.bind(null, a) : null;
}
function $fdd90c8cbe9e299b$var$Nk(a, b) {
    var c = $fdd90c8cbe9e299b$var$sk;
    a.current.memoizedState.isDehydrated && ($fdd90c8cbe9e299b$var$Kk(a, b).flags |= 256);
    a = $fdd90c8cbe9e299b$var$Ik(a, b);
    2 !== a && (b = $fdd90c8cbe9e299b$var$tk, $fdd90c8cbe9e299b$var$tk = c, null !== b && $fdd90c8cbe9e299b$var$Fj(b));
    return a;
}
function $fdd90c8cbe9e299b$var$Fj(a) {
    null === $fdd90c8cbe9e299b$var$tk ? $fdd90c8cbe9e299b$var$tk = a : $fdd90c8cbe9e299b$var$tk.push.apply($fdd90c8cbe9e299b$var$tk, a);
}
function $fdd90c8cbe9e299b$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$fdd90c8cbe9e299b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $fdd90c8cbe9e299b$var$Ck(a, b) {
    b &= ~$fdd90c8cbe9e299b$var$rk;
    b &= ~$fdd90c8cbe9e299b$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $fdd90c8cbe9e299b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $fdd90c8cbe9e299b$var$Ek(a) {
    if (0 !== ($fdd90c8cbe9e299b$var$K & 6)) throw Error($fdd90c8cbe9e299b$var$p(327));
    $fdd90c8cbe9e299b$var$Hk();
    var b = $fdd90c8cbe9e299b$var$uc(a, 0);
    if (0 === (b & 1)) return $fdd90c8cbe9e299b$var$Dk(a, $fdd90c8cbe9e299b$var$B()), null;
    var c = $fdd90c8cbe9e299b$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $fdd90c8cbe9e299b$var$xc(a);
        0 !== d && (b = d, c = $fdd90c8cbe9e299b$var$Nk(a, d));
    }
    if (1 === c) throw c = $fdd90c8cbe9e299b$var$pk, $fdd90c8cbe9e299b$var$Kk(a, 0), $fdd90c8cbe9e299b$var$Ck(a, b), $fdd90c8cbe9e299b$var$Dk(a, $fdd90c8cbe9e299b$var$B()), c;
    if (6 === c) throw Error($fdd90c8cbe9e299b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $fdd90c8cbe9e299b$var$Pk(a, $fdd90c8cbe9e299b$var$tk, $fdd90c8cbe9e299b$var$uk);
    $fdd90c8cbe9e299b$var$Dk(a, $fdd90c8cbe9e299b$var$B());
    return null;
}
function $fdd90c8cbe9e299b$var$Qk(a, b) {
    var c = $fdd90c8cbe9e299b$var$K;
    $fdd90c8cbe9e299b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $fdd90c8cbe9e299b$var$K = c, 0 === $fdd90c8cbe9e299b$var$K && ($fdd90c8cbe9e299b$var$Gj = $fdd90c8cbe9e299b$var$B() + 500, $fdd90c8cbe9e299b$var$fg && $fdd90c8cbe9e299b$var$jg());
    }
}
function $fdd90c8cbe9e299b$var$Rk(a) {
    null !== $fdd90c8cbe9e299b$var$wk && 0 === $fdd90c8cbe9e299b$var$wk.tag && 0 === ($fdd90c8cbe9e299b$var$K & 6) && $fdd90c8cbe9e299b$var$Hk();
    var b = $fdd90c8cbe9e299b$var$K;
    $fdd90c8cbe9e299b$var$K |= 1;
    var c = $fdd90c8cbe9e299b$var$ok.transition, d = $fdd90c8cbe9e299b$var$C;
    try {
        if ($fdd90c8cbe9e299b$var$ok.transition = null, $fdd90c8cbe9e299b$var$C = 1, a) return a();
    } finally{
        $fdd90c8cbe9e299b$var$C = d, $fdd90c8cbe9e299b$var$ok.transition = c, $fdd90c8cbe9e299b$var$K = b, 0 === ($fdd90c8cbe9e299b$var$K & 6) && $fdd90c8cbe9e299b$var$jg();
    }
}
function $fdd90c8cbe9e299b$var$Hj() {
    $fdd90c8cbe9e299b$var$fj = $fdd90c8cbe9e299b$var$ej.current;
    $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$ej);
}
function $fdd90c8cbe9e299b$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $fdd90c8cbe9e299b$var$Gf(c));
    if (null !== $fdd90c8cbe9e299b$var$Y) for(c = $fdd90c8cbe9e299b$var$Y.return; null !== c;){
        var d = c;
        $fdd90c8cbe9e299b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $fdd90c8cbe9e299b$var$$f();
                break;
            case 3:
                $fdd90c8cbe9e299b$var$zh();
                $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$Wf);
                $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$H);
                $fdd90c8cbe9e299b$var$Eh();
                break;
            case 5:
                $fdd90c8cbe9e299b$var$Bh(d);
                break;
            case 4:
                $fdd90c8cbe9e299b$var$zh();
                break;
            case 13:
                $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$L);
                break;
            case 19:
                $fdd90c8cbe9e299b$var$E($fdd90c8cbe9e299b$var$L);
                break;
            case 10:
                $fdd90c8cbe9e299b$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $fdd90c8cbe9e299b$var$Hj();
        }
        c = c.return;
    }
    $fdd90c8cbe9e299b$var$Q = a;
    $fdd90c8cbe9e299b$var$Y = a = $fdd90c8cbe9e299b$var$Pg(a.current, null);
    $fdd90c8cbe9e299b$var$Z = $fdd90c8cbe9e299b$var$fj = b;
    $fdd90c8cbe9e299b$var$T = 0;
    $fdd90c8cbe9e299b$var$pk = null;
    $fdd90c8cbe9e299b$var$rk = $fdd90c8cbe9e299b$var$qk = $fdd90c8cbe9e299b$var$rh = 0;
    $fdd90c8cbe9e299b$var$tk = $fdd90c8cbe9e299b$var$sk = null;
    if (null !== $fdd90c8cbe9e299b$var$fh) {
        for(b = 0; b < $fdd90c8cbe9e299b$var$fh.length; b++)if (c = $fdd90c8cbe9e299b$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $fdd90c8cbe9e299b$var$fh = null;
    }
    return a;
}
function $fdd90c8cbe9e299b$var$Mk(a, b) {
    do {
        var c = $fdd90c8cbe9e299b$var$Y;
        try {
            $fdd90c8cbe9e299b$var$$g();
            $fdd90c8cbe9e299b$var$Fh.current = $fdd90c8cbe9e299b$var$Rh;
            if ($fdd90c8cbe9e299b$var$Ih) {
                for(var d = $fdd90c8cbe9e299b$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $fdd90c8cbe9e299b$var$Ih = !1;
            }
            $fdd90c8cbe9e299b$var$Hh = 0;
            $fdd90c8cbe9e299b$var$O = $fdd90c8cbe9e299b$var$N = $fdd90c8cbe9e299b$var$M = null;
            $fdd90c8cbe9e299b$var$Jh = !1;
            $fdd90c8cbe9e299b$var$Kh = 0;
            $fdd90c8cbe9e299b$var$nk.current = null;
            if (null === c || null === c.return) {
                $fdd90c8cbe9e299b$var$T = 1;
                $fdd90c8cbe9e299b$var$pk = b;
                $fdd90c8cbe9e299b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $fdd90c8cbe9e299b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $fdd90c8cbe9e299b$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $fdd90c8cbe9e299b$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $fdd90c8cbe9e299b$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $fdd90c8cbe9e299b$var$Si(f, l, b);
                            $fdd90c8cbe9e299b$var$tj();
                            break a;
                        }
                        k = Error($fdd90c8cbe9e299b$var$p(426));
                    }
                } else if ($fdd90c8cbe9e299b$var$I && h.mode & 1) {
                    var J = $fdd90c8cbe9e299b$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $fdd90c8cbe9e299b$var$Vi(J, g, h, f, b);
                        $fdd90c8cbe9e299b$var$Jg($fdd90c8cbe9e299b$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $fdd90c8cbe9e299b$var$Ji(k, h);
                4 !== $fdd90c8cbe9e299b$var$T && ($fdd90c8cbe9e299b$var$T = 2);
                null === $fdd90c8cbe9e299b$var$sk ? $fdd90c8cbe9e299b$var$sk = [
                    f
                ] : $fdd90c8cbe9e299b$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $fdd90c8cbe9e299b$var$Ni(f, k, b);
                            $fdd90c8cbe9e299b$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $fdd90c8cbe9e299b$var$Ri || !$fdd90c8cbe9e299b$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $fdd90c8cbe9e299b$var$Qi(f, h, b);
                                $fdd90c8cbe9e299b$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $fdd90c8cbe9e299b$var$Sk(c);
        } catch (na) {
            b = na;
            $fdd90c8cbe9e299b$var$Y === c && null !== c && ($fdd90c8cbe9e299b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $fdd90c8cbe9e299b$var$Jk() {
    var a = $fdd90c8cbe9e299b$var$mk.current;
    $fdd90c8cbe9e299b$var$mk.current = $fdd90c8cbe9e299b$var$Rh;
    return null === a ? $fdd90c8cbe9e299b$var$Rh : a;
}
function $fdd90c8cbe9e299b$var$tj() {
    if (0 === $fdd90c8cbe9e299b$var$T || 3 === $fdd90c8cbe9e299b$var$T || 2 === $fdd90c8cbe9e299b$var$T) $fdd90c8cbe9e299b$var$T = 4;
    null === $fdd90c8cbe9e299b$var$Q || 0 === ($fdd90c8cbe9e299b$var$rh & 268435455) && 0 === ($fdd90c8cbe9e299b$var$qk & 268435455) || $fdd90c8cbe9e299b$var$Ck($fdd90c8cbe9e299b$var$Q, $fdd90c8cbe9e299b$var$Z);
}
function $fdd90c8cbe9e299b$var$Ik(a, b) {
    var c = $fdd90c8cbe9e299b$var$K;
    $fdd90c8cbe9e299b$var$K |= 2;
    var d = $fdd90c8cbe9e299b$var$Jk();
    if ($fdd90c8cbe9e299b$var$Q !== a || $fdd90c8cbe9e299b$var$Z !== b) $fdd90c8cbe9e299b$var$uk = null, $fdd90c8cbe9e299b$var$Kk(a, b);
    for(;;)try {
        $fdd90c8cbe9e299b$var$Tk();
        break;
    } catch (e) {
        $fdd90c8cbe9e299b$var$Mk(a, e);
    }
    $fdd90c8cbe9e299b$var$$g();
    $fdd90c8cbe9e299b$var$K = c;
    $fdd90c8cbe9e299b$var$mk.current = d;
    if (null !== $fdd90c8cbe9e299b$var$Y) throw Error($fdd90c8cbe9e299b$var$p(261));
    $fdd90c8cbe9e299b$var$Q = null;
    $fdd90c8cbe9e299b$var$Z = 0;
    return $fdd90c8cbe9e299b$var$T;
}
function $fdd90c8cbe9e299b$var$Tk() {
    for(; null !== $fdd90c8cbe9e299b$var$Y;)$fdd90c8cbe9e299b$var$Uk($fdd90c8cbe9e299b$var$Y);
}
function $fdd90c8cbe9e299b$var$Lk() {
    for(; null !== $fdd90c8cbe9e299b$var$Y && !$fdd90c8cbe9e299b$var$cc();)$fdd90c8cbe9e299b$var$Uk($fdd90c8cbe9e299b$var$Y);
}
function $fdd90c8cbe9e299b$var$Uk(a) {
    var b = $fdd90c8cbe9e299b$var$Vk(a.alternate, a, $fdd90c8cbe9e299b$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $fdd90c8cbe9e299b$var$Sk(a) : $fdd90c8cbe9e299b$var$Y = b;
    $fdd90c8cbe9e299b$var$nk.current = null;
}
function $fdd90c8cbe9e299b$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $fdd90c8cbe9e299b$var$Ej(c, b, $fdd90c8cbe9e299b$var$fj), null !== c) {
                $fdd90c8cbe9e299b$var$Y = c;
                return;
            }
        } else {
            c = $fdd90c8cbe9e299b$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $fdd90c8cbe9e299b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $fdd90c8cbe9e299b$var$T = 6;
                $fdd90c8cbe9e299b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $fdd90c8cbe9e299b$var$Y = b;
            return;
        }
        $fdd90c8cbe9e299b$var$Y = b = a;
    }while (null !== b);
    0 === $fdd90c8cbe9e299b$var$T && ($fdd90c8cbe9e299b$var$T = 5);
}
function $fdd90c8cbe9e299b$var$Pk(a, b, c) {
    var d = $fdd90c8cbe9e299b$var$C, e = $fdd90c8cbe9e299b$var$ok.transition;
    try {
        $fdd90c8cbe9e299b$var$ok.transition = null, $fdd90c8cbe9e299b$var$C = 1, $fdd90c8cbe9e299b$var$Wk(a, b, c, d);
    } finally{
        $fdd90c8cbe9e299b$var$ok.transition = e, $fdd90c8cbe9e299b$var$C = d;
    }
    return null;
}
function $fdd90c8cbe9e299b$var$Wk(a, b, c, d) {
    do $fdd90c8cbe9e299b$var$Hk();
    while (null !== $fdd90c8cbe9e299b$var$wk);
    if (0 !== ($fdd90c8cbe9e299b$var$K & 6)) throw Error($fdd90c8cbe9e299b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($fdd90c8cbe9e299b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $fdd90c8cbe9e299b$var$Bc(a, f);
    a === $fdd90c8cbe9e299b$var$Q && ($fdd90c8cbe9e299b$var$Y = $fdd90c8cbe9e299b$var$Q = null, $fdd90c8cbe9e299b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $fdd90c8cbe9e299b$var$vk || ($fdd90c8cbe9e299b$var$vk = !0, $fdd90c8cbe9e299b$var$Fk($fdd90c8cbe9e299b$var$hc, function() {
        $fdd90c8cbe9e299b$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $fdd90c8cbe9e299b$var$ok.transition;
        $fdd90c8cbe9e299b$var$ok.transition = null;
        var g = $fdd90c8cbe9e299b$var$C;
        $fdd90c8cbe9e299b$var$C = 1;
        var h = $fdd90c8cbe9e299b$var$K;
        $fdd90c8cbe9e299b$var$K |= 4;
        $fdd90c8cbe9e299b$var$nk.current = null;
        $fdd90c8cbe9e299b$var$Oj(a, c);
        $fdd90c8cbe9e299b$var$dk(c, a);
        $fdd90c8cbe9e299b$var$Oe($fdd90c8cbe9e299b$var$Df);
        $fdd90c8cbe9e299b$var$dd = !!$fdd90c8cbe9e299b$var$Cf;
        $fdd90c8cbe9e299b$var$Df = $fdd90c8cbe9e299b$var$Cf = null;
        a.current = c;
        $fdd90c8cbe9e299b$var$hk(c, a, e);
        $fdd90c8cbe9e299b$var$dc();
        $fdd90c8cbe9e299b$var$K = h;
        $fdd90c8cbe9e299b$var$C = g;
        $fdd90c8cbe9e299b$var$ok.transition = f;
    } else a.current = c;
    $fdd90c8cbe9e299b$var$vk && ($fdd90c8cbe9e299b$var$vk = !1, $fdd90c8cbe9e299b$var$wk = a, $fdd90c8cbe9e299b$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($fdd90c8cbe9e299b$var$Ri = null);
    $fdd90c8cbe9e299b$var$mc(c.stateNode, d);
    $fdd90c8cbe9e299b$var$Dk(a, $fdd90c8cbe9e299b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($fdd90c8cbe9e299b$var$Oi) throw $fdd90c8cbe9e299b$var$Oi = !1, a = $fdd90c8cbe9e299b$var$Pi, $fdd90c8cbe9e299b$var$Pi = null, a;
    0 !== ($fdd90c8cbe9e299b$var$xk & 1) && 0 !== a.tag && $fdd90c8cbe9e299b$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $fdd90c8cbe9e299b$var$zk ? $fdd90c8cbe9e299b$var$yk++ : ($fdd90c8cbe9e299b$var$yk = 0, $fdd90c8cbe9e299b$var$zk = a) : $fdd90c8cbe9e299b$var$yk = 0;
    $fdd90c8cbe9e299b$var$jg();
    return null;
}
function $fdd90c8cbe9e299b$var$Hk() {
    if (null !== $fdd90c8cbe9e299b$var$wk) {
        var a = $fdd90c8cbe9e299b$var$Dc($fdd90c8cbe9e299b$var$xk), b = $fdd90c8cbe9e299b$var$ok.transition, c = $fdd90c8cbe9e299b$var$C;
        try {
            $fdd90c8cbe9e299b$var$ok.transition = null;
            $fdd90c8cbe9e299b$var$C = 16 > a ? 16 : a;
            if (null === $fdd90c8cbe9e299b$var$wk) var d = !1;
            else {
                a = $fdd90c8cbe9e299b$var$wk;
                $fdd90c8cbe9e299b$var$wk = null;
                $fdd90c8cbe9e299b$var$xk = 0;
                if (0 !== ($fdd90c8cbe9e299b$var$K & 6)) throw Error($fdd90c8cbe9e299b$var$p(331));
                var e = $fdd90c8cbe9e299b$var$K;
                $fdd90c8cbe9e299b$var$K |= 4;
                for($fdd90c8cbe9e299b$var$V = a.current; null !== $fdd90c8cbe9e299b$var$V;){
                    var f = $fdd90c8cbe9e299b$var$V, g = f.child;
                    if (0 !== ($fdd90c8cbe9e299b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($fdd90c8cbe9e299b$var$V = l; null !== $fdd90c8cbe9e299b$var$V;){
                                    var m = $fdd90c8cbe9e299b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $fdd90c8cbe9e299b$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $fdd90c8cbe9e299b$var$V = q;
                                    else for(; null !== $fdd90c8cbe9e299b$var$V;){
                                        m = $fdd90c8cbe9e299b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $fdd90c8cbe9e299b$var$Sj(m);
                                        if (m === l) {
                                            $fdd90c8cbe9e299b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $fdd90c8cbe9e299b$var$V = r;
                                            break;
                                        }
                                        $fdd90c8cbe9e299b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $fdd90c8cbe9e299b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $fdd90c8cbe9e299b$var$V = g;
                    else b: for(; null !== $fdd90c8cbe9e299b$var$V;){
                        f = $fdd90c8cbe9e299b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $fdd90c8cbe9e299b$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $fdd90c8cbe9e299b$var$V = x;
                            break b;
                        }
                        $fdd90c8cbe9e299b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($fdd90c8cbe9e299b$var$V = w; null !== $fdd90c8cbe9e299b$var$V;){
                    g = $fdd90c8cbe9e299b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $fdd90c8cbe9e299b$var$V = u;
                    else b: for(g = w; null !== $fdd90c8cbe9e299b$var$V;){
                        h = $fdd90c8cbe9e299b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $fdd90c8cbe9e299b$var$Qj(9, h);
                            }
                        } catch (na) {
                            $fdd90c8cbe9e299b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $fdd90c8cbe9e299b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $fdd90c8cbe9e299b$var$V = F;
                            break b;
                        }
                        $fdd90c8cbe9e299b$var$V = h.return;
                    }
                }
                $fdd90c8cbe9e299b$var$K = e;
                $fdd90c8cbe9e299b$var$jg();
                if ($fdd90c8cbe9e299b$var$lc && "function" === typeof $fdd90c8cbe9e299b$var$lc.onPostCommitFiberRoot) try {
                    $fdd90c8cbe9e299b$var$lc.onPostCommitFiberRoot($fdd90c8cbe9e299b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $fdd90c8cbe9e299b$var$C = c, $fdd90c8cbe9e299b$var$ok.transition = b;
        }
    }
    return !1;
}
function $fdd90c8cbe9e299b$var$Xk(a, b, c) {
    b = $fdd90c8cbe9e299b$var$Ji(c, b);
    b = $fdd90c8cbe9e299b$var$Ni(a, b, 1);
    a = $fdd90c8cbe9e299b$var$nh(a, b, 1);
    b = $fdd90c8cbe9e299b$var$R();
    null !== a && ($fdd90c8cbe9e299b$var$Ac(a, 1, b), $fdd90c8cbe9e299b$var$Dk(a, b));
}
function $fdd90c8cbe9e299b$var$W(a, b, c) {
    if (3 === a.tag) $fdd90c8cbe9e299b$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $fdd90c8cbe9e299b$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $fdd90c8cbe9e299b$var$Ri || !$fdd90c8cbe9e299b$var$Ri.has(d))) {
                a = $fdd90c8cbe9e299b$var$Ji(c, a);
                a = $fdd90c8cbe9e299b$var$Qi(b, a, 1);
                b = $fdd90c8cbe9e299b$var$nh(b, a, 1);
                a = $fdd90c8cbe9e299b$var$R();
                null !== b && ($fdd90c8cbe9e299b$var$Ac(b, 1, a), $fdd90c8cbe9e299b$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $fdd90c8cbe9e299b$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $fdd90c8cbe9e299b$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $fdd90c8cbe9e299b$var$Q === a && ($fdd90c8cbe9e299b$var$Z & c) === c && (4 === $fdd90c8cbe9e299b$var$T || 3 === $fdd90c8cbe9e299b$var$T && ($fdd90c8cbe9e299b$var$Z & 130023424) === $fdd90c8cbe9e299b$var$Z && 500 > $fdd90c8cbe9e299b$var$B() - $fdd90c8cbe9e299b$var$fk ? $fdd90c8cbe9e299b$var$Kk(a, 0) : $fdd90c8cbe9e299b$var$rk |= c);
    $fdd90c8cbe9e299b$var$Dk(a, b);
}
function $fdd90c8cbe9e299b$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $fdd90c8cbe9e299b$var$sc, $fdd90c8cbe9e299b$var$sc <<= 1, 0 === ($fdd90c8cbe9e299b$var$sc & 130023424) && ($fdd90c8cbe9e299b$var$sc = 4194304)));
    var c = $fdd90c8cbe9e299b$var$R();
    a = $fdd90c8cbe9e299b$var$ih(a, b);
    null !== a && ($fdd90c8cbe9e299b$var$Ac(a, b, c), $fdd90c8cbe9e299b$var$Dk(a, c));
}
function $fdd90c8cbe9e299b$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $fdd90c8cbe9e299b$var$Yk(a, c);
}
function $fdd90c8cbe9e299b$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($fdd90c8cbe9e299b$var$p(314));
    }
    null !== d && d.delete(b);
    $fdd90c8cbe9e299b$var$Yk(a, c);
}
var $fdd90c8cbe9e299b$var$Vk;
$fdd90c8cbe9e299b$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $fdd90c8cbe9e299b$var$Wf.current) $fdd90c8cbe9e299b$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $fdd90c8cbe9e299b$var$dh = !1, $fdd90c8cbe9e299b$var$yj(a, b, c);
            $fdd90c8cbe9e299b$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $fdd90c8cbe9e299b$var$dh = !1, $fdd90c8cbe9e299b$var$I && 0 !== (b.flags & 1048576) && $fdd90c8cbe9e299b$var$ug(b, $fdd90c8cbe9e299b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $fdd90c8cbe9e299b$var$ij(a, b);
            a = b.pendingProps;
            var e = $fdd90c8cbe9e299b$var$Yf(b, $fdd90c8cbe9e299b$var$H.current);
            $fdd90c8cbe9e299b$var$ch(b, c);
            e = $fdd90c8cbe9e299b$var$Nh(null, b, d, a, e, c);
            var f = $fdd90c8cbe9e299b$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $fdd90c8cbe9e299b$var$Zf(d) ? (f = !0, $fdd90c8cbe9e299b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $fdd90c8cbe9e299b$var$kh(b), e.updater = $fdd90c8cbe9e299b$var$Ei, b.stateNode = e, e._reactInternals = b, $fdd90c8cbe9e299b$var$Ii(b, d, a, c), b = $fdd90c8cbe9e299b$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $fdd90c8cbe9e299b$var$I && f && $fdd90c8cbe9e299b$var$vg(b), $fdd90c8cbe9e299b$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $fdd90c8cbe9e299b$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $fdd90c8cbe9e299b$var$Zk(d);
                a = $fdd90c8cbe9e299b$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $fdd90c8cbe9e299b$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $fdd90c8cbe9e299b$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $fdd90c8cbe9e299b$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $fdd90c8cbe9e299b$var$$i(null, b, d, $fdd90c8cbe9e299b$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($fdd90c8cbe9e299b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fdd90c8cbe9e299b$var$Ci(d, e), $fdd90c8cbe9e299b$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fdd90c8cbe9e299b$var$Ci(d, e), $fdd90c8cbe9e299b$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $fdd90c8cbe9e299b$var$kj(b);
                if (null === a) throw Error($fdd90c8cbe9e299b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $fdd90c8cbe9e299b$var$lh(a, b);
                $fdd90c8cbe9e299b$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $fdd90c8cbe9e299b$var$Ji(Error($fdd90c8cbe9e299b$var$p(423)), b);
                        b = $fdd90c8cbe9e299b$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $fdd90c8cbe9e299b$var$Ji(Error($fdd90c8cbe9e299b$var$p(424)), b);
                        b = $fdd90c8cbe9e299b$var$lj(a, b, d, c, e);
                        break a;
                    } else for($fdd90c8cbe9e299b$var$yg = $fdd90c8cbe9e299b$var$Lf(b.stateNode.containerInfo.firstChild), $fdd90c8cbe9e299b$var$xg = b, $fdd90c8cbe9e299b$var$I = !0, $fdd90c8cbe9e299b$var$zg = null, c = $fdd90c8cbe9e299b$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $fdd90c8cbe9e299b$var$Ig();
                    if (d === e) {
                        b = $fdd90c8cbe9e299b$var$Zi(a, b, c);
                        break a;
                    }
                    $fdd90c8cbe9e299b$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $fdd90c8cbe9e299b$var$Ah(b), null === a && $fdd90c8cbe9e299b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $fdd90c8cbe9e299b$var$Ef(d, e) ? g = null : null !== f && $fdd90c8cbe9e299b$var$Ef(d, f) && (b.flags |= 32), $fdd90c8cbe9e299b$var$gj(a, b), $fdd90c8cbe9e299b$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $fdd90c8cbe9e299b$var$Eg(b), null;
        case 13:
            return $fdd90c8cbe9e299b$var$oj(a, b, c);
        case 4:
            return $fdd90c8cbe9e299b$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $fdd90c8cbe9e299b$var$Ug(b, null, d, c) : $fdd90c8cbe9e299b$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fdd90c8cbe9e299b$var$Ci(d, e), $fdd90c8cbe9e299b$var$Yi(a, b, d, e, c);
        case 7:
            return $fdd90c8cbe9e299b$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $fdd90c8cbe9e299b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $fdd90c8cbe9e299b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $fdd90c8cbe9e299b$var$G($fdd90c8cbe9e299b$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($fdd90c8cbe9e299b$var$He(f.value, g)) {
                        if (f.children === e.children && !$fdd90c8cbe9e299b$var$Wf.current) {
                            b = $fdd90c8cbe9e299b$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $fdd90c8cbe9e299b$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $fdd90c8cbe9e299b$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($fdd90c8cbe9e299b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $fdd90c8cbe9e299b$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $fdd90c8cbe9e299b$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $fdd90c8cbe9e299b$var$ch(b, c), e = $fdd90c8cbe9e299b$var$eh(e), d = d(e), b.flags |= 1, $fdd90c8cbe9e299b$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $fdd90c8cbe9e299b$var$Ci(d, b.pendingProps), e = $fdd90c8cbe9e299b$var$Ci(d.type, e), $fdd90c8cbe9e299b$var$$i(a, b, d, e, c);
        case 15:
            return $fdd90c8cbe9e299b$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fdd90c8cbe9e299b$var$Ci(d, e), $fdd90c8cbe9e299b$var$ij(a, b), b.tag = 1, $fdd90c8cbe9e299b$var$Zf(d) ? (a = !0, $fdd90c8cbe9e299b$var$cg(b)) : a = !1, $fdd90c8cbe9e299b$var$ch(b, c), $fdd90c8cbe9e299b$var$Gi(b, d, e), $fdd90c8cbe9e299b$var$Ii(b, d, e, c), $fdd90c8cbe9e299b$var$jj(null, b, d, !0, a, c);
        case 19:
            return $fdd90c8cbe9e299b$var$xj(a, b, c);
        case 22:
            return $fdd90c8cbe9e299b$var$dj(a, b, c);
    }
    throw Error($fdd90c8cbe9e299b$var$p(156, b.tag));
};
function $fdd90c8cbe9e299b$var$Fk(a, b) {
    return $fdd90c8cbe9e299b$var$ac(a, b);
}
function $fdd90c8cbe9e299b$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $fdd90c8cbe9e299b$var$Bg(a, b, c, d) {
    return new $fdd90c8cbe9e299b$var$$k(a, b, c, d);
}
function $fdd90c8cbe9e299b$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $fdd90c8cbe9e299b$var$Zk(a) {
    if ("function" === typeof a) return $fdd90c8cbe9e299b$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $fdd90c8cbe9e299b$var$Da) return 11;
        if (a === $fdd90c8cbe9e299b$var$Ga) return 14;
    }
    return 2;
}
function $fdd90c8cbe9e299b$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $fdd90c8cbe9e299b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $fdd90c8cbe9e299b$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $fdd90c8cbe9e299b$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $fdd90c8cbe9e299b$var$ya:
            return $fdd90c8cbe9e299b$var$Tg(c.children, e, f, b);
        case $fdd90c8cbe9e299b$var$za:
            g = 8;
            e |= 8;
            break;
        case $fdd90c8cbe9e299b$var$Aa:
            return a = $fdd90c8cbe9e299b$var$Bg(12, c, b, e | 2), a.elementType = $fdd90c8cbe9e299b$var$Aa, a.lanes = f, a;
        case $fdd90c8cbe9e299b$var$Ea:
            return a = $fdd90c8cbe9e299b$var$Bg(13, c, b, e), a.elementType = $fdd90c8cbe9e299b$var$Ea, a.lanes = f, a;
        case $fdd90c8cbe9e299b$var$Fa:
            return a = $fdd90c8cbe9e299b$var$Bg(19, c, b, e), a.elementType = $fdd90c8cbe9e299b$var$Fa, a.lanes = f, a;
        case $fdd90c8cbe9e299b$var$Ia:
            return $fdd90c8cbe9e299b$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $fdd90c8cbe9e299b$var$Ba:
                    g = 10;
                    break a;
                case $fdd90c8cbe9e299b$var$Ca:
                    g = 9;
                    break a;
                case $fdd90c8cbe9e299b$var$Da:
                    g = 11;
                    break a;
                case $fdd90c8cbe9e299b$var$Ga:
                    g = 14;
                    break a;
                case $fdd90c8cbe9e299b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($fdd90c8cbe9e299b$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $fdd90c8cbe9e299b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $fdd90c8cbe9e299b$var$Tg(a, b, c, d) {
    a = $fdd90c8cbe9e299b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $fdd90c8cbe9e299b$var$pj(a, b, c, d) {
    a = $fdd90c8cbe9e299b$var$Bg(22, a, d, b);
    a.elementType = $fdd90c8cbe9e299b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $fdd90c8cbe9e299b$var$Qg(a, b, c) {
    a = $fdd90c8cbe9e299b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $fdd90c8cbe9e299b$var$Sg(a, b, c) {
    b = $fdd90c8cbe9e299b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $fdd90c8cbe9e299b$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $fdd90c8cbe9e299b$var$zc(0);
    this.expirationTimes = $fdd90c8cbe9e299b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $fdd90c8cbe9e299b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $fdd90c8cbe9e299b$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $fdd90c8cbe9e299b$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $fdd90c8cbe9e299b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $fdd90c8cbe9e299b$var$kh(f);
    return a;
}
function $fdd90c8cbe9e299b$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $fdd90c8cbe9e299b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $fdd90c8cbe9e299b$var$dl(a) {
    if (!a) return $fdd90c8cbe9e299b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($fdd90c8cbe9e299b$var$Vb(a) !== a || 1 !== a.tag) throw Error($fdd90c8cbe9e299b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($fdd90c8cbe9e299b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($fdd90c8cbe9e299b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($fdd90c8cbe9e299b$var$Zf(c)) return $fdd90c8cbe9e299b$var$bg(a, c, b);
    }
    return b;
}
function $fdd90c8cbe9e299b$var$el(a, b, c, d, e, f, g, h, k) {
    a = $fdd90c8cbe9e299b$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $fdd90c8cbe9e299b$var$dl(null);
    c = a.current;
    d = $fdd90c8cbe9e299b$var$R();
    e = $fdd90c8cbe9e299b$var$yi(c);
    f = $fdd90c8cbe9e299b$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $fdd90c8cbe9e299b$var$nh(c, f, e);
    a.current.lanes = e;
    $fdd90c8cbe9e299b$var$Ac(a, e, d);
    $fdd90c8cbe9e299b$var$Dk(a, d);
    return a;
}
function $fdd90c8cbe9e299b$var$fl(a, b, c, d) {
    var e = b.current, f = $fdd90c8cbe9e299b$var$R(), g = $fdd90c8cbe9e299b$var$yi(e);
    c = $fdd90c8cbe9e299b$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $fdd90c8cbe9e299b$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $fdd90c8cbe9e299b$var$nh(e, b, g);
    null !== a && ($fdd90c8cbe9e299b$var$gi(a, e, g, f), $fdd90c8cbe9e299b$var$oh(a, e, g));
    return g;
}
function $fdd90c8cbe9e299b$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $fdd90c8cbe9e299b$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $fdd90c8cbe9e299b$var$il(a, b) {
    $fdd90c8cbe9e299b$var$hl(a, b);
    (a = a.alternate) && $fdd90c8cbe9e299b$var$hl(a, b);
}
function $fdd90c8cbe9e299b$var$jl() {
    return null;
}
var $fdd90c8cbe9e299b$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $fdd90c8cbe9e299b$var$ll(a) {
    this._internalRoot = a;
}
$fdd90c8cbe9e299b$var$ml.prototype.render = $fdd90c8cbe9e299b$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($fdd90c8cbe9e299b$var$p(409));
    $fdd90c8cbe9e299b$var$fl(a, b, null, null);
};
$fdd90c8cbe9e299b$var$ml.prototype.unmount = $fdd90c8cbe9e299b$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $fdd90c8cbe9e299b$var$Rk(function() {
            $fdd90c8cbe9e299b$var$fl(null, a, null, null);
        });
        b[$fdd90c8cbe9e299b$var$uf] = null;
    }
};
function $fdd90c8cbe9e299b$var$ml(a) {
    this._internalRoot = a;
}
$fdd90c8cbe9e299b$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $fdd90c8cbe9e299b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $fdd90c8cbe9e299b$var$Qc.length && 0 !== b && b < $fdd90c8cbe9e299b$var$Qc[c].priority; c++);
        $fdd90c8cbe9e299b$var$Qc.splice(c, 0, a);
        0 === c && $fdd90c8cbe9e299b$var$Vc(a);
    }
};
function $fdd90c8cbe9e299b$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $fdd90c8cbe9e299b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $fdd90c8cbe9e299b$var$pl() {}
function $fdd90c8cbe9e299b$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $fdd90c8cbe9e299b$var$gl(g);
                f.call(a);
            };
        }
        var g = $fdd90c8cbe9e299b$var$el(b, d, a, 0, null, !1, !1, "", $fdd90c8cbe9e299b$var$pl);
        a._reactRootContainer = g;
        a[$fdd90c8cbe9e299b$var$uf] = g.current;
        $fdd90c8cbe9e299b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $fdd90c8cbe9e299b$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $fdd90c8cbe9e299b$var$gl(k);
            h.call(a);
        };
    }
    var k = $fdd90c8cbe9e299b$var$bl(a, 0, !1, null, null, !1, !1, "", $fdd90c8cbe9e299b$var$pl);
    a._reactRootContainer = k;
    a[$fdd90c8cbe9e299b$var$uf] = k.current;
    $fdd90c8cbe9e299b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $fdd90c8cbe9e299b$var$Rk(function() {
        $fdd90c8cbe9e299b$var$fl(b, k, c, d);
    });
    return k;
}
function $fdd90c8cbe9e299b$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $fdd90c8cbe9e299b$var$gl(g);
                h.call(a);
            };
        }
        $fdd90c8cbe9e299b$var$fl(b, g, a, e);
    } else g = $fdd90c8cbe9e299b$var$ql(c, b, a, e, d);
    return $fdd90c8cbe9e299b$var$gl(g);
}
$fdd90c8cbe9e299b$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $fdd90c8cbe9e299b$var$tc(b.pendingLanes);
                0 !== c && ($fdd90c8cbe9e299b$var$Cc(b, c | 1), $fdd90c8cbe9e299b$var$Dk(b, $fdd90c8cbe9e299b$var$B()), 0 === ($fdd90c8cbe9e299b$var$K & 6) && ($fdd90c8cbe9e299b$var$Gj = $fdd90c8cbe9e299b$var$B() + 500, $fdd90c8cbe9e299b$var$jg()));
            }
            break;
        case 13:
            $fdd90c8cbe9e299b$var$Rk(function() {
                var b = $fdd90c8cbe9e299b$var$ih(a, 1);
                if (null !== b) {
                    var c = $fdd90c8cbe9e299b$var$R();
                    $fdd90c8cbe9e299b$var$gi(b, a, 1, c);
                }
            }), $fdd90c8cbe9e299b$var$il(a, 1);
    }
};
$fdd90c8cbe9e299b$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $fdd90c8cbe9e299b$var$ih(a, 134217728);
        if (null !== b) {
            var c = $fdd90c8cbe9e299b$var$R();
            $fdd90c8cbe9e299b$var$gi(b, a, 134217728, c);
        }
        $fdd90c8cbe9e299b$var$il(a, 134217728);
    }
};
$fdd90c8cbe9e299b$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $fdd90c8cbe9e299b$var$yi(a), c = $fdd90c8cbe9e299b$var$ih(a, b);
        if (null !== c) {
            var d = $fdd90c8cbe9e299b$var$R();
            $fdd90c8cbe9e299b$var$gi(c, a, b, d);
        }
        $fdd90c8cbe9e299b$var$il(a, b);
    }
};
$fdd90c8cbe9e299b$var$Hc = function() {
    return $fdd90c8cbe9e299b$var$C;
};
$fdd90c8cbe9e299b$var$Ic = function(a, b) {
    var c = $fdd90c8cbe9e299b$var$C;
    try {
        return $fdd90c8cbe9e299b$var$C = a, b();
    } finally{
        $fdd90c8cbe9e299b$var$C = c;
    }
};
$fdd90c8cbe9e299b$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $fdd90c8cbe9e299b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $fdd90c8cbe9e299b$var$Db(d);
                        if (!e) throw Error($fdd90c8cbe9e299b$var$p(90));
                        $fdd90c8cbe9e299b$var$Wa(d);
                        $fdd90c8cbe9e299b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $fdd90c8cbe9e299b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $fdd90c8cbe9e299b$var$fb(a, !!c.multiple, b, !1);
    }
};
$fdd90c8cbe9e299b$var$Gb = $fdd90c8cbe9e299b$var$Qk;
$fdd90c8cbe9e299b$var$Hb = $fdd90c8cbe9e299b$var$Rk;
var $fdd90c8cbe9e299b$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $fdd90c8cbe9e299b$var$Cb,
        $fdd90c8cbe9e299b$var$ue,
        $fdd90c8cbe9e299b$var$Db,
        $fdd90c8cbe9e299b$var$Eb,
        $fdd90c8cbe9e299b$var$Fb,
        $fdd90c8cbe9e299b$var$Qk
    ]
}, $fdd90c8cbe9e299b$var$tl = {
    findFiberByHostInstance: $fdd90c8cbe9e299b$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $fdd90c8cbe9e299b$var$ul = {
    bundleType: $fdd90c8cbe9e299b$var$tl.bundleType,
    version: $fdd90c8cbe9e299b$var$tl.version,
    rendererPackageName: $fdd90c8cbe9e299b$var$tl.rendererPackageName,
    rendererConfig: $fdd90c8cbe9e299b$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $fdd90c8cbe9e299b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $fdd90c8cbe9e299b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $fdd90c8cbe9e299b$var$tl.findFiberByHostInstance || $fdd90c8cbe9e299b$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $fdd90c8cbe9e299b$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$fdd90c8cbe9e299b$var$vl.isDisabled && $fdd90c8cbe9e299b$var$vl.supportsFiber) try {
        $fdd90c8cbe9e299b$var$kc = $fdd90c8cbe9e299b$var$vl.inject($fdd90c8cbe9e299b$var$ul), $fdd90c8cbe9e299b$var$lc = $fdd90c8cbe9e299b$var$vl;
    } catch (a) {}
}
$fdd90c8cbe9e299b$export$ae55be85d98224ed = $fdd90c8cbe9e299b$var$sl;
$fdd90c8cbe9e299b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$fdd90c8cbe9e299b$var$nl(b)) throw Error($fdd90c8cbe9e299b$var$p(200));
    return $fdd90c8cbe9e299b$var$cl(a, b, null, c);
};
$fdd90c8cbe9e299b$export$882461b6382ed46c = function(a, b) {
    if (!$fdd90c8cbe9e299b$var$nl(a)) throw Error($fdd90c8cbe9e299b$var$p(299));
    var c = !1, d = "", e = $fdd90c8cbe9e299b$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $fdd90c8cbe9e299b$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$fdd90c8cbe9e299b$var$uf] = b.current;
    $fdd90c8cbe9e299b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $fdd90c8cbe9e299b$var$ll(b);
};
$fdd90c8cbe9e299b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($fdd90c8cbe9e299b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($fdd90c8cbe9e299b$var$p(268, a));
    }
    a = $fdd90c8cbe9e299b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$fdd90c8cbe9e299b$export$cd75ccfd720a3cd4 = function(a) {
    return $fdd90c8cbe9e299b$var$Rk(a);
};
$fdd90c8cbe9e299b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$fdd90c8cbe9e299b$var$ol(b)) throw Error($fdd90c8cbe9e299b$var$p(200));
    return $fdd90c8cbe9e299b$var$rl(null, a, b, !0, c);
};
$fdd90c8cbe9e299b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$fdd90c8cbe9e299b$var$nl(a)) throw Error($fdd90c8cbe9e299b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $fdd90c8cbe9e299b$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $fdd90c8cbe9e299b$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$fdd90c8cbe9e299b$var$uf] = b.current;
    $fdd90c8cbe9e299b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $fdd90c8cbe9e299b$var$ml(b);
};
$fdd90c8cbe9e299b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$fdd90c8cbe9e299b$var$ol(b)) throw Error($fdd90c8cbe9e299b$var$p(200));
    return $fdd90c8cbe9e299b$var$rl(null, a, b, !1, c);
};
$fdd90c8cbe9e299b$export$502457920280e6be = function(a) {
    if (!$fdd90c8cbe9e299b$var$ol(a)) throw Error($fdd90c8cbe9e299b$var$p(40));
    return a._reactRootContainer ? ($fdd90c8cbe9e299b$var$Rk(function() {
        $fdd90c8cbe9e299b$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$fdd90c8cbe9e299b$var$uf] = null;
        });
    }), !0) : !1;
};
$fdd90c8cbe9e299b$export$c78a37762a8d58e1 = $fdd90c8cbe9e299b$var$Qk;
$fdd90c8cbe9e299b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$fdd90c8cbe9e299b$var$ol(c)) throw Error($fdd90c8cbe9e299b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($fdd90c8cbe9e299b$var$p(38));
    return $fdd90c8cbe9e299b$var$rl(a, b, c, !1, d);
};
$fdd90c8cbe9e299b$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("3tsZj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("04Zxz"));

});
parcelRegister("04Zxz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $00f01c7e38db0d01$export$c4744153514ff05d; }, function (v) { return $00f01c7e38db0d01$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $00f01c7e38db0d01$export$3e506c1ccc9cc1a7; }, function (v) { return $00f01c7e38db0d01$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $00f01c7e38db0d01$export$e26fe2ed2fa76875; }, function (v) { return $00f01c7e38db0d01$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $00f01c7e38db0d01$export$502329bbf4b505b1; }, function (v) { return $00f01c7e38db0d01$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $00f01c7e38db0d01$export$6e3807111c4874c4; }, function (v) { return $00f01c7e38db0d01$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $00f01c7e38db0d01$export$c27134553091fb3a; }, function (v) { return $00f01c7e38db0d01$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $00f01c7e38db0d01$export$33ee1acdc04fd2a2; }, function (v) { return $00f01c7e38db0d01$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $00f01c7e38db0d01$export$b00a404bbd5edef2; }, function (v) { return $00f01c7e38db0d01$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $00f01c7e38db0d01$export$8352ce38b91d0c62; }, function (v) { return $00f01c7e38db0d01$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $00f01c7e38db0d01$export$d66a1c1c77bd778b; }, function (v) { return $00f01c7e38db0d01$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $00f01c7e38db0d01$export$d3dfb8e4810cb555; }, function (v) { return $00f01c7e38db0d01$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $00f01c7e38db0d01$export$839f9183b0465a69; }, function (v) { return $00f01c7e38db0d01$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $00f01c7e38db0d01$export$72fdf0e06517287b; }, function (v) { return $00f01c7e38db0d01$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $00f01c7e38db0d01$export$4b844e58a3e414b4; }, function (v) { return $00f01c7e38db0d01$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $00f01c7e38db0d01$export$816d2913ae6b83b1; }, function (v) { return $00f01c7e38db0d01$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $00f01c7e38db0d01$export$61bcfe829111a1d0; }, function (v) { return $00f01c7e38db0d01$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $00f01c7e38db0d01$export$7ee8c9beb337bc3f; }, function (v) { return $00f01c7e38db0d01$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $00f01c7e38db0d01$export$b5836b71941fa3ed; }, function (v) { return $00f01c7e38db0d01$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $00f01c7e38db0d01$export$cf845f2c119da08a; }, function (v) { return $00f01c7e38db0d01$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $00f01c7e38db0d01$export$c4744153514ff05d;
var $00f01c7e38db0d01$export$3e506c1ccc9cc1a7;
var $00f01c7e38db0d01$export$e26fe2ed2fa76875;
var $00f01c7e38db0d01$export$502329bbf4b505b1;
var $00f01c7e38db0d01$export$6e3807111c4874c4;
var $00f01c7e38db0d01$export$c27134553091fb3a;
var $00f01c7e38db0d01$export$33ee1acdc04fd2a2;
var $00f01c7e38db0d01$export$b00a404bbd5edef2;
var $00f01c7e38db0d01$export$8352ce38b91d0c62;
var $00f01c7e38db0d01$export$d66a1c1c77bd778b;
var $00f01c7e38db0d01$export$d3dfb8e4810cb555;
var $00f01c7e38db0d01$export$839f9183b0465a69;
var $00f01c7e38db0d01$export$72fdf0e06517287b;
var $00f01c7e38db0d01$export$4b844e58a3e414b4;
var $00f01c7e38db0d01$export$816d2913ae6b83b1;
var $00f01c7e38db0d01$export$61bcfe829111a1d0;
var $00f01c7e38db0d01$export$7ee8c9beb337bc3f;
var $00f01c7e38db0d01$export$b5836b71941fa3ed;
var $00f01c7e38db0d01$export$cf845f2c119da08a;
'use strict';
function $00f01c7e38db0d01$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $00f01c7e38db0d01$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $00f01c7e38db0d01$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $00f01c7e38db0d01$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $00f01c7e38db0d01$var$g(C, c)) n < e && 0 > $00f01c7e38db0d01$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $00f01c7e38db0d01$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $00f01c7e38db0d01$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $00f01c7e38db0d01$var$l = performance;
    $00f01c7e38db0d01$export$c4744153514ff05d = function() {
        return $00f01c7e38db0d01$var$l.now();
    };
} else {
    var $00f01c7e38db0d01$var$p = Date, $00f01c7e38db0d01$var$q = $00f01c7e38db0d01$var$p.now();
    $00f01c7e38db0d01$export$c4744153514ff05d = function() {
        return $00f01c7e38db0d01$var$p.now() - $00f01c7e38db0d01$var$q;
    };
}
var $00f01c7e38db0d01$var$r = [], $00f01c7e38db0d01$var$t = [], $00f01c7e38db0d01$var$u = 1, $00f01c7e38db0d01$var$v = null, $00f01c7e38db0d01$var$y = 3, $00f01c7e38db0d01$var$z = !1, $00f01c7e38db0d01$var$A = !1, $00f01c7e38db0d01$var$B = !1, $00f01c7e38db0d01$var$D = "function" === typeof setTimeout ? setTimeout : null, $00f01c7e38db0d01$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $00f01c7e38db0d01$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $00f01c7e38db0d01$var$G(a) {
    for(var b = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$t); null !== b;){
        if (null === b.callback) $00f01c7e38db0d01$var$k($00f01c7e38db0d01$var$t);
        else if (b.startTime <= a) $00f01c7e38db0d01$var$k($00f01c7e38db0d01$var$t), b.sortIndex = b.expirationTime, $00f01c7e38db0d01$var$f($00f01c7e38db0d01$var$r, b);
        else break;
        b = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$t);
    }
}
function $00f01c7e38db0d01$var$H(a) {
    $00f01c7e38db0d01$var$B = !1;
    $00f01c7e38db0d01$var$G(a);
    if (!$00f01c7e38db0d01$var$A) {
        if (null !== $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r)) $00f01c7e38db0d01$var$A = !0, $00f01c7e38db0d01$var$I($00f01c7e38db0d01$var$J);
        else {
            var b = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$t);
            null !== b && $00f01c7e38db0d01$var$K($00f01c7e38db0d01$var$H, b.startTime - a);
        }
    }
}
function $00f01c7e38db0d01$var$J(a, b) {
    $00f01c7e38db0d01$var$A = !1;
    $00f01c7e38db0d01$var$B && ($00f01c7e38db0d01$var$B = !1, $00f01c7e38db0d01$var$E($00f01c7e38db0d01$var$L), $00f01c7e38db0d01$var$L = -1);
    $00f01c7e38db0d01$var$z = !0;
    var c = $00f01c7e38db0d01$var$y;
    try {
        $00f01c7e38db0d01$var$G(b);
        for($00f01c7e38db0d01$var$v = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r); null !== $00f01c7e38db0d01$var$v && (!($00f01c7e38db0d01$var$v.expirationTime > b) || a && !$00f01c7e38db0d01$var$M());){
            var d = $00f01c7e38db0d01$var$v.callback;
            if ("function" === typeof d) {
                $00f01c7e38db0d01$var$v.callback = null;
                $00f01c7e38db0d01$var$y = $00f01c7e38db0d01$var$v.priorityLevel;
                var e = d($00f01c7e38db0d01$var$v.expirationTime <= b);
                b = $00f01c7e38db0d01$export$c4744153514ff05d();
                "function" === typeof e ? $00f01c7e38db0d01$var$v.callback = e : $00f01c7e38db0d01$var$v === $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r) && $00f01c7e38db0d01$var$k($00f01c7e38db0d01$var$r);
                $00f01c7e38db0d01$var$G(b);
            } else $00f01c7e38db0d01$var$k($00f01c7e38db0d01$var$r);
            $00f01c7e38db0d01$var$v = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r);
        }
        if (null !== $00f01c7e38db0d01$var$v) var w = !0;
        else {
            var m = $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$t);
            null !== m && $00f01c7e38db0d01$var$K($00f01c7e38db0d01$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $00f01c7e38db0d01$var$v = null, $00f01c7e38db0d01$var$y = c, $00f01c7e38db0d01$var$z = !1;
    }
}
var $00f01c7e38db0d01$var$N = !1, $00f01c7e38db0d01$var$O = null, $00f01c7e38db0d01$var$L = -1, $00f01c7e38db0d01$var$P = 5, $00f01c7e38db0d01$var$Q = -1;
function $00f01c7e38db0d01$var$M() {
    return $00f01c7e38db0d01$export$c4744153514ff05d() - $00f01c7e38db0d01$var$Q < $00f01c7e38db0d01$var$P ? !1 : !0;
}
function $00f01c7e38db0d01$var$R() {
    if (null !== $00f01c7e38db0d01$var$O) {
        var a = $00f01c7e38db0d01$export$c4744153514ff05d();
        $00f01c7e38db0d01$var$Q = a;
        var b = !0;
        try {
            b = $00f01c7e38db0d01$var$O(!0, a);
        } finally{
            b ? $00f01c7e38db0d01$var$S() : ($00f01c7e38db0d01$var$N = !1, $00f01c7e38db0d01$var$O = null);
        }
    } else $00f01c7e38db0d01$var$N = !1;
}
var $00f01c7e38db0d01$var$S;
if ("function" === typeof $00f01c7e38db0d01$var$F) $00f01c7e38db0d01$var$S = function() {
    $00f01c7e38db0d01$var$F($00f01c7e38db0d01$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $00f01c7e38db0d01$var$T = new MessageChannel, $00f01c7e38db0d01$var$U = $00f01c7e38db0d01$var$T.port2;
    $00f01c7e38db0d01$var$T.port1.onmessage = $00f01c7e38db0d01$var$R;
    $00f01c7e38db0d01$var$S = function() {
        $00f01c7e38db0d01$var$U.postMessage(null);
    };
} else $00f01c7e38db0d01$var$S = function() {
    $00f01c7e38db0d01$var$D($00f01c7e38db0d01$var$R, 0);
};
function $00f01c7e38db0d01$var$I(a) {
    $00f01c7e38db0d01$var$O = a;
    $00f01c7e38db0d01$var$N || ($00f01c7e38db0d01$var$N = !0, $00f01c7e38db0d01$var$S());
}
function $00f01c7e38db0d01$var$K(a, b) {
    $00f01c7e38db0d01$var$L = $00f01c7e38db0d01$var$D(function() {
        a($00f01c7e38db0d01$export$c4744153514ff05d());
    }, b);
}
$00f01c7e38db0d01$export$3e506c1ccc9cc1a7 = 5;
$00f01c7e38db0d01$export$e26fe2ed2fa76875 = 1;
$00f01c7e38db0d01$export$502329bbf4b505b1 = 4;
$00f01c7e38db0d01$export$6e3807111c4874c4 = 3;
$00f01c7e38db0d01$export$c27134553091fb3a = null;
$00f01c7e38db0d01$export$33ee1acdc04fd2a2 = 2;
$00f01c7e38db0d01$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$00f01c7e38db0d01$export$8352ce38b91d0c62 = function() {
    $00f01c7e38db0d01$var$A || $00f01c7e38db0d01$var$z || ($00f01c7e38db0d01$var$A = !0, $00f01c7e38db0d01$var$I($00f01c7e38db0d01$var$J));
};
$00f01c7e38db0d01$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $00f01c7e38db0d01$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$00f01c7e38db0d01$export$d3dfb8e4810cb555 = function() {
    return $00f01c7e38db0d01$var$y;
};
$00f01c7e38db0d01$export$839f9183b0465a69 = function() {
    return $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r);
};
$00f01c7e38db0d01$export$72fdf0e06517287b = function(a) {
    switch($00f01c7e38db0d01$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $00f01c7e38db0d01$var$y;
    }
    var c = $00f01c7e38db0d01$var$y;
    $00f01c7e38db0d01$var$y = b;
    try {
        return a();
    } finally{
        $00f01c7e38db0d01$var$y = c;
    }
};
$00f01c7e38db0d01$export$4b844e58a3e414b4 = function() {};
$00f01c7e38db0d01$export$816d2913ae6b83b1 = function() {};
$00f01c7e38db0d01$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $00f01c7e38db0d01$var$y;
    $00f01c7e38db0d01$var$y = a;
    try {
        return b();
    } finally{
        $00f01c7e38db0d01$var$y = c;
    }
};
$00f01c7e38db0d01$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $00f01c7e38db0d01$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $00f01c7e38db0d01$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $00f01c7e38db0d01$var$f($00f01c7e38db0d01$var$t, a), null === $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$r) && a === $00f01c7e38db0d01$var$h($00f01c7e38db0d01$var$t) && ($00f01c7e38db0d01$var$B ? ($00f01c7e38db0d01$var$E($00f01c7e38db0d01$var$L), $00f01c7e38db0d01$var$L = -1) : $00f01c7e38db0d01$var$B = !0, $00f01c7e38db0d01$var$K($00f01c7e38db0d01$var$H, c - d))) : (a.sortIndex = e, $00f01c7e38db0d01$var$f($00f01c7e38db0d01$var$r, a), $00f01c7e38db0d01$var$A || $00f01c7e38db0d01$var$z || ($00f01c7e38db0d01$var$A = !0, $00f01c7e38db0d01$var$I($00f01c7e38db0d01$var$J)));
    return a;
};
$00f01c7e38db0d01$export$b5836b71941fa3ed = $00f01c7e38db0d01$var$M;
$00f01c7e38db0d01$export$cf845f2c119da08a = function(a) {
    var b = $00f01c7e38db0d01$var$y;
    return function() {
        var c = $00f01c7e38db0d01$var$y;
        $00f01c7e38db0d01$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $00f01c7e38db0d01$var$y = c;
        }
    };
};

});



parcelRegister("3bLDg", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $252758f1bfeb9310$export$a7c73072b1a182ae; }, function (v) { return $252758f1bfeb9310$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $252758f1bfeb9310$export$9f27bc3417b4524d; }, function (v) { return $252758f1bfeb9310$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $252758f1bfeb9310$export$db77ccec0bb4ccac; }, function (v) { return $252758f1bfeb9310$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $252758f1bfeb9310$export$8392c0c9d3dcbd35; }, function (v) { return $252758f1bfeb9310$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $252758f1bfeb9310$export$ffb0004e005737fa; }, function (v) { return $252758f1bfeb9310$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $252758f1bfeb9310$export$b624eff549462981; }, function (v) { return $252758f1bfeb9310$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $252758f1bfeb9310$export$7897aa7841a5380c; }, function (v) { return $252758f1bfeb9310$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $252758f1bfeb9310$export$602eac185826482c; }, function (v) { return $252758f1bfeb9310$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $252758f1bfeb9310$export$e2c29f18771995cb; }, function (v) { return $252758f1bfeb9310$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $252758f1bfeb9310$export$5f8d39834fd61797; }, function (v) { return $252758f1bfeb9310$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $252758f1bfeb9310$export$74bf444e3cd11ea5; }, function (v) { return $252758f1bfeb9310$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $252758f1bfeb9310$export$998bcd577473dd93; }, function (v) { return $252758f1bfeb9310$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $252758f1bfeb9310$export$92387174baf9b227; }, function (v) { return $252758f1bfeb9310$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $252758f1bfeb9310$export$ec112efeb987d9c6; }, function (v) { return $252758f1bfeb9310$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $252758f1bfeb9310$export$b706b080d889d2c9; }, function (v) { return $252758f1bfeb9310$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $252758f1bfeb9310$export$5be5a87408f70ddc; }, function (v) { return $252758f1bfeb9310$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $252758f1bfeb9310$export$45a5e7f76e0caa8d; }, function (v) { return $252758f1bfeb9310$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $252758f1bfeb9310$export$455c2e768291efa6; }, function (v) { return $252758f1bfeb9310$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $252758f1bfeb9310$export$9522e17588c12572; }, function (v) { return $252758f1bfeb9310$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $252758f1bfeb9310$export$2110ac352bb060b9; }, function (v) { return $252758f1bfeb9310$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $252758f1bfeb9310$export$56885ab8b9c456ab; }, function (v) { return $252758f1bfeb9310$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $252758f1bfeb9310$export$d927fcb6adf8f9de; }, function (v) { return $252758f1bfeb9310$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $252758f1bfeb9310$export$b82d16f27459e05a; }, function (v) { return $252758f1bfeb9310$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $252758f1bfeb9310$export$522c17b4f5e123e8; }, function (v) { return $252758f1bfeb9310$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $252758f1bfeb9310$export$1aabd8a0274ecfd6; }, function (v) { return $252758f1bfeb9310$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $252758f1bfeb9310$export$3d6c20d97e46b957; }, function (v) { return $252758f1bfeb9310$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $252758f1bfeb9310$export$9b621391a187a31a; }, function (v) { return $252758f1bfeb9310$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $252758f1bfeb9310$export$f5bbd400c2f4426f; }, function (v) { return $252758f1bfeb9310$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $252758f1bfeb9310$export$a7c73072b1a182ae;
var $252758f1bfeb9310$export$9f27bc3417b4524d;
var $252758f1bfeb9310$export$db77ccec0bb4ccac;
var $252758f1bfeb9310$export$8392c0c9d3dcbd35;
var $252758f1bfeb9310$export$ffb0004e005737fa;
var $252758f1bfeb9310$export$b624eff549462981;
var $252758f1bfeb9310$export$7897aa7841a5380c;
var $252758f1bfeb9310$export$602eac185826482c;
var $252758f1bfeb9310$export$e2c29f18771995cb;
var $252758f1bfeb9310$export$5f8d39834fd61797;
var $252758f1bfeb9310$export$74bf444e3cd11ea5;
var $252758f1bfeb9310$export$998bcd577473dd93;
var $252758f1bfeb9310$export$92387174baf9b227;
var $252758f1bfeb9310$export$ec112efeb987d9c6;
var $252758f1bfeb9310$export$b706b080d889d2c9;
var $252758f1bfeb9310$export$5be5a87408f70ddc;
var $252758f1bfeb9310$export$45a5e7f76e0caa8d;
var $252758f1bfeb9310$export$455c2e768291efa6;
var $252758f1bfeb9310$export$9522e17588c12572;
var $252758f1bfeb9310$export$2110ac352bb060b9;
var $252758f1bfeb9310$export$56885ab8b9c456ab;
var $252758f1bfeb9310$export$d927fcb6adf8f9de;
var $252758f1bfeb9310$export$b82d16f27459e05a;
var $252758f1bfeb9310$export$522c17b4f5e123e8;
var $252758f1bfeb9310$export$1aabd8a0274ecfd6;
var $252758f1bfeb9310$export$3d6c20d97e46b957;
var $252758f1bfeb9310$export$9b621391a187a31a;
var $252758f1bfeb9310$export$f5bbd400c2f4426f;
'use strict';
var $252758f1bfeb9310$var$b = Symbol.for("react.element"), $252758f1bfeb9310$var$c = Symbol.for("react.portal"), $252758f1bfeb9310$var$d = Symbol.for("react.fragment"), $252758f1bfeb9310$var$e = Symbol.for("react.strict_mode"), $252758f1bfeb9310$var$f = Symbol.for("react.profiler"), $252758f1bfeb9310$var$g = Symbol.for("react.provider"), $252758f1bfeb9310$var$h = Symbol.for("react.context"), $252758f1bfeb9310$var$k = Symbol.for("react.server_context"), $252758f1bfeb9310$var$l = Symbol.for("react.forward_ref"), $252758f1bfeb9310$var$m = Symbol.for("react.suspense"), $252758f1bfeb9310$var$n = Symbol.for("react.suspense_list"), $252758f1bfeb9310$var$p = Symbol.for("react.memo"), $252758f1bfeb9310$var$q = Symbol.for("react.lazy"), $252758f1bfeb9310$var$t = Symbol.for("react.offscreen"), $252758f1bfeb9310$var$u;
$252758f1bfeb9310$var$u = Symbol.for("react.module.reference");
function $252758f1bfeb9310$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $252758f1bfeb9310$var$b:
                switch(a = a.type, a){
                    case $252758f1bfeb9310$var$d:
                    case $252758f1bfeb9310$var$f:
                    case $252758f1bfeb9310$var$e:
                    case $252758f1bfeb9310$var$m:
                    case $252758f1bfeb9310$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $252758f1bfeb9310$var$k:
                            case $252758f1bfeb9310$var$h:
                            case $252758f1bfeb9310$var$l:
                            case $252758f1bfeb9310$var$q:
                            case $252758f1bfeb9310$var$p:
                            case $252758f1bfeb9310$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $252758f1bfeb9310$var$c:
                return r;
        }
    }
}
$252758f1bfeb9310$export$a7c73072b1a182ae = $252758f1bfeb9310$var$h;
$252758f1bfeb9310$export$9f27bc3417b4524d = $252758f1bfeb9310$var$g;
$252758f1bfeb9310$export$db77ccec0bb4ccac = $252758f1bfeb9310$var$b;
$252758f1bfeb9310$export$8392c0c9d3dcbd35 = $252758f1bfeb9310$var$l;
$252758f1bfeb9310$export$ffb0004e005737fa = $252758f1bfeb9310$var$d;
$252758f1bfeb9310$export$b624eff549462981 = $252758f1bfeb9310$var$q;
$252758f1bfeb9310$export$7897aa7841a5380c = $252758f1bfeb9310$var$p;
$252758f1bfeb9310$export$602eac185826482c = $252758f1bfeb9310$var$c;
$252758f1bfeb9310$export$e2c29f18771995cb = $252758f1bfeb9310$var$f;
$252758f1bfeb9310$export$5f8d39834fd61797 = $252758f1bfeb9310$var$e;
$252758f1bfeb9310$export$74bf444e3cd11ea5 = $252758f1bfeb9310$var$m;
$252758f1bfeb9310$export$998bcd577473dd93 = $252758f1bfeb9310$var$n;
$252758f1bfeb9310$export$92387174baf9b227 = function() {
    return !1;
};
$252758f1bfeb9310$export$ec112efeb987d9c6 = function() {
    return !1;
};
$252758f1bfeb9310$export$b706b080d889d2c9 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$h;
};
$252758f1bfeb9310$export$5be5a87408f70ddc = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$g;
};
$252758f1bfeb9310$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $252758f1bfeb9310$var$b;
};
$252758f1bfeb9310$export$455c2e768291efa6 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$l;
};
$252758f1bfeb9310$export$9522e17588c12572 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$d;
};
$252758f1bfeb9310$export$2110ac352bb060b9 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$q;
};
$252758f1bfeb9310$export$56885ab8b9c456ab = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$p;
};
$252758f1bfeb9310$export$d927fcb6adf8f9de = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$c;
};
$252758f1bfeb9310$export$b82d16f27459e05a = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$f;
};
$252758f1bfeb9310$export$522c17b4f5e123e8 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$e;
};
$252758f1bfeb9310$export$1aabd8a0274ecfd6 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$m;
};
$252758f1bfeb9310$export$3d6c20d97e46b957 = function(a) {
    return $252758f1bfeb9310$var$v(a) === $252758f1bfeb9310$var$n;
};
$252758f1bfeb9310$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $252758f1bfeb9310$var$d || a === $252758f1bfeb9310$var$f || a === $252758f1bfeb9310$var$e || a === $252758f1bfeb9310$var$m || a === $252758f1bfeb9310$var$n || a === $252758f1bfeb9310$var$t || "object" === typeof a && null !== a && (a.$$typeof === $252758f1bfeb9310$var$q || a.$$typeof === $252758f1bfeb9310$var$p || a.$$typeof === $252758f1bfeb9310$var$g || a.$$typeof === $252758f1bfeb9310$var$h || a.$$typeof === $252758f1bfeb9310$var$l || a.$$typeof === $252758f1bfeb9310$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$252758f1bfeb9310$export$f5bbd400c2f4426f = $252758f1bfeb9310$var$v;

});

parcelRegister("2yL8S", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $1dd353382616da23$export$2b8d127b894957b9; }, function (v) { return $1dd353382616da23$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $1dd353382616da23$export$cea3a54a6425200c; }, function (v) { return $1dd353382616da23$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $1dd353382616da23$export$a7c73072b1a182ae; }, function (v) { return $1dd353382616da23$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $1dd353382616da23$export$9f27bc3417b4524d; }, function (v) { return $1dd353382616da23$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $1dd353382616da23$export$db77ccec0bb4ccac; }, function (v) { return $1dd353382616da23$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $1dd353382616da23$export$8392c0c9d3dcbd35; }, function (v) { return $1dd353382616da23$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1dd353382616da23$export$ffb0004e005737fa; }, function (v) { return $1dd353382616da23$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $1dd353382616da23$export$b624eff549462981; }, function (v) { return $1dd353382616da23$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $1dd353382616da23$export$7897aa7841a5380c; }, function (v) { return $1dd353382616da23$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $1dd353382616da23$export$602eac185826482c; }, function (v) { return $1dd353382616da23$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $1dd353382616da23$export$e2c29f18771995cb; }, function (v) { return $1dd353382616da23$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1dd353382616da23$export$5f8d39834fd61797; }, function (v) { return $1dd353382616da23$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1dd353382616da23$export$74bf444e3cd11ea5; }, function (v) { return $1dd353382616da23$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $1dd353382616da23$export$92387174baf9b227; }, function (v) { return $1dd353382616da23$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $1dd353382616da23$export$ec112efeb987d9c6; }, function (v) { return $1dd353382616da23$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $1dd353382616da23$export$b706b080d889d2c9; }, function (v) { return $1dd353382616da23$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $1dd353382616da23$export$5be5a87408f70ddc; }, function (v) { return $1dd353382616da23$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $1dd353382616da23$export$45a5e7f76e0caa8d; }, function (v) { return $1dd353382616da23$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $1dd353382616da23$export$455c2e768291efa6; }, function (v) { return $1dd353382616da23$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $1dd353382616da23$export$9522e17588c12572; }, function (v) { return $1dd353382616da23$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $1dd353382616da23$export$2110ac352bb060b9; }, function (v) { return $1dd353382616da23$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $1dd353382616da23$export$56885ab8b9c456ab; }, function (v) { return $1dd353382616da23$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $1dd353382616da23$export$d927fcb6adf8f9de; }, function (v) { return $1dd353382616da23$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $1dd353382616da23$export$b82d16f27459e05a; }, function (v) { return $1dd353382616da23$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $1dd353382616da23$export$522c17b4f5e123e8; }, function (v) { return $1dd353382616da23$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $1dd353382616da23$export$1aabd8a0274ecfd6; }, function (v) { return $1dd353382616da23$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $1dd353382616da23$export$9b621391a187a31a; }, function (v) { return $1dd353382616da23$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $1dd353382616da23$export$f5bbd400c2f4426f; }, function (v) { return $1dd353382616da23$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1dd353382616da23$export$2b8d127b894957b9;
var $1dd353382616da23$export$cea3a54a6425200c;
var $1dd353382616da23$export$a7c73072b1a182ae;
var $1dd353382616da23$export$9f27bc3417b4524d;
var $1dd353382616da23$export$db77ccec0bb4ccac;
var $1dd353382616da23$export$8392c0c9d3dcbd35;
var $1dd353382616da23$export$ffb0004e005737fa;
var $1dd353382616da23$export$b624eff549462981;
var $1dd353382616da23$export$7897aa7841a5380c;
var $1dd353382616da23$export$602eac185826482c;
var $1dd353382616da23$export$e2c29f18771995cb;
var $1dd353382616da23$export$5f8d39834fd61797;
var $1dd353382616da23$export$74bf444e3cd11ea5;
var $1dd353382616da23$export$92387174baf9b227;
var $1dd353382616da23$export$ec112efeb987d9c6;
var $1dd353382616da23$export$b706b080d889d2c9;
var $1dd353382616da23$export$5be5a87408f70ddc;
var $1dd353382616da23$export$45a5e7f76e0caa8d;
var $1dd353382616da23$export$455c2e768291efa6;
var $1dd353382616da23$export$9522e17588c12572;
var $1dd353382616da23$export$2110ac352bb060b9;
var $1dd353382616da23$export$56885ab8b9c456ab;
var $1dd353382616da23$export$d927fcb6adf8f9de;
var $1dd353382616da23$export$b82d16f27459e05a;
var $1dd353382616da23$export$522c17b4f5e123e8;
var $1dd353382616da23$export$1aabd8a0274ecfd6;
var $1dd353382616da23$export$9b621391a187a31a;
var $1dd353382616da23$export$f5bbd400c2f4426f;
'use strict';
var $1dd353382616da23$var$b = "function" === typeof Symbol && Symbol.for, $1dd353382616da23$var$c = $1dd353382616da23$var$b ? Symbol.for("react.element") : 60103, $1dd353382616da23$var$d = $1dd353382616da23$var$b ? Symbol.for("react.portal") : 60106, $1dd353382616da23$var$e = $1dd353382616da23$var$b ? Symbol.for("react.fragment") : 60107, $1dd353382616da23$var$f = $1dd353382616da23$var$b ? Symbol.for("react.strict_mode") : 60108, $1dd353382616da23$var$g = $1dd353382616da23$var$b ? Symbol.for("react.profiler") : 60114, $1dd353382616da23$var$h = $1dd353382616da23$var$b ? Symbol.for("react.provider") : 60109, $1dd353382616da23$var$k = $1dd353382616da23$var$b ? Symbol.for("react.context") : 60110, $1dd353382616da23$var$l = $1dd353382616da23$var$b ? Symbol.for("react.async_mode") : 60111, $1dd353382616da23$var$m = $1dd353382616da23$var$b ? Symbol.for("react.concurrent_mode") : 60111, $1dd353382616da23$var$n = $1dd353382616da23$var$b ? Symbol.for("react.forward_ref") : 60112, $1dd353382616da23$var$p = $1dd353382616da23$var$b ? Symbol.for("react.suspense") : 60113, $1dd353382616da23$var$q = $1dd353382616da23$var$b ? Symbol.for("react.suspense_list") : 60120, $1dd353382616da23$var$r = $1dd353382616da23$var$b ? Symbol.for("react.memo") : 60115, $1dd353382616da23$var$t = $1dd353382616da23$var$b ? Symbol.for("react.lazy") : 60116, $1dd353382616da23$var$v = $1dd353382616da23$var$b ? Symbol.for("react.block") : 60121, $1dd353382616da23$var$w = $1dd353382616da23$var$b ? Symbol.for("react.fundamental") : 60117, $1dd353382616da23$var$x = $1dd353382616da23$var$b ? Symbol.for("react.responder") : 60118, $1dd353382616da23$var$y = $1dd353382616da23$var$b ? Symbol.for("react.scope") : 60119;
function $1dd353382616da23$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $1dd353382616da23$var$c:
                switch(a = a.type, a){
                    case $1dd353382616da23$var$l:
                    case $1dd353382616da23$var$m:
                    case $1dd353382616da23$var$e:
                    case $1dd353382616da23$var$g:
                    case $1dd353382616da23$var$f:
                    case $1dd353382616da23$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1dd353382616da23$var$k:
                            case $1dd353382616da23$var$n:
                            case $1dd353382616da23$var$t:
                            case $1dd353382616da23$var$r:
                            case $1dd353382616da23$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $1dd353382616da23$var$d:
                return u;
        }
    }
}
function $1dd353382616da23$var$A(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$m;
}
$1dd353382616da23$export$2b8d127b894957b9 = $1dd353382616da23$var$l;
$1dd353382616da23$export$cea3a54a6425200c = $1dd353382616da23$var$m;
$1dd353382616da23$export$a7c73072b1a182ae = $1dd353382616da23$var$k;
$1dd353382616da23$export$9f27bc3417b4524d = $1dd353382616da23$var$h;
$1dd353382616da23$export$db77ccec0bb4ccac = $1dd353382616da23$var$c;
$1dd353382616da23$export$8392c0c9d3dcbd35 = $1dd353382616da23$var$n;
$1dd353382616da23$export$ffb0004e005737fa = $1dd353382616da23$var$e;
$1dd353382616da23$export$b624eff549462981 = $1dd353382616da23$var$t;
$1dd353382616da23$export$7897aa7841a5380c = $1dd353382616da23$var$r;
$1dd353382616da23$export$602eac185826482c = $1dd353382616da23$var$d;
$1dd353382616da23$export$e2c29f18771995cb = $1dd353382616da23$var$g;
$1dd353382616da23$export$5f8d39834fd61797 = $1dd353382616da23$var$f;
$1dd353382616da23$export$74bf444e3cd11ea5 = $1dd353382616da23$var$p;
$1dd353382616da23$export$92387174baf9b227 = function(a) {
    return $1dd353382616da23$var$A(a) || $1dd353382616da23$var$z(a) === $1dd353382616da23$var$l;
};
$1dd353382616da23$export$ec112efeb987d9c6 = $1dd353382616da23$var$A;
$1dd353382616da23$export$b706b080d889d2c9 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$k;
};
$1dd353382616da23$export$5be5a87408f70ddc = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$h;
};
$1dd353382616da23$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1dd353382616da23$var$c;
};
$1dd353382616da23$export$455c2e768291efa6 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$n;
};
$1dd353382616da23$export$9522e17588c12572 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$e;
};
$1dd353382616da23$export$2110ac352bb060b9 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$t;
};
$1dd353382616da23$export$56885ab8b9c456ab = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$r;
};
$1dd353382616da23$export$d927fcb6adf8f9de = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$d;
};
$1dd353382616da23$export$b82d16f27459e05a = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$g;
};
$1dd353382616da23$export$522c17b4f5e123e8 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$f;
};
$1dd353382616da23$export$1aabd8a0274ecfd6 = function(a) {
    return $1dd353382616da23$var$z(a) === $1dd353382616da23$var$p;
};
$1dd353382616da23$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1dd353382616da23$var$e || a === $1dd353382616da23$var$m || a === $1dd353382616da23$var$g || a === $1dd353382616da23$var$f || a === $1dd353382616da23$var$p || a === $1dd353382616da23$var$q || "object" === typeof a && null !== a && (a.$$typeof === $1dd353382616da23$var$t || a.$$typeof === $1dd353382616da23$var$r || a.$$typeof === $1dd353382616da23$var$h || a.$$typeof === $1dd353382616da23$var$k || a.$$typeof === $1dd353382616da23$var$n || a.$$typeof === $1dd353382616da23$var$w || a.$$typeof === $1dd353382616da23$var$x || a.$$typeof === $1dd353382616da23$var$y || a.$$typeof === $1dd353382616da23$var$v);
};
$1dd353382616da23$export$f5bbd400c2f4426f = $1dd353382616da23$var$z;

});

parcelRegister("hFdkQ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $2VFtY = parcelRequire("2VFtY");
function $cdc09c1de74df641$var$emptyFunction() {}
function $cdc09c1de74df641$var$emptyFunctionWithReset() {}
$cdc09c1de74df641$var$emptyFunctionWithReset.resetWarningCache = $cdc09c1de74df641$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $2VFtY) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cdc09c1de74df641$var$emptyFunctionWithReset,
        resetWarningCache: $cdc09c1de74df641$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("2VFtY", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $22211530d000fb5c$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $22211530d000fb5c$var$ReactPropTypesSecret;

});


parcelRegister("fbg6f", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $b0d45f28c5a0599a$export$306c0aa65ff9ec16; }, function (v) { return $b0d45f28c5a0599a$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0d45f28c5a0599a$export$306c0aa65ff9ec16;
"use strict";

var $9nZCP = parcelRequire("9nZCP");
function $b0d45f28c5a0599a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b0d45f28c5a0599a$var$objectIs = "function" === typeof Object.is ? Object.is : $b0d45f28c5a0599a$var$is, $b0d45f28c5a0599a$var$useState = $9nZCP.useState, $b0d45f28c5a0599a$var$useEffect = $9nZCP.useEffect, $b0d45f28c5a0599a$var$useLayoutEffect = $9nZCP.useLayoutEffect, $b0d45f28c5a0599a$var$useDebugValue = $9nZCP.useDebugValue;
function $b0d45f28c5a0599a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $b0d45f28c5a0599a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $b0d45f28c5a0599a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $b0d45f28c5a0599a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $b0d45f28c5a0599a$var$useEffect(function() {
        $b0d45f28c5a0599a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $b0d45f28c5a0599a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $b0d45f28c5a0599a$var$useDebugValue(value);
    return value;
}
function $b0d45f28c5a0599a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b0d45f28c5a0599a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b0d45f28c5a0599a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $b0d45f28c5a0599a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $b0d45f28c5a0599a$var$useSyncExternalStore$1 : $b0d45f28c5a0599a$var$useSyncExternalStore$2;
$b0d45f28c5a0599a$export$306c0aa65ff9ec16 = void 0 !== $9nZCP.useSyncExternalStore ? $9nZCP.useSyncExternalStore : $b0d45f28c5a0599a$var$shim;

});

parcelRegister("a141p", function(module, exports) {
var global = typeof self !== 'undefined' ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: 'URLSearchParams' in self1,
            iterable: 'Symbol' in self1 && 'iterator' in Symbol,
            blob: 'FileReader' in self1 && 'Blob' in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in self1,
            arrayBuffer: 'ArrayBuffer' in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError('Invalid character in header field name');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = '';
                else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'POST',
            'PUT'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = 'statusText' in options ? options.statusText : 'OK';
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ''
            });
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError('Network request failed'));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException('Aborted', 'AbortError'));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr && support.blob) xhr.responseType = 'blob';
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

var $dde41420777b5d34$exports = {};
'use strict';

$dde41420777b5d34$exports = (parcelRequire("6XFBA"));



var $9nZCP = parcelRequire("9nZCP");
var $d6d573f2d6b6d1f8$export$882461b6382ed46c;
var $d6d573f2d6b6d1f8$export$757ceba2d55c277e;
'use strict';
var $06928105ffc753ea$exports = {};
'use strict';
function $06928105ffc753ea$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($06928105ffc753ea$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$06928105ffc753ea$var$checkDCE();

$06928105ffc753ea$exports = (parcelRequire("lNe1g"));


var $d6d573f2d6b6d1f8$var$i;
$d6d573f2d6b6d1f8$export$882461b6382ed46c = $06928105ffc753ea$exports.createRoot;
$d6d573f2d6b6d1f8$export$757ceba2d55c277e = $06928105ffc753ea$exports.hydrateRoot;


var $1d9bd5c523349ec4$exports = {};

$parcel$defineInteropFlag($1d9bd5c523349ec4$exports);

$parcel$export($1d9bd5c523349ec4$exports, "isStyledComponent", function () { return $1d9bd5c523349ec4$export$7ba318d8d2f06c76; });
$parcel$export($1d9bd5c523349ec4$exports, "version", function () { return $1d9bd5c523349ec4$export$83d89fbfd8236492; });
$parcel$export($1d9bd5c523349ec4$exports, "StyleSheetContext", function () { return $1d9bd5c523349ec4$export$8c190ef828af4c86; });
$parcel$export($1d9bd5c523349ec4$exports, "StyleSheetConsumer", function () { return $1d9bd5c523349ec4$export$91317688fc694efa; });
$parcel$export($1d9bd5c523349ec4$exports, "StyleSheetManager", function () { return $1d9bd5c523349ec4$export$a473771da2f0ff7c; });
$parcel$export($1d9bd5c523349ec4$exports, "css", function () { return $1d9bd5c523349ec4$export$dbf350e5966cf602; });
$parcel$export($1d9bd5c523349ec4$exports, "ThemeContext", function () { return $1d9bd5c523349ec4$export$2c657da244d00bd6; });
$parcel$export($1d9bd5c523349ec4$exports, "ThemeConsumer", function () { return $1d9bd5c523349ec4$export$b631efc24e9d5e2f; });
$parcel$export($1d9bd5c523349ec4$exports, "ThemeProvider", function () { return $1d9bd5c523349ec4$export$d8964aec282183a3; });
$parcel$export($1d9bd5c523349ec4$exports, "createGlobalStyle", function () { return $1d9bd5c523349ec4$export$f0f03736edb61697; });
$parcel$export($1d9bd5c523349ec4$exports, "keyframes", function () { return $1d9bd5c523349ec4$export$d25ddfdf17c3ad3e; });
$parcel$export($1d9bd5c523349ec4$exports, "ServerStyleSheet", function () { return $1d9bd5c523349ec4$export$ae8c7d15c8b89a20; });
$parcel$export($1d9bd5c523349ec4$exports, "withTheme", function () { return $1d9bd5c523349ec4$export$e8748c6a27b910dc; });
$parcel$export($1d9bd5c523349ec4$exports, "useTheme", function () { return $1d9bd5c523349ec4$export$93d4e7f90805808f; });
$parcel$export($1d9bd5c523349ec4$exports, "__PRIVATE__", function () { return $1d9bd5c523349ec4$export$5c87cfe6c475f500; });
$parcel$export($1d9bd5c523349ec4$exports, "default", function () { return $1d9bd5c523349ec4$export$2e2bcd8739ae039; });
var $641555432cc96e57$exports = {};
'use strict';

$641555432cc96e57$exports = (parcelRequire("3bLDg"));



var $9nZCP = parcelRequire("9nZCP");
var $6c6fcafea3e67b1c$exports = {};
//
$6c6fcafea3e67b1c$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $4592fee8d7fd368d$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $4592fee8d7fd368d$export$2e2bcd8739ae039 = $4592fee8d7fd368d$var$stylis_min;


var $8f8653a6518971cd$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $8f8653a6518971cd$export$2e2bcd8739ae039 = $8f8653a6518971cd$var$unitlessKeys;


function $3a9bed4c6f1a8239$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $8cc731d47fbd173f$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8cc731d47fbd173f$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $3a9bed4c6f1a8239$export$2e2bcd8739ae039)(function(prop) {
    return $8cc731d47fbd173f$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $732263a4f5417bca$exports = {};
'use strict';
var $c1125ce14f41c46e$exports = {};
'use strict';

$c1125ce14f41c46e$exports = (parcelRequire("2yL8S"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $732263a4f5417bca$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $732263a4f5417bca$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $732263a4f5417bca$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $732263a4f5417bca$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $732263a4f5417bca$var$TYPE_STATICS = {};
$732263a4f5417bca$var$TYPE_STATICS[$c1125ce14f41c46e$exports.ForwardRef] = $732263a4f5417bca$var$FORWARD_REF_STATICS;
$732263a4f5417bca$var$TYPE_STATICS[$c1125ce14f41c46e$exports.Memo] = $732263a4f5417bca$var$MEMO_STATICS;
function $732263a4f5417bca$var$getStatics(component) {
    // React v16.11 and below
    if ($c1125ce14f41c46e$exports.isMemo(component)) return $732263a4f5417bca$var$MEMO_STATICS;
     // React v16.12 and above
    return $732263a4f5417bca$var$TYPE_STATICS[component['$$typeof']] || $732263a4f5417bca$var$REACT_STATICS;
}
var $732263a4f5417bca$var$defineProperty = Object.defineProperty;
var $732263a4f5417bca$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $732263a4f5417bca$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $732263a4f5417bca$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $732263a4f5417bca$var$getPrototypeOf = Object.getPrototypeOf;
var $732263a4f5417bca$var$objectPrototype = Object.prototype;
function $732263a4f5417bca$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($732263a4f5417bca$var$objectPrototype) {
            var inheritedComponent = $732263a4f5417bca$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $732263a4f5417bca$var$objectPrototype) $732263a4f5417bca$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $732263a4f5417bca$var$getOwnPropertyNames(sourceComponent);
        if ($732263a4f5417bca$var$getOwnPropertySymbols) keys = keys.concat($732263a4f5417bca$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $732263a4f5417bca$var$getStatics(targetComponent);
        var sourceStatics = $732263a4f5417bca$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$732263a4f5417bca$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $732263a4f5417bca$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $732263a4f5417bca$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$732263a4f5417bca$exports = $732263a4f5417bca$var$hoistNonReactStatics;


var $8972dd6366fe5fef$exports = {};
// shim for using process in browser
var $8972dd6366fe5fef$var$process = $8972dd6366fe5fef$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8972dd6366fe5fef$var$cachedSetTimeout;
var $8972dd6366fe5fef$var$cachedClearTimeout;
function $8972dd6366fe5fef$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $8972dd6366fe5fef$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $8972dd6366fe5fef$var$cachedSetTimeout = setTimeout;
        else $8972dd6366fe5fef$var$cachedSetTimeout = $8972dd6366fe5fef$var$defaultSetTimout;
    } catch (e) {
        $8972dd6366fe5fef$var$cachedSetTimeout = $8972dd6366fe5fef$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $8972dd6366fe5fef$var$cachedClearTimeout = clearTimeout;
        else $8972dd6366fe5fef$var$cachedClearTimeout = $8972dd6366fe5fef$var$defaultClearTimeout;
    } catch (e) {
        $8972dd6366fe5fef$var$cachedClearTimeout = $8972dd6366fe5fef$var$defaultClearTimeout;
    }
})();
function $8972dd6366fe5fef$var$runTimeout(fun) {
    if ($8972dd6366fe5fef$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8972dd6366fe5fef$var$cachedSetTimeout === $8972dd6366fe5fef$var$defaultSetTimout || !$8972dd6366fe5fef$var$cachedSetTimeout) && setTimeout) {
        $8972dd6366fe5fef$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8972dd6366fe5fef$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8972dd6366fe5fef$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8972dd6366fe5fef$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8972dd6366fe5fef$var$runClearTimeout(marker) {
    if ($8972dd6366fe5fef$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8972dd6366fe5fef$var$cachedClearTimeout === $8972dd6366fe5fef$var$defaultClearTimeout || !$8972dd6366fe5fef$var$cachedClearTimeout) && clearTimeout) {
        $8972dd6366fe5fef$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8972dd6366fe5fef$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8972dd6366fe5fef$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8972dd6366fe5fef$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8972dd6366fe5fef$var$queue = [];
var $8972dd6366fe5fef$var$draining = false;
var $8972dd6366fe5fef$var$currentQueue;
var $8972dd6366fe5fef$var$queueIndex = -1;
function $8972dd6366fe5fef$var$cleanUpNextTick() {
    if (!$8972dd6366fe5fef$var$draining || !$8972dd6366fe5fef$var$currentQueue) return;
    $8972dd6366fe5fef$var$draining = false;
    if ($8972dd6366fe5fef$var$currentQueue.length) $8972dd6366fe5fef$var$queue = $8972dd6366fe5fef$var$currentQueue.concat($8972dd6366fe5fef$var$queue);
    else $8972dd6366fe5fef$var$queueIndex = -1;
    if ($8972dd6366fe5fef$var$queue.length) $8972dd6366fe5fef$var$drainQueue();
}
function $8972dd6366fe5fef$var$drainQueue() {
    if ($8972dd6366fe5fef$var$draining) return;
    var timeout = $8972dd6366fe5fef$var$runTimeout($8972dd6366fe5fef$var$cleanUpNextTick);
    $8972dd6366fe5fef$var$draining = true;
    var len = $8972dd6366fe5fef$var$queue.length;
    while(len){
        $8972dd6366fe5fef$var$currentQueue = $8972dd6366fe5fef$var$queue;
        $8972dd6366fe5fef$var$queue = [];
        while(++$8972dd6366fe5fef$var$queueIndex < len)if ($8972dd6366fe5fef$var$currentQueue) $8972dd6366fe5fef$var$currentQueue[$8972dd6366fe5fef$var$queueIndex].run();
        $8972dd6366fe5fef$var$queueIndex = -1;
        len = $8972dd6366fe5fef$var$queue.length;
    }
    $8972dd6366fe5fef$var$currentQueue = null;
    $8972dd6366fe5fef$var$draining = false;
    $8972dd6366fe5fef$var$runClearTimeout(timeout);
}
$8972dd6366fe5fef$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8972dd6366fe5fef$var$queue.push(new $8972dd6366fe5fef$var$Item(fun, args));
    if ($8972dd6366fe5fef$var$queue.length === 1 && !$8972dd6366fe5fef$var$draining) $8972dd6366fe5fef$var$runTimeout($8972dd6366fe5fef$var$drainQueue);
};
// v8 likes predictible objects
function $8972dd6366fe5fef$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8972dd6366fe5fef$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8972dd6366fe5fef$var$process.title = 'browser';
$8972dd6366fe5fef$var$process.browser = true;
$8972dd6366fe5fef$var$process.env = {};
$8972dd6366fe5fef$var$process.argv = [];
$8972dd6366fe5fef$var$process.version = ''; // empty string to avoid regexp issues
$8972dd6366fe5fef$var$process.versions = {};
function $8972dd6366fe5fef$var$noop() {}
$8972dd6366fe5fef$var$process.on = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.addListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.once = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.off = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.removeListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.removeAllListeners = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.emit = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.prependListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.prependOnceListener = $8972dd6366fe5fef$var$noop;
$8972dd6366fe5fef$var$process.listeners = function(name) {
    return [];
};
$8972dd6366fe5fef$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$8972dd6366fe5fef$var$process.cwd = function() {
    return '/';
};
$8972dd6366fe5fef$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$8972dd6366fe5fef$var$process.umask = function() {
    return 0;
};


function $1d9bd5c523349ec4$var$y() {
    return ($1d9bd5c523349ec4$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $1d9bd5c523349ec4$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $1d9bd5c523349ec4$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $641555432cc96e57$exports.typeOf)(t);
}, $1d9bd5c523349ec4$var$S = Object.freeze([]), $1d9bd5c523349ec4$var$w = Object.freeze({});
function $1d9bd5c523349ec4$var$E(e) {
    return "function" == typeof e;
}
function $1d9bd5c523349ec4$var$b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $1d9bd5c523349ec4$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $1d9bd5c523349ec4$var$N = ("undefined" != typeof $8972dd6366fe5fef$exports && void 0 !== $8972dd6366fe5fef$exports.env && undefined, "data-styled"), $1d9bd5c523349ec4$export$83d89fbfd8236492 = "5.3.11", $1d9bd5c523349ec4$var$C = "undefined" != typeof window && "HTMLElement" in window, $1d9bd5c523349ec4$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $8972dd6366fe5fef$exports && void 0 !== $8972dd6366fe5fef$exports.env && false), $1d9bd5c523349ec4$var$P = {}, $1d9bd5c523349ec4$var$O = {};
function $1d9bd5c523349ec4$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $1d9bd5c523349ec4$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $1d9bd5c523349ec4$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $1d9bd5c523349ec4$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $1d9bd5c523349ec4$var$T = new Map, $1d9bd5c523349ec4$var$x = new Map, $1d9bd5c523349ec4$var$k = 1, $1d9bd5c523349ec4$var$V = function(e) {
    if ($1d9bd5c523349ec4$var$T.has(e)) return $1d9bd5c523349ec4$var$T.get(e);
    for(; $1d9bd5c523349ec4$var$x.has($1d9bd5c523349ec4$var$k);)$1d9bd5c523349ec4$var$k++;
    var t = $1d9bd5c523349ec4$var$k++;
    return $1d9bd5c523349ec4$var$T.set(e, t), $1d9bd5c523349ec4$var$x.set(t, e), t;
}, $1d9bd5c523349ec4$var$B = function(e) {
    return $1d9bd5c523349ec4$var$x.get(e);
}, $1d9bd5c523349ec4$var$z = function(e, t) {
    t >= $1d9bd5c523349ec4$var$k && ($1d9bd5c523349ec4$var$k = t + 1), $1d9bd5c523349ec4$var$T.set(e, t), $1d9bd5c523349ec4$var$x.set(t, e);
}, $1d9bd5c523349ec4$var$M = "style[" + $1d9bd5c523349ec4$var$N + '][data-styled-version="5.3.11"]', $1d9bd5c523349ec4$var$G = new RegExp("^" + $1d9bd5c523349ec4$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $1d9bd5c523349ec4$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $1d9bd5c523349ec4$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($1d9bd5c523349ec4$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($1d9bd5c523349ec4$var$z(u, c), $1d9bd5c523349ec4$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $1d9bd5c523349ec4$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $1d9bd5c523349ec4$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($1d9bd5c523349ec4$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($1d9bd5c523349ec4$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $1d9bd5c523349ec4$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $1d9bd5c523349ec4$var$H = function() {
    function e(e) {
        var t = this.element = $1d9bd5c523349ec4$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $1d9bd5c523349ec4$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $1d9bd5c523349ec4$var$$ = function() {
    function e(e) {
        var t = this.element = $1d9bd5c523349ec4$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $1d9bd5c523349ec4$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $1d9bd5c523349ec4$var$U = $1d9bd5c523349ec4$var$C, $1d9bd5c523349ec4$var$J = {
    isServer: !$1d9bd5c523349ec4$var$C,
    useCSSOMInjection: !$1d9bd5c523349ec4$var$I
}, $1d9bd5c523349ec4$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $1d9bd5c523349ec4$var$w), void 0 === t && (t = {}), this.options = $1d9bd5c523349ec4$var$y({}, $1d9bd5c523349ec4$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $1d9bd5c523349ec4$var$C && $1d9bd5c523349ec4$var$U && ($1d9bd5c523349ec4$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($1d9bd5c523349ec4$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($1d9bd5c523349ec4$var$N) && ($1d9bd5c523349ec4$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $1d9bd5c523349ec4$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($1d9bd5c523349ec4$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $1d9bd5c523349ec4$var$W(o) : r ? new $1d9bd5c523349ec4$var$H(o) : new $1d9bd5c523349ec4$var$$(o), new $1d9bd5c523349ec4$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($1d9bd5c523349ec4$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($1d9bd5c523349ec4$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($1d9bd5c523349ec4$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $1d9bd5c523349ec4$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $1d9bd5c523349ec4$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $1d9bd5c523349ec4$var$Z = /(a)(d)/gi, $1d9bd5c523349ec4$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $1d9bd5c523349ec4$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $1d9bd5c523349ec4$var$K(t % 52) + n;
    return ($1d9bd5c523349ec4$var$K(t % 52) + n).replace($1d9bd5c523349ec4$var$Z, "$1-$2");
}
var $1d9bd5c523349ec4$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $1d9bd5c523349ec4$var$te = function(e) {
    return $1d9bd5c523349ec4$var$ee(5381, e);
};
function $1d9bd5c523349ec4$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($1d9bd5c523349ec4$var$E(n) && !$1d9bd5c523349ec4$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $1d9bd5c523349ec4$var$re = $1d9bd5c523349ec4$var$te("5.3.11"), $1d9bd5c523349ec4$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $1d9bd5c523349ec4$var$ne(e), this.componentId = t, this.baseHash = $1d9bd5c523349ec4$var$ee($1d9bd5c523349ec4$var$re, t), this.baseStyle = n, $1d9bd5c523349ec4$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $1d9bd5c523349ec4$var$_e(this.rules, e, t, n).join(""), i = $1d9bd5c523349ec4$var$Q($1d9bd5c523349ec4$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $1d9bd5c523349ec4$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $1d9bd5c523349ec4$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $1d9bd5c523349ec4$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $1d9bd5c523349ec4$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $1d9bd5c523349ec4$var$se = /^\s*\/\/.*$/gm, $1d9bd5c523349ec4$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $1d9bd5c523349ec4$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $1d9bd5c523349ec4$var$w : e, i = s.options, a = void 0 === i ? $1d9bd5c523349ec4$var$w : i, c = s.plugins, u = void 0 === c ? $1d9bd5c523349ec4$var$S : c, l = new (0, $4592fee8d7fd368d$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $1d9bd5c523349ec4$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($1d9bd5c523349ec4$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $1d9bd5c523349ec4$var$D(15), $1d9bd5c523349ec4$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $1d9bd5c523349ec4$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createContext(), $1d9bd5c523349ec4$export$91317688fc694efa = $1d9bd5c523349ec4$export$8c190ef828af4c86.Consumer, $1d9bd5c523349ec4$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createContext(), $1d9bd5c523349ec4$var$de = ($1d9bd5c523349ec4$var$le.Consumer, new $1d9bd5c523349ec4$var$X), $1d9bd5c523349ec4$var$he = $1d9bd5c523349ec4$var$ae();
function $1d9bd5c523349ec4$var$pe() {
    return (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$8c190ef828af4c86) || $1d9bd5c523349ec4$var$de;
}
function $1d9bd5c523349ec4$var$fe() {
    return (0, $9nZCP.useContext)($1d9bd5c523349ec4$var$le) || $1d9bd5c523349ec4$var$he;
}
function $1d9bd5c523349ec4$export$a473771da2f0ff7c(e) {
    var t = (0, $9nZCP.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $1d9bd5c523349ec4$var$pe(), u = (0, $9nZCP.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $9nZCP.useMemo)(function() {
        return $1d9bd5c523349ec4$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $9nZCP.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($6c6fcafea3e67b1c$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($1d9bd5c523349ec4$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($1d9bd5c523349ec4$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $1d9bd5c523349ec4$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $1d9bd5c523349ec4$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $1d9bd5c523349ec4$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $1d9bd5c523349ec4$var$he), this.name + e.hash;
    }, e;
}(), $1d9bd5c523349ec4$var$ve = /([A-Z])/, $1d9bd5c523349ec4$var$ge = /([A-Z])/g, $1d9bd5c523349ec4$var$Se = /^ms-/, $1d9bd5c523349ec4$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $1d9bd5c523349ec4$var$Ee(e) {
    return $1d9bd5c523349ec4$var$ve.test(e) ? e.replace($1d9bd5c523349ec4$var$ge, $1d9bd5c523349ec4$var$we).replace($1d9bd5c523349ec4$var$Se, "-ms-") : e;
}
var $1d9bd5c523349ec4$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $1d9bd5c523349ec4$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $1d9bd5c523349ec4$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($1d9bd5c523349ec4$var$be(e)) return "";
    if ($1d9bd5c523349ec4$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($1d9bd5c523349ec4$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $1d9bd5c523349ec4$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $1d9bd5c523349ec4$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $1d9bd5c523349ec4$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$1d9bd5c523349ec4$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $1d9bd5c523349ec4$var$E(t[i]) ? s.push($1d9bd5c523349ec4$var$Ee(i) + ":", t[i], ";") : $1d9bd5c523349ec4$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($1d9bd5c523349ec4$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $8f8653a6518971cd$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $1d9bd5c523349ec4$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $1d9bd5c523349ec4$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $1d9bd5c523349ec4$var$E(e) || $1d9bd5c523349ec4$var$g(e) ? $1d9bd5c523349ec4$var$Ne($1d9bd5c523349ec4$var$_e($1d9bd5c523349ec4$var$v($1d9bd5c523349ec4$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $1d9bd5c523349ec4$var$Ne($1d9bd5c523349ec4$var$_e($1d9bd5c523349ec4$var$v(e, n)));
}
var $1d9bd5c523349ec4$var$Ce = /invalid hook call/i, $1d9bd5c523349ec4$var$Ie = new Set, $1d9bd5c523349ec4$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $1d9bd5c523349ec4$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $1d9bd5c523349ec4$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $1d9bd5c523349ec4$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $1d9bd5c523349ec4$var$De = /(^-|-$)/g;
function $1d9bd5c523349ec4$var$je(e) {
    return e.replace($1d9bd5c523349ec4$var$Re, "-").replace($1d9bd5c523349ec4$var$De, "");
}
var $1d9bd5c523349ec4$var$Te = function(e) {
    return $1d9bd5c523349ec4$var$Q($1d9bd5c523349ec4$var$te(e) >>> 0);
};
function $1d9bd5c523349ec4$var$xe(e) {
    return "string" == typeof e && true;
}
var $1d9bd5c523349ec4$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $1d9bd5c523349ec4$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $1d9bd5c523349ec4$var$Be(e, t, n) {
    var r = e[n];
    $1d9bd5c523349ec4$var$ke(t) && $1d9bd5c523349ec4$var$ke(r) ? $1d9bd5c523349ec4$var$ze(r, t) : e[n] = t;
}
function $1d9bd5c523349ec4$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($1d9bd5c523349ec4$var$ke(i)) for(var a in i)$1d9bd5c523349ec4$var$Ve(a) && $1d9bd5c523349ec4$var$Be(e, i[a], a);
    }
    return e;
}
var $1d9bd5c523349ec4$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createContext(), $1d9bd5c523349ec4$export$b631efc24e9d5e2f = $1d9bd5c523349ec4$export$2c657da244d00bd6.Consumer;
function $1d9bd5c523349ec4$export$d8964aec282183a3(e) {
    var t = (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$2c657da244d00bd6), n = (0, $9nZCP.useMemo)(function() {
        return function(e, t) {
            if (!e) return $1d9bd5c523349ec4$var$D(14);
            if ($1d9bd5c523349ec4$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $1d9bd5c523349ec4$var$D(8) : t ? $1d9bd5c523349ec4$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($1d9bd5c523349ec4$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $1d9bd5c523349ec4$var$Fe = {};
function $1d9bd5c523349ec4$var$Ye(e, t, n) {
    var o = $1d9bd5c523349ec4$export$7ba318d8d2f06c76(e), i = !$1d9bd5c523349ec4$var$xe(e), a = t.attrs, c = void 0 === a ? $1d9bd5c523349ec4$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $1d9bd5c523349ec4$var$je(e);
        $1d9bd5c523349ec4$var$Fe[n] = ($1d9bd5c523349ec4$var$Fe[n] || 0) + 1;
        var r = n + "-" + $1d9bd5c523349ec4$var$Te("5.3.11" + n + $1d9bd5c523349ec4$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $1d9bd5c523349ec4$var$xe(e) ? "styled." + e : "Styled(" + $1d9bd5c523349ec4$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $1d9bd5c523349ec4$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $1d9bd5c523349ec4$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $1d9bd5c523349ec4$var$w);
                var r = $1d9bd5c523349ec4$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $1d9bd5c523349ec4$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($1d9bd5c523349ec4$var$Oe(t, (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$2c657da244d00bd6), a) || $1d9bd5c523349ec4$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $1d9bd5c523349ec4$var$pe(), s = $1d9bd5c523349ec4$var$fe(), i = t ? e.generateAndInjectStyles($1d9bd5c523349ec4$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $1d9bd5c523349ec4$var$xe(b), N = v !== t ? $1d9bd5c523349ec4$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $8cc731d47fbd173f$export$2e2bcd8739ae039), b) : !_ || (0, $8cc731d47fbd173f$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $1d9bd5c523349ec4$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $9nZCP.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $1d9bd5c523349ec4$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($1d9bd5c523349ec4$var$xe(e) ? e : $1d9bd5c523349ec4$var$je($1d9bd5c523349ec4$var$b(e)));
        return $1d9bd5c523349ec4$var$Ye(e, $1d9bd5c523349ec4$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $1d9bd5c523349ec4$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($732263a4f5417bca$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $1d9bd5c523349ec4$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $1d9bd5c523349ec4$var$w), !(0, $641555432cc96e57$exports.isValidElementType)(r)) return $1d9bd5c523349ec4$var$D(1, String(r));
        var s = function() {
            return t(r, o, $1d9bd5c523349ec4$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $1d9bd5c523349ec4$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $1d9bd5c523349ec4$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($1d9bd5c523349ec4$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $1d9bd5c523349ec4$var$qe[e] = $1d9bd5c523349ec4$var$qe(e);
});
var $1d9bd5c523349ec4$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $1d9bd5c523349ec4$var$ne(e), $1d9bd5c523349ec4$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($1d9bd5c523349ec4$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $1d9bd5c523349ec4$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $1d9bd5c523349ec4$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $1d9bd5c523349ec4$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $1d9bd5c523349ec4$var$Te(JSON.stringify(i)), u = new $1d9bd5c523349ec4$var$He(i, a);
    function d(e) {
        var t = $1d9bd5c523349ec4$var$pe(), n = $1d9bd5c523349ec4$var$fe(), o = (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$2c657da244d00bd6), d = (0, $9nZCP.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $9nZCP.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $1d9bd5c523349ec4$var$P, n, o);
        else {
            var s = $1d9bd5c523349ec4$var$y({}, t, {
                theme: $1d9bd5c523349ec4$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).memo(d);
}
function $1d9bd5c523349ec4$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $1d9bd5c523349ec4$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $1d9bd5c523349ec4$var$Te(o);
    return new $1d9bd5c523349ec4$var$ye(s, o);
}
var $1d9bd5c523349ec4$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $1d9bd5c523349ec4$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $1d9bd5c523349ec4$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $1d9bd5c523349ec4$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $1d9bd5c523349ec4$var$D(2);
            var n = ((t = {})[$1d9bd5c523349ec4$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $1d9bd5c523349ec4$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("style", $1d9bd5c523349ec4$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $1d9bd5c523349ec4$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $1d9bd5c523349ec4$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement($1d9bd5c523349ec4$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $1d9bd5c523349ec4$var$D(3);
    }, e;
}(), $1d9bd5c523349ec4$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).forwardRef(function(t, n) {
        var o = (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$2c657da244d00bd6), i = e.defaultProps, a = $1d9bd5c523349ec4$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement(e, $1d9bd5c523349ec4$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($732263a4f5417bca$exports)))(t, e), t.displayName = "WithTheme(" + $1d9bd5c523349ec4$var$b(e) + ")", t;
}, $1d9bd5c523349ec4$export$93d4e7f90805808f = function() {
    return (0, $9nZCP.useContext)($1d9bd5c523349ec4$export$2c657da244d00bd6);
}, $1d9bd5c523349ec4$export$5c87cfe6c475f500 = {
    StyleSheet: $1d9bd5c523349ec4$var$X,
    masterSheet: $1d9bd5c523349ec4$var$de
};
var $1d9bd5c523349ec4$export$2e2bcd8739ae039 = $1d9bd5c523349ec4$var$qe;




const $108e5c20d852b43b$export$863f8b1efd907ec3 = (style)=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
  @media (max-width: 1250px) {
    ${style.toString()}
  }
`;


const $12dd8b97d88addd6$export$f05794e648629f6c = (0, $1d9bd5c523349ec4$export$f0f03736edb61697)`
  html {
    box-sizing: border-box;
    margin: 0px;
    overflow-x: hidden;
    margin-right: calc(-1 * (100vw - 100%));

  }
  *, *:before, *:after {
    box-sizing: inherit;
    margin: 0px;
  }
  body {
    font-family: "Oxanium", sans-serif;
    background-color: ${({ theme: theme })=>theme.color.dark};
  }
  h1 {
    font-family: "Major Mono Display";
    font-size: 6rem;
    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      font-size: calc(64px + (98 - 64) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 600;
    color: ${({ theme: theme })=>theme.color.white};
  }
  h2 {
    font-family: "Major Mono Display";
    font-size: 3rem;
    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      font-size: calc(32px + (48 - 32) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 400;
    color: ${({ theme: theme })=>theme.color.white};
  }
  h3 {
    font-family: "Major Mono Display";
    font-size: 2rem;
    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      font-size: calc(24px + (32 - 24) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 600;
    color: ${({ theme: theme })=>theme.color.white};
  }
  h4 {
    font-family: "Major Mono Display";
    font-size: 2rem;
    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      font-size: calc(24px + (32 - 24) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 400;
    color: ${({ theme: theme })=>theme.color.white};
  }
  h5 {
    font-family: "Major Mono Display";
    font-size: 1.5rem;
    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      font-size: calc(16px + (24 - 16) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 400;
    color: ${({ theme: theme })=>theme.color.white};
  }
  p {
    line-height: 1.25rem;
    font-size: 1.25rem;
    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      font-size: calc(16px + (24 - 16) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 300;
    color: ${({ theme: theme })=>theme.color.white};
  }
  small {
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    font-family: "Oxanium";
    color: ${({ theme: theme })=>theme.color.white};
  }
  label{
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  font-family: "Oxanium";
  color: ${({ theme: theme })=>theme.color.pink} !important;
  }
  button {
    all: unset;
    box-sizing: border-box;
    :hover {
      cursor: pointer;
    }
  }
  hr {
    opacity: 1;
  }
  svg, img {
    display: inline-block;
    visibility: visible;
    vertical-align: middle;
  }

  *::-webkit-scrollbar {
    width: 12px;
  }

  *::-webkit-scrollbar-track {
    background-color: ${({ theme: theme })=>theme.color.lightBlue}80;
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${({ theme: theme })=>theme.color.pink}80;
    border-radius: 12px;
    border: 2px solid transparent;
  }
`;




var $9nZCP = parcelRequire("9nZCP");
var $48090fca70e3183a$exports = {};


var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");
var $b38ef1abffe94323$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $b38ef1abffe94323$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $b38ef1abffe94323$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $b38ef1abffe94323$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $b38ef1abffe94323$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $b38ef1abffe94323$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $b38ef1abffe94323$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $b38ef1abffe94323$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $b38ef1abffe94323$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $b38ef1abffe94323$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $b38ef1abffe94323$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b38ef1abffe94323$var$root = $b38ef1abffe94323$var$freeGlobal || $b38ef1abffe94323$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $b38ef1abffe94323$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b38ef1abffe94323$var$objectToString = $b38ef1abffe94323$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b38ef1abffe94323$var$nativeMax = Math.max, $b38ef1abffe94323$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $b38ef1abffe94323$var$now = function() {
    return $b38ef1abffe94323$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $b38ef1abffe94323$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($b38ef1abffe94323$var$FUNC_ERROR_TEXT);
    wait = $b38ef1abffe94323$var$toNumber(wait) || 0;
    if ($b38ef1abffe94323$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $b38ef1abffe94323$var$nativeMax($b38ef1abffe94323$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $b38ef1abffe94323$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $b38ef1abffe94323$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($b38ef1abffe94323$var$now());
    }
    function debounced() {
        var time = $b38ef1abffe94323$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b38ef1abffe94323$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b38ef1abffe94323$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b38ef1abffe94323$var$isSymbol(value) {
    return typeof value == 'symbol' || $b38ef1abffe94323$var$isObjectLike(value) && $b38ef1abffe94323$var$objectToString.call(value) == $b38ef1abffe94323$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $b38ef1abffe94323$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($b38ef1abffe94323$var$isSymbol(value)) return $b38ef1abffe94323$var$NAN;
    if ($b38ef1abffe94323$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $b38ef1abffe94323$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($b38ef1abffe94323$var$reTrim, '');
    var isBinary = $b38ef1abffe94323$var$reIsBinary.test(value);
    return isBinary || $b38ef1abffe94323$var$reIsOctal.test(value) ? $b38ef1abffe94323$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $b38ef1abffe94323$var$reIsBadHex.test(value) ? $b38ef1abffe94323$var$NAN : +value;
}
$b38ef1abffe94323$exports = $b38ef1abffe94323$var$debounce;


// src/useBoolean/useBoolean.ts
function $4e705cd33f69a99b$export$c32275ecbd12948f(defaultValue) {
    const [value, setValue] = (0, $9nZCP.useState)(!!defaultValue);
    const setTrue = (0, $9nZCP.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $9nZCP.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $9nZCP.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $4e705cd33f69a99b$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $9nZCP.useLayoutEffect) : (0, $9nZCP.useEffect);
// src/useEventListener/useEventListener.ts
function $4e705cd33f69a99b$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $9nZCP.useRef)(handler);
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $9nZCP.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $4e705cd33f69a99b$export$5139c081cbc6c8bb(handler) {
    $4e705cd33f69a99b$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $4e705cd33f69a99b$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $9nZCP.useState)(null);
    const copy = (0, $9nZCP.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $4e705cd33f69a99b$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $9nZCP.useState)(initialValue ?? 0);
    const increment = ()=>{
        setCount((x)=>x + 1);
    };
    const decrement = ()=>{
        setCount((x)=>x - 1);
    };
    const reset = ()=>{
        setCount(initialValue ?? 0);
    };
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $4e705cd33f69a99b$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $9nZCP.useRef)(callback);
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $9nZCP.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $4e705cd33f69a99b$export$8103f7eb37e19f7b(countdownOptions) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ("seconds" in countdownOptions) {
        console.warn("[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.");
        isDeprecated = true;
        countStart = countdownOptions.seconds;
        intervalMs = countdownOptions.interval;
        isIncrement = countdownOptions.isIncrement;
    } else ({ countStart: countStart, intervalMs: intervalMs, isIncrement: isIncrement, countStop: countStop } = countdownOptions);
    intervalMs = intervalMs ?? 1e3;
    isIncrement = isIncrement ?? false;
    countStop = countStop ?? 0;
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $4e705cd33f69a99b$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $4e705cd33f69a99b$export$c32275ecbd12948f(false);
    const resetCountdown = ()=>{
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = (0, $9nZCP.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $4e705cd33f69a99b$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated ? [
        count,
        {
            start: startCountdown,
            stop: stopCountdown,
            reset: resetCountdown
        }
    ] : [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $4e705cd33f69a99b$export$ee5b5d04074a389e(fn) {
    const ref = (0, $9nZCP.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $9nZCP.useCallback)((...args)=>ref.current(...args), [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $4e705cd33f69a99b$var$IS_SERVER = typeof window === "undefined";
function $4e705cd33f69a99b$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $9nZCP.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $9nZCP.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $9nZCP.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($4e705cd33f69a99b$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $9nZCP.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $4e705cd33f69a99b$export$ee5b5d04074a389e((value)=>{
        if ($4e705cd33f69a99b$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    (0, $9nZCP.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $9nZCP.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $4e705cd33f69a99b$export$7080b3e976bc91ab("storage", handleStorageChange);
    $4e705cd33f69a99b$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
var $4e705cd33f69a99b$var$IS_SERVER2 = typeof window === "undefined";
function $4e705cd33f69a99b$export$32d5543ab307c01(query, options) {
    const defaultValue = typeof options === "boolean" ? options : (options == null ? void 0 : options.defaultValue) ?? false;
    const initializeWithValue = typeof options === "boolean" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const getMatches = (query2)=>{
        if ($4e705cd33f69a99b$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $9nZCP.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $4e705cd33f69a99b$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $4e705cd33f69a99b$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $4e705cd33f69a99b$export$4673cbff94e146e2(options, localStorageKeyProps = $4e705cd33f69a99b$var$LOCAL_STORAGE_KEY) {
    const counter = (0, $9nZCP.useRef)(0);
    counter.current++;
    const defaultValue = typeof options === "boolean" ? options : options == null ? void 0 : options.defaultValue;
    const localStorageKey = typeof options === "boolean" ? localStorageKeyProps ?? $4e705cd33f69a99b$var$LOCAL_STORAGE_KEY : (options == null ? void 0 : options.localStorageKey) ?? $4e705cd33f69a99b$var$LOCAL_STORAGE_KEY;
    const initializeWithValue = typeof options === "boolean" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const isDarkOS = $4e705cd33f69a99b$export$32d5543ab307c01($4e705cd33f69a99b$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $4e705cd33f69a99b$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $4e705cd33f69a99b$export$21805fee57372823(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $9nZCP.useState)(value);
    (0, $9nZCP.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay ?? 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
function $4e705cd33f69a99b$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $9nZCP.useRef)(func);
    funcRef.current = func;
    (0, $9nZCP.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $4e705cd33f69a99b$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $9nZCP.useRef)();
    $4e705cd33f69a99b$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $9nZCP.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($b38ef1abffe94323$exports)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $9nZCP.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($b38ef1abffe94323$exports)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $4e705cd33f69a99b$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $9nZCP.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $9nZCP.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $4e705cd33f69a99b$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $4e705cd33f69a99b$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $9nZCP.useRef)(null);
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $4e705cd33f69a99b$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $4e705cd33f69a99b$export$b558662bb0641046(effect) {
    (0, $9nZCP.useEffect)(effect, []);
}
function $4e705cd33f69a99b$export$2b86bedf890eab8(options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const [ref, setRef] = (0, $9nZCP.useState)(null);
    const readValue = (0, $9nZCP.useCallback)(()=>{
        return {
            width: (ref == null ? void 0 : ref.offsetWidth) ?? void 0,
            height: (ref == null ? void 0 : ref.offsetHeight) ?? void 0
        };
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    const [size, setSize] = (0, $9nZCP.useState)(()=>{
        if (initializeWithValue) return readValue();
        return {
            width: void 0,
            height: void 0
        };
    });
    const handleSize = (0, $9nZCP.useCallback)(()=>{
        setSize(readValue());
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    $4e705cd33f69a99b$export$7080b3e976bc91ab("resize", handleSize);
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        handleSize();
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    const result = [
        setRef,
        size
    ];
    result.ref = result[0];
    result.width = size.width;
    result.height = size.height;
    return result;
}
function $4e705cd33f69a99b$export$d852f5f778460fa4(url, options) {
    const cache = (0, $9nZCP.useRef)({});
    const cancelRequest = (0, $9nZCP.useRef)(false);
    const initialState = {
        error: void 0,
        data: void 0
    };
    const fetchReducer = (state2, action)=>{
        switch(action.type){
            case "loading":
                return {
                    ...initialState
                };
            case "fetched":
                return {
                    ...initialState,
                    data: action.payload
                };
            case "error":
                return {
                    ...initialState,
                    error: action.payload
                };
            default:
                return state2;
        }
    };
    const [state, dispatch] = (0, $9nZCP.useReducer)(fetchReducer, initialState);
    (0, $9nZCP.useEffect)(()=>{
        if (!url) return;
        cancelRequest.current = false;
        const fetchData = async ()=>{
            dispatch({
                type: "loading"
            });
            const currentCache = cache.current[url];
            if (currentCache) {
                dispatch({
                    type: "fetched",
                    payload: currentCache
                });
                return;
            }
            try {
                const response = await fetch(url, options);
                if (!response.ok) throw new Error(response.statusText);
                const data = await response.json();
                cache.current[url] = data;
                if (cancelRequest.current) return;
                dispatch({
                    type: "fetched",
                    payload: data
                });
            } catch (error) {
                if (cancelRequest.current) return;
                dispatch({
                    type: "error",
                    payload: error
                });
            }
        };
        fetchData();
        return ()=>{
            cancelRequest.current = true;
        };
    }, [
        url
    ]);
    return state;
}
function $4e705cd33f69a99b$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $9nZCP.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $4e705cd33f69a99b$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $4e705cd33f69a99b$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $4e705cd33f69a99b$export$c822f44b98c8bbf2() {
    const [isLoaded, setIsLoaded] = (0, $9nZCP.useState)(false);
    const handleImageOnLoad = ()=>{
        setIsLoaded(true);
    };
    const css = {
        // Thumbnail style.
        thumbnail: {
            visibility: isLoaded ? "hidden" : "visible",
            filter: "blur(8px)",
            transition: "visibility 0ms ease-out 500ms"
        },
        // Full image style.
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 500ms ease-in 0ms"
        }
    };
    return {
        handleImageOnLoad: handleImageOnLoad,
        css: css
    };
}
function $4e705cd33f69a99b$export$a7395f9832c00176(optionsOrLegacyRef, legacyOptions) {
    var _a;
    const isLegacySignature = "current" in optionsOrLegacyRef;
    const options = isLegacySignature ? legacyOptions : optionsOrLegacyRef;
    const { threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false } = options ?? {};
    const [newRef, setNewRef] = (0, $9nZCP.useState)(null);
    const ref = isLegacySignature ? optionsOrLegacyRef.current : newRef;
    const [state, setState] = (0, $9nZCP.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $9nZCP.useRef)();
    callbackRef.current = options == null ? void 0 : options.onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $9nZCP.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $9nZCP.useRef)(null);
    (0, $9nZCP.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    if (isLegacySignature) return state.entry;
    const result = [
        setNewRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $4e705cd33f69a99b$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $9nZCP.useState)(false);
    (0, $9nZCP.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $4e705cd33f69a99b$export$5964c316e853650f() {
    const isFirst = (0, $9nZCP.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
function $4e705cd33f69a99b$export$80c2a3957bcb42ea() {
    const isMounted = (0, $9nZCP.useRef)(false);
    (0, $9nZCP.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $9nZCP.useCallback)(()=>isMounted.current, []);
}
function $4e705cd33f69a99b$export$314db5846aaeae6e(initialLocked = false, rootId = "___gatsby") {
    const [locked, setLocked] = (0, $9nZCP.useState)(initialLocked);
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        if (!locked) return;
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = "hidden";
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) document.body.style.paddingRight = `${scrollBarWidth}px`;
        return ()=>{
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) document.body.style.paddingRight = originalPaddingRight;
        };
    }, [
        locked
    ]);
    (0, $9nZCP.useEffect)(()=>{
        if (locked !== initialLocked) setLocked(initialLocked);
    }, [
        initialLocked
    ]);
    return [
        locked,
        setLocked
    ];
}
function $4e705cd33f69a99b$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $9nZCP.useState)(new Map(initialState));
    const actions = {
        set: (0, $9nZCP.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $9nZCP.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $9nZCP.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $9nZCP.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $4e705cd33f69a99b$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown") {
    $4e705cd33f69a99b$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    });
}
var $4e705cd33f69a99b$var$IS_SERVER3 = typeof window === "undefined";
function $4e705cd33f69a99b$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($4e705cd33f69a99b$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $9nZCP.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $9nZCP.useCallback)(()=>{
        if ($4e705cd33f69a99b$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $9nZCP.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $9nZCP.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $9nZCP.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $4e705cd33f69a99b$export$7080b3e976bc91ab("storage", handleStorageChange);
    $4e705cd33f69a99b$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $4e705cd33f69a99b$var$initialSize = {
    width: void 0,
    height: void 0
};
function $4e705cd33f69a99b$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $9nZCP.useState)($4e705cd33f69a99b$var$initialSize);
    const isMounted = $4e705cd33f69a99b$export$80c2a3957bcb42ea();
    const previousSize = (0, $9nZCP.useRef)({
        ...$4e705cd33f69a99b$var$initialSize
    });
    const onResize = (0, $9nZCP.useRef)(void 0);
    onResize.current = options == null ? void 0 : options.onResize;
    (0, $9nZCP.useEffect)(()=>{
        if (!(ref == null ? void 0 : ref.current)) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $4e705cd33f69a99b$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $4e705cd33f69a99b$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize == null ? void 0 : onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $4e705cd33f69a99b$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $4e705cd33f69a99b$var$IS_SERVER4 = typeof window === "undefined";
function $4e705cd33f69a99b$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($4e705cd33f69a99b$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($4e705cd33f69a99b$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $9nZCP.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $4e705cd33f69a99b$export$40ae01be0011c1e6(setScreen, options == null ? void 0 : options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = (options == null ? void 0 : options.debounceDelay) ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $4e705cd33f69a99b$export$7080b3e976bc91ab("resize", handleSize);
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $4e705cd33f69a99b$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $4e705cd33f69a99b$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $4e705cd33f69a99b$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $9nZCP.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $4e705cd33f69a99b$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $9nZCP.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $4e705cd33f69a99b$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $4e705cd33f69a99b$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $4e705cd33f69a99b$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $4e705cd33f69a99b$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $4e705cd33f69a99b$var$IS_SERVER5 = typeof window === "undefined";
function $4e705cd33f69a99b$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $9nZCP.useState)(false);
    const target = (0, $9nZCP.useRef)(null);
    const originalStyle = (0, $9nZCP.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        if ($4e705cd33f69a99b$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $4e705cd33f69a99b$var$IS_SERVER6 = typeof window === "undefined";
function $4e705cd33f69a99b$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $9nZCP.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $9nZCP.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $9nZCP.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($4e705cd33f69a99b$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $9nZCP.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $4e705cd33f69a99b$export$ee5b5d04074a389e((value)=>{
        if ($4e705cd33f69a99b$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    (0, $9nZCP.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $9nZCP.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $4e705cd33f69a99b$export$7080b3e976bc91ab("storage", handleStorageChange);
    $4e705cd33f69a99b$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
// src/useSsr/useSsr.ts
function $4e705cd33f69a99b$export$f4eafc809f5e6ccc() {
    var _a;
    const isDOM = // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    typeof window !== "undefined" && !!((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.documentElement);
    return {
        isBrowser: isDOM,
        isServer: !isDOM
    };
}
function $4e705cd33f69a99b$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $9nZCP.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $9nZCP.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $9nZCP.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $9nZCP.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $9nZCP.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $4e705cd33f69a99b$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $4e705cd33f69a99b$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $4e705cd33f69a99b$export$ec561688e440eda6(options) {
    const defaultValue = typeof options === "string" ? "system" : (options == null ? void 0 : options.defaultValue) ?? "system";
    const localStorageKey = typeof options === "string" ? options : (options == null ? void 0 : options.localStorageKey) ?? $4e705cd33f69a99b$var$LOCAL_STORAGE_KEY2;
    const initializeWithValue = typeof options === "string" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const isDarkOS = $4e705cd33f69a99b$export$32d5543ab307c01($4e705cd33f69a99b$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $4e705cd33f69a99b$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $4e705cd33f69a99b$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $9nZCP.useRef)(callback);
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $9nZCP.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $4e705cd33f69a99b$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $9nZCP.useState)(!!defaultValue);
    const toggle = (0, $9nZCP.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
function $4e705cd33f69a99b$export$496315a1608d9602(effect, deps) {
    const isFirst = $4e705cd33f69a99b$export$5964c316e853650f();
    (0, $9nZCP.useEffect)(()=>{
        if (!isFirst) return effect();
    }, deps);
}
var $4e705cd33f69a99b$var$IS_SERVER7 = typeof window === "undefined";
function $4e705cd33f69a99b$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($4e705cd33f69a99b$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $9nZCP.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $4e705cd33f69a99b$export$40ae01be0011c1e6(setWindowSize, options == null ? void 0 : options.debounceDelay);
    function handleSize() {
        const setSize = (options == null ? void 0 : options.debounceDelay) ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $4e705cd33f69a99b$export$7080b3e976bc91ab("resize", handleSize);
    $4e705cd33f69a99b$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}


var $b76fad9a3dd6491d$exports = {};

$parcel$defineInteropFlag($b76fad9a3dd6491d$exports);

$parcel$export($b76fad9a3dd6491d$exports, "default", function () { return $b76fad9a3dd6491d$export$2e2bcd8739ae039; });
/**
 * simplebar-react - v2.4.3
 * React component for SimpleBar
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat
 * Under MIT License
 */ 
var $9nZCP = parcelRequire("9nZCP");
var $0287d6dd1c5d0193$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0287d6dd1c5d0193$var$ReactIs, $0287d6dd1c5d0193$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$0287d6dd1c5d0193$exports = (parcelRequire("hFdkQ"))();


/**
 * SimpleBar.js - v5.3.9
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ 'use strict';
var $621e6bc7a2f56e42$exports = {};
'use strict';
var $f73c1cbf36add1e3$exports = {};
'use strict';
var $f73c1cbf36add1e3$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$f73c1cbf36add1e3$exports = // eslint-disable-next-line es/no-global-this -- safe
$f73c1cbf36add1e3$var$check(typeof globalThis == 'object' && globalThis) || $f73c1cbf36add1e3$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$f73c1cbf36add1e3$var$check(typeof self == 'object' && self) || $f73c1cbf36add1e3$var$check(typeof $parcel$global == 'object' && $parcel$global) || $f73c1cbf36add1e3$var$check(typeof $f73c1cbf36add1e3$exports == 'object' && $f73c1cbf36add1e3$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $5dee88fe230545da$export$2d1720544b23b823;
'use strict';
var $a934004253d25a42$exports = {};
'use strict';
var $1c0f139a1a463ce1$exports = {};
'use strict';
$1c0f139a1a463ce1$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$a934004253d25a42$exports = !$1c0f139a1a463ce1$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $ba3e81ca5de34305$exports = {};
'use strict';
var $13cf557f31fcb3db$exports = {};
'use strict';

$13cf557f31fcb3db$exports = !$1c0f139a1a463ce1$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $ba3e81ca5de34305$var$call = Function.prototype.call;
$ba3e81ca5de34305$exports = $13cf557f31fcb3db$exports ? $ba3e81ca5de34305$var$call.bind($ba3e81ca5de34305$var$call) : function() {
    return $ba3e81ca5de34305$var$call.apply($ba3e81ca5de34305$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $37435e8ffd2f28b9$export$2d1720544b23b823;
'use strict';
var $37435e8ffd2f28b9$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $37435e8ffd2f28b9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $37435e8ffd2f28b9$var$NASHORN_BUG = $37435e8ffd2f28b9$var$getOwnPropertyDescriptor && !$37435e8ffd2f28b9$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$37435e8ffd2f28b9$export$2d1720544b23b823 = $37435e8ffd2f28b9$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $37435e8ffd2f28b9$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $37435e8ffd2f28b9$var$$propertyIsEnumerable;


var $7f001fc6b2d5740c$exports = {};
'use strict';
$7f001fc6b2d5740c$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $08ccc8de002b7975$exports = {};
'use strict';
var $9d1a1577a6ed79d1$exports = {};
'use strict';
var $86d27fcf3ddb374a$exports = {};
'use strict';

var $86d27fcf3ddb374a$var$FunctionPrototype = Function.prototype;
var $86d27fcf3ddb374a$var$call = $86d27fcf3ddb374a$var$FunctionPrototype.call;
var $86d27fcf3ddb374a$var$uncurryThisWithBind = $13cf557f31fcb3db$exports && $86d27fcf3ddb374a$var$FunctionPrototype.bind.bind($86d27fcf3ddb374a$var$call, $86d27fcf3ddb374a$var$call);
$86d27fcf3ddb374a$exports = $13cf557f31fcb3db$exports ? $86d27fcf3ddb374a$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $86d27fcf3ddb374a$var$call.apply(fn, arguments);
    };
};



var $f65b6a6904086b61$exports = {};
'use strict';

var $f65b6a6904086b61$var$toString = $86d27fcf3ddb374a$exports({}.toString);
var $f65b6a6904086b61$var$stringSlice = $86d27fcf3ddb374a$exports(''.slice);
$f65b6a6904086b61$exports = function(it) {
    return $f65b6a6904086b61$var$stringSlice($f65b6a6904086b61$var$toString(it), 8, -1);
};


var $9d1a1577a6ed79d1$var$$Object = Object;
var $9d1a1577a6ed79d1$var$split = $86d27fcf3ddb374a$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$9d1a1577a6ed79d1$exports = $1c0f139a1a463ce1$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$9d1a1577a6ed79d1$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $f65b6a6904086b61$exports(it) === 'String' ? $9d1a1577a6ed79d1$var$split(it, '') : $9d1a1577a6ed79d1$var$$Object(it);
} : $9d1a1577a6ed79d1$var$$Object;


var $ce17aed0e5032df3$exports = {};
'use strict';
var $896d3aa83f9594d3$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$896d3aa83f9594d3$exports = function(it) {
    return it === null || it === undefined;
};


var $ce17aed0e5032df3$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$ce17aed0e5032df3$exports = function(it) {
    if ($896d3aa83f9594d3$exports(it)) throw new $ce17aed0e5032df3$var$$TypeError("Can't call method on " + it);
    return it;
};


$08ccc8de002b7975$exports = function(it) {
    return $9d1a1577a6ed79d1$exports($ce17aed0e5032df3$exports(it));
};


var $aa87b438f737b110$exports = {};
'use strict';
var $f834c60b1a0b755b$exports = {};
'use strict';

var $abc01766c6ffc0a1$exports = {};
'use strict';
var $da9965769ab8d492$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $da9965769ab8d492$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$da9965769ab8d492$exports = typeof $da9965769ab8d492$var$documentAll == 'undefined' && $da9965769ab8d492$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $da9965769ab8d492$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$abc01766c6ffc0a1$exports = function(it) {
    return typeof it == 'object' ? it !== null : $da9965769ab8d492$exports(it);
};


var $5df20ec038ad0f10$exports = {};
'use strict';
var $18c5ef8b38a03108$exports = {};
'use strict';


var $18c5ef8b38a03108$var$aFunction = function(argument) {
    return $da9965769ab8d492$exports(argument) ? argument : undefined;
};
$18c5ef8b38a03108$exports = function(namespace, method) {
    return arguments.length < 2 ? $18c5ef8b38a03108$var$aFunction($f73c1cbf36add1e3$exports[namespace]) : $f73c1cbf36add1e3$exports[namespace] && $f73c1cbf36add1e3$exports[namespace][method];
};



var $d5379fc5818962a4$exports = {};
'use strict';

$d5379fc5818962a4$exports = $86d27fcf3ddb374a$exports({}.isPrototypeOf);


var $08fd740cb2cfbfcb$exports = {};
'use strict';
var $371337e1b5a91d41$exports = {};
'use strict';
var $76342eacb009e653$exports = {};
'use strict';

var $7f1a0e28c2927ca0$exports = {};
'use strict';

var $7f1a0e28c2927ca0$var$navigator = $f73c1cbf36add1e3$exports.navigator;
var $7f1a0e28c2927ca0$var$userAgent = $7f1a0e28c2927ca0$var$navigator && $7f1a0e28c2927ca0$var$navigator.userAgent;
$7f1a0e28c2927ca0$exports = $7f1a0e28c2927ca0$var$userAgent ? String($7f1a0e28c2927ca0$var$userAgent) : '';


var $76342eacb009e653$var$process = $f73c1cbf36add1e3$exports.process;
var $76342eacb009e653$var$Deno = $f73c1cbf36add1e3$exports.Deno;
var $76342eacb009e653$var$versions = $76342eacb009e653$var$process && $76342eacb009e653$var$process.versions || $76342eacb009e653$var$Deno && $76342eacb009e653$var$Deno.version;
var $76342eacb009e653$var$v8 = $76342eacb009e653$var$versions && $76342eacb009e653$var$versions.v8;
var $76342eacb009e653$var$match, $76342eacb009e653$var$version;
if ($76342eacb009e653$var$v8) {
    $76342eacb009e653$var$match = $76342eacb009e653$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $76342eacb009e653$var$version = $76342eacb009e653$var$match[0] > 0 && $76342eacb009e653$var$match[0] < 4 ? 1 : +($76342eacb009e653$var$match[0] + $76342eacb009e653$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$76342eacb009e653$var$version && $7f1a0e28c2927ca0$exports) {
    $76342eacb009e653$var$match = $7f1a0e28c2927ca0$exports.match(/Edge\/(\d+)/);
    if (!$76342eacb009e653$var$match || $76342eacb009e653$var$match[1] >= 74) {
        $76342eacb009e653$var$match = $7f1a0e28c2927ca0$exports.match(/Chrome\/(\d+)/);
        if ($76342eacb009e653$var$match) $76342eacb009e653$var$version = +$76342eacb009e653$var$match[1];
    }
}
$76342eacb009e653$exports = $76342eacb009e653$var$version;




var $371337e1b5a91d41$var$$String = $f73c1cbf36add1e3$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$371337e1b5a91d41$exports = !!Object.getOwnPropertySymbols && !$1c0f139a1a463ce1$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$371337e1b5a91d41$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $76342eacb009e653$exports && $76342eacb009e653$exports < 41;
});


$08fd740cb2cfbfcb$exports = $371337e1b5a91d41$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $5df20ec038ad0f10$var$$Object = Object;
$5df20ec038ad0f10$exports = $08fd740cb2cfbfcb$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $18c5ef8b38a03108$exports('Symbol');
    return $da9965769ab8d492$exports($Symbol) && $d5379fc5818962a4$exports($Symbol.prototype, $5df20ec038ad0f10$var$$Object(it));
};


var $ea805a34e9f0856a$exports = {};
'use strict';
var $a339c863cff407d1$exports = {};
'use strict';

var $3ad1d00e209ff694$exports = {};
'use strict';
var $3ad1d00e209ff694$var$$String = String;
$3ad1d00e209ff694$exports = function(argument) {
    try {
        return $3ad1d00e209ff694$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $a339c863cff407d1$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$a339c863cff407d1$exports = function(argument) {
    if ($da9965769ab8d492$exports(argument)) return argument;
    throw new $a339c863cff407d1$var$$TypeError($3ad1d00e209ff694$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$ea805a34e9f0856a$exports = function(V, P) {
    var func = V[P];
    return $896d3aa83f9594d3$exports(func) ? undefined : $a339c863cff407d1$exports(func);
};


var $7320fa2e6fa65726$exports = {};
'use strict';



var $7320fa2e6fa65726$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$7320fa2e6fa65726$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $da9965769ab8d492$exports(fn = input.toString) && !$abc01766c6ffc0a1$exports(val = $ba3e81ca5de34305$exports(fn, input))) return val;
    if ($da9965769ab8d492$exports(fn = input.valueOf) && !$abc01766c6ffc0a1$exports(val = $ba3e81ca5de34305$exports(fn, input))) return val;
    if (pref !== 'string' && $da9965769ab8d492$exports(fn = input.toString) && !$abc01766c6ffc0a1$exports(val = $ba3e81ca5de34305$exports(fn, input))) return val;
    throw new $7320fa2e6fa65726$var$$TypeError("Can't convert object to primitive value");
};


var $06b7b285e3a7068a$exports = {};
'use strict';

var $9b42448d053bd3c4$exports = {};
'use strict';
var $b1111eb01f23fc98$exports = {};
'use strict';
var $8a834a2771c3d77e$exports = {};
'use strict';
$8a834a2771c3d77e$exports = false;



var $85363e39cdbcb0f8$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $85363e39cdbcb0f8$var$defineProperty = Object.defineProperty;
$85363e39cdbcb0f8$exports = function(key, value) {
    try {
        $85363e39cdbcb0f8$var$defineProperty($f73c1cbf36add1e3$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $f73c1cbf36add1e3$exports[key] = value;
    }
    return value;
};


var $b1111eb01f23fc98$var$SHARED = '__core-js_shared__';
var $b1111eb01f23fc98$var$store = $b1111eb01f23fc98$exports = $f73c1cbf36add1e3$exports[$b1111eb01f23fc98$var$SHARED] || $85363e39cdbcb0f8$exports($b1111eb01f23fc98$var$SHARED, {});
($b1111eb01f23fc98$var$store.versions || ($b1111eb01f23fc98$var$store.versions = [])).push({
    version: '3.39.0',
    mode: $8a834a2771c3d77e$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$9b42448d053bd3c4$exports = function(key, value) {
    return $b1111eb01f23fc98$exports[key] || ($b1111eb01f23fc98$exports[key] = value || {});
};


var $9fd86a02d78d2d99$exports = {};
'use strict';

var $c9b4f3ef4a96c778$exports = {};
'use strict';

var $c9b4f3ef4a96c778$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$c9b4f3ef4a96c778$exports = function(argument) {
    return $c9b4f3ef4a96c778$var$$Object($ce17aed0e5032df3$exports(argument));
};


var $9fd86a02d78d2d99$var$hasOwnProperty = $86d27fcf3ddb374a$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$9fd86a02d78d2d99$exports = Object.hasOwn || function hasOwn(it, key) {
    return $9fd86a02d78d2d99$var$hasOwnProperty($c9b4f3ef4a96c778$exports(it), key);
};


var $2e904edd887c2aab$exports = {};
'use strict';

var $2e904edd887c2aab$var$id = 0;
var $2e904edd887c2aab$var$postfix = Math.random();
var $2e904edd887c2aab$var$toString = $86d27fcf3ddb374a$exports(1.0.toString);
$2e904edd887c2aab$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $2e904edd887c2aab$var$toString(++$2e904edd887c2aab$var$id + $2e904edd887c2aab$var$postfix, 36);
};




var $06b7b285e3a7068a$var$Symbol = $f73c1cbf36add1e3$exports.Symbol;
var $06b7b285e3a7068a$var$WellKnownSymbolsStore = $9b42448d053bd3c4$exports('wks');
var $06b7b285e3a7068a$var$createWellKnownSymbol = $08fd740cb2cfbfcb$exports ? $06b7b285e3a7068a$var$Symbol['for'] || $06b7b285e3a7068a$var$Symbol : $06b7b285e3a7068a$var$Symbol && $06b7b285e3a7068a$var$Symbol.withoutSetter || $2e904edd887c2aab$exports;
$06b7b285e3a7068a$exports = function(name) {
    if (!$9fd86a02d78d2d99$exports($06b7b285e3a7068a$var$WellKnownSymbolsStore, name)) $06b7b285e3a7068a$var$WellKnownSymbolsStore[name] = $371337e1b5a91d41$exports && $9fd86a02d78d2d99$exports($06b7b285e3a7068a$var$Symbol, name) ? $06b7b285e3a7068a$var$Symbol[name] : $06b7b285e3a7068a$var$createWellKnownSymbol('Symbol.' + name);
    return $06b7b285e3a7068a$var$WellKnownSymbolsStore[name];
};


var $f834c60b1a0b755b$var$$TypeError = TypeError;
var $f834c60b1a0b755b$var$TO_PRIMITIVE = $06b7b285e3a7068a$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$f834c60b1a0b755b$exports = function(input, pref) {
    if (!$abc01766c6ffc0a1$exports(input) || $5df20ec038ad0f10$exports(input)) return input;
    var exoticToPrim = $ea805a34e9f0856a$exports(input, $f834c60b1a0b755b$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $ba3e81ca5de34305$exports(exoticToPrim, input, pref);
        if (!$abc01766c6ffc0a1$exports(result) || $5df20ec038ad0f10$exports(result)) return result;
        throw new $f834c60b1a0b755b$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $7320fa2e6fa65726$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$aa87b438f737b110$exports = function(argument) {
    var key = $f834c60b1a0b755b$exports(argument, 'string');
    return $5df20ec038ad0f10$exports(key) ? key : key + '';
};



var $a4f0c82f3dc91231$exports = {};
'use strict';


var $6a21b3c3b047179b$exports = {};
'use strict';


var $6a21b3c3b047179b$var$document = $f73c1cbf36add1e3$exports.document;
// typeof document.createElement is 'object' in old IE
var $6a21b3c3b047179b$var$EXISTS = $abc01766c6ffc0a1$exports($6a21b3c3b047179b$var$document) && $abc01766c6ffc0a1$exports($6a21b3c3b047179b$var$document.createElement);
$6a21b3c3b047179b$exports = function(it) {
    return $6a21b3c3b047179b$var$EXISTS ? $6a21b3c3b047179b$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$a4f0c82f3dc91231$exports = !$a934004253d25a42$exports && !$1c0f139a1a463ce1$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($6a21b3c3b047179b$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $5dee88fe230545da$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$5dee88fe230545da$export$2d1720544b23b823 = $a934004253d25a42$exports ? $5dee88fe230545da$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $08ccc8de002b7975$exports(O);
    P = $aa87b438f737b110$exports(P);
    if ($a4f0c82f3dc91231$exports) try {
        return $5dee88fe230545da$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($9fd86a02d78d2d99$exports(O, P)) return $7f001fc6b2d5740c$exports(!$ba3e81ca5de34305$exports($37435e8ffd2f28b9$export$2d1720544b23b823, O, P), O[P]);
};


var $621e6bc7a2f56e42$require$getOwnPropertyDescriptor = $5dee88fe230545da$export$2d1720544b23b823;
var $3d5a463be44ffeea$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $96bd28438ee2eee5$export$2d1720544b23b823;
'use strict';


var $99f023d30bb6ec12$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$99f023d30bb6ec12$exports = $a934004253d25a42$exports && $1c0f139a1a463ce1$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $c53804bbcc663539$exports = {};
'use strict';

var $c53804bbcc663539$var$$String = String;
var $c53804bbcc663539$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c53804bbcc663539$exports = function(argument) {
    if ($abc01766c6ffc0a1$exports(argument)) return argument;
    throw new $c53804bbcc663539$var$$TypeError($c53804bbcc663539$var$$String(argument) + ' is not an object');
};



var $96bd28438ee2eee5$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $96bd28438ee2eee5$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $96bd28438ee2eee5$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $96bd28438ee2eee5$var$ENUMERABLE = 'enumerable';
var $96bd28438ee2eee5$var$CONFIGURABLE = 'configurable';
var $96bd28438ee2eee5$var$WRITABLE = 'writable';
$96bd28438ee2eee5$export$2d1720544b23b823 = $a934004253d25a42$exports ? $99f023d30bb6ec12$exports ? function defineProperty(O, P, Attributes) {
    $c53804bbcc663539$exports(O);
    P = $aa87b438f737b110$exports(P);
    $c53804bbcc663539$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $96bd28438ee2eee5$var$WRITABLE in Attributes && !Attributes[$96bd28438ee2eee5$var$WRITABLE]) {
        var current = $96bd28438ee2eee5$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$96bd28438ee2eee5$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $96bd28438ee2eee5$var$CONFIGURABLE in Attributes ? Attributes[$96bd28438ee2eee5$var$CONFIGURABLE] : current[$96bd28438ee2eee5$var$CONFIGURABLE],
                enumerable: $96bd28438ee2eee5$var$ENUMERABLE in Attributes ? Attributes[$96bd28438ee2eee5$var$ENUMERABLE] : current[$96bd28438ee2eee5$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $96bd28438ee2eee5$var$$defineProperty(O, P, Attributes);
} : $96bd28438ee2eee5$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c53804bbcc663539$exports(O);
    P = $aa87b438f737b110$exports(P);
    $c53804bbcc663539$exports(Attributes);
    if ($a4f0c82f3dc91231$exports) try {
        return $96bd28438ee2eee5$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $96bd28438ee2eee5$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$3d5a463be44ffeea$exports = $a934004253d25a42$exports ? function(object, key, value) {
    return $96bd28438ee2eee5$export$2d1720544b23b823(object, key, $7f001fc6b2d5740c$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $cc8a5761541cd35d$exports = {};
'use strict';


var $157fbe5a4073e8a8$exports = {};
'use strict';





var $b82122a7f3a0fd21$exports = {};
'use strict';


var $b82122a7f3a0fd21$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $b82122a7f3a0fd21$var$getDescriptor = $a934004253d25a42$exports && Object.getOwnPropertyDescriptor;
var $b82122a7f3a0fd21$var$EXISTS = $9fd86a02d78d2d99$exports($b82122a7f3a0fd21$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $b82122a7f3a0fd21$var$PROPER = $b82122a7f3a0fd21$var$EXISTS && (function something() {}).name === 'something';
var $b82122a7f3a0fd21$var$CONFIGURABLE = $b82122a7f3a0fd21$var$EXISTS && (!$a934004253d25a42$exports || $a934004253d25a42$exports && $b82122a7f3a0fd21$var$getDescriptor($b82122a7f3a0fd21$var$FunctionPrototype, 'name').configurable);
$b82122a7f3a0fd21$exports = {
    EXISTS: $b82122a7f3a0fd21$var$EXISTS,
    PROPER: $b82122a7f3a0fd21$var$PROPER,
    CONFIGURABLE: $b82122a7f3a0fd21$var$CONFIGURABLE
};


var $157fbe5a4073e8a8$require$CONFIGURABLE_FUNCTION_NAME = $b82122a7f3a0fd21$exports.CONFIGURABLE;
var $33a7bcb147d04741$exports = {};
'use strict';



var $33a7bcb147d04741$var$functionToString = $86d27fcf3ddb374a$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$da9965769ab8d492$exports($b1111eb01f23fc98$exports.inspectSource)) $b1111eb01f23fc98$exports.inspectSource = function(it) {
    return $33a7bcb147d04741$var$functionToString(it);
};
$33a7bcb147d04741$exports = $b1111eb01f23fc98$exports.inspectSource;


var $033d4cca21ca5361$exports = {};
'use strict';
var $d5d26662890f9fd9$exports = {};
'use strict';


var $d5d26662890f9fd9$var$WeakMap = $f73c1cbf36add1e3$exports.WeakMap;
$d5d26662890f9fd9$exports = $da9965769ab8d492$exports($d5d26662890f9fd9$var$WeakMap) && /native code/.test(String($d5d26662890f9fd9$var$WeakMap));







var $8bce327c7c566c42$exports = {};
'use strict';


var $8bce327c7c566c42$var$keys = $9b42448d053bd3c4$exports('keys');
$8bce327c7c566c42$exports = function(key) {
    return $8bce327c7c566c42$var$keys[key] || ($8bce327c7c566c42$var$keys[key] = $2e904edd887c2aab$exports(key));
};


var $c134b99a007ffe97$exports = {};
'use strict';
$c134b99a007ffe97$exports = {};


var $033d4cca21ca5361$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $033d4cca21ca5361$var$TypeError = $f73c1cbf36add1e3$exports.TypeError;
var $033d4cca21ca5361$var$WeakMap = $f73c1cbf36add1e3$exports.WeakMap;
var $033d4cca21ca5361$var$set, $033d4cca21ca5361$var$get, $033d4cca21ca5361$var$has;
var $033d4cca21ca5361$var$enforce = function(it) {
    return $033d4cca21ca5361$var$has(it) ? $033d4cca21ca5361$var$get(it) : $033d4cca21ca5361$var$set(it, {});
};
var $033d4cca21ca5361$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$abc01766c6ffc0a1$exports(it) || (state = $033d4cca21ca5361$var$get(it)).type !== TYPE) throw new $033d4cca21ca5361$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($d5d26662890f9fd9$exports || $b1111eb01f23fc98$exports.state) {
    var $033d4cca21ca5361$var$store = $b1111eb01f23fc98$exports.state || ($b1111eb01f23fc98$exports.state = new $033d4cca21ca5361$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $033d4cca21ca5361$var$store.get = $033d4cca21ca5361$var$store.get;
    $033d4cca21ca5361$var$store.has = $033d4cca21ca5361$var$store.has;
    $033d4cca21ca5361$var$store.set = $033d4cca21ca5361$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $033d4cca21ca5361$var$set = function(it, metadata) {
        if ($033d4cca21ca5361$var$store.has(it)) throw new $033d4cca21ca5361$var$TypeError($033d4cca21ca5361$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $033d4cca21ca5361$var$store.set(it, metadata);
        return metadata;
    };
    $033d4cca21ca5361$var$get = function(it) {
        return $033d4cca21ca5361$var$store.get(it) || {};
    };
    $033d4cca21ca5361$var$has = function(it) {
        return $033d4cca21ca5361$var$store.has(it);
    };
} else {
    var $033d4cca21ca5361$var$STATE = $8bce327c7c566c42$exports('state');
    $c134b99a007ffe97$exports[$033d4cca21ca5361$var$STATE] = true;
    $033d4cca21ca5361$var$set = function(it, metadata) {
        if ($9fd86a02d78d2d99$exports(it, $033d4cca21ca5361$var$STATE)) throw new $033d4cca21ca5361$var$TypeError($033d4cca21ca5361$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3d5a463be44ffeea$exports(it, $033d4cca21ca5361$var$STATE, metadata);
        return metadata;
    };
    $033d4cca21ca5361$var$get = function(it) {
        return $9fd86a02d78d2d99$exports(it, $033d4cca21ca5361$var$STATE) ? it[$033d4cca21ca5361$var$STATE] : {};
    };
    $033d4cca21ca5361$var$has = function(it) {
        return $9fd86a02d78d2d99$exports(it, $033d4cca21ca5361$var$STATE);
    };
}
$033d4cca21ca5361$exports = {
    set: $033d4cca21ca5361$var$set,
    get: $033d4cca21ca5361$var$get,
    has: $033d4cca21ca5361$var$has,
    enforce: $033d4cca21ca5361$var$enforce,
    getterFor: $033d4cca21ca5361$var$getterFor
};


var $157fbe5a4073e8a8$var$enforceInternalState = $033d4cca21ca5361$exports.enforce;
var $157fbe5a4073e8a8$var$getInternalState = $033d4cca21ca5361$exports.get;
var $157fbe5a4073e8a8$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $157fbe5a4073e8a8$var$defineProperty = Object.defineProperty;
var $157fbe5a4073e8a8$var$stringSlice = $86d27fcf3ddb374a$exports(''.slice);
var $157fbe5a4073e8a8$var$replace = $86d27fcf3ddb374a$exports(''.replace);
var $157fbe5a4073e8a8$var$join = $86d27fcf3ddb374a$exports([].join);
var $157fbe5a4073e8a8$var$CONFIGURABLE_LENGTH = $a934004253d25a42$exports && !$1c0f139a1a463ce1$exports(function() {
    return $157fbe5a4073e8a8$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $157fbe5a4073e8a8$var$TEMPLATE = String(String).split('String');
var $157fbe5a4073e8a8$var$makeBuiltIn = $157fbe5a4073e8a8$exports = function(value, name, options) {
    if ($157fbe5a4073e8a8$var$stringSlice($157fbe5a4073e8a8$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $157fbe5a4073e8a8$var$replace($157fbe5a4073e8a8$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$9fd86a02d78d2d99$exports(value, 'name') || $157fbe5a4073e8a8$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($a934004253d25a42$exports) $157fbe5a4073e8a8$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($157fbe5a4073e8a8$var$CONFIGURABLE_LENGTH && options && $9fd86a02d78d2d99$exports(options, 'arity') && value.length !== options.arity) $157fbe5a4073e8a8$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $9fd86a02d78d2d99$exports(options, 'constructor') && options.constructor) {
            if ($a934004253d25a42$exports) $157fbe5a4073e8a8$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $157fbe5a4073e8a8$var$enforceInternalState(value);
    if (!$9fd86a02d78d2d99$exports(state, 'source')) state.source = $157fbe5a4073e8a8$var$join($157fbe5a4073e8a8$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $157fbe5a4073e8a8$var$makeBuiltIn(function toString() {
    return $da9965769ab8d492$exports(this) && $157fbe5a4073e8a8$var$getInternalState(this).source || $33a7bcb147d04741$exports(this);
}, 'toString');



$cc8a5761541cd35d$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($da9965769ab8d492$exports(value)) $157fbe5a4073e8a8$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $85363e39cdbcb0f8$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $96bd28438ee2eee5$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ea8d859a0429cd4d$exports = {};
'use strict';

var $e6692f8ed69dfc75$exports = {};
'use strict';


var $f160027a9f5364b6$exports = {};

$parcel$export($f160027a9f5364b6$exports, "f", function () { return $f160027a9f5364b6$export$2d1720544b23b823; }, function (v) { return $f160027a9f5364b6$export$2d1720544b23b823 = v; });
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $f160027a9f5364b6$export$2d1720544b23b823;
'use strict';
var $9b74ee65fcf3f4aa$exports = {};
'use strict';



var $2d3f31e9ada712f4$exports = {};
'use strict';

var $03a189a753198cb5$exports = {};
'use strict';
var $8abe88bfd140bd58$exports = {};
'use strict';
var $2d58632983b0e2dc$exports = {};
'use strict';
var $2d58632983b0e2dc$var$ceil = Math.ceil;
var $2d58632983b0e2dc$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$2d58632983b0e2dc$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $2d58632983b0e2dc$var$floor : $2d58632983b0e2dc$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$8abe88bfd140bd58$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $2d58632983b0e2dc$exports(number);
};


var $03a189a753198cb5$var$max = Math.max;
var $03a189a753198cb5$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$03a189a753198cb5$exports = function(index, length) {
    var integer = $8abe88bfd140bd58$exports(index);
    return integer < 0 ? $03a189a753198cb5$var$max(integer + length, 0) : $03a189a753198cb5$var$min(integer, length);
};


var $86912fee58c01fd8$exports = {};
'use strict';
var $d6e59aaba77a5f67$exports = {};
'use strict';

var $d6e59aaba77a5f67$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$d6e59aaba77a5f67$exports = function(argument) {
    var len = $8abe88bfd140bd58$exports(argument);
    return len > 0 ? $d6e59aaba77a5f67$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$86912fee58c01fd8$exports = function(obj) {
    return $d6e59aaba77a5f67$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $2d3f31e9ada712f4$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $08ccc8de002b7975$exports($this);
        var length = $86912fee58c01fd8$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $03a189a753198cb5$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$2d3f31e9ada712f4$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $2d3f31e9ada712f4$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $2d3f31e9ada712f4$var$createMethod(false)
};


var $9b74ee65fcf3f4aa$require$indexOf = $2d3f31e9ada712f4$exports.indexOf;

var $9b74ee65fcf3f4aa$var$push = $86d27fcf3ddb374a$exports([].push);
$9b74ee65fcf3f4aa$exports = function(object, names) {
    var O = $08ccc8de002b7975$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$9fd86a02d78d2d99$exports($c134b99a007ffe97$exports, key) && $9fd86a02d78d2d99$exports(O, key) && $9b74ee65fcf3f4aa$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($9fd86a02d78d2d99$exports(O, key = names[i++])) ~$9b74ee65fcf3f4aa$require$indexOf(result, key) || $9b74ee65fcf3f4aa$var$push(result, key);
    return result;
};


var $af891a628637cbe1$exports = {};
'use strict';
// IE8- don't enum bug keys
$af891a628637cbe1$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $f160027a9f5364b6$var$hiddenKeys = $af891a628637cbe1$exports.concat('length', 'prototype');
$f160027a9f5364b6$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $9b74ee65fcf3f4aa$exports(O, $f160027a9f5364b6$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $a58edbe542a39e4c$export$2d1720544b23b823;
'use strict';
$a58edbe542a39e4c$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $e6692f8ed69dfc75$var$concat = $86d27fcf3ddb374a$exports([].concat);
// all object keys, includes non-enumerable and symbols
$e6692f8ed69dfc75$exports = $18c5ef8b38a03108$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $f160027a9f5364b6$export$2d1720544b23b823($c53804bbcc663539$exports(it));
    var getOwnPropertySymbols = $a58edbe542a39e4c$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $e6692f8ed69dfc75$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ea8d859a0429cd4d$exports = function(target, source, exceptions) {
    var keys = $e6692f8ed69dfc75$exports(source);
    var defineProperty = $96bd28438ee2eee5$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $5dee88fe230545da$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$9fd86a02d78d2d99$exports(target, key) && !(exceptions && $9fd86a02d78d2d99$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $32073ab696b14d8d$exports = {};
'use strict';


var $32073ab696b14d8d$var$replacement = /#|\.prototype\./;
var $32073ab696b14d8d$var$isForced = function(feature, detection) {
    var value = $32073ab696b14d8d$var$data[$32073ab696b14d8d$var$normalize(feature)];
    return value === $32073ab696b14d8d$var$POLYFILL ? true : value === $32073ab696b14d8d$var$NATIVE ? false : $da9965769ab8d492$exports(detection) ? $1c0f139a1a463ce1$exports(detection) : !!detection;
};
var $32073ab696b14d8d$var$normalize = $32073ab696b14d8d$var$isForced.normalize = function(string) {
    return String(string).replace($32073ab696b14d8d$var$replacement, '.').toLowerCase();
};
var $32073ab696b14d8d$var$data = $32073ab696b14d8d$var$isForced.data = {};
var $32073ab696b14d8d$var$NATIVE = $32073ab696b14d8d$var$isForced.NATIVE = 'N';
var $32073ab696b14d8d$var$POLYFILL = $32073ab696b14d8d$var$isForced.POLYFILL = 'P';
$32073ab696b14d8d$exports = $32073ab696b14d8d$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $621e6bc7a2f56e42$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $f73c1cbf36add1e3$exports;
    else if (STATIC) target = $f73c1cbf36add1e3$exports[TARGET] || $85363e39cdbcb0f8$exports(TARGET, {});
    else target = $f73c1cbf36add1e3$exports[TARGET] && $f73c1cbf36add1e3$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $621e6bc7a2f56e42$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $32073ab696b14d8d$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ea8d859a0429cd4d$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $3d5a463be44ffeea$exports(sourceProperty, 'sham', true);
        $cc8a5761541cd35d$exports(target, key, sourceProperty, options);
    }
};


var $d0c673959784318b$exports = {};
'use strict';



var $0f08e96df1c6e400$exports = {};
'use strict';
var $28938e7b08ad8d2f$exports = {};
'use strict';
var $0cd6fb43abc87faf$exports = {};
'use strict';

var $0cd6fb43abc87faf$var$TO_STRING_TAG = $06b7b285e3a7068a$exports('toStringTag');
var $0cd6fb43abc87faf$var$test = {};
$0cd6fb43abc87faf$var$test[$0cd6fb43abc87faf$var$TO_STRING_TAG] = 'z';
$0cd6fb43abc87faf$exports = String($0cd6fb43abc87faf$var$test) === '[object z]';





var $28938e7b08ad8d2f$var$TO_STRING_TAG = $06b7b285e3a7068a$exports('toStringTag');
var $28938e7b08ad8d2f$var$$Object = Object;
// ES3 wrong here
var $28938e7b08ad8d2f$var$CORRECT_ARGUMENTS = $f65b6a6904086b61$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $28938e7b08ad8d2f$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$28938e7b08ad8d2f$exports = $0cd6fb43abc87faf$exports ? $f65b6a6904086b61$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $28938e7b08ad8d2f$var$tryGet(O = $28938e7b08ad8d2f$var$$Object(it), $28938e7b08ad8d2f$var$TO_STRING_TAG)) == 'string' ? tag : $28938e7b08ad8d2f$var$CORRECT_ARGUMENTS ? $f65b6a6904086b61$exports(O) : (result = $f65b6a6904086b61$exports(O)) === 'Object' && $da9965769ab8d492$exports(O.callee) ? 'Arguments' : result;
};


var $0f08e96df1c6e400$var$$String = String;
$0f08e96df1c6e400$exports = function(argument) {
    if ($28938e7b08ad8d2f$exports(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $0f08e96df1c6e400$var$$String(argument);
};


var $3fbb288b6dc9417e$exports = {};
'use strict';



var $36f5638d99a5ed32$exports = {};
'use strict';
// a string of all valid unicode whitespaces
$36f5638d99a5ed32$exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";


var $3fbb288b6dc9417e$var$replace = $86d27fcf3ddb374a$exports(''.replace);
var $3fbb288b6dc9417e$var$ltrim = RegExp('^[' + $36f5638d99a5ed32$exports + ']+');
var $3fbb288b6dc9417e$var$rtrim = RegExp('(^|[^' + $36f5638d99a5ed32$exports + '])[' + $36f5638d99a5ed32$exports + ']+$');
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $3fbb288b6dc9417e$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $0f08e96df1c6e400$exports($ce17aed0e5032df3$exports($this));
        if (TYPE & 1) string = $3fbb288b6dc9417e$var$replace(string, $3fbb288b6dc9417e$var$ltrim, '');
        if (TYPE & 2) string = $3fbb288b6dc9417e$var$replace(string, $3fbb288b6dc9417e$var$rtrim, '$1');
        return string;
    };
};
$3fbb288b6dc9417e$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $3fbb288b6dc9417e$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $3fbb288b6dc9417e$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $3fbb288b6dc9417e$var$createMethod(3)
};


var $d0c673959784318b$require$trim = $3fbb288b6dc9417e$exports.trim;

var $d0c673959784318b$var$$parseInt = $f73c1cbf36add1e3$exports.parseInt;
var $d0c673959784318b$var$Symbol = $f73c1cbf36add1e3$exports.Symbol;
var $d0c673959784318b$var$ITERATOR = $d0c673959784318b$var$Symbol && $d0c673959784318b$var$Symbol.iterator;
var $d0c673959784318b$var$hex = /^[+-]?0x/i;
var $d0c673959784318b$var$exec = $86d27fcf3ddb374a$exports($d0c673959784318b$var$hex.exec);
var $d0c673959784318b$var$FORCED = $d0c673959784318b$var$$parseInt($36f5638d99a5ed32$exports + '08') !== 8 || $d0c673959784318b$var$$parseInt($36f5638d99a5ed32$exports + '0x16') !== 22 || $d0c673959784318b$var$ITERATOR && !$1c0f139a1a463ce1$exports(function() {
    $d0c673959784318b$var$$parseInt(Object($d0c673959784318b$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$d0c673959784318b$exports = $d0c673959784318b$var$FORCED ? function parseInt(string, radix) {
    var S = $d0c673959784318b$require$trim($0f08e96df1c6e400$exports(string));
    return $d0c673959784318b$var$$parseInt(S, radix >>> 0 || ($d0c673959784318b$var$exec($d0c673959784318b$var$hex, S) ? 16 : 10));
} : $d0c673959784318b$var$$parseInt;


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$621e6bc7a2f56e42$exports({
    global: true,
    forced: parseInt !== $d0c673959784318b$exports
}, {
    parseInt: $d0c673959784318b$exports
});


'use strict';

var $4f76b280750aac79$exports = {};
'use strict';




var $b70a4de23bb82696$exports = {};
'use strict';


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$b70a4de23bb82696$exports = Object.keys || function keys(O) {
    return $9b74ee65fcf3f4aa$exports(O, $af891a628637cbe1$exports);
};






// eslint-disable-next-line es/no-object-assign -- safe
var $4f76b280750aac79$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $4f76b280750aac79$var$defineProperty = Object.defineProperty;
var $4f76b280750aac79$var$concat = $86d27fcf3ddb374a$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$4f76b280750aac79$exports = !$4f76b280750aac79$var$$assign || $1c0f139a1a463ce1$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($a934004253d25a42$exports && $4f76b280750aac79$var$$assign({
        b: 1
    }, $4f76b280750aac79$var$$assign($4f76b280750aac79$var$defineProperty({}, 'a', {
        enumerable: true,
        get: function() {
            $4f76b280750aac79$var$defineProperty(this, 'b', {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol('assign detection');
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    alphabet.split('').forEach(function(chr) {
        B[chr] = chr;
    });
    return $4f76b280750aac79$var$$assign({}, A)[symbol] !== 7 || $b70a4de23bb82696$exports($4f76b280750aac79$var$$assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
    var T = $c9b4f3ef4a96c778$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $a58edbe542a39e4c$export$2d1720544b23b823;
    var propertyIsEnumerable = $37435e8ffd2f28b9$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $9d1a1577a6ed79d1$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $4f76b280750aac79$var$concat($b70a4de23bb82696$exports(S), getOwnPropertySymbols(S)) : $b70a4de23bb82696$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$a934004253d25a42$exports || $ba3e81ca5de34305$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $4f76b280750aac79$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$621e6bc7a2f56e42$exports({
    target: 'Object',
    stat: true,
    arity: 2,
    forced: Object.assign !== $4f76b280750aac79$exports
}, {
    assign: $4f76b280750aac79$exports
});


'use strict';

var $bec34a0e29a6ea95$exports = {};
'use strict';
var $e702529819d2fe6f$exports = {};
'use strict';
var $c0f7cba2112dcc1e$exports = {};
'use strict';


$c0f7cba2112dcc1e$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($f65b6a6904086b61$exports(fn) === 'Function') return $86d27fcf3ddb374a$exports(fn);
};




var $e702529819d2fe6f$var$bind = $c0f7cba2112dcc1e$exports($c0f7cba2112dcc1e$exports.bind);
// optional / simple context binding
$e702529819d2fe6f$exports = function(fn, that) {
    $a339c863cff407d1$exports(fn);
    return that === undefined ? fn : $13cf557f31fcb3db$exports ? $e702529819d2fe6f$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};






var $4c23e7d9602bf3b9$exports = {};
'use strict';
var $d22419573b71a9b5$exports = {};
'use strict';
var $9bfde3ac2a1c2ebe$exports = {};
'use strict';

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$9bfde3ac2a1c2ebe$exports = Array.isArray || function isArray(argument) {
    return $f65b6a6904086b61$exports(argument) === 'Array';
};


var $fe31ea0376f692ac$exports = {};
'use strict';






var $fe31ea0376f692ac$var$noop = function() {};
var $fe31ea0376f692ac$var$construct = $18c5ef8b38a03108$exports('Reflect', 'construct');
var $fe31ea0376f692ac$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $fe31ea0376f692ac$var$exec = $86d27fcf3ddb374a$exports($fe31ea0376f692ac$var$constructorRegExp.exec);
var $fe31ea0376f692ac$var$INCORRECT_TO_STRING = !$fe31ea0376f692ac$var$constructorRegExp.test($fe31ea0376f692ac$var$noop);
var $fe31ea0376f692ac$var$isConstructorModern = function isConstructor(argument) {
    if (!$da9965769ab8d492$exports(argument)) return false;
    try {
        $fe31ea0376f692ac$var$construct($fe31ea0376f692ac$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $fe31ea0376f692ac$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$da9965769ab8d492$exports(argument)) return false;
    switch($28938e7b08ad8d2f$exports(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $fe31ea0376f692ac$var$INCORRECT_TO_STRING || !!$fe31ea0376f692ac$var$exec($fe31ea0376f692ac$var$constructorRegExp, $33a7bcb147d04741$exports(argument));
    } catch (error) {
        return true;
    }
};
$fe31ea0376f692ac$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$fe31ea0376f692ac$exports = !$fe31ea0376f692ac$var$construct || $1c0f139a1a463ce1$exports(function() {
    var called;
    return $fe31ea0376f692ac$var$isConstructorModern($fe31ea0376f692ac$var$isConstructorModern.call) || !$fe31ea0376f692ac$var$isConstructorModern(Object) || !$fe31ea0376f692ac$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $fe31ea0376f692ac$var$isConstructorLegacy : $fe31ea0376f692ac$var$isConstructorModern;




var $d22419573b71a9b5$var$SPECIES = $06b7b285e3a7068a$exports('species');
var $d22419573b71a9b5$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$d22419573b71a9b5$exports = function(originalArray) {
    var C;
    if ($9bfde3ac2a1c2ebe$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($fe31ea0376f692ac$exports(C) && (C === $d22419573b71a9b5$var$$Array || $9bfde3ac2a1c2ebe$exports(C.prototype))) C = undefined;
        else if ($abc01766c6ffc0a1$exports(C)) {
            C = C[$d22419573b71a9b5$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $d22419573b71a9b5$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$4c23e7d9602bf3b9$exports = function(originalArray, length) {
    return new ($d22419573b71a9b5$exports(originalArray))(length === 0 ? 0 : length);
};


var $bec34a0e29a6ea95$var$push = $86d27fcf3ddb374a$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $bec34a0e29a6ea95$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $c9b4f3ef4a96c778$exports($this);
        var self = $9d1a1577a6ed79d1$exports(O);
        var length = $86912fee58c01fd8$exports(self);
        var boundFunction = $e702529819d2fe6f$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $4c23e7d9602bf3b9$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $bec34a0e29a6ea95$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $bec34a0e29a6ea95$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$bec34a0e29a6ea95$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $bec34a0e29a6ea95$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $bec34a0e29a6ea95$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $bec34a0e29a6ea95$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $bec34a0e29a6ea95$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $bec34a0e29a6ea95$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $bec34a0e29a6ea95$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $bec34a0e29a6ea95$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $bec34a0e29a6ea95$var$createMethod(7)
};


var $a9e8817e1c9ddd72$require$$filter = $bec34a0e29a6ea95$exports.filter;
var $ae48b81f8a6445c9$exports = {};
'use strict';



var $ae48b81f8a6445c9$var$SPECIES = $06b7b285e3a7068a$exports('species');
$ae48b81f8a6445c9$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $76342eacb009e653$exports >= 51 || !$1c0f139a1a463ce1$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$ae48b81f8a6445c9$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};


var $a9e8817e1c9ddd72$var$HAS_SPECIES_SUPPORT = $ae48b81f8a6445c9$exports('filter');
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$621e6bc7a2f56e42$exports({
    target: 'Array',
    proto: true,
    forced: !$a9e8817e1c9ddd72$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $a9e8817e1c9ddd72$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';


var $f2c024c47d1aba50$exports = {};
'use strict';


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$f2c024c47d1aba50$exports = $0cd6fb43abc87faf$exports ? ({}).toString : function toString() {
    return '[object ' + $28938e7b08ad8d2f$exports(this) + ']';
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$0cd6fb43abc87faf$exports) $cc8a5761541cd35d$exports(Object.prototype, 'toString', $f2c024c47d1aba50$exports, {
    unsafe: true
});


var $121e9cdb73c6da98$exports = {};
'use strict';

var $374bab7f556b652b$exports = {};
'use strict';

var $ee4937dd0bdfcee6$exports = {};
'use strict';

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $68b6a7cfb9f3eb01$export$2d1720544b23b823;
'use strict';






$68b6a7cfb9f3eb01$export$2d1720544b23b823 = $a934004253d25a42$exports && !$99f023d30bb6ec12$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $c53804bbcc663539$exports(O);
    var props = $08ccc8de002b7975$exports(Properties);
    var keys = $b70a4de23bb82696$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$96bd28438ee2eee5$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $2892e8717adda2e1$exports = {};
'use strict';

$2892e8717adda2e1$exports = $18c5ef8b38a03108$exports('document', 'documentElement');




var $ee4937dd0bdfcee6$var$GT = '>';
var $ee4937dd0bdfcee6$var$LT = '<';
var $ee4937dd0bdfcee6$var$PROTOTYPE = 'prototype';
var $ee4937dd0bdfcee6$var$SCRIPT = 'script';
var $ee4937dd0bdfcee6$var$IE_PROTO = $8bce327c7c566c42$exports('IE_PROTO');
var $ee4937dd0bdfcee6$var$EmptyConstructor = function() {};
var $ee4937dd0bdfcee6$var$scriptTag = function(content) {
    return $ee4937dd0bdfcee6$var$LT + $ee4937dd0bdfcee6$var$SCRIPT + $ee4937dd0bdfcee6$var$GT + content + $ee4937dd0bdfcee6$var$LT + '/' + $ee4937dd0bdfcee6$var$SCRIPT + $ee4937dd0bdfcee6$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $ee4937dd0bdfcee6$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($ee4937dd0bdfcee6$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $ee4937dd0bdfcee6$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $6a21b3c3b047179b$exports('iframe');
    var JS = 'java' + $ee4937dd0bdfcee6$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $2892e8717adda2e1$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($ee4937dd0bdfcee6$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $ee4937dd0bdfcee6$var$activeXDocument;
var $ee4937dd0bdfcee6$var$NullProtoObject = function() {
    try {
        $ee4937dd0bdfcee6$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $ee4937dd0bdfcee6$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $ee4937dd0bdfcee6$var$activeXDocument ? $ee4937dd0bdfcee6$var$NullProtoObjectViaActiveX($ee4937dd0bdfcee6$var$activeXDocument) // old IE
     : $ee4937dd0bdfcee6$var$NullProtoObjectViaIFrame() : $ee4937dd0bdfcee6$var$NullProtoObjectViaActiveX($ee4937dd0bdfcee6$var$activeXDocument); // WSH
    var length = $af891a628637cbe1$exports.length;
    while(length--)delete $ee4937dd0bdfcee6$var$NullProtoObject[$ee4937dd0bdfcee6$var$PROTOTYPE][$af891a628637cbe1$exports[length]];
    return $ee4937dd0bdfcee6$var$NullProtoObject();
};
$c134b99a007ffe97$exports[$ee4937dd0bdfcee6$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$ee4937dd0bdfcee6$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $ee4937dd0bdfcee6$var$EmptyConstructor[$ee4937dd0bdfcee6$var$PROTOTYPE] = $c53804bbcc663539$exports(O);
        result = new $ee4937dd0bdfcee6$var$EmptyConstructor();
        $ee4937dd0bdfcee6$var$EmptyConstructor[$ee4937dd0bdfcee6$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$ee4937dd0bdfcee6$var$IE_PROTO] = O;
    } else result = $ee4937dd0bdfcee6$var$NullProtoObject();
    return Properties === undefined ? result : $68b6a7cfb9f3eb01$export$2d1720544b23b823(result, Properties);
};



var $374bab7f556b652b$require$defineProperty = $96bd28438ee2eee5$export$2d1720544b23b823;
var $374bab7f556b652b$var$UNSCOPABLES = $06b7b285e3a7068a$exports('unscopables');
var $374bab7f556b652b$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($374bab7f556b652b$var$ArrayPrototype[$374bab7f556b652b$var$UNSCOPABLES] === undefined) $374bab7f556b652b$require$defineProperty($374bab7f556b652b$var$ArrayPrototype, $374bab7f556b652b$var$UNSCOPABLES, {
    configurable: true,
    value: $ee4937dd0bdfcee6$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$374bab7f556b652b$exports = function(key) {
    $374bab7f556b652b$var$ArrayPrototype[$374bab7f556b652b$var$UNSCOPABLES][key] = true;
};


var $898708d156ba5812$exports = {};
'use strict';
$898708d156ba5812$exports = {};




var $121e9cdb73c6da98$require$defineProperty = $96bd28438ee2eee5$export$2d1720544b23b823;
var $ad4a3702b8819b30$exports = {};
'use strict';





var $ffcc0f6e93e42ad7$exports = {};
'use strict';
var $a763eda09a06e511$exports = {};
'use strict';




var $5e684cfc91407f82$exports = {};
'use strict';




var $e74801456a5e63d3$exports = {};
'use strict';

$e74801456a5e63d3$exports = !$1c0f139a1a463ce1$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $5e684cfc91407f82$var$IE_PROTO = $8bce327c7c566c42$exports('IE_PROTO');
var $5e684cfc91407f82$var$$Object = Object;
var $5e684cfc91407f82$var$ObjectPrototype = $5e684cfc91407f82$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$5e684cfc91407f82$exports = $e74801456a5e63d3$exports ? $5e684cfc91407f82$var$$Object.getPrototypeOf : function(O) {
    var object = $c9b4f3ef4a96c778$exports(O);
    if ($9fd86a02d78d2d99$exports(object, $5e684cfc91407f82$var$IE_PROTO)) return object[$5e684cfc91407f82$var$IE_PROTO];
    var constructor = object.constructor;
    if ($da9965769ab8d492$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $5e684cfc91407f82$var$$Object ? $5e684cfc91407f82$var$ObjectPrototype : null;
};





var $a763eda09a06e511$var$ITERATOR = $06b7b285e3a7068a$exports('iterator');
var $a763eda09a06e511$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $a763eda09a06e511$var$IteratorPrototype, $a763eda09a06e511$var$PrototypeOfArrayIteratorPrototype, $a763eda09a06e511$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $a763eda09a06e511$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $a763eda09a06e511$var$arrayIterator)) $a763eda09a06e511$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $a763eda09a06e511$var$PrototypeOfArrayIteratorPrototype = $5e684cfc91407f82$exports($5e684cfc91407f82$exports($a763eda09a06e511$var$arrayIterator));
        if ($a763eda09a06e511$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $a763eda09a06e511$var$IteratorPrototype = $a763eda09a06e511$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $a763eda09a06e511$var$NEW_ITERATOR_PROTOTYPE = !$abc01766c6ffc0a1$exports($a763eda09a06e511$var$IteratorPrototype) || $1c0f139a1a463ce1$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $a763eda09a06e511$var$IteratorPrototype[$a763eda09a06e511$var$ITERATOR].call(test) !== test;
});
if ($a763eda09a06e511$var$NEW_ITERATOR_PROTOTYPE) $a763eda09a06e511$var$IteratorPrototype = {};
else if ($8a834a2771c3d77e$exports) $a763eda09a06e511$var$IteratorPrototype = $ee4937dd0bdfcee6$exports($a763eda09a06e511$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$da9965769ab8d492$exports($a763eda09a06e511$var$IteratorPrototype[$a763eda09a06e511$var$ITERATOR])) $cc8a5761541cd35d$exports($a763eda09a06e511$var$IteratorPrototype, $a763eda09a06e511$var$ITERATOR, function() {
    return this;
});
$a763eda09a06e511$exports = {
    IteratorPrototype: $a763eda09a06e511$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $a763eda09a06e511$var$BUGGY_SAFARI_ITERATORS
};


var $ffcc0f6e93e42ad7$require$IteratorPrototype = $a763eda09a06e511$exports.IteratorPrototype;


var $8f25367a6f31c129$exports = {};
'use strict';

var $8f25367a6f31c129$require$defineProperty = $96bd28438ee2eee5$export$2d1720544b23b823;


var $8f25367a6f31c129$var$TO_STRING_TAG = $06b7b285e3a7068a$exports('toStringTag');
$8f25367a6f31c129$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$9fd86a02d78d2d99$exports(target, $8f25367a6f31c129$var$TO_STRING_TAG)) $8f25367a6f31c129$require$defineProperty(target, $8f25367a6f31c129$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $ffcc0f6e93e42ad7$var$returnThis = function() {
    return this;
};
$ffcc0f6e93e42ad7$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $ee4937dd0bdfcee6$exports($ffcc0f6e93e42ad7$require$IteratorPrototype, {
        next: $7f001fc6b2d5740c$exports(+!ENUMERABLE_NEXT, next)
    });
    $8f25367a6f31c129$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $898708d156ba5812$exports[TO_STRING_TAG] = $ffcc0f6e93e42ad7$var$returnThis;
    return IteratorConstructor;
};



var $e667f1deebc629ea$exports = {};
'use strict';
var $f14cf30eaeb0d4f0$exports = {};
'use strict';


$f14cf30eaeb0d4f0$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $86d27fcf3ddb374a$exports($a339c863cff407d1$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $bbeac7cd1e985d4e$exports = {};
'use strict';
var $653d18f0057902f3$exports = {};
'use strict';

$653d18f0057902f3$exports = function(argument) {
    return $abc01766c6ffc0a1$exports(argument) || argument === null;
};


var $bbeac7cd1e985d4e$var$$String = String;
var $bbeac7cd1e985d4e$var$$TypeError = TypeError;
$bbeac7cd1e985d4e$exports = function(argument) {
    if ($653d18f0057902f3$exports(argument)) return argument;
    throw new $bbeac7cd1e985d4e$var$$TypeError("Can't set " + $bbeac7cd1e985d4e$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$e667f1deebc629ea$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $f14cf30eaeb0d4f0$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $ce17aed0e5032df3$exports(O);
        $bbeac7cd1e985d4e$exports(proto);
        if (!$abc01766c6ffc0a1$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $ad4a3702b8819b30$var$PROPER_FUNCTION_NAME = $b82122a7f3a0fd21$exports.PROPER;
var $ad4a3702b8819b30$var$CONFIGURABLE_FUNCTION_NAME = $b82122a7f3a0fd21$exports.CONFIGURABLE;
var $ad4a3702b8819b30$var$IteratorPrototype = $a763eda09a06e511$exports.IteratorPrototype;
var $ad4a3702b8819b30$var$BUGGY_SAFARI_ITERATORS = $a763eda09a06e511$exports.BUGGY_SAFARI_ITERATORS;
var $ad4a3702b8819b30$var$ITERATOR = $06b7b285e3a7068a$exports('iterator');
var $ad4a3702b8819b30$var$KEYS = 'keys';
var $ad4a3702b8819b30$var$VALUES = 'values';
var $ad4a3702b8819b30$var$ENTRIES = 'entries';
var $ad4a3702b8819b30$var$returnThis = function() {
    return this;
};
$ad4a3702b8819b30$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $ffcc0f6e93e42ad7$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$ad4a3702b8819b30$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $ad4a3702b8819b30$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $ad4a3702b8819b30$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $ad4a3702b8819b30$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$ad4a3702b8819b30$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$ad4a3702b8819b30$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $5e684cfc91407f82$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$8a834a2771c3d77e$exports && $5e684cfc91407f82$exports(CurrentIteratorPrototype) !== $ad4a3702b8819b30$var$IteratorPrototype) {
                if ($e667f1deebc629ea$exports) $e667f1deebc629ea$exports(CurrentIteratorPrototype, $ad4a3702b8819b30$var$IteratorPrototype);
                else if (!$da9965769ab8d492$exports(CurrentIteratorPrototype[$ad4a3702b8819b30$var$ITERATOR])) $cc8a5761541cd35d$exports(CurrentIteratorPrototype, $ad4a3702b8819b30$var$ITERATOR, $ad4a3702b8819b30$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $8f25367a6f31c129$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($8a834a2771c3d77e$exports) $898708d156ba5812$exports[TO_STRING_TAG] = $ad4a3702b8819b30$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($ad4a3702b8819b30$var$PROPER_FUNCTION_NAME && DEFAULT === $ad4a3702b8819b30$var$VALUES && nativeIterator && nativeIterator.name !== $ad4a3702b8819b30$var$VALUES) {
        if (!$8a834a2771c3d77e$exports && $ad4a3702b8819b30$var$CONFIGURABLE_FUNCTION_NAME) $3d5a463be44ffeea$exports(IterablePrototype, 'name', $ad4a3702b8819b30$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $ba3e81ca5de34305$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($ad4a3702b8819b30$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($ad4a3702b8819b30$var$KEYS),
            entries: getIterationMethod($ad4a3702b8819b30$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($ad4a3702b8819b30$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $cc8a5761541cd35d$exports(IterablePrototype, KEY, methods[KEY]);
        } else $621e6bc7a2f56e42$exports({
            target: NAME,
            proto: true,
            forced: $ad4a3702b8819b30$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$8a834a2771c3d77e$exports || FORCED) && IterablePrototype[$ad4a3702b8819b30$var$ITERATOR] !== defaultIterator) $cc8a5761541cd35d$exports(IterablePrototype, $ad4a3702b8819b30$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $898708d156ba5812$exports[NAME] = defaultIterator;
    return methods;
};


var $f38e0f43c1e0dbb1$exports = {};
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$f38e0f43c1e0dbb1$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $121e9cdb73c6da98$var$ARRAY_ITERATOR = 'Array Iterator';
var $121e9cdb73c6da98$var$setInternalState = $033d4cca21ca5361$exports.set;
var $121e9cdb73c6da98$var$getInternalState = $033d4cca21ca5361$exports.getterFor($121e9cdb73c6da98$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$121e9cdb73c6da98$exports = $ad4a3702b8819b30$exports(Array, 'Array', function(iterated, kind) {
    $121e9cdb73c6da98$var$setInternalState(this, {
        type: $121e9cdb73c6da98$var$ARRAY_ITERATOR,
        target: $08ccc8de002b7975$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $121e9cdb73c6da98$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $f38e0f43c1e0dbb1$exports(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $f38e0f43c1e0dbb1$exports(index, false);
        case 'values':
            return $f38e0f43c1e0dbb1$exports(target[index], false);
    }
    return $f38e0f43c1e0dbb1$exports([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $121e9cdb73c6da98$var$values = $898708d156ba5812$exports.Arguments = $898708d156ba5812$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$374bab7f556b652b$exports('keys');
$374bab7f556b652b$exports('values');
$374bab7f556b652b$exports('entries');
// V8 ~ Chrome 45- bug
if (!$8a834a2771c3d77e$exports && $a934004253d25a42$exports && $121e9cdb73c6da98$var$values.name !== 'values') try {
    $121e9cdb73c6da98$require$defineProperty($121e9cdb73c6da98$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}


'use strict';
var $ac5e43fd8976501e$exports = {};
'use strict';




var $ac5e43fd8976501e$var$charAt = $86d27fcf3ddb374a$exports(''.charAt);
var $ac5e43fd8976501e$var$charCodeAt = $86d27fcf3ddb374a$exports(''.charCodeAt);
var $ac5e43fd8976501e$var$stringSlice = $86d27fcf3ddb374a$exports(''.slice);
var $ac5e43fd8976501e$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $0f08e96df1c6e400$exports($ce17aed0e5032df3$exports($this));
        var position = $8abe88bfd140bd58$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $ac5e43fd8976501e$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $ac5e43fd8976501e$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $ac5e43fd8976501e$var$charAt(S, position) : first : CONVERT_TO_STRING ? $ac5e43fd8976501e$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$ac5e43fd8976501e$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $ac5e43fd8976501e$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $ac5e43fd8976501e$var$createMethod(true)
};


var $0b4586806b35418f$require$charAt = $ac5e43fd8976501e$exports.charAt;




var $0b4586806b35418f$var$STRING_ITERATOR = 'String Iterator';
var $0b4586806b35418f$var$setInternalState = $033d4cca21ca5361$exports.set;
var $0b4586806b35418f$var$getInternalState = $033d4cca21ca5361$exports.getterFor($0b4586806b35418f$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$ad4a3702b8819b30$exports(String, 'String', function(iterated) {
    $0b4586806b35418f$var$setInternalState(this, {
        type: $0b4586806b35418f$var$STRING_ITERATOR,
        string: $0f08e96df1c6e400$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $0b4586806b35418f$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $f38e0f43c1e0dbb1$exports(undefined, true);
    point = $0b4586806b35418f$require$charAt(string, index);
    state.index += point.length;
    return $f38e0f43c1e0dbb1$exports(point, false);
});


'use strict';
'use strict';
var $0e06fdda58a9995f$exports = {};
'use strict';

$0e06fdda58a9995f$exports = !$1c0f139a1a463ce1$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});




var $b741a7223573301b$exports = {};
'use strict';

$b741a7223573301b$exports = function(target, src, options) {
    for(var key in src)$cc8a5761541cd35d$exports(target, key, src[key], options);
    return target;
};


var $c659de18108f2b9d$exports = {};
'use strict';






var $c659de18108f2b9d$require$defineProperty = $96bd28438ee2eee5$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $870bf0ae771919e5$export$2d1720544b23b823;
'use strict';



var $870bf0ae771919e5$require$$getOwnPropertyNames = $f160027a9f5364b6$export$2d1720544b23b823;
var $c884eb1b9a961956$exports = {};
'use strict';

$c884eb1b9a961956$exports = $86d27fcf3ddb374a$exports([].slice);


var $870bf0ae771919e5$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $870bf0ae771919e5$var$getWindowNames = function(it) {
    try {
        return $870bf0ae771919e5$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $c884eb1b9a961956$exports($870bf0ae771919e5$var$windowNames);
    }
};
$870bf0ae771919e5$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $870bf0ae771919e5$var$windowNames && $f65b6a6904086b61$exports(it) === 'Window' ? $870bf0ae771919e5$var$getWindowNames(it) : $870bf0ae771919e5$require$$getOwnPropertyNames($08ccc8de002b7975$exports(it));
};


var $90dc3c5a8ac0491b$exports = {};
'use strict';



var $563445bc992b5636$exports = {};
'use strict';

$563445bc992b5636$exports = $1c0f139a1a463ce1$exports(function() {
    if (typeof ArrayBuffer == 'function') {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $90dc3c5a8ac0491b$var$$isExtensible = Object.isExtensible;
var $90dc3c5a8ac0491b$var$FAILS_ON_PRIMITIVES = $1c0f139a1a463ce1$exports(function() {
    $90dc3c5a8ac0491b$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$90dc3c5a8ac0491b$exports = $90dc3c5a8ac0491b$var$FAILS_ON_PRIMITIVES || $563445bc992b5636$exports ? function isExtensible(it) {
    if (!$abc01766c6ffc0a1$exports(it)) return false;
    if ($563445bc992b5636$exports && $f65b6a6904086b61$exports(it) === 'ArrayBuffer') return false;
    return $90dc3c5a8ac0491b$var$$isExtensible ? $90dc3c5a8ac0491b$var$$isExtensible(it) : true;
} : $90dc3c5a8ac0491b$var$$isExtensible;




var $c659de18108f2b9d$var$REQUIRED = false;
var $c659de18108f2b9d$var$METADATA = $2e904edd887c2aab$exports('meta');
var $c659de18108f2b9d$var$id = 0;
var $c659de18108f2b9d$var$setMetadata = function(it) {
    $c659de18108f2b9d$require$defineProperty(it, $c659de18108f2b9d$var$METADATA, {
        value: {
            objectID: 'O' + $c659de18108f2b9d$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $c659de18108f2b9d$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$abc01766c6ffc0a1$exports(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$9fd86a02d78d2d99$exports(it, $c659de18108f2b9d$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$90dc3c5a8ac0491b$exports(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $c659de18108f2b9d$var$setMetadata(it);
    // return object ID
    }
    return it[$c659de18108f2b9d$var$METADATA].objectID;
};
var $c659de18108f2b9d$var$getWeakData = function(it, create) {
    if (!$9fd86a02d78d2d99$exports(it, $c659de18108f2b9d$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$90dc3c5a8ac0491b$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $c659de18108f2b9d$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$c659de18108f2b9d$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $c659de18108f2b9d$var$onFreeze = function(it) {
    if ($0e06fdda58a9995f$exports && $c659de18108f2b9d$var$REQUIRED && $90dc3c5a8ac0491b$exports(it) && !$9fd86a02d78d2d99$exports(it, $c659de18108f2b9d$var$METADATA)) $c659de18108f2b9d$var$setMetadata(it);
    return it;
};
var $c659de18108f2b9d$var$enable = function() {
    $c659de18108f2b9d$var$meta.enable = function() {};
    $c659de18108f2b9d$var$REQUIRED = true;
    var getOwnPropertyNames = $f160027a9f5364b6$export$2d1720544b23b823;
    var splice = $86d27fcf3ddb374a$exports([].splice);
    var test = {};
    test[$c659de18108f2b9d$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $f160027a9f5364b6$exports.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $c659de18108f2b9d$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $621e6bc7a2f56e42$exports({
            target: 'Object',
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $870bf0ae771919e5$export$2d1720544b23b823
        });
    }
};
var $c659de18108f2b9d$var$meta = $c659de18108f2b9d$exports = {
    enable: $c659de18108f2b9d$var$enable,
    fastKey: $c659de18108f2b9d$var$fastKey,
    getWeakData: $c659de18108f2b9d$var$getWeakData,
    onFreeze: $c659de18108f2b9d$var$onFreeze
};
$c134b99a007ffe97$exports[$c659de18108f2b9d$var$METADATA] = true;


var $feb3547d1b47cd95$exports = {};
'use strict';






var $3e11f2a1874c6bd7$exports = {};
'use strict';




var $6ef3986b7be069bb$exports = {};
'use strict';


var $6ef3986b7be069bb$var$ITERATOR = $06b7b285e3a7068a$exports('iterator');
var $6ef3986b7be069bb$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$6ef3986b7be069bb$exports = function(it) {
    return it !== undefined && ($898708d156ba5812$exports.Array === it || $6ef3986b7be069bb$var$ArrayPrototype[$6ef3986b7be069bb$var$ITERATOR] === it);
};




var $39f784c36ed16836$exports = {};
'use strict';




var $e4f2c4d8bd8780b9$exports = {};
'use strict';





var $e4f2c4d8bd8780b9$var$ITERATOR = $06b7b285e3a7068a$exports('iterator');
$e4f2c4d8bd8780b9$exports = function(it) {
    if (!$896d3aa83f9594d3$exports(it)) return $ea805a34e9f0856a$exports(it, $e4f2c4d8bd8780b9$var$ITERATOR) || $ea805a34e9f0856a$exports(it, '@@iterator') || $898708d156ba5812$exports[$28938e7b08ad8d2f$exports(it)];
};


var $39f784c36ed16836$var$$TypeError = TypeError;
$39f784c36ed16836$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $e4f2c4d8bd8780b9$exports(argument) : usingIterator;
    if ($a339c863cff407d1$exports(iteratorMethod)) return $c53804bbcc663539$exports($ba3e81ca5de34305$exports(iteratorMethod, argument));
    throw new $39f784c36ed16836$var$$TypeError($3ad1d00e209ff694$exports(argument) + ' is not iterable');
};



var $3d1d3a3160c5a95a$exports = {};
'use strict';



$3d1d3a3160c5a95a$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $c53804bbcc663539$exports(iterator);
    try {
        innerResult = $ea805a34e9f0856a$exports(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $ba3e81ca5de34305$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $c53804bbcc663539$exports(innerResult);
    return value;
};


var $3e11f2a1874c6bd7$var$$TypeError = TypeError;
var $3e11f2a1874c6bd7$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $3e11f2a1874c6bd7$var$ResultPrototype = $3e11f2a1874c6bd7$var$Result.prototype;
$3e11f2a1874c6bd7$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $e702529819d2fe6f$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $3d1d3a3160c5a95a$exports(iterator, 'normal', condition);
        return new $3e11f2a1874c6bd7$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $c53804bbcc663539$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $e4f2c4d8bd8780b9$exports(iterable);
        if (!iterFn) throw new $3e11f2a1874c6bd7$var$$TypeError($3ad1d00e209ff694$exports(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($6ef3986b7be069bb$exports(iterFn)) {
            for(index = 0, length = $86912fee58c01fd8$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $d5379fc5818962a4$exports($3e11f2a1874c6bd7$var$ResultPrototype, result)) return result;
            }
            return new $3e11f2a1874c6bd7$var$Result(false);
        }
        iterator = $39f784c36ed16836$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $ba3e81ca5de34305$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $3d1d3a3160c5a95a$exports(iterator, 'throw', error);
        }
        if (typeof result == 'object' && result && $d5379fc5818962a4$exports($3e11f2a1874c6bd7$var$ResultPrototype, result)) return result;
    }
    return new $3e11f2a1874c6bd7$var$Result(false);
};


var $b771e1b4d81409fe$exports = {};
'use strict';

var $b771e1b4d81409fe$var$$TypeError = TypeError;
$b771e1b4d81409fe$exports = function(it, Prototype) {
    if ($d5379fc5818962a4$exports(Prototype, it)) return it;
    throw new $b771e1b4d81409fe$var$$TypeError('Incorrect invocation');
};






var $e1138293a817967b$exports = {};
'use strict';

var $e1138293a817967b$var$ITERATOR = $06b7b285e3a7068a$exports('iterator');
var $e1138293a817967b$var$SAFE_CLOSING = false;
try {
    var $e1138293a817967b$var$called = 0;
    var $e1138293a817967b$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$e1138293a817967b$var$called++
            };
        },
        'return': function() {
            $e1138293a817967b$var$SAFE_CLOSING = true;
        }
    };
    $e1138293a817967b$var$iteratorWithReturn[$e1138293a817967b$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($e1138293a817967b$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$e1138293a817967b$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$e1138293a817967b$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$e1138293a817967b$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $1164434a76a3b13b$exports = {};
'use strict';



// makes subclassing work correct for wrapped built-ins
$1164434a76a3b13b$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $e667f1deebc629ea$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $da9965769ab8d492$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $abc01766c6ffc0a1$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $e667f1deebc629ea$exports($this, NewTargetPrototype);
    return $this;
};


$feb3547d1b47cd95$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = $f73c1cbf36add1e3$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $86d27fcf3ddb374a$exports(NativePrototype[KEY]);
        $cc8a5761541cd35d$exports(NativePrototype, KEY, KEY === 'add' ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === 'delete' ? function(key) {
            return IS_WEAK && !$abc01766c6ffc0a1$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'get' ? function get(key) {
            return IS_WEAK && !$abc01766c6ffc0a1$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'has' ? function has(key) {
            return IS_WEAK && !$abc01766c6ffc0a1$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $32073ab696b14d8d$exports(CONSTRUCTOR_NAME, !$da9965769ab8d492$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$1c0f139a1a463ce1$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $c659de18108f2b9d$exports.enable();
    } else if ($32073ab696b14d8d$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $1c0f139a1a463ce1$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $e1138293a817967b$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $1c0f139a1a463ce1$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $b771e1b4d81409fe$exports(dummy, NativePrototype);
                var that = $1164434a76a3b13b$exports(new NativeConstructor(), dummy, Constructor);
                if (!$896d3aa83f9594d3$exports(iterable)) $3e11f2a1874c6bd7$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $621e6bc7a2f56e42$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $8f25367a6f31c129$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $ff795a54b9068452$exports = {};
'use strict';



var $ff795a54b9068452$require$getWeakData = $c659de18108f2b9d$exports.getWeakData;








var $ff795a54b9068452$var$setInternalState = $033d4cca21ca5361$exports.set;
var $ff795a54b9068452$var$internalStateGetterFor = $033d4cca21ca5361$exports.getterFor;
var $ff795a54b9068452$var$find = $bec34a0e29a6ea95$exports.find;
var $ff795a54b9068452$var$findIndex = $bec34a0e29a6ea95$exports.findIndex;
var $ff795a54b9068452$var$splice = $86d27fcf3ddb374a$exports([].splice);
var $ff795a54b9068452$var$id = 0;
// fallback for uncaught frozen keys
var $ff795a54b9068452$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $ff795a54b9068452$var$UncaughtFrozenStore());
};
var $ff795a54b9068452$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $ff795a54b9068452$var$findUncaughtFrozen = function(store, key) {
    return $ff795a54b9068452$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$ff795a54b9068452$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $ff795a54b9068452$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$ff795a54b9068452$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $ff795a54b9068452$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $ff795a54b9068452$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $ff795a54b9068452$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$ff795a54b9068452$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $b771e1b4d81409fe$exports(that, Prototype);
            $ff795a54b9068452$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $ff795a54b9068452$var$id++,
                frozen: null
            });
            if (!$896d3aa83f9594d3$exports(iterable)) $3e11f2a1874c6bd7$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $ff795a54b9068452$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $ff795a54b9068452$require$getWeakData($c53804bbcc663539$exports(key), true);
            if (data === true) $ff795a54b9068452$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $b741a7223573301b$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            'delete': function(key) {
                var state = getInternalState(this);
                if (!$abc01766c6ffc0a1$exports(key)) return false;
                var data = $ff795a54b9068452$require$getWeakData(key);
                if (data === true) return $ff795a54b9068452$var$uncaughtFrozenStore(state)['delete'](key);
                return data && $9fd86a02d78d2d99$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$abc01766c6ffc0a1$exports(key)) return false;
                var data = $ff795a54b9068452$require$getWeakData(key);
                if (data === true) return $ff795a54b9068452$var$uncaughtFrozenStore(state).has(key);
                return data && $9fd86a02d78d2d99$exports(data, state.id);
            }
        });
        $b741a7223573301b$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($abc01766c6ffc0a1$exports(key)) {
                    var data = $ff795a54b9068452$require$getWeakData(key);
                    if (data === true) return $ff795a54b9068452$var$uncaughtFrozenStore(state).get(key);
                    if (data) return data[state.id];
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $f8f2a2e5d7739272$require$enforceInternalState = $033d4cca21ca5361$exports.enforce;


var $f8f2a2e5d7739272$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $f8f2a2e5d7739272$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $f8f2a2e5d7739272$var$isExtensible = $f8f2a2e5d7739272$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $f8f2a2e5d7739272$var$isFrozen = $f8f2a2e5d7739272$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $f8f2a2e5d7739272$var$isSealed = $f8f2a2e5d7739272$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $f8f2a2e5d7739272$var$freeze = $f8f2a2e5d7739272$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $f8f2a2e5d7739272$var$seal = $f8f2a2e5d7739272$var$$Object.seal;
var $f8f2a2e5d7739272$var$IS_IE11 = !$f73c1cbf36add1e3$exports.ActiveXObject && 'ActiveXObject' in $f73c1cbf36add1e3$exports;
var $f8f2a2e5d7739272$var$InternalWeakMap;
var $f8f2a2e5d7739272$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $f8f2a2e5d7739272$var$$WeakMap = $feb3547d1b47cd95$exports('WeakMap', $f8f2a2e5d7739272$var$wrapper, $ff795a54b9068452$exports);
var $f8f2a2e5d7739272$var$WeakMapPrototype = $f8f2a2e5d7739272$var$$WeakMap.prototype;
var $f8f2a2e5d7739272$var$nativeSet = $86d27fcf3ddb374a$exports($f8f2a2e5d7739272$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $f8f2a2e5d7739272$var$hasMSEdgeFreezingBug = function() {
    return $0e06fdda58a9995f$exports && $1c0f139a1a463ce1$exports(function() {
        var frozenArray = $f8f2a2e5d7739272$var$freeze([]);
        $f8f2a2e5d7739272$var$nativeSet(new $f8f2a2e5d7739272$var$$WeakMap(), frozenArray, 1);
        return !$f8f2a2e5d7739272$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($d5d26662890f9fd9$exports) {
    if ($f8f2a2e5d7739272$var$IS_IE11) {
        $f8f2a2e5d7739272$var$InternalWeakMap = $ff795a54b9068452$exports.getConstructor($f8f2a2e5d7739272$var$wrapper, 'WeakMap', true);
        $c659de18108f2b9d$exports.enable();
        var $f8f2a2e5d7739272$var$nativeDelete = $86d27fcf3ddb374a$exports($f8f2a2e5d7739272$var$WeakMapPrototype['delete']);
        var $f8f2a2e5d7739272$var$nativeHas = $86d27fcf3ddb374a$exports($f8f2a2e5d7739272$var$WeakMapPrototype.has);
        var $f8f2a2e5d7739272$var$nativeGet = $86d27fcf3ddb374a$exports($f8f2a2e5d7739272$var$WeakMapPrototype.get);
        $b741a7223573301b$exports($f8f2a2e5d7739272$var$WeakMapPrototype, {
            'delete': function(key) {
                if ($abc01766c6ffc0a1$exports(key) && !$f8f2a2e5d7739272$var$isExtensible(key)) {
                    var state = $f8f2a2e5d7739272$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $f8f2a2e5d7739272$var$InternalWeakMap();
                    return $f8f2a2e5d7739272$var$nativeDelete(this, key) || state.frozen['delete'](key);
                }
                return $f8f2a2e5d7739272$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($abc01766c6ffc0a1$exports(key) && !$f8f2a2e5d7739272$var$isExtensible(key)) {
                    var state = $f8f2a2e5d7739272$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $f8f2a2e5d7739272$var$InternalWeakMap();
                    return $f8f2a2e5d7739272$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $f8f2a2e5d7739272$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($abc01766c6ffc0a1$exports(key) && !$f8f2a2e5d7739272$var$isExtensible(key)) {
                    var state = $f8f2a2e5d7739272$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $f8f2a2e5d7739272$var$InternalWeakMap();
                    return $f8f2a2e5d7739272$var$nativeHas(this, key) ? $f8f2a2e5d7739272$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $f8f2a2e5d7739272$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($abc01766c6ffc0a1$exports(key) && !$f8f2a2e5d7739272$var$isExtensible(key)) {
                    var state = $f8f2a2e5d7739272$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $f8f2a2e5d7739272$var$InternalWeakMap();
                    $f8f2a2e5d7739272$var$nativeHas(this, key) ? $f8f2a2e5d7739272$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $f8f2a2e5d7739272$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($f8f2a2e5d7739272$var$hasMSEdgeFreezingBug()) $b741a7223573301b$exports($f8f2a2e5d7739272$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($f8f2a2e5d7739272$var$isArray(key)) {
                if ($f8f2a2e5d7739272$var$isFrozen(key)) arrayIntegrityLevel = $f8f2a2e5d7739272$var$freeze;
                else if ($f8f2a2e5d7739272$var$isSealed(key)) arrayIntegrityLevel = $f8f2a2e5d7739272$var$seal;
            }
            $f8f2a2e5d7739272$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}




'use strict';

var $2c2d10dfcf45ad43$exports = {};
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$2c2d10dfcf45ad43$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $c1bce5d1e69c6b84$exports = {};
'use strict';

var $c1bce5d1e69c6b84$var$classList = $6a21b3c3b047179b$exports('span').classList;
var $c1bce5d1e69c6b84$var$DOMTokenListPrototype = $c1bce5d1e69c6b84$var$classList && $c1bce5d1e69c6b84$var$classList.constructor && $c1bce5d1e69c6b84$var$classList.constructor.prototype;
$c1bce5d1e69c6b84$exports = $c1bce5d1e69c6b84$var$DOMTokenListPrototype === Object.prototype ? undefined : $c1bce5d1e69c6b84$var$DOMTokenListPrototype;






var $d6f0ecee22d99965$var$ITERATOR = $06b7b285e3a7068a$exports('iterator');
var $d6f0ecee22d99965$var$ArrayValues = $121e9cdb73c6da98$exports.values;
var $d6f0ecee22d99965$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$d6f0ecee22d99965$var$ITERATOR] !== $d6f0ecee22d99965$var$ArrayValues) try {
            $3d5a463be44ffeea$exports(CollectionPrototype, $d6f0ecee22d99965$var$ITERATOR, $d6f0ecee22d99965$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$d6f0ecee22d99965$var$ITERATOR] = $d6f0ecee22d99965$var$ArrayValues;
        }
        $8f25367a6f31c129$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($2c2d10dfcf45ad43$exports[COLLECTION_NAME]) for(var METHOD_NAME in $121e9cdb73c6da98$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $121e9cdb73c6da98$exports[METHOD_NAME]) try {
                $3d5a463be44ffeea$exports(CollectionPrototype, METHOD_NAME, $121e9cdb73c6da98$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $121e9cdb73c6da98$exports[METHOD_NAME];
            }
        }
    }
};
for(var $d6f0ecee22d99965$var$COLLECTION_NAME in $2c2d10dfcf45ad43$exports)$d6f0ecee22d99965$var$handlePrototype($f73c1cbf36add1e3$exports[$d6f0ecee22d99965$var$COLLECTION_NAME] && $f73c1cbf36add1e3$exports[$d6f0ecee22d99965$var$COLLECTION_NAME].prototype, $d6f0ecee22d99965$var$COLLECTION_NAME);
$d6f0ecee22d99965$var$handlePrototype($c1bce5d1e69c6b84$exports, 'DOMTokenList');


var $ac15e73f2bda9226$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $ac15e73f2bda9226$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $ac15e73f2bda9226$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ac15e73f2bda9226$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $ac15e73f2bda9226$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ac15e73f2bda9226$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ac15e73f2bda9226$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ac15e73f2bda9226$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ac15e73f2bda9226$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $ac15e73f2bda9226$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $ac15e73f2bda9226$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ac15e73f2bda9226$var$root = $ac15e73f2bda9226$var$freeGlobal || $ac15e73f2bda9226$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $ac15e73f2bda9226$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ac15e73f2bda9226$var$objectToString = $ac15e73f2bda9226$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ac15e73f2bda9226$var$nativeMax = Math.max, $ac15e73f2bda9226$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ac15e73f2bda9226$var$now = function() {
    return $ac15e73f2bda9226$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ac15e73f2bda9226$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($ac15e73f2bda9226$var$FUNC_ERROR_TEXT);
    wait = $ac15e73f2bda9226$var$toNumber(wait) || 0;
    if ($ac15e73f2bda9226$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $ac15e73f2bda9226$var$nativeMax($ac15e73f2bda9226$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $ac15e73f2bda9226$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ac15e73f2bda9226$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ac15e73f2bda9226$var$now());
    }
    function debounced() {
        var time = $ac15e73f2bda9226$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ac15e73f2bda9226$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($ac15e73f2bda9226$var$FUNC_ERROR_TEXT);
    if ($ac15e73f2bda9226$var$isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $ac15e73f2bda9226$var$debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ac15e73f2bda9226$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ac15e73f2bda9226$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ac15e73f2bda9226$var$isSymbol(value) {
    return typeof value == 'symbol' || $ac15e73f2bda9226$var$isObjectLike(value) && $ac15e73f2bda9226$var$objectToString.call(value) == $ac15e73f2bda9226$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ac15e73f2bda9226$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($ac15e73f2bda9226$var$isSymbol(value)) return $ac15e73f2bda9226$var$NAN;
    if ($ac15e73f2bda9226$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $ac15e73f2bda9226$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($ac15e73f2bda9226$var$reTrim, '');
    var isBinary = $ac15e73f2bda9226$var$reIsBinary.test(value);
    return isBinary || $ac15e73f2bda9226$var$reIsOctal.test(value) ? $ac15e73f2bda9226$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ac15e73f2bda9226$var$reIsBadHex.test(value) ? $ac15e73f2bda9226$var$NAN : +value;
}
$ac15e73f2bda9226$exports = $ac15e73f2bda9226$var$throttle;



var $3d80b95f583ab164$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $3d80b95f583ab164$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var $3d80b95f583ab164$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** `Object#toString` result references. */ var $3d80b95f583ab164$var$funcTag = '[object Function]', $3d80b95f583ab164$var$genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $3d80b95f583ab164$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $3d80b95f583ab164$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $3d80b95f583ab164$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $3d80b95f583ab164$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $3d80b95f583ab164$var$root = $3d80b95f583ab164$var$freeGlobal || $3d80b95f583ab164$var$freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $3d80b95f583ab164$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $3d80b95f583ab164$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $3d80b95f583ab164$var$arrayProto = Array.prototype, $3d80b95f583ab164$var$funcProto = Function.prototype, $3d80b95f583ab164$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $3d80b95f583ab164$var$coreJsData = $3d80b95f583ab164$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $3d80b95f583ab164$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($3d80b95f583ab164$var$coreJsData && $3d80b95f583ab164$var$coreJsData.keys && $3d80b95f583ab164$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $3d80b95f583ab164$var$funcToString = $3d80b95f583ab164$var$funcProto.toString;
/** Used to check objects for own properties. */ var $3d80b95f583ab164$var$hasOwnProperty = $3d80b95f583ab164$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3d80b95f583ab164$var$objectToString = $3d80b95f583ab164$var$objectProto.toString;
/** Used to detect if a method is native. */ var $3d80b95f583ab164$var$reIsNative = RegExp('^' + $3d80b95f583ab164$var$funcToString.call($3d80b95f583ab164$var$hasOwnProperty).replace($3d80b95f583ab164$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $3d80b95f583ab164$var$splice = $3d80b95f583ab164$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $3d80b95f583ab164$var$Map = $3d80b95f583ab164$var$getNative($3d80b95f583ab164$var$root, 'Map'), $3d80b95f583ab164$var$nativeCreate = $3d80b95f583ab164$var$getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3d80b95f583ab164$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $3d80b95f583ab164$var$hashClear() {
    this.__data__ = $3d80b95f583ab164$var$nativeCreate ? $3d80b95f583ab164$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3d80b95f583ab164$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3d80b95f583ab164$var$hashGet(key) {
    var data = this.__data__;
    if ($3d80b95f583ab164$var$nativeCreate) {
        var result = data[key];
        return result === $3d80b95f583ab164$var$HASH_UNDEFINED ? undefined : result;
    }
    return $3d80b95f583ab164$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d80b95f583ab164$var$hashHas(key) {
    var data = this.__data__;
    return $3d80b95f583ab164$var$nativeCreate ? data[key] !== undefined : $3d80b95f583ab164$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $3d80b95f583ab164$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $3d80b95f583ab164$var$nativeCreate && value === undefined ? $3d80b95f583ab164$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$3d80b95f583ab164$var$Hash.prototype.clear = $3d80b95f583ab164$var$hashClear;
$3d80b95f583ab164$var$Hash.prototype['delete'] = $3d80b95f583ab164$var$hashDelete;
$3d80b95f583ab164$var$Hash.prototype.get = $3d80b95f583ab164$var$hashGet;
$3d80b95f583ab164$var$Hash.prototype.has = $3d80b95f583ab164$var$hashHas;
$3d80b95f583ab164$var$Hash.prototype.set = $3d80b95f583ab164$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3d80b95f583ab164$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $3d80b95f583ab164$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3d80b95f583ab164$var$listCacheDelete(key) {
    var data = this.__data__, index = $3d80b95f583ab164$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $3d80b95f583ab164$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3d80b95f583ab164$var$listCacheGet(key) {
    var data = this.__data__, index = $3d80b95f583ab164$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d80b95f583ab164$var$listCacheHas(key) {
    return $3d80b95f583ab164$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $3d80b95f583ab164$var$listCacheSet(key, value) {
    var data = this.__data__, index = $3d80b95f583ab164$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$3d80b95f583ab164$var$ListCache.prototype.clear = $3d80b95f583ab164$var$listCacheClear;
$3d80b95f583ab164$var$ListCache.prototype['delete'] = $3d80b95f583ab164$var$listCacheDelete;
$3d80b95f583ab164$var$ListCache.prototype.get = $3d80b95f583ab164$var$listCacheGet;
$3d80b95f583ab164$var$ListCache.prototype.has = $3d80b95f583ab164$var$listCacheHas;
$3d80b95f583ab164$var$ListCache.prototype.set = $3d80b95f583ab164$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3d80b95f583ab164$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $3d80b95f583ab164$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $3d80b95f583ab164$var$Hash,
        'map': new ($3d80b95f583ab164$var$Map || $3d80b95f583ab164$var$ListCache),
        'string': new $3d80b95f583ab164$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3d80b95f583ab164$var$mapCacheDelete(key) {
    return $3d80b95f583ab164$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3d80b95f583ab164$var$mapCacheGet(key) {
    return $3d80b95f583ab164$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d80b95f583ab164$var$mapCacheHas(key) {
    return $3d80b95f583ab164$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3d80b95f583ab164$var$mapCacheSet(key, value) {
    $3d80b95f583ab164$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$3d80b95f583ab164$var$MapCache.prototype.clear = $3d80b95f583ab164$var$mapCacheClear;
$3d80b95f583ab164$var$MapCache.prototype['delete'] = $3d80b95f583ab164$var$mapCacheDelete;
$3d80b95f583ab164$var$MapCache.prototype.get = $3d80b95f583ab164$var$mapCacheGet;
$3d80b95f583ab164$var$MapCache.prototype.has = $3d80b95f583ab164$var$mapCacheHas;
$3d80b95f583ab164$var$MapCache.prototype.set = $3d80b95f583ab164$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $3d80b95f583ab164$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($3d80b95f583ab164$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $3d80b95f583ab164$var$baseIsNative(value) {
    if (!$3d80b95f583ab164$var$isObject(value) || $3d80b95f583ab164$var$isMasked(value)) return false;
    var pattern = $3d80b95f583ab164$var$isFunction(value) || $3d80b95f583ab164$var$isHostObject(value) ? $3d80b95f583ab164$var$reIsNative : $3d80b95f583ab164$var$reIsHostCtor;
    return pattern.test($3d80b95f583ab164$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $3d80b95f583ab164$var$getMapData(map, key) {
    var data = map.__data__;
    return $3d80b95f583ab164$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $3d80b95f583ab164$var$getNative(object, key) {
    var value = $3d80b95f583ab164$var$getValue(object, key);
    return $3d80b95f583ab164$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $3d80b95f583ab164$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $3d80b95f583ab164$var$isMasked(func) {
    return !!$3d80b95f583ab164$var$maskSrcKey && $3d80b95f583ab164$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $3d80b95f583ab164$var$toSource(func) {
    if (func != null) {
        try {
            return $3d80b95f583ab164$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $3d80b95f583ab164$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError($3d80b95f583ab164$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($3d80b95f583ab164$var$memoize.Cache || $3d80b95f583ab164$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$3d80b95f583ab164$var$memoize.Cache = $3d80b95f583ab164$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $3d80b95f583ab164$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3d80b95f583ab164$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $3d80b95f583ab164$var$isObject(value) ? $3d80b95f583ab164$var$objectToString.call(value) : '';
    return tag == $3d80b95f583ab164$var$funcTag || tag == $3d80b95f583ab164$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3d80b95f583ab164$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
$3d80b95f583ab164$exports = $3d80b95f583ab164$var$memoize;


var $9f6cc918bbd0f399$export$402e76927ebf6a24 = [];


var $44d5933aae3bd66d$export$63c81bd924f89474 = function() {
    return (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $ca048bcf49b62a94$export$8ca35300535e324d = function() {
    return (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $1fe74cf0a2ddb5d8$var$msg = 'ResizeObserver loop completed with undelivered notifications.';
var $1fe74cf0a2ddb5d8$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: $1fe74cf0a2ddb5d8$var$msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = $1fe74cf0a2ddb5d8$var$msg;
    }
    window.dispatchEvent(event);
};



var $8314067dec4b2950$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($8314067dec4b2950$export$416d111b83cd1483 || ($8314067dec4b2950$export$416d111b83cd1483 = {}));


var $76d63437f73f4f9f$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $30aaee0efb79fe49$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $76d63437f73f4f9f$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $17bf486e956e5d87$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $76d63437f73f4f9f$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $80f87743c2cc41ed$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var $80f87743c2cc41ed$export$ee695c13482bb5dd = function(target) {
    if ($80f87743c2cc41ed$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $80f87743c2cc41ed$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $80f87743c2cc41ed$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};



var $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af = typeof window !== 'undefined' ? window : {};


var $a77d2204e7ff4fc3$var$cache = new WeakMap();
var $a77d2204e7ff4fc3$var$scrollRegexp = /auto|scroll/;
var $a77d2204e7ff4fc3$var$verticalRegexp = /^tb|vertical/;
var $a77d2204e7ff4fc3$var$IE = /msie|trident/i.test((0, $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af).navigator && (0, $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af).navigator.userAgent);
var $a77d2204e7ff4fc3$var$parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var $a77d2204e7ff4fc3$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $30aaee0efb79fe49$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $a77d2204e7ff4fc3$var$zeroBoxes = (0, $76d63437f73f4f9f$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $a77d2204e7ff4fc3$var$size(),
    borderBoxSize: $a77d2204e7ff4fc3$var$size(),
    contentBoxSize: $a77d2204e7ff4fc3$var$size(),
    contentRect: new (0, $17bf486e956e5d87$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $a77d2204e7ff4fc3$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($a77d2204e7ff4fc3$var$cache.has(target) && !forceRecalculation) return $a77d2204e7ff4fc3$var$cache.get(target);
    if ((0, $80f87743c2cc41ed$export$ee695c13482bb5dd)(target)) {
        $a77d2204e7ff4fc3$var$cache.set(target, $a77d2204e7ff4fc3$var$zeroBoxes);
        return $a77d2204e7ff4fc3$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $80f87743c2cc41ed$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$a77d2204e7ff4fc3$var$IE && cs.boxSizing === 'border-box';
    var switchSizes = $a77d2204e7ff4fc3$var$verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && $a77d2204e7ff4fc3$var$scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && $a77d2204e7ff4fc3$var$scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $a77d2204e7ff4fc3$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $a77d2204e7ff4fc3$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $a77d2204e7ff4fc3$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $76d63437f73f4f9f$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $a77d2204e7ff4fc3$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $a77d2204e7ff4fc3$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $a77d2204e7ff4fc3$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $17bf486e956e5d87$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $a77d2204e7ff4fc3$var$cache.set(target, boxes);
    return boxes;
};
var $a77d2204e7ff4fc3$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $a77d2204e7ff4fc3$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $8314067dec4b2950$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $8314067dec4b2950$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $d5be95add2fa60d9$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $a77d2204e7ff4fc3$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $76d63437f73f4f9f$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $76d63437f73f4f9f$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $76d63437f73f4f9f$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $74f7269ef8367517$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $80f87743c2cc41ed$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $af2802e502a5e189$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $d5be95add2fa60d9$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $74f7269ef8367517$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $a77d2204e7ff4fc3$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $83ed81c9ea1756c2$export$9c17b8913a2a3572 = function(depth) {
    (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $74f7269ef8367517$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $f8517573e873feed$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $83ed81c9ea1756c2$export$9c17b8913a2a3572)(depth);
    while((0, $44d5933aae3bd66d$export$63c81bd924f89474)()){
        depth = (0, $af2802e502a5e189$export$9cac928141e5443b)();
        (0, $83ed81c9ea1756c2$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $ca048bcf49b62a94$export$8ca35300535e324d)()) (0, $1fe74cf0a2ddb5d8$export$888cb69481582149)();
    return depth > 0;
};



var $630e9c3d4d5be402$var$trigger;
var $630e9c3d4d5be402$var$callbacks = [];
var $630e9c3d4d5be402$var$notify = function() {
    return $630e9c3d4d5be402$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $630e9c3d4d5be402$export$4c995d4933c4abb = function(callback) {
    if (!$630e9c3d4d5be402$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $630e9c3d4d5be402$var$notify();
        }).observe(el_1, config);
        $630e9c3d4d5be402$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $630e9c3d4d5be402$var$callbacks.push(callback);
    $630e9c3d4d5be402$var$trigger();
};


var $8625626a068d8071$export$5755c7b572e34c6 = function(cb) {
    (0, $630e9c3d4d5be402$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $ceaa7b0fb49ab085$var$watching = 0;
var $ceaa7b0fb49ab085$var$isWatching = function() {
    return !!$ceaa7b0fb49ab085$var$watching;
};
var $ceaa7b0fb49ab085$var$CATCH_PERIOD = 250;
var $ceaa7b0fb49ab085$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $ceaa7b0fb49ab085$var$events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var $ceaa7b0fb49ab085$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $ceaa7b0fb49ab085$var$scheduled = false;
var $ceaa7b0fb49ab085$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $ceaa7b0fb49ab085$var$CATCH_PERIOD;
        if ($ceaa7b0fb49ab085$var$scheduled) return;
        $ceaa7b0fb49ab085$var$scheduled = true;
        var until = $ceaa7b0fb49ab085$var$time(timeout);
        (0, $8625626a068d8071$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $f8517573e873feed$export$e54fe5b0f43758f7)();
            } finally{
                $ceaa7b0fb49ab085$var$scheduled = false;
                timeout = until - $ceaa7b0fb49ab085$var$time();
                if (!$ceaa7b0fb49ab085$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $ceaa7b0fb49ab085$var$observerConfig);
        };
        document.body ? cb() : (0, $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $ceaa7b0fb49ab085$var$events.forEach(function(name) {
                return (0, $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $ceaa7b0fb49ab085$var$events.forEach(function(name) {
                return (0, $9b2ebe639ac9e1e0$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $ceaa7b0fb49ab085$export$d30788f2c20241cd = new $ceaa7b0fb49ab085$var$Scheduler();
var $ceaa7b0fb49ab085$export$1f18a74d42722835 = function(n) {
    !$ceaa7b0fb49ab085$var$watching && n > 0 && $ceaa7b0fb49ab085$export$d30788f2c20241cd.start();
    $ceaa7b0fb49ab085$var$watching += n;
    !$ceaa7b0fb49ab085$var$watching && $ceaa7b0fb49ab085$export$d30788f2c20241cd.stop();
};





var $6f08a140fa0cf6f3$var$skipNotifyOnElement = function(target) {
    return !(0, $80f87743c2cc41ed$export$165b39ed277223c2)(target) && !(0, $80f87743c2cc41ed$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === 'inline';
};
var $6f08a140fa0cf6f3$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $8314067dec4b2950$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $a77d2204e7ff4fc3$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($6f08a140fa0cf6f3$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $3c10bfd5b2fe44df$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $0a4dd209e7047afa$var$observerMap = new WeakMap();
var $0a4dd209e7047afa$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $0a4dd209e7047afa$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $3c10bfd5b2fe44df$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $0a4dd209e7047afa$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $0a4dd209e7047afa$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($0a4dd209e7047afa$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $6f08a140fa0cf6f3$export$fea412043713122)(target, options && options.box));
            (0, $ceaa7b0fb49ab085$export$1f18a74d42722835)(1);
            (0, $ceaa7b0fb49ab085$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $0a4dd209e7047afa$var$observerMap.get(resizeObserver);
        var index = $0a4dd209e7047afa$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $9f6cc918bbd0f399$export$402e76927ebf6a24).splice((0, $9f6cc918bbd0f399$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $ceaa7b0fb49ab085$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $0a4dd209e7047afa$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $31609950d3966c62$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $0a4dd209e7047afa$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $80f87743c2cc41ed$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $0a4dd209e7047afa$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $80f87743c2cc41ed$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $0a4dd209e7047afa$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $0a4dd209e7047afa$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();






var $b696bbfb437150c8$exports = {};
var $b696bbfb437150c8$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
$b696bbfb437150c8$exports = $b696bbfb437150c8$var$canUseDOM;


'use strict';

var $471f29b552388c63$exports = {};
'use strict';




var $471f29b552388c63$var$$TypeError = TypeError;
var $471f29b552388c63$var$REDUCE_EMPTY = 'Reduce of empty array with no initial value';
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $471f29b552388c63$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $c9b4f3ef4a96c778$exports(that);
        var self = $9d1a1577a6ed79d1$exports(O);
        var length = $86912fee58c01fd8$exports(O);
        $a339c863cff407d1$exports(callbackfn);
        if (length === 0 && argumentsLength < 2) throw new $471f29b552388c63$var$$TypeError($471f29b552388c63$var$REDUCE_EMPTY);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $471f29b552388c63$var$$TypeError($471f29b552388c63$var$REDUCE_EMPTY);
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$471f29b552388c63$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $471f29b552388c63$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $471f29b552388c63$var$createMethod(true)
};


var $b5b769674ac65a84$require$$reduce = $471f29b552388c63$exports.left;
var $517ea068d2123fd0$exports = {};
'use strict';

$517ea068d2123fd0$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $1c0f139a1a463ce1$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};



var $58598a0d333d35d4$exports = {};
'use strict';
var $04be41523ca41528$exports = {};
'use strict';



var $04be41523ca41528$var$userAgentStartsWith = function(string) {
    return $7f1a0e28c2927ca0$exports.slice(0, string.length) === string;
};
$04be41523ca41528$exports = function() {
    if ($04be41523ca41528$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($04be41523ca41528$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($04be41523ca41528$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($04be41523ca41528$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($f73c1cbf36add1e3$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($f73c1cbf36add1e3$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($f65b6a6904086b61$exports($f73c1cbf36add1e3$exports.process) === 'process') return 'NODE';
    if ($f73c1cbf36add1e3$exports.window && $f73c1cbf36add1e3$exports.document) return 'BROWSER';
    return 'REST';
}();


$58598a0d333d35d4$exports = $04be41523ca41528$exports === 'NODE';


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $b5b769674ac65a84$var$CHROME_BUG = !$58598a0d333d35d4$exports && $76342eacb009e653$exports > 79 && $76342eacb009e653$exports < 83;
var $b5b769674ac65a84$var$FORCED = $b5b769674ac65a84$var$CHROME_BUG || !$517ea068d2123fd0$exports('reduce');
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$621e6bc7a2f56e42$exports({
    target: 'Array',
    proto: true,
    forced: $b5b769674ac65a84$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $b5b769674ac65a84$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


'use strict';

var $743bfc98b506a5f7$exports = {};
'use strict';



var $3aa38f04e131e4f8$exports = {};
'use strict';

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$3aa38f04e131e4f8$exports = function() {
    var that = $c53804bbcc663539$exports(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};


var $d4aad8f9752f515c$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $d4aad8f9752f515c$var$$RegExp = $f73c1cbf36add1e3$exports.RegExp;
var $d4aad8f9752f515c$var$UNSUPPORTED_Y = $1c0f139a1a463ce1$exports(function() {
    var re = $d4aad8f9752f515c$var$$RegExp('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $d4aad8f9752f515c$var$MISSED_STICKY = $d4aad8f9752f515c$var$UNSUPPORTED_Y || $1c0f139a1a463ce1$exports(function() {
    return !$d4aad8f9752f515c$var$$RegExp('a', 'y').sticky;
});
var $d4aad8f9752f515c$var$BROKEN_CARET = $d4aad8f9752f515c$var$UNSUPPORTED_Y || $1c0f139a1a463ce1$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $d4aad8f9752f515c$var$$RegExp('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') !== null;
});
$d4aad8f9752f515c$exports = {
    BROKEN_CARET: $d4aad8f9752f515c$var$BROKEN_CARET,
    MISSED_STICKY: $d4aad8f9752f515c$var$MISSED_STICKY,
    UNSUPPORTED_Y: $d4aad8f9752f515c$var$UNSUPPORTED_Y
};





var $743bfc98b506a5f7$require$getInternalState = $033d4cca21ca5361$exports.get;
var $1bd6d24d1518b39c$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $1bd6d24d1518b39c$var$$RegExp = $f73c1cbf36add1e3$exports.RegExp;
$1bd6d24d1518b39c$exports = $1c0f139a1a463ce1$exports(function() {
    var re = $1bd6d24d1518b39c$var$$RegExp('.', 's');
    return !(re.dotAll && re.test('\n') && re.flags === 's');
});


var $c010815a869b49b5$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $c010815a869b49b5$var$$RegExp = $f73c1cbf36add1e3$exports.RegExp;
$c010815a869b49b5$exports = $1c0f139a1a463ce1$exports(function() {
    var re = $c010815a869b49b5$var$$RegExp('(?<a>b)', 'g');
    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});


var $743bfc98b506a5f7$var$nativeReplace = $9b42448d053bd3c4$exports('native-string-replace', String.prototype.replace);
var $743bfc98b506a5f7$var$nativeExec = RegExp.prototype.exec;
var $743bfc98b506a5f7$var$patchedExec = $743bfc98b506a5f7$var$nativeExec;
var $743bfc98b506a5f7$var$charAt = $86d27fcf3ddb374a$exports(''.charAt);
var $743bfc98b506a5f7$var$indexOf = $86d27fcf3ddb374a$exports(''.indexOf);
var $743bfc98b506a5f7$var$replace = $86d27fcf3ddb374a$exports(''.replace);
var $743bfc98b506a5f7$var$stringSlice = $86d27fcf3ddb374a$exports(''.slice);
var $743bfc98b506a5f7$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $ba3e81ca5de34305$exports($743bfc98b506a5f7$var$nativeExec, re1, 'a');
    $ba3e81ca5de34305$exports($743bfc98b506a5f7$var$nativeExec, re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $743bfc98b506a5f7$var$UNSUPPORTED_Y = $d4aad8f9752f515c$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $743bfc98b506a5f7$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $743bfc98b506a5f7$var$PATCH = $743bfc98b506a5f7$var$UPDATES_LAST_INDEX_WRONG || $743bfc98b506a5f7$var$NPCG_INCLUDED || $743bfc98b506a5f7$var$UNSUPPORTED_Y || $1bd6d24d1518b39c$exports || $c010815a869b49b5$exports;
if ($743bfc98b506a5f7$var$PATCH) $743bfc98b506a5f7$var$patchedExec = function exec(string) {
    var re = this;
    var state = $743bfc98b506a5f7$require$getInternalState(re);
    var str = $0f08e96df1c6e400$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $ba3e81ca5de34305$exports($743bfc98b506a5f7$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $743bfc98b506a5f7$var$UNSUPPORTED_Y && re.sticky;
    var flags = $ba3e81ca5de34305$exports($3aa38f04e131e4f8$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $743bfc98b506a5f7$var$replace(flags, 'y', '');
        if ($743bfc98b506a5f7$var$indexOf(flags, 'g') === -1) flags += 'g';
        strCopy = $743bfc98b506a5f7$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $743bfc98b506a5f7$var$charAt(str, re.lastIndex - 1) !== '\n')) {
            source = '(?: ' + source + ')';
            strCopy = ' ' + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if ($743bfc98b506a5f7$var$NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    if ($743bfc98b506a5f7$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $ba3e81ca5de34305$exports($743bfc98b506a5f7$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $743bfc98b506a5f7$var$stringSlice(match.input, charsAdded);
            match[0] = $743bfc98b506a5f7$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($743bfc98b506a5f7$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($743bfc98b506a5f7$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $ba3e81ca5de34305$exports($743bfc98b506a5f7$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $ee4937dd0bdfcee6$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$743bfc98b506a5f7$exports = $743bfc98b506a5f7$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$621e6bc7a2f56e42$exports({
    target: 'RegExp',
    proto: true,
    forced: /./.exec !== $743bfc98b506a5f7$exports
}, {
    exec: $743bfc98b506a5f7$exports
});


'use strict';

var $99ec118ba57bfc2e$exports = {};
'use strict';







var $99ec118ba57bfc2e$var$SPECIES = $06b7b285e3a7068a$exports('species');
var $99ec118ba57bfc2e$var$RegExpPrototype = RegExp.prototype;
$99ec118ba57bfc2e$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $06b7b285e3a7068a$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$1c0f139a1a463ce1$exports(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$1c0f139a1a463ce1$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === 'split') {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$99ec118ba57bfc2e$var$SPECIES] = function() {
                return re;
            };
            re.flags = '';
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]('');
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === $743bfc98b506a5f7$exports || $exec === $99ec118ba57bfc2e$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: $ba3e81ca5de34305$exports(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: $ba3e81ca5de34305$exports(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $cc8a5761541cd35d$exports(String.prototype, KEY, methods[0]);
        $cc8a5761541cd35d$exports($99ec118ba57bfc2e$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $3d5a463be44ffeea$exports($99ec118ba57bfc2e$var$RegExpPrototype[SYMBOL], 'sham', true);
};








var $a4fcf085d59bf86c$exports = {};
'use strict';

var $a4fcf085d59bf86c$require$charAt = $ac5e43fd8976501e$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$a4fcf085d59bf86c$exports = function(S, index, unicode) {
    return index + (unicode ? $a4fcf085d59bf86c$require$charAt(S, index).length : 1);
};


var $a9f5a13b846be821$exports = {};
'use strict';





var $a9f5a13b846be821$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$a9f5a13b846be821$exports = function(R, S) {
    var exec = R.exec;
    if ($da9965769ab8d492$exports(exec)) {
        var result = $ba3e81ca5de34305$exports(exec, R, S);
        if (result !== null) $c53804bbcc663539$exports(result);
        return result;
    }
    if ($f65b6a6904086b61$exports(R) === 'RegExp') return $ba3e81ca5de34305$exports($743bfc98b506a5f7$exports, R, S);
    throw new $a9f5a13b846be821$var$$TypeError('RegExp#exec called on incompatible receiver');
};


// @@match logic
$99ec118ba57bfc2e$exports('match', function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $ce17aed0e5032df3$exports(this);
            var matcher = $896d3aa83f9594d3$exports(regexp) ? undefined : $ea805a34e9f0856a$exports(regexp, MATCH);
            return matcher ? $ba3e81ca5de34305$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($0f08e96df1c6e400$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $c53804bbcc663539$exports(this);
            var S = $0f08e96df1c6e400$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $a9f5a13b846be821$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $a9f5a13b846be821$exports(rx, S)) !== null){
                var matchStr = $0f08e96df1c6e400$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = $a4fcf085d59bf86c$exports(S, $d6e59aaba77a5f67$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


'use strict';


var $695195722cd8c925$require$FUNCTION_NAME_EXISTS = $b82122a7f3a0fd21$exports.EXISTS;

var $aa953b3cd6d43062$exports = {};
'use strict';


$aa953b3cd6d43062$exports = function(target, name, descriptor) {
    if (descriptor.get) $157fbe5a4073e8a8$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $157fbe5a4073e8a8$exports(descriptor.set, name, {
        setter: true
    });
    return $96bd28438ee2eee5$export$2d1720544b23b823(target, name, descriptor);
};


var $695195722cd8c925$var$FunctionPrototype = Function.prototype;
var $695195722cd8c925$var$functionToString = $86d27fcf3ddb374a$exports($695195722cd8c925$var$FunctionPrototype.toString);
var $695195722cd8c925$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $695195722cd8c925$var$regExpExec = $86d27fcf3ddb374a$exports($695195722cd8c925$var$nameRE.exec);
var $695195722cd8c925$var$NAME = 'name';
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($a934004253d25a42$exports && !$695195722cd8c925$require$FUNCTION_NAME_EXISTS) $aa953b3cd6d43062$exports($695195722cd8c925$var$FunctionPrototype, $695195722cd8c925$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return $695195722cd8c925$var$regExpExec($695195722cd8c925$var$nameRE, $695195722cd8c925$var$functionToString(this))[1];
        } catch (error) {
            return '';
        }
    }
});


'use strict';
var $1ca25e06778db054$exports = {};
'use strict';

var $1ca25e06778db054$var$FunctionPrototype = Function.prototype;
var $1ca25e06778db054$var$apply = $1ca25e06778db054$var$FunctionPrototype.apply;
var $1ca25e06778db054$var$call = $1ca25e06778db054$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$1ca25e06778db054$exports = typeof Reflect == 'object' && Reflect.apply || ($13cf557f31fcb3db$exports ? $1ca25e06778db054$var$call.bind($1ca25e06778db054$var$apply) : function() {
    return $1ca25e06778db054$var$call.apply($1ca25e06778db054$var$apply, arguments);
});















var $2c1a80e70d71e019$exports = {};
'use strict';


var $2c1a80e70d71e019$var$floor = Math.floor;
var $2c1a80e70d71e019$var$charAt = $86d27fcf3ddb374a$exports(''.charAt);
var $2c1a80e70d71e019$var$replace = $86d27fcf3ddb374a$exports(''.replace);
var $2c1a80e70d71e019$var$stringSlice = $86d27fcf3ddb374a$exports(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $2c1a80e70d71e019$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $2c1a80e70d71e019$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$2c1a80e70d71e019$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $2c1a80e70d71e019$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $c9b4f3ef4a96c778$exports(namedCaptures);
        symbols = $2c1a80e70d71e019$var$SUBSTITUTION_SYMBOLS;
    }
    return $2c1a80e70d71e019$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($2c1a80e70d71e019$var$charAt(ch, 0)){
            case '$':
                return '$';
            case '&':
                return matched;
            case '`':
                return $2c1a80e70d71e019$var$stringSlice(str, 0, position);
            case "'":
                return $2c1a80e70d71e019$var$stringSlice(str, tailPos);
            case '<':
                capture = namedCaptures[$2c1a80e70d71e019$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $2c1a80e70d71e019$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $2c1a80e70d71e019$var$charAt(ch, 1) : captures[f - 1] + $2c1a80e70d71e019$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? '' : capture;
    });
};




var $973427c5c04dbb8a$var$REPLACE = $06b7b285e3a7068a$exports('replace');
var $973427c5c04dbb8a$var$max = Math.max;
var $973427c5c04dbb8a$var$min = Math.min;
var $973427c5c04dbb8a$var$concat = $86d27fcf3ddb374a$exports([].concat);
var $973427c5c04dbb8a$var$push = $86d27fcf3ddb374a$exports([].push);
var $973427c5c04dbb8a$var$stringIndexOf = $86d27fcf3ddb374a$exports(''.indexOf);
var $973427c5c04dbb8a$var$stringSlice = $86d27fcf3ddb374a$exports(''.slice);
var $973427c5c04dbb8a$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $973427c5c04dbb8a$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return 'a'.replace(/./, '$0') === '$0';
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $973427c5c04dbb8a$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$973427c5c04dbb8a$var$REPLACE]) return /./[$973427c5c04dbb8a$var$REPLACE]('a', '$0') === '';
    return false;
}();
var $973427c5c04dbb8a$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$1c0f139a1a463ce1$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return ''.replace(re, '$<a>') !== '7';
});
// @@replace logic
$99ec118ba57bfc2e$exports('replace', function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $973427c5c04dbb8a$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $ce17aed0e5032df3$exports(this);
            var replacer = $896d3aa83f9594d3$exports(searchValue) ? undefined : $ea805a34e9f0856a$exports(searchValue, $973427c5c04dbb8a$var$REPLACE);
            return replacer ? $ba3e81ca5de34305$exports(replacer, searchValue, O, replaceValue) : $ba3e81ca5de34305$exports(nativeReplace, $0f08e96df1c6e400$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $c53804bbcc663539$exports(this);
            var S = $0f08e96df1c6e400$exports(string);
            if (typeof replaceValue == 'string' && $973427c5c04dbb8a$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $973427c5c04dbb8a$var$stringIndexOf(replaceValue, '$<') === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $da9965769ab8d492$exports(replaceValue);
            if (!functionalReplace) replaceValue = $0f08e96df1c6e400$exports(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $a9f5a13b846be821$exports(rx, S);
                if (result === null) break;
                $973427c5c04dbb8a$var$push(results, result);
                if (!global) break;
                var matchStr = $0f08e96df1c6e400$exports(result[0]);
                if (matchStr === '') rx.lastIndex = $a4fcf085d59bf86c$exports(S, $d6e59aaba77a5f67$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $0f08e96df1c6e400$exports(result[0]);
                var position = $973427c5c04dbb8a$var$max($973427c5c04dbb8a$var$min($8abe88bfd140bd58$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$973427c5c04dbb8a$var$push(captures, $973427c5c04dbb8a$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $973427c5c04dbb8a$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $973427c5c04dbb8a$var$push(replacerArgs, namedCaptures);
                    replacement = $0f08e96df1c6e400$exports($1ca25e06778db054$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $2c1a80e70d71e019$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $973427c5c04dbb8a$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $973427c5c04dbb8a$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$973427c5c04dbb8a$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$973427c5c04dbb8a$var$REPLACE_KEEPS_$0 || $973427c5c04dbb8a$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


function $8cbbb70f74567bd0$var$getElementWindow(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $8cbbb70f74567bd0$var$getElementDocument(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
var $8cbbb70f74567bd0$var$cachedScrollbarWidth = null;
var $8cbbb70f74567bd0$var$cachedDevicePixelRatio = null;
if (0, (/*@__PURE__*/$parcel$interopDefault($b696bbfb437150c8$exports))) window.addEventListener('resize', function() {
    if ($8cbbb70f74567bd0$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $8cbbb70f74567bd0$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $8cbbb70f74567bd0$var$cachedScrollbarWidth = null;
    }
});
function $8cbbb70f74567bd0$var$scrollbarWidth(el) {
    if ($8cbbb70f74567bd0$var$cachedScrollbarWidth === null) {
        var document1 = $8cbbb70f74567bd0$var$getElementDocument(el);
        if (typeof document1 === 'undefined') {
            $8cbbb70f74567bd0$var$cachedScrollbarWidth = 0;
            return $8cbbb70f74567bd0$var$cachedScrollbarWidth;
        }
        var body = document1.body;
        var box = document1.createElement('div');
        box.classList.add('simplebar-hide-scrollbar');
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $8cbbb70f74567bd0$var$cachedScrollbarWidth = width;
    }
    return $8cbbb70f74567bd0$var$cachedScrollbarWidth;
}
var $8cbbb70f74567bd0$var$SimpleBar = /*#__PURE__*/ function() {
    function SimpleBar(element, options) {
        var _this = this;
        this.onScroll = function() {
            var elWindow = $8cbbb70f74567bd0$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) {
                _this.showScrollbar('x');
                _this.positionScrollbar('x');
            }
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) {
                _this.showScrollbar('y');
                _this.positionScrollbar('y');
            }
            _this.scrollYTicking = false;
        };
        this.onMouseEnter = function() {
            _this.showScrollbar('x');
            _this.showScrollbar('y');
        };
        this.onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis('x');
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis('y');
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis('x');
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis('y');
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this.onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.hideScrollbars = function() {
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (!_this.isWithinBounds(_this.axis.y.track.rect)) {
                _this.axis.y.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.y.isVisible = false;
            }
            if (!_this.isWithinBounds(_this.axis.x.track.rect)) {
                _this.axis.x.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.x.isVisible = false;
            }
        };
        this.onPointerEvent = function(e) {
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
             // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Preventing the event's default action stops text being
                // selectable during the drag.
                e.preventDefault(); // Prevent event leaking
                e.stopPropagation();
                if (e.type === 'mousedown') {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, 'x');
                        else _this.onTrackClick(e, 'x');
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, 'y');
                        else _this.onTrackClick(e, 'y');
                    }
                }
            }
        };
        this.drag = function(e) {
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = track.rect[_this.axis[_this.draggedAxis].sizeAttr];
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollSizeAttr];
            var hostSize = parseInt(_this.elStyles[_this.axis[_this.draggedAxis].sizeAttr], 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === 'y') eventOffset = e.pageY;
            else eventOffset = e.pageX;
             // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - track.rect[_this.axis[_this.draggedAxis].offsetAttr] - _this.axis[_this.draggedAxis].dragOffset; // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size); // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize); // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === 'x') {
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? scrollPos - (trackSize + scrollbar.size) : scrollPos;
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollPos : scrollPos;
            }
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        this.onEndDrag = function(e) {
            var elDocument = $8cbbb70f74567bd0$var$getElementDocument(_this.el);
            var elWindow = $8cbbb70f74567bd0$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            _this.el.classList.remove(_this.classNames.dragging);
            elDocument.removeEventListener('mousemove', _this.drag, true);
            elDocument.removeEventListener('mouseup', _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener('click', _this.preventClick, true);
                elDocument.removeEventListener('dblclick', _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.minScrollbarWidth = 20;
        this.options = Object.assign({}, SimpleBar.defaultOptions, options);
        this.classNames = Object.assign({}, SimpleBar.defaultOptions.classNames, this.options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: 'scrollLeft',
                sizeAttr: 'width',
                scrollSizeAttr: 'scrollWidth',
                offsetSizeAttr: 'offsetWidth',
                offsetAttr: 'left',
                overflowAttr: 'overflowX',
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            },
            y: {
                scrollOffsetAttr: 'scrollTop',
                sizeAttr: 'height',
                scrollSizeAttr: 'scrollHeight',
                offsetSizeAttr: 'offsetHeight',
                offsetAttr: 'top',
                overflowAttr: 'overflowY',
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            }
        };
        this.removePreventClickId = null; // Don't re-instantiate over an existing one
        if (SimpleBar.instances.has(this.el)) return;
        this.recalculate = (0, (/*@__PURE__*/$parcel$interopDefault($ac15e73f2bda9226$exports)))(this.recalculate.bind(this), 64);
        this.onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($ac15e73f2bda9226$exports)))(this.onMouseMove.bind(this), 64);
        this.hideScrollbars = (0, (/*@__PURE__*/$parcel$interopDefault($b38ef1abffe94323$exports)))(this.hideScrollbars.bind(this), this.options.timeout);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($b38ef1abffe94323$exports)))(this.onWindowResize.bind(this), 64, {
            leading: true
        });
        SimpleBar.getRtlHelpers = (0, (/*@__PURE__*/$parcel$interopDefault($3d80b95f583ab164$exports)))(SimpleBar.getRtlHelpers);
        this.init();
    }
    /**
   * Static properties
   */ /**
   * Helper to fix browsers inconsistency on RTL:
   *  - Firefox inverts the scrollbar initial position
   *  - IE11 inverts both scrollbar position and scrolling offset
   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
   */ SimpleBar.getRtlHelpers = function getRtlHelpers() {
        var dummyDiv = document.createElement('div');
        dummyDiv.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        document.body.appendChild(scrollbarDummyEl);
        var dummyContainerChild = scrollbarDummyEl.firstElementChild;
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBar.getOffset(scrollbarDummyEl);
        var dummyContainerChildOffset = SimpleBar.getOffset(dummyContainerChild);
        scrollbarDummyEl.scrollLeft = 999;
        var dummyContainerScrollOffsetAfterScroll = SimpleBar.getOffset(dummyContainerChild);
        return {
            // determines if the scrolling is responding with negative values
            isRtlScrollingInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left && dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left !== 0,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isRtlScrollbarInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left
        };
    };
    SimpleBar.getOffset = function getOffset(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $8cbbb70f74567bd0$var$getElementDocument(el);
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    var _proto = SimpleBar.prototype;
    _proto.init = function init() {
        // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(this.el, this); // We stop here on server-side
        if (0, (/*@__PURE__*/$parcel$interopDefault($b696bbfb437150c8$exports))) {
            this.initDOM();
            this.setAccessibilityAttributes();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    _proto.initDOM = function initDOM() {
        var _this2 = this;
        // make sure this element doesn't have the elements yet
        if (Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this2.classNames.wrapper);
        }).length) {
            // assume that element has his DOM already initiated
            this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper);
            this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper);
            this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl);
            this.offsetEl = this.el.querySelector("." + this.classNames.offset);
            this.maskEl = this.el.querySelector("." + this.classNames.mask);
            this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder);
            this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl);
            this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal);
            this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
        } else {
            // Prepare DOM
            this.wrapperEl = document.createElement('div');
            this.contentWrapperEl = document.createElement('div');
            this.offsetEl = document.createElement('div');
            this.maskEl = document.createElement('div');
            this.contentEl = document.createElement('div');
            this.placeholderEl = document.createElement('div');
            this.heightAutoObserverWrapperEl = document.createElement('div');
            this.heightAutoObserverEl = document.createElement('div');
            this.wrapperEl.classList.add(this.classNames.wrapper);
            this.contentWrapperEl.classList.add(this.classNames.contentWrapper);
            this.offsetEl.classList.add(this.classNames.offset);
            this.maskEl.classList.add(this.classNames.mask);
            this.contentEl.classList.add(this.classNames.contentEl);
            this.placeholderEl.classList.add(this.classNames.placeholder);
            this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement('div');
            var scrollbar = document.createElement('div');
            track.classList.add(this.classNames.track);
            scrollbar.classList.add(this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            this.axis.x.track.el.classList.add(this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            this.axis.y.track.el.classList.add(this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar);
        this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar);
        if (!this.options.autoHide) {
            this.axis.x.scrollbar.el.classList.add(this.classNames.visible);
            this.axis.y.scrollbar.el.classList.add(this.classNames.visible);
        }
        this.el.setAttribute('data-simplebar', 'init');
    };
    _proto.setAccessibilityAttributes = function setAccessibilityAttributes() {
        var ariaLabel = this.options.ariaLabel || 'scrollable content';
        this.contentWrapperEl.setAttribute('tabindex', '0');
        this.contentWrapperEl.setAttribute('role', 'region');
        this.contentWrapperEl.setAttribute('aria-label', ariaLabel);
    };
    _proto.initListeners = function initListeners() {
        var _this3 = this;
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.addEventListener('mouseenter', this.onMouseEnter);
        [
            'mousedown',
            'click',
            'dblclick'
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, true);
        });
        [
            'touchstart',
            'touchend',
            'touchmove'
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.addEventListener('mousemove', this.onMouseMove);
        this.el.addEventListener('mouseleave', this.onMouseLeave);
        this.contentWrapperEl.addEventListener('scroll', this.onScroll); // Browser zoom triggers a window resize
        elWindow.addEventListener('resize', this.onWindowResize); // Hack for https://github.com/WICG/ResizeObserver/issues/38
        var resizeObserverStarted = false;
        var resizeAnimationFrameId = null;
        var resizeObserver = elWindow.ResizeObserver || (0, $31609950d3966c62$export$9caf76241ca21a11);
        this.resizeObserver = new resizeObserver(function() {
            if (!resizeObserverStarted || resizeAnimationFrameId !== null) return;
            resizeAnimationFrameId = elWindow.requestAnimationFrame(function() {
                _this3.recalculate();
                resizeAnimationFrameId = null;
            });
        });
        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.contentEl);
        elWindow.requestAnimationFrame(function() {
            resizeObserverStarted = true;
        }); // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(this.recalculate);
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    _proto.recalculate = function recalculate() {
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === 'rtl';
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1;
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft;
        this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? 'auto' : '100%'; // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? contentElOffsetWidth + "px" : 'auto';
        this.placeholderEl.style.height = contentElScrollHeight + "px";
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight; // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === 'hidden' ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === 'hidden' ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === 'x' || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === 'y' || this.options.forceVisible === true;
        this.hideNativeScrollbar(); // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize('x');
        this.axis.y.scrollbar.size = this.getScrollbarSize('y');
        this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px";
        this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px";
        this.positionScrollbar('x');
        this.positionScrollbar('y');
        this.toggleTrackVisibility('x');
        this.toggleTrackVisibility('y');
    } /**
   * Calculate scrollbar size
   */ ;
    _proto.getScrollbarSize = function getScrollbarSize(axis) {
        if (axis === void 0) axis = 'y';
        if (!this.axis[axis].isOverflowing) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var scrollbarSize;
        var scrollbarRatio = trackSize / contentSize; // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    _proto.positionScrollbar = function positionScrollbar(axis) {
        if (axis === void 0) axis = 'y';
        if (!this.axis[axis].isOverflowing) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollbar = this.axis[axis].scrollbar;
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === 'x' && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollOffset : scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === 'x' && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === 'x' ? "translate3d(" + handleOffset + "px, 0, 0)" : "translate3d(0, " + handleOffset + "px, 0)";
    };
    _proto.toggleTrackVisibility = function toggleTrackVisibility(axis) {
        if (axis === void 0) axis = 'y';
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = 'visible';
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'scroll';
        } else {
            track.style.visibility = 'hidden';
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'hidden';
        } // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = 'block';
        else scrollbar.style.display = 'none';
    };
    _proto.hideNativeScrollbar = function hideNativeScrollbar() {
        this.offsetEl.style[this.isRtl ? 'left' : 'right'] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
    } /**
   * On scroll event handling
   */ ;
    _proto.onMouseMoveForAxis = function onMouseMoveForAxis(axis) {
        if (axis === void 0) axis = 'y';
        this.axis[axis].track.rect = this.axis[axis].track.el.getBoundingClientRect();
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var isWithinScrollbarBoundsX = this.isWithinBounds(this.axis[axis].scrollbar.rect);
        if (isWithinScrollbarBoundsX) this.axis[axis].scrollbar.el.classList.add(this.classNames.hover);
        else this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
        if (this.isWithinBounds(this.axis[axis].track.rect)) {
            this.showScrollbar(axis);
            this.axis[axis].track.el.classList.add(this.classNames.hover);
        } else this.axis[axis].track.el.classList.remove(this.classNames.hover);
    };
    _proto.onMouseLeaveForAxis = function onMouseLeaveForAxis(axis) {
        if (axis === void 0) axis = 'y';
        this.axis[axis].track.el.classList.remove(this.classNames.hover);
        this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
    };
    /**
   * Show scrollbar
   */ _proto.showScrollbar = function showScrollbar(axis) {
        if (axis === void 0) axis = 'y';
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!this.axis[axis].isVisible) {
            scrollbar.classList.add(this.classNames.visible);
            this.axis[axis].isVisible = true;
        }
        if (this.options.autoHide) this.hideScrollbars();
    } /**
   * Hide Scrollbar
   */ ;
    /**
   * on scrollbar handle drag movement starts
   */ _proto.onDragStart = function onDragStart(e, axis) {
        if (axis === void 0) axis = 'y';
        var elDocument = $8cbbb70f74567bd0$var$getElementDocument(this.el);
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar; // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === 'y' ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - scrollbar.rect[this.axis[axis].offsetAttr];
        this.draggedAxis = axis;
        this.el.classList.add(this.classNames.dragging);
        elDocument.addEventListener('mousemove', this.drag, true);
        elDocument.addEventListener('mouseup', this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener('click', this.preventClick, true);
            elDocument.addEventListener('dblclick', this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    } /**
   * Drag scrollbar handle
   */ ;
    _proto.onTrackClick = function onTrackClick(e, axis) {
        var _this4 = this;
        if (axis === void 0) axis = 'y';
        if (!this.options.clickOnTrack) return;
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = scrollbar.rect[this.axis[axis].offsetAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === 'y' ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var scrollTo = function scrollTo() {
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    var _this4$contentWrapper;
                    scrolled -= _this4.options.clickOnTrackSpeed;
                    _this4.contentWrapperEl.scrollTo((_this4$contentWrapper = {}, _this4$contentWrapper[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper));
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                var _this4$contentWrapper2;
                scrolled += _this4.options.clickOnTrackSpeed;
                _this4.contentWrapperEl.scrollTo((_this4$contentWrapper2 = {}, _this4$contentWrapper2[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper2));
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    } /**
   * Getter for content element
   */ ;
    _proto.getContentElement = function getContentElement() {
        return this.contentEl;
    } /**
   * Getter for original scrolling element
   */ ;
    _proto.getScrollElement = function getScrollElement() {
        return this.contentWrapperEl;
    };
    _proto.getScrollbarWidth = function getScrollbarWidth() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (getComputedStyle(this.contentWrapperEl, '::-webkit-scrollbar').display === 'none' || 'scrollbarWidth' in document.documentElement.style || '-ms-overflow-style' in document.documentElement.style) return 0;
            else return $8cbbb70f74567bd0$var$scrollbarWidth(this.el);
        } catch (e) {
            return $8cbbb70f74567bd0$var$scrollbarWidth(this.el);
        }
    };
    _proto.removeListeners = function removeListeners() {
        var _this5 = this;
        var elWindow = $8cbbb70f74567bd0$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.removeEventListener('mouseenter', this.onMouseEnter);
        [
            'mousedown',
            'click',
            'dblclick'
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, true);
        });
        [
            'touchstart',
            'touchend',
            'touchmove'
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.removeEventListener('mousemove', this.onMouseMove);
        this.el.removeEventListener('mouseleave', this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener('scroll', this.onScroll);
        elWindow.removeEventListener('resize', this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
         // Cancel all debounced functions
        this.recalculate.cancel();
        this.onMouseMove.cancel();
        this.hideScrollbars.cancel();
        this.onWindowResize.cancel();
    } /**
   * UnMount mutation observer and delete SimpleBar instance from DOM element
   */ ;
    _proto.unMount = function unMount() {
        this.removeListeners();
        SimpleBar.instances.delete(this.el);
    } /**
   * Check if mouse is within bounds
   */ ;
    _proto.isWithinBounds = function isWithinBounds(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    } /**
   * Find element children matches query
   */ ;
    _proto.findChild = function findChild(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    return SimpleBar;
}();
$8cbbb70f74567bd0$var$SimpleBar.defaultOptions = {
    autoHide: true,
    forceVisible: false,
    clickOnTrack: true,
    clickOnTrackSpeed: 40,
    classNames: {
        contentEl: 'simplebar-content',
        contentWrapper: 'simplebar-content-wrapper',
        offset: 'simplebar-offset',
        mask: 'simplebar-mask',
        wrapper: 'simplebar-wrapper',
        placeholder: 'simplebar-placeholder',
        scrollbar: 'simplebar-scrollbar',
        track: 'simplebar-track',
        heightAutoObserverWrapperEl: 'simplebar-height-auto-observer-wrapper',
        heightAutoObserverEl: 'simplebar-height-auto-observer',
        visible: 'simplebar-visible',
        horizontal: 'simplebar-horizontal',
        vertical: 'simplebar-vertical',
        hover: 'simplebar-hover',
        dragging: 'simplebar-dragging'
    },
    scrollbarMinSize: 25,
    scrollbarMaxSize: 0,
    timeout: 1000
};
$8cbbb70f74567bd0$var$SimpleBar.instances = new WeakMap();
var $8cbbb70f74567bd0$export$2e2bcd8739ae039 = $8cbbb70f74567bd0$var$SimpleBar;


function $b76fad9a3dd6491d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b76fad9a3dd6491d$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b76fad9a3dd6491d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b76fad9a3dd6491d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b76fad9a3dd6491d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b76fad9a3dd6491d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b76fad9a3dd6491d$var$_extends() {
    $b76fad9a3dd6491d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b76fad9a3dd6491d$var$_extends.apply(this, arguments);
}
function $b76fad9a3dd6491d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b76fad9a3dd6491d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b76fad9a3dd6491d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $b76fad9a3dd6491d$var$_excluded = [
    "children",
    "scrollableNodeProps",
    "tag"
];
/* Deprecated
 * Hardcore this here until we can safely deprecated it.
 * Helper function to retrieve options from element attributes
 */ var $b76fad9a3dd6491d$var$getOptions = function getOptions(obj) {
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(x, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case 'true':
                    acc[key] = true;
                    break;
                case 'false':
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, {});
    return options;
};
var $b76fad9a3dd6491d$var$SimpleBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).forwardRef(function(_ref, ref) {
    var children = _ref.children, _ref$scrollableNodePr = _ref.scrollableNodeProps, scrollableNodeProps = _ref$scrollableNodePr === void 0 ? {} : _ref$scrollableNodePr, _ref$tag = _ref.tag, tag = _ref$tag === void 0 ? 'div' : _ref$tag, otherProps = $b76fad9a3dd6491d$var$_objectWithoutProperties(_ref, $b76fad9a3dd6491d$var$_excluded);
    var RootTag = tag;
    var instance;
    var scrollableNodeRef = (0, $9nZCP.useRef)();
    var elRef = (0, $9nZCP.useRef)();
    var contentNodeRef = (0, $9nZCP.useRef)();
    var options = {};
    var rest = {};
    var deprecatedOptions = [];
    Object.keys(otherProps).forEach(function(key) {
        if (Object.prototype.hasOwnProperty.call((0, $8cbbb70f74567bd0$export$2e2bcd8739ae039).defaultOptions, key)) options[key] = otherProps[key];
        else if (key.match(/data-simplebar-(.+)/) && key !== 'data-simplebar-direction') deprecatedOptions.push({
            name: key,
            value: otherProps[key]
        });
        else rest[key] = otherProps[key];
    });
    if (deprecatedOptions.length) console.warn("simplebar-react: this way of passing options is deprecated. Pass it like normal props instead:\n        'data-simplebar-auto-hide=\"false\"' \u2014> 'autoHide=\"false\"'\n      ");
    (0, $9nZCP.useEffect)(function() {
        scrollableNodeRef = scrollableNodeProps.ref || scrollableNodeRef;
        if (elRef.current) {
            instance = new (0, $8cbbb70f74567bd0$export$2e2bcd8739ae039)(elRef.current, $b76fad9a3dd6491d$var$_objectSpread2($b76fad9a3dd6491d$var$_objectSpread2($b76fad9a3dd6491d$var$_objectSpread2($b76fad9a3dd6491d$var$_objectSpread2({}, $b76fad9a3dd6491d$var$getOptions(deprecatedOptions)), options), scrollableNodeRef && {
                scrollableNode: scrollableNodeRef.current
            }), contentNodeRef.current && {
                contentNode: contentNodeRef.current
            }));
            if (typeof ref === 'function') ref(instance);
            else if (ref) ref.current = instance;
        }
        return function() {
            instance.unMount();
            instance = null;
            if (typeof ref === 'function') ref(null);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement(RootTag, $b76fad9a3dd6491d$var$_extends({
        ref: elRef,
        "data-simplebar": true
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-height-auto-observer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-height-auto-observer"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-mask"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-offset"
    }, typeof children === 'function' ? children({
        scrollableNodeRef: scrollableNodeRef,
        contentNodeRef: contentNodeRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", $b76fad9a3dd6491d$var$_extends({}, scrollableNodeProps, {
        className: "simplebar-content-wrapper".concat(scrollableNodeProps.className ? " ".concat(scrollableNodeProps.className) : '')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-content"
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-placeholder"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-track simplebar-horizontal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-scrollbar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-track simplebar-vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "simplebar-scrollbar"
    })));
});
$b76fad9a3dd6491d$var$SimpleBar.displayName = 'SimpleBar';
$b76fad9a3dd6491d$var$SimpleBar.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($0287d6dd1c5d0193$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($0287d6dd1c5d0193$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($0287d6dd1c5d0193$exports))).func
    ]),
    scrollableNodeProps: (0, (/*@__PURE__*/$parcel$interopDefault($0287d6dd1c5d0193$exports))).object,
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($0287d6dd1c5d0193$exports))).string
};
var $b76fad9a3dd6491d$export$2e2bcd8739ae039 = $b76fad9a3dd6491d$var$SimpleBar;



var $95dd3fa9eb45140c$exports = {};

$parcel$defineInteropFlag($95dd3fa9eb45140c$exports);

$parcel$export($95dd3fa9eb45140c$exports, "default", function () { return $95dd3fa9eb45140c$export$2e2bcd8739ae039; });
function $41b38629d66853aa$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $41b38629d66853aa$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $41b38629d66853aa$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $41b38629d66853aa$var$e(r.overflowY, n) || $41b38629d66853aa$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $41b38629d66853aa$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $41b38629d66853aa$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$41b38629d66853aa$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $41b38629d66853aa$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $41b38629d66853aa$var$n(m) && !$41b38629d66853aa$var$n(document.documentElement) || null != m && $41b38629d66853aa$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $41b38629d66853aa$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $41b38629d66853aa$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $41b38629d66853aa$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $41b38629d66853aa$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};


function $cf968986cd650ffb$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $cf968986cd650ffb$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $cf968986cd650ffb$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($cf968986cd650ffb$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $cf968986cd650ffb$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($cf968986cd650ffb$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(isTargetAttached ? (0, $41b38629d66853aa$export$2e2bcd8739ae039)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $cf968986cd650ffb$var$getOptions(options);
    return $cf968986cd650ffb$var$defaultBehavior((0, $41b38629d66853aa$export$2e2bcd8739ae039)(target, computeOptions), computeOptions.behavior);
}
var $cf968986cd650ffb$export$2e2bcd8739ae039 = $cf968986cd650ffb$var$scrollIntoView;


var $95dd3fa9eb45140c$var$memoizedNow;
var $95dd3fa9eb45140c$var$now = function now() {
    if (!$95dd3fa9eb45140c$var$memoizedNow) $95dd3fa9eb45140c$var$memoizedNow = 'performance' in window ? performance.now.bind(performance) : Date.now;
    return $95dd3fa9eb45140c$var$memoizedNow();
};
function $95dd3fa9eb45140c$var$step(context) {
    var time = $95dd3fa9eb45140c$var$now();
    var elapsed = Math.min((time - context.startTime) / context.duration, 1);
    var value = context.ease(elapsed);
    var currentX = context.startX + (context.x - context.startX) * value;
    var currentY = context.startY + (context.y - context.startY) * value;
    context.method(currentX, currentY);
    if (currentX !== context.x || currentY !== context.y) requestAnimationFrame(function() {
        return $95dd3fa9eb45140c$var$step(context);
    });
    else context.cb();
}
function $95dd3fa9eb45140c$var$smoothScroll(el, x, y, duration, ease, cb) {
    if (duration === void 0) duration = 600;
    if (ease === void 0) ease = function ease(t) {
        return 1 + --t * t * t * t * t;
    };
    var scrollable;
    var startX;
    var startY;
    var method;
    scrollable = el;
    startX = el.scrollLeft;
    startY = el.scrollTop;
    method = function method(x, y) {
        el.scrollLeft = Math.ceil(x);
        el.scrollTop = Math.ceil(y);
    };
    $95dd3fa9eb45140c$var$step({
        scrollable: scrollable,
        method: method,
        startTime: $95dd3fa9eb45140c$var$now(),
        startX: startX,
        startY: startY,
        x: x,
        y: y,
        duration: duration,
        ease: ease,
        cb: cb
    });
}
var $95dd3fa9eb45140c$var$shouldSmoothScroll = function shouldSmoothScroll(options) {
    return options && !options.behavior || options.behavior === 'smooth';
};
function $95dd3fa9eb45140c$var$scroll(target, options) {
    var overrides = options || {};
    if ($95dd3fa9eb45140c$var$shouldSmoothScroll(overrides)) return (0, $cf968986cd650ffb$export$2e2bcd8739ae039)(target, {
        block: overrides.block,
        inline: overrides.inline,
        scrollMode: overrides.scrollMode,
        boundary: overrides.boundary,
        behavior: function behavior(actions) {
            return Promise.all(actions.reduce(function(results, _ref) {
                var el = _ref.el, left = _ref.left, top = _ref.top;
                var startLeft = el.scrollLeft;
                var startTop = el.scrollTop;
                if (startLeft === left && startTop === top) return results;
                return [].concat(results, [
                    new Promise(function(resolve) {
                        return $95dd3fa9eb45140c$var$smoothScroll(el, left, top, overrides.duration, overrides.ease, function() {
                            return resolve({
                                el: el,
                                left: [
                                    startLeft,
                                    left
                                ],
                                top: [
                                    startTop,
                                    top
                                ]
                            });
                        });
                    })
                ]);
            }, []));
        }
    });
    return Promise.resolve((0, $cf968986cd650ffb$export$2e2bcd8739ae039)(target, options));
}
var $95dd3fa9eb45140c$var$smoothScrollIntoView = $95dd3fa9eb45140c$var$scroll;
var $95dd3fa9eb45140c$export$2e2bcd8739ae039 = $95dd3fa9eb45140c$var$smoothScrollIntoView;


var $8fc1eb2c15e0076e$exports = {};

$parcel$defineInteropFlag($8fc1eb2c15e0076e$exports);

$parcel$export($8fc1eb2c15e0076e$exports, "default", function () { return $8fc1eb2c15e0076e$export$2e2bcd8739ae039; });
$parcel$export($8fc1eb2c15e0076e$exports, "Range", function () { return $1333fa204e4662b3$export$2e2bcd8739ae039; });
$parcel$export($8fc1eb2c15e0076e$exports, "Handle", function () { return $49e439059d842d52$export$2e2bcd8739ae039; });
$parcel$export($8fc1eb2c15e0076e$exports, "createSliderWithTooltip", function () { return $63d3d36722fc19de$export$2e2bcd8739ae039; });
$parcel$export($8fc1eb2c15e0076e$exports, "SliderTooltip", function () { return $f7939232b8700452$export$2e2bcd8739ae039; });
function $b97407360a5cbf3c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b97407360a5cbf3c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b97407360a5cbf3c$export$2e2bcd8739ae039(o);
}



function $49b43895e7ccc5c1$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $20af1ec26fc848f1$export$2e2bcd8739ae039(t) {
    var i = (0, $49b43895e7ccc5c1$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $0e91f7da3580de3e$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $20af1ec26fc848f1$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $835511f338e067d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $835511f338e067d8$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $835511f338e067d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $835511f338e067d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $760550b9da8dc9e1$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $e2992e4fbdf715a4$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $20af1ec26fc848f1$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $e2992e4fbdf715a4$export$2e2bcd8739ae039(e, r, t) {
    return r && $e2992e4fbdf715a4$var$_defineProperties(e.prototype, r), t && $e2992e4fbdf715a4$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $228dd0b0569f35b6$export$2e2bcd8739ae039(t, e) {
    return $228dd0b0569f35b6$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $228dd0b0569f35b6$export$2e2bcd8739ae039(t, e);
}


function $e9432b2dc1794836$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $228dd0b0569f35b6$export$2e2bcd8739ae039)(t, e);
}


function $53b14ef86235fdcb$export$2e2bcd8739ae039(t) {
    return $53b14ef86235fdcb$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $53b14ef86235fdcb$export$2e2bcd8739ae039(t);
}


function $111ef934f90d625c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($111ef934f90d625c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $940bcf9a64d33faf$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $50a2c7dbcf58753e$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(t);
}


function $d9bb25c2822f374b$export$2e2bcd8739ae039(t) {
    var r = (0, $111ef934f90d625c$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $50a2c7dbcf58753e$export$2e2bcd8739ae039)(this, e);
    };
}



var $9nZCP = parcelRequire("9nZCP");
/* eslint-disable no-console */ var $c196facde74adb39$var$warned = {};
var $c196facde74adb39$var$preWarningFns = [];
var $c196facde74adb39$export$61616f168f0e5a05 = function preMessage(fn) {
    $c196facde74adb39$var$preWarningFns.push(fn);
};
function $c196facde74adb39$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $c196facde74adb39$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $c196facde74adb39$export$60eef1277fe463e4() {
    $c196facde74adb39$var$warned = {};
}
function $c196facde74adb39$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$c196facde74adb39$var$warned[message]) {
        method(false, message);
        $c196facde74adb39$var$warned[message] = true;
    }
}
function $c196facde74adb39$export$82934adf09101657(valid, message) {
    $c196facde74adb39$export$848feb93d8f32b9b($c196facde74adb39$export$491112666e282270, valid, message);
}
function $c196facde74adb39$export$89ff31684837bbbf(valid, message) {
    $c196facde74adb39$export$848feb93d8f32b9b($c196facde74adb39$export$a92e4c44d367d0af, valid, message);
}
$c196facde74adb39$export$82934adf09101657.preMessage = $c196facde74adb39$export$61616f168f0e5a05;
$c196facde74adb39$export$82934adf09101657.resetWarned = $c196facde74adb39$export$60eef1277fe463e4;
$c196facde74adb39$export$82934adf09101657.noteOnce = $c196facde74adb39$export$89ff31684837bbbf;
var $c196facde74adb39$export$2e2bcd8739ae039 = $c196facde74adb39$export$82934adf09101657;





var $9nZCP = parcelRequire("9nZCP");
var $50b2e2071653f08e$var$Track = function Track(props) {
    var _ref, _ref2;
    var className = props.className, included = props.included, vertical = props.vertical, style = props.style;
    var length = props.length, offset = props.offset, reverse = props.reverse;
    if (length < 0) {
        reverse = !reverse;
        length = Math.abs(length);
        offset = 100 - offset;
    }
    var positonStyle = vertical ? (_ref = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, reverse ? 'left' : 'right', 'auto'), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, "width", "".concat(length, "%")), _ref2);
    var elStyle = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, style), positonStyle);
    return included ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: className,
        style: elStyle
    }) : null;
};
var $50b2e2071653f08e$export$2e2bcd8739ae039 = $50b2e2071653f08e$var$Track;


function $d3700a4be188dae5$export$2e2bcd8739ae039() {
    return $d3700a4be188dae5$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d3700a4be188dae5$export$2e2bcd8739ae039.apply(null, arguments);
}


function $94c08baf51322beb$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $d757eeb1353aad21$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $94c08baf51322beb$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}




function $82c21e0f607951b1$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $4fd1e7788390d081$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $82c21e0f607951b1$export$2e2bcd8739ae039)(r);
}


function $d13b6ea07b6676dc$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $972a974728b0ca3d$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $82c21e0f607951b1$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $82c21e0f607951b1$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $08898464f1376a72$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $513d655c75612b28$export$2e2bcd8739ae039(r) {
    return (0, $4fd1e7788390d081$export$2e2bcd8739ae039)(r) || (0, $d13b6ea07b6676dc$export$2e2bcd8739ae039)(r) || (0, $972a974728b0ca3d$export$2e2bcd8739ae039)(r) || (0, $08898464f1376a72$export$2e2bcd8739ae039)();
}





function $c24f65a6bf43193c$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(t)););
    return t;
}


function $64b283de2d7de7c1$export$2e2bcd8739ae039() {
    return $64b283de2d7de7c1$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $c24f65a6bf43193c$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $64b283de2d7de7c1$export$2e2bcd8739ae039.apply(null, arguments);
}






var $9nZCP = parcelRequire("9nZCP");

function $2c9c50b08e6db3ce$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}


var $81466bf476712888$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, $81466bf476712888$exports) {
        classNames.default = classNames;
        $81466bf476712888$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();






var $9nZCP = parcelRequire("9nZCP");


var $0c53fbe1c5ac04a8$var$calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
    (0, $c196facde74adb39$export$2e2bcd8739ae039)(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
    var points = Object.keys(marks).map(parseFloat).sort(function(a, b) {
        return a - b;
    });
    if (dots && step) {
        for(var i = min; i <= max; i += step)if (points.indexOf(i) === -1) points.push(i);
    }
    return points;
};
var $0c53fbe1c5ac04a8$var$Steps = function Steps(_ref) {
    var prefixCls = _ref.prefixCls, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, dots = _ref.dots, step = _ref.step, included = _ref.included, lowerBound = _ref.lowerBound, upperBound = _ref.upperBound, max = _ref.max, min = _ref.min, dotStyle = _ref.dotStyle, activeDotStyle = _ref.activeDotStyle;
    var range = max - min;
    var elements = $0c53fbe1c5ac04a8$var$calcPoints(vertical, marks, dots, step, min, max).map(function(point) {
        var _classNames;
        var offset = "".concat(Math.abs(point - min) / range * 100, "%");
        var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var style = vertical ? (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, reverse ? 'top' : 'bottom', offset)) : (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, reverse ? 'right' : 'left', offset));
        if (isActived) style = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, style), activeDotStyle);
        var pointClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))((_classNames = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot"), true), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-active"), isActived), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("span", {
            className: pointClassName,
            style: style,
            key: point
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, elements);
};
var $0c53fbe1c5ac04a8$export$2e2bcd8739ae039 = $0c53fbe1c5ac04a8$var$Steps;






var $9nZCP = parcelRequire("9nZCP");

var $d3bad4f6579d6632$var$Marks = function Marks(_ref) {
    var className = _ref.className, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, included = _ref.included, upperBound = _ref.upperBound, lowerBound = _ref.lowerBound, max = _ref.max, min = _ref.min, onClickLabel = _ref.onClickLabel;
    var marksKeys = Object.keys(marks);
    var range = max - min;
    var elements = marksKeys.map(parseFloat).sort(function(a, b) {
        return a - b;
    }).map(function(point) {
        var _classNames;
        var markPoint = marks[point];
        var markPointIsObject = (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(markPoint) === 'object' && !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).isValidElement(markPoint);
        var markLabel = markPointIsObject ? markPoint.label : markPoint;
        if (!markLabel && markLabel !== 0) return null;
        var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var markClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))((_classNames = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text"), true), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text-active"), isActive), _classNames));
        var bottomStyle = (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({
            marginBottom: '-50%'
        }, reverse ? 'top' : 'bottom', "".concat((point - min) / range * 100, "%"));
        var leftStyle = (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({
            transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
            msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
        }, reverse ? 'right' : 'left', "".concat((point - min) / range * 100, "%"));
        var style = vertical ? bottomStyle : leftStyle;
        var markStyle = markPointIsObject ? (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, style), markPoint.style) : style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("span", {
            className: markClassName,
            style: markStyle,
            key: point,
            onMouseDown: function onMouseDown(e) {
                return onClickLabel(e, point);
            },
            onTouchStart: function onTouchStart(e) {
                return onClickLabel(e, point);
            }
        }, markLabel);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
        className: className
    }, elements);
};
var $d3bad4f6579d6632$export$2e2bcd8739ae039 = $d3bad4f6579d6632$var$Marks;











var $9nZCP = parcelRequire("9nZCP");


var $49e439059d842d52$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(Handle, _React$Component);
    var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(Handle);
    function Handle() {
        var _this;
        (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, Handle);
        _this = _super.apply(this, arguments);
        _this.state = {
            clickFocused: false
        };
        _this.setHandleRef = function(node) {
            _this.handle = node;
        };
        _this.handleMouseUp = function() {
            if (document.activeElement === _this.handle) _this.setClickFocus(true);
        };
        _this.handleMouseDown = function(e) {
            // avoid selecting text during drag
            // https://github.com/ant-design/ant-design/issues/25010
            e.preventDefault(); // fix https://github.com/ant-design/ant-design/issues/15324
            _this.focus();
        };
        _this.handleBlur = function() {
            _this.setClickFocus(false);
        };
        _this.handleKeyDown = function() {
            _this.setClickFocus(false);
        };
        return _this;
    }
    (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(Handle, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // mouseup won't trigger if mouse moved out of handle,
                // so we listen on document here.
                this.onMouseUpListener = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(document, 'mouseup', this.handleMouseUp);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.onMouseUpListener) this.onMouseUpListener.remove();
            }
        },
        {
            key: "setClickFocus",
            value: function setClickFocus(focused) {
                this.setState({
                    clickFocused: focused
                });
            }
        },
        {
            key: "clickFocus",
            value: function clickFocus() {
                this.setClickFocus(true);
                this.focus();
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.handle.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.handle.blur();
            }
        },
        {
            key: "render",
            value: function render() {
                var _ref, _ref2;
                var _this$props = this.props, prefixCls = _this$props.prefixCls, vertical = _this$props.vertical, reverse = _this$props.reverse, offset = _this$props.offset, style = _this$props.style, disabled = _this$props.disabled, min = _this$props.min, max = _this$props.max, value = _this$props.value, tabIndex = _this$props.tabIndex, ariaLabel = _this$props.ariaLabel, ariaLabelledBy = _this$props.ariaLabelledBy, ariaValueTextFormatter = _this$props.ariaValueTextFormatter, restProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_this$props, [
                    "prefixCls",
                    "vertical",
                    "reverse",
                    "offset",
                    "style",
                    "disabled",
                    "min",
                    "max",
                    "value",
                    "tabIndex",
                    "ariaLabel",
                    "ariaLabelledBy",
                    "ariaValueTextFormatter"
                ]);
                var className = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))(this.props.className, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
                var positionStyle = vertical ? (_ref = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, reverse ? 'left' : 'right', 'auto'), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_ref2, "transform", "translateX(".concat(reverse ? '+' : '-', "50%)")), _ref2);
                var elStyle = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, style), positionStyle);
                var mergedTabIndex = tabIndex || 0;
                if (disabled || tabIndex === null) mergedTabIndex = null;
                var ariaValueText;
                if (ariaValueTextFormatter) ariaValueText = ariaValueTextFormatter(value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
                    ref: this.setHandleRef,
                    tabIndex: mergedTabIndex
                }, restProps, {
                    className: className,
                    style: elStyle,
                    onBlur: this.handleBlur,
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleMouseDown // aria attribute
                    ,
                    role: "slider",
                    "aria-valuemin": min,
                    "aria-valuemax": max,
                    "aria-valuenow": value,
                    "aria-disabled": !!disabled,
                    "aria-label": ariaLabel,
                    "aria-labelledby": ariaLabelledBy,
                    "aria-valuetext": ariaValueText
                }));
            }
        }
    ]);
    return Handle;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Component);




/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $d3a8d9285e373915$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $d3a8d9285e373915$var$KeyCode.F1 && keyCode <= $d3a8d9285e373915$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $d3a8d9285e373915$var$KeyCode.ALT:
            case $d3a8d9285e373915$var$KeyCode.CAPS_LOCK:
            case $d3a8d9285e373915$var$KeyCode.CONTEXT_MENU:
            case $d3a8d9285e373915$var$KeyCode.CTRL:
            case $d3a8d9285e373915$var$KeyCode.DOWN:
            case $d3a8d9285e373915$var$KeyCode.END:
            case $d3a8d9285e373915$var$KeyCode.ESC:
            case $d3a8d9285e373915$var$KeyCode.HOME:
            case $d3a8d9285e373915$var$KeyCode.INSERT:
            case $d3a8d9285e373915$var$KeyCode.LEFT:
            case $d3a8d9285e373915$var$KeyCode.MAC_FF_META:
            case $d3a8d9285e373915$var$KeyCode.META:
            case $d3a8d9285e373915$var$KeyCode.NUMLOCK:
            case $d3a8d9285e373915$var$KeyCode.NUM_CENTER:
            case $d3a8d9285e373915$var$KeyCode.PAGE_DOWN:
            case $d3a8d9285e373915$var$KeyCode.PAGE_UP:
            case $d3a8d9285e373915$var$KeyCode.PAUSE:
            case $d3a8d9285e373915$var$KeyCode.PRINT_SCREEN:
            case $d3a8d9285e373915$var$KeyCode.RIGHT:
            case $d3a8d9285e373915$var$KeyCode.SHIFT:
            case $d3a8d9285e373915$var$KeyCode.UP:
            case $d3a8d9285e373915$var$KeyCode.WIN_KEY:
            case $d3a8d9285e373915$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $d3a8d9285e373915$var$KeyCode.ZERO && keyCode <= $d3a8d9285e373915$var$KeyCode.NINE) return true;
        if (keyCode >= $d3a8d9285e373915$var$KeyCode.NUM_ZERO && keyCode <= $d3a8d9285e373915$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $d3a8d9285e373915$var$KeyCode.A && keyCode <= $d3a8d9285e373915$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $d3a8d9285e373915$var$KeyCode.SPACE:
            case $d3a8d9285e373915$var$KeyCode.QUESTION_MARK:
            case $d3a8d9285e373915$var$KeyCode.NUM_PLUS:
            case $d3a8d9285e373915$var$KeyCode.NUM_MINUS:
            case $d3a8d9285e373915$var$KeyCode.NUM_PERIOD:
            case $d3a8d9285e373915$var$KeyCode.NUM_DIVISION:
            case $d3a8d9285e373915$var$KeyCode.SEMICOLON:
            case $d3a8d9285e373915$var$KeyCode.DASH:
            case $d3a8d9285e373915$var$KeyCode.EQUALS:
            case $d3a8d9285e373915$var$KeyCode.COMMA:
            case $d3a8d9285e373915$var$KeyCode.PERIOD:
            case $d3a8d9285e373915$var$KeyCode.SLASH:
            case $d3a8d9285e373915$var$KeyCode.APOSTROPHE:
            case $d3a8d9285e373915$var$KeyCode.SINGLE_QUOTE:
            case $d3a8d9285e373915$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $d3a8d9285e373915$var$KeyCode.BACKSLASH:
            case $d3a8d9285e373915$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $d3a8d9285e373915$export$2e2bcd8739ae039 = $d3a8d9285e373915$var$KeyCode;


function $9595af4ca8f59963$export$597415897f3287c9(e, handles) {
    try {
        return Object.keys(handles).some(function(key) {
            return e.target === (0, $06928105ffc753ea$exports.findDOMNode)(handles[key]);
        });
    } catch (error) {
        return false;
    }
}
function $9595af4ca8f59963$export$f4657b4dc4cc2ea4(value, _ref) {
    var min = _ref.min, max = _ref.max;
    return value < min || value > max;
}
function $9595af4ca8f59963$export$eaf0efc71c45a02(e) {
    return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}
function $9595af4ca8f59963$export$e3e031d5dec39373(val, _ref2) {
    var marks = _ref2.marks, step = _ref2.step, min = _ref2.min, max = _ref2.max;
    var points = Object.keys(marks).map(parseFloat);
    if (step !== null) {
        var baseNum = Math.pow(10, $9595af4ca8f59963$export$e0c74b50bbd10f68(step));
        var maxSteps = Math.floor((max * baseNum - min * baseNum) / (step * baseNum));
        var steps = Math.min((val - min) / step, maxSteps);
        var closestStep = Math.round(steps) * step + min;
        points.push(closestStep);
    }
    var diffs = points.map(function(point) {
        return Math.abs(val - point);
    });
    return points[diffs.indexOf(Math.min.apply(Math, (0, $513d655c75612b28$export$2e2bcd8739ae039)(diffs)))];
}
function $9595af4ca8f59963$export$e0c74b50bbd10f68(step) {
    var stepString = step.toString();
    var precision = 0;
    if (stepString.indexOf('.') >= 0) precision = stepString.length - stepString.indexOf('.') - 1;
    return precision;
}
function $9595af4ca8f59963$export$642213d516a9b928(vertical, e) {
    return vertical ? e.clientY : e.pageX;
}
function $9595af4ca8f59963$export$7e1d3da113d10e8e(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function $9595af4ca8f59963$export$ec6357f54996b379(vertical, handle) {
    var coords = handle.getBoundingClientRect();
    return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function $9595af4ca8f59963$export$65e4339c6f9d8d24(val, _ref3) {
    var max = _ref3.max, min = _ref3.min;
    if (val <= min) return min;
    if (val >= max) return max;
    return val;
}
function $9595af4ca8f59963$export$5bea24a9dfe5ab1a(val, props) {
    var step = props.step;
    var closestPoint = isFinite($9595af4ca8f59963$export$e3e031d5dec39373(val, props)) ? $9595af4ca8f59963$export$e3e031d5dec39373(val, props) : 0; // eslint-disable-line
    return step === null ? closestPoint : parseFloat(closestPoint.toFixed($9595af4ca8f59963$export$e0c74b50bbd10f68(step)));
}
function $9595af4ca8f59963$export$3f9ffdaf2961f43f(e) {
    e.stopPropagation();
    e.preventDefault();
}
function $9595af4ca8f59963$export$e5722e0a8bbb32d9(func, value, props) {
    var operations = {
        increase: function increase(a, b) {
            return a + b;
        },
        decrease: function decrease(a, b) {
            return a - b;
        }
    };
    var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
    var keyToGet = Object.keys(props.marks)[indexToGet];
    if (props.step) return operations[func](value, props.step);
    if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) return props.marks[keyToGet];
    return value;
}
function $9595af4ca8f59963$export$3bef836a1fb84ee6(e, vertical, reverse) {
    var increase = 'increase';
    var decrease = 'decrease';
    var method = increase;
    switch(e.keyCode){
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).UP:
            method = vertical && reverse ? decrease : increase;
            break;
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).RIGHT:
            method = !vertical && reverse ? decrease : increase;
            break;
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).DOWN:
            method = vertical && reverse ? increase : decrease;
            break;
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).LEFT:
            method = !vertical && reverse ? increase : decrease;
            break;
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).END:
            return function(value, props) {
                return props.max;
            };
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).HOME:
            return function(value, props) {
                return props.min;
            };
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).PAGE_UP:
            return function(value, props) {
                return value + props.step * 2;
            };
        case (0, $d3a8d9285e373915$export$2e2bcd8739ae039).PAGE_DOWN:
            return function(value, props) {
                return value - props.step * 2;
            };
        default:
            return undefined;
    }
    return function(value, props) {
        return $9595af4ca8f59963$export$e5722e0a8bbb32d9(method, value, props);
    };
}


/* eslint-disable @typescript-eslint/no-explicit-any */ function $2ccbbbdef185509f$var$noop() {}
function $2ccbbbdef185509f$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_Component) {
        (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(ComponentEnhancer, _Component);
        var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(ComponentEnhancer);
        function ComponentEnhancer(props) {
            var _this;
            (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, ComponentEnhancer);
            _this = _super.call(this, props);
            _this.onDown = function(e, position) {
                var p = position;
                var _this$props = _this.props, draggableTrack = _this$props.draggableTrack, isVertical = _this$props.vertical;
                var bounds = _this.state.bounds;
                var value = draggableTrack && _this.positionGetValue ? _this.positionGetValue(p) || [] : [];
                var inPoint = $9595af4ca8f59963$export$597415897f3287c9(e, _this.handlesRefs);
                _this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function(n, i) {
                    var v = !i ? n >= bounds[i] : true;
                    return i === value.length - 1 ? n <= bounds[i] : v;
                }).some(function(c) {
                    return !c;
                });
                if (_this.dragTrack) {
                    _this.dragOffset = p;
                    _this.startBounds = (0, $513d655c75612b28$export$2e2bcd8739ae039)(bounds);
                } else {
                    if (!inPoint) _this.dragOffset = 0;
                    else {
                        var handlePosition = $9595af4ca8f59963$export$ec6357f54996b379(isVertical, e.target);
                        _this.dragOffset = p - handlePosition;
                        p = handlePosition;
                    }
                    _this.onStart(p);
                }
            };
            _this.onMouseDown = function(e) {
                if (e.button !== 0) return;
                _this.removeDocumentEvents();
                var isVertical = _this.props.vertical;
                var position = $9595af4ca8f59963$export$642213d516a9b928(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentMouseEvents();
            };
            _this.onTouchStart = function(e) {
                if ($9595af4ca8f59963$export$eaf0efc71c45a02(e)) return;
                var isVertical = _this.props.vertical;
                var position = $9595af4ca8f59963$export$7e1d3da113d10e8e(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentTouchEvents();
                $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
            };
            _this.onFocus = function(e) {
                var _this$props2 = _this.props, onFocus = _this$props2.onFocus, vertical = _this$props2.vertical;
                if ($9595af4ca8f59963$export$597415897f3287c9(e, _this.handlesRefs) && !_this.dragTrack) {
                    var handlePosition = $9595af4ca8f59963$export$ec6357f54996b379(vertical, e.target);
                    _this.dragOffset = 0;
                    _this.onStart(handlePosition);
                    $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
                    if (onFocus) onFocus(e);
                }
            };
            _this.onBlur = function(e) {
                var onBlur = _this.props.onBlur;
                if (!_this.dragTrack) _this.onEnd();
                if (onBlur) onBlur(e);
            };
            _this.onMouseUp = function() {
                if (_this.handlesRefs[_this.prevMovedHandleIndex]) _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
            };
            _this.onMouseMove = function(e) {
                if (!_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $9595af4ca8f59963$export$642213d516a9b928(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onTouchMove = function(e) {
                if ($9595af4ca8f59963$export$eaf0efc71c45a02(e) || !_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $9595af4ca8f59963$export$7e1d3da113d10e8e(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onKeyDown = function(e) {
                if (_this.sliderRef && $9595af4ca8f59963$export$597415897f3287c9(e, _this.handlesRefs)) _this.onKeyboard(e);
            };
            _this.onClickMarkLabel = function(e, value) {
                e.stopPropagation();
                _this.onChange({
                    value: value
                }); // eslint-disable-next-line react/no-unused-state
                _this.setState({
                    value: value
                }, function() {
                    return _this.onEnd(true);
                });
            };
            _this.saveSlider = function(slider) {
                _this.sliderRef = slider;
            };
            var step = props.step, max = props.max, min = props.min;
            var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
            (0, $c196facde74adb39$export$2e2bcd8739ae039)(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
            _this.handlesRefs = {};
            return _this;
        }
        (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(ComponentEnhancer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    // Snapshot testing cannot handle refs, so be sure to null-check this.
                    this.document = this.sliderRef && this.sliderRef.ownerDocument;
                    var _this$props3 = this.props, autoFocus = _this$props3.autoFocus, disabled = _this$props3.disabled;
                    if (autoFocus && !disabled) this.focus();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if ((0, $64b283de2d7de7c1$export$2e2bcd8739ae039)((0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this)) (0, $64b283de2d7de7c1$export$2e2bcd8739ae039)((0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
                    this.removeDocumentEvents();
                }
            },
            {
                key: "getSliderStart",
                value: function getSliderStart() {
                    var slider = this.sliderRef;
                    var _this$props4 = this.props, vertical = _this$props4.vertical, reverse = _this$props4.reverse;
                    var rect = slider.getBoundingClientRect();
                    if (vertical) return reverse ? rect.bottom : rect.top;
                    return window.pageXOffset + (reverse ? rect.right : rect.left);
                }
            },
            {
                key: "getSliderLength",
                value: function getSliderLength() {
                    var slider = this.sliderRef;
                    if (!slider) return 0;
                    var coords = slider.getBoundingClientRect();
                    return this.props.vertical ? coords.height : coords.width;
                }
            },
            {
                key: "addDocumentTouchEvents",
                value: function addDocumentTouchEvents() {
                    // just work for Chrome iOS Safari and Android Browser
                    this.onTouchMoveListener = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(this.document, 'touchmove', this.onTouchMove);
                    this.onTouchUpListener = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(this.document, 'touchend', this.onEnd);
                }
            },
            {
                key: "addDocumentMouseEvents",
                value: function addDocumentMouseEvents() {
                    this.onMouseMoveListener = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(this.document, 'mousemove', this.onMouseMove);
                    this.onMouseUpListener = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(this.document, 'mouseup', this.onEnd);
                }
            },
            {
                key: "removeDocumentEvents",
                value: function removeDocumentEvents() {
                    /* eslint-disable @typescript-eslint/no-unused-expressions */ this.onTouchMoveListener && this.onTouchMoveListener.remove();
                    this.onTouchUpListener && this.onTouchUpListener.remove();
                    this.onMouseMoveListener && this.onMouseMoveListener.remove();
                    this.onMouseUpListener && this.onMouseUpListener.remove();
                /* eslint-enable no-unused-expressions */ }
            },
            {
                key: "focus",
                value: function focus() {
                    var _this$handlesRefs$;
                    if (this.props.disabled) return;
                    (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 || _this$handlesRefs$.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    var _this2 = this;
                    if (this.props.disabled) return;
                    Object.keys(this.handlesRefs).forEach(function(key) {
                        var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;
                        (_this2$handlesRefs$ke = _this2.handlesRefs[key]) === null || _this2$handlesRefs$ke === void 0 || (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 || _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
                    });
                }
            },
            {
                key: "calcValue",
                value: function calcValue(offset) {
                    var _this$props5 = this.props, vertical = _this$props5.vertical, min = _this$props5.min, max = _this$props5.max;
                    var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
                    var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
                    return value;
                }
            },
            {
                key: "calcValueByPos",
                value: function calcValueByPos(position) {
                    var sign = this.props.reverse ? -1 : 1;
                    var pixelOffset = sign * (position - this.getSliderStart());
                    var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
                    return nextValue;
                }
            },
            {
                key: "calcOffset",
                value: function calcOffset(value) {
                    var _this$props6 = this.props, min = _this$props6.min, max = _this$props6.max;
                    var ratio = (value - min) / (max - min);
                    return Math.max(0, ratio * 100);
                }
            },
            {
                key: "saveHandle",
                value: function saveHandle(index, handle) {
                    this.handlesRefs[index] = handle;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _classNames;
                    var _this$props7 = this.props, prefixCls = _this$props7.prefixCls, className = _this$props7.className, marks = _this$props7.marks, dots = _this$props7.dots, step = _this$props7.step, included = _this$props7.included, disabled = _this$props7.disabled, vertical = _this$props7.vertical, reverse = _this$props7.reverse, min = _this$props7.min, max = _this$props7.max, children = _this$props7.children, maximumTrackStyle = _this$props7.maximumTrackStyle, style = _this$props7.style, railStyle = _this$props7.railStyle, dotStyle = _this$props7.dotStyle, activeDotStyle = _this$props7.activeDotStyle;
                    var _get$call = (0, $64b283de2d7de7c1$export$2e2bcd8739ae039)((0, $53b14ef86235fdcb$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "render", this).call(this), tracks = _get$call.tracks, handles = _get$call.handles;
                    var sliderClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))(prefixCls, (_classNames = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-vertical"), vertical), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, className, className), _classNames));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
                        ref: this.saveSlider,
                        className: sliderClassName,
                        onTouchStart: disabled ? $2ccbbbdef185509f$var$noop : this.onTouchStart,
                        onMouseDown: disabled ? $2ccbbbdef185509f$var$noop : this.onMouseDown,
                        onMouseUp: disabled ? $2ccbbbdef185509f$var$noop : this.onMouseUp,
                        onKeyDown: disabled ? $2ccbbbdef185509f$var$noop : this.onKeyDown,
                        onFocus: disabled ? $2ccbbbdef185509f$var$noop : this.onFocus,
                        onBlur: disabled ? $2ccbbbdef185509f$var$noop : this.onBlur,
                        style: style
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement("div", {
                        className: "".concat(prefixCls, "-rail"),
                        style: (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, maximumTrackStyle), railStyle)
                    }), tracks, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $0c53fbe1c5ac04a8$export$2e2bcd8739ae039), {
                        prefixCls: prefixCls,
                        vertical: vertical,
                        reverse: reverse,
                        marks: marks,
                        dots: dots,
                        step: step,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        dotStyle: dotStyle,
                        activeDotStyle: activeDotStyle
                    }), handles, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $d3bad4f6579d6632$export$2e2bcd8739ae039), {
                        className: "".concat(prefixCls, "-mark"),
                        onClickLabel: disabled ? $2ccbbbdef185509f$var$noop : this.onClickMarkLabel,
                        vertical: vertical,
                        marks: marks,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        reverse: reverse
                    }), children);
                }
            }
        ]);
        return ComponentEnhancer;
    }(Component), _a.displayName = "ComponentEnhancer(".concat(Component.displayName, ")"), _a.defaultProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, Component.defaultProps), {}, {
        prefixCls: 'rc-slider',
        className: '',
        min: 0,
        max: 100,
        step: 1,
        marks: {},
        handle: function handle(props) {
            var index = props.index, restProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(props, [
                "index"
            ]);
            delete restProps.dragging;
            if (restProps.value === null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $49e439059d842d52$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, restProps, {
                key: index
            }));
        },
        onBeforeChange: $2ccbbbdef185509f$var$noop,
        onChange: $2ccbbbdef185509f$var$noop,
        onAfterChange: $2ccbbbdef185509f$var$noop,
        included: true,
        disabled: false,
        dots: false,
        vertical: false,
        reverse: false,
        trackStyle: [
            {}
        ],
        handleStyle: [
            {}
        ],
        railStyle: {},
        dotStyle: {},
        activeDotStyle: {}
    }), _a;
}



var $424139e045fedefc$var$Slider = /*#__PURE__*/ function(_React$Component) {
    (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(Slider, _React$Component);
    var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(Slider);
    /* eslint-enable */ function Slider(props) {
        var _this;
        (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, Slider);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            return [];
        };
        _this.onEnd = function(force) {
            var dragging = _this.state.dragging;
            _this.removeDocumentEvents();
            if (dragging || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                dragging: false
            });
        };
        var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
        var value = props.value !== undefined ? props.value : defaultValue;
        _this.state = {
            value: _this.trimAlignValue(value),
            dragging: false
        };
        (0, $c196facde74adb39$export$2e2bcd8739ae039)(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
        (0, $c196facde74adb39$export$2e2bcd8739ae039)(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(Slider, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props = this.props, min = _this$props.min, max = _this$props.max, value = _this$props.value, onChange = _this$props.onChange;
                if (!('min' in this.props || 'max' in this.props)) return;
                var theValue = value !== undefined ? value : prevState.value;
                var nextValue = this.trimAlignValue(theValue, this.props);
                if (nextValue === prevState.value) return;
                 // eslint-disable-next-line
                this.setState({
                    value: nextValue
                });
                if (!(min === prevProps.min && max === prevProps.max) && $9595af4ca8f59963$export$f4657b4dc4cc2ea4(theValue, this.props)) onChange(nextValue);
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !('value' in props);
                var nextState = state.value > this.props.max ? (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, state), {}, {
                    value: this.props.max
                }) : state;
                if (isNotControlled) this.setState(nextState);
                var changedValue = nextState.value;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                this.setState({
                    dragging: true
                });
                var props = this.props;
                var prevValue = this.getValue();
                props.onBeforeChange(prevValue);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                if (value === prevValue) return;
                this.prevMovedHandleIndex = 0;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position) {
                $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
                var oldValue = this.state.value;
                var value = this.calcValueByPos(position);
                if (value === oldValue) return;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $9595af4ca8f59963$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
                    var state = this.state;
                    var oldValue = state.value;
                    var mutatedValue = valueMutator(oldValue, this.props);
                    var value = this.trimAlignValue(mutatedValue);
                    if (value === oldValue) return;
                    this.onChange({
                        value: value
                    });
                    this.props.onAfterChange(value);
                    this.onEnd();
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.value;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                var minPoint = this.props.startPoint || this.props.min;
                return this.state.value > minPoint ? minPoint : this.state.value;
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                if (this.state.value < this.props.startPoint) return this.props.startPoint;
                return this.state.value;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(v) {
                var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (v === null) return null;
                var mergedProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, this.props), nextProps);
                var val = $9595af4ca8f59963$export$65e4339c6f9d8d24(v, mergedProps);
                return $9595af4ca8f59963$export$5bea24a9dfe5ab1a(val, mergedProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, prefixCls = _this$props3.prefixCls, vertical = _this$props3.vertical, included = _this$props3.included, disabled = _this$props3.disabled, minimumTrackStyle = _this$props3.minimumTrackStyle, trackStyle = _this$props3.trackStyle, handleStyle = _this$props3.handleStyle, tabIndex = _this$props3.tabIndex, ariaLabelForHandle = _this$props3.ariaLabelForHandle, ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle, min = _this$props3.min, max = _this$props3.max, startPoint = _this$props3.startPoint, reverse = _this$props3.reverse, handleGenerator = _this$props3.handle;
                var _this$state = this.state, value = _this$state.value, dragging = _this$state.dragging;
                var offset = this.calcOffset(value);
                var handle = handleGenerator({
                    className: "".concat(prefixCls, "-handle"),
                    prefixCls: prefixCls,
                    vertical: vertical,
                    offset: offset,
                    value: value,
                    dragging: dragging,
                    disabled: disabled,
                    min: min,
                    max: max,
                    reverse: reverse,
                    index: 0,
                    tabIndex: tabIndex,
                    ariaLabel: ariaLabelForHandle,
                    ariaLabelledBy: ariaLabelledByForHandle,
                    ariaValueTextFormatter: ariaValueTextFormatterForHandle,
                    style: handleStyle[0] || handleStyle,
                    ref: function ref(h) {
                        return _this2.saveHandle(0, h);
                    }
                });
                var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
                var mergedTrackStyle = trackStyle[0] || trackStyle;
                var track = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $50b2e2071653f08e$export$2e2bcd8739ae039), {
                    className: "".concat(prefixCls, "-track"),
                    vertical: vertical,
                    included: included,
                    offset: trackOffset,
                    reverse: reverse,
                    length: offset - trackOffset,
                    style: (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, minimumTrackStyle), mergedTrackStyle)
                });
                return {
                    tracks: track,
                    handles: handle
                };
            }
        }
    ]);
    return Slider;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Component);
var $424139e045fedefc$export$2e2bcd8739ae039 = (0, $2ccbbbdef185509f$export$2e2bcd8739ae039)($424139e045fedefc$var$Slider);










var $9nZCP = parcelRequire("9nZCP");




var $1333fa204e4662b3$var$_trimAlignValue = function trimAlignValue(_ref) {
    var value = _ref.value, handle = _ref.handle, bounds = _ref.bounds, props = _ref.props;
    var allowCross = props.allowCross, pushable = props.pushable;
    var thershold = Number(pushable);
    var valInRange = $9595af4ca8f59963$export$65e4339c6f9d8d24(value, props);
    var valNotConflict = valInRange;
    if (!allowCross && handle != null && bounds !== undefined) {
        if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) valNotConflict = bounds[handle - 1] + thershold;
        if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) valNotConflict = bounds[handle + 1] - thershold;
    }
    return $9595af4ca8f59963$export$5bea24a9dfe5ab1a(valNotConflict, props);
};
var $1333fa204e4662b3$var$Range = /*#__PURE__*/ function(_React$Component) {
    (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(Range, _React$Component);
    var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(Range);
    function Range(props) {
        var _this;
        (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, Range);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            var bounds = _this.getValue();
            var value = _this.calcValueByPos(position);
            var closestBound = _this.getClosestBound(value);
            var index = _this.getBoundNeedMoving(value, closestBound);
            var prevValue = bounds[index];
            if (value === prevValue) return null;
            var nextBounds = (0, $513d655c75612b28$export$2e2bcd8739ae039)(bounds);
            nextBounds[index] = value;
            return nextBounds;
        };
        _this.onEnd = function(force) {
            var handle = _this.state.handle;
            _this.removeDocumentEvents();
            if (!handle) _this.dragTrack = false;
            if (handle !== null || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                handle: null
            });
        };
        var count = props.count, min = props.min, max = props.max;
        var initialValue = Array.apply(void 0, (0, $513d655c75612b28$export$2e2bcd8739ae039)(Array(count + 1))).map(function() {
            return min;
        });
        var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
        var value = props.value !== undefined ? props.value : defaultValue;
        var bounds = value.map(function(v, i) {
            return $1333fa204e4662b3$var$_trimAlignValue({
                value: v,
                handle: i,
                props: props
            });
        });
        var recent = bounds[0] === max ? 0 : bounds.length - 1;
        _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds
        };
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(Range, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "getSliderLength",
            value: function getSliderLength() {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _this$props = this.props, onChange = _this$props.onChange, value = _this$props.value, min = _this$props.min, max = _this$props.max;
                if (!('min' in this.props || 'max' in this.props)) return;
                if (min === prevProps.min && max === prevProps.max) return;
                var currentValue = value || prevState.bounds;
                if (currentValue.some(function(v) {
                    return $9595af4ca8f59963$export$f4657b4dc4cc2ea4(v, _this2.props);
                })) {
                    var newValues = currentValue.map(function(v) {
                        return $9595af4ca8f59963$export$65e4339c6f9d8d24(v, _this2.props);
                    });
                    onChange(newValues);
                }
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !('value' in props);
                if (isNotControlled) this.setState(state);
                else {
                    var controlledState = {};
                    [
                        'handle',
                        'recent'
                    ].forEach(function(item) {
                        if (state[item] !== undefined) controlledState[item] = state[item];
                    });
                    if (Object.keys(controlledState).length) this.setState(controlledState);
                }
                var data = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, this.state), state);
                var changedValue = data.bounds;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                var props = this.props, state = this.state;
                var bounds = this.getValue();
                props.onBeforeChange(bounds);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                var closestBound = this.getClosestBound(value);
                this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
                this.setState({
                    handle: this.prevMovedHandleIndex,
                    recent: this.prevMovedHandleIndex
                });
                var prevValue = bounds[this.prevMovedHandleIndex];
                if (value === prevValue) return;
                var nextBounds = (0, $513d655c75612b28$export$2e2bcd8739ae039)(state.bounds);
                nextBounds[this.prevMovedHandleIndex] = value;
                this.onChange({
                    bounds: nextBounds
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position, dragTrack, startBounds) {
                $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
                var state = this.state, props = this.props;
                var maxValue = props.max || 100;
                var minValue = props.min || 0;
                if (dragTrack) {
                    var pos = props.vertical ? -position : position;
                    pos = props.reverse ? -pos : pos;
                    var max = maxValue - Math.max.apply(Math, (0, $513d655c75612b28$export$2e2bcd8739ae039)(startBounds));
                    var min = minValue - Math.min.apply(Math, (0, $513d655c75612b28$export$2e2bcd8739ae039)(startBounds));
                    var ratio = Math.min(Math.max(pos / (this.getSliderLength() / (maxValue - minValue)), min), max);
                    var nextBounds = startBounds.map(function(v) {
                        return Math.floor(Math.max(Math.min(v + ratio, maxValue), minValue));
                    });
                    if (state.bounds.map(function(c, i) {
                        return c === nextBounds[i];
                    }).some(function(c) {
                        return !c;
                    })) this.onChange({
                        bounds: nextBounds
                    });
                    return;
                }
                var value = this.calcValueByPos(position);
                var oldValue = state.bounds[state.handle];
                if (value === oldValue) return;
                this.moveTo(value);
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $9595af4ca8f59963$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $9595af4ca8f59963$export$3f9ffdaf2961f43f(e);
                    var state = this.state, props = this.props;
                    var bounds = state.bounds, handle = state.handle;
                    var oldValue = bounds[handle === null ? state.recent : handle];
                    var mutatedValue = valueMutator(oldValue, props);
                    var value = $1333fa204e4662b3$var$_trimAlignValue({
                        value: mutatedValue,
                        handle: handle,
                        bounds: state.bounds,
                        props: props
                    });
                    if (value === oldValue) return;
                    var isFromKeyboardEvent = true;
                    this.moveTo(value, isFromKeyboardEvent);
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.bounds;
            }
        },
        {
            key: "getClosestBound",
            value: function getClosestBound(value) {
                var bounds = this.state.bounds;
                var closestBound = 0;
                for(var i = 1; i < bounds.length - 1; i += 1)if (value >= bounds[i]) closestBound = i;
                if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) closestBound += 1;
                return closestBound;
            }
        },
        {
            key: "getBoundNeedMoving",
            value: function getBoundNeedMoving(value, closestBound) {
                var _this$state = this.state, bounds = _this$state.bounds, recent = _this$state.recent;
                var boundNeedMoving = closestBound;
                var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
                if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) boundNeedMoving = recent;
                if (isAtTheSamePoint && value !== bounds[closestBound + 1]) boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
                return boundNeedMoving;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                return this.state.bounds[0];
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                var bounds = this.state.bounds;
                return bounds[bounds.length - 1];
            }
        },
        {
            key: "getPoints",
            value: function getPoints() {
                var _this$props3 = this.props, marks = _this$props3.marks, step = _this$props3.step, min = _this$props3.min, max = _this$props3.max;
                var cache = this.internalPointsCache;
                if (!cache || cache.marks !== marks || cache.step !== step) {
                    var pointsObject = (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, marks);
                    if (step !== null) for(var point = min; point <= max; point += step)pointsObject[point] = point;
                    var points = Object.keys(pointsObject).map(parseFloat);
                    points.sort(function(a, b) {
                        return a - b;
                    });
                    this.internalPointsCache = {
                        marks: marks,
                        step: step,
                        points: points
                    };
                }
                return this.internalPointsCache.points;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(value, isFromKeyboardEvent) {
                var _this3 = this;
                var state = this.state, props = this.props;
                var nextBounds = (0, $513d655c75612b28$export$2e2bcd8739ae039)(state.bounds);
                var handle = state.handle === null ? state.recent : state.handle;
                nextBounds[handle] = value;
                var nextHandle = handle;
                if (props.pushable !== false) this.pushSurroundingHandles(nextBounds, nextHandle);
                else if (props.allowCross) {
                    nextBounds.sort(function(a, b) {
                        return a - b;
                    });
                    nextHandle = nextBounds.indexOf(value);
                }
                this.onChange({
                    recent: nextHandle,
                    handle: nextHandle,
                    bounds: nextBounds
                });
                if (isFromKeyboardEvent) {
                    // known problem: because setState is async,
                    // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
                    // cause onBeforeChange and onAfterChange receive wrong value.
                    // here use setState callback to hack，but not elegant
                    this.props.onAfterChange(nextBounds);
                    this.setState({}, function() {
                        _this3.handlesRefs[nextHandle].focus();
                    });
                    this.onEnd();
                }
            }
        },
        {
            key: "pushSurroundingHandles",
            value: function pushSurroundingHandles(bounds, handle) {
                var value = bounds[handle];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var direction = 0;
                if (bounds[handle + 1] - value < threshold) direction = 1; // push to right
                if (value - bounds[handle - 1] < threshold) direction = -1; // push to left
                if (direction === 0) return;
                var nextHandle = handle + direction;
                var diffToNext = direction * (bounds[nextHandle] - value);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // revert to original value if pushing is impossible
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = bounds[nextHandle] - direction * threshold;
            }
        },
        {
            key: "pushHandle",
            value: function pushHandle(bounds, handle, direction, amount) {
                var originalValue = bounds[handle];
                var currentValue = bounds[handle];
                while(direction * (currentValue - originalValue) < amount){
                    if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                        // can't push handle enough to create the needed `amount` gap, so we
                        // revert its position to the original value
                        // eslint-disable-next-line no-param-reassign
                        bounds[handle] = originalValue;
                        return false;
                    }
                    currentValue = bounds[handle];
                } // the handle was pushed enough to create the needed `amount` gap
                return true;
            }
        },
        {
            key: "pushHandleOnePoint",
            value: function pushHandleOnePoint(bounds, handle, direction) {
                var points = this.getPoints();
                var pointIndex = points.indexOf(bounds[handle]);
                var nextPointIndex = pointIndex + direction;
                if (nextPointIndex >= points.length || nextPointIndex < 0) // reached the minimum or maximum available point, can't push anymore
                return false;
                var nextHandle = handle + direction;
                var nextValue = points[nextPointIndex];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var diffToNext = direction * (bounds[nextHandle] - nextValue);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // couldn't push next handle, so we won't push this one either
                return false;
                 // push the handle
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = nextValue;
                return true;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(value) {
                var _this$state2 = this.state, handle = _this$state2.handle, bounds = _this$state2.bounds;
                return $1333fa204e4662b3$var$_trimAlignValue({
                    value: value,
                    handle: handle,
                    bounds: bounds,
                    props: this.props
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _this$state3 = this.state, handle = _this$state3.handle, bounds = _this$state3.bounds;
                var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, vertical = _this$props4.vertical, included = _this$props4.included, disabled = _this$props4.disabled, min = _this$props4.min, max = _this$props4.max, reverse = _this$props4.reverse, handleGenerator = _this$props4.handle, trackStyle = _this$props4.trackStyle, handleStyle = _this$props4.handleStyle, tabIndex = _this$props4.tabIndex, ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles, ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles, ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
                var offsets = bounds.map(function(v) {
                    return _this4.calcOffset(v);
                });
                var handleClassName = "".concat(prefixCls, "-handle");
                var handles = bounds.map(function(v, i) {
                    var _classNames;
                    var mergedTabIndex = tabIndex[i] || 0;
                    if (disabled || tabIndex[i] === null) mergedTabIndex = null;
                    var dragging = handle === i;
                    return handleGenerator({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))((_classNames = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, handleClassName, true), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-").concat(i + 1), true), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
                        prefixCls: prefixCls,
                        vertical: vertical,
                        dragging: dragging,
                        offset: offsets[i],
                        value: v,
                        index: i,
                        tabIndex: mergedTabIndex,
                        min: min,
                        max: max,
                        reverse: reverse,
                        disabled: disabled,
                        style: handleStyle[i],
                        ref: function ref(h) {
                            return _this4.saveHandle(i, h);
                        },
                        ariaLabel: ariaLabelGroupForHandles[i],
                        ariaLabelledBy: ariaLabelledByGroupForHandles[i],
                        ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
                    });
                });
                var tracks = bounds.slice(0, -1).map(function(_, index) {
                    var _classNames2;
                    var i = index + 1;
                    var trackClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))((_classNames2 = {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track"), true), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track-").concat(i), true), _classNames2));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $50b2e2071653f08e$export$2e2bcd8739ae039), {
                        className: trackClassName,
                        vertical: vertical,
                        reverse: reverse,
                        included: included,
                        offset: offsets[i - 1],
                        length: offsets[i] - offsets[i - 1],
                        style: trackStyle[index],
                        key: i
                    });
                });
                return {
                    tracks: tracks,
                    handles: handles
                };
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (!('value' in props || 'min' in props || 'max' in props)) return null;
                var value = props.value || state.bounds;
                var nextBounds = value.map(function(v, i) {
                    return $1333fa204e4662b3$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        bounds: state.bounds,
                        props: props
                    });
                });
                if (state.bounds.length === nextBounds.length) {
                    if (nextBounds.every(function(v, i) {
                        return v === state.bounds[i];
                    })) return null;
                } else nextBounds = value.map(function(v, i) {
                    return $1333fa204e4662b3$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        props: props
                    });
                });
                return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, state), {}, {
                    bounds: nextBounds
                });
            }
        }
    ]);
    return Range;
}((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Component);
/* eslint-enable */ $1333fa204e4662b3$var$Range.displayName = 'Range';
$1333fa204e4662b3$var$Range.defaultProps = {
    count: 1,
    allowCross: true,
    pushable: false,
    draggableTrack: false,
    tabIndex: [],
    ariaLabelGroupForHandles: [],
    ariaLabelledByGroupForHandles: [],
    ariaValueTextFormatterGroupForHandles: []
};
var $1333fa204e4662b3$export$2e2bcd8739ae039 = (0, $2ccbbbdef185509f$export$2e2bcd8739ae039)($1333fa204e4662b3$var$Range);












var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");





var $9nZCP = parcelRequire("9nZCP");









var $9nZCP = parcelRequire("9nZCP");

var $74c50fa010549a87$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $74c50fa010549a87$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $74c50fa010549a87$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $74c50fa010549a87$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $74c50fa010549a87$var$rafUUID = 0;
var $74c50fa010549a87$var$rafIds = new Map();
function $74c50fa010549a87$var$cleanup(id) {
    $74c50fa010549a87$var$rafIds.delete(id);
}
var $74c50fa010549a87$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $74c50fa010549a87$var$rafUUID += 1;
    var id = $74c50fa010549a87$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $74c50fa010549a87$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $74c50fa010549a87$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $74c50fa010549a87$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$74c50fa010549a87$var$wrapperRaf.cancel = function(id) {
    var realId = $74c50fa010549a87$var$rafIds.get(id);
    $74c50fa010549a87$var$cleanup(id);
    return $74c50fa010549a87$var$caf(realId);
};
var $74c50fa010549a87$export$2e2bcd8739ae039 = $74c50fa010549a87$var$wrapperRaf;


function $a5f4fb2511f41816$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}




var $9nZCP = parcelRequire("9nZCP");

function $93bb6ec4cced17a6$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $93bb6ec4cced17a6$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(node) === 'object' && $93bb6ec4cced17a6$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($93bb6ec4cced17a6$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $93bb6ec4cced17a6$export$2e2bcd8739ae039(node) {
    var domNode = $93bb6ec4cced17a6$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))), node);
    }
    return null;
}




var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");
function $78ee045b99bd059c$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $9nZCP.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}



var $ba3a81fede34ba5d$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $ba3a81fede34ba5d$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $ba3a81fede34ba5d$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $ba3a81fede34ba5d$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(object) === 'object' && // React Element type
    (object.$$typeof === $ba3a81fede34ba5d$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $ba3a81fede34ba5d$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $ba3a81fede34ba5d$var$REACT_FRAGMENT_TYPE);
}


var $ece7587e1886b1b9$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $ece7587e1886b1b9$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $ece7587e1886b1b9$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $ece7587e1886b1b9$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $78ee045b99bd059c$export$2e2bcd8739ae039)(function() {
        return $ece7587e1886b1b9$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $ece7587e1886b1b9$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($ece7587e1886b1b9$var$isReactElement(nodeOrComponent) && nodeOrComponent.props.propertyIsEnumerable('ref')) return true;
    var type = (0, $641555432cc96e57$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $641555432cc96e57$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $641555432cc96e57$exports.ForwardRef)) return false;
    return true;
};
function $ece7587e1886b1b9$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $9nZCP.isValidElement)(node) && !(0, $ba3a81fede34ba5d$export$2e2bcd8739ae039)(node);
}
var $ece7587e1886b1b9$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $ece7587e1886b1b9$var$isReactElement(node) && $ece7587e1886b1b9$export$c1cec34af06bcf7(node);
};
var $ece7587e1886b1b9$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $ece7587e1886b1b9$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};




var $9nZCP = parcelRequire("9nZCP");

function $f14589e789dffb0e$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


var $f28890857a395782$var$Portal = /*#__PURE__*/ (0, $9nZCP.forwardRef)(function(props, ref) {
    var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
    var parentRef = (0, $9nZCP.useRef)();
    var containerRef = (0, $9nZCP.useRef)();
    // Ref return nothing, only for wrapper check exist
    (0, $9nZCP.useImperativeHandle)(ref, function() {
        return {};
    });
    // Create container in client side with sync to avoid useEffect not get ref
    var initRef = (0, $9nZCP.useRef)(false);
    if (!initRef.current && (0, $f14589e789dffb0e$export$2e2bcd8739ae039)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $9nZCP.useEffect)(function() {
        didUpdate === null || didUpdate === void 0 || didUpdate(props);
    });
    (0, $9nZCP.useEffect)(function() {
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return function() {
            var _containerRef$current;
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))).createPortal(children, containerRef.current) : null;
});
var $f28890857a395782$export$2e2bcd8739ae039 = $f28890857a395782$var$Portal;




function $d5666b43b133354b$var$isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $d5666b43b133354b$export$44605b74f7c5d944(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, baseAlign), align);
}
function $d5666b43b133354b$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var placement = placements[i];
        if ($d5666b43b133354b$var$isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return '';
}




function $7b7118c37340dbc2$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $66926ee39021de02$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $0512d7435b9a4ed1$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $5364cf1643bb9b6d$export$2e2bcd8739ae039(r, e) {
    return (0, $7b7118c37340dbc2$export$2e2bcd8739ae039)(r) || (0, $66926ee39021de02$export$2e2bcd8739ae039)(r, e) || (0, $972a974728b0ca3d$export$2e2bcd8739ae039)(r, e) || (0, $0512d7435b9a4ed1$export$2e2bcd8739ae039)();
}




var $9nZCP = parcelRequire("9nZCP");
var $0be4b22dededee67$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};





var $9nZCP = parcelRequire("9nZCP");









var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");
var $6f49c89efcd6b8a4$var$_excluded = [
    "children"
];
var $6f49c89efcd6b8a4$export$841858b892ce1f4c = /*#__PURE__*/ $9nZCP.createContext({});
function $6f49c89efcd6b8a4$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_ref, $6f49c89efcd6b8a4$var$_excluded);
    return /*#__PURE__*/ $9nZCP.createElement($6f49c89efcd6b8a4$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $9nZCP = parcelRequire("9nZCP");
var $67a41eee446def57$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($9nZCP.Component);
var $67a41eee446def57$export$2e2bcd8739ae039 = $67a41eee446def57$var$DomWrapper;






var $9nZCP = parcelRequire("9nZCP");
function $d015c949809bb4a7$export$2e2bcd8739ae039(callback) {
    var fnRef = $9nZCP.useRef();
    fnRef.current = callback;
    var memoFn = $9nZCP.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}





var $9nZCP = parcelRequire("9nZCP");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $5c3e3cad1a762d0b$var$useInternalLayoutEffect = (0, $f14589e789dffb0e$export$2e2bcd8739ae039)() ? $9nZCP.useLayoutEffect : $9nZCP.useEffect;
var $5c3e3cad1a762d0b$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $9nZCP.useRef(true);
    $5c3e3cad1a762d0b$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $5c3e3cad1a762d0b$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $5c3e3cad1a762d0b$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $5c3e3cad1a762d0b$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $5c3e3cad1a762d0b$export$2e2bcd8739ae039 = $5c3e3cad1a762d0b$var$useLayoutEffect;




var $9nZCP = parcelRequire("9nZCP");
function $4e01688ba8da34ba$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $9nZCP.useRef(false);
    var _React$useState = $9nZCP.useState(defaultValue), _React$useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $9nZCP.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $e8529fdf7cd6abdf$var$hasValue(value) {
    return value !== undefined;
}
function $e8529fdf7cd6abdf$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)(function() {
        if ($e8529fdf7cd6abdf$var$hasValue(value)) return value;
        else if ($e8529fdf7cd6abdf$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $d015c949809bb4a7$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $5c3e3cad1a762d0b$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $5c3e3cad1a762d0b$export$9283e56bae2f7b0f)(function() {
        if (!$e8529fdf7cd6abdf$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $d015c949809bb4a7$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



function $f70c1867d80a62b3$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}









function $a47e6a9d9c2482f0$export$2e2bcd8739ae039(r) {
    return (0, $7b7118c37340dbc2$export$2e2bcd8739ae039)(r) || (0, $d13b6ea07b6676dc$export$2e2bcd8739ae039)(r) || (0, $972a974728b0ca3d$export$2e2bcd8739ae039)(r) || (0, $0512d7435b9a4ed1$export$2e2bcd8739ae039)();
}



function $dfbb767e3acfb28d$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $a47e6a9d9c2482f0$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $513d655c75612b28$export$2e2bcd8739ae039)(entity);
    else clone = (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $dfbb767e3acfb28d$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $dfbb767e3acfb28d$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $f70c1867d80a62b3$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $dfbb767e3acfb28d$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $dfbb767e3acfb28d$var$isObject(obj) {
    return (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $dfbb767e3acfb28d$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $dfbb767e3acfb28d$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $dfbb767e3acfb28d$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $dfbb767e3acfb28d$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $f70c1867d80a62b3$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $dfbb767e3acfb28d$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $f70c1867d80a62b3$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $dfbb767e3acfb28d$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $dfbb767e3acfb28d$export$2e2bcd8739ae039(clone, path, $dfbb767e3acfb28d$var$createEmpty(value));
                    $dfbb767e3acfb28d$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $513d655c75612b28$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $dfbb767e3acfb28d$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}








var $9nZCP = parcelRequire("9nZCP");

function $ab654d5c4393bde6$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $9nZCP.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $9nZCP.useRef(defaultValue);
    var getValue = (0, $d015c949809bb4a7$export$2e2bcd8739ae039)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $d015c949809bb4a7$export$2e2bcd8739ae039)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}



var $9nZCP = parcelRequire("9nZCP");
var $7d9f27a1ecfcb923$export$de71442bbf2143da = 'none';
var $7d9f27a1ecfcb923$export$4fc3521687bcacd2 = 'appear';
var $7d9f27a1ecfcb923$export$5d6af549241fe2e8 = 'enter';
var $7d9f27a1ecfcb923$export$59b1c493d29f68e4 = 'leave';
var $7d9f27a1ecfcb923$export$40b34dd77d5522bf = 'none';
var $7d9f27a1ecfcb923$export$1b792916a5fac4fc = 'prepare';
var $7d9f27a1ecfcb923$export$9563153dd25a3ce8 = 'start';
var $7d9f27a1ecfcb923$export$e205886172277ec6 = 'active';
var $7d9f27a1ecfcb923$export$3a846c3d2fac10b8 = 'end';
var $7d9f27a1ecfcb923$export$98351fa4e6b4f204 = 'prepared';



var $9nZCP = parcelRequire("9nZCP");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $65be73a51576fb77$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $65be73a51576fb77$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $65be73a51576fb77$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $65be73a51576fb77$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $65be73a51576fb77$var$vendorPrefixes = $65be73a51576fb77$export$6e8b350b1a8958a0((0, $f14589e789dffb0e$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
var $65be73a51576fb77$var$style = {};
if ((0, $f14589e789dffb0e$export$2e2bcd8739ae039)()) {
    var $65be73a51576fb77$var$_document$createEleme = document.createElement('div');
    $65be73a51576fb77$var$style = $65be73a51576fb77$var$_document$createEleme.style;
}
var $65be73a51576fb77$var$prefixedEventNames = {};
function $65be73a51576fb77$export$a032e4f39350c1d8(eventName) {
    if ($65be73a51576fb77$var$prefixedEventNames[eventName]) return $65be73a51576fb77$var$prefixedEventNames[eventName];
    var prefixMap = $65be73a51576fb77$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $65be73a51576fb77$var$style) {
                $65be73a51576fb77$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $65be73a51576fb77$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $65be73a51576fb77$var$internalAnimationEndName = $65be73a51576fb77$export$a032e4f39350c1d8('animationend');
var $65be73a51576fb77$var$internalTransitionEndName = $65be73a51576fb77$export$a032e4f39350c1d8('transitionend');
var $65be73a51576fb77$export$d28133ed3ad06c8b = !!($65be73a51576fb77$var$internalAnimationEndName && $65be73a51576fb77$var$internalTransitionEndName);
var $65be73a51576fb77$export$760cc9769c51b738 = $65be73a51576fb77$var$internalAnimationEndName || 'animationend';
var $65be73a51576fb77$export$44baea64b8602e3c = $65be73a51576fb77$var$internalTransitionEndName || 'transitionend';
function $65be73a51576fb77$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $e852ff56348c9091$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $9nZCP.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $65be73a51576fb77$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $65be73a51576fb77$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $65be73a51576fb77$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $65be73a51576fb77$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $9nZCP.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $9nZCP = parcelRequire("9nZCP");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $272eb0a7d82dfb31$var$useIsomorphicLayoutEffect = (0, $f14589e789dffb0e$export$2e2bcd8739ae039)() ? (0, $9nZCP.useLayoutEffect) : (0, $9nZCP.useEffect);
var $272eb0a7d82dfb31$export$2e2bcd8739ae039 = $272eb0a7d82dfb31$var$useIsomorphicLayoutEffect;





var $9nZCP = parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");
var $6904c33263bf6c3a$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $9nZCP.useRef(null);
    function cancelNextFrame() {
        (0, $74c50fa010549a87$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $74c50fa010549a87$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $9nZCP.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $3bfe7cebc04eb42c$var$FULL_STEP_QUEUE = [
    (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc),
    (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8),
    (0, $7d9f27a1ecfcb923$export$e205886172277ec6),
    (0, $7d9f27a1ecfcb923$export$3a846c3d2fac10b8)
];
var $3bfe7cebc04eb42c$var$SIMPLE_STEP_QUEUE = [
    (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc),
    (0, $7d9f27a1ecfcb923$export$98351fa4e6b4f204)
];
var $3bfe7cebc04eb42c$export$c2029bf6cfdbc28a = false;
var $3bfe7cebc04eb42c$export$dbee1e282e8c4830 = true;
function $3bfe7cebc04eb42c$export$39e04e72f972b885(step) {
    return step === (0, $7d9f27a1ecfcb923$export$e205886172277ec6) || step === (0, $7d9f27a1ecfcb923$export$3a846c3d2fac10b8);
}
var $3bfe7cebc04eb42c$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)((0, $7d9f27a1ecfcb923$export$40b34dd77d5522bf)), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $6904c33263bf6c3a$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $3bfe7cebc04eb42c$var$SIMPLE_STEP_QUEUE : $3bfe7cebc04eb42c$var$FULL_STEP_QUEUE;
    (0, $272eb0a7d82dfb31$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $7d9f27a1ecfcb923$export$40b34dd77d5522bf) && step !== (0, $7d9f27a1ecfcb923$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $3bfe7cebc04eb42c$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $9nZCP.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $b63fc9da4878f335$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)(), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $ab654d5c4393bde6$export$2e2bcd8739ae039)((0, $7d9f27a1ecfcb923$export$de71442bbf2143da)), _useSyncState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)(null), _useState4 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $9nZCP.useRef)(false);
    var deadlineRef = (0, $9nZCP.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $9nZCP.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $7d9f27a1ecfcb923$export$de71442bbf2143da));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $d015c949809bb4a7$export$2e2bcd8739ae039)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $7d9f27a1ecfcb923$export$de71442bbf2143da)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $7d9f27a1ecfcb923$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $7d9f27a1ecfcb923$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $7d9f27a1ecfcb923$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $e852ff56348c9091$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $7d9f27a1ecfcb923$export$4fc3521687bcacd2:
                return (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc), onAppearPrepare), (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8), onAppearStart), (0, $7d9f27a1ecfcb923$export$e205886172277ec6), onAppearActive);
            case 0, $7d9f27a1ecfcb923$export$5d6af549241fe2e8:
                return (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc), onEnterPrepare), (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8), onEnterStart), (0, $7d9f27a1ecfcb923$export$e205886172277ec6), onEnterActive);
            case 0, $7d9f27a1ecfcb923$export$59b1c493d29f68e4:
                return (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc), onLeavePrepare), (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8), onLeaveStart), (0, $7d9f27a1ecfcb923$export$e205886172277ec6), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $9nZCP.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $3bfe7cebc04eb42c$export$2e2bcd8739ae039)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $3bfe7cebc04eb42c$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $7d9f27a1ecfcb923$export$e205886172277ec6) && currentStatus !== (0, $7d9f27a1ecfcb923$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $7d9f27a1ecfcb923$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $3bfe7cebc04eb42c$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $3bfe7cebc04eb42c$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    // Update with new status
    (0, $272eb0a7d82dfb31$export$2e2bcd8739ae039)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $7d9f27a1ecfcb923$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $7d9f27a1ecfcb923$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $7d9f27a1ecfcb923$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $7d9f27a1ecfcb923$export$de71442bbf2143da));
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $9nZCP.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $7d9f27a1ecfcb923$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $7d9f27a1ecfcb923$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $7d9f27a1ecfcb923$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $7d9f27a1ecfcb923$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $9nZCP.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $9nZCP.useRef(false);
    (0, $9nZCP.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $7d9f27a1ecfcb923$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc] && step === (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8)) mergedStyle = (0, $835511f338e067d8$export$2e2bcd8739ae039)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $c4ab6975dfa295b2$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $9nZCP.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $9nZCP.useContext((0, $6f49c89efcd6b8a4$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $9nZCP.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $9nZCP.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $93bb6ec4cced17a6$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $b63fc9da4878f335$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $9nZCP.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $9nZCP.useCallback(function(node) {
            nodeRef.current = node;
            (0, $ece7587e1886b1b9$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $7d9f27a1ecfcb923$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $7d9f27a1ecfcb923$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
            else if ((0, $3bfe7cebc04eb42c$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $7d9f27a1ecfcb923$export$9563153dd25a3ce8)) statusSuffix = 'start';
            var motionCls = (0, $65be73a51576fb77$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))((0, $65be73a51576fb77$export$27c72201b1d09951)(motionName, status), (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $9nZCP.isValidElement(motionChildren) && (0, $ece7587e1886b1b9$export$c1cec34af06bcf7)(motionChildren)) {
            var originNodeRef = (0, $ece7587e1886b1b9$export$7465e5c0bf44f19a)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $9nZCP.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $9nZCP.createElement((0, $67a41eee446def57$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $c4ab6975dfa295b2$export$2e2bcd8739ae039 = $c4ab6975dfa295b2$export$e265d52a86a9f199((0, $65be73a51576fb77$export$d28133ed3ad06c8b));












var $9nZCP = parcelRequire("9nZCP");



var $9e3a6d91ab4ec0d6$export$3904baa009bc026e = 'add';
var $9e3a6d91ab4ec0d6$export$851162f0adad2cbc = 'keep';
var $9e3a6d91ab4ec0d6$export$c8b3fb08b68cfc85 = 'remove';
var $9e3a6d91ab4ec0d6$export$2ac1bd1808d2e43a = 'removed';
function $9e3a6d91ab4ec0d6$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $9e3a6d91ab4ec0d6$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($9e3a6d91ab4ec0d6$export$c47fd798e598c85c);
}
function $9e3a6d91ab4ec0d6$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $9e3a6d91ab4ec0d6$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $9e3a6d91ab4ec0d6$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $9e3a6d91ab4ec0d6$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $9e3a6d91ab4ec0d6$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $9e3a6d91ab4ec0d6$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $9e3a6d91ab4ec0d6$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $9e3a6d91ab4ec0d6$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $9e3a6d91ab4ec0d6$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $3c4117f4af9ea6fe$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $3c4117f4af9ea6fe$var$_excluded2 = [
    "status"
];
var $3c4117f4af9ea6fe$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $3c4117f4af9ea6fe$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $c4ab6975dfa295b2$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, entity), {}, {
                            status: (0, $9e3a6d91ab4ec0d6$export$2ac1bd1808d2e43a)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $9e3a6d91ab4ec0d6$export$2ac1bd1808d2e43a);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_this$props, $3c4117f4af9ea6fe$var$_excluded);
                    var Component = component || $9nZCP.Fragment;
                    var motionProps = {};
                    $3c4117f4af9ea6fe$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $9nZCP.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_ref2, $3c4117f4af9ea6fe$var$_excluded2);
                        var visible = status === (0, $9e3a6d91ab4ec0d6$export$3904baa009bc026e) || status === (0, $9e3a6d91ab4ec0d6$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $9nZCP.createElement(CSSMotion, (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $9e3a6d91ab4ec0d6$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $9e3a6d91ab4ec0d6$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $9e3a6d91ab4ec0d6$export$2ac1bd1808d2e43a) && entity.status === (0, $9e3a6d91ab4ec0d6$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($9nZCP.Component);
    (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $3c4117f4af9ea6fe$export$2e2bcd8739ae039 = $3c4117f4af9ea6fe$export$fcfc62c1d33d5e2e((0, $65be73a51576fb77$export$d28133ed3ad06c8b));



var $ba55528cb86ff86c$export$2e2bcd8739ae039 = (0, $c4ab6975dfa295b2$export$2e2bcd8739ae039);


function $daa737f1914dfdb8$export$7b8936ddc277a29a(_ref) {
    var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName = _ref.transitionName;
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}


function $2c5306aae19cdf6e$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) return null;
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) motion = (0, $835511f338e067d8$export$2e2bcd8739ae039)({
        motionAppear: true
    }, (0, $daa737f1914dfdb8$export$7b8936ddc277a29a)({
        motion: maskMotion,
        prefixCls: prefixCls,
        transitionName: maskTransitionName,
        animation: maskAnimation
    }));
    return /*#__PURE__*/ $9nZCP.createElement((0, $ba55528cb86ff86c$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, motion, {
        visible: visible,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $9nZCP.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}






var $9nZCP = parcelRequire("9nZCP");
// export this package's api


function $d519476296871852$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d519476296871852$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d519476296871852$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d519476296871852$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d519476296871852$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d519476296871852$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d519476296871852$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d519476296871852$var$_typeof(obj);
}
function $d519476296871852$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d519476296871852$var$vendorPrefix;
var $d519476296871852$var$jsCssMap = {
    Webkit: '-webkit-',
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-'
};
function $d519476296871852$var$getVendorPrefix() {
    if ($d519476296871852$var$vendorPrefix !== undefined) return $d519476296871852$var$vendorPrefix;
    $d519476296871852$var$vendorPrefix = '';
    var style = document.createElement('p').style;
    var testProp = 'Transform';
    for(var key in $d519476296871852$var$jsCssMap)if (key + testProp in style) $d519476296871852$var$vendorPrefix = key;
    return $d519476296871852$var$vendorPrefix;
}
function $d519476296871852$var$getTransitionName() {
    return $d519476296871852$var$getVendorPrefix() ? "".concat($d519476296871852$var$getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function $d519476296871852$var$getTransformName() {
    return $d519476296871852$var$getVendorPrefix() ? "".concat($d519476296871852$var$getVendorPrefix(), "Transform") : 'transform';
}
function $d519476296871852$var$setTransitionProperty(node, value) {
    var name = $d519476296871852$var$getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transitionProperty') node.style.transitionProperty = value;
    }
}
function $d519476296871852$var$setTransform(node, value) {
    var name = $d519476296871852$var$getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transform') node.style.transform = value;
    }
}
function $d519476296871852$var$getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[$d519476296871852$var$getTransitionName()];
}
function $d519476296871852$var$getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($d519476296871852$var$getTransformName());
    if (transform && transform !== 'none') {
        var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var $d519476296871852$var$matrix2d = /matrix\((.*)\)/;
var $d519476296871852$var$matrix3d = /matrix3d\((.*)\)/;
function $d519476296871852$var$setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($d519476296871852$var$getTransformName());
    if (transform && transform !== 'none') {
        var arr;
        var match2d = transform.match($d519476296871852$var$matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            $d519476296871852$var$setTransform(node, "matrix(".concat(arr.join(','), ")"));
        } else {
            var match3d = transform.match($d519476296871852$var$matrix3d)[1];
            arr = match3d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            $d519476296871852$var$setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
        }
    } else $d519476296871852$var$setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var $d519476296871852$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var $d519476296871852$var$getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function $d519476296871852$var$forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = 'none';
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function $d519476296871852$var$css(el, name, v) {
    var value = v;
    if ($d519476296871852$var$_typeof(name) === 'object') {
        for(var i in name)if (name.hasOwnProperty(i)) $d519476296871852$var$css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== 'undefined') {
        if (typeof value === 'number') value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return $d519476296871852$var$getComputedStyleX(el, name);
}
function $d519476296871852$var$getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $d519476296871852$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== 'number') // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $d519476296871852$var$getScrollLeft(w) {
    return $d519476296871852$var$getScroll(w);
}
function $d519476296871852$var$getScrollTop(w) {
    return $d519476296871852$var$getScroll(w, true);
}
function $d519476296871852$var$getOffset(el) {
    var pos = $d519476296871852$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $d519476296871852$var$getScrollLeft(w);
    pos.top += $d519476296871852$var$getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $d519476296871852$var$isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function $d519476296871852$var$getDocument(node) {
    if ($d519476296871852$var$isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function $d519476296871852$var$_getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = '';
    var d = $d519476296871852$var$getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $d519476296871852$var$_RE_NUM_NO_PX = new RegExp("^(".concat($d519476296871852$var$RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var $d519476296871852$var$RE_POS = /^(top|right|bottom|left)$/;
var $d519476296871852$var$CURRENT_STYLE = 'currentStyle';
var $d519476296871852$var$RUNTIME_STYLE = 'runtimeStyle';
var $d519476296871852$var$LEFT = 'left';
var $d519476296871852$var$PX = 'px';
function $d519476296871852$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$d519476296871852$var$CURRENT_STYLE] && elem[$d519476296871852$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($d519476296871852$var$_RE_NUM_NO_PX.test(ret) && !$d519476296871852$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[$d519476296871852$var$LEFT];
        var rsLeft = elem[$d519476296871852$var$RUNTIME_STYLE][$d519476296871852$var$LEFT];
        // prevent flashing of content
        elem[$d519476296871852$var$RUNTIME_STYLE][$d519476296871852$var$LEFT] = elem[$d519476296871852$var$CURRENT_STYLE][$d519476296871852$var$LEFT];
        // Put in the new values to get a computed value out
        style[$d519476296871852$var$LEFT] = name === 'fontSize' ? '1em' : ret || 0;
        ret = style.pixelLeft + $d519476296871852$var$PX;
        // Revert the changed values
        style[$d519476296871852$var$LEFT] = left;
        elem[$d519476296871852$var$RUNTIME_STYLE][$d519476296871852$var$LEFT] = rsLeft;
    }
    return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') $d519476296871852$var$getComputedStyleX = window.getComputedStyle ? $d519476296871852$var$_getComputedStyle : $d519476296871852$var$_getComputedStyleIE;
function $d519476296871852$var$getOffsetDirection(dir, option) {
    if (dir === 'left') return option.useCssRight ? 'right' : dir;
    return option.useCssBottom ? 'bottom' : dir;
}
function $d519476296871852$var$oppositeOffsetDirection(dir) {
    if (dir === 'left') return 'right';
    else if (dir === 'right') return 'left';
    else if (dir === 'top') return 'bottom';
    else if (dir === 'bottom') return 'top';
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function $d519476296871852$var$setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if ($d519476296871852$var$css(elem, 'position') === 'static') elem.style.position = 'relative';
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = $d519476296871852$var$getOffsetDirection('left', option);
    var verticalProperty = $d519476296871852$var$getOffsetDirection('top', option);
    var oppositeHorizontalProperty = $d519476296871852$var$oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = $d519476296871852$var$oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== 'left') presetH = 999;
    if (verticalProperty !== 'top') presetV = 999;
    var originalTransition = '';
    var originalOffset = $d519476296871852$var$getOffset(elem);
    if ('left' in offset || 'top' in offset) {
        originalTransition = $d519476296871852$var$getTransitionProperty(elem) || '';
        $d519476296871852$var$setTransitionProperty(elem, 'none');
    }
    if ('left' in offset) {
        elem.style[oppositeHorizontalProperty] = '';
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ('top' in offset) {
        elem.style[oppositeVerticalProperty] = '';
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    $d519476296871852$var$forceRelayout(elem);
    var old = $d519476296871852$var$getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = $d519476296871852$var$getOffsetDirection(key, option);
        var preset = key === 'left' ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    $d519476296871852$var$css(elem, originalStyle);
    // force relayout
    $d519476296871852$var$forceRelayout(elem);
    if ('left' in offset || 'top' in offset) $d519476296871852$var$setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = $d519476296871852$var$getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    $d519476296871852$var$css(elem, ret);
}
function $d519476296871852$var$setTransform$1(elem, offset) {
    var originalOffset = $d519476296871852$var$getOffset(elem);
    var originalXY = $d519476296871852$var$getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ('left' in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ('top' in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    $d519476296871852$var$setTransformXY(elem, resultXY);
}
function $d519476296871852$var$setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = $d519476296871852$var$getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) $d519476296871852$var$setLeftTop(elem, offset, option);
    else if (option.useCssTransform && $d519476296871852$var$getTransformName() in document.body.style) $d519476296871852$var$setTransform$1(elem, offset);
    else $d519476296871852$var$setLeftTop(elem, offset, option);
}
function $d519476296871852$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $d519476296871852$var$isBorderBoxFn(elem) {
    return $d519476296871852$var$getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var $d519476296871852$var$BOX_MODELS = [
    'margin',
    'border',
    'padding'
];
var $d519476296871852$var$CONTENT_INDEX = -1;
var $d519476296871852$var$PADDING_INDEX = 2;
var $d519476296871852$var$BORDER_INDEX = 1;
var $d519476296871852$var$MARGIN_INDEX = 0;
function $d519476296871852$var$swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function $d519476296871852$var$getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === 'border') cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat($d519476296871852$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var $d519476296871852$var$domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
$d519476296871852$var$each([
    'Width',
    'Height'
], function(name) {
    $d519476296871852$var$domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], $d519476296871852$var$domUtils["viewport".concat(name)](d));
    };
    $d519476296871852$var$domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $d519476296871852$var$getWH(elem, name, ex) {
    var extra = ex;
    if ($d519476296871852$var$isWindow(elem)) return name === 'width' ? $d519476296871852$var$domUtils.viewportWidth(elem) : $d519476296871852$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === 'width' ? $d519476296871852$var$domUtils.docWidth(elem) : $d519476296871852$var$domUtils.docHeight(elem);
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = $d519476296871852$var$isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $d519476296871852$var$getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $d519476296871852$var$BORDER_INDEX : $d519476296871852$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $d519476296871852$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $d519476296871852$var$getPBMWidth(elem, [
            'border',
            'padding'
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === $d519476296871852$var$BORDER_INDEX) return val;
        return val + (extra === $d519476296871852$var$PADDING_INDEX ? -$d519476296871852$var$getPBMWidth(elem, [
            'border'
        ], which) : $d519476296871852$var$getPBMWidth(elem, [
            'margin'
        ], which));
    }
    return cssBoxValue + $d519476296871852$var$getPBMWidth(elem, $d519476296871852$var$BOX_MODELS.slice(extra), which);
}
var $d519476296871852$var$cssShow = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $d519476296871852$var$getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $d519476296871852$var$getWH.apply(undefined, args);
    else $d519476296871852$var$swap(elem, $d519476296871852$var$cssShow, function() {
        val = $d519476296871852$var$getWH.apply(undefined, args);
    });
    return val;
}
$d519476296871852$var$each([
    'width',
    'height'
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $d519476296871852$var$domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && $d519476296871852$var$getWHIgnoreDisplay(el, name, includeMargin ? $d519476296871852$var$MARGIN_INDEX : $d519476296871852$var$BORDER_INDEX);
    };
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    $d519476296871852$var$domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = $d519476296871852$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $d519476296871852$var$getPBMWidth(elem, [
                    'padding',
                    'border'
                ], which);
                return $d519476296871852$var$css(elem, name, val);
            }
            return undefined;
        }
        return elem && $d519476296871852$var$getWHIgnoreDisplay(elem, name, $d519476296871852$var$CONTENT_INDEX);
    };
});
function $d519476296871852$var$mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var $d519476296871852$var$utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: $d519476296871852$var$getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== 'undefined') $d519476296871852$var$setOffset(el, value, option || {});
        else return $d519476296871852$var$getOffset(el);
    },
    isWindow: $d519476296871852$var$isWindow,
    each: $d519476296871852$var$each,
    css: $d519476296871852$var$css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: $d519476296871852$var$mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return $d519476296871852$var$getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return $d519476296871852$var$getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$d519476296871852$var$utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$d519476296871852$var$mix($d519476296871852$var$utils, $d519476296871852$var$domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var $d519476296871852$var$getParent = $d519476296871852$var$utils.getParent;
function $d519476296871852$var$getOffsetParent(element) {
    if ($d519476296871852$var$utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = $d519476296871852$var$utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = $d519476296871852$var$utils.css(element, 'position');
    var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
    if (!skipStatic) return element.nodeName.toLowerCase() === 'html' ? null : $d519476296871852$var$getParent(element);
    for(parent = $d519476296871852$var$getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = $d519476296871852$var$getParent(parent)){
        positionStyle = $d519476296871852$var$utils.css(parent, 'position');
        if (positionStyle !== 'static') return parent;
    }
    return null;
}
var $d519476296871852$var$getParent$1 = $d519476296871852$var$utils.getParent;
function $d519476296871852$var$isAncestorFixed(element) {
    if ($d519476296871852$var$utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = $d519476296871852$var$utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = $d519476296871852$var$getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = $d519476296871852$var$getParent$1(parent)){
        var positionStyle = $d519476296871852$var$utils.css(parent, 'position');
        if (positionStyle === 'fixed') return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function $d519476296871852$var$getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = $d519476296871852$var$getOffsetParent(element);
    var doc = $d519476296871852$var$utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && $d519476296871852$var$utils.css(el, 'overflow') !== 'visible') {
            var pos = $d519476296871852$var$utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = $d519476296871852$var$getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!$d519476296871852$var$utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = $d519476296871852$var$utils.css(element, 'position');
        if (position === 'absolute') element.style.position = 'fixed';
    }
    var scrollX = $d519476296871852$var$utils.getWindowScrollLeft(win);
    var scrollY = $d519476296871852$var$utils.getWindowScrollTop(win);
    var viewportWidth = $d519476296871852$var$utils.viewportWidth(win);
    var viewportHeight = $d519476296871852$var$utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === 'hidden') documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === 'hidden') documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || $d519476296871852$var$isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function $d519476296871852$var$adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = $d519476296871852$var$utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return $d519476296871852$var$utils.mix(pos, size);
}
function $d519476296871852$var$getRegion(node) {
    var offset;
    var w;
    var h;
    if (!$d519476296871852$var$utils.isWindow(node) && node.nodeType !== 9) {
        offset = $d519476296871852$var$utils.offset(node);
        w = $d519476296871852$var$utils.outerWidth(node);
        h = $d519476296871852$var$utils.outerHeight(node);
    } else {
        var win = $d519476296871852$var$utils.getWindow(node);
        offset = {
            left: $d519476296871852$var$utils.getWindowScrollLeft(win),
            top: $d519476296871852$var$utils.getWindowScrollTop(win)
        };
        w = $d519476296871852$var$utils.viewportWidth(win);
        h = $d519476296871852$var$utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function $d519476296871852$var$getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === 'c') y += h / 2;
    else if (V === 'b') y += h;
    if (H === 'c') x += w / 2;
    else if (H === 'r') x += w;
    return {
        left: x,
        top: y
    };
}
function $d519476296871852$var$getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = $d519476296871852$var$getAlignOffset(refNodeRegion, points[1]);
    var p2 = $d519476296871852$var$getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function $d519476296871852$var$isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function $d519476296871852$var$isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function $d519476296871852$var$isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function $d519476296871852$var$isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function $d519476296871852$var$flip(points, reg, map) {
    var ret = [];
    $d519476296871852$var$utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function $d519476296871852$var$flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function $d519476296871852$var$convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function $d519476296871852$var$normalizeOffset(offset, el) {
    offset[0] = $d519476296871852$var$convertOffset(offset[0], el.width);
    offset[1] = $d519476296871852$var$convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function $d519476296871852$var$doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = $d519476296871852$var$getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = $d519476296871852$var$getRegion(source);
    // 将 offset 转换成数值，支持百分比
    $d519476296871852$var$normalizeOffset(offset, elRegion);
    $d519476296871852$var$normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = $d519476296871852$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = $d519476296871852$var$utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if ($d519476296871852$var$isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = $d519476296871852$var$flip(points, /[lr]/gi, {
                    l: 'r',
                    r: 'l'
                });
                // 偏移量也反下
                var newOffset = $d519476296871852$var$flipOffset(offset, 0);
                var newTargetOffset = $d519476296871852$var$flipOffset(targetOffset, 0);
                var newElFuturePos = $d519476296871852$var$getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!$d519476296871852$var$isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if ($d519476296871852$var$isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = $d519476296871852$var$flip(points, /[tb]/gi, {
                    t: 'b',
                    b: 't'
                });
                // 偏移量也反下
                var _newOffset = $d519476296871852$var$flipOffset(offset, 1);
                var _newTargetOffset = $d519476296871852$var$flipOffset(targetOffset, 1);
                var _newElFuturePos = $d519476296871852$var$getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!$d519476296871852$var$isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = $d519476296871852$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            $d519476296871852$var$utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = $d519476296871852$var$isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = $d519476296871852$var$isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = $d519476296871852$var$flip(points, /[lr]/gi, {
                l: 'r',
                r: 'l'
            });
            if (isStillFailY) _newPoints2 = $d519476296871852$var$flip(points, /[tb]/gi, {
                t: 'b',
                b: 't'
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = $d519476296871852$var$adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) $d519476296871852$var$utils.css(source, 'width', $d519476296871852$var$utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) $d519476296871852$var$utils.css(source, 'height', $d519476296871852$var$utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    $d519476296871852$var$utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function $d519476296871852$var$isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = $d519476296871852$var$getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = $d519476296871852$var$getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function $d519476296871852$export$ec21431d5ee6c534(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = $d519476296871852$var$getRegion(target);
    var isTargetNotOutOfVisible = !$d519476296871852$var$isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return $d519476296871852$var$doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
$d519476296871852$export$ec21431d5ee6c534.__getOffsetParent = $d519476296871852$var$getOffsetParent;
$d519476296871852$export$ec21431d5ee6c534.__getVisibleRectForElement = $d519476296871852$var$getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function $d519476296871852$export$38f0e12f0aa28098(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = $d519476296871852$var$utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = $d519476296871852$var$utils.getWindowScrollLeft(win);
    var scrollY = $d519476296871852$var$utils.getWindowScrollTop(win);
    var viewportWidth = $d519476296871852$var$utils.viewportWidth(win);
    var viewportHeight = $d519476296871852$var$utils.viewportHeight(win);
    if ('pageX' in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ('pageY' in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        'cc'
    ];
    return $d519476296871852$var$doAlign(el, tgtRegion, $d519476296871852$var$_objectSpread2($d519476296871852$var$_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
var $d519476296871852$export$2e2bcd8739ae039 = $d519476296871852$export$ec21431d5ee6c534;




/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $e5e5184330c59443$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $c196facde74adb39$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(a) === 'object' && (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $e5e5184330c59443$export$2e2bcd8739ae039 = $e5e5184330c59443$var$isEqual;



var $00310ab02d24bab6$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};





var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");
var $b83890186fb16bb5$export$2e2bcd8739ae039 = function(callback, buffer) {
    var calledRef = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useRef(false);
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        cancelTrigger();
        if (!calledRef.current || force === true) {
            if (callback(force) === false) // Not delay since callback cancelled self
            return;
            calledRef.current = true;
            timeoutRef.current = window.setTimeout(function() {
                calledRef.current = false;
            }, buffer);
        } else timeoutRef.current = window.setTimeout(function() {
            calledRef.current = false;
            trigger();
        }, buffer);
    }
    return [
        trigger,
        function() {
            calledRef.current = false;
            cancelTrigger();
        }
    ];
};



/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $8da7b27379e7687c$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $8da7b27379e7687c$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $8da7b27379e7687c$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $8da7b27379e7687c$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($8da7b27379e7687c$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $8da7b27379e7687c$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $8da7b27379e7687c$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $8da7b27379e7687c$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $8da7b27379e7687c$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $8da7b27379e7687c$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $8da7b27379e7687c$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $8da7b27379e7687c$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $8da7b27379e7687c$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $8da7b27379e7687c$var$throttle(this.refresh.bind(this), $8da7b27379e7687c$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$8da7b27379e7687c$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($8da7b27379e7687c$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$8da7b27379e7687c$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $8da7b27379e7687c$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $8da7b27379e7687c$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $8da7b27379e7687c$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $8da7b27379e7687c$var$global$1;
};
// Placeholder of an empty content rectangle.
var $8da7b27379e7687c$var$emptyRect = $8da7b27379e7687c$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $8da7b27379e7687c$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $8da7b27379e7687c$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $8da7b27379e7687c$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $8da7b27379e7687c$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $8da7b27379e7687c$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $8da7b27379e7687c$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $8da7b27379e7687c$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $8da7b27379e7687c$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $8da7b27379e7687c$var$emptyRect;
    var styles = $8da7b27379e7687c$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $8da7b27379e7687c$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $8da7b27379e7687c$var$toFloat(styles.width), height = $8da7b27379e7687c$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $8da7b27379e7687c$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $8da7b27379e7687c$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$8da7b27379e7687c$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $8da7b27379e7687c$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $8da7b27379e7687c$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $8da7b27379e7687c$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $8da7b27379e7687c$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $8da7b27379e7687c$var$isDocumentElement(target) {
    return target === $8da7b27379e7687c$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $8da7b27379e7687c$var$getContentRect(target) {
    if (!$8da7b27379e7687c$var$isBrowser) return $8da7b27379e7687c$var$emptyRect;
    if ($8da7b27379e7687c$var$isSVGGraphicsElement(target)) return $8da7b27379e7687c$var$getSVGContentRect(target);
    return $8da7b27379e7687c$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $8da7b27379e7687c$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $8da7b27379e7687c$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $8da7b27379e7687c$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $8da7b27379e7687c$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $8da7b27379e7687c$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $8da7b27379e7687c$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $8da7b27379e7687c$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $8da7b27379e7687c$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $8da7b27379e7687c$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $8da7b27379e7687c$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $8da7b27379e7687c$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $8da7b27379e7687c$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $8da7b27379e7687c$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $8da7b27379e7687c$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $8da7b27379e7687c$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $8da7b27379e7687c$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $8da7b27379e7687c$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $8da7b27379e7687c$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $8da7b27379e7687c$var$ResizeObserverController.getInstance();
        var observer = new $8da7b27379e7687c$var$ResizeObserverSPI(callback, controller, this);
        $8da7b27379e7687c$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $8da7b27379e7687c$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $8da7b27379e7687c$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $8da7b27379e7687c$var$index = function() {
    // Export existing implementation if available.
    if (typeof $8da7b27379e7687c$var$global$1.ResizeObserver !== 'undefined') return $8da7b27379e7687c$var$global$1.ResizeObserver;
    return $8da7b27379e7687c$var$ResizeObserver;
}();
var $8da7b27379e7687c$export$2e2bcd8739ae039 = $8da7b27379e7687c$var$index;



function $86cbc0da93c4c577$export$792a4d7b8e9efb33(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ('pageX' in next && 'pageY' in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ('clientX' in next && 'clientY' in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function $86cbc0da93c4c577$export$2284e449d64b22d5(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, $a5f4fb2511f41816$export$2e2bcd8739ae039)(container, activeElement) && typeof activeElement.focus === 'function') activeElement.focus();
}
function $86cbc0da93c4c577$export$f56787db9e74dfe(element, callback) {
    var prevWidth = null;
    var prevHeight = null;
    function onResize(_ref) {
        var _ref2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_ref, 1), target = _ref2[0].target;
        if (!document.documentElement.contains(target)) return;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) // https://webkit.org/blog/9997/resizeobserver-in-webkit/
        Promise.resolve().then(function() {
            callback({
                width: fixedWidth,
                height: fixedHeight
            });
        });
        prevWidth = fixedWidth;
        prevHeight = fixedHeight;
    }
    var resizeObserver = new (0, $8da7b27379e7687c$export$2e2bcd8739ae039)(onResize);
    if (element) resizeObserver.observe(element);
    return function() {
        resizeObserver.disconnect();
    };
}


function $38129e366659dd04$var$getElement(func) {
    if (typeof func !== 'function') return null;
    return func();
}
function $38129e366659dd04$var$getPoint(point) {
    if ((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(point) !== 'object' || !point) return null;
    return point;
}
var $38129e366659dd04$var$Align = function Align(_ref, ref) {
    var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
    var cacheRef = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useRef({});
    /** Popup node ref */ var nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useRef();
    var childNode = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Children.only(children); // ===================== Align ======================
    // We save the props here to avoid closure makes props ood
    var forceAlignPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useRef({});
    forceAlignPropsRef.current.disabled = disabled;
    forceAlignPropsRef.current.target = target;
    forceAlignPropsRef.current.align = align;
    forceAlignPropsRef.current.onAlign = onAlign;
    var _useBuffer = (0, $b83890186fb16bb5$export$2e2bcd8739ae039)(function() {
        var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
        var source = nodeRef.current;
        if (!latestDisabled && latestTarget && source) {
            var _result;
            var _element = $38129e366659dd04$var$getElement(latestTarget);
            var _point = $38129e366659dd04$var$getPoint(latestTarget);
            cacheRef.current.element = _element;
            cacheRef.current.point = _point;
            cacheRef.current.align = latestAlign; // IE lose focus after element realign
            // We should record activeElement and restore later
            var _document = document, activeElement = _document.activeElement; // We only align when element is visible
            if (_element && (0, $00310ab02d24bab6$export$2e2bcd8739ae039)(_element)) _result = (0, $d519476296871852$export$ec21431d5ee6c534)(source, _element, latestAlign);
            else if (_point) _result = (0, $d519476296871852$export$38f0e12f0aa28098)(source, _point, latestAlign);
            (0, $86cbc0da93c4c577$export$2284e449d64b22d5)(activeElement, source);
            if (latestOnAlign && _result) latestOnAlign(source, _result);
            return true;
        }
        return false;
    }, monitorBufferTime), _useBuffer2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
    // Handle props change
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useState(), _React$useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useState(), _React$useState4 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
    (0, $5c3e3cad1a762d0b$export$2e2bcd8739ae039)(function() {
        setElement($38129e366659dd04$var$getElement(target));
        setPoint($38129e366659dd04$var$getPoint(target));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        if (cacheRef.current.element !== element || !(0, $86cbc0da93c4c577$export$792a4d7b8e9efb33)(cacheRef.current.point, point) || !(0, $e5e5184330c59443$export$2e2bcd8739ae039)(cacheRef.current.align, align)) _forceAlign();
    }); // Watch popup element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        var cancelFn = (0, $86cbc0da93c4c577$export$f56787db9e74dfe)(nodeRef.current, _forceAlign);
        return cancelFn;
    }, [
        nodeRef.current
    ]); // Watch target element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        var cancelFn = (0, $86cbc0da93c4c577$export$f56787db9e74dfe)(element, _forceAlign);
        return cancelFn;
    }, [
        element
    ]); // Listen for disabled change
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        if (!disabled) _forceAlign();
        else cancelForceAlign();
    }, [
        disabled
    ]); // Listen for window resize
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        if (monitorWindowResize) {
            var cancelFn = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(window, 'resize', _forceAlign);
            return cancelFn.remove;
        }
    }, [
        monitorWindowResize
    ]); // Clear all if unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useEffect(function() {
        return function() {
            cancelForceAlign();
        };
    }, []); // ====================== Ref =======================
    (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {
                return _forceAlign(true);
            }
        };
    }); // ===================== Render =====================
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).isValidElement(childNode)) childNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).cloneElement(childNode, {
        ref: (0, $ece7587e1886b1b9$export$ab452c34e8e05029)(childNode.ref, nodeRef)
    });
    return childNode;
};
var $38129e366659dd04$var$RcAlign = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).forwardRef($38129e366659dd04$var$Align);
$38129e366659dd04$var$RcAlign.displayName = 'Align';
var $38129e366659dd04$export$2e2bcd8739ae039 = $38129e366659dd04$var$RcAlign;


var $69d70584be8875fb$export$2e2bcd8739ae039 = (0, $38129e366659dd04$export$2e2bcd8739ae039);






function $c442b5afd6e896a4$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $c442b5afd6e896a4$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}


function $046437010de474b2$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $046437010de474b2$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $046437010de474b2$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $046437010de474b2$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}




var $9nZCP = parcelRequire("9nZCP");


/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */ var $fb886a7d8d3a33c3$var$StatusQueue = [
    'measure',
    'alignPre',
    'align',
    null,
    'motion'
];
var $fb886a7d8d3a33c3$export$2e2bcd8739ae039 = function(visible, doMeasure) {
    var _useState = (0, $4e01688ba8da34ba$export$2e2bcd8739ae039)(null), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
    var rafRef = (0, $9nZCP.useRef)();
    function setStatus(nextStatus) {
        setInternalStatus(nextStatus, true);
    }
    function cancelRaf() {
        (0, $74c50fa010549a87$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, $74c50fa010549a87$export$2e2bcd8739ae039)(function() {
            // Only align should be manually trigger
            setStatus(function(prev) {
                switch(status){
                    case 'align':
                        return 'motion';
                    case 'motion':
                        return 'stable';
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 || callback();
        });
    } // Init status
    (0, $9nZCP.useEffect)(function() {
        setStatus('measure');
    }, [
        visible
    ]); // Go next status
    (0, $9nZCP.useEffect)(function() {
        switch(status){
            case 'measure':
                doMeasure();
                break;
            default:
        }
        if (status) rafRef.current = (0, $74c50fa010549a87$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $046437010de474b2$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $c442b5afd6e896a4$export$2e2bcd8739ae039)().mark(function _callee() {
            var index, nextStatus;
            return (0, $c442b5afd6e896a4$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        index = $fb886a7d8d3a33c3$var$StatusQueue.indexOf(status);
                        nextStatus = $fb886a7d8d3a33c3$var$StatusQueue[index + 1];
                        if (nextStatus && index !== -1) setStatus(nextStatus);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    }, [
        status
    ]);
    (0, $9nZCP.useEffect)(function() {
        return function() {
            cancelRaf();
        };
    }, []);
    return [
        status,
        goNextStatus
    ];
};





var $9nZCP = parcelRequire("9nZCP");
var $c95db9a7865696c9$export$2e2bcd8739ae039 = function(stretch) {
    var _React$useState = $9nZCP.useState({
        width: 0,
        height: 0
    }), _React$useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
    function measureStretch(element) {
        var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
        var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
        if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
            tgtWidth = width;
            tgtHeight = height;
        }
        setTargetSize({
            width: tgtWidth,
            height: tgtHeight
        });
    } // Merge stretch style
    var style = $9nZCP.useMemo(function() {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height; // Stretch with target
            if (stretch.indexOf('height') !== -1 && height) sizeStyle.height = height;
            else if (stretch.indexOf('minHeight') !== -1 && height) sizeStyle.minHeight = height;
            if (stretch.indexOf('width') !== -1 && width) sizeStyle.width = width;
            else if (stretch.indexOf('minWidth') !== -1 && width) sizeStyle.minWidth = width;
        }
        return sizeStyle;
    }, [
        stretch,
        targetSize
    ]);
    return [
        style,
        measureStretch
    ];
};


var $3356b80a5431cc45$var$PopupInner = /*#__PURE__*/ $9nZCP.forwardRef(function(props, ref) {
    var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
    var alignRef = (0, $9nZCP.useRef)();
    var elementRef = (0, $9nZCP.useRef)();
    var _useState = (0, $9nZCP.useState)(), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1]; // ======================= Measure ========================
    var _useStretchStyle = (0, $c95db9a7865696c9$export$2e2bcd8739ae039)(stretch), _useStretchStyle2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    function doMeasure() {
        if (stretch) measureStretchStyle(getRootDomNode());
    } // ======================== Status ========================
    var _useVisibleStatus = (0, $fb886a7d8d3a33c3$export$2e2bcd8739ae039)(visible, doMeasure), _useVisibleStatus2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
    /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */ var _useState3 = (0, $9nZCP.useState)(0), _useState4 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
    var prepareResolveRef = (0, $9nZCP.useRef)();
    (0, $5c3e3cad1a762d0b$export$2e2bcd8739ae039)(function() {
        if (status === 'alignPre') setAlignTimes(0);
    }, [
        status
    ]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    function getAlignTarget() {
        if (point) return point;
        return getRootDomNode;
    }
    function forceAlign() {
        var _alignRef$current;
        (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 || _alignRef$current.forceAlign();
    }
    function onInternalAlign(popupDomNode, matchAlign) {
        var nextAlignedClassName = getClassNameFromAlign(matchAlign);
        if (alignedClassName !== nextAlignedClassName) setAlignedClassName(nextAlignedClassName);
         // We will retry multi times to make sure that the element has been align in the right position.
        setAlignTimes(function(val) {
            return val + 1;
        });
        if (status === 'align') onAlign === null || onAlign === void 0 || onAlign(popupDomNode, matchAlign);
    } // Delay to go to next status
    (0, $5c3e3cad1a762d0b$export$2e2bcd8739ae039)(function() {
        if (status === 'align') {
            // Repeat until not more align needed
            if (alignTimes < 3) forceAlign();
            else goNextStatus(function() {
                var _prepareResolveRef$cu;
                (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 || _prepareResolveRef$cu.call(prepareResolveRef);
            });
        }
    }, [
        alignTimes
    ]); // ======================== Motion ========================
    var motion = (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, (0, $daa737f1914dfdb8$export$7b8936ddc277a29a)(props));
    [
        'onAppearEnd',
        'onEnterEnd',
        'onLeaveEnd'
    ].forEach(function(eventName) {
        var originHandler = motion[eventName];
        motion[eventName] = function(element, event) {
            goNextStatus();
            return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
        };
    });
    function onShowPrepare() {
        return new Promise(function(resolve) {
            prepareResolveRef.current = resolve;
        });
    } // Go to stable directly when motion not provided
    $9nZCP.useEffect(function() {
        if (!motion.motionName && status === 'motion') goNextStatus();
    }, [
        motion.motionName,
        status
    ]); // ========================= Refs =========================
    $9nZCP.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, stretchStyle), {}, {
        zIndex: zIndex,
        opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
        // Cannot interact with disappearing elements
        // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
        pointerEvents: !visible && status !== 'stable' ? 'none' : undefined
    }, style); // Align status
    var alignDisabled = true;
    if (align !== null && align !== void 0 && align.points && (status === 'align' || status === 'stable')) alignDisabled = false;
    var childNode = children; // Wrapper when multiple children
    if ($9nZCP.Children.count(children) > 1) childNode = /*#__PURE__*/ $9nZCP.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
    return /*#__PURE__*/ $9nZCP.createElement((0, $ba55528cb86ff86c$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
        visible: visible,
        ref: elementRef,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onShowPrepare,
        onEnterPrepare: onShowPrepare,
        removeOnLeave: destroyPopupOnHide,
        forceRender: forceRender
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))(prefixCls, className, alignedClassName, motionClassName);
        return /*#__PURE__*/ $9nZCP.createElement((0, $69d70584be8875fb$export$2e2bcd8739ae039), {
            target: getAlignTarget(),
            key: "popup",
            ref: alignRef,
            monitorWindowResize: true,
            disabled: alignDisabled,
            align: align,
            onAlign: onInternalAlign
        }, /*#__PURE__*/ $9nZCP.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDownCapture: onMouseDown,
            onTouchStartCapture: onTouchStart,
            onClick: onClick,
            style: (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode));
    });
});
$3356b80a5431cc45$var$PopupInner.displayName = 'PopupInner';
var $3356b80a5431cc45$export$2e2bcd8739ae039 = $3356b80a5431cc45$var$PopupInner;





var $9nZCP = parcelRequire("9nZCP");


var $d4b3b7ecbc9a956c$var$MobilePopupInner = /*#__PURE__*/ $9nZCP.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
    _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
    var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
    var elementRef = $9nZCP.useRef(); // ========================= Refs =========================
    $9nZCP.useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {},
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $835511f338e067d8$export$2e2bcd8739ae039)({
        zIndex: zIndex
    }, popupStyle);
    var childNode = children; // Wrapper when multiple children
    if ($9nZCP.Children.count(children) > 1) childNode = /*#__PURE__*/ $9nZCP.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
     // Mobile support additional render
    if (popupRender) childNode = popupRender(childNode);
    return /*#__PURE__*/ $9nZCP.createElement((0, $ba55528cb86ff86c$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
        visible: visible,
        ref: elementRef,
        removeOnLeave: true
    }, popupMotion), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))(prefixCls, popupClassName, motionClassName);
        return /*#__PURE__*/ $9nZCP.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onClick: onClick,
            style: (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode);
    });
});
$d4b3b7ecbc9a956c$var$MobilePopupInner.displayName = 'MobilePopupInner';
var $d4b3b7ecbc9a956c$export$2e2bcd8739ae039 = $d4b3b7ecbc9a956c$var$MobilePopupInner;


var $5f6996233639d41e$var$_excluded = [
    "visible",
    "mobile"
];
var $5f6996233639d41e$var$Popup = /*#__PURE__*/ $9nZCP.forwardRef(function(_ref, ref) {
    var visible = _ref.visible, mobile = _ref.mobile, props = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_ref, $5f6996233639d41e$var$_excluded);
    var _useState = (0, $9nZCP.useState)(visible), _useState2 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
    var _useState3 = (0, $9nZCP.useState)(false), _useState4 = (0, $5364cf1643bb9b6d$export$2e2bcd8739ae039)(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
    var cloneProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, props), {}, {
        visible: innerVisible
    }); // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, $9nZCP.useEffect)(function() {
        serInnerVisible(visible);
        if (visible && mobile) setInMobile((0, $0be4b22dededee67$export$2e2bcd8739ae039)());
    }, [
        visible,
        mobile
    ]);
    var popupNode = inMobile ? /*#__PURE__*/ $9nZCP.createElement((0, $d4b3b7ecbc9a956c$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, cloneProps, {
        mobile: mobile,
        ref: ref
    })) : /*#__PURE__*/ $9nZCP.createElement((0, $3356b80a5431cc45$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, cloneProps, {
        ref: ref
    })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return /*#__PURE__*/ $9nZCP.createElement("div", null, /*#__PURE__*/ $9nZCP.createElement((0, $2c5306aae19cdf6e$export$2e2bcd8739ae039), cloneProps), popupNode);
});
$5f6996233639d41e$var$Popup.displayName = 'Popup';
var $5f6996233639d41e$export$2e2bcd8739ae039 = $5f6996233639d41e$var$Popup;



var $9nZCP = parcelRequire("9nZCP");
var $e401097ef1d73ab3$var$TriggerContext = /*#__PURE__*/ $9nZCP.createContext(null);
var $e401097ef1d73ab3$export$2e2bcd8739ae039 = $e401097ef1d73ab3$var$TriggerContext;


function $ab2fc57d2029f006$var$noop() {}
function $ab2fc57d2029f006$var$returnEmptyString() {
    return '';
}
function $ab2fc57d2029f006$var$returnDocument(element) {
    if (element) return element.ownerDocument;
    return window.document;
}
var $ab2fc57d2029f006$var$ALL_HANDLERS = [
    'onClick',
    'onMouseDown',
    'onTouchStart',
    'onMouseEnter',
    'onMouseLeave',
    'onFocus',
    'onBlur',
    'onContextMenu'
];
function $ab2fc57d2029f006$export$55e99723d7f71b47(PortalComponent) {
    var Trigger = /*#__PURE__*/ function(_React$Component) {
        (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(Trigger, _React$Component);
        var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(Trigger);
        // ensure `getContainer` will be called only once
        function Trigger(props) {
            var _this;
            (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, Trigger);
            _this = _super.call(this, props);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "popupRef", /*#__PURE__*/ $9nZCP.createRef());
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "triggerRef", /*#__PURE__*/ $9nZCP.createRef());
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "portalContainer", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "attachId", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "clickOutsideHandler", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "touchOutsideHandler", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "contextMenuOutsideHandler1", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "contextMenuOutsideHandler2", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "mouseDownTimeout", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "focusTime", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "preClickTime", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "preTouchTime", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "delayTimer", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "hasPopupMouseDown", void 0);
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onMouseEnter", function(e) {
                var mouseEnterDelay = _this.props.mouseEnterDelay;
                _this.fireEvents('onMouseEnter', e);
                _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onMouseMove", function(e) {
                _this.fireEvents('onMouseMove', e);
                _this.setPoint(e);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onMouseLeave", function(e) {
                _this.fireEvents('onMouseLeave', e);
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onPopupMouseEnter", function() {
                _this.clearDelayTimer();
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onPopupMouseLeave", function(e) {
                var _this$popupRef$curren;
                // https://github.com/react-component/trigger/pull/13
                // react bug?
                if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, $a5f4fb2511f41816$export$2e2bcd8739ae039)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) return;
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onFocus", function(e) {
                _this.fireEvents('onFocus', e); // incase focusin and focusout
                _this.clearDelayTimer();
                if (_this.isFocusToShow()) {
                    _this.focusTime = Date.now();
                    _this.delaySetPopupVisible(true, _this.props.focusDelay);
                }
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onMouseDown", function(e) {
                _this.fireEvents('onMouseDown', e);
                _this.preClickTime = Date.now();
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onTouchStart", function(e) {
                _this.fireEvents('onTouchStart', e);
                _this.preTouchTime = Date.now();
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onBlur", function(e) {
                _this.fireEvents('onBlur', e);
                _this.clearDelayTimer();
                if (_this.isBlurToHide()) _this.delaySetPopupVisible(false, _this.props.blurDelay);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onContextMenu", function(e) {
                e.preventDefault();
                _this.fireEvents('onContextMenu', e);
                _this.setPopupVisible(true, e);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onContextMenuClose", function() {
                if (_this.isContextMenuToShow()) _this.close();
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onClick", function(event) {
                _this.fireEvents('onClick', event); // focus will trigger click
                if (_this.focusTime) {
                    var preTime;
                    if (_this.preClickTime && _this.preTouchTime) preTime = Math.min(_this.preClickTime, _this.preTouchTime);
                    else if (_this.preClickTime) preTime = _this.preClickTime;
                    else if (_this.preTouchTime) preTime = _this.preTouchTime;
                    if (Math.abs(preTime - _this.focusTime) < 20) return;
                    _this.focusTime = 0;
                }
                _this.preClickTime = 0;
                _this.preTouchTime = 0; // Only prevent default when all the action is click.
                // https://github.com/ant-design/ant-design/issues/17043
                // https://github.com/ant-design/ant-design/issues/17291
                if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
                var nextVisible = !_this.state.popupVisible;
                if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) _this.setPopupVisible(!_this.state.popupVisible, event);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onPopupMouseDown", function() {
                _this.hasPopupMouseDown = true;
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = window.setTimeout(function() {
                    _this.hasPopupMouseDown = false;
                }, 0);
                if (_this.context) {
                    var _this$context;
                    (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
                }
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "onDocumentClick", function(event) {
                if (_this.props.mask && !_this.props.maskClosable) return;
                var target = event.target;
                var root = _this.getRootDomNode();
                var popupNode = _this.getPopupDomNode();
                if (// https://github.com/ant-design/ant-design/issues/29853
                (!(0, $a5f4fb2511f41816$export$2e2bcd8739ae039)(root, target) || _this.isContextMenuOnly()) && !(0, $a5f4fb2511f41816$export$2e2bcd8739ae039)(popupNode, target) && !_this.hasPopupMouseDown) _this.close();
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "getRootDomNode", function() {
                var getTriggerDOMNode = _this.props.getTriggerDOMNode;
                if (getTriggerDOMNode) return getTriggerDOMNode(_this.triggerRef.current);
                try {
                    var domNode = (0, $93bb6ec4cced17a6$export$2e2bcd8739ae039)(_this.triggerRef.current);
                    if (domNode) return domNode;
                } catch (err) {}
                return (0, (/*@__PURE__*/$parcel$interopDefault($06928105ffc753ea$exports))).findDOMNode((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this));
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "getPopupClassNameFromAlign", function(align) {
                var className = [];
                var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
                if (popupPlacement && builtinPlacements) className.push((0, $d5666b43b133354b$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, align, alignPoint));
                if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
                return className.join(' ');
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "getComponent", function() {
                var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
                var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
                var align = _this.getPopupAlign();
                var mouseProps = {};
                if (_this.isMouseEnterToShow()) mouseProps.onMouseEnter = _this.onPopupMouseEnter;
                if (_this.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this.onPopupMouseLeave;
                mouseProps.onMouseDown = _this.onPopupMouseDown;
                mouseProps.onTouchStart = _this.onPopupMouseDown;
                return /*#__PURE__*/ $9nZCP.createElement((0, $5f6996233639d41e$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
                    prefixCls: prefixCls,
                    destroyPopupOnHide: destroyPopupOnHide,
                    visible: popupVisible,
                    point: alignPoint && point,
                    className: popupClassName,
                    align: align,
                    onAlign: onPopupAlign,
                    animation: popupAnimation,
                    getClassNameFromAlign: _this.getPopupClassNameFromAlign
                }, mouseProps, {
                    stretch: stretch,
                    getRootDomNode: _this.getRootDomNode,
                    style: popupStyle,
                    mask: mask,
                    zIndex: zIndex,
                    transitionName: popupTransitionName,
                    maskAnimation: maskAnimation,
                    maskTransitionName: maskTransitionName,
                    maskMotion: maskMotion,
                    ref: _this.popupRef,
                    motion: popupMotion,
                    mobile: mobile,
                    forceRender: forceRender,
                    onClick: onPopupClick
                }), typeof popup === 'function' ? popup() : popup);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "attachParent", function(popupContainer) {
                (0, $74c50fa010549a87$export$2e2bcd8739ae039).cancel(_this.attachId);
                var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument = _this$props3.getDocument;
                var domNode = _this.getRootDomNode();
                var mountNode;
                if (!getPopupContainer) mountNode = getDocument(_this.getRootDomNode()).body;
                else if (domNode || getPopupContainer.length === 0) // Compatible for legacy getPopupContainer with domNode argument.
                // If no need `domNode` argument, will call directly.
                // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
                mountNode = getPopupContainer(domNode);
                if (mountNode) mountNode.appendChild(popupContainer);
                else // Retry after frame render in case parent not ready
                _this.attachId = (0, $74c50fa010549a87$export$2e2bcd8739ae039)(function() {
                    _this.attachParent(popupContainer);
                });
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "getContainer", function() {
                if (!_this.portalContainer) {
                    // In React.StrictMode component will call render multiple time in first mount.
                    // When you want to refactor with FC, useRef will also init multiple time and
                    // point to different useRef instance which will create multiple element
                    // (This multiple render will not trigger effect so you can not clean up this
                    // in effect). But this is safe with class component since it always point to same class instance.
                    var getDocument = _this.props.getDocument;
                    var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
                    // https://github.com/react-component/trigger/issues/41
                    popupContainer.style.position = 'absolute';
                    popupContainer.style.top = '0';
                    popupContainer.style.left = '0';
                    popupContainer.style.width = '100%';
                    _this.portalContainer = popupContainer;
                }
                _this.attachParent(_this.portalContainer);
                return _this.portalContainer;
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "setPoint", function(point) {
                var alignPoint = _this.props.alignPoint;
                if (!alignPoint || !point) return;
                _this.setState({
                    point: {
                        pageX: point.pageX,
                        pageY: point.pageY
                    }
                });
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "handlePortalUpdate", function() {
                if (_this.state.prevPopupVisible !== _this.state.popupVisible) _this.props.afterPopupVisibleChange(_this.state.popupVisible);
            });
            (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)((0, $940bcf9a64d33faf$export$2e2bcd8739ae039)(_this), "triggerContextValue", {
                onPopupMouseDown: _this.onPopupMouseDown
            });
            var _popupVisible;
            if ('popupVisible' in props) _popupVisible = !!props.popupVisible;
            else _popupVisible = !!props.defaultPopupVisible;
            _this.state = {
                prevPopupVisible: _popupVisible,
                popupVisible: _popupVisible
            };
            $ab2fc57d2029f006$var$ALL_HANDLERS.forEach(function(h) {
                _this["fire".concat(h)] = function(e) {
                    _this.fireEvents(h, e);
                };
            });
            return _this;
        }
        (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(Trigger, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.componentDidUpdate();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var props = this.props;
                    var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
                    // https://github.com/ant-design/ant-design/issues/5804
                    // https://github.com/react-component/calendar/issues/250
                    // https://github.com/react-component/trigger/issues/50
                    if (state.popupVisible) {
                        var currentDocument;
                        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                            currentDocument = props.getDocument(this.getRootDomNode());
                            this.clickOutsideHandler = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(currentDocument, 'mousedown', this.onDocumentClick);
                        } // always hide on mobile
                        if (!this.touchOutsideHandler) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.touchOutsideHandler = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(currentDocument, 'touchstart', this.onDocumentClick);
                        } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
                        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.contextMenuOutsideHandler1 = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(currentDocument, 'scroll', this.onContextMenuClose);
                        } // close popup when trigger type contains 'onContextMenu' and window is blur.
                        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, $2c9c50b08e6db3ce$export$2e2bcd8739ae039)(window, 'blur', this.onContextMenuClose);
                        return;
                    }
                    this.clearOutsideHandler();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDelayTimer();
                    this.clearOutsideHandler();
                    clearTimeout(this.mouseDownTimeout);
                    (0, $74c50fa010549a87$export$2e2bcd8739ae039).cancel(this.attachId);
                }
            },
            {
                key: "getPopupDomNode",
                value: function getPopupDomNode() {
                    var _this$popupRef$curren2;
                    // for test
                    return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
                }
            },
            {
                key: "getPopupAlign",
                value: function getPopupAlign() {
                    var props = this.props;
                    var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
                    if (popupPlacement && builtinPlacements) return (0, $d5666b43b133354b$export$44605b74f7c5d944)(builtinPlacements, popupPlacement, popupAlign);
                    return popupAlign;
                }
            },
            {
                key: "setPopupVisible",
                value: /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */ function setPopupVisible(popupVisible, event) {
                    var alignPoint = this.props.alignPoint;
                    var prevPopupVisible = this.state.popupVisible;
                    this.clearDelayTimer();
                    if (prevPopupVisible !== popupVisible) {
                        if (!('popupVisible' in this.props)) this.setState({
                            popupVisible: popupVisible,
                            prevPopupVisible: prevPopupVisible
                        });
                        this.props.onPopupVisibleChange(popupVisible);
                    } // Always record the point position since mouseEnterDelay will delay the show
                    if (alignPoint && event && popupVisible) this.setPoint(event);
                }
            },
            {
                key: "delaySetPopupVisible",
                value: function delaySetPopupVisible(visible, delayS, event) {
                    var _this2 = this;
                    var delay = delayS * 1000;
                    this.clearDelayTimer();
                    if (delay) {
                        var point = event ? {
                            pageX: event.pageX,
                            pageY: event.pageY
                        } : null;
                        this.delayTimer = window.setTimeout(function() {
                            _this2.setPopupVisible(visible, point);
                            _this2.clearDelayTimer();
                        }, delay);
                    } else this.setPopupVisible(visible, event);
                }
            },
            {
                key: "clearDelayTimer",
                value: function clearDelayTimer() {
                    if (this.delayTimer) {
                        clearTimeout(this.delayTimer);
                        this.delayTimer = null;
                    }
                }
            },
            {
                key: "clearOutsideHandler",
                value: function clearOutsideHandler() {
                    if (this.clickOutsideHandler) {
                        this.clickOutsideHandler.remove();
                        this.clickOutsideHandler = null;
                    }
                    if (this.contextMenuOutsideHandler1) {
                        this.contextMenuOutsideHandler1.remove();
                        this.contextMenuOutsideHandler1 = null;
                    }
                    if (this.contextMenuOutsideHandler2) {
                        this.contextMenuOutsideHandler2.remove();
                        this.contextMenuOutsideHandler2 = null;
                    }
                    if (this.touchOutsideHandler) {
                        this.touchOutsideHandler.remove();
                        this.touchOutsideHandler = null;
                    }
                }
            },
            {
                key: "createTwoChains",
                value: function createTwoChains(event) {
                    var childPros = this.props.children.props;
                    var props = this.props;
                    if (childPros[event] && props[event]) return this["fire".concat(event)];
                    return childPros[event] || props[event];
                }
            },
            {
                key: "isClickToShow",
                value: function isClickToShow() {
                    var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
                    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isContextMenuOnly",
                value: function isContextMenuOnly() {
                    var action = this.props.action;
                    return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
                }
            },
            {
                key: "isContextMenuToShow",
                value: function isContextMenuToShow() {
                    var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
                    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
                }
            },
            {
                key: "isClickToHide",
                value: function isClickToHide() {
                    var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
                    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isMouseEnterToShow",
                value: function isMouseEnterToShow() {
                    var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
                    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
                }
            },
            {
                key: "isMouseLeaveToHide",
                value: function isMouseLeaveToHide() {
                    var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
                    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
                }
            },
            {
                key: "isFocusToShow",
                value: function isFocusToShow() {
                    var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
                    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
                }
            },
            {
                key: "isBlurToHide",
                value: function isBlurToHide() {
                    var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
                    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
                }
            },
            {
                key: "forcePopupAlign",
                value: function forcePopupAlign() {
                    if (this.state.popupVisible) {
                        var _this$popupRef$curren3;
                        (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 || _this$popupRef$curren3.forceAlign();
                    }
                }
            },
            {
                key: "fireEvents",
                value: function fireEvents(type, e) {
                    var childCallback = this.props.children.props[type];
                    if (childCallback) childCallback(e);
                    var callback = this.props[type];
                    if (callback) callback(e);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.setPopupVisible(false);
                }
            },
            {
                key: "render",
                value: function render() {
                    var popupVisible = this.state.popupVisible;
                    var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
                    var child = $9nZCP.Children.only(children);
                    var newChildProps = {
                        key: 'trigger'
                    }; // ============================== Visible Handlers ==============================
                    // >>> ContextMenu
                    if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
                    else newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
                     // >>> Click
                    if (this.isClickToHide() || this.isClickToShow()) {
                        newChildProps.onClick = this.onClick;
                        newChildProps.onMouseDown = this.onMouseDown;
                        newChildProps.onTouchStart = this.onTouchStart;
                    } else {
                        newChildProps.onClick = this.createTwoChains('onClick');
                        newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
                        newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
                    } // >>> Hover(enter)
                    if (this.isMouseEnterToShow()) {
                        newChildProps.onMouseEnter = this.onMouseEnter; // Point align
                        if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
                    } else newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
                     // >>> Hover(leave)
                    if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
                    else newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
                     // >>> Focus
                    if (this.isFocusToShow() || this.isBlurToHide()) {
                        newChildProps.onFocus = this.onFocus;
                        newChildProps.onBlur = this.onBlur;
                    } else {
                        newChildProps.onFocus = this.createTwoChains('onFocus');
                        newChildProps.onBlur = this.createTwoChains('onBlur');
                    } // =================================== Render ===================================
                    var childrenClassName = (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))(child && child.props && child.props.className, className);
                    if (childrenClassName) newChildProps.className = childrenClassName;
                    var cloneProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, newChildProps);
                    if ((0, $ece7587e1886b1b9$export$c1cec34af06bcf7)(child)) cloneProps.ref = (0, $ece7587e1886b1b9$export$ab452c34e8e05029)(this.triggerRef, child.ref);
                    var trigger = /*#__PURE__*/ $9nZCP.cloneElement(child, cloneProps);
                    var portal; // prevent unmounting after it's rendered
                    if (popupVisible || this.popupRef.current || forceRender) portal = /*#__PURE__*/ $9nZCP.createElement(PortalComponent, {
                        key: "portal",
                        getContainer: this.getContainer,
                        didUpdate: this.handlePortalUpdate
                    }, this.getComponent());
                    if (!popupVisible && autoDestroy) portal = null;
                    return /*#__PURE__*/ $9nZCP.createElement((0, $e401097ef1d73ab3$export$2e2bcd8739ae039).Provider, {
                        value: this.triggerContextValue
                    }, trigger, portal);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref, prevState) {
                    var popupVisible = _ref.popupVisible;
                    var newState = {};
                    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
                        newState.popupVisible = popupVisible;
                        newState.prevPopupVisible = prevState.popupVisible;
                    }
                    return newState;
                }
            }
        ]);
        return Trigger;
    }($9nZCP.Component);
    (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(Trigger, "contextType", (0, $e401097ef1d73ab3$export$2e2bcd8739ae039));
    (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)(Trigger, "defaultProps", {
        prefixCls: 'rc-trigger-popup',
        getPopupClassNameFromAlign: $ab2fc57d2029f006$var$returnEmptyString,
        getDocument: $ab2fc57d2029f006$var$returnDocument,
        onPopupVisibleChange: $ab2fc57d2029f006$var$noop,
        afterPopupVisibleChange: $ab2fc57d2029f006$var$noop,
        onPopupAlign: $ab2fc57d2029f006$var$noop,
        popupClassName: '',
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: [],
        autoDestroy: false
    });
    return Trigger;
}
var $ab2fc57d2029f006$export$2e2bcd8739ae039 = $ab2fc57d2029f006$export$55e99723d7f71b47((0, $f28890857a395782$export$2e2bcd8739ae039));


var $7619b09d98a7e935$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $7619b09d98a7e935$var$targetOffset = [
    0,
    0
];
var $7619b09d98a7e935$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $7619b09d98a7e935$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $7619b09d98a7e935$var$targetOffset
    }
};
var $7619b09d98a7e935$export$2e2bcd8739ae039 = $7619b09d98a7e935$export$803cd8101b6c182b;



var $9nZCP = parcelRequire("9nZCP");

function $2be2fd6b9ea03ced$export$2e2bcd8739ae039(props) {
    var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $9nZCP.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($81466bf476712888$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, showArrow !== false && /*#__PURE__*/ $9nZCP.createElement("div", {
        className: "".concat(prefixCls, "-arrow"),
        key: "arrow"
    }, arrowContent), /*#__PURE__*/ $9nZCP.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === 'function' ? children() : children));
}


var $599f1530db4cdd2a$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow"
];
var $599f1530db4cdd2a$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(props, $599f1530db4cdd2a$var$_excluded);
    var domRef = (0, $9nZCP.useRef)(null);
    (0, $9nZCP.useImperativeHandle)(ref, function() {
        return domRef.current;
    });
    var extraProps = (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, restProps);
    if ('visible' in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $9nZCP.createElement((0, $2be2fd6b9ea03ced$export$2e2bcd8739ae039), {
            showArrow: showArrow,
            arrowContent: arrowContent,
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    var destroyTooltip = false;
    var autoDestroy = false;
    if (typeof destroyTooltipOnHide === 'boolean') destroyTooltip = destroyTooltipOnHide;
    else if (destroyTooltipOnHide && (0, $b97407360a5cbf3c$export$2e2bcd8739ae039)(destroyTooltipOnHide) === 'object') {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip = keepParent === true;
        autoDestroy = keepParent === false;
    }
    return /*#__PURE__*/ $9nZCP.createElement((0, $ab2fc57d2029f006$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $7619b09d98a7e935$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: domRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip,
        autoDestroy: autoDestroy,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
    }, extraProps), children);
};
var $599f1530db4cdd2a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $9nZCP.forwardRef)($599f1530db4cdd2a$var$Tooltip);



var $d446dff0e4ef5baa$export$2e2bcd8739ae039 = (0, $599f1530db4cdd2a$export$2e2bcd8739ae039);




var $f7939232b8700452$var$SliderTooltip = /*#__PURE__*/ $9nZCP.forwardRef(function(props, ref) {
    var visible = props.visible, overlay = props.overlay;
    var innerRef = $9nZCP.useRef(null);
    var tooltipRef = (0, $ece7587e1886b1b9$export$ab452c34e8e05029)(ref, innerRef);
    var rafRef = $9nZCP.useRef(null);
    function cancelKeepAlign() {
        (0, $74c50fa010549a87$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function keepAlign() {
        rafRef.current = (0, $74c50fa010549a87$export$2e2bcd8739ae039)(function() {
            var _innerRef$current;
            (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 || _innerRef$current.forcePopupAlign();
        });
    }
    $9nZCP.useEffect(function() {
        if (visible) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        visible,
        overlay
    ]);
    return /*#__PURE__*/ $9nZCP.createElement((0, $d446dff0e4ef5baa$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({
        ref: tooltipRef
    }, props));
});
var $f7939232b8700452$export$2e2bcd8739ae039 = $f7939232b8700452$var$SliderTooltip;



function $63d3d36722fc19de$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_React$Component) {
        (0, $e9432b2dc1794836$export$2e2bcd8739ae039)(ComponentWrapper, _React$Component);
        var _super = (0, $d9bb25c2822f374b$export$2e2bcd8739ae039)(ComponentWrapper);
        function ComponentWrapper() {
            var _this;
            (0, $760550b9da8dc9e1$export$2e2bcd8739ae039)(this, ComponentWrapper);
            _this = _super.apply(this, arguments);
            _this.state = {
                visibles: {}
            };
            _this.handleTooltipVisibleChange = function(index, visible) {
                _this.setState(function(prevState) {
                    return {
                        visibles: (0, $835511f338e067d8$export$2e2bcd8739ae039)((0, $835511f338e067d8$export$2e2bcd8739ae039)({}, prevState.visibles), {}, (0, $0e91f7da3580de3e$export$2e2bcd8739ae039)({}, index, visible))
                    };
                });
            };
            _this.handleWithTooltip = function(_ref) {
                var value = _ref.value, dragging = _ref.dragging, index = _ref.index, disabled = _ref.disabled, restProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(_ref, [
                    "value",
                    "dragging",
                    "index",
                    "disabled"
                ]);
                var _this$props = _this.props, tipFormatter = _this$props.tipFormatter, tipProps = _this$props.tipProps, handleStyle = _this$props.handleStyle, getTooltipContainer = _this$props.getTooltipContainer;
                var _tipProps$prefixCls = tipProps.prefixCls, prefixCls = _tipProps$prefixCls === void 0 ? 'rc-slider-tooltip' : _tipProps$prefixCls, _tipProps$overlay = tipProps.overlay, overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay, _tipProps$placement = tipProps.placement, placement = _tipProps$placement === void 0 ? 'top' : _tipProps$placement, _tipProps$visible = tipProps.visible, visible = _tipProps$visible === void 0 ? false : _tipProps$visible, restTooltipProps = (0, $d757eeb1353aad21$export$2e2bcd8739ae039)(tipProps, [
                    "prefixCls",
                    "overlay",
                    "placement",
                    "visible"
                ]);
                var handleStyleWithIndex;
                if (Array.isArray(handleStyle)) handleStyleWithIndex = handleStyle[index] || handleStyle[0];
                else handleStyleWithIndex = handleStyle;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $f7939232b8700452$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, restTooltipProps, {
                    getTooltipContainer: getTooltipContainer,
                    prefixCls: prefixCls,
                    overlay: overlay,
                    placement: placement,
                    visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
                    key: index
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement((0, $49e439059d842d52$export$2e2bcd8739ae039), (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, restProps, {
                    style: (0, $835511f338e067d8$export$2e2bcd8739ae039)({}, handleStyleWithIndex),
                    value: value,
                    onMouseEnter: function onMouseEnter() {
                        return _this.handleTooltipVisibleChange(index, true);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this.handleTooltipVisibleChange(index, false);
                    }
                })));
            };
            return _this;
        }
        (0, $e2992e4fbdf715a4$export$2e2bcd8739ae039)(ComponentWrapper, [
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).createElement(Component, (0, $d3700a4be188dae5$export$2e2bcd8739ae039)({}, this.props, {
                        handle: this.handleWithTooltip
                    }));
                }
            }
        ]);
        return ComponentWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).Component), _a.defaultProps = {
        tipFormatter: function tipFormatter(value) {
            return value;
        },
        handleStyle: [
            {}
        ],
        tipProps: {},
        getTooltipContainer: function getTooltipContainer(node) {
            return node.parentNode;
        }
    }, _a;
}



var $8fc1eb2c15e0076e$var$InternalSlider = (0, $424139e045fedefc$export$2e2bcd8739ae039);
$8fc1eb2c15e0076e$var$InternalSlider.Range = (0, $1333fa204e4662b3$export$2e2bcd8739ae039);
$8fc1eb2c15e0076e$var$InternalSlider.Handle = (0, $49e439059d842d52$export$2e2bcd8739ae039);
$8fc1eb2c15e0076e$var$InternalSlider.createSliderWithTooltip = (0, $63d3d36722fc19de$export$2e2bcd8739ae039);
var $8fc1eb2c15e0076e$export$2e2bcd8739ae039 = $8fc1eb2c15e0076e$var$InternalSlider;




var $9nZCP = parcelRequire("9nZCP");
var $d6e59866f4ac3ecb$var$a = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $d6e59866f4ac3ecb$var$i(t) {
    return function(e) {
        var n = e || {}, r = n.width ? String(n.width) : t.defaultWidth;
        return t.formats[r] || t.formats[t.defaultWidth];
    };
}
var $d6e59866f4ac3ecb$var$o = {
    date: $d6e59866f4ac3ecb$var$i({
        formats: {
            full: 'EEEE, MMMM do, y',
            long: 'MMMM do, y',
            medium: 'MMM d, y',
            short: 'MM/dd/yyyy'
        },
        defaultWidth: 'full'
    }),
    time: $d6e59866f4ac3ecb$var$i({
        formats: {
            full: 'h:mm:ss a zzzz',
            long: 'h:mm:ss a z',
            medium: 'h:mm:ss a',
            short: 'h:mm a'
        },
        defaultWidth: 'full'
    }),
    dateTime: $d6e59866f4ac3ecb$var$i({
        formats: {
            full: "{{date}} 'at' {{time}}",
            long: "{{date}} 'at' {{time}}",
            medium: '{{date}}, {{time}}',
            short: '{{date}}, {{time}}'
        },
        defaultWidth: 'full'
    })
}, $d6e59866f4ac3ecb$var$u = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $d6e59866f4ac3ecb$var$s(t) {
    return function(e, n) {
        var r, a = n || {};
        if ('formatting' === (a.context ? String(a.context) : 'standalone') && t.formattingValues) {
            var i = t.defaultFormattingWidth || t.defaultWidth, o = a.width ? String(a.width) : i;
            r = t.formattingValues[o] || t.formattingValues[i];
        } else {
            var u = t.defaultWidth, s = a.width ? String(a.width) : t.defaultWidth;
            r = t.values[s] || t.values[u];
        }
        return r[t.argumentCallback ? t.argumentCallback(e) : e];
    };
}
function $d6e59866f4ac3ecb$var$c(t) {
    return function(e, n) {
        var r = String(e), a = n || {}, i = a.width, o = i && t.matchPatterns[i] || t.matchPatterns[t.defaultMatchWidth], u = r.match(o);
        if (!u) return null;
        var s, c = u[0], d = i && t.parsePatterns[i] || t.parsePatterns[t.defaultParseWidth];
        return s = '[object Array]' === Object.prototype.toString.call(d) ? function(t, e) {
            for(var n = 0; n < t.length; n++)if (e(t[n])) return n;
        }(d, function(t) {
            return t.test(c);
        }) : function(t, e) {
            for(var n in t)if (t.hasOwnProperty(n) && e(t[n])) return n;
        }(d, function(t) {
            return t.test(c);
        }), s = t.valueCallback ? t.valueCallback(s) : s, {
            value: s = a.valueCallback ? a.valueCallback(s) : s,
            rest: r.slice(c.length)
        };
    };
}
var $d6e59866f4ac3ecb$var$d, $d6e59866f4ac3ecb$var$l = {
    code: 'en-US',
    formatDistance: function(t, e, n) {
        var r;
        return n = n || {}, r = 'string' == typeof $d6e59866f4ac3ecb$var$a[t] ? $d6e59866f4ac3ecb$var$a[t] : 1 === e ? $d6e59866f4ac3ecb$var$a[t].one : $d6e59866f4ac3ecb$var$a[t].other.replace('{{count}}', e), n.addSuffix ? n.comparison > 0 ? 'in ' + r : r + ' ago' : r;
    },
    formatLong: $d6e59866f4ac3ecb$var$o,
    formatRelative: function(t, e, n, r) {
        return $d6e59866f4ac3ecb$var$u[t];
    },
    localize: {
        ordinalNumber: function(t, e) {
            var n = Number(t), r = n % 100;
            if (r > 20 || r < 10) switch(r % 10){
                case 1:
                    return n + 'st';
                case 2:
                    return n + 'nd';
                case 3:
                    return n + 'rd';
            }
            return n + 'th';
        },
        era: $d6e59866f4ac3ecb$var$s({
            values: {
                narrow: [
                    'B',
                    'A'
                ],
                abbreviated: [
                    'BC',
                    'AD'
                ],
                wide: [
                    'Before Christ',
                    'Anno Domini'
                ]
            },
            defaultWidth: 'wide'
        }),
        quarter: $d6e59866f4ac3ecb$var$s({
            values: {
                narrow: [
                    '1',
                    '2',
                    '3',
                    '4'
                ],
                abbreviated: [
                    'Q1',
                    'Q2',
                    'Q3',
                    'Q4'
                ],
                wide: [
                    '1st quarter',
                    '2nd quarter',
                    '3rd quarter',
                    '4th quarter'
                ]
            },
            defaultWidth: 'wide',
            argumentCallback: function(t) {
                return Number(t) - 1;
            }
        }),
        month: $d6e59866f4ac3ecb$var$s({
            values: {
                narrow: [
                    'J',
                    'F',
                    'M',
                    'A',
                    'M',
                    'J',
                    'J',
                    'A',
                    'S',
                    'O',
                    'N',
                    'D'
                ],
                abbreviated: [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                ],
                wide: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ]
            },
            defaultWidth: 'wide'
        }),
        day: $d6e59866f4ac3ecb$var$s({
            values: {
                narrow: [
                    'S',
                    'M',
                    'T',
                    'W',
                    'T',
                    'F',
                    'S'
                ],
                short: [
                    'Su',
                    'Mo',
                    'Tu',
                    'We',
                    'Th',
                    'Fr',
                    'Sa'
                ],
                abbreviated: [
                    'Sun',
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat'
                ],
                wide: [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                ]
            },
            defaultWidth: 'wide'
        }),
        dayPeriod: $d6e59866f4ac3ecb$var$s({
            values: {
                narrow: {
                    am: 'a',
                    pm: 'p',
                    midnight: 'mi',
                    noon: 'n',
                    morning: 'morning',
                    afternoon: 'afternoon',
                    evening: 'evening',
                    night: 'night'
                },
                abbreviated: {
                    am: 'AM',
                    pm: 'PM',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'morning',
                    afternoon: 'afternoon',
                    evening: 'evening',
                    night: 'night'
                },
                wide: {
                    am: 'a.m.',
                    pm: 'p.m.',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'morning',
                    afternoon: 'afternoon',
                    evening: 'evening',
                    night: 'night'
                }
            },
            defaultWidth: 'wide',
            formattingValues: {
                narrow: {
                    am: 'a',
                    pm: 'p',
                    midnight: 'mi',
                    noon: 'n',
                    morning: 'in the morning',
                    afternoon: 'in the afternoon',
                    evening: 'in the evening',
                    night: 'at night'
                },
                abbreviated: {
                    am: 'AM',
                    pm: 'PM',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'in the morning',
                    afternoon: 'in the afternoon',
                    evening: 'in the evening',
                    night: 'at night'
                },
                wide: {
                    am: 'a.m.',
                    pm: 'p.m.',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'in the morning',
                    afternoon: 'in the afternoon',
                    evening: 'in the evening',
                    night: 'at night'
                }
            },
            defaultFormattingWidth: 'wide'
        })
    },
    match: {
        ordinalNumber: ($d6e59866f4ac3ecb$var$d = {
            matchPattern: /^(\d+)(th|st|nd|rd)?/i,
            parsePattern: /\d+/i,
            valueCallback: function(t) {
                return parseInt(t, 10);
            }
        }, function(t, e) {
            var n = String(t), r = e || {}, a = n.match($d6e59866f4ac3ecb$var$d.matchPattern);
            if (!a) return null;
            var i = a[0], o = n.match($d6e59866f4ac3ecb$var$d.parsePattern);
            if (!o) return null;
            var u = $d6e59866f4ac3ecb$var$d.valueCallback ? $d6e59866f4ac3ecb$var$d.valueCallback(o[0]) : o[0];
            return {
                value: u = r.valueCallback ? r.valueCallback(u) : u,
                rest: n.slice(i.length)
            };
        }),
        era: $d6e59866f4ac3ecb$var$c({
            matchPatterns: {
                narrow: /^(b|a)/i,
                abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
                wide: /^(before christ|before common era|anno domini|common era)/i
            },
            defaultMatchWidth: 'wide',
            parsePatterns: {
                any: [
                    /^b/i,
                    /^(a|c)/i
                ]
            },
            defaultParseWidth: 'any'
        }),
        quarter: $d6e59866f4ac3ecb$var$c({
            matchPatterns: {
                narrow: /^[1234]/i,
                abbreviated: /^q[1234]/i,
                wide: /^[1234](th|st|nd|rd)? quarter/i
            },
            defaultMatchWidth: 'wide',
            parsePatterns: {
                any: [
                    /1/i,
                    /2/i,
                    /3/i,
                    /4/i
                ]
            },
            defaultParseWidth: 'any',
            valueCallback: function(t) {
                return t + 1;
            }
        }),
        month: $d6e59866f4ac3ecb$var$c({
            matchPatterns: {
                narrow: /^[jfmasond]/i,
                abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
                wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
            },
            defaultMatchWidth: 'wide',
            parsePatterns: {
                narrow: [
                    /^j/i,
                    /^f/i,
                    /^m/i,
                    /^a/i,
                    /^m/i,
                    /^j/i,
                    /^j/i,
                    /^a/i,
                    /^s/i,
                    /^o/i,
                    /^n/i,
                    /^d/i
                ],
                any: [
                    /^ja/i,
                    /^f/i,
                    /^mar/i,
                    /^ap/i,
                    /^may/i,
                    /^jun/i,
                    /^jul/i,
                    /^au/i,
                    /^s/i,
                    /^o/i,
                    /^n/i,
                    /^d/i
                ]
            },
            defaultParseWidth: 'any'
        }),
        day: $d6e59866f4ac3ecb$var$c({
            matchPatterns: {
                narrow: /^[smtwf]/i,
                short: /^(su|mo|tu|we|th|fr|sa)/i,
                abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
                wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
            },
            defaultMatchWidth: 'wide',
            parsePatterns: {
                narrow: [
                    /^s/i,
                    /^m/i,
                    /^t/i,
                    /^w/i,
                    /^t/i,
                    /^f/i,
                    /^s/i
                ],
                any: [
                    /^su/i,
                    /^m/i,
                    /^tu/i,
                    /^w/i,
                    /^th/i,
                    /^f/i,
                    /^sa/i
                ]
            },
            defaultParseWidth: 'any'
        }),
        dayPeriod: $d6e59866f4ac3ecb$var$c({
            matchPatterns: {
                narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
                any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
            },
            defaultMatchWidth: 'any',
            parsePatterns: {
                any: {
                    am: /^a/i,
                    pm: /^p/i,
                    midnight: /^mi/i,
                    noon: /^no/i,
                    morning: /morning/i,
                    afternoon: /afternoon/i,
                    evening: /evening/i,
                    night: /night/i
                }
            },
            defaultParseWidth: 'any'
        })
    },
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
function $d6e59866f4ac3ecb$var$f(t) {
    if (null === t || !0 === t || !1 === t) return NaN;
    var e = Number(t);
    return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function $d6e59866f4ac3ecb$var$h(t, e) {
    if (e.length < t) throw new TypeError(t + ' argument' + (t > 1 ? 's' : '') + ' required, but only ' + e.length + ' present');
}
function $d6e59866f4ac3ecb$var$m(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = Object.prototype.toString.call(t);
    return t instanceof Date || 'object' == typeof t && '[object Date]' === e ? new Date(t.getTime()) : 'number' == typeof t || '[object Number]' === e ? new Date(t) : ('string' != typeof t && '[object String]' !== e || 'undefined' == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}
function $d6e59866f4ac3ecb$var$w(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t).getTime(), r = $d6e59866f4ac3ecb$var$f(e);
    return new Date(n + r);
}
function $d6e59866f4ac3ecb$var$g(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$f(e);
    return $d6e59866f4ac3ecb$var$w(t, -n);
}
function $d6e59866f4ac3ecb$var$v(t, e) {
    if (null == t) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var n in e = e || {})e.hasOwnProperty(n) && (t[n] = e[n]);
    return t;
}
function $d6e59866f4ac3ecb$var$y(t, e) {
    switch(t){
        case 'P':
            return e.date({
                width: 'short'
            });
        case 'PP':
            return e.date({
                width: 'medium'
            });
        case 'PPP':
            return e.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return e.date({
                width: 'full'
            });
    }
}
function $d6e59866f4ac3ecb$var$b(t, e) {
    switch(t){
        case 'p':
            return e.time({
                width: 'short'
            });
        case 'pp':
            return e.time({
                width: 'medium'
            });
        case 'ppp':
            return e.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return e.time({
                width: 'full'
            });
    }
}
var $d6e59866f4ac3ecb$var$D = {
    p: $d6e59866f4ac3ecb$var$b,
    P: function(t, e) {
        var n, r = t.match(/(P+)(p+)?/), a = r[1], i = r[2];
        if (!i) return $d6e59866f4ac3ecb$var$y(t, e);
        switch(a){
            case 'P':
                n = e.dateTime({
                    width: 'short'
                });
                break;
            case 'PP':
                n = e.dateTime({
                    width: 'medium'
                });
                break;
            case 'PPP':
                n = e.dateTime({
                    width: 'long'
                });
                break;
            case 'PPPP':
            default:
                n = e.dateTime({
                    width: 'full'
                });
        }
        return n.replace('{{date}}', $d6e59866f4ac3ecb$var$y(a, e)).replace('{{time}}', $d6e59866f4ac3ecb$var$b(i, e));
    }
};
function $d6e59866f4ac3ecb$var$T(t) {
    return t.getTime() % 6e4;
}
function $d6e59866f4ac3ecb$var$p(t) {
    var e = new Date(t.getTime()), n = Math.ceil(e.getTimezoneOffset());
    return e.setSeconds(0, 0), 6e4 * n + (n > 0 ? (6e4 + $d6e59866f4ac3ecb$var$T(e)) % 6e4 : $d6e59866f4ac3ecb$var$T(e));
}
var $d6e59866f4ac3ecb$var$k = [
    'D',
    'DD'
], $d6e59866f4ac3ecb$var$x = [
    'YY',
    'YYYY'
];
function $d6e59866f4ac3ecb$var$C(t) {
    return -1 !== $d6e59866f4ac3ecb$var$k.indexOf(t);
}
function $d6e59866f4ac3ecb$var$M(t) {
    return -1 !== $d6e59866f4ac3ecb$var$x.indexOf(t);
}
function $d6e59866f4ac3ecb$var$U(t) {
    if ('YYYY' === t) throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
    if ('YY' === t) throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
    if ('D' === t) throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
    if ('DD' === t) throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
}
function $d6e59866f4ac3ecb$var$S(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $d6e59866f4ac3ecb$var$f(a), o = null == n.weekStartsOn ? i : $d6e59866f4ac3ecb$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var u = $d6e59866f4ac3ecb$var$m(t), s = u.getUTCDay(), c = (s < o ? 7 : 0) + s - o;
    return u.setUTCDate(u.getUTCDate() - c), u.setUTCHours(0, 0, 0, 0), u;
}
function $d6e59866f4ac3ecb$var$P(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t, e), r = n.getUTCFullYear(), a = e || {}, i = a.locale, o = i && i.options && i.options.firstWeekContainsDate, u = null == o ? 1 : $d6e59866f4ac3ecb$var$f(o), s = null == a.firstWeekContainsDate ? u : $d6e59866f4ac3ecb$var$f(a.firstWeekContainsDate);
    if (!(s >= 1 && s <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var c = new Date(0);
    c.setUTCFullYear(r + 1, 0, s), c.setUTCHours(0, 0, 0, 0);
    var d = $d6e59866f4ac3ecb$var$S(c, e), l = new Date(0);
    l.setUTCFullYear(r, 0, s), l.setUTCHours(0, 0, 0, 0);
    var w = $d6e59866f4ac3ecb$var$S(l, e);
    return n.getTime() >= d.getTime() ? r + 1 : n.getTime() >= w.getTime() ? r : r - 1;
}
function $d6e59866f4ac3ecb$var$E(t, e, n) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var r = n || {}, a = r.locale, i = a && a.options && a.options.weekStartsOn, o = null == i ? 0 : $d6e59866f4ac3ecb$var$f(i), u = null == r.weekStartsOn ? o : $d6e59866f4ac3ecb$var$f(r.weekStartsOn);
    if (!(u >= 0 && u <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var s = $d6e59866f4ac3ecb$var$m(t), c = $d6e59866f4ac3ecb$var$f(e), d = s.getUTCDay(), l = c % 7, w = (l + 7) % 7, g = (w < u ? 7 : 0) + c - d;
    return s.setUTCDate(s.getUTCDate() + g), s;
}
function $d6e59866f4ac3ecb$var$Y(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = 1, n = $d6e59866f4ac3ecb$var$m(t), r = n.getUTCDay(), a = (r < e ? 7 : 0) + r - e;
    return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function $d6e59866f4ac3ecb$var$N(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$m(t), n = e.getUTCFullYear(), r = new Date(0);
    r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
    var a = $d6e59866f4ac3ecb$var$Y(r), i = new Date(0);
    i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
    var o = $d6e59866f4ac3ecb$var$Y(i);
    return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function $d6e59866f4ac3ecb$var$q(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$N(t), n = new Date(0);
    n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
    var r = $d6e59866f4ac3ecb$var$Y(n);
    return r;
}
function $d6e59866f4ac3ecb$var$B(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$m(t), n = $d6e59866f4ac3ecb$var$Y(e).getTime() - $d6e59866f4ac3ecb$var$q(e).getTime();
    return Math.round(n / 6048e5) + 1;
}
function $d6e59866f4ac3ecb$var$O(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.firstWeekContainsDate, i = null == a ? 1 : $d6e59866f4ac3ecb$var$f(a), o = null == n.firstWeekContainsDate ? i : $d6e59866f4ac3ecb$var$f(n.firstWeekContainsDate), u = $d6e59866f4ac3ecb$var$P(t, e), s = new Date(0);
    s.setUTCFullYear(u, 0, o), s.setUTCHours(0, 0, 0, 0);
    var c = $d6e59866f4ac3ecb$var$S(s, e);
    return c;
}
function $d6e59866f4ac3ecb$var$H(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$S(n, e).getTime() - $d6e59866f4ac3ecb$var$O(n, e).getTime();
    return Math.round(r / 6048e5) + 1;
}
var $d6e59866f4ac3ecb$var$L = /^(1[0-2]|0?\d)/, $d6e59866f4ac3ecb$var$W = /^(3[0-1]|[0-2]?\d)/, $d6e59866f4ac3ecb$var$F = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, $d6e59866f4ac3ecb$var$Q = /^(5[0-3]|[0-4]?\d)/, $d6e59866f4ac3ecb$var$R = /^(2[0-3]|[0-1]?\d)/, $d6e59866f4ac3ecb$var$I = /^(2[0-4]|[0-1]?\d)/, $d6e59866f4ac3ecb$var$X = /^(1[0-1]|0?\d)/, $d6e59866f4ac3ecb$var$G = /^(1[0-2]|0?\d)/, $d6e59866f4ac3ecb$var$A = /^[0-5]?\d/, $d6e59866f4ac3ecb$var$z = /^[0-5]?\d/, $d6e59866f4ac3ecb$var$j = /^\d/, $d6e59866f4ac3ecb$var$K = /^\d{1,2}/, $d6e59866f4ac3ecb$var$J = /^\d{1,3}/, $d6e59866f4ac3ecb$var$Z = /^\d{1,4}/, $d6e59866f4ac3ecb$var$_ = /^-?\d+/, $d6e59866f4ac3ecb$var$$ = /^-?\d/, $d6e59866f4ac3ecb$var$V = /^-?\d{1,2}/, $d6e59866f4ac3ecb$var$tt = /^-?\d{1,3}/, $d6e59866f4ac3ecb$var$et = /^-?\d{1,4}/, $d6e59866f4ac3ecb$var$nt = /^([+-])(\d{2})(\d{2})?|Z/, $d6e59866f4ac3ecb$var$rt = /^([+-])(\d{2})(\d{2})|Z/, $d6e59866f4ac3ecb$var$at = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/, $d6e59866f4ac3ecb$var$it = /^([+-])(\d{2}):(\d{2})|Z/, $d6e59866f4ac3ecb$var$ot = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;
function $d6e59866f4ac3ecb$var$ut(t, e, n) {
    var r = e.match(t);
    if (!r) return null;
    var a = parseInt(r[0], 10);
    return {
        value: n ? n(a) : a,
        rest: e.slice(r[0].length)
    };
}
function $d6e59866f4ac3ecb$var$st(t, e) {
    var n = e.match(t);
    return n ? 'Z' === n[0] ? {
        value: 0,
        rest: e.slice(1)
    } : {
        value: ('+' === n[1] ? 1 : -1) * (36e5 * (n[2] ? parseInt(n[2], 10) : 0) + 6e4 * (n[3] ? parseInt(n[3], 10) : 0) + 1e3 * (n[5] ? parseInt(n[5], 10) : 0)),
        rest: e.slice(n[0].length)
    } : null;
}
function $d6e59866f4ac3ecb$var$ct(t, e) {
    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$_, t, e);
}
function $d6e59866f4ac3ecb$var$dt(t, e, n) {
    switch(t){
        case 1:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$j, e, n);
        case 2:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$K, e, n);
        case 3:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$J, e, n);
        case 4:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$Z, e, n);
        default:
            return $d6e59866f4ac3ecb$var$ut(new RegExp('^\\d{1,' + t + '}'), e, n);
    }
}
function $d6e59866f4ac3ecb$var$lt(t, e, n) {
    switch(t){
        case 1:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$$, e, n);
        case 2:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$V, e, n);
        case 3:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$tt, e, n);
        case 4:
            return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$et, e, n);
        default:
            return $d6e59866f4ac3ecb$var$ut(new RegExp('^-?\\d{1,' + t + '}'), e, n);
    }
}
function $d6e59866f4ac3ecb$var$ft(t) {
    switch(t){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $d6e59866f4ac3ecb$var$ht(t, e) {
    var n, r = e > 0, a = r ? e : 1 - e;
    if (a <= 50) n = t || 100;
    else {
        var i = a + 50;
        n = t + 100 * Math.floor(i / 100) - (t >= i % 100 ? 100 : 0);
    }
    return r ? n : 1 - n;
}
var $d6e59866f4ac3ecb$var$mt = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], $d6e59866f4ac3ecb$var$wt = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $d6e59866f4ac3ecb$var$gt(t) {
    return t % 400 == 0 || t % 4 == 0 && t % 100 != 0;
}
var $d6e59866f4ac3ecb$var$vt = {
    G: {
        priority: 140,
        parse: function(t, e, n, r) {
            switch(e){
                case 'G':
                case 'GG':
                case 'GGG':
                    return n.era(t, {
                        width: 'abbreviated'
                    }) || n.era(t, {
                        width: 'narrow'
                    });
                case 'GGGGG':
                    return n.era(t, {
                        width: 'narrow'
                    });
                case 'GGGG':
                default:
                    return n.era(t, {
                        width: 'wide'
                    }) || n.era(t, {
                        width: 'abbreviated'
                    }) || n.era(t, {
                        width: 'narrow'
                    });
            }
        },
        set: function(t, e, n, r) {
            return e.era = n, t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'R',
            'u',
            't',
            'T'
        ]
    },
    y: {
        priority: 130,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return {
                    year: t,
                    isTwoDigitYear: 'yy' === e
                };
            };
            switch(e){
                case 'y':
                    return $d6e59866f4ac3ecb$var$dt(4, t, a);
                case 'yo':
                    return n.ordinalNumber(t, {
                        unit: 'year',
                        valueCallback: a
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t, a);
            }
        },
        validate: function(t, e, n) {
            return e.isTwoDigitYear || e.year > 0;
        },
        set: function(t, e, n, r) {
            var a = t.getUTCFullYear();
            if (n.isTwoDigitYear) {
                var i = $d6e59866f4ac3ecb$var$ht(n.year, a);
                return t.setUTCFullYear(i, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
            }
            var o = 'era' in e && 1 !== e.era ? 1 - n.year : n.year;
            return t.setUTCFullYear(o, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    Y: {
        priority: 130,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return {
                    year: t,
                    isTwoDigitYear: 'YY' === e
                };
            };
            switch(e){
                case 'Y':
                    return $d6e59866f4ac3ecb$var$dt(4, t, a);
                case 'Yo':
                    return n.ordinalNumber(t, {
                        unit: 'year',
                        valueCallback: a
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t, a);
            }
        },
        validate: function(t, e, n) {
            return e.isTwoDigitYear || e.year > 0;
        },
        set: function(t, e, n, r) {
            var a = $d6e59866f4ac3ecb$var$P(t, r);
            if (n.isTwoDigitYear) {
                var i = $d6e59866f4ac3ecb$var$ht(n.year, a);
                return t.setUTCFullYear(i, 0, r.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), $d6e59866f4ac3ecb$var$S(t, r);
            }
            var o = 'era' in e && 1 !== e.era ? 1 - n.year : n.year;
            return t.setUTCFullYear(o, 0, r.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), $d6e59866f4ac3ecb$var$S(t, r);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    R: {
        priority: 130,
        parse: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$lt('R' === e ? 4 : e.length, t);
        },
        set: function(t, e, n, r) {
            var a = new Date(0);
            return a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0), $d6e59866f4ac3ecb$var$Y(a);
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    u: {
        priority: 130,
        parse: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$lt('u' === e ? 4 : e.length, t);
        },
        set: function(t, e, n, r) {
            return t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    Q: {
        priority: 120,
        parse: function(t, e, n, r) {
            switch(e){
                case 'Q':
                case 'QQ':
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
                case 'Qo':
                    return n.ordinalNumber(t, {
                        unit: 'quarter'
                    });
                case 'QQQ':
                    return n.quarter(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.quarter(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'QQQQQ':
                    return n.quarter(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'QQQQ':
                default:
                    return n.quarter(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.quarter(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.quarter(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 4;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(3 * (n - 1), 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    q: {
        priority: 120,
        parse: function(t, e, n, r) {
            switch(e){
                case 'q':
                case 'qq':
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
                case 'qo':
                    return n.ordinalNumber(t, {
                        unit: 'quarter'
                    });
                case 'qqq':
                    return n.quarter(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.quarter(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'qqqqq':
                    return n.quarter(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'qqqq':
                default:
                    return n.quarter(t, {
                        width: 'wide',
                        context: 'standalone'
                    }) || n.quarter(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.quarter(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 4;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(3 * (n - 1), 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    M: {
        priority: 110,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return t - 1;
            };
            switch(e){
                case 'M':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$L, t, a);
                case 'MM':
                    return $d6e59866f4ac3ecb$var$dt(2, t, a);
                case 'Mo':
                    return n.ordinalNumber(t, {
                        unit: 'month',
                        valueCallback: a
                    });
                case 'MMM':
                    return n.month(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.month(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'MMMMM':
                    return n.month(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'MMMM':
                default:
                    return n.month(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.month(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.month(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    L: {
        priority: 110,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return t - 1;
            };
            switch(e){
                case 'L':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$L, t, a);
                case 'LL':
                    return $d6e59866f4ac3ecb$var$dt(2, t, a);
                case 'Lo':
                    return n.ordinalNumber(t, {
                        unit: 'month',
                        valueCallback: a
                    });
                case 'LLL':
                    return n.month(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.month(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'LLLLL':
                    return n.month(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'LLLL':
                default:
                    return n.month(t, {
                        width: 'wide',
                        context: 'standalone'
                    }) || n.month(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.month(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    w: {
        priority: 100,
        parse: function(t, e, n, r) {
            switch(e){
                case 'w':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$Q, t);
                case 'wo':
                    return n.ordinalNumber(t, {
                        unit: 'week'
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 53;
        },
        set: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$S(function(t, e, n) {
                $d6e59866f4ac3ecb$var$h(2, arguments);
                var r = $d6e59866f4ac3ecb$var$m(t), a = $d6e59866f4ac3ecb$var$f(e), i = $d6e59866f4ac3ecb$var$H(r, n) - a;
                return r.setUTCDate(r.getUTCDate() - 7 * i), r;
            }(t, n, r), r);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    I: {
        priority: 100,
        parse: function(t, e, n, r) {
            switch(e){
                case 'I':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$Q, t);
                case 'Io':
                    return n.ordinalNumber(t, {
                        unit: 'week'
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 53;
        },
        set: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$Y(function(t, e) {
                $d6e59866f4ac3ecb$var$h(2, arguments);
                var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$f(e), a = $d6e59866f4ac3ecb$var$B(n) - r;
                return n.setUTCDate(n.getUTCDate() - 7 * a), n;
            }(t, n, r), r);
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    d: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case 'd':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$W, t);
                case 'do':
                    return n.ordinalNumber(t, {
                        unit: 'date'
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            var r = $d6e59866f4ac3ecb$var$gt(t.getUTCFullYear()), a = t.getUTCMonth();
            return r ? e >= 1 && e <= $d6e59866f4ac3ecb$var$wt[a] : e >= 1 && e <= $d6e59866f4ac3ecb$var$mt[a];
        },
        set: function(t, e, n, r) {
            return t.setUTCDate(n), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    D: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case 'D':
                case 'DD':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$F, t);
                case 'Do':
                    return n.ordinalNumber(t, {
                        unit: 'date'
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return $d6e59866f4ac3ecb$var$gt(t.getUTCFullYear()) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(0, n), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    E: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case 'E':
                case 'EE':
                case 'EEE':
                    return n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEEE':
                    return n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEEEE':
                    return n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEE':
                default:
                    return n.day(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $d6e59866f4ac3ecb$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    e: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                var e = 7 * Math.floor((t - 1) / 7);
                return (t + r.weekStartsOn + 6) % 7 + e;
            };
            switch(e){
                case 'e':
                case 'ee':
                    return $d6e59866f4ac3ecb$var$dt(e.length, t, a);
                case 'eo':
                    return n.ordinalNumber(t, {
                        unit: 'day',
                        valueCallback: a
                    });
                case 'eee':
                    return n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeeee':
                    return n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeeeee':
                    return n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeee':
                default:
                    return n.day(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $d6e59866f4ac3ecb$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]
    },
    c: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                var e = 7 * Math.floor((t - 1) / 7);
                return (t + r.weekStartsOn + 6) % 7 + e;
            };
            switch(e){
                case 'c':
                case 'cc':
                    return $d6e59866f4ac3ecb$var$dt(e.length, t, a);
                case 'co':
                    return n.ordinalNumber(t, {
                        unit: 'day',
                        valueCallback: a
                    });
                case 'ccc':
                    return n.day(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'ccccc':
                    return n.day(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'cccccc':
                    return n.day(t, {
                        width: 'short',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'cccc':
                default:
                    return n.day(t, {
                        width: 'wide',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $d6e59866f4ac3ecb$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]
    },
    i: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return 0 === t ? 7 : t;
            };
            switch(e){
                case 'i':
                case 'ii':
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
                case 'io':
                    return n.ordinalNumber(t, {
                        unit: 'day'
                    });
                case 'iii':
                    return n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: a
                    });
                case 'iiiii':
                    return n.day(t, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: a
                    });
                case 'iiiiii':
                    return n.day(t, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: a
                    });
                case 'iiii':
                default:
                    return n.day(t, {
                        width: 'wide',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: a
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 7;
        },
        set: function(t, e, n, r) {
            return (t = function(t, e) {
                $d6e59866f4ac3ecb$var$h(2, arguments);
                var n = $d6e59866f4ac3ecb$var$f(e);
                n % 7 == 0 && (n -= 7);
                var r = 1, a = $d6e59866f4ac3ecb$var$m(t), i = a.getUTCDay(), o = n % 7, u = (o + 7) % 7, s = (u < r ? 7 : 0) + n - i;
                return a.setUTCDate(a.getUTCDate() + s), a;
            }(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]
    },
    a: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case 'a':
                case 'aa':
                case 'aaa':
                    return n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaaa':
                    return n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return n.dayPeriod(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($d6e59866f4ac3ecb$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            'b',
            'B',
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    b: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case 'b':
                case 'bb':
                case 'bbb':
                    return n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbbb':
                    return n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return n.dayPeriod(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($d6e59866f4ac3ecb$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            'a',
            'B',
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    B: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case 'B':
                case 'BB':
                case 'BBB':
                    return n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return n.dayPeriod(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($d6e59866f4ac3ecb$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            'a',
            'b',
            't',
            'T'
        ]
    },
    h: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case 'h':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$G, t);
                case 'ho':
                    return n.ordinalNumber(t, {
                        unit: 'hour'
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 12;
        },
        set: function(t, e, n, r) {
            var a = t.getUTCHours() >= 12;
            return a && n < 12 ? t.setUTCHours(n + 12, 0, 0, 0) : a || 12 !== n ? t.setUTCHours(n, 0, 0, 0) : t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    H: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case 'H':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$R, t);
                case 'Ho':
                    return n.ordinalNumber(t, {
                        unit: 'hour'
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 23;
        },
        set: function(t, e, n, r) {
            return t.setUTCHours(n, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]
    },
    K: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case 'K':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$X, t);
                case 'Ko':
                    return n.ordinalNumber(t, {
                        unit: 'hour'
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.getUTCHours() >= 12 && n < 12 ? t.setUTCHours(n + 12, 0, 0, 0) : t.setUTCHours(n, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'H',
            'k',
            't',
            'T'
        ]
    },
    k: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case 'k':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$I, t);
                case 'ko':
                    return n.ordinalNumber(t, {
                        unit: 'hour'
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 24;
        },
        set: function(t, e, n, r) {
            var a = n <= 24 ? n % 24 : n;
            return t.setUTCHours(a, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]
    },
    m: {
        priority: 60,
        parse: function(t, e, n, r) {
            switch(e){
                case 'm':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$A, t);
                case 'mo':
                    return n.ordinalNumber(t, {
                        unit: 'minute'
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 59;
        },
        set: function(t, e, n, r) {
            return t.setUTCMinutes(n, 0, 0), t;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    s: {
        priority: 50,
        parse: function(t, e, n, r) {
            switch(e){
                case 's':
                    return $d6e59866f4ac3ecb$var$ut($d6e59866f4ac3ecb$var$z, t);
                case 'so':
                    return n.ordinalNumber(t, {
                        unit: 'second'
                    });
                default:
                    return $d6e59866f4ac3ecb$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 59;
        },
        set: function(t, e, n, r) {
            return t.setUTCSeconds(n, 0), t;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    S: {
        priority: 30,
        parse: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$dt(e.length, t, function(t) {
                return Math.floor(t * Math.pow(10, 3 - e.length));
            });
        },
        set: function(t, e, n, r) {
            return t.setUTCMilliseconds(n), t;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    X: {
        priority: 10,
        parse: function(t, e, n, r) {
            switch(e){
                case 'X':
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$nt, t);
                case 'XX':
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$rt, t);
                case 'XXXX':
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$at, t);
                case 'XXXXX':
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$ot, t);
                case 'XXX':
                default:
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$it, t);
            }
        },
        set: function(t, e, n, r) {
            return e.timestampIsSet ? t : new Date(t.getTime() - n);
        },
        incompatibleTokens: [
            't',
            'T',
            'x'
        ]
    },
    x: {
        priority: 10,
        parse: function(t, e, n, r) {
            switch(e){
                case 'x':
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$nt, t);
                case 'xx':
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$rt, t);
                case 'xxxx':
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$at, t);
                case 'xxxxx':
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$ot, t);
                case 'xxx':
                default:
                    return $d6e59866f4ac3ecb$var$st($d6e59866f4ac3ecb$var$it, t);
            }
        },
        set: function(t, e, n, r) {
            return e.timestampIsSet ? t : new Date(t.getTime() - n);
        },
        incompatibleTokens: [
            't',
            'T',
            'X'
        ]
    },
    t: {
        priority: 40,
        parse: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$ct(t);
        },
        set: function(t, e, n, r) {
            return [
                new Date(1e3 * n),
                {
                    timestampIsSet: !0
                }
            ];
        },
        incompatibleTokens: '*'
    },
    T: {
        priority: 20,
        parse: function(t, e, n, r) {
            return $d6e59866f4ac3ecb$var$ct(t);
        },
        set: function(t, e, n, r) {
            return [
                new Date(n),
                {
                    timestampIsSet: !0
                }
            ];
        },
        incompatibleTokens: '*'
    }
}, $d6e59866f4ac3ecb$var$yt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $d6e59866f4ac3ecb$var$bt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $d6e59866f4ac3ecb$var$Dt = /^'([^]*?)'?$/, $d6e59866f4ac3ecb$var$Tt = /''/g, $d6e59866f4ac3ecb$var$pt = /\S/, $d6e59866f4ac3ecb$var$kt = /[a-zA-Z]/;
function $d6e59866f4ac3ecb$export$6b862160d295c8e(t, e, n, r) {
    $d6e59866f4ac3ecb$var$h(3, arguments);
    var a = String(t), i = String(e), o = r || {}, u = o.locale || $d6e59866f4ac3ecb$var$l;
    if (!u.match) throw new RangeError('locale must contain match property');
    var s = u.options && u.options.firstWeekContainsDate, c = null == s ? 1 : $d6e59866f4ac3ecb$var$f(s), d = null == o.firstWeekContainsDate ? c : $d6e59866f4ac3ecb$var$f(o.firstWeekContainsDate);
    if (!(d >= 1 && d <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var w = u.options && u.options.weekStartsOn, y = null == w ? 0 : $d6e59866f4ac3ecb$var$f(w), b = null == o.weekStartsOn ? y : $d6e59866f4ac3ecb$var$f(o.weekStartsOn);
    if (!(b >= 0 && b <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if ('' === i) return '' === a ? $d6e59866f4ac3ecb$var$m(n) : new Date(NaN);
    var T, k = {
        firstWeekContainsDate: d,
        weekStartsOn: b,
        locale: u
    }, x = [
        {
            priority: 10,
            set: $d6e59866f4ac3ecb$var$Ct,
            index: 0
        }
    ], S = i.match($d6e59866f4ac3ecb$var$bt).map(function(t) {
        var e = t[0];
        return 'p' === e || 'P' === e ? (0, $d6e59866f4ac3ecb$var$D[e])(t, u.formatLong, k) : t;
    }).join('').match($d6e59866f4ac3ecb$var$yt), P = [];
    for(T = 0; T < S.length; T++){
        var E = S[T];
        !o.useAdditionalWeekYearTokens && $d6e59866f4ac3ecb$var$M(E) && $d6e59866f4ac3ecb$var$U(E), !o.useAdditionalDayOfYearTokens && $d6e59866f4ac3ecb$var$C(E) && $d6e59866f4ac3ecb$var$U(E);
        var Y = E[0], N = $d6e59866f4ac3ecb$var$vt[Y];
        if (N) {
            var q = N.incompatibleTokens;
            if (Array.isArray(q)) {
                for(var B = void 0, O = 0; O < P.length; O++){
                    var H = P[O].token;
                    if (-1 !== q.indexOf(H) || H === Y) {
                        B = P[O];
                        break;
                    }
                }
                if (B) throw new RangeError("The format string mustn't contain `".concat(B.fullToken, '` and `').concat(E, '` at the same time'));
            } else if ('*' === N.incompatibleTokens && P.length) throw new RangeError("The format string mustn't contain `".concat(E, '` and any other token at the same time'));
            P.push({
                token: Y,
                fullToken: E
            });
            var L = N.parse(a, E, u.match, k);
            if (!L) return new Date(NaN);
            x.push({
                priority: N.priority,
                set: N.set,
                validate: N.validate,
                value: L.value,
                index: x.length
            }), a = L.rest;
        } else {
            if (Y.match($d6e59866f4ac3ecb$var$kt)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + Y + '`');
            if ("''" === E ? E = "'" : "'" === Y && (E = $d6e59866f4ac3ecb$var$Mt(E)), 0 !== a.indexOf(E)) return new Date(NaN);
            a = a.slice(E.length);
        }
    }
    if (a.length > 0 && $d6e59866f4ac3ecb$var$pt.test(a)) return new Date(NaN);
    var W = x.map(function(t) {
        return t.priority;
    }).sort(function(t, e) {
        return e - t;
    }).filter(function(t, e, n) {
        return n.indexOf(t) === e;
    }).map(function(t) {
        return x.filter(function(e) {
            return e.priority === t;
        }).reverse();
    }).map(function(t) {
        return t[0];
    }), F = $d6e59866f4ac3ecb$var$m(n);
    if (isNaN(F)) return new Date(NaN);
    var Q = $d6e59866f4ac3ecb$var$g(F, $d6e59866f4ac3ecb$var$p(F)), R = {};
    for(T = 0; T < W.length; T++){
        var I = W[T];
        if (I.validate && !I.validate(Q, I.value, k)) return new Date(NaN);
        var X = I.set(Q, R, I.value, k);
        X[0] ? (Q = X[0], $d6e59866f4ac3ecb$var$v(R, X[1])) : Q = X;
    }
    return Q;
}
function $d6e59866f4ac3ecb$var$Ct(t, e) {
    if (e.timestampIsSet) return t;
    var n = new Date(0);
    return n.setFullYear(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()), n.setHours(t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds()), n;
}
function $d6e59866f4ac3ecb$var$Mt(t) {
    return t.match($d6e59866f4ac3ecb$var$Dt)[1].replace($d6e59866f4ac3ecb$var$Tt, "'");
}
function $d6e59866f4ac3ecb$var$Ut(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$m(t);
    return !isNaN(e);
}
function $d6e59866f4ac3ecb$var$St(t, e) {
    for(var n = t < 0 ? '-' : '', r = Math.abs(t).toString(); r.length < e;)r = '0' + r;
    return n + r;
}
var $d6e59866f4ac3ecb$var$Pt = function(t, e) {
    var n = t.getUTCFullYear(), r = n > 0 ? n : 1 - n;
    return $d6e59866f4ac3ecb$var$St('yy' === e ? r % 100 : r, e.length);
}, $d6e59866f4ac3ecb$var$Et = function(t, e) {
    var n = t.getUTCMonth();
    return 'M' === e ? String(n + 1) : $d6e59866f4ac3ecb$var$St(n + 1, 2);
}, $d6e59866f4ac3ecb$var$Yt = function(t, e) {
    return $d6e59866f4ac3ecb$var$St(t.getUTCDate(), e.length);
}, $d6e59866f4ac3ecb$var$Nt = function(t, e) {
    return $d6e59866f4ac3ecb$var$St(t.getUTCHours() % 12 || 12, e.length);
}, $d6e59866f4ac3ecb$var$qt = function(t, e) {
    return $d6e59866f4ac3ecb$var$St(t.getUTCHours(), e.length);
}, $d6e59866f4ac3ecb$var$Bt = function(t, e) {
    return $d6e59866f4ac3ecb$var$St(t.getUTCMinutes(), e.length);
}, $d6e59866f4ac3ecb$var$Ot = function(t, e) {
    return $d6e59866f4ac3ecb$var$St(t.getUTCSeconds(), e.length);
}, $d6e59866f4ac3ecb$var$Ht = function(t, e) {
    var n = e.length, r = t.getUTCMilliseconds();
    return $d6e59866f4ac3ecb$var$St(Math.floor(r * Math.pow(10, n - 3)), e.length);
};
var $d6e59866f4ac3ecb$var$Lt = 'midnight', $d6e59866f4ac3ecb$var$Wt = 'noon', $d6e59866f4ac3ecb$var$Ft = 'morning', $d6e59866f4ac3ecb$var$Qt = 'afternoon', $d6e59866f4ac3ecb$var$Rt = 'evening', $d6e59866f4ac3ecb$var$It = 'night', $d6e59866f4ac3ecb$var$Xt = {
    G: function(t, e, n) {
        var r = t.getUTCFullYear() > 0 ? 1 : 0;
        switch(e){
            case 'G':
            case 'GG':
            case 'GGG':
                return n.era(r, {
                    width: 'abbreviated'
                });
            case 'GGGGG':
                return n.era(r, {
                    width: 'narrow'
                });
            case 'GGGG':
            default:
                return n.era(r, {
                    width: 'wide'
                });
        }
    },
    y: function(t, e, n) {
        if ('yo' === e) {
            var r = t.getUTCFullYear(), a = r > 0 ? r : 1 - r;
            return n.ordinalNumber(a, {
                unit: 'year'
            });
        }
        return $d6e59866f4ac3ecb$var$Pt(t, e);
    },
    Y: function(t, e, n, r) {
        var a = $d6e59866f4ac3ecb$var$P(t, r), i = a > 0 ? a : 1 - a;
        return 'YY' === e ? $d6e59866f4ac3ecb$var$St(i % 100, 2) : 'Yo' === e ? n.ordinalNumber(i, {
            unit: 'year'
        }) : $d6e59866f4ac3ecb$var$St(i, e.length);
    },
    R: function(t, e) {
        return $d6e59866f4ac3ecb$var$St($d6e59866f4ac3ecb$var$N(t), e.length);
    },
    u: function(t, e) {
        return $d6e59866f4ac3ecb$var$St(t.getUTCFullYear(), e.length);
    },
    Q: function(t, e, n) {
        var r = Math.ceil((t.getUTCMonth() + 1) / 3);
        switch(e){
            case 'Q':
                return String(r);
            case 'QQ':
                return $d6e59866f4ac3ecb$var$St(r, 2);
            case 'Qo':
                return n.ordinalNumber(r, {
                    unit: 'quarter'
                });
            case 'QQQ':
                return n.quarter(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'QQQQQ':
                return n.quarter(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'QQQQ':
            default:
                return n.quarter(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    q: function(t, e, n) {
        var r = Math.ceil((t.getUTCMonth() + 1) / 3);
        switch(e){
            case 'q':
                return String(r);
            case 'qq':
                return $d6e59866f4ac3ecb$var$St(r, 2);
            case 'qo':
                return n.ordinalNumber(r, {
                    unit: 'quarter'
                });
            case 'qqq':
                return n.quarter(r, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            case 'qqqqq':
                return n.quarter(r, {
                    width: 'narrow',
                    context: 'standalone'
                });
            case 'qqqq':
            default:
                return n.quarter(r, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    M: function(t, e, n) {
        var r = t.getUTCMonth();
        switch(e){
            case 'M':
            case 'MM':
                return $d6e59866f4ac3ecb$var$Et(t, e);
            case 'Mo':
                return n.ordinalNumber(r + 1, {
                    unit: 'month'
                });
            case 'MMM':
                return n.month(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'MMMMM':
                return n.month(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'MMMM':
            default:
                return n.month(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    L: function(t, e, n) {
        var r = t.getUTCMonth();
        switch(e){
            case 'L':
                return String(r + 1);
            case 'LL':
                return $d6e59866f4ac3ecb$var$St(r + 1, 2);
            case 'Lo':
                return n.ordinalNumber(r + 1, {
                    unit: 'month'
                });
            case 'LLL':
                return n.month(r, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            case 'LLLLL':
                return n.month(r, {
                    width: 'narrow',
                    context: 'standalone'
                });
            case 'LLLL':
            default:
                return n.month(r, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    w: function(t, e, n, r) {
        var a = $d6e59866f4ac3ecb$var$H(t, r);
        return 'wo' === e ? n.ordinalNumber(a, {
            unit: 'week'
        }) : $d6e59866f4ac3ecb$var$St(a, e.length);
    },
    I: function(t, e, n) {
        var r = $d6e59866f4ac3ecb$var$B(t);
        return 'Io' === e ? n.ordinalNumber(r, {
            unit: 'week'
        }) : $d6e59866f4ac3ecb$var$St(r, e.length);
    },
    d: function(t, e, n) {
        return 'do' === e ? n.ordinalNumber(t.getUTCDate(), {
            unit: 'date'
        }) : $d6e59866f4ac3ecb$var$Yt(t, e);
    },
    D: function(t, e, n) {
        var r = function(t) {
            $d6e59866f4ac3ecb$var$h(1, arguments);
            var e = $d6e59866f4ac3ecb$var$m(t), n = e.getTime();
            e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
            var r = e.getTime(), a = n - r;
            return Math.floor(a / 864e5) + 1;
        }(t);
        return 'Do' === e ? n.ordinalNumber(r, {
            unit: 'dayOfYear'
        }) : $d6e59866f4ac3ecb$var$St(r, e.length);
    },
    E: function(t, e, n) {
        var r = t.getUTCDay();
        switch(e){
            case 'E':
            case 'EE':
            case 'EEE':
                return n.day(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'EEEEE':
                return n.day(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'EEEEEE':
                return n.day(r, {
                    width: 'short',
                    context: 'formatting'
                });
            case 'EEEE':
            default:
                return n.day(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    e: function(t, e, n, r) {
        var a = t.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
        switch(e){
            case 'e':
                return String(i);
            case 'ee':
                return $d6e59866f4ac3ecb$var$St(i, 2);
            case 'eo':
                return n.ordinalNumber(i, {
                    unit: 'day'
                });
            case 'eee':
                return n.day(a, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'eeeee':
                return n.day(a, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'eeeeee':
                return n.day(a, {
                    width: 'short',
                    context: 'formatting'
                });
            case 'eeee':
            default:
                return n.day(a, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    c: function(t, e, n, r) {
        var a = t.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
        switch(e){
            case 'c':
                return String(i);
            case 'cc':
                return $d6e59866f4ac3ecb$var$St(i, e.length);
            case 'co':
                return n.ordinalNumber(i, {
                    unit: 'day'
                });
            case 'ccc':
                return n.day(a, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            case 'ccccc':
                return n.day(a, {
                    width: 'narrow',
                    context: 'standalone'
                });
            case 'cccccc':
                return n.day(a, {
                    width: 'short',
                    context: 'standalone'
                });
            case 'cccc':
            default:
                return n.day(a, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    i: function(t, e, n) {
        var r = t.getUTCDay(), a = 0 === r ? 7 : r;
        switch(e){
            case 'i':
                return String(a);
            case 'ii':
                return $d6e59866f4ac3ecb$var$St(a, e.length);
            case 'io':
                return n.ordinalNumber(a, {
                    unit: 'day'
                });
            case 'iii':
                return n.day(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'iiiii':
                return n.day(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'iiiiii':
                return n.day(r, {
                    width: 'short',
                    context: 'formatting'
                });
            case 'iiii':
            default:
                return n.day(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    a: function(t, e, n) {
        var r = t.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(e){
            case 'a':
            case 'aa':
            case 'aaa':
                return n.dayPeriod(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaaaa':
                return n.dayPeriod(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return n.dayPeriod(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    b: function(t, e, n) {
        var r, a = t.getUTCHours();
        switch(r = 12 === a ? $d6e59866f4ac3ecb$var$Wt : 0 === a ? $d6e59866f4ac3ecb$var$Lt : a / 12 >= 1 ? 'pm' : 'am', e){
            case 'b':
            case 'bb':
            case 'bbb':
                return n.dayPeriod(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbbbb':
                return n.dayPeriod(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return n.dayPeriod(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    B: function(t, e, n) {
        var r, a = t.getUTCHours();
        switch(r = a >= 17 ? $d6e59866f4ac3ecb$var$Rt : a >= 12 ? $d6e59866f4ac3ecb$var$Qt : a >= 4 ? $d6e59866f4ac3ecb$var$Ft : $d6e59866f4ac3ecb$var$It, e){
            case 'B':
            case 'BB':
            case 'BBB':
                return n.dayPeriod(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return n.dayPeriod(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return n.dayPeriod(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    h: function(t, e, n) {
        if ('ho' === e) {
            var r = t.getUTCHours() % 12;
            return 0 === r && (r = 12), n.ordinalNumber(r, {
                unit: 'hour'
            });
        }
        return $d6e59866f4ac3ecb$var$Nt(t, e);
    },
    H: function(t, e, n) {
        return 'Ho' === e ? n.ordinalNumber(t.getUTCHours(), {
            unit: 'hour'
        }) : $d6e59866f4ac3ecb$var$qt(t, e);
    },
    K: function(t, e, n) {
        var r = t.getUTCHours() % 12;
        return 'Ko' === e ? n.ordinalNumber(r, {
            unit: 'hour'
        }) : $d6e59866f4ac3ecb$var$St(r, e.length);
    },
    k: function(t, e, n) {
        var r = t.getUTCHours();
        return 0 === r && (r = 24), 'ko' === e ? n.ordinalNumber(r, {
            unit: 'hour'
        }) : $d6e59866f4ac3ecb$var$St(r, e.length);
    },
    m: function(t, e, n) {
        return 'mo' === e ? n.ordinalNumber(t.getUTCMinutes(), {
            unit: 'minute'
        }) : $d6e59866f4ac3ecb$var$Bt(t, e);
    },
    s: function(t, e, n) {
        return 'so' === e ? n.ordinalNumber(t.getUTCSeconds(), {
            unit: 'second'
        }) : $d6e59866f4ac3ecb$var$Ot(t, e);
    },
    S: function(t, e) {
        return $d6e59866f4ac3ecb$var$Ht(t, e);
    },
    X: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        if (0 === a) return 'Z';
        switch(e){
            case 'X':
                return $d6e59866f4ac3ecb$var$At(a);
            case 'XXXX':
            case 'XX':
                return $d6e59866f4ac3ecb$var$zt(a);
            case 'XXXXX':
            case 'XXX':
            default:
                return $d6e59866f4ac3ecb$var$zt(a, ':');
        }
    },
    x: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case 'x':
                return $d6e59866f4ac3ecb$var$At(a);
            case 'xxxx':
            case 'xx':
                return $d6e59866f4ac3ecb$var$zt(a);
            case 'xxxxx':
            case 'xxx':
            default:
                return $d6e59866f4ac3ecb$var$zt(a, ':');
        }
    },
    O: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $d6e59866f4ac3ecb$var$Gt(a, ':');
            case 'OOOO':
            default:
                return 'GMT' + $d6e59866f4ac3ecb$var$zt(a, ':');
        }
    },
    z: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $d6e59866f4ac3ecb$var$Gt(a, ':');
            case 'zzzz':
            default:
                return 'GMT' + $d6e59866f4ac3ecb$var$zt(a, ':');
        }
    },
    t: function(t, e, n, r) {
        var a = r._originalDate || t;
        return $d6e59866f4ac3ecb$var$St(Math.floor(a.getTime() / 1e3), e.length);
    },
    T: function(t, e, n, r) {
        return $d6e59866f4ac3ecb$var$St((r._originalDate || t).getTime(), e.length);
    }
};
function $d6e59866f4ac3ecb$var$Gt(t, e) {
    var n = t > 0 ? '-' : '+', r = Math.abs(t), a = Math.floor(r / 60), i = r % 60;
    if (0 === i) return n + String(a);
    var o = e || '';
    return n + String(a) + o + $d6e59866f4ac3ecb$var$St(i, 2);
}
function $d6e59866f4ac3ecb$var$At(t, e) {
    return t % 60 == 0 ? (t > 0 ? '-' : '+') + $d6e59866f4ac3ecb$var$St(Math.abs(t) / 60, 2) : $d6e59866f4ac3ecb$var$zt(t, e);
}
function $d6e59866f4ac3ecb$var$zt(t, e) {
    var n = e || '', r = t > 0 ? '-' : '+', a = Math.abs(t);
    return r + $d6e59866f4ac3ecb$var$St(Math.floor(a / 60), 2) + n + $d6e59866f4ac3ecb$var$St(a % 60, 2);
}
var $d6e59866f4ac3ecb$var$jt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $d6e59866f4ac3ecb$var$Kt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $d6e59866f4ac3ecb$var$Jt = /^'([^]*?)'?$/, $d6e59866f4ac3ecb$var$Zt = /''/g, $d6e59866f4ac3ecb$var$_t = /[a-zA-Z]/;
function $d6e59866f4ac3ecb$var$$t(t, e, n) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var r = String(e), a = n || {}, i = a.locale || $d6e59866f4ac3ecb$var$l, o = i.options && i.options.firstWeekContainsDate, u = null == o ? 1 : $d6e59866f4ac3ecb$var$f(o), s = null == a.firstWeekContainsDate ? u : $d6e59866f4ac3ecb$var$f(a.firstWeekContainsDate);
    if (!(s >= 1 && s <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var c = i.options && i.options.weekStartsOn, d = null == c ? 0 : $d6e59866f4ac3ecb$var$f(c), w = null == a.weekStartsOn ? d : $d6e59866f4ac3ecb$var$f(a.weekStartsOn);
    if (!(w >= 0 && w <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!i.localize) throw new RangeError('locale must contain localize property');
    if (!i.formatLong) throw new RangeError('locale must contain formatLong property');
    var v = $d6e59866f4ac3ecb$var$m(t);
    if (!$d6e59866f4ac3ecb$var$Ut(v)) throw new RangeError('Invalid time value');
    var y = $d6e59866f4ac3ecb$var$p(v), b = $d6e59866f4ac3ecb$var$g(v, y), T = {
        firstWeekContainsDate: s,
        weekStartsOn: w,
        locale: i,
        _originalDate: v
    }, k = r.match($d6e59866f4ac3ecb$var$Kt).map(function(t) {
        var e = t[0];
        return 'p' === e || 'P' === e ? (0, $d6e59866f4ac3ecb$var$D[e])(t, i.formatLong, T) : t;
    }).join('').match($d6e59866f4ac3ecb$var$jt).map(function(t) {
        if ("''" === t) return "'";
        var e = t[0];
        if ("'" === e) return $d6e59866f4ac3ecb$var$Vt(t);
        var n = $d6e59866f4ac3ecb$var$Xt[e];
        if (n) return !a.useAdditionalWeekYearTokens && $d6e59866f4ac3ecb$var$M(t) && $d6e59866f4ac3ecb$var$U(t), !a.useAdditionalDayOfYearTokens && $d6e59866f4ac3ecb$var$C(t) && $d6e59866f4ac3ecb$var$U(t), n(b, t, i.localize, T);
        if (e.match($d6e59866f4ac3ecb$var$_t)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + e + '`');
        return t;
    }).join('');
    return k;
}
function $d6e59866f4ac3ecb$var$Vt(t) {
    return t.match($d6e59866f4ac3ecb$var$Jt)[1].replace($d6e59866f4ac3ecb$var$Zt, "'");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $d6e59866f4ac3ecb$var$te(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$f(e);
    return isNaN(r) ? new Date(NaN) : r ? (n.setDate(n.getDate() + r), n) : n;
}
function $d6e59866f4ac3ecb$var$ee(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = t || {}, r = $d6e59866f4ac3ecb$var$m(n.start), a = $d6e59866f4ac3ecb$var$m(n.end), i = a.getTime();
    if (!(r.getTime() <= i)) throw new RangeError('Invalid interval');
    var o = [], u = r;
    u.setHours(0, 0, 0, 0);
    var s = e && 'step' in e ? Number(e.step) : 1;
    if (s < 1 || isNaN(s)) throw new RangeError('`options.step` must be a number greater than 1');
    for(; u.getTime() <= i;)o.push($d6e59866f4ac3ecb$var$m(u)), u.setDate(u.getDate() + s), u.setHours(0, 0, 0, 0);
    return o;
}
function $d6e59866f4ac3ecb$var$ne(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $d6e59866f4ac3ecb$var$f(a), o = null == n.weekStartsOn ? i : $d6e59866f4ac3ecb$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var u = $d6e59866f4ac3ecb$var$m(t), s = u.getDay(), c = 6 + (s < o ? -7 : 0) - (s - o);
    return u.setDate(u.getDate() + c), u.setHours(23, 59, 59, 999), u;
}
function $d6e59866f4ac3ecb$var$re(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$m(t);
    return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function $d6e59866f4ac3ecb$var$ae(t, e) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $d6e59866f4ac3ecb$var$f(a), o = null == n.weekStartsOn ? i : $d6e59866f4ac3ecb$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var u = $d6e59866f4ac3ecb$var$m(t), s = u.getDay(), c = (s < o ? 7 : 0) + s - o;
    return u.setDate(u.getDate() - c), u.setHours(0, 0, 0, 0), u;
}
function $d6e59866f4ac3ecb$export$fa1807b86c22c08c(t) {
    var e = void 0 === t ? {} : t, n = e.firstDayOfWeek, r = void 0 === n ? 1 : n, a = e.weekdayLabelFormat, i = void 0 === a ? function(t) {
        return $d6e59866f4ac3ecb$var$$t(t, 'iiiiii');
    } : a, o = new Date();
    return $d6e59866f4ac3ecb$var$ee({
        start: $d6e59866f4ac3ecb$var$te($d6e59866f4ac3ecb$var$ae(o), r),
        end: $d6e59866f4ac3ecb$var$te($d6e59866f4ac3ecb$var$ne(o), r)
    }).reduce(function(t, e) {
        return t.push(i(e)), t;
    }, []);
}
function $d6e59866f4ac3ecb$export$5f84d4e06c0693c4(t) {
    var e = t.year, n = t.month, r = t.firstDayOfWeek, a = void 0 === r ? 1 : r, i = t.dayLabelFormat, o = void 0 === i ? function(t) {
        return $d6e59866f4ac3ecb$var$$t(t, 'dd');
    } : i, u = new Date(e, n), s = $d6e59866f4ac3ecb$var$re(u), c = function(t) {
        $d6e59866f4ac3ecb$var$h(1, arguments);
        var e = $d6e59866f4ac3ecb$var$m(t), n = e.getDay();
        return n;
    }(s), d = function(t) {
        $d6e59866f4ac3ecb$var$h(1, arguments);
        var e = $d6e59866f4ac3ecb$var$m(t), n = e.getMonth();
        return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
    }(u);
    return function() {
        for(var t = 0, e = 0, n = arguments.length; e < n; e++)t += arguments[e].length;
        var r = Array(t), a = 0;
        for(e = 0; e < n; e++)for(var i = arguments[e], o = 0, u = i.length; o < u; o++, a++)r[a] = i[o];
        return r;
    }(Array.from(Array(c >= a ? c - a : 6 - a + c + 1).keys()).fill(0), $d6e59866f4ac3ecb$var$ee({
        start: s,
        end: d
    }).map(function(t) {
        return {
            date: t,
            dayLabel: o(t)
        };
    }));
}
var $d6e59866f4ac3ecb$export$ae8ce18f4c87a98d = function(t) {
    return $d6e59866f4ac3ecb$var$$t(t, 'dd');
}, $d6e59866f4ac3ecb$export$c91a7ea1bd918f41 = function(t) {
    return $d6e59866f4ac3ecb$var$$t(t, 'eeeeee');
}, $d6e59866f4ac3ecb$export$85e553ba2321487b = function(t) {
    return $d6e59866f4ac3ecb$var$$t(t, 'MMMM yyyy');
};
function $d6e59866f4ac3ecb$export$41527c87dc759868(e) {
    var n = e.year, r = e.month, a = e.firstDayOfWeek, i = void 0 === a ? 1 : a, o = e.dayLabelFormat, u = void 0 === o ? $d6e59866f4ac3ecb$export$ae8ce18f4c87a98d : o, s = e.weekdayLabelFormat, c = void 0 === s ? $d6e59866f4ac3ecb$export$c91a7ea1bd918f41 : s, d = e.monthLabelFormat, l = void 0 === d ? $d6e59866f4ac3ecb$export$85e553ba2321487b : d;
    return {
        days: (0, $9nZCP.useMemo)(function() {
            return $d6e59866f4ac3ecb$export$5f84d4e06c0693c4({
                year: n,
                month: r,
                firstDayOfWeek: i,
                dayLabelFormat: u
            });
        }, [
            n,
            r,
            i,
            u
        ]),
        weekdayLabels: (0, $9nZCP.useMemo)(function() {
            return $d6e59866f4ac3ecb$export$fa1807b86c22c08c({
                firstDayOfWeek: i,
                weekdayLabelFormat: c
            });
        }, [
            i,
            c
        ]),
        monthLabel: l(new Date(n, r))
    };
}
function $d6e59866f4ac3ecb$var$le(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$m(e);
    return n.getTime() < r.getTime();
}
function $d6e59866f4ac3ecb$var$fe(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$m(e);
    return n.getTime() > r.getTime();
}
function $d6e59866f4ac3ecb$var$he(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = e || {}, r = $d6e59866f4ac3ecb$var$m(t).getTime(), a = $d6e59866f4ac3ecb$var$m(n.start).getTime(), i = $d6e59866f4ac3ecb$var$m(n.end).getTime();
    if (!(a <= i)) throw new RangeError('Invalid interval');
    return r >= a && r <= i;
}
function $d6e59866f4ac3ecb$var$me(t) {
    $d6e59866f4ac3ecb$var$h(1, arguments);
    var e = $d6e59866f4ac3ecb$var$m(t);
    return e.setHours(0, 0, 0, 0), e;
}
function $d6e59866f4ac3ecb$var$we(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$me(t), r = $d6e59866f4ac3ecb$var$me(e);
    return n.getTime() === r.getTime();
}
function $d6e59866f4ac3ecb$var$ge(t, e) {
    $d6e59866f4ac3ecb$var$h(2, arguments);
    var n = $d6e59866f4ac3ecb$var$m(t), r = $d6e59866f4ac3ecb$var$f(e);
    if (isNaN(r)) return new Date(NaN);
    if (!r) return n;
    var a = n.getDate(), i = new Date(n.getTime());
    i.setMonth(n.getMonth() + r + 1, 0);
    var o = i.getDate();
    return a >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), a), n);
}
var $d6e59866f4ac3ecb$var$ve = function(t, e) {
    return void 0 === t && (t = []), t.some(function(t) {
        return $d6e59866f4ac3ecb$var$we(e, t);
    });
};
function $d6e59866f4ac3ecb$export$b165a5bc4ad10935(t, e, n) {
    return !(!e || !n) && $d6e59866f4ac3ecb$var$he(t, {
        start: e,
        end: n
    });
}
function $d6e59866f4ac3ecb$export$8260647f4936851e(t, e, n) {
    return !!(e && $d6e59866f4ac3ecb$var$we(t, e) || n && $d6e59866f4ac3ecb$var$we(t, n));
}
function $d6e59866f4ac3ecb$export$c8db6e7f6335237c(t, e) {
    return !(!e || !$d6e59866f4ac3ecb$var$we(t, e));
}
function $d6e59866f4ac3ecb$export$b3c72c1338a4197(t, e) {
    return !(!e || !$d6e59866f4ac3ecb$var$we(t, e));
}
function $d6e59866f4ac3ecb$export$757515830049c710(t) {
    var e = t.date, n = t.minBookingDate, r = t.maxBookingDate, a = t.isDateBlockedFn, i = t.startDate, o = t.endDate, u = t.minBookingDays, s = void 0 === u ? 1 : u, c = t.unavailableDates, d = void 0 === c ? [] : c, l = n ? new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0) : n, f = r ? new Date(r.getFullYear(), r.getMonth(), r.getDate(), 0, 0, 0) : r;
    return !!($d6e59866f4ac3ecb$var$ve(d, e) || l && $d6e59866f4ac3ecb$var$le(e, l) || f && $d6e59866f4ac3ecb$var$fe(e, f) || i && !o && s > 1 && $d6e59866f4ac3ecb$var$he(e, {
        start: i,
        end: $d6e59866f4ac3ecb$var$te(i, s - 2)
    }) || a && a(e));
}
function $d6e59866f4ac3ecb$export$3046c068c9f01601(t) {
    var e = $d6e59866f4ac3ecb$var$re(t);
    return {
        year: function(t) {
            $d6e59866f4ac3ecb$var$h(1, arguments);
            var e = $d6e59866f4ac3ecb$var$m(t), n = e.getFullYear();
            return n;
        }(e),
        month: function(t) {
            $d6e59866f4ac3ecb$var$h(1, arguments);
            var e = $d6e59866f4ac3ecb$var$m(t), n = e.getMonth();
            return n;
        }(e),
        date: e
    };
}
function $d6e59866f4ac3ecb$export$f446e9d44b503a48() {
    return $d6e59866f4ac3ecb$export$3046c068c9f01601($d6e59866f4ac3ecb$var$me(Date.now()));
}
function $d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(t, e) {
    var n = e ? $d6e59866f4ac3ecb$export$3046c068c9f01601(e) : $d6e59866f4ac3ecb$export$f446e9d44b503a48(), r = n.date, a = [
        n
    ];
    return t > 1 && (a = Array.from(Array(t - 1).keys()).reduce(function(t) {
        return r = $d6e59866f4ac3ecb$var$ge(t[t.length - 1].date, 1), t.concat([
            $d6e59866f4ac3ecb$export$3046c068c9f01601(r)
        ]);
    }, a)), a;
}
function $d6e59866f4ac3ecb$var$Me(t, e, n, r) {
    var a = t[r ? n > 0 ? 0 : t.length - r : n > 0 ? t.length - 1 : 0].date;
    return Array.from(Array(e).keys()).reduce(function(t) {
        return a = 0 === t.length ? $d6e59866f4ac3ecb$var$ge(a, n) : $d6e59866f4ac3ecb$var$ge(a, n >= 0 ? 1 : -1), n > 0 ? t.concat([
            $d6e59866f4ac3ecb$export$3046c068c9f01601(a)
        ]) : [
            $d6e59866f4ac3ecb$export$3046c068c9f01601(a)
        ].concat(t);
    }, []);
}
function $d6e59866f4ac3ecb$export$c5e4b84d2ce61726(t, e, n) {
    return t && 'string' == typeof e ? $d6e59866f4ac3ecb$var$$t(t, e) : t && 'function' == typeof e ? e(t) : n;
}
function $d6e59866f4ac3ecb$var$Se(t) {
    var e = t.startDate, n = t.endDate, r = t.isDateBlocked, a = t.minBookingDays, i = t.exactMinBookingDays, o = t.minBookingDate, u = t.maxBookingDate, s = !o || !$d6e59866f4ac3ecb$var$le(e, $d6e59866f4ac3ecb$var$te(o, -1)), c = !u || !$d6e59866f4ac3ecb$var$fe($d6e59866f4ac3ecb$var$te(e, a - 1), u);
    return !(!e || 1 !== a || n || r(e)) || (e && a > 1 && !n && !i || e && a > 0 && i && s && c || e && a > 0 && i && !o && !u ? !$d6e59866f4ac3ecb$var$ee({
        start: e,
        end: $d6e59866f4ac3ecb$var$te(e, a - 1)
    }).some(function(t) {
        return r(t);
    }) : !(!e || !n || i) && !$d6e59866f4ac3ecb$var$le(n, $d6e59866f4ac3ecb$var$te(e, a - 1)) && !$d6e59866f4ac3ecb$var$ee({
        start: e,
        end: n
    }).some(function(t) {
        return r(t);
    }));
}
var $d6e59866f4ac3ecb$export$99a467bcc22b8df9 = 'startDate', $d6e59866f4ac3ecb$export$1113b91e67d28ba7 = 'endDate';
function $d6e59866f4ac3ecb$export$2d9bfdb55c82a287(t) {
    var a = t.startDate, i = t.endDate, o = t.focusedInput, u = t.minBookingDate, s = t.maxBookingDate, c = t.onDatesChange, d = t.initialVisibleMonth, l = t.exactMinBookingDays, f = void 0 !== l && l, h = t.minBookingDays, m = void 0 === h ? 1 : h, w = t.numberOfMonths, g = void 0 === w ? 2 : w, v = t.firstDayOfWeek, y = void 0 === v ? 1 : v, b = t.isDateBlocked, D = void 0 === b ? function() {
        return !1;
    } : b, T = t.unavailableDates, p = void 0 === T ? [] : T, k = t.changeActiveMonthOnSelect, x = void 0 === k || k, C = (0, $9nZCP.useState)(function() {
        return $d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(g, a || d || null);
    }), M = C[0], U = C[1], S = (0, $9nZCP.useState)(null), P = S[0], E = S[1], Y = (0, $9nZCP.useState)(a), N = Y[0], q = Y[1];
    (0, $9nZCP.useEffect)(function() {
        return 'undefined' != typeof window && window.addEventListener && window.addEventListener('keydown', L), function() {
            window.removeEventListener && window.removeEventListener('keydown', L);
        };
    });
    var B = function(t) {
        return $d6e59866f4ac3ecb$var$ve(p, t) || D(t);
    }, O = function(t) {
        q(t), (!N || N && !$d6e59866f4ac3ecb$var$we(t, N)) && U($d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(g, t));
    }, H = function(t) {
        return $d6e59866f4ac3ecb$export$757515830049c710({
            date: t,
            minBookingDate: u,
            maxBookingDate: s,
            startDate: a,
            endDate: i,
            minBookingDays: m,
            isDateBlockedFn: B
        });
    };
    function L(t) {
        if (('ArrowRight' === t.key || 'ArrowLeft' === t.key || 'ArrowDown' === t.key || 'ArrowUp' === t.key) && !N) {
            var e = M[0];
            O(e.date), U($d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(g, e.date));
        }
    }
    var W = (0, $9nZCP.useCallback)(function() {
        U($d6e59866f4ac3ecb$var$Me(M, g, -1)), q(null);
    }, [
        M,
        g
    ]), F = (0, $9nZCP.useCallback)(function() {
        U($d6e59866f4ac3ecb$var$Me(M, g, -1, 1)), q(null);
    }, [
        M,
        g
    ]), Q = (0, $9nZCP.useCallback)(function() {
        U($d6e59866f4ac3ecb$var$Me(M, g, 1)), q(null);
    }, [
        M,
        g
    ]), R = (0, $9nZCP.useCallback)(function() {
        U($d6e59866f4ac3ecb$var$Me(M, g, 1, 1)), q(null);
    }, [
        M,
        g
    ]), I = (0, $9nZCP.useCallback)(function(t) {
        U($d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(g, t)), q(null);
    }, [
        g
    ]), X = (0, $9nZCP.useCallback)(function(t) {
        void 0 === t && (t = 1), U($d6e59866f4ac3ecb$var$Me(M, g, -(12 * t - g + 1))), q(null);
    }, [
        M,
        g
    ]), G = (0, $9nZCP.useCallback)(function(t) {
        void 0 === t && (t = 1), U($d6e59866f4ac3ecb$var$Me(M, g, 12 * t - g + 1)), q(null);
    }, [
        M,
        g
    ]);
    return {
        firstDayOfWeek: y,
        activeMonths: M,
        isDateSelected: function(t) {
            return $d6e59866f4ac3ecb$export$b165a5bc4ad10935(t, a, i);
        },
        isDateHovered: function(t) {
            return function(t) {
                var e = t.date, n = t.startDate, r = t.endDate, a = t.isDateBlocked, i = t.hoveredDate, o = t.minBookingDays, u = t.exactMinBookingDays;
                return i && o > 1 && u && $d6e59866f4ac3ecb$var$he(e, {
                    start: i,
                    end: $d6e59866f4ac3ecb$var$te(i, o - 1)
                }) ? !$d6e59866f4ac3ecb$var$ee({
                    start: i,
                    end: $d6e59866f4ac3ecb$var$te(i, o - 1)
                }).some(function(t) {
                    return a(t);
                }) : n && !r && i && $d6e59866f4ac3ecb$var$he(e, {
                    start: n,
                    end: $d6e59866f4ac3ecb$var$te(n, o - 1)
                }) && $d6e59866f4ac3ecb$var$we(n, i) && o > 1 ? !$d6e59866f4ac3ecb$var$ee({
                    start: n,
                    end: $d6e59866f4ac3ecb$var$te(n, o - 1)
                }).some(function(t) {
                    return a(t);
                }) : !(!n || r || !i || $d6e59866f4ac3ecb$var$le(i, n) || !$d6e59866f4ac3ecb$var$he(e, {
                    start: n,
                    end: i
                })) && !$d6e59866f4ac3ecb$var$ee({
                    start: n,
                    end: i
                }).some(function(t) {
                    return a(t);
                });
            }({
                date: t,
                hoveredDate: P,
                startDate: a,
                endDate: i,
                minBookingDays: m,
                exactMinBookingDays: f,
                isDateBlocked: B
            });
        },
        isFirstOrLastSelectedDate: function(t) {
            return $d6e59866f4ac3ecb$export$8260647f4936851e(t, a, i);
        },
        isStartDate: function(t) {
            return $d6e59866f4ac3ecb$export$c8db6e7f6335237c(t, a);
        },
        isEndDate: function(t) {
            return $d6e59866f4ac3ecb$export$b3c72c1338a4197(t, i);
        },
        isDateBlocked: H,
        numberOfMonths: g,
        isDateFocused: function(t) {
            return !!N && $d6e59866f4ac3ecb$var$we(t, N);
        },
        focusedDate: N,
        hoveredDate: P,
        onResetDates: function() {
            c({
                startDate: null,
                endDate: null,
                focusedInput: 'startDate'
            });
        },
        onDateHover: function(t) {
            if (t) {
                if (t) {
                    var e = !H(t) || a && $d6e59866f4ac3ecb$var$we(t, a), n = !u || !$d6e59866f4ac3ecb$var$le(t, $d6e59866f4ac3ecb$var$te(u, -1)), r = !s || !$d6e59866f4ac3ecb$var$fe(t, s), o = $d6e59866f4ac3ecb$var$te(t, m - 1), c = !u || !$d6e59866f4ac3ecb$var$le(o, u), d = !s || !$d6e59866f4ac3ecb$var$fe(o, s), l = f && m > 1 && n && r && c && d, h = a && !i && !f && n && r, w = !(m > 1 && a) || $d6e59866f4ac3ecb$var$he(t, {
                        start: a,
                        end: $d6e59866f4ac3ecb$var$te(a, m - 2)
                    }), g = a && $d6e59866f4ac3ecb$var$we(t, a) && w;
                    e && (l || h || g) ? E(t) : null !== P && E(null);
                }
            } else E(null);
        },
        onDateSelect: function(t) {
            ('endDate' === o || 'startDate' === o) && m > 0 && f && $d6e59866f4ac3ecb$var$Se({
                minBookingDays: m,
                exactMinBookingDays: f,
                minBookingDate: u,
                maxBookingDate: s,
                isDateBlocked: B,
                startDate: t,
                endDate: null
            }) ? c({
                startDate: t,
                endDate: $d6e59866f4ac3ecb$var$te(t, m - 1),
                focusedInput: null
            }) : ('endDate' === o && a && $d6e59866f4ac3ecb$var$le(t, a) || 'startDate' === o && i && $d6e59866f4ac3ecb$var$fe(t, i)) && !f && $d6e59866f4ac3ecb$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                startDate: t,
                endDate: null
            }) ? c({
                endDate: null,
                startDate: t,
                focusedInput: 'endDate'
            }) : 'startDate' === o && !f && $d6e59866f4ac3ecb$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                endDate: i,
                startDate: t
            }) ? c({
                endDate: i,
                startDate: t,
                focusedInput: 'endDate'
            }) : 'startDate' === o && !f && $d6e59866f4ac3ecb$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                endDate: null,
                startDate: t
            }) ? c({
                endDate: null,
                startDate: t,
                focusedInput: 'endDate'
            }) : 'endDate' === o && a && !$d6e59866f4ac3ecb$var$le(t, a) && !f && $d6e59866f4ac3ecb$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                startDate: a,
                endDate: t
            }) && c({
                startDate: a,
                endDate: t,
                focusedInput: null
            }), 'endDate' !== o && (!N || N && !$d6e59866f4ac3ecb$var$we(t, N)) && x && U($d6e59866f4ac3ecb$export$6b0a3e73eaccfee4(g, t));
        },
        onDateFocus: O,
        goToPreviousMonths: W,
        goToPreviousMonthsByOneMonth: F,
        goToNextMonths: Q,
        goToNextMonthsByOneMonth: R,
        goToDate: I,
        goToPreviousYear: X,
        goToNextYear: G
    };
}
function $d6e59866f4ac3ecb$export$1937086c6b64f72d(t) {
    var e = t.date, n = t.focusedDate, a = t.isDateSelected, i = t.isDateFocused, o = t.isFirstOrLastSelectedDate, u = t.isDateHovered, s = t.isDateBlocked, c = t.onDateSelect, d = t.onDateFocus, l = t.onDateHover, f = (0, $9nZCP.useCallback)(function() {
        return c(e);
    }, [
        e,
        c
    ]), h = (0, $9nZCP.useCallback)(function() {
        return l(e);
    }, [
        e,
        l
    ]), m = s(e) && !u(e);
    return {
        tabIndex: null === n || i(e) ? 0 : -1,
        isSelected: a(e),
        isSelectedStartOrEnd: o(e),
        isWithinHoverRange: u(e),
        disabledDate: m,
        onKeyDown: function(t) {
            'ArrowRight' === t.key ? d($d6e59866f4ac3ecb$var$te(e, 1)) : 'ArrowLeft' === t.key ? d($d6e59866f4ac3ecb$var$te(e, -1)) : 'ArrowUp' === t.key ? d($d6e59866f4ac3ecb$var$te(e, -7)) : 'ArrowDown' === t.key && d($d6e59866f4ac3ecb$var$te(e, 7));
        },
        onClick: m ? function() {} : f,
        onMouseEnter: h
    };
}


function $48090fca70e3183a$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $48090fca70e3183a$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Accordion", function() {
    return $48090fca70e3183a$var$$906ee81c6c1db5eb$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "CustomAccordion", function() {
    return $48090fca70e3183a$var$$81cddd8d5c3e47e4$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Button", function() {
    return $48090fca70e3183a$var$$2987665db72ba3c1$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Card", function() {
    return $48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Box", function() {
    return $48090fca70e3183a$var$$476168fcb44518cc$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "DisplayLarge", function() {
    return $48090fca70e3183a$var$$ec746cba4029e202$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "DisplayIcon", function() {
    return $48090fca70e3183a$var$$e0180679e35f2273$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "DisplaySmall", function() {
    return $48090fca70e3183a$var$$d98b0fa15808b520$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "DropdownSelect", function() {
    return $48090fca70e3183a$var$$69ead81f7adc490a$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "DropdownCascader", function() {
    return $48090fca70e3183a$var$$d8e895830981b43b$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Field", function() {
    return $48090fca70e3183a$var$$2677d04b7028c72d$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Searchbar", function() {
    return $48090fca70e3183a$var$$aa6f4c7dc0f5685c$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Textarea", function() {
    return $48090fca70e3183a$var$$870ba58bccab6eec$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Slider", function() {
    return $48090fca70e3183a$var$$409b8f5f63cd4acf$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "FileUploader", function() {
    return $48090fca70e3183a$var$$eab617fde0d2a814$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Datepicker", function() {
    return $48090fca70e3183a$var$$1d445195934320ed$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Radio", function() {
    return $48090fca70e3183a$var$$86e1d79a67710eda$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Checkbox", function() {
    return $48090fca70e3183a$var$$b679852ecf8e9c02$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Switch", function() {
    return $48090fca70e3183a$var$$34871b0f15f7c161$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "AlertMessage", function() {
    return $48090fca70e3183a$var$$d963730b715e990c$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "PushMessage", function() {
    return $48090fca70e3183a$var$$cadd1c9c3bca1fc9$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "CompactPagination", function() {
    return $48090fca70e3183a$var$$831351fb15d68ad0$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "StandardPagination", function() {
    return $48090fca70e3183a$var$$60c375d8d52bb6d6$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Tabs", function() {
    return $48090fca70e3183a$var$$35a1a5ac66949050$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Breadcrumb", function() {
    return $48090fca70e3183a$var$$a6857e6cae2f9c5f$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "LinearProgress", function() {
    return $48090fca70e3183a$var$$8688d42e9f1d381a$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "CircularProgress", function() {
    return $48090fca70e3183a$var$$e09296aea30ed10d$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Steps", function() {
    return $48090fca70e3183a$var$$250cfcb8116ed97e$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Timeline", function() {
    return $48090fca70e3183a$var$$c3e303edb7751c77$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "CustomTimeline", function() {
    return $48090fca70e3183a$var$$a3f868921843a442$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Tag", function() {
    return $48090fca70e3183a$var$$4c05722f1abfb34c$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Tooltip", function() {
    return $48090fca70e3183a$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "ScrollbarContainer", function() {
    return $48090fca70e3183a$var$$b252c20c2dedb54c$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "Copiable", function() {
    return $48090fca70e3183a$var$$f9cf7fe05b87a0bc$export$2e2bcd8739ae039;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "lightTheme", function() {
    return $48090fca70e3183a$var$$18386f08588a981e$export$f30cb9bc4f736419;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "darkTheme", function() {
    return $48090fca70e3183a$var$$18386f08588a981e$export$3e936a8db52a10a0;
});
$48090fca70e3183a$var$$parcel$export($48090fca70e3183a$exports, "veaTheme", function() {
    return $48090fca70e3183a$var$$18386f08588a981e$export$a183395ddd946500;
});
function $48090fca70e3183a$var$$e1b614a35dc83093$export$683480f191c0e3ea(element, callback) {
    (0, $9nZCP.useLayoutEffect)(()=>{
        if (!element) return;
        const observer = new ResizeObserver((entries)=>{
            callback(element, entries[0]);
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        callback,
        element
    ]);
}
var $48090fca70e3183a$var$$e1b614a35dc83093$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$e1b614a35dc83093$export$683480f191c0e3ea;
function $48090fca70e3183a$var$$2592152d06a7ba66$export$2b86bedf890eab8() {
    // Mutable values like 'ref.current' aren't valid dependencies
    // because mutating them doesn't re-render the component.
    // Instead, we use a state as a ref to be reactive.
    const [ref, setRef] = (0, $9nZCP.useState)(null);
    const [size, setSize] = (0, $9nZCP.useState)({
        width: 0,
        height: 0
    });
    // Prevent too many rendering using useCallback
    const handleSize = (0, $9nZCP.useCallback)(()=>{
        setSize({
            width: ref?.offsetWidth || 0,
            height: ref?.offsetHeight || 0
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth
    ]);
    (0, $4e705cd33f69a99b$export$7080b3e976bc91ab)("resize", handleSize);
    (0, $4e705cd33f69a99b$export$700979bc83e7db82)(()=>{
        handleSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth
    ]);
    $48090fca70e3183a$var$$e1b614a35dc83093$export$683480f191c0e3ea(ref, handleSize);
    return [
        setRef,
        size
    ];
}
var $48090fca70e3183a$var$$2592152d06a7ba66$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2592152d06a7ba66$export$2b86bedf890eab8;
const $48090fca70e3183a$var$$f15a4f5132e5ea52$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            clipRule: "evenodd",
            d: "M8.697 0H7.302c-.124 0-.186.06-.186.178v6.977H.186c-.124 0-.186.06-.186.178v1.334c0 .118.062.177.186.177h6.93v6.978c0 .119.062.178.186.178h1.395c.124 0 .186-.06.186-.178V8.844h6.931c.124 0 .186-.059.186-.177V7.333c0-.118-.062-.178-.186-.178h-6.93V.178C8.883.059 8.82 0 8.696 0Z"
        })
    });
var $48090fca70e3183a$var$$f15a4f5132e5ea52$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$f15a4f5132e5ea52$var$SvgPlus;
const $48090fca70e3183a$var$$ed272acf889bf255$var$SvgMinus = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M15.826.333H.174A.174.174 0 0 0 0 .507v1.305c0 .095.078.174.174.174h15.652A.174.174 0 0 0 16 1.812V.507a.174.174 0 0 0-.174-.174Z"
        })
    });
var $48090fca70e3183a$var$$ed272acf889bf255$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$ed272acf889bf255$var$SvgMinus;
const $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30 = (styleFn)=>(0, $1d9bd5c523349ec4$exports.css)([
        "@media (max-width:900px){",
        "}"
    ], styleFn());
const $48090fca70e3183a$var$$49a276e58256b44f$export$448e4850cad7c7b0 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-size:24px;font-weight:600;line-height:33px;margin:0;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b = (0, $1d9bd5c523349ec4$exports.css)([
    "font-size:16px;font-weight:600;line-height:22px;margin:0;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-size:16px;font-weight:400;line-height:22px;margin:0;color:",
    ";overflow-wrap:break-word;"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-size:14px;font-weight:400;line-height:19px;margin:0;color:",
    ";overflow-wrap:break-word;"
], ({ theme: theme })=>theme.klerosUIComponentsSecondaryText);
const $48090fca70e3183a$var$$49a276e58256b44f$export$b4adb3f464574dcf = (0, $1d9bd5c523349ec4$exports.css)([
    "opacity:1;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68 = (0, $1d9bd5c523349ec4$exports.css)([
    "display:inline-block;vertical-align:middle;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$463b44d9bf3628be = (0, $1d9bd5c523349ec4$exports.css)([
    "display:inline-block;vertical-align:middle;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;overflow:visible;text-transform:none;-webkit-appearance:button;:hover:enabled{cursor:pointer;}"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$b7e3ae3d7c15e42e = (0, $1d9bd5c523349ec4$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;overflow:visible;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$b9d336f245a516e8 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$2e6c959c16ff56b8 = (0, $1d9bd5c523349ec4$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;text-transform:none;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$a3574df893ffa88d = (0, $1d9bd5c523349ec4$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;"
]);
const $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26 = (0, $1d9bd5c523349ec4$exports.css)([
    "box-sizing:border-box;*,*:before,*:after{box-sizing:border-box;}"
]);
const $48090fca70e3183a$var$$33bd37d24f01bb71$var$StyledDiv = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "accordion-item__StyledDiv",
    componentId: "sc-17yp2l-0"
})([
    "margin:8px 0px;.accordion-button{",
    " width:100%;background:",
    ";border-radius:3px;padding:11.5px 32px;display:flex;justify-content:space-between;align-items:center;.accordion-svg{",
    " height:16px;width:16px;fill:",
    ";}}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsPrimaryPurple, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsLightPurple);
const $48090fca70e3183a$var$$33bd37d24f01bb71$var$Collapsible = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "accordion-item__Collapsible",
    componentId: "sc-17yp2l-1"
})([
    "height:",
    "px;overflow:",
    ";transition:height ease ",
    ";"
], (props)=>props.expanded ? props.totalHeight.toString() : "0", (props)=>props.expanded ? "visible" : "hidden", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $48090fca70e3183a$var$$33bd37d24f01bb71$var$Body = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "accordion-item__Body",
    componentId: "sc-17yp2l-2"
})([
    "padding:32px;"
]);
const $48090fca70e3183a$var$$33bd37d24f01bb71$var$AccordionItem = ({ title: title, body: body, index: index, expanded: expanded, setExpanded: setExpanded })=>{
    const [ref, { height: height }] = $48090fca70e3183a$var$$2592152d06a7ba66$export$2b86bedf890eab8();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$33bd37d24f01bb71$var$StyledDiv, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("button", {
                className: "accordion-button",
                onClick: ()=>setExpanded(expanded ? -1 : index),
                children: [
                    title,
                    expanded ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ed272acf889bf255$export$2e2bcd8739ae039, {
                        className: "accordion-svg"
                    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$f15a4f5132e5ea52$export$2e2bcd8739ae039, {
                        className: "accordion-svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$33bd37d24f01bb71$var$Collapsible, {
                expanded: expanded,
                totalHeight: height,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$33bd37d24f01bb71$var$Body, {
                    ref: ref,
                    children: [
                        " ",
                        body,
                        " "
                    ]
                })
            })
        ]
    });
};
var $48090fca70e3183a$var$$33bd37d24f01bb71$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$33bd37d24f01bb71$var$AccordionItem;
const $48090fca70e3183a$var$$906ee81c6c1db5eb$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "accordion__Wrapper",
    componentId: "sc-7o1u6g-0"
})([
    "",
    " display:flex;flex-direction:column;width:1000px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$906ee81c6c1db5eb$var$AccordionTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "accordion__AccordionTitle",
    componentId: "sc-7o1u6g-1"
})([
    "",
    " width:fit-content;font-weight:600;text-align:center;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ theme: theme })=>theme.klerosUIComponentsLightPurple);
const $48090fca70e3183a$var$$906ee81c6c1db5eb$var$DefaultTitle = ({ item: item })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($dde41420777b5d34$exports.Fragment, {
        children: [
            item.icon ?? (item.Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(item.Icon, {})),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$906ee81c6c1db5eb$var$AccordionTitle, {
                children: item.title
            })
        ]
    });
const $48090fca70e3183a$var$$906ee81c6c1db5eb$var$Accordion = ({ items: items, defaultExpanded: defaultExpanded, ...props })=>{
    const [expanded, setExpanded] = (0, $9nZCP.useState)(defaultExpanded ?? -1);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$906ee81c6c1db5eb$var$Wrapper, {
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$33bd37d24f01bb71$export$2e2bcd8739ae039, {
                index: index,
                title: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$906ee81c6c1db5eb$var$DefaultTitle, {
                    item: item
                }),
                body: item.body,
                setExpanded: setExpanded,
                expanded: expanded === index
            }, index))
    });
};
var $48090fca70e3183a$var$$906ee81c6c1db5eb$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$906ee81c6c1db5eb$var$Accordion;
const $48090fca70e3183a$var$$81cddd8d5c3e47e4$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "custom__Wrapper",
    componentId: "sc-dc5dy3-0"
})([
    "",
    " display:flex;flex-direction:column;width:1000px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$81cddd8d5c3e47e4$var$CustomAccordion = ({ items: items, ...props })=>{
    const [expanded, setExpanded] = (0, $9nZCP.useState)(-1);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$81cddd8d5c3e47e4$var$Wrapper, {
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$33bd37d24f01bb71$export$2e2bcd8739ae039, {
                index: index,
                title: item.title,
                body: item.body,
                setExpanded: setExpanded,
                expanded: expanded === index
            }, index))
    });
};
var $48090fca70e3183a$var$$81cddd8d5c3e47e4$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$81cddd8d5c3e47e4$var$CustomAccordion;
const $48090fca70e3183a$var$$85dbc8aeed51bed3$var$breathing = (0, $1d9bd5c523349ec4$exports.keyframes)([
    "0%{transform:scale(1);}50%{transform:scale(1.3);}100%{transform:scale(1);}"
]);
const $48090fca70e3183a$var$$85dbc8aeed51bed3$var$BaseButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "base__BaseButton",
    componentId: "sc-15fqe1k-0"
})([
    "",
    " ",
    " position:relative;width:fit-content;height:fit-content;display:flex;flex-direction:row;justify-content:center;align-items:center;padding:",
    ";border-radius:3px;border:none;transition:background ease ",
    ";.button-text{",
    " ",
    " font-weight:600;text-align:center;white-space:pre;}.button-svg{",
    " ",
    " height:16px;width:16px;margin-right:8px;}.button-loading{position:absolute;height:22px;fill:",
    ";animation:",
    " 2s ease-out infinite normal;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>{
    if (props.small) return props.variant === "secondary" ? "5px 23px" : "6px 24px";
    return props.variant === "secondary" ? "10.5px 31px" : "11.5px 32px";
}, (props)=>props.theme.klerosUIComponentsTransitionSpeed, $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ isLoading: isLoading })=>isLoading && "visibility: hidden;", $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ isLoading: isLoading })=>isLoading && "visibility: hidden;", ({ theme: theme })=>theme.klerosUIComponentsStroke, $48090fca70e3183a$var$$85dbc8aeed51bed3$var$breathing);
var $48090fca70e3183a$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$85dbc8aeed51bed3$var$BaseButton;
const $48090fca70e3183a$var$$64030e1eefd54f6b$var$PrimaryButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "primary__PrimaryButton",
    componentId: "sc-1cfrthg-0"
})([
    "background:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsSecondaryBlue);
var $48090fca70e3183a$var$$64030e1eefd54f6b$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$64030e1eefd54f6b$var$PrimaryButton;
const $48090fca70e3183a$var$$e015af9dc133eba5$var$SecondaryButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "secondary__SecondaryButton",
    componentId: "sc-urt0vi-0"
})([
    "background:",
    ";border:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? `1px solid ${props.theme.klerosUIComponentsStroke}` : `1px solid ${props.theme.klerosUIComponentsPrimaryBlue}`, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsMediumBlue);
var $48090fca70e3183a$var$$e015af9dc133eba5$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$e015af9dc133eba5$var$SecondaryButton;
const $48090fca70e3183a$var$$a028db5d769593a3$var$TertiaryButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "tertiary__TertiaryButton",
    componentId: "sc-jvmd2g-0"
})([
    "background:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.theme.klerosUIComponentsSecondaryPurple, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsPrimaryPurple);
var $48090fca70e3183a$var$$a028db5d769593a3$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a028db5d769593a3$var$TertiaryButton;
const $48090fca70e3183a$var$$c65a9c2fdb9de77b$var$SvgKleros = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 46 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "m14.545 3.992 21.06.94 8.526 18.92L32.1 41.143 10.929 39.79l-8.68-20.5L14.544 3.993Zm15.44 10.906-15.263 6.66L27.77 31.634l2.214-16.736Zm-1.768-3.337L16.02 6.316l-2.562 11.028 14.76-5.783Zm-3.091 22.608-13.257-9.454.321 12.81 12.936-3.356ZM42.013 23.81l-9.033-9.154-2.384 17.604 11.417-8.45Zm-13.78 12.418-11.18 2.918 13.148.84-1.967-3.758Zm12.015-8.264-9.786 7.28 1.944 3.796 7.842-11.076Zm-4.63-20.388-1.9 3.897 7.075 7.182-5.174-11.08ZM33.252 5.71l-12.424-.504 10.248 4.477 2.176-3.973ZM12.73 7.513 4.028 18.487l5.819 1.23L12.73 7.514ZM9.496 21.871 3.65 20.635l6.1 14.352-.254-13.116Z"
        })
    });
var $48090fca70e3183a$var$$c65a9c2fdb9de77b$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$c65a9c2fdb9de77b$var$SvgKleros;
const $48090fca70e3183a$var$$2987665db72ba3c1$var$Button = ({ text: text, variant: variant, Icon: Icon, icon: icon, onClick: onClick, isLoading: isLoading, ...props })=>{
    let ButtonType = $48090fca70e3183a$var$$64030e1eefd54f6b$export$2e2bcd8739ae039;
    if (variant === "secondary") ButtonType = $48090fca70e3183a$var$$e015af9dc133eba5$export$2e2bcd8739ae039;
    if (variant === "tertiary") ButtonType = $48090fca70e3183a$var$$a028db5d769593a3$export$2e2bcd8739ae039;
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)(ButtonType, {
        variant: variant,
        onClick: onClick,
        isLoading: isLoading,
        ...props,
        children: [
            isLoading && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c65a9c2fdb9de77b$export$2e2bcd8739ae039, {
                className: "button-loading"
            }),
            icon ?? (Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                className: "button-svg"
            })),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("p", {
                className: "button-text",
                children: text
            })
        ]
    });
};
var $48090fca70e3183a$var$$2987665db72ba3c1$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2987665db72ba3c1$var$Button;
const $48090fca70e3183a$var$$48087ec110ef8615$var$Card = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "card__Card",
    componentId: "sc-1g2jfm3-0"
})([
    "",
    " background:",
    ";border:1px solid ",
    ";box-shadow:0px 2px 3px ",
    ";border-radius:",
    ";width:328px;height:200px;transition:box-shadow ease ",
    ";",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsDefaultShadow, ({ round: round })=>round ? "18px" : "3px", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme, hover: hover })=>hover && `
      :hover {
        box-shadow: 0px 6px 9px ${theme.klerosUIComponentsHoveredShadow};
        cursor: pointer;
      }
  `);
var $48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$48087ec110ef8615$var$Card;
const $48090fca70e3183a$var$$476168fcb44518cc$var$Box = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "box__Box",
    componentId: "sc-1by74ub-0"
})([
    "",
    " background:",
    ";border-radius:18px;width:328px;height:200px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue);
var $48090fca70e3183a$var$$476168fcb44518cc$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$476168fcb44518cc$var$Box;
const $48090fca70e3183a$var$$ec746cba4029e202$var$StyledCard = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "large__StyledCard",
    componentId: "sc-1f0y32e-0"
})([
    "position:relative;height:80px;width:288px;padding:16px;display:flex;flex-direction:column;align-items:start;justify-content:center;.display-icon{",
    " position:absolute;top:16px;right:16px;max-height:16px;max-width:16px;}.display-text{",
    "}.display-label{",
    "}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $48090fca70e3183a$var$$49a276e58256b44f$export$448e4850cad7c7b0, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $48090fca70e3183a$var$$ec746cba4029e202$var$DisplayLarge = ({ text: text, Icon: Icon, label: label, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$ec746cba4029e202$var$StyledCard, {
        ...props,
        children: [
            Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                className: "display-icon"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("h1", {
                className: "display-text",
                children: text
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                className: "display-label",
                children: label
            })
        ]
    });
var $48090fca70e3183a$var$$ec746cba4029e202$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$ec746cba4029e202$var$DisplayLarge;
const $48090fca70e3183a$var$$e0180679e35f2273$var$StyledCard = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "icon__StyledCard",
    componentId: "sc-12ixf6j-0"
})([
    "height:80px;width:288px;padding:16px;display:flex;"
]);
const $48090fca70e3183a$var$$e0180679e35f2273$var$Text = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "icon__Text",
    componentId: "sc-12ixf6j-1"
})([
    "",
    " height:100%;width:auto;margin-left:16px;flex-direction:column;align-items:start;justify-content:center;.display-text{",
    "}.display-label{",
    "}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$448e4850cad7c7b0, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $48090fca70e3183a$var$$e0180679e35f2273$var$IconCard = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "icon__IconCard",
    componentId: "sc-12ixf6j-2"
})([
    "height:48px;width:48px;display:flex;justify-content:center;align-items:center;.display-icon{",
    " max-height:32px;max-width:32px;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$e0180679e35f2273$var$DisplayIcon = ({ text: text, Icon: Icon, label: label, ...props })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$e0180679e35f2273$var$StyledCard, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$e0180679e35f2273$var$IconCard, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                    className: "display-icon"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$e0180679e35f2273$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("h1", {
                        className: "display-text",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                        className: "display-label",
                        children: label
                    })
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$e0180679e35f2273$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$e0180679e35f2273$var$DisplayIcon;
const $48090fca70e3183a$var$$d98b0fa15808b520$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "small__Wrapper",
    componentId: "sc-ismyqd-0"
})([
    "",
    " width:217px;display:flex;flex-direction:column;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$d98b0fa15808b520$var$StyledLabel = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "small__StyledLabel",
    componentId: "sc-ismyqd-1"
})([
    "",
    " color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$d98b0fa15808b520$var$StyledCard = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "small__StyledCard",
    componentId: "sc-ismyqd-2"
})([
    "height:45px;width:100%;margin-top:16px;display:flex;align-items:center;padding:0px 16px;.display-icon{",
    " max-height:16px;max-width:16px;margin-right:8px;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$d98b0fa15808b520$var$StyledText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "small__StyledText",
    componentId: "sc-ismyqd-3"
})([
    "",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $48090fca70e3183a$var$$d98b0fa15808b520$var$DisplaySmall = ({ text: text, Icon: Icon, label: label, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d98b0fa15808b520$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d98b0fa15808b520$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d98b0fa15808b520$var$StyledCard, {
                children: [
                    Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                        className: "display-icon"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d98b0fa15808b520$var$StyledText, {
                        children: text
                    })
                ]
            })
        ]
    });
var $48090fca70e3183a$var$$d98b0fa15808b520$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d98b0fa15808b520$var$DisplaySmall;
//! type
//eslint-disable-next-line @typescript-eslint/ban-types
function $48090fca70e3183a$var$$bfcc265ae6655ec9$var$useFocusOutside(ref, callback) {
    (0, $9nZCP.useEffect)(()=>{
        function handleEvent(event) {
            if (ref.current && !ref.current.contains(event.target)) callback();
        }
        document.addEventListener("focusin", handleEvent);
        document.addEventListener("mousedown", handleEvent);
        return ()=>{
            document.removeEventListener("focusin", handleEvent);
            document.removeEventListener("mousedown", handleEvent);
        };
    }, [
        ref,
        callback
    ]);
}
var $48090fca70e3183a$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$bfcc265ae6655ec9$var$useFocusOutside;
const $48090fca70e3183a$var$$a4b0ebb54b8823c5$var$SvgArrow = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 12 8",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M11.598.25H.402C.067.25-.121.605.087.847l5.598 6.49c.16.186.468.186.63 0l5.598-6.49c.208-.242.02-.597-.316-.597Z"
        })
    });
var $48090fca70e3183a$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a4b0ebb54b8823c5$var$SvgArrow;
const $48090fca70e3183a$var$$43d9fcbe58645246$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "button__Container",
    componentId: "sc-wywpa8-0"
})([
    "",
    " ",
    " width:240px;background:",
    ";border:1px solid ",
    ";border-radius:3px;display:flex;align-items:center;justify-content:space-between;padding:0px 16px 0px 0px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$43d9fcbe58645246$var$StyledArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)(({ ignoredIsOpen: ignoredIsOpen, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039, {
        ...props
    })).withConfig({
    displayName: "button__StyledArrow",
    componentId: "sc-wywpa8-1"
})([
    "",
    " width:16px;height:16px;fill:",
    ";",
    " transition:transform ease ",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ ignoredIsOpen: ignoredIsOpen })=>ignoredIsOpen && (0, $1d9bd5c523349ec4$exports.css)([
        "transform:rotate(180deg);"
    ]), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $48090fca70e3183a$var$$43d9fcbe58645246$var$DropdownButton = ({ node: node, isOpen: isOpen, setIsOpen: setIsOpen, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$43d9fcbe58645246$var$Container, {
        onClick: ()=>setIsOpen(!isOpen),
        ...props,
        children: [
            node,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$43d9fcbe58645246$var$StyledArrow, {
                ignoredIsOpen: isOpen,
                ...props
            })
        ]
    });
var $48090fca70e3183a$var$$43d9fcbe58645246$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$43d9fcbe58645246$var$DropdownButton;
const $48090fca70e3183a$var$$83ebe14398e57e2d$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "simple-button__Container",
    componentId: "sc-rpqfxz-0"
})([
    "",
    " ",
    " background:none;display:flex;align-items:center;padding:0px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledSmallText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "simple-button__StyledSmallText",
    componentId: "sc-rpqfxz-1"
})([
    "",
    " font-weight:600;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledBigText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h1.withConfig({
    displayName: "simple-button__StyledBigText",
    componentId: "sc-rpqfxz-2"
})([
    "",
    " font-weight:600;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$448e4850cad7c7b0, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)(({ ignoredIsOpen: ignoredIsOpen, ignoredSmall: ignoredSmall, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039, {
        ...props
    })).withConfig({
    displayName: "simple-button__StyledArrow",
    componentId: "sc-rpqfxz-3"
})([
    "",
    " width:",
    "px;height:",
    "px;fill:",
    ";",
    " transition:transform ease ",
    ";margin-left:8px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ ignoredSmall: small })=>small ? "8" : "16", ({ ignoredSmall: small })=>small ? "8" : "16", ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ ignoredIsOpen: isOpen })=>isOpen && (0, $1d9bd5c523349ec4$exports.css)([
        "transform:rotate(180deg);"
    ]), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $48090fca70e3183a$var$$83ebe14398e57e2d$var$DropdownButton = ({ text: text, isOpen: isOpen, setIsOpen: setIsOpen, small: small, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$83ebe14398e57e2d$var$Container, {
        onClick: ()=>setIsOpen(!isOpen),
        ...props,
        children: [
            small ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledSmallText, {
                children: text
            }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledBigText, {
                children: text
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$83ebe14398e57e2d$var$StyledArrow, {
                ignoredIsOpen: isOpen,
                ignoredSmall: small,
                ...props
            })
        ]
    });
var $48090fca70e3183a$var$$83ebe14398e57e2d$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$83ebe14398e57e2d$var$DropdownButton;
const $48090fca70e3183a$var$$b252c20c2dedb54c$var$CustomScrollbarContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$parcel$interopDefault($b76fad9a3dd6491d$exports)).withConfig({
    displayName: "scrollbar__CustomScrollbarContainer",
    componentId: "sc-16x8nkv-0"
})([
    "",
    " .simplebar-scrollbar:before{background:",
    ";}.simplebar-scrollbar.simplebar-visible:before{opacity:1;}.simplebar-mask{background:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
var $48090fca70e3183a$var$$b252c20c2dedb54c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$b252c20c2dedb54c$var$CustomScrollbarContainer;
const $48090fca70e3183a$var$$4fc41d5788d8f02e$var$ItemContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "base-item-container__ItemContainer",
    componentId: "sc-1h7f57o-0"
})([
    "",
    " flex:1;width:238px;height:auto;background:",
    ";padding:16px 0px;display:grid;grid-template-rows:repeat(auto-fill,minmax(0,45px));"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$4fc41d5788d8f02e$var$StyledScrollbarContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$b252c20c2dedb54c$export$2e2bcd8739ae039).withConfig({
    displayName: "base-item-container__StyledScrollbarContainer",
    componentId: "sc-1h7f57o-1"
})([
    "width:238px;max-height:350px;"
]);
const $48090fca70e3183a$var$$4fc41d5788d8f02e$var$ItemContainerWithScrollbar = ({ children: children, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4fc41d5788d8f02e$var$StyledScrollbarContainer, {
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4fc41d5788d8f02e$var$ItemContainer, {
            children: children
        })
    });
var $48090fca70e3183a$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$4fc41d5788d8f02e$var$ItemContainerWithScrollbar;
const $48090fca70e3183a$var$$66882cfb76c803d6$var$Dot = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "dot__Dot",
    componentId: "sc-1v9nycp-0"
})([
    "",
    " background:",
    ";border-radius:50%;width:8px;height:8px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ color: color })=>color);
var $48090fca70e3183a$var$$66882cfb76c803d6$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$66882cfb76c803d6$var$Dot;
const $48090fca70e3183a$var$$eff5a32ef289d478$var$Item = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "base-item__Item",
    componentId: "sc-1q4tyix-0"
})([
    "",
    " background:",
    ";padding:",
    ";display:flex;align-items:center;",
    " .item-icon{",
    " max-height:16px;max-width:16px;min-height:12px;min-width:12px;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsMediumBlue : theme.klerosUIComponentsWhiteBackground, ({ current: current })=>current ? "10.5px 16px 10.5px 13px" : "11.5px 16px 11.5px 13px", (props)=>!props.current && (0, $1d9bd5c523349ec4$exports.css)([
        ":hover{background:",
        ";cursor:pointer;}"
    ], props.theme.klerosUIComponentsMediumBlue), $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$eff5a32ef289d478$var$StyledText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "base-item__StyledText",
    componentId: "sc-1q4tyix-1"
})([
    "",
    " font-size:16px;user-select:none;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $48090fca70e3183a$var$$eff5a32ef289d478$var$StyledDot = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$66882cfb76c803d6$export$2e2bcd8739ae039).withConfig({
    displayName: "base-item__StyledDot",
    componentId: "sc-1q4tyix-2"
})([
    "margin-right:8px;"
]);
const $48090fca70e3183a$var$$eff5a32ef289d478$var$BaseItem = ({ text: text, Icon: Icon, icon: icon, dot: dot, onClick: onClick, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$eff5a32ef289d478$var$Item, {
        onKeyPress: (e)=>onClick && e.key === "Enter" ? onClick() : undefined,
        onClick: onClick,
        ...props,
        children: [
            icon ?? (Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                className: "item-icon"
            })),
            dot && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eff5a32ef289d478$var$StyledDot, {
                color: dot
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eff5a32ef289d478$var$StyledText, {
                children: text
            })
        ]
    });
var $48090fca70e3183a$var$$eff5a32ef289d478$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$eff5a32ef289d478$var$BaseItem;
const $48090fca70e3183a$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4 = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$eff5a32ef289d478$export$2e2bcd8739ae039).withConfig({
    displayName: "item-container__StyledItem",
    componentId: "sc-b6y23n-0"
})([
    "border-left:3px solid ",
    ";",
    ""
], ({ theme: theme, selected: selected })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsWhiteBackground, ({ theme: theme, selected: selected, current: current })=>!current && (0, $1d9bd5c523349ec4$exports.css)([
        ":hover{border-left:3px solid ",
        ";}"
    ], selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsMediumBlue));
const $48090fca70e3183a$var$$bc9b74e06ed8f896$var$ItemContainer = ({ items: items, selected: selected, onChange: onChange })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039, {
        children: items.map(({ text: text, Icon: Icon, icon: icon, dot: dot, value: value }, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4, {
                tabIndex: 0,
                selected: value === selected,
                onClick: ()=>onChange(value),
                text: text,
                dot: dot,
                Icon: Icon,
                icon: icon
            }, i))
    });
var $48090fca70e3183a$var$$bc9b74e06ed8f896$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$bc9b74e06ed8f896$var$ItemContainer;
const $48090fca70e3183a$var$$2d381104713b6d5d$var$SelectButton = ({ item: item, simple: simple, small: small, isOpen: isOpen, setIsOpen: setIsOpen })=>simple ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$83ebe14398e57e2d$export$2e2bcd8739ae039, {
        text: item.text,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        small: small
    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$43d9fcbe58645246$export$2e2bcd8739ae039, {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        node: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4, {
            current: true,
            ...item
        })
    });
var $48090fca70e3183a$var$$2d381104713b6d5d$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2d381104713b6d5d$var$SelectButton;
const $48090fca70e3183a$var$$dad9719307029a16$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "dropdown-container__Container",
    componentId: "sc-qkfxj5-0"
})([
    "",
    " ",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme, isOpen: isOpen, alignRight: alignRight })=>(0, $1d9bd5c523349ec4$exports.css)([
        "position:absolute;",
        " z-index:100;visibility:",
        ";transform:scaleY(",
        ");transform-origin:top;transition-property:transform,visibility;transition-duration:",
        ";transition-timing-function:ease;height:auto;background:transparent;box-shadow:0px 2px 3px ",
        ";overflow:hidden;"
    ], alignRight ? "right: 0px;" : "", isOpen ? "visible" : "hidden", isOpen ? "1" : "0", theme.klerosUIComponentsTransitionSpeed, theme.klerosUIComponentsDefaultShadow));
const $48090fca70e3183a$var$$dad9719307029a16$var$DropdownContainer = ({ children: children, isOpen: isOpen, alignRight: alignRight, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$dad9719307029a16$var$Container, {
        isOpen: isOpen,
        alignRight: alignRight,
        ...props,
        children: [
            " ",
            children,
            " "
        ]
    });
var $48090fca70e3183a$var$$dad9719307029a16$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$dad9719307029a16$var$DropdownContainer;
const $48090fca70e3183a$var$$69ead81f7adc490a$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "select__Container",
    componentId: "sc-s4pei-0"
})([
    "position:relative;"
]);
const $48090fca70e3183a$var$$69ead81f7adc490a$var$DropdownContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$dad9719307029a16$export$2e2bcd8739ae039).withConfig({
    displayName: "select__DropdownContainer",
    componentId: "sc-s4pei-1"
})([
    "",
    ""
], ({ theme: theme })=>(0, $1d9bd5c523349ec4$exports.css)([
        "background:",
        ";border:1px solid ",
        ";border-radius:3px;"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsStroke));
const $48090fca70e3183a$var$$69ead81f7adc490a$var$Select = ({ items: items, callback: callback, simpleButton: simpleButton, smallButton: smallButton, defaultValue: defaultValue, placeholder: placeholder, alignRight: alignRight, ...props })=>{
    const [isOpen, setIsOpen] = (0, $9nZCP.useState)(false);
    const containerRef = (0, $9nZCP.useRef)(null);
    $48090fca70e3183a$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    const [selected, setSelected] = (0, $9nZCP.useState)(defaultValue);
    const currentItem = items.find(({ value: value })=>value === selected);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$69ead81f7adc490a$var$Container, {
        ref: containerRef,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2d381104713b6d5d$export$2e2bcd8739ae039, {
                item: currentItem ? currentItem : placeholder ? placeholder : {
                    text: ""
                },
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                simple: simpleButton,
                small: smallButton
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$69ead81f7adc490a$var$DropdownContainer, {
                isOpen: isOpen,
                alignRight: alignRight,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$bc9b74e06ed8f896$export$2e2bcd8739ae039, {
                    items: items,
                    selected: selected,
                    onChange: (value)=>{
                        new Promise((resolve)=>resolve(callback(value))).then(()=>{
                            setSelected(value);
                            setIsOpen(false);
                        }).catch((error)=>console.error(error));
                    }
                })
            })
        ]
    });
};
var $48090fca70e3183a$var$$69ead81f7adc490a$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$69ead81f7adc490a$var$Select;
const $48090fca70e3183a$var$$be261e7e6de1aa96$var$SvgLightLeft = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 7,
        height: 11,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M6.375 1.143V.107c0-.09-.103-.139-.173-.084L.165 4.739a.427.427 0 0 0 0 .673l6.037 4.716a.107.107 0 0 0 .173-.085V9.008a.217.217 0 0 0-.082-.168L1.472 5.075l4.821-3.765a.217.217 0 0 0 .082-.168Z"
        })
    });
var $48090fca70e3183a$var$$be261e7e6de1aa96$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$be261e7e6de1aa96$var$SvgLightLeft;
const $48090fca70e3183a$var$$2f29ff49e895ab7b$export$a1a71dc089009936 = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$eff5a32ef289d478$export$2e2bcd8739ae039).withConfig({
    displayName: "item-container__StyledBaseItem",
    componentId: "sc-gth5to-0"
})([
    "position:relative;.item-icon{position:absolute;transform:rotate(180deg);right:16px;fill:",
    ";}"
], ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$2f29ff49e895ab7b$var$ItemContainer = ({ layer: layer, onChange: onChange, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039, {
        ...props,
        children: layer.items.map((item, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                tabIndex: 0,
                text: item.label,
                Icon: item.children && $48090fca70e3183a$var$$be261e7e6de1aa96$export$2e2bcd8739ae039,
                onClick: ()=>onChange(item),
                selected: item.value === layer.selected
            }, i))
    });
var $48090fca70e3183a$var$$2f29ff49e895ab7b$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2f29ff49e895ab7b$var$ItemContainer;
const $48090fca70e3183a$var$$3b159669545f46c0$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "selector__Wrapper",
    componentId: "sc-1nl16fm-0"
})([
    "",
    " border-bottom-left-radius:3px;border-bottom-right-radius:3px;background:",
    ";padding:8px 16px;display:flex;",
    " justify-content:end;align-items:center;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "justify-content:center;"
    ])));
const $48090fca70e3183a$var$$3b159669545f46c0$var$Selector = ({ currentSelection: currentSelection, onSelect: onSelect, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b159669545f46c0$var$Wrapper, {
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2987665db72ba3c1$export$2e2bcd8739ae039, {
            onClick: ()=>onSelect(),
            text: currentSelection ? `Select\n${currentSelection}` : "No Selection",
            disabled: !currentSelection
        })
    });
var $48090fca70e3183a$var$$3b159669545f46c0$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$3b159669545f46c0$var$Selector;
const $48090fca70e3183a$var$$d8e895830981b43b$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$dad9719307029a16$export$2e2bcd8739ae039).withConfig({
    displayName: "cascader__Wrapper",
    componentId: "sc-x4ug59-0"
})([
    "border:1px solid ",
    ";",
    " border-radius:3px;"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "width:240px;"
    ])));
const $48090fca70e3183a$var$$d8e895830981b43b$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "cascader__Container",
    componentId: "sc-x4ug59-1"
})([
    "",
    ""
], ({ theme: theme, path: path, isOpen: isOpen })=>(0, $1d9bd5c523349ec4$exports.css)([
        "background:",
        ";border-bottom:1px solid ",
        ";border-radius:3px;display:grid;grid-template-columns:repeat(",
        ",238px) 0px;grid-template-rows:max-content;gap:1px;",
        ""
    ], isOpen ? theme.klerosUIComponentsStroke : theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, path.length, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
            "overflow:auto;"
        ]))));
const $48090fca70e3183a$var$$d8e895830981b43b$var$Cascader = ({ items: items, onSelect: onSelect, placeholder: placeholder, value: value, ...props })=>{
    const [path, setPath] = (0, $9nZCP.useState)([
        {
            items: items
        }
    ]);
    const [current, setCurrent] = (0, $9nZCP.useState)();
    const [selected, setSelected] = (0, $9nZCP.useState)();
    const [isOpen, setIsOpen] = (0, $9nZCP.useState)(false);
    const containerRef = (0, $9nZCP.useRef)(null);
    const lastElementRef = (0, $9nZCP.useRef)(null);
    $48090fca70e3183a$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    (0, $9nZCP.useEffect)(()=>{
        if (lastElementRef?.current && isOpen) $48090fca70e3183a$var$$parcel$interopDefault($95dd3fa9eb45140c$exports)(lastElementRef.current);
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        path
    ]);
    const label = (0, $9nZCP.useMemo)(()=>value ? $48090fca70e3183a$var$$d8e895830981b43b$var$findLabelByValue(items, value) : undefined, [
        items,
        value
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("div", {
        ref: containerRef,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$43d9fcbe58645246$export$2e2bcd8739ae039, {
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                node: selected ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                    current: true,
                    text: selected.label
                }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                    current: true,
                    text: label ?? placeholder
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d8e895830981b43b$var$Wrapper, {
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d8e895830981b43b$var$Container, {
                        path: path,
                        isOpen: isOpen,
                        children: [
                            path.map((layer, depth)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f29ff49e895ab7b$export$2e2bcd8739ae039, {
                                    layer: layer,
                                    onChange: (item)=>{
                                        let newPath;
                                        if (depth < path.length) newPath = path.slice(0, depth + 1);
                                        else newPath = path;
                                        newPath[depth].selected = item.value;
                                        if (item.children) newPath.push({
                                            items: item.children
                                        });
                                        setPath(newPath);
                                        setCurrent(item);
                                    }
                                }, depth)),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("div", {
                                ref: lastElementRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b159669545f46c0$export$2e2bcd8739ae039, {
                        onSelect: ()=>{
                            if (current) new Promise((resolve)=>resolve(onSelect(current.value))).then(()=>{
                                setSelected(current);
                                setIsOpen(false);
                            }).catch((error)=>console.error(error));
                        },
                        currentSelection: current?.label
                    })
                ]
            })
        ]
    });
};
/**
 * @param nodes the nodes
 * @param targetValue the value to search, can be string or number
 * @returns the label if the item is found, else returns undefined
 */ function $48090fca70e3183a$var$$d8e895830981b43b$var$findLabelByValue(nodes, targetValue) {
    for (const node of nodes){
        if (node.value == targetValue) return node.label;
        if (node.children) {
            const result = $48090fca70e3183a$var$$d8e895830981b43b$var$findLabelByValue(node.children, targetValue);
            if (result) return result;
        }
    }
    return undefined;
}
var $48090fca70e3183a$var$$d8e895830981b43b$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d8e895830981b43b$var$Cascader;
const $48090fca70e3183a$var$$1fbc1df023618cf8$var$SvgSuccess = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 10.6a.567.567 0 0 1-.923 0L4.545 7.516a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z"
        })
    });
var $48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1fbc1df023618cf8$var$SvgSuccess;
const $48090fca70e3183a$var$$773dfb225348757e$var$SvgWarning = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037 3.749a.857.857 0 1 1 1.211-1.212.857.857 0 0 1-1.211 1.212Zm1.034-2.606h-.857A.143.143 0 0 1 7.428 9V4.143c0-.079.065-.143.143-.143h.857c.079 0 .143.064.143.143V9a.143.143 0 0 1-.143.143Z"
        })
    });
var $48090fca70e3183a$var$$773dfb225348757e$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$773dfb225348757e$var$SvgWarning;
const $48090fca70e3183a$var$$1055d191a5da0897$var$SvgError = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.596-2.967c.079 0 .143.064.143.143 0 .034-.01.068-.032.093L8.741 8.037l2.32 2.766a.148.148 0 0 1 .033.092c0 .08-.064.143-.143.143l-1.178-.005L8 8.919l-1.773 2.116-1.18.005a.143.143 0 0 1-.11-.236L7.26 8.038 4.937 5.271a.149.149 0 0 1-.034-.093c0-.08.065-.143.143-.143l1.18.005L8 7.154l1.775-2.116 1.178-.005Z"
        })
    });
var $48090fca70e3183a$var$$1055d191a5da0897$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1055d191a5da0897$var$SvgError;
const $48090fca70e3183a$var$$3b81fb62e49a97d5$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037-2.537a.857.857 0 1 1 1.212-1.212.857.857 0 0 1-1.212 1.212Zm.177 1.394h.857c.079 0 .143.064.143.143v4.857a.143.143 0 0 1-.143.143h-.857a.143.143 0 0 1-.143-.143V7c0-.079.065-.143.143-.143Z"
        })
    });
var $48090fca70e3183a$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$3b81fb62e49a97d5$var$SvgInfo;
const $48090fca70e3183a$var$$8355cfb0932ae33e$var$SvgFieldArrowUp = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M278.313 48.296a42.667 42.667 0 0 1 15.876 15.876l182.478 319.336c11.691 20.46 4.583 46.523-15.876 58.214a42.667 42.667 0 0 1-21.169 5.621H74.667C51.103 447.343 32 428.241 32 404.677a42.667 42.667 0 0 1 5.622-21.169L220.099 64.172c11.691-20.46 37.755-27.567 58.214-15.876Z",
            fill: "#000",
            fillRule: "evenodd"
        })
    });
var $48090fca70e3183a$var$$8355cfb0932ae33e$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$8355cfb0932ae33e$var$SvgFieldArrowUp;
const $48090fca70e3183a$var$$e594305c09c6e506$var$SvgFieldArrowDown = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        transform: "scale(1 -1)",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M278.313 48.296a42.667 42.667 0 0 1 15.876 15.876l182.478 319.336c11.691 20.46 4.583 46.523-15.876 58.214a42.667 42.667 0 0 1-21.169 5.621H74.667C51.103 447.343 32 428.241 32 404.677a42.667 42.667 0 0 1 5.622-21.169L220.099 64.172c11.691-20.46 37.755-27.567 58.214-15.876Z",
            fill: "#000",
            fillRule: "evenodd"
        })
    });
var $48090fca70e3183a$var$$e594305c09c6e506$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$e594305c09c6e506$var$SvgFieldArrowDown;
const $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6 = (0, $1d9bd5c523349ec4$exports.css)([
    "",
    ""
], ({ variant: variant, theme: theme })=>{
    if (variant === "warning") return theme.klerosUIComponentsWarning;
    if (variant === "error") return theme.klerosUIComponentsError;
    if (variant === "success") return theme.klerosUIComponentsSuccess;
    return theme.klerosUIComponentsSecondaryText;
});
const $48090fca70e3183a$var$$2677d04b7028c72d$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "field__Wrapper",
    componentId: "sc-4pge1s-0"
})([
    "",
    " height:45px;width:278px;position:relative;color:red;.field-svg{",
    " height:16px;width:16px;position:absolute;top:14px;right:16px;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSuccessIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledSuccessIcon",
    componentId: "sc-4pge1s-1"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsSuccess);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledWarningIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$773dfb225348757e$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledWarningIcon",
    componentId: "sc-4pge1s-2"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsWarning);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledErrorIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$1055d191a5da0897$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledErrorIcon",
    componentId: "sc-4pge1s-3"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsError);
const $48090fca70e3183a$var$$2677d04b7028c72d$export$ceeb223748e25cf7 = (0, $1d9bd5c523349ec4$exports.css)([
    "height:100%;width:100%;background:",
    ";border:1px solid ",
    ";border-radius:3px;color:",
    ";:focus{outline:none;border:1px solid ",
    "40;box-shadow:0px 0px 6px ",
    ";border-radius:3px;}::placeholder{color:",
    ";opacity:0.5;}"
], (props)=>props.theme.klerosUIComponentsWhiteBackground, ({ variant: variant, theme: theme })=>variant ? $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6 : theme.klerosUIComponentsStroke, (props)=>props.theme.klerosUIComponentsPrimaryText, (props)=>props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.theme.klerosUIComponentsSecondaryText);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledInput = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).input.withConfig({
    displayName: "field__StyledInput",
    componentId: "sc-4pge1s-4"
})([
    "padding-top:14px;padding-bottom:14px;padding-left:16px;padding-right:",
    ";::-webkit-outer-spin-button,::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}-moz-appearance:textfield;appearance:textfield;",
    ""
], ({ Icon: Icon, variant: variant, type: type })=>{
    if (Icon) return type === "number" ? "64px" : "56px";
    if (variant) return type === "number" ? "52px" : "44px";
    return type === "number" ? "30px" : "16px";
}, $48090fca70e3183a$var$$2677d04b7028c72d$export$ceeb223748e25cf7);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$ArrowsContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "field__ArrowsContainer",
    componentId: "sc-4pge1s-5"
})([
    "display:flex;flex-direction:column;justify-content:center;align-items:center;position:absolute;height:100%;width:14px;gap:4px;top:0;right:",
    ";"
], ({ Icon: Icon, variant: variant })=>{
    if (Icon) return "48px";
    if (variant) return "36px";
    return "12px";
});
const $48090fca70e3183a$var$$2677d04b7028c72d$var$ArrowButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "field__ArrowButton",
    componentId: "sc-4pge1s-6"
})([
    "height:14px;width:14px;display:flex;justify-content:center;align-items:center;background:transparent;border:none;border-radius:3px;padding:0;cursor:pointer;:hover{background:",
    ";}"
], (props)=>props.theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledArrowIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "field__StyledArrowIcon",
    componentId: "sc-4pge1s-7"
})([
    "width:8px;height:8px;path{fill:",
    ";}"
], (props)=>props.theme.klerosUIComponentsSecondaryText);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "field__StyledSVG",
    componentId: "sc-4pge1s-8"
})([
    ""
]);
const $48090fca70e3183a$var$$2677d04b7028c72d$export$ca8581ef51d2f0a9 = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "field__StyledMessage",
    componentId: "sc-4pge1s-9"
})([
    "margin-top:6px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSmall = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "field__StyledSmall",
    componentId: "sc-4pge1s-10"
})([
    "",
    " position:relative;text-align:justify;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$IconContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "field__IconContainer",
    componentId: "sc-4pge1s-11"
})([
    "display:flex;width:44px;height:43px;position:absolute;top:1px;right:1px;align-items:center;justify-content:center;background:",
    ";border-left:1px solid ",
    ";"
], (props)=>props.theme.klerosUIComponentsLightBlue, (props)=>props.theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledIconSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "field__StyledIconSVG",
    componentId: "sc-4pge1s-12"
})([
    "width:24px;height:24px;"
]);
const $48090fca70e3183a$var$$2677d04b7028c72d$var$Field = ({ variant: variant, message: message, Icon: Icon, className: className, ...props })=>{
    const wrapperRef = (0, $9nZCP.useRef)(null);
    const inputRef = (0, $9nZCP.useRef)(null);
    const hovering = (0, $4e705cd33f69a99b$export$ae780daf29e6d456)(wrapperRef);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2677d04b7028c72d$var$Wrapper, {
        ref: wrapperRef,
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledInput, {
                ref: inputRef,
                variant: variant,
                Icon: Icon,
                ...props
            }),
            props.type === "number" && hovering && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2677d04b7028c72d$var$ArrowsContainer, {
                className: "field-arrows",
                variant: variant,
                Icon: Icon,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$ArrowButton, {
                        "aria-label": "increment",
                        onClick: ()=>inputRef?.current?.stepUp(),
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledArrowIcon, {
                            as: $48090fca70e3183a$var$$8355cfb0932ae33e$export$2e2bcd8739ae039
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$ArrowButton, {
                        "aria-label": "decrement",
                        onClick: ()=>inputRef?.current?.stepDown(),
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledArrowIcon, {
                            as: $48090fca70e3183a$var$$e594305c09c6e506$export$2e2bcd8739ae039
                        })
                    })
                ]
            }),
            variant === "success" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSuccessIcon, {
                className: "field-svg"
            }),
            variant === "warning" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledWarningIcon, {
                className: "field-svg"
            }),
            variant === "error" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledErrorIcon, {
                className: "field-svg"
            }),
            Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$IconContainer, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledIconSVG, {
                    as: Icon
                })
            }),
            message && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2677d04b7028c72d$export$ca8581ef51d2f0a9, {
                variant: variant,
                children: [
                    variant === "info" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2677d04b7028c72d$var$StyledSmall, {
                        variant: variant,
                        children: message
                    })
                ]
            })
        ]
    });
};
$48090fca70e3183a$var$$2677d04b7028c72d$var$Field.displayName = "Field";
var $48090fca70e3183a$var$$2677d04b7028c72d$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2677d04b7028c72d$var$Field;
const $48090fca70e3183a$var$$619d93e693d921a0$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "m15.78 13.833-3.116-3.115a.75.75 0 0 0-.53-.219h-.51a6.468 6.468 0 0 0 1.375-4c0-3.59-2.91-6.499-6.5-6.499S0 2.91 0 6.5s2.91 6.499 6.5 6.499c1.509 0 2.896-.513 3.999-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 0 0 1.06 0l.884-.885a.753.753 0 0 0 .003-1.062ZM6.5 10.499c-2.21 0-4-1.787-4-4 0-2.209 1.787-4 4-4 2.209 0 3.999 1.788 3.999 4 0 2.21-1.787 4-4 4Z"
        })
    });
var $48090fca70e3183a$var$$619d93e693d921a0$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$619d93e693d921a0$var$SvgSearch;
const $48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "searchbar__Wrapper",
    componentId: "sc-1lxp2tc-0"
})([
    "",
    " position:relative;width:278px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$StyledField = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$2677d04b7028c72d$export$2e2bcd8739ae039).withConfig({
    displayName: "searchbar__StyledField",
    componentId: "sc-1lxp2tc-1"
})([
    "height:100%;width:100%;input{padding:14px 16px 14px 40px;}"
]);
const $48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$StyledSearchIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$619d93e693d921a0$export$2e2bcd8739ae039).withConfig({
    displayName: "searchbar__StyledSearchIcon",
    componentId: "sc-1lxp2tc-2"
})([
    "position:absolute;left:16px;top:50%;transform:translateY(-50%);width:16px;height:16px;max-width:16px;max-height:16px;fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$Searchbar = ({ className: className, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$StyledField, {
                placeholder: "Search",
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$StyledSearchIcon, {})
        ]
    });
var $48090fca70e3183a$var$$aa6f4c7dc0f5685c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$aa6f4c7dc0f5685c$var$Searchbar;
const $48090fca70e3183a$var$$870ba58bccab6eec$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "textarea__Wrapper",
    componentId: "sc-bi4jd2-0"
})([
    "",
    " height:115px;width:400px;position:relative;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledTextarea = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).textarea.withConfig({
    displayName: "textarea__StyledTextarea",
    componentId: "sc-bi4jd2-1"
})([
    "resize:none;padding:16px;display:block;font-family:inherit;",
    ""
], $48090fca70e3183a$var$$2677d04b7028c72d$export$ceeb223748e25cf7);
const $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "textarea__StyledSVG",
    componentId: "sc-bi4jd2-2"
})([
    ""
]);
const $48090fca70e3183a$var$$870ba58bccab6eec$var$Message = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "textarea__Message",
    componentId: "sc-bi4jd2-3"
})([
    "margin-top:12px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSmall = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "textarea__StyledSmall",
    componentId: "sc-bi4jd2-4"
})([
    "",
    " position:relative;text-align:justify;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$870ba58bccab6eec$var$Textarea = ({ message: message, variant: variant, className: className, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$870ba58bccab6eec$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$870ba58bccab6eec$var$StyledTextarea, {
                variant: variant,
                ...props
            }),
            message && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$870ba58bccab6eec$var$Message, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "warning" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$773dfb225348757e$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "error" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1055d191a5da0897$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "info" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$870ba58bccab6eec$var$StyledSmall, {
                        variant: variant,
                        children: message
                    })
                ]
            })
        ]
    });
$48090fca70e3183a$var$$870ba58bccab6eec$var$Textarea.displayName = "Textarea";
var $48090fca70e3183a$var$$870ba58bccab6eec$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$870ba58bccab6eec$var$Textarea;
const $48090fca70e3183a$var$$ba3b8df995d5886a$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "handle__Wrapper",
    componentId: "sc-no0w1x-0"
})([
    "",
    " display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;position:relative;top:8px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$ba3b8df995d5886a$var$Label = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "handle__Label",
    componentId: "sc-no0w1x-1"
})([
    "position:relative;left:",
    "%;transform:translateX(-50%);bottom:44px;color:",
    ";"
], ({ offset: offset })=>offset, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$ba3b8df995d5886a$var$StyledHandle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($8fc1eb2c15e0076e$exports.Handle).withConfig({
    displayName: "handle__StyledHandle",
    componentId: "sc-no0w1x-2"
})([
    "width:30px;height:30px;margin-top:-19px;border:3px solid ",
    ";background-color:",
    ";:hover{cursor:pointer;border-color:",
    ";}:active{box-shadow:0 0 5px ",
    ";}"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$ba3b8df995d5886a$var$Handle = ({ label: label, dragging: dragging, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$ba3b8df995d5886a$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ba3b8df995d5886a$var$Label, {
                offset: props.offset,
                children: label
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ba3b8df995d5886a$var$StyledHandle, {
                dragging: dragging.toString(),
                ...props
            })
        ]
    });
var $48090fca70e3183a$var$$ba3b8df995d5886a$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$ba3b8df995d5886a$var$Handle;
const $48090fca70e3183a$var$$409b8f5f63cd4acf$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "slider__Wrapper",
    componentId: "sc-5b6ug3-0"
})([
    "",
    " width:500px;margin-top:30px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$409b8f5f63cd4acf$var$StyledSlider = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$parcel$interopDefault($8fc1eb2c15e0076e$exports)).withConfig({
    displayName: "slider__StyledSlider",
    componentId: "sc-5b6ug3-1"
})([
    "width:100%;.rc-slider-handle-click-focused:focus{border-color:",
    ";}"
], (props)=>props.theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$409b8f5f63cd4acf$var$StyledLabel = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "slider__StyledLabel",
    componentId: "sc-5b6ug3-2"
})([
    "",
    " color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$409b8f5f63cd4acf$var$Labels = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "slider__Labels",
    componentId: "sc-5b6ug3-3"
})([
    "width:100%;margin-top:16px;display:flex;align-items:center;justify-content:space-between;"
]);
const $48090fca70e3183a$var$$409b8f5f63cd4acf$var$Slider = ({ label: label, min: min, max: max, leftLabel: leftLabel, rightLabel: rightLabel, callback: callback, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$StyledSlider, {
                handle: ({ ref: ignored, ...handleProps })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ba3b8df995d5886a$export$2e2bcd8739ae039, {
                        label: label,
                        ...handleProps
                    }),
                railStyle: {
                    height: "8px",
                    backgroundColor: props.theme.klerosUIComponentsStroke,
                    borderRadius: "30px",
                    cursor: "pointer"
                },
                trackStyle: [
                    {
                        height: "8px",
                        backgroundColor: props.theme.klerosUIComponentsPrimaryBlue,
                        borderRadius: "30px",
                        cursor: "pointer"
                    }
                ],
                onChange: callback,
                min: min,
                max: max,
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$Labels, {
                children: [
                    leftLabel && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$StyledLabel, {
                        children: leftLabel
                    }),
                    rightLabel && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$StyledLabel, {
                        children: rightLabel
                    })
                ]
            })
        ]
    });
$48090fca70e3183a$var$$409b8f5f63cd4acf$var$Slider.displayName = "Slider";
var $48090fca70e3183a$var$$409b8f5f63cd4acf$export$2e2bcd8739ae039 = (0, $1d9bd5c523349ec4$exports.withTheme)($48090fca70e3183a$var$$409b8f5f63cd4acf$var$Slider);
const $48090fca70e3183a$var$$a9ca8be356aca825$var$SvgUploadIcon = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M8.406 5.378h2.371V16.91c0 .15.116.273.257.273h1.925c.142 0 .257-.123.257-.273V5.378h2.378c.215 0 .333-.263.202-.44L12.202.105a.26.26 0 0 0-.09-.077.244.244 0 0 0-.224 0 .26.26 0 0 0-.09.077l-3.594 4.83c-.131.18-.013.443.202.443Zm15.337 10.51h-1.925c-.141 0-.257.122-.257.272v5.25H2.44v-5.25c0-.15-.116-.273-.257-.273H.257c-.141 0-.257.123-.257.273v6.75C0 23.511.459 24 1.027 24h21.946c.568 0 1.027-.488 1.027-1.09v-6.75c0-.15-.116-.273-.257-.273Z"
        })
    });
var $48090fca70e3183a$var$$a9ca8be356aca825$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a9ca8be356aca825$var$SvgUploadIcon;
const $48090fca70e3183a$var$$eab617fde0d2a814$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "file-uploader__Wrapper",
    componentId: "sc-18nhvs2-0"
})([
    "",
    " width:200px;height:64px;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$DropZone = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "file-uploader__DropZone",
    componentId: "sc-18nhvs2-1"
})([
    "",
    " height:100%;width:100%;background:",
    ";border:1px dashed ",
    ";border-radius:3px;display:flex;justify-content:center;align-items:center;font-size:14px;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledUploadIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$a9ca8be356aca825$export$2e2bcd8739ae039).withConfig({
    displayName: "file-uploader__StyledUploadIcon",
    componentId: "sc-18nhvs2-2"
})([
    "",
    " height:24px;width:24px;fill:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$FileInput = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).input.withConfig({
    displayName: "file-uploader__FileInput",
    componentId: "sc-18nhvs2-3"
})([
    "display:none;"
]);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSmall = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "file-uploader__StyledSmall",
    componentId: "sc-18nhvs2-4"
})([
    "",
    " position:relative;top:-1px;text-align:justify;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "file-uploader__StyledSVG",
    componentId: "sc-18nhvs2-5"
})([
    ""
]);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$Message = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "file-uploader__Message",
    componentId: "sc-18nhvs2-6"
})([
    "margin-top:16px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $48090fca70e3183a$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$eab617fde0d2a814$var$FileUploader = ({ callback: callback, msg: msg, variant: variant, className: className, ...props })=>{
    const fileInputRef = (0, $9nZCP.useRef)(); //! type
    const [fileSelected, setFileSelected] = (0, $9nZCP.useState)();
    const handleDragEnter = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDragLeave = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDragOver = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDrop = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        fileInputRef.current.files = event.dataTransfer?.files;
        setFileSelected(event.dataTransfer?.files[0]);
        callback(event.dataTransfer?.files[0]);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$eab617fde0d2a814$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eab617fde0d2a814$var$DropZone, {
                onClick: ()=>fileInputRef?.current.click(),
                onDrop: (e)=>handleDrop(e),
                onDragOver: (e)=>handleDragOver(e),
                onDragEnter: (e)=>handleDragEnter(e),
                onDragLeave: (e)=>handleDragLeave(e),
                children: fileSelected ? fileSelected.name : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eab617fde0d2a814$var$StyledUploadIcon, {})
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eab617fde0d2a814$var$FileInput, {
                ref: fileInputRef,
                type: "file",
                onChange: (event)=>{
                    //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    setFileSelected(event.target.files[0]);
                    //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    callback(event.target.files[0]);
                },
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$eab617fde0d2a814$var$Message, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "warning" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$773dfb225348757e$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "error" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1055d191a5da0897$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "info" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$eab617fde0d2a814$var$StyledSmall, {
                        variant: variant,
                        children: msg
                    })
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$eab617fde0d2a814$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$eab617fde0d2a814$var$FileUploader;
const $48090fca70e3183a$var$$1a85d5c881834fd9$var$datepickerContextDefaultValue = {
    focusedDate: null,
    isDateFocused: ()=>false,
    isDateSelected: ()=>false,
    isDateHovered: ()=>false,
    isDateBlocked: ()=>false,
    isFirstOrLastSelectedDate: ()=>false,
    onDateFocus: ()=>{
    //do nothing
    },
    onDateHover: ()=>{
    //do nothing
    },
    onDateSelect: ()=>{
    //do nothing
    }
};
var $48090fca70e3183a$var$$1a85d5c881834fd9$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$parcel$interopDefault($9nZCP).createContext($48090fca70e3183a$var$$1a85d5c881834fd9$var$datepickerContextDefaultValue);
const $48090fca70e3183a$var$$8da322913a568d32$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M5.625 9h-1.25A.376.376 0 0 1 4 8.625v-1.25C4 7.169 4.169 7 4.375 7h1.25c.206 0 .375.169.375.375v1.25A.376.376 0 0 1 5.625 9ZM9 8.625v-1.25A.376.376 0 0 0 8.625 7h-1.25A.376.376 0 0 0 7 7.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 9 8.625Zm3 0v-1.25A.376.376 0 0 0 11.625 7h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 12 8.625Zm-3 3v-1.25A.376.376 0 0 0 8.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 9 11.625Zm-3 0v-1.25A.376.376 0 0 0 5.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 6 11.625Zm6 0v-1.25a.376.376 0 0 0-.375-.375h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 0 0 .375-.375ZM15 3.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5v-11A1.5 1.5 0 0 1 2.5 2H4V.375C4 .169 4.169 0 4.375 0h1.25C5.831 0 6 .169 6 .375V2h4V.375c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375V2h1.5A1.5 1.5 0 0 1 15 3.5Zm-1.5 10.813V5h-11v9.313c0 .103.084.187.188.187h10.624a.188.188 0 0 0 .188-.188Z"
        })
    });
var $48090fca70e3183a$var$$8da322913a568d32$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$8da322913a568d32$var$SvgCalendar;
const $48090fca70e3183a$var$$02569186343496d4$var$StyledButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "display-button__StyledButton",
    componentId: "sc-1n9stdw-0"
})([
    "",
    " height:45px;width:330px;background:",
    ";border:1px solid ",
    ";border-radius:3px;padding:0px 16px;display:flex;justify-content:flex-start;align-items:center;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$02569186343496d4$var$StyledDate = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "display-button__StyledDate",
    componentId: "sc-1n9stdw-1"
})([
    "",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $48090fca70e3183a$var$$02569186343496d4$var$StyledCalendar = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$8da322913a568d32$export$2e2bcd8739ae039).withConfig({
    displayName: "display-button__StyledCalendar",
    componentId: "sc-1n9stdw-2"
})([
    "position:absolute;right:16px;height:16px;width:16px;fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$02569186343496d4$var$DisplayButton = ({ onClick: onClick, date: date, time: time })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$02569186343496d4$var$StyledButton, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$02569186343496d4$var$StyledDate, {
                children: [
                    date.toLocaleDateString(),
                    time && `, ${date.getHours().toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })}:${date.getMinutes().toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })} Local time`
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$02569186343496d4$var$StyledCalendar, {})
        ]
    });
var $48090fca70e3183a$var$$02569186343496d4$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$02569186343496d4$var$DisplayButton;
const $48090fca70e3183a$var$$1a3cb6cad04c22a8$var$StyledDayNumber = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "day__StyledDayNumber",
    componentId: "sc-1cckfjj-0"
})([
    "",
    " color:",
    " !important;font-weight:600;cursor:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.isSelected ? props.theme.klerosUIComponentsWhiteBackground : props.disabledDate ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsSecondaryText, (props)=>props.disabledDate ? "not-allowed" : "pointer");
const $48090fca70e3183a$var$$1a3cb6cad04c22a8$var$StyledButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "day__StyledButton",
    componentId: "sc-1cckfjj-1"
})([
    "",
    " height:24px;width:24px;border-radius:12px;background-color:",
    ";padding:0;display:flex;justify-content:center;align-items:center;:hover{background-color:",
    ";& ",
    "{color:",
    " !important;}}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.isSelected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.isSelected ? props.theme.klerosUIComponentsPrimaryBlue : props.disabledDate ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsSecondaryBlue, $48090fca70e3183a$var$$1a3cb6cad04c22a8$var$StyledDayNumber, (props)=>props.disabledDate ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$1a3cb6cad04c22a8$var$Day = ({ date: date, dayLabel: dayLabel })=>{
    const dayRef = (0, $9nZCP.useRef)(null);
    const { isSelected: isSelected, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, tabIndex: tabIndex } = (0, $d6e59866f4ac3ecb$export$1937086c6b64f72d)({
        dayRef: dayRef,
        date: date,
        ...(0, $9nZCP.useContext)($48090fca70e3183a$var$$1a85d5c881834fd9$export$2e2bcd8739ae039)
    });
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const isPastDate = date.getTime() < today.getTime();
    const handleClick = ()=>{
        if (!isPastDate) onClick();
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1a3cb6cad04c22a8$var$StyledButton, {
        ref: dayRef,
        isSelected: isSelected,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        tabIndex: tabIndex,
        disabledDate: isPastDate,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1a3cb6cad04c22a8$var$StyledDayNumber, {
            isSelected: isSelected,
            disabledDate: isPastDate,
            children: dayLabel
        })
    });
};
var $48090fca70e3183a$var$$1a3cb6cad04c22a8$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1a3cb6cad04c22a8$var$Day;
const $48090fca70e3183a$var$$b6c83c11430985d2$var$MonthContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "month__MonthContainer",
    componentId: "sc-1lt566d-0"
})([
    "width:330px;height:220px;padding-top:16px;display:flex;justify-content:center;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$b6c83c11430985d2$var$StyledGridContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "month__StyledGridContainer",
    componentId: "sc-1lt566d-1"
})([
    "height:26px;width:32px;display:flex;justify-content:center;align-items:center;"
]);
const $48090fca70e3183a$var$$b6c83c11430985d2$var$StyledWeekDay = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "month__StyledWeekDay",
    componentId: "sc-1lt566d-2"
})([
    "",
    " color:",
    ";font-weight:600;user-select:none;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$b6c83c11430985d2$var$StyledMonth = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "month__StyledMonth",
    componentId: "sc-1lt566d-3"
})([
    "width:fit-content;height:fit-content;display:grid;grid-template-columns:repeat(7,32px);"
]);
const $48090fca70e3183a$var$$b6c83c11430985d2$var$Month = ({ days: days, weekdayLabels: weekdayLabels })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$var$MonthContainer, {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$b6c83c11430985d2$var$StyledMonth, {
            children: [
                weekdayLabels.map((dayLabel, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$var$StyledGridContainer, {
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$var$StyledWeekDay, {
                            children: dayLabel
                        })
                    }, i)),
                days.map((day, i)=>typeof day === "number" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$var$StyledGridContainer, {}, i) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$var$StyledGridContainer, {
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1a3cb6cad04c22a8$export$2e2bcd8739ae039, {
                            ...day
                        }, i)
                    }, i))
            ]
        })
    });
var $48090fca70e3183a$var$$b6c83c11430985d2$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$b6c83c11430985d2$var$Month;
const $48090fca70e3183a$var$$51df4a6e8b413d48$var$SvgSimpleLeft = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "m9.197 14.429-.793.786a.859.859 0 0 1-1.21 0L.252 8.335a.841.841 0 0 1 0-1.201L7.194.25a.859.859 0 0 1 1.21 0l.793.786a.846.846 0 0 1-.014 1.214L4.88 6.316h10.263c.475 0 .857.379.857.85v1.133c0 .471-.382.85-.857.85H4.88l4.303 4.065a.84.84 0 0 1 .014 1.215Z"
        })
    });
var $48090fca70e3183a$var$$51df4a6e8b413d48$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$51df4a6e8b413d48$var$SvgSimpleLeft;
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "month-selector__Wrapper",
    componentId: "sc-1tkddgk-0"
})([
    "width:100%;height:64px;padding:24px;display:flex;justify-content:space-between;"
]);
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$StyledMonthTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "month-selector__StyledMonthTitle",
    componentId: "sc-1tkddgk-1"
})([
    "",
    " user-select:none;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$StyledArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$51df4a6e8b413d48$export$2e2bcd8739ae039).withConfig({
    displayName: "month-selector__StyledArrow",
    componentId: "sc-1tkddgk-2"
})([
    "",
    " width:16px;height:16px;fill:",
    ";transition:fill ease ",
    ";:hover{fill:",
    ";}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$RightArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$StyledArrow).withConfig({
    displayName: "month-selector__RightArrow",
    componentId: "sc-1tkddgk-3"
})([
    "transform:rotate(180deg);"
]);
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$UnstyledButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "month-selector__UnstyledButton",
    componentId: "sc-1tkddgk-4"
})([
    "",
    " background:none;padding:0;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$MonthSelector = ({ monthLabel: monthLabel, goToNextMonths: goToNextMonths, goToPreviousMonths: goToPreviousMonths })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$UnstyledButton, {
                onClick: goToPreviousMonths,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$StyledArrow, {})
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$StyledMonthTitle, {
                children: monthLabel
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$UnstyledButton, {
                onClick: goToNextMonths,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$RightArrow, {})
            })
        ]
    });
var $48090fca70e3183a$var$$d9b6f601d2dcc8ac$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d9b6f601d2dcc8ac$var$MonthSelector;
const $48090fca70e3183a$var$$5b91024d35847b4a$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "date-selector__Wrapper",
    componentId: "sc-dxn9nj-0"
})([
    "display:flex;flex-direction:column;"
]);
const $48090fca70e3183a$var$$5b91024d35847b4a$var$DateSelector = ({ year: year, month: month, firstDayOfWeek: firstDayOfWeek, goToNextMonths: goToNextMonths, goToPreviousMonths: goToPreviousMonths })=>{
    const { days: days, weekdayLabels: weekdayLabels, monthLabel: monthLabel } = (0, $d6e59866f4ac3ecb$export$41527c87dc759868)({
        year: year,
        month: month,
        firstDayOfWeek: firstDayOfWeek
    });
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$5b91024d35847b4a$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d9b6f601d2dcc8ac$export$2e2bcd8739ae039, {
                monthLabel: monthLabel,
                goToPreviousMonths: goToPreviousMonths,
                goToNextMonths: goToNextMonths
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b6c83c11430985d2$export$2e2bcd8739ae039, {
                days: days,
                weekdayLabels: weekdayLabels
            })
        ]
    });
};
var $48090fca70e3183a$var$$5b91024d35847b4a$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$5b91024d35847b4a$var$DateSelector;
const $48090fca70e3183a$var$$2dfb31ff65652603$var$TimeControl = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "time-controls__TimeControl",
    componentId: "sc-198k8z7-0"
})([
    "flex-grow:1;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";display:flex;flex-direction:column;"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$TimeDisplay = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "time-controls__TimeDisplay",
    componentId: "sc-198k8z7-1"
})([
    "width:100%;height:64px;background-color:",
    ";padding:0px 24px;display:flex;justify-content:space-between;align-items:center;"
], ({ theme: theme })=>theme.klerosUIComponentsMediumBlue);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$StyledTime = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "time-controls__StyledTime",
    componentId: "sc-198k8z7-2"
})([
    "",
    " font-weight:600;color:",
    ";user-select:none;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$TimeButtons = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$2dfb31ff65652603$var$TimeDisplay).withConfig({
    displayName: "time-controls__TimeButtons",
    componentId: "sc-198k8z7-3"
})([
    "flex-grow:1;background-color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$StyledArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$51df4a6e8b413d48$export$2e2bcd8739ae039).withConfig({
    displayName: "time-controls__StyledArrow",
    componentId: "sc-198k8z7-4"
})([
    "",
    " width:16px;height:16px;fill:",
    ";transition:fill ease ",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$UpArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$2dfb31ff65652603$var$StyledArrow).withConfig({
    displayName: "time-controls__UpArrow",
    componentId: "sc-198k8z7-5"
})([
    "transform:rotate(90deg);"
]);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$DownArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$2dfb31ff65652603$var$StyledArrow).withConfig({
    displayName: "time-controls__DownArrow",
    componentId: "sc-198k8z7-6"
})([
    "transform:rotate(-90deg);"
]);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$UnstyledButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "time-controls__UnstyledButton",
    componentId: "sc-198k8z7-7"
})([
    "",
    " background:none;padding:0;:hover{& ",
    "{fill:",
    ";}}:disabled{& ",
    "{fill:",
    ";}}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $48090fca70e3183a$var$$2dfb31ff65652603$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue, $48090fca70e3183a$var$$2dfb31ff65652603$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$2dfb31ff65652603$var$TimeControls = ({ date: date, hours: hours, minutes: minutes, setHours: setHours, setMinutes: setMinutes })=>{
    const today = new Date();
    const disableHourUp = hours === 23;
    const disableMinuteUp = minutes === 59;
    const isToday = date.toDateString() === today.toDateString();
    const currentTime = today.getTime();
    const checkTime = new Date(date).setHours(hours - 1, minutes);
    const disableHourDown = hours === 0 || isToday && (hours - 1 < today.getHours() || hours - 1 === today.getHours() && minutes <= today.getMinutes() || checkTime <= currentTime);
    const disableMinuteDown = minutes === 0 || isToday && (hours < today.getHours() || hours === today.getHours() && minutes - 1 <= today.getMinutes());
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2dfb31ff65652603$var$TimeControl, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2dfb31ff65652603$var$TimeButtons, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newHours = hours + 1;
                            setHours(newHours);
                            date.setHours(newHours, minutes);
                        },
                        disabled: disableHourUp,
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UpArrow, {})
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newMinutes = minutes + 1;
                            setMinutes(newMinutes);
                            date.setHours(hours, newMinutes);
                        },
                        disabled: disableMinuteUp,
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UpArrow, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2dfb31ff65652603$var$TimeDisplay, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$StyledTime, {
                        children: hours.toLocaleString("en-US", {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$StyledTime, {
                        children: ":"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$StyledTime, {
                        children: minutes.toLocaleString("en-US", {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2dfb31ff65652603$var$TimeButtons, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newHours = hours - 1;
                            setHours(newHours);
                            date.setHours(newHours, minutes);
                        },
                        disabled: disableHourDown,
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$DownArrow, {})
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newMinutes = minutes - 1;
                            setMinutes(newMinutes);
                            date.setHours(hours, newMinutes);
                        },
                        disabled: disableMinuteDown,
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$var$DownArrow, {})
                    })
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$2dfb31ff65652603$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2dfb31ff65652603$var$TimeControls;
const $48090fca70e3183a$var$$a1eb1518e9214887$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "time-selector__Wrapper",
    componentId: "sc-1i0y3my-0"
})([
    "width:118px;height:284px;border-left:1px solid ",
    ";display:flex;flex-direction:column;",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "border:1px solid ",
        ";border-top:none;border-bottom:none;"
    ], ({ theme: theme })=>theme.klerosUIComponentsStroke)));
const $48090fca70e3183a$var$$a1eb1518e9214887$var$Header = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "time-selector__Header",
    componentId: "sc-1i0y3my-1"
})([
    "height:64px;display:flex;justify-content:center;align-items:center;"
]);
const $48090fca70e3183a$var$$a1eb1518e9214887$var$StyledTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "time-selector__StyledTitle",
    componentId: "sc-1i0y3my-2"
})([
    "",
    " user-select:none;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $48090fca70e3183a$var$$a1eb1518e9214887$var$TimeSelector = (props)=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$a1eb1518e9214887$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a1eb1518e9214887$var$Header, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a1eb1518e9214887$var$StyledTitle, {
                    children: "Time"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2dfb31ff65652603$export$2e2bcd8739ae039, {
                ...props
            })
        ]
    });
};
var $48090fca70e3183a$var$$a1eb1518e9214887$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a1eb1518e9214887$var$TimeSelector;
const $48090fca70e3183a$var$$275ab796fce9757e$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "dropdown__Container",
    componentId: "sc-xqzukb-0"
})([
    "position:absolute;z-index:100;overflow:hidden;height:",
    ";width:",
    ";transition:height ease ",
    ";background:",
    ";",
    ";box-shadow:0px 2px 3px ",
    ";border-radius:3px;",
    ""
], ({ isOpen: isOpen })=>isOpen ? "auto" : "0", ({ time: time })=>time ? "450px" : "330px", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ isOpen: isOpen, theme: theme })=>isOpen ? `border: 1px solid ${theme.klerosUIComponentsStroke}` : "", ({ theme: theme })=>theme.klerosUIComponentsDefaultShadow, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "width:332px;position:static;margin:0;left:0;top:0;"
    ])));
const $48090fca70e3183a$var$$275ab796fce9757e$var$Selectors = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "dropdown__Selectors",
    componentId: "sc-xqzukb-1"
})([
    "display:flex;",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "flex-direction:column;align-items:center;justify-content:flex-start;"
    ])));
const $48090fca70e3183a$var$$275ab796fce9757e$var$ButtonContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "dropdown__ButtonContainer",
    componentId: "sc-xqzukb-2"
})([
    "width:100%;padding:16px 24px;display:flex;justify-content:flex-end;align-items:center;",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "justify-content:center;"
    ])));
const $48090fca70e3183a$var$$275ab796fce9757e$var$Dropdown = ({ onSelect: onSelect, isOpen: isOpen, time: time, date: date, hours: hours, minutes: minutes, setHours: setHours, setMinutes: setMinutes, ...dateSelectorProps })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$275ab796fce9757e$var$Container, {
        isOpen: isOpen,
        time: time,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$275ab796fce9757e$var$Selectors, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$5b91024d35847b4a$export$2e2bcd8739ae039, {
                        ...dateSelectorProps
                    }),
                    time && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a1eb1518e9214887$export$2e2bcd8739ae039, {
                        date: date,
                        hours: hours,
                        minutes: minutes,
                        setHours: setHours,
                        setMinutes: setMinutes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$275ab796fce9757e$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2987665db72ba3c1$export$2e2bcd8739ae039, {
                    small: true,
                    variant: "primary",
                    text: "Select",
                    onClick: onSelect
                })
            })
        ]
    });
var $48090fca70e3183a$var$$275ab796fce9757e$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$275ab796fce9757e$var$Dropdown;
const $48090fca70e3183a$var$$1d445195934320ed$var$PositionedContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "datepicker__PositionedContainer",
    componentId: "sc-1gv6m20-0"
})([
    "",
    " position:relative;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$1d445195934320ed$var$DatePicker = ({ onSelect: onSelect, time: time })=>{
    const [isOpen, setIsOpen] = (0, $9nZCP.useState)(false);
    const containerRef = (0, $9nZCP.useRef)(null);
    $48090fca70e3183a$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    const [date, setDate] = (0, $9nZCP.useState)(new Date());
    const [hours, setHours] = (0, $9nZCP.useState)(date.getHours());
    const [minutes, setMinutes] = (0, $9nZCP.useState)(date.getMinutes());
    const today = new Date();
    const lastSelectableDate = new Date(today);
    lastSelectableDate.setDate(today.getDate());
    const updateDateWithTime = (selectedDate)=>{
        if (selectedDate.toDateString() === lastSelectableDate.toDateString()) {
            const now = new Date();
            selectedDate.setHours(now.getHours(), now.getMinutes());
            setHours(now.getHours());
            setMinutes(now.getMinutes());
        } else selectedDate.setHours(hours, minutes);
        setDate(selectedDate);
        onSelect(selectedDate);
    };
    const { firstDayOfWeek: firstDayOfWeek, activeMonths: activeMonths, isDateHovered: isDateHovered, isFirstOrLastSelectedDate: isFirstOrLastSelectedDate, isDateBlocked: isDateBlocked, isDateFocused: isDateFocused, focusedDate: focusedDate, onDateHover: onDateHover, onDateSelect: handleDateSelect, onDateFocus: onDateFocus, goToPreviousMonths: goToPreviousMonths, goToNextMonths: goToNextMonths } = (0, $d6e59866f4ac3ecb$export$2d9bfdb55c82a287)({
        startDate: date,
        endDate: date,
        focusedInput: $d6e59866f4ac3ecb$export$99a467bcc22b8df9,
        onDatesChange: (data)=>{
            if (data.startDate) updateDateWithTime(new Date(data.startDate));
        },
        numberOfMonths: 1,
        minBookingDays: 1,
        exactMinBookingDays: true
    });
    const onTimeChange = (newHours, newMinutes)=>{
        const newDate = new Date(date);
        newDate.setHours(newHours, newMinutes);
        setHours(newHours);
        setMinutes(newMinutes);
        setDate(newDate);
        onSelect(newDate);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1a85d5c881834fd9$export$2e2bcd8739ae039.Provider, {
        value: {
            focusedDate: focusedDate,
            isDateFocused: isDateFocused,
            isDateSelected: (selectedDate)=>{
                return selectedDate.getDate() === date.getDate() && selectedDate.getMonth() === date.getMonth() && selectedDate.getFullYear() === date.getFullYear();
            },
            isDateHovered: isDateHovered,
            isDateBlocked: isDateBlocked,
            isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
            onDateSelect: (selectedDate)=>{
                handleDateSelect(selectedDate);
                updateDateWithTime(selectedDate);
            },
            onDateFocus: onDateFocus,
            onDateHover: onDateHover
        },
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$1d445195934320ed$var$PositionedContainer, {
            ref: containerRef,
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$02569186343496d4$export$2e2bcd8739ae039, {
                    date: date,
                    time: time,
                    onClick: ()=>setIsOpen(!isOpen)
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$275ab796fce9757e$export$2e2bcd8739ae039, {
                    ...activeMonths[0],
                    isOpen: isOpen,
                    time: time,
                    firstDayOfWeek: firstDayOfWeek,
                    goToNextMonths: goToNextMonths,
                    goToPreviousMonths: goToPreviousMonths,
                    date: date,
                    hours: hours,
                    minutes: minutes,
                    setHours: (newHours)=>onTimeChange(newHours, minutes),
                    setMinutes: (newMinutes)=>onTimeChange(hours, newMinutes),
                    onSelect: ()=>{
                        date.setHours(hours, minutes);
                        onSelect(date);
                        setIsOpen(false);
                    }
                })
            ]
        })
    });
};
var $48090fca70e3183a$var$$1d445195934320ed$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1d445195934320ed$var$DatePicker;
const $48090fca70e3183a$var$$86e1d79a67710eda$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).label.withConfig({
    displayName: "radio__Wrapper",
    componentId: "sc-1jhzktg-0"
})([
    "",
    " display:block;position:relative;cursor:pointer;user-select:none;color:",
    ";",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, ({ small: small })=>small ? (0, $1d9bd5c523349ec4$exports.css)([
        "font-size:16px;padding-left:28px;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        "font-size:22px;padding-left:35px;"
    ]));
const $48090fca70e3183a$var$$86e1d79a67710eda$var$HiddenInput = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).input.attrs({
    type: "radio"
}).withConfig({
    displayName: "radio__HiddenInput",
    componentId: "sc-1jhzktg-1"
})([
    "position:absolute;opacity:0;cursor:pointer;"
]);
const $48090fca70e3183a$var$$86e1d79a67710eda$var$StyledRadio = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).span.withConfig({
    displayName: "radio__StyledRadio",
    componentId: "sc-1jhzktg-2"
})([
    "position:absolute;top:0;left:0;border:1px solid ",
    ";border-radius:50%;",
    ' :after{content:"";position:absolute;display:none;border-radius:50%;background:',
    ";",
    "}",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ small: small })=>small ? (0, $1d9bd5c523349ec4$exports.css)([
        "width:16px;height:16px;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        "width:24px;height:24px;"
    ]), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ small: small })=>small ? (0, $1d9bd5c523349ec4$exports.css)([
        "top:3px;left:3px;width:8px;height:8px;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        "top:5px;left:5px;width:12px;height:12px;"
    ]), ({ theme: theme, checked: checked })=>checked && (0, $1d9bd5c523349ec4$exports.css)([
        "background:",
        ";border:1px solid ",
        ";:after{display:block;}"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsPrimaryBlue));
const $48090fca70e3183a$var$$86e1d79a67710eda$var$Radio = ({ small: small, checked: checked, label: label, className: className, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$86e1d79a67710eda$var$Wrapper, {
        small: small,
        className: className,
        children: [
            label,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$86e1d79a67710eda$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$86e1d79a67710eda$var$StyledRadio, {
                small: small,
                checked: checked
            })
        ]
    });
var $48090fca70e3183a$var$$86e1d79a67710eda$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$86e1d79a67710eda$var$Radio;
const $48090fca70e3183a$var$$1d196f635349b3e7$var$SvgCheckmark = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 15 12",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M14.416 0h-1.77c-.384 0-.75.185-.977.502L5.737 8.729 3.05 5a1.207 1.207 0 0 0-.978-.502H.302c-.245 0-.388.28-.245.48l4.702 6.52a1.2 1.2 0 0 0 1.951 0L14.658.48A.3.3 0 0 0 14.416 0Z"
        })
    });
var $48090fca70e3183a$var$$1d196f635349b3e7$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1d196f635349b3e7$var$SvgCheckmark;
const $48090fca70e3183a$var$$b679852ecf8e9c02$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).label.withConfig({
    displayName: "checkbox__Wrapper",
    componentId: "sc-1qpo0fn-0"
})([
    "",
    " display:block;position:relative;cursor:pointer;user-select:none;color:",
    ";",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, ({ small: small })=>small ? (0, $1d9bd5c523349ec4$exports.css)([
        "font-size:16px;padding-left:28px;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        "font-size:22px;padding-left:35px;"
    ]));
const $48090fca70e3183a$var$$b679852ecf8e9c02$var$HiddenInput = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "checkbox__HiddenInput",
    componentId: "sc-1qpo0fn-1"
})([
    "position:absolute;opacity:0;cursor:pointer;height:0;width:0;"
]);
const $48090fca70e3183a$var$$b679852ecf8e9c02$var$StyledCheckmark = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$1d196f635349b3e7$export$2e2bcd8739ae039).withConfig({
    displayName: "checkbox__StyledCheckmark",
    componentId: "sc-1qpo0fn-2"
})([
    "",
    " position:absolute;top:0;left:0;border-radius:3px;border:1px solid ",
    ";",
    " ",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ $small: $small })=>$small ? (0, $1d9bd5c523349ec4$exports.css)([
        "padding:0 3px;width:16px;height:16px;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        "padding:0 4px;width:24px;height:24px;"
    ]), ({ theme: theme, checked: checked })=>checked ? (0, $1d9bd5c523349ec4$exports.css)([
        "fill:",
        ";background:",
        ";border:none;:after{display:block;}"
    ], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsPrimaryBlue) : (0, $1d9bd5c523349ec4$exports.css)([
        "fill:transparent;"
    ]));
const $48090fca70e3183a$var$$b679852ecf8e9c02$var$Checkbox = ({ small: small = false, checked: checked, label: label, className: className, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$b679852ecf8e9c02$var$Wrapper, {
        small: small,
        className: className,
        children: [
            label,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b679852ecf8e9c02$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b679852ecf8e9c02$var$StyledCheckmark, {
                $small: small,
                checked: checked
            })
        ]
    });
var $48090fca70e3183a$var$$b679852ecf8e9c02$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$b679852ecf8e9c02$var$Checkbox;
const $48090fca70e3183a$var$$34871b0f15f7c161$var$StyledSwitch = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).label.withConfig({
    displayName: "switch__StyledSwitch",
    componentId: "sc-1or3qt0-0"
})([
    "",
    " position:relative;display:inline-block;height:",
    ";width:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ small: small })=>small ? "16px" : "24px", ({ small: small })=>small ? "32px" : "48px");
const $48090fca70e3183a$var$$34871b0f15f7c161$var$HiddenInput = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "switch__HiddenInput",
    componentId: "sc-1or3qt0-1"
})([
    "opacity:0;width:0;height:0;"
]);
const $48090fca70e3183a$var$$34871b0f15f7c161$var$StyledSlider = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).span.withConfig({
    displayName: "switch__StyledSlider",
    componentId: "sc-1or3qt0-2"
})([
    "position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:",
    ';transition:0.4s;border-radius:34px;&:before{position:absolute;content:"";height:',
    ";width:",
    ";left:2px;bottom:2px;border-radius:50%;background-color:white;transition:0.4s;}",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ small: small })=>small ? "12px" : "20px", ({ small: small })=>small ? "12px" : "20px", ({ checked: checked, theme: theme, small: small })=>checked && (0, $1d9bd5c523349ec4$exports.css)([
        "background-color:",
        ";:before{transform:translateX(",
        ");}"
    ], theme.klerosUIComponentsPrimaryBlue, small ? "16px" : "24px"));
const $48090fca70e3183a$var$$34871b0f15f7c161$var$Switch = ({ small: small, checked: checked, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$34871b0f15f7c161$var$StyledSwitch, {
        small: small,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$34871b0f15f7c161$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$34871b0f15f7c161$var$StyledSlider, {
                small: small,
                checked: checked
            })
        ]
    });
var $48090fca70e3183a$var$$34871b0f15f7c161$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$34871b0f15f7c161$var$Switch;
const $48090fca70e3183a$var$$d963730b715e990c$var$variantColor = (0, $1d9bd5c523349ec4$exports.css)([
    "",
    ""
], ({ theme: theme, variant: variant })=>{
    switch(variant){
        case "success":
            return (0, $1d9bd5c523349ec4$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsSuccess);
        case "warning":
            return (0, $1d9bd5c523349ec4$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsWarning);
        case "error":
            return (0, $1d9bd5c523349ec4$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsError);
        case "info":
        default:
            return (0, $1d9bd5c523349ec4$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsPrimaryBlue);
    }
});
const $48090fca70e3183a$var$$d963730b715e990c$var$borderColor = ({ theme: theme, variant: variant })=>{
    const colors = {
        success: theme.klerosUIComponentsSuccess,
        warning: theme.klerosUIComponentsWarning,
        error: theme.klerosUIComponentsError,
        info: theme.klerosUIComponentsPrimaryBlue
    };
    return colors[variant];
};
const $48090fca70e3183a$var$$d963730b715e990c$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "alert__Wrapper",
    componentId: "sc-rckqp0-0"
})([
    "display:grid;grid-template-columns:24px auto;gap:16px;align-items:center;background:",
    ";border:1px solid ",
    ";border-radius:3px;padding:16px 24px 20px 24px;"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme, variant: variant })=>$48090fca70e3183a$var$$d963730b715e990c$var$borderColor({
        theme: theme,
        variant: variant
    }));
const $48090fca70e3183a$var$$d963730b715e990c$var$IconWrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "alert__IconWrapper",
    componentId: "sc-rckqp0-1"
})([
    "",
    " height:24px;width:24px;svg{",
    " fill:currentColor;}"
], $48090fca70e3183a$var$$d963730b715e990c$var$variantColor, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$d963730b715e990c$var$StyledTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "alert__StyledTitle",
    componentId: "sc-rckqp0-2"
})([
    "",
    " font-size:16px;margin:0;font-weight:600;line-height:24px;"
], $48090fca70e3183a$var$$d963730b715e990c$var$variantColor);
const $48090fca70e3183a$var$$d963730b715e990c$var$TitleAndMessage = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "alert__TitleAndMessage",
    componentId: "sc-rckqp0-3"
})([
    "display:flex;flex-direction:column;",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "gap:8px;"
    ])));
const $48090fca70e3183a$var$$d963730b715e990c$var$StyledMessage = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "alert__StyledMessage",
    componentId: "sc-rckqp0-4"
})([
    "color:",
    ";font-weight:400;"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$d963730b715e990c$var$Alert = ({ variant: variant, title: title, msg: msg })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d963730b715e990c$var$Wrapper, {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d963730b715e990c$var$IconWrapper, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {}),
                    variant === "warning" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$773dfb225348757e$export$2e2bcd8739ae039, {}),
                    variant === "error" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1055d191a5da0897$export$2e2bcd8739ae039, {}),
                    variant === "info" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {})
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$d963730b715e990c$var$TitleAndMessage, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d963730b715e990c$var$StyledTitle, {
                        variant: variant,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d963730b715e990c$var$StyledMessage, {
                        children: msg
                    })
                ]
            })
        ]
    });
var $48090fca70e3183a$var$$d963730b715e990c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d963730b715e990c$var$Alert;
const $48090fca70e3183a$var$$296cff7698ec0f63$var$SvgSolidSuccess = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm6.91 10.775-7.52 10.429a1.136 1.136 0 0 1-1.847 0l-4.454-6.172a.287.287 0 0 1 .232-.453h1.675c.365 0 .711.175.925.475l2.543 3.528 5.615-7.785c.214-.297.557-.475.925-.475h1.675c.232 0 .367.264.232.453Z"
        })
    });
var $48090fca70e3183a$var$$296cff7698ec0f63$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$296cff7698ec0f63$var$SvgSolidSuccess;
const $48090fca70e3183a$var$$ff1548a205f71f6a$var$SvgSolidError = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm5.907 22.079-2.357-.011L16 17.836l-3.546 4.228-2.361.011a.284.284 0 0 1-.286-.286c0-.068.025-.132.068-.185l4.646-5.536-4.646-5.532a.287.287 0 0 1 .218-.471l2.36.01L16 14.307l3.546-4.228 2.358-.011c.157 0 .285.125.285.286a.297.297 0 0 1-.068.185l-4.639 5.532 4.643 5.536a.287.287 0 0 1-.218.472Z"
        })
    });
var $48090fca70e3183a$var$$ff1548a205f71f6a$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$ff1548a205f71f6a$var$SvgSolidError;
const $48090fca70e3183a$var$$d6917595109333d4$var$SvgSync = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M2.171 11.777a9.807 9.807 0 0 1 2.874-6.726 9.778 9.778 0 0 1 6.951-2.88c1.33 0 2.615.26 3.824.772a9.757 9.757 0 0 1 3.123 2.108c.283.283.548.583.794.898l-1.72 1.342a.229.229 0 0 0 .086.403l5.02 1.229a.23.23 0 0 0 .283-.22l.023-5.169c0-.191-.22-.3-.369-.18l-1.611 1.26A11.967 11.967 0 0 0 11.994 0C5.45 0 .123 5.246 0 11.766A.228.228 0 0 0 .23 12h1.714c.126 0 .226-.1.228-.223Zm21.6.223h-1.714c-.125 0-.226.1-.228.223a9.76 9.76 0 0 1-.769 3.6 9.778 9.778 0 0 1-2.106 3.126 9.786 9.786 0 0 1-6.951 2.88 9.779 9.779 0 0 1-6.949-2.88 9.853 9.853 0 0 1-.794-.898l1.72-1.342a.23.23 0 0 0 .024-.34.229.229 0 0 0-.11-.063l-5.02-1.229a.23.23 0 0 0-.282.22l-.02 5.172c0 .191.22.3.368.18l1.611-1.26A11.973 11.973 0 0 0 12.006 24C18.554 24 23.877 18.751 24 12.234a.229.229 0 0 0-.229-.234Z"
        })
    });
var $48090fca70e3183a$var$$d6917595109333d4$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d6917595109333d4$var$SvgSync;
const $48090fca70e3183a$var$$88d96d829ac44aee$var$SvgClose = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 8 8",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M4.525 4 7.746.16A.098.098 0 0 0 7.671 0h-.979a.2.2 0 0 0-.15.07L3.884 3.237 1.228.07a.196.196 0 0 0-.15-.07h-.98a.098.098 0 0 0-.075.16L3.244 4 .024 7.84A.098.098 0 0 0 .097 8h.98a.2.2 0 0 0 .15-.07l2.657-3.167L6.54 7.93c.037.044.092.07.151.07h.98a.098.098 0 0 0 .074-.16L4.526 4Z"
        })
    });
var $48090fca70e3183a$var$$88d96d829ac44aee$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$88d96d829ac44aee$var$SvgClose;
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "push__StyledSVG",
    componentId: "sc-4wrqai-0"
})([
    ""
]);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "push__Wrapper",
    componentId: "sc-4wrqai-1"
})([
    "",
    " position:relative;height:",
    ";width:",
    ";background:",
    ";border-radius:3px;padding:",
    ";display:flex;align-items:center;& ",
    "{",
    " height:",
    ";width:",
    ";min-height:",
    ";min-width:",
    ";fill:",
    ";}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ small: small })=>small ? "48px" : "100px", ({ small: small })=>small ? "300px" : "422px", ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ small: small })=>small ? "12px 24px 12px 24px" : "16px 32px 16px 24px", $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "push__StyledTitle",
    componentId: "sc-4wrqai-2"
})([
    "",
    " color:inherit;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledMessage = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "push__StyledMessage",
    componentId: "sc-4wrqai-3"
})([
    "",
    " color:inherit;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Text = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "push__Text",
    componentId: "sc-4wrqai-4"
})([
    "margin-left:16px;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$CloseButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "push__CloseButton",
    componentId: "sc-4wrqai-5"
})([
    "",
    " position:absolute;top:24px;right:24px;height:8px;width:8px;background:none;padding:0;display:inline-flex;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledCloseIcon = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$88d96d829ac44aee$export$2e2bcd8739ae039).withConfig({
    displayName: "push__StyledCloseIcon",
    componentId: "sc-4wrqai-6"
})([
    "",
    " height:8px;width:8px;min-height:8px;min-width:8px;fill:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Push = ({ variant: variant, title: title, msg: msg, callback: callback, small: small, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Wrapper, {
        small: small,
        ...props,
        children: [
            variant === "success" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$296cff7698ec0f63$export$2e2bcd8739ae039, {
                className: $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            variant === "error" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ff1548a205f71f6a$export$2e2bcd8739ae039, {
                className: $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            variant === "sync" && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$d6917595109333d4$export$2e2bcd8739ae039, {
                className: $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledTitle, {
                        children: title
                    }),
                    !small && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledMessage, {
                        children: msg
                    })
                ]
            }),
            !small && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$CloseButton, {
                onClick: ()=>callback(),
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$StyledCloseIcon, {})
            })
        ]
    });
var $48090fca70e3183a$var$$cadd1c9c3bca1fc9$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$cadd1c9c3bca1fc9$var$Push;
const $48090fca70e3183a$var$$0ef3fc8611d56815$var$usePagination = (currentPage, numPages, callback, onCloseOnLastPage, numNeighbors = 2)=>{
    const incrementPage = ()=>{
        if (currentPage === numPages && onCloseOnLastPage) onCloseOnLastPage();
        else {
            const newPage = Math.min(numPages, currentPage + 1);
            callback(newPage);
        }
    };
    const decrementPage = ()=>{
        const newPage = Math.max(1, currentPage - 1);
        callback(newPage);
    };
    const goToPage = (newPage)=>{
        callback(newPage);
    };
    const minPageReached = currentPage === 1;
    const maxPageReached = currentPage === numPages;
    const getPageRange = ()=>{
        const leftBoundary = Math.max(1, currentPage - numNeighbors - Math.max(0, numNeighbors - (numPages - currentPage)));
        const rightBoundary = Math.min(numPages, currentPage + numNeighbors + Math.max(0, numNeighbors - currentPage + 1));
        return [
            ...Array(rightBoundary - leftBoundary + 1).keys()
        ].map((i)=>i + leftBoundary);
    };
    return [
        {
            incrementPage: incrementPage,
            decrementPage: decrementPage,
            goToPage: goToPage,
            minPageReached: minPageReached,
            maxPageReached: maxPageReached,
            getPageRange: getPageRange
        }
    ];
};
var $48090fca70e3183a$var$$0ef3fc8611d56815$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$0ef3fc8611d56815$var$usePagination;
const $48090fca70e3183a$var$$1edefcf4055fc9a6$var$SvgCircleLeft = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm-.124 16.697.52-.527a.572.572 0 0 0-.009-.815L9.56 12.626h6.742a.565.565 0 0 0 .563-.57v-.76a.565.565 0 0 0-.563-.57H9.56l2.827-2.73a.576.576 0 0 0 .01-.814l-.521-.528a.556.556 0 0 0-.796 0l-4.56 4.62a.573.573 0 0 0 0 .806l4.56 4.617a.556.556 0 0 0 .796 0Z"
        })
    });
var $48090fca70e3183a$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$1edefcf4055fc9a6$var$SvgCircleLeft;
const $48090fca70e3183a$var$$831351fb15d68ad0$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "compact__Wrapper",
    componentId: "sc-1a5y08h-0"
})([
    "",
    " display:flex;align-items:center;justify-content:end;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "compact__StyledSVG",
    componentId: "sc-1a5y08h-1"
})([
    ""
]);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$ArrowButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "compact__ArrowButton",
    componentId: "sc-1a5y08h-2"
})([
    "",
    " height:24px;width:24px;background:none;padding:0;border-radius:50%;& ",
    "{",
    " height:24px;width:24px;fill:",
    ";transition:fill ease ",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledLabel = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "compact__StyledLabel",
    componentId: "sc-1a5y08h-3"
})([
    "",
    " color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$LeftArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__LeftArrow",
    componentId: "sc-1a5y08h-4"
})([
    "margin-left:16px;"
]);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$RightArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__RightArrow",
    componentId: "sc-1a5y08h-5"
})([
    "margin-left:8px;& ",
    "{transform:rotate(180deg);}"
], $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$CloseButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__CloseButton",
    componentId: "sc-1a5y08h-6"
})([
    "margin-left:8px;& ",
    "{fill:",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG, (props)=>props.theme.klerosUIComponentsPrimaryBlue, $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $48090fca70e3183a$var$$831351fb15d68ad0$var$CompactPagination = ({ currentPage: currentPage, numPages: numPages, callback: callback, onCloseOnLastPage: onCloseOnLastPage, label: label, className: className })=>{
    const [{ incrementPage: incrementPage, decrementPage: decrementPage, minPageReached: minPageReached, maxPageReached: maxPageReached }] = $48090fca70e3183a$var$$0ef3fc8611d56815$export$2e2bcd8739ae039(currentPage, numPages, callback, onCloseOnLastPage);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$831351fb15d68ad0$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$831351fb15d68ad0$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$831351fb15d68ad0$var$LeftArrow, {
                disabled: minPageReached,
                onClick: decrementPage,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039, {
                    className: $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            }),
            currentPage === numPages && onCloseOnLastPage ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$831351fb15d68ad0$var$CloseButton, {
                onClick: onCloseOnLastPage,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$ff1548a205f71f6a$export$2e2bcd8739ae039, {
                    className: $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$831351fb15d68ad0$var$RightArrow, {
                disabled: maxPageReached,
                onClick: incrementPage,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039, {
                    className: $48090fca70e3183a$var$$831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            })
        ]
    });
};
var $48090fca70e3183a$var$$831351fb15d68ad0$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$831351fb15d68ad0$var$CompactPagination;
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "standard__Wrapper",
    componentId: "sc-n01q9o-0"
})([
    "",
    " display:flex;align-items:center;justify-content:center;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$PageButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "standard__PageButton",
    componentId: "sc-n01q9o-1"
})([
    "",
    " height:32px;width:32px;margin:4px;background:",
    ";border:1px solid ",
    ";border-radius:3px;display:flex;align-items:center;justify-content:center;font-size:14px;color:",
    ";:hover:enabled{background:",
    ";border:1px solid ",
    ";color:",
    ";}:hover:disabled{cursor:default;}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.selected ? props.theme.klerosUIComponentsLightBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsPrimaryText, (props)=>props.selected ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsLightBlue, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "standard__StyledArrow",
    componentId: "sc-n01q9o-2"
})([
    ""
]);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$ArrowButton = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$PageButton).withConfig({
    displayName: "standard__ArrowButton",
    componentId: "sc-n01q9o-3"
})([
    "& ",
    "{",
    " fill:",
    ";transition:fill ease ",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryText, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$LeftArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$ArrowButton).withConfig({
    displayName: "standard__LeftArrow",
    componentId: "sc-n01q9o-4"
})([
    "& ",
    "{padding-right:1px;}"
], $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$RightArrow = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$ArrowButton).withConfig({
    displayName: "standard__RightArrow",
    componentId: "sc-n01q9o-5"
})([
    "& ",
    "{padding-left:1px;transform:rotate(180deg);}"
], $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow);
const $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StandardPagination = ({ currentPage: currentPage, numPages: numPages, callback: callback, disableNumbers: disableNumbers, hideNumbers: hideNumbers, className: className })=>{
    const [{ incrementPage: incrementPage, decrementPage: decrementPage, goToPage: goToPage, minPageReached: minPageReached, maxPageReached: maxPageReached, getPageRange: getPageRange }] = $48090fca70e3183a$var$$0ef3fc8611d56815$export$2e2bcd8739ae039(currentPage, numPages, callback);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$LeftArrow, {
                disabled: minPageReached,
                onClick: decrementPage,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$be261e7e6de1aa96$export$2e2bcd8739ae039, {
                    className: $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow.styledComponentId
                })
            }),
            !hideNumbers && getPageRange().map((i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$PageButton, {
                    selected: currentPage === i,
                    onClick: ()=>goToPage(i),
                    disabled: disableNumbers,
                    children: i
                }, i)),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$60c375d8d52bb6d6$var$RightArrow, {
                disabled: maxPageReached,
                onClick: incrementPage,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$be261e7e6de1aa96$export$2e2bcd8739ae039, {
                    className: $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StyledArrow.styledComponentId
                })
            })
        ]
    });
};
var $48090fca70e3183a$var$$60c375d8d52bb6d6$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$60c375d8d52bb6d6$var$StandardPagination;
const $48090fca70e3183a$var$$35a1a5ac66949050$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "tabs__Wrapper",
    componentId: "sc-1dgmogo-0"
})([
    "",
    " height:fit-content;width:500px;display:flex;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$35a1a5ac66949050$var$StyledSVG = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "tabs__StyledSVG",
    componentId: "sc-1dgmogo-1"
})([
    ""
]);
const $48090fca70e3183a$var$$35a1a5ac66949050$var$StyledTab = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "tabs__StyledTab",
    componentId: "sc-1dgmogo-2"
})([
    "",
    " flex-grow:1;height:45px;background:none;border-bottom:3px solid ",
    ";display:flex;align-items:center;justify-content:center;color:",
    ";",
    " & ",
    "{",
    " height:16px;width:16px;margin-right:16px;fill:",
    ";}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>{
    if (props.selected) return props.theme.klerosUIComponentsPrimaryBlue;
    else if (props.disabled) return props.theme.klerosUIComponentsStroke;
    else return props.theme.klerosUIComponentsPrimaryText;
}, (props)=>!props.disabled && !props.selected ? `:hover {
            border-bottom: 3px solid
              ${props.theme.klerosUIComponentsSecondaryBlue};
          }` : "", $48090fca70e3183a$var$$35a1a5ac66949050$var$StyledSVG, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>{
    if (props.selected) return props.theme.klerosUIComponentsPrimaryBlue;
    else if (props.disabled) return props.theme.klerosUIComponentsStroke;
    else return props.theme.klerosUIComponentsPrimaryText;
});
const $48090fca70e3183a$var$$35a1a5ac66949050$var$Tabs = ({ items: items, ...props })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$35a1a5ac66949050$var$Wrapper, {
        ...props,
        children: items.map(({ Icon: Icon, icon: icon, text: text, value: value, disabled: disabled })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$35a1a5ac66949050$var$StyledTab, {
                disabled: disabled,
                selected: value === props.currentValue,
                onClick: ()=>props.callback(value),
                children: [
                    icon ?? (Icon && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {
                        className: $48090fca70e3183a$var$$35a1a5ac66949050$var$StyledSVG.styledComponentId
                    })),
                    text
                ]
            }, value))
    });
};
var $48090fca70e3183a$var$$35a1a5ac66949050$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$35a1a5ac66949050$var$Tabs;
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "breadcrumb__Wrapper",
    componentId: "sc-2m5bd-0"
})([
    "",
    " display:flex;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Element = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "breadcrumb__Element",
    componentId: "sc-2m5bd-1"
})([
    "",
    " background:none;padding:0;:hover{",
    "}"
], $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ clickable: clickable, theme: theme })=>clickable ? `small { color: ${theme.klerosUIComponentsPrimaryText}; }` : `cursor: text !important`);
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Content = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "breadcrumb__Content",
    componentId: "sc-2m5bd-2"
})([
    "",
    " transition:color ease ",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Separator = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Content).withConfig({
    displayName: "breadcrumb__Separator",
    componentId: "sc-2m5bd-3"
})([
    "margin:0px 8px;"
]);
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$ActiveElement = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Content).withConfig({
    displayName: "breadcrumb__ActiveElement",
    componentId: "sc-2m5bd-4"
})([
    "color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Breadcrumb = ({ items: items, callback: callback, clickable: clickable, className: className })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Wrapper, {
        className: className,
        children: items.map(({ text: text, value: value }, i)=>i === items.length - 1 ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$ActiveElement, {
                children: text
            }, i) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$parcel$interopDefault($9nZCP).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Element, {
                        onClick: ()=>callback ? callback(value) : null,
                        clickable: clickable,
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Content, {
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Separator, {
                        children: "/"
                    })
                ]
            }, i))
    });
var $48090fca70e3183a$var$$a6857e6cae2f9c5f$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a6857e6cae2f9c5f$var$Breadcrumb;
const $48090fca70e3183a$var$$d623bf354733f290$var$SvgHourglass = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        width: 12,
        height: 15,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M1.275 14.5h9.31a.66.66 0 0 0 .665-.656v-.438a.66.66 0 0 0-.665-.656c0-2.487-1.414-4.586-3.348-5.25 1.934-.664 3.348-2.763 3.348-5.25a.66.66 0 0 0 .665-.656v-.438A.66.66 0 0 0 10.585.5h-9.31a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656c0 2.487 1.414 4.586 3.348 5.25-1.934.664-3.348 2.763-3.348 5.25a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656ZM3.048 2.25h5.764c0 2.118-1.28 3.938-2.882 3.938-1.601 0-2.882-1.82-2.882-3.938Z"
        })
    });
var $48090fca70e3183a$var$$d623bf354733f290$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$d623bf354733f290$var$SvgHourglass;
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$progressAnimation = (width)=>(0, $1d9bd5c523349ec4$exports.keyframes)([
        "0%{stroke-dasharray:0 ",
        ";}"
    ], width);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "linear__Wrapper",
    componentId: "sc-bwbdj5-0"
})([
    "",
    " display:flex;flex-direction:column;align-items:center;font-size:14px;color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$StyledText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "linear__StyledText",
    componentId: "sc-bwbdj5-1"
})([
    "",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$BarTimerWrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "linear__BarTimerWrapper",
    componentId: "sc-bwbdj5-2"
})([
    "display:flex;flex-direction:column;align-items:flex-start;"
]);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$LinearChart = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "linear__LinearChart",
    componentId: "sc-bwbdj5-3"
})([
    "",
    " stroke:",
    ";display:block;margin:10px auto;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ width: width })=>width);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$LineBackground = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).path.withConfig({
    displayName: "linear__LineBackground",
    componentId: "sc-bwbdj5-4"
})([
    "stroke:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$Line = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).path.withConfig({
    displayName: "linear__Line",
    componentId: "sc-bwbdj5-5"
})([
    "stroke:",
    ";",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsSuccess, ({ animated: animated, width: width })=>animated && (0, $1d9bd5c523349ec4$exports.css)([
        "animation:",
        " 1s ease-out forwards;"
    ], $48090fca70e3183a$var$$8688d42e9f1d381a$var$progressAnimation(width)));
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$StyledHourglass = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$d623bf354733f290$export$2e2bcd8739ae039).withConfig({
    displayName: "linear__StyledHourglass",
    componentId: "sc-bwbdj5-6"
})([
    "",
    " margin-right:9.75px;fill:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsError);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$TimerMessage = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "linear__TimerMessage",
    componentId: "sc-bwbdj5-7"
})([
    "margin-top:5px;display:flex;justify-content:center;align-items:center;color:",
    ";font-weight:600;line-height:1em;"
], ({ theme: theme })=>theme.klerosUIComponentsError);
const $48090fca70e3183a$var$$8688d42e9f1d381a$var$Linear = ({ text: text, progress: progress, width: width, timerText: timerText, animated: animated = true })=>{
    const sw = 8;
    const linePath = `M ${sw / 2} ${sw / 2} h ${width - sw}`;
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$8688d42e9f1d381a$var$Wrapper, {
        children: [
            text && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$8688d42e9f1d381a$var$StyledText, {
                children: text
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$8688d42e9f1d381a$var$BarTimerWrapper, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$8688d42e9f1d381a$var$LinearChart, {
                        width: width,
                        height: sw,
                        fill: "none",
                        strokeWidth: sw,
                        strokeLinecap: "round",
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$8688d42e9f1d381a$var$LineBackground, {
                                d: linePath
                            }),
                            progress && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$8688d42e9f1d381a$var$Line, {
                                animated: animated,
                                width: width,
                                strokeDasharray: `${progress * width / 100} ${width}`,
                                d: linePath
                            })
                        ]
                    }),
                    timerText && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$8688d42e9f1d381a$var$TimerMessage, {
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$8688d42e9f1d381a$var$StyledHourglass, {}),
                            timerText
                        ]
                    })
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$8688d42e9f1d381a$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$8688d42e9f1d381a$var$Linear;
const $48090fca70e3183a$var$$e09296aea30ed10d$var$progressAnimation = (circ)=>(0, $1d9bd5c523349ec4$exports.keyframes)([
        "0%{stroke-dasharray:0 ",
        ";}"
    ], circ);
const $48090fca70e3183a$var$$e09296aea30ed10d$var$CircularChart = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).svg.withConfig({
    displayName: "circular__CircularChart",
    componentId: "sc-73w0na-0"
})([
    "",
    " ",
    " display:block;margin:10px auto;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $48090fca70e3183a$var$$e09296aea30ed10d$var$CircleBackground = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).path.withConfig({
    displayName: "circular__CircleBackground",
    componentId: "sc-73w0na-1"
})([
    "stroke:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$e09296aea30ed10d$var$Circle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).path.withConfig({
    displayName: "circular__Circle",
    componentId: "sc-73w0na-2"
})([
    "stroke:",
    ";",
    ""
], (props)=>props.progress < 100 ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSuccess, ({ animated: animated, circ: circ })=>animated && (0, $1d9bd5c523349ec4$exports.css)([
        "animation:",
        " 1s ease-out forwards;"
    ], $48090fca70e3183a$var$$e09296aea30ed10d$var$progressAnimation(circ)));
const $48090fca70e3183a$var$$e09296aea30ed10d$var$Percentage = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).text.withConfig({
    displayName: "circular__Percentage",
    componentId: "sc-73w0na-3"
})([
    "fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $48090fca70e3183a$var$$e09296aea30ed10d$var$Circular = ({ progress: progress, small: small, animated: animated = true })=>{
    const width = small ? 80 : 120;
    const sw = width / 20; // stroke-width
    const rad = (width - sw) / 2 + 1;
    const dy = width - sw + 2;
    const circ = 2 * Math.PI * rad;
    const circlePath = `M ${(width + sw) / 2} ${sw / 2}
  a ${rad} ${rad} 0 0 1 0 ${dy}
  a ${rad} ${rad} 0 0 1 0 -${dy}`;
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$e09296aea30ed10d$var$CircularChart, {
        fill: "none",
        strokeWidth: sw,
        strokeLinecap: "round",
        width: width + sw,
        height: width + sw,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$e09296aea30ed10d$var$CircleBackground, {
                d: circlePath
            }),
            progress && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$e09296aea30ed10d$var$Circle, {
                strokeDasharray: `${circ * progress / 100} ${circ}`,
                progress: progress,
                d: circlePath,
                circ: circ,
                animated: animated
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$e09296aea30ed10d$var$Percentage, {
                fontSize: small ? 16 : 24,
                fontWeight: 600,
                textAnchor: "middle",
                dominantBaseline: "middle",
                x: "50%",
                y: "50%",
                children: [
                    progress,
                    "%"
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$e09296aea30ed10d$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$e09296aea30ed10d$var$Circular;
const $48090fca70e3183a$var$$757595619553281c$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet-circle__Wrapper",
    componentId: "sc-1bvj53u-0"
})([
    "height:100%;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"
]);
const $48090fca70e3183a$var$$757595619553281c$var$StyledSuccess = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$1fbc1df023618cf8$export$2e2bcd8739ae039).withConfig({
    displayName: "bullet-circle__StyledSuccess",
    componentId: "sc-1bvj53u-1"
})([
    "height:24px;width:24px;flex-basis:auto;fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$757595619553281c$var$Circle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet-circle__Circle",
    componentId: "sc-1bvj53u-2"
})([
    "height:24px;width:24px;flex-basis:auto;background-color:",
    ";border-radius:12px;border:1px solid ",
    ";display:flex;justify-content:center;align-items:center;font-size:12px;color:",
    ";"
], (props)=>props.active ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>props.active ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$757595619553281c$var$Line = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet-circle__Line",
    componentId: "sc-1bvj53u-3"
})([
    "height:auto;width:0px;flex-grow:1;border-left:1px solid ",
    ";margin:8px 0px;"
], (props)=>props.completed ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$757595619553281c$var$BulletCircle = ({ active: active, completed: completed, line: line, index: index, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$757595619553281c$var$Wrapper, {
        ...props,
        children: [
            completed ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$757595619553281c$var$StyledSuccess, {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$757595619553281c$var$Circle, {
                active: active,
                children: [
                    " ",
                    index,
                    " "
                ]
            }),
            line && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$757595619553281c$var$Line, {
                completed: completed
            })
        ]
    });
var $48090fca70e3183a$var$$757595619553281c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$757595619553281c$var$BulletCircle;
const $48090fca70e3183a$var$$c37ea337805e62b1$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__Wrapper",
    componentId: "sc-1ly7f40-0"
})([
    "flex-basis:0;flex-grow:1;width:fit-content;display:flex;"
]);
const $48090fca70e3183a$var$$c37ea337805e62b1$var$StyledTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "bullet__StyledTitle",
    componentId: "sc-1ly7f40-1"
})([
    ""
]);
const $48090fca70e3183a$var$$c37ea337805e62b1$var$StyledBody = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "bullet__StyledBody",
    componentId: "sc-1ly7f40-2"
})([
    ""
]);
const $48090fca70e3183a$var$$c37ea337805e62b1$var$TextContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__TextContainer",
    componentId: "sc-1ly7f40-3"
})([
    "margin-left:16px;margin-top:2px;& ",
    "{",
    " font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " font-size:12px;line-height:16px;}"
], $48090fca70e3183a$var$$c37ea337805e62b1$var$StyledTitle, $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryText : props.theme.klerosUIComponentsSecondaryText, $48090fca70e3183a$var$$c37ea337805e62b1$var$StyledBody, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $48090fca70e3183a$var$$c37ea337805e62b1$var$SubitemsContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__SubitemsContainer",
    componentId: "sc-1ly7f40-4"
})([
    "display:flex;flex-direction:column;"
]);
const $48090fca70e3183a$var$$c37ea337805e62b1$var$Bullet = ({ title: title, subitems: subitems, index: index, active: active, completed: completed, line: line, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$c37ea337805e62b1$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$757595619553281c$export$2e2bcd8739ae039, {
                index: index,
                active: active,
                completed: completed,
                line: line
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$c37ea337805e62b1$var$TextContainer, {
                active: active,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c37ea337805e62b1$var$StyledTitle, {
                        children: title
                    }),
                    subitems && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c37ea337805e62b1$var$SubitemsContainer, {
                        children: subitems.map((item, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c37ea337805e62b1$var$StyledBody, {
                                children: item
                            }, i))
                    })
                ]
            })
        ]
    });
var $48090fca70e3183a$var$$c37ea337805e62b1$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$c37ea337805e62b1$var$Bullet;
const $48090fca70e3183a$var$$2f7d25ee5647072f$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "vertical__Wrapper",
    componentId: "sc-1rvtpa4-0"
})([
    "height:100px;display:flex;flex-direction:column;"
]);
const $48090fca70e3183a$var$$2f7d25ee5647072f$var$BulletsContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "vertical__BulletsContainer",
    componentId: "sc-1rvtpa4-1"
})([
    "height:auto;display:flex;flex-direction:column;flex-grow:1;"
]);
const $48090fca70e3183a$var$$2f7d25ee5647072f$var$LastBullet = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$c37ea337805e62b1$export$2e2bcd8739ae039).withConfig({
    displayName: "vertical__LastBullet",
    componentId: "sc-1rvtpa4-2"
})([
    "flex-basis:auto;flex-grow:0;"
]);
const $48090fca70e3183a$var$$2f7d25ee5647072f$var$Steps = ({ items: items, currentItemIndex: currentItemIndex, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$2f7d25ee5647072f$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f7d25ee5647072f$var$BulletsContainer, {
                children: items.slice(0, -1).map(({ title: title, subitems: subitems }, i)=>/*#__PURE__*/ (0, $9nZCP.createElement)($48090fca70e3183a$var$$c37ea337805e62b1$export$2e2bcd8739ae039, {
                        title: title,
                        subitems: subitems,
                        completed: i < currentItemIndex,
                        active: i === currentItemIndex,
                        line: !(i + 1 === items.length),
                        index: i + 1,
                        key: i
                    }))
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f7d25ee5647072f$var$LastBullet, {
                title: lastItem.title,
                subitems: lastItem.subitems,
                completed: items.length - 1 < currentItemIndex,
                active: items.length - 1 === currentItemIndex,
                index: items.length
            })
        ]
    });
};
var $48090fca70e3183a$var$$2f7d25ee5647072f$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$2f7d25ee5647072f$var$Steps;
const $48090fca70e3183a$var$$cf0f856d949d5193$var$Container = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "horizontal-bullet__Container",
    componentId: "sc-1tljr4r-0"
})([
    "position:relative;height:fit-content;display:flex;justify-content:center;align-items:start;",
    ""
], ({ theme: theme, last: last, completed: completed })=>last ? (0, $1d9bd5c523349ec4$exports.css)([
        "flex-grow:0;"
    ]) : (0, $1d9bd5c523349ec4$exports.css)([
        'flex-grow:1;:after{content:"";height:0px;width:auto;flex-grow:1;border-top:1px solid ',
        ";margin:12px 16px;}"
    ], completed ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke));
const $48090fca70e3183a$var$$cf0f856d949d5193$var$TextWrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "horizontal-bullet__TextWrapper",
    componentId: "sc-1tljr4r-1"
})([
    "margin-left:8px;display:flex;flex-direction:column;align-items:start;> h2{",
    " font-size:14px;line-height:24px;color:",
    ";}> small{",
    " font-size:12px;line-height:16px;}",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryText : props.theme.klerosUIComponentsSecondaryText, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, $48090fca70e3183a$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $1d9bd5c523349ec4$exports.css)([
        "position:absolute;top:24px;left:0;margin-left:0px;transform:translateX(calc(-50% + 12px));align-items:center;text-align:center;> h2{line-height:19px;}"
    ])));
const $48090fca70e3183a$var$$cf0f856d949d5193$var$HorizontalBullet = ({ index: index, title: title, subitems: subitems, active: active, last: last, completed: completed, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$cf0f856d949d5193$var$Container, {
        active: active,
        completed: completed,
        last: last,
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$757595619553281c$export$2e2bcd8739ae039, {
                active: active,
                completed: completed,
                index: index
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$cf0f856d949d5193$var$TextWrapper, {
                active: active,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("h2", {
                        children: title
                    }),
                    subitems && subitems.map((item, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                            children: item
                        }, i))
                ]
            })
        ]
    });
var $48090fca70e3183a$var$$cf0f856d949d5193$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$cf0f856d949d5193$var$HorizontalBullet;
const $48090fca70e3183a$var$$4987b48a13ec5480$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "horizontal__Wrapper",
    componentId: "sc-12u32gl-0"
})([
    "",
    " width:250px;display:flex;justify-content:center;align-items:start;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$4987b48a13ec5480$var$HorizontalSteps = ({ items: items, currentItemIndex: currentItemIndex, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4987b48a13ec5480$var$Wrapper, {
        ...props,
        children: items.map((item, i)=>/*#__PURE__*/ (0, $9nZCP.createElement)($48090fca70e3183a$var$$cf0f856d949d5193$export$2e2bcd8739ae039, {
                ...item,
                completed: i < currentItemIndex,
                active: i === currentItemIndex,
                last: i + 1 === items.length,
                index: i + 1,
                key: i
            }))
    });
var $48090fca70e3183a$var$$4987b48a13ec5480$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$4987b48a13ec5480$var$HorizontalSteps;
const $48090fca70e3183a$var$$250cfcb8116ed97e$var$Steps = ({ horizontal: horizontal, ...props })=>horizontal ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4987b48a13ec5480$export$2e2bcd8739ae039, {
        ...props
    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$2f7d25ee5647072f$export$2e2bcd8739ae039, {
        ...props
    });
var $48090fca70e3183a$var$$250cfcb8116ed97e$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$250cfcb8116ed97e$var$Steps;
const $48090fca70e3183a$var$$b17bb74d528cffb5$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "spine__Wrapper",
    componentId: "sc-1nqkm41-0"
})([
    "height:auto;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"
]);
const $48090fca70e3183a$var$$b17bb74d528cffb5$var$colorRegex = new RegExp("^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$");
const $48090fca70e3183a$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6 = (0, $1d9bd5c523349ec4$exports.css)([
    "",
    ""
], ({ variant: variant, theme: theme })=>{
    if (variant === "accepted") return theme.klerosUIComponentsSuccess;
    if (variant === "refused") return theme.klerosUIComponentsError;
    if (variant && $48090fca70e3183a$var$$b17bb74d528cffb5$var$colorRegex.test(variant)) return variant;
    return theme.klerosUIComponentsPrimaryBlue;
});
const $48090fca70e3183a$var$$b17bb74d528cffb5$var$Circle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "spine__Circle",
    componentId: "sc-1nqkm41-1"
})([
    "height:16px;width:16px;flex-basis:auto;background-color:",
    ";border-radius:8px;border:2px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, $48090fca70e3183a$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6);
const $48090fca70e3183a$var$$b17bb74d528cffb5$var$Line = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "spine__Line",
    componentId: "sc-1nqkm41-2"
})([
    "height:",
    ";width:0px;flex-grow:",
    ";border-left:1px solid ",
    ";"
], ({ topHeight: topHeight })=>topHeight ? `${topHeight}px` : "auto", ({ topHeight: topHeight })=>topHeight ? 0 : 1, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $48090fca70e3183a$var$$b17bb74d528cffb5$var$Spine = ({ variant: variant, line: line, Icon: Icon, titleRef: titleRef })=>{
    const [topHeight, setTopHeight] = (0, $9nZCP.useState)();
    (0, $9nZCP.useEffect)(()=>{
        const handleOffsetTopChange = ()=>{
            if (titleRef?.current) {
                const newOffsetTop = titleRef.current.offsetTop;
                if (newOffsetTop !== topHeight) setTopHeight(newOffsetTop);
            }
        };
        handleOffsetTopChange();
        window.addEventListener("resize", handleOffsetTopChange);
        return ()=>{
            window.removeEventListener("resize", handleOffsetTopChange);
        };
    }, [
        titleRef,
        topHeight
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$b17bb74d528cffb5$var$Wrapper, {
        children: [
            topHeight ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b17bb74d528cffb5$var$Line, {
                topHeight: topHeight
            }) : null,
            Icon ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {}) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b17bb74d528cffb5$var$Circle, {
                variant: variant
            }),
            line && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b17bb74d528cffb5$var$Line, {})
        ]
    });
};
var $48090fca70e3183a$var$$b17bb74d528cffb5$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$b17bb74d528cffb5$var$Spine;
const $48090fca70e3183a$var$$febc15bff886858c$var$loading = (0, $1d9bd5c523349ec4$exports.keyframes)([
    "0%{opacity:1;}50%{opacity:0.5;}100%{opacity:1;}"
]);
const $48090fca70e3183a$var$$febc15bff886858c$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__Wrapper",
    componentId: "sc-6vrqo5-0"
})([
    "display:flex;position:relative;justify-content:",
    ";",
    ""
], ({ rightSided: rightSided })=>rightSided ? "flex-start" : "flex-end", ({ state: state })=>{
    if (state === "disabled") return (0, $1d9bd5c523349ec4$exports.css)([
        "opacity:0.5;"
    ]);
    if (state === "loading") return (0, $1d9bd5c523349ec4$exports.css)([
        "animation:",
        " 2s ease-in-out infinite normal;"
    ], $48090fca70e3183a$var$$febc15bff886858c$var$loading);
    return (0, $1d9bd5c523349ec4$exports.css)([
        "opacity:1;"
    ]);
});
const $48090fca70e3183a$var$$febc15bff886858c$var$StyledTitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).h2.withConfig({
    displayName: "bullet__StyledTitle",
    componentId: "sc-6vrqo5-1"
})([
    ""
]);
const $48090fca70e3183a$var$$febc15bff886858c$var$StyledParty = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "bullet__StyledParty",
    componentId: "sc-6vrqo5-2"
})([
    ""
]);
const $48090fca70e3183a$var$$febc15bff886858c$var$StyledSubtitle = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "bullet__StyledSubtitle",
    componentId: "sc-6vrqo5-3"
})([
    ""
]);
const $48090fca70e3183a$var$$febc15bff886858c$var$PartyElementWrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__PartyElementWrapper",
    componentId: "sc-6vrqo5-4"
})([
    "display:inline-flex;"
]);
const $48090fca70e3183a$var$$febc15bff886858c$var$TextContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__TextContainer",
    componentId: "sc-6vrqo5-5"
})([
    "margin-",
    ":20px;order:",
    ";display:flex;flex-direction:column;margin-bottom:",
    ";gap:2px;text-align:",
    ";@media (max-width:900px){margin-",
    ":16px;margin-bottom:",
    ";gap:4px;}& ",
    "{",
    " order:",
    ";font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " order:",
    ";font-size:14px;line-height:19px;color:",
    ";}& ",
    "{order:",
    ";max-height:32px;overflow:hidden;}& ",
    "{",
    " align-self:flex-",
    ";font-size:12px;line-height:16px;}"
], ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ rightSided: rightSided })=>rightSided ? 1 : -1, ({ isLast: isLast })=>isLast ? "0" : "18px", ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ isLast: isLast })=>isLast ? "0" : "16px", $48090fca70e3183a$var$$febc15bff886858c$var$StyledTitle, $48090fca70e3183a$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, ({ rightSided: rightSided })=>rightSided ? 1 : 2, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, $48090fca70e3183a$var$$febc15bff886858c$var$StyledParty, $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ rightSided: rightSided })=>rightSided ? 2 : 1, $48090fca70e3183a$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6, $48090fca70e3183a$var$$febc15bff886858c$var$PartyElementWrapper, ({ rightSided: rightSided })=>rightSided ? 2 : 1, $48090fca70e3183a$var$$febc15bff886858c$var$StyledSubtitle, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ rightSided: rightSided })=>rightSided ? "start" : "end");
const $48090fca70e3183a$var$$febc15bff886858c$var$PartyTitleContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "bullet__PartyTitleContainer",
    componentId: "sc-6vrqo5-6"
})([
    "display:flex;position:relative;align-items:center;flex-direction:row;flex-wrap:wrap;gap:4px 8px;justify-content:",
    ";"
], ({ rightSided: rightSided })=>rightSided ? "flex-start" : "flex-end");
const $48090fca70e3183a$var$$febc15bff886858c$var$Bullet = (props)=>{
    const { title: title, party: party, subtitle: subtitle, ...restProps } = props;
    const { rightSided: rightSided, variant: variant, line: line, Icon: Icon, isLast: isLast, state: state, ...wrapperProps } = restProps;
    const titleRef = (0, $9nZCP.useRef)(null);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$febc15bff886858c$var$Wrapper, {
        rightSided: rightSided,
        state: state,
        ...wrapperProps,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$b17bb74d528cffb5$export$2e2bcd8739ae039, {
                variant: variant,
                line: line,
                Icon: Icon,
                titleRef: titleRef
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$febc15bff886858c$var$TextContainer, {
                className: "text-container",
                variant: variant,
                rightSided: rightSided,
                isLast: isLast,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$febc15bff886858c$var$PartyTitleContainer, {
                        rightSided: rightSided,
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$febc15bff886858c$var$StyledTitle, {
                                ref: titleRef,
                                children: title
                            }),
                            typeof party === `string` ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$febc15bff886858c$var$StyledParty, {
                                children: party
                            }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$febc15bff886858c$var$PartyElementWrapper, {
                                className: "party-wrapper",
                                children: party
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$febc15bff886858c$var$StyledSubtitle, {
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
var $48090fca70e3183a$var$$febc15bff886858c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$febc15bff886858c$var$Bullet;
const $48090fca70e3183a$var$$c3e303edb7751c77$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "timeline__Wrapper",
    componentId: "sc-rxkvqs-0"
})([
    "",
    " display:flex;flex-direction:column;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$c3e303edb7751c77$var$StyledBullet = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$febc15bff886858c$export$2e2bcd8739ae039).withConfig({
    displayName: "timeline__StyledBullet",
    componentId: "sc-rxkvqs-1"
})([
    "position:relative;transform:translateX( ",
    " );"
], ({ rightSided: rightSided })=>rightSided ? "calc(50% - 8px)" : "calc(-50% + 8px)");
const $48090fca70e3183a$var$$c3e303edb7751c77$var$LastBullet = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$c3e303edb7751c77$var$StyledBullet).withConfig({
    displayName: "timeline__LastBullet",
    componentId: "sc-rxkvqs-2"
})([
    "height:unset;flex-basis:auto;flex-grow:0;"
]);
const $48090fca70e3183a$var$$c3e303edb7751c77$var$Timeline = ({ items: items, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$c3e303edb7751c77$var$Wrapper, {
        ...props,
        children: [
            items.slice(0, -1).map((item, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c3e303edb7751c77$var$StyledBullet, {
                    line: true,
                    ...item,
                    isLast: false
                }, i)),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$c3e303edb7751c77$var$LastBullet, {
                ...lastItem,
                isLast: true
            })
        ]
    });
};
var $48090fca70e3183a$var$$c3e303edb7751c77$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$c3e303edb7751c77$var$Timeline;
const $48090fca70e3183a$var$$a3f868921843a442$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "custom__Wrapper",
    componentId: "sc-k2o2ay-0"
})([
    "",
    " display:flex;flex-direction:column;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26);
const $48090fca70e3183a$var$$a3f868921843a442$var$LastBullet = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$febc15bff886858c$export$2e2bcd8739ae039).withConfig({
    displayName: "custom__LastBullet",
    componentId: "sc-k2o2ay-1"
})([
    "height:unset;flex-basis:auto;flex-grow:0;"
]);
const $48090fca70e3183a$var$$a3f868921843a442$var$CustomTimeline = ({ items: items, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$a3f868921843a442$var$Wrapper, {
        ...props,
        children: [
            items.slice(0, -1).map((item, i)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$febc15bff886858c$export$2e2bcd8739ae039, {
                    line: true,
                    ...item,
                    rightSided: true,
                    isLast: false
                }, i)),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a3f868921843a442$var$LastBullet, {
                rightSided: true,
                ...lastItem,
                isLast: true
            })
        ]
    });
};
var $48090fca70e3183a$var$$a3f868921843a442$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a3f868921843a442$var$CustomTimeline;
const $48090fca70e3183a$var$$4c05722f1abfb34c$var$BaseTag = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).button.withConfig({
    displayName: "tag__BaseTag",
    componentId: "sc-19f0jzg-0"
})([
    "",
    " ",
    " height:32px;background:",
    ";border:",
    ";border-radius:300px;padding:0 16px;display:flex;justify-content:center;align-items:center;"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, $48090fca70e3183a$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue, ({ theme: theme, active: active })=>active ? `1px solid ${theme.klerosUIComponentsPrimaryBlue}` : "none");
const $48090fca70e3183a$var$$4c05722f1abfb34c$var$StyledText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).p.withConfig({
    displayName: "tag__StyledText",
    componentId: "sc-19f0jzg-1"
})([
    "",
    " color:",
    ";"
], $48090fca70e3183a$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $48090fca70e3183a$var$$4c05722f1abfb34c$var$Tag = ({ text: text, active: active, as: as, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4c05722f1abfb34c$var$BaseTag, {
        active: active,
        as: as,
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4c05722f1abfb34c$var$StyledText, {
            children: text
        })
    });
var $48090fca70e3183a$var$$4c05722f1abfb34c$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$4c05722f1abfb34c$var$Tag;
const $48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledText = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).small.withConfig({
    displayName: "tooltip__StyledText",
    componentId: "sc-2flh2z-0"
})([
    ""
]);
const $48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledTooltip = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).span.withConfig({
    displayName: "tooltip__StyledTooltip",
    componentId: "sc-2flh2z-1"
})([
    "",
    " ",
    ""
], $48090fca70e3183a$var$$49a276e58256b44f$export$ed32643c9618a26, ({ place: place, theme: theme, small: small })=>(0, $1d9bd5c523349ec4$exports.css)([
        "visibility:hidden;position:absolute;z-index:1;width:max-content;max-width:240px;background:",
        ";border-radius:3px;padding:13px 16px;display:flex;justify-content:center;align-items:center;& ",
        "{",
        " font-weight:100;text-align:",
        ";color:",
        ';}::after{content:"";position:absolute;border-width:8px;border-style:solid;}',
        " ",
        " ",
        " ",
        ""
    ], theme.klerosUIComponentsPrimaryBlue, $48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledText, $48090fca70e3183a$var$$49a276e58256b44f$export$3c17b0e969a90510, small ? "center" : "left", theme.klerosUIComponentsWhiteBackground, place === "top" && (0, $1d9bd5c523349ec4$exports.css)([
        "bottom:calc(100% + 16px);left:50%;transform:translateX(-50%);::after{top:100%;left:50%;transform:translateX(-50%);border-color:",
        " transparent transparent transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "right" && (0, $1d9bd5c523349ec4$exports.css)([
        "top:50%;left:calc(100% + 16px);transform:translateY(-50%);::after{top:50%;right:100%;transform:translateY(-50%);border-color:transparent ",
        " transparent transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "bottom" && (0, $1d9bd5c523349ec4$exports.css)([
        "top:calc(100% + 16px);left:50%;transform:translateX(-50%);::after{left:50%;bottom:100%;transform:translateX(-50%);border-color:transparent transparent ",
        " transparent;}"
    ], theme.klerosUIComponentsPrimaryBlue), place === "left" && (0, $1d9bd5c523349ec4$exports.css)([
        "top:50%;right:calc(100% + 16px);transform:translateY(-50%);::after{top:50%;left:100%;transform:translateY(-50%);border-color:transparent transparent transparent ",
        ";}"
    ], theme.klerosUIComponentsPrimaryBlue)));
const $48090fca70e3183a$var$$4ceeceac8d19d80b$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "tooltip__Wrapper",
    componentId: "sc-2flh2z-2"
})([
    "position:relative;display:inline-block;&:hover ",
    "{visibility:visible;}"
], $48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledTooltip);
const $48090fca70e3183a$var$$4ceeceac8d19d80b$var$Tooltip = ({ place: place = "top", text: text, children: children, small: small, ...props })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$4ceeceac8d19d80b$var$Wrapper, {
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledTooltip, {
                small: small,
                place: place,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$4ceeceac8d19d80b$var$StyledText, {
                    children: text
                })
            })
        ]
    });
var $48090fca70e3183a$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$4ceeceac8d19d80b$var$Tooltip;
const $48090fca70e3183a$var$$a5329119b99a1727$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 16",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M13.776 2.06 12.129.44A1.536 1.536 0 0 0 11.05 0H5.587c-.841 0-1.524.672-1.524 1.5V3h-2.54C.684 3 0 3.672 0 4.5v10c0 .828.682 1.5 1.524 1.5h7.11c.843 0 1.525-.672 1.525-1.5V13h2.54c.841 0 1.523-.672 1.523-1.5V3.121c0-.398-.16-.779-.446-1.06ZM8.444 14.5h-6.73a.192.192 0 0 1-.134-.055.186.186 0 0 1-.056-.133V4.688c0-.05.02-.098.056-.133a.192.192 0 0 1 .134-.055h2.35v7c0 .828.682 1.5 1.523 1.5h3.048v1.313c0 .05-.02.097-.056.132a.192.192 0 0 1-.135.055Zm4.064-3h-6.73a.192.192 0 0 1-.135-.055.186.186 0 0 1-.056-.133V1.688c0-.05.02-.098.056-.133a.192.192 0 0 1 .135-.055h3.365v2.75c0 .414.341.75.762.75h2.793v6.313c0 .05-.02.097-.055.132a.192.192 0 0 1-.135.055Zm.19-8h-2.031v-2h.305c.051 0 .1.02.135.055l1.536 1.511a.186.186 0 0 1 .055.133V3.5Z",
            fill: "#009AFF"
        })
    });
var $48090fca70e3183a$var$$a5329119b99a1727$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$a5329119b99a1727$var$SvgCopy;
const $48090fca70e3183a$var$$24ee0e3ed5abf092$var$SvgCopied = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
            clipPath: "url('#clip0_13289_179292')",
            children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 8.5a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8.5Zm1.357 0a6.644 6.644 0 0 0 13.286 0 6.644 6.644 0 0 0-13.286 0Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 11.1a.567.567 0 0 1-.923 0L4.545 8.016a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z",
                fill: "#009AFF"
            })
        })
    });
var $48090fca70e3183a$var$$24ee0e3ed5abf092$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$24ee0e3ed5abf092$var$SvgCopied;
const $48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$Wrapper = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "copiable__Wrapper",
    componentId: "sc-3t2xjv-0"
})([
    "position:relative;display:inline-flex;align-items:center;gap:8px;flex-direction:",
    ";"
], ({ iconPlacement: iconPlacement })=>iconPlacement === "left" ? "row-reverse" : "row");
const $48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$StyledTooltip = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports)($48090fca70e3183a$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039).withConfig({
    displayName: "copiable__StyledTooltip",
    componentId: "sc-3t2xjv-1"
})([
    "> span{padding:8px;}"
]);
const $48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$IconContainer = $48090fca70e3183a$var$$parcel$interopDefault($1d9bd5c523349ec4$exports).div.withConfig({
    displayName: "copiable__IconContainer",
    componentId: "sc-3t2xjv-2"
})([
    "cursor:pointer;display:flex;align-items:center;width:16px;height:16px;"
]);
/**
 * @description Wraps a component to make it copiable.
 * @param copiableContent The text to be copied to user's clipboard
 * @param info Modify the message displayed in the copy button's tooltip
 * @param tooltipProps Copy button's tooltip props
 */ const $48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$Copiable = ({ copiableContent: copiableContent, info: info, children: children, tooltipProps: tooltipProps, iconPlacement: iconPlacement = "right", ...props })=>{
    const [isCopied, setIsCopied] = (0, $9nZCP.useState)(false);
    const handleCopy = ()=>{
        navigator.clipboard.writeText(copiableContent).then(()=>{
            setIsCopied(true);
            setTimeout(()=>setIsCopied(false), 2000);
        }).catch(()=>setIsCopied(false));
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$Wrapper, {
        ...props,
        iconPlacement: iconPlacement,
        children: [
            children,
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$StyledTooltip, {
                text: isCopied ? "Copied!" : `${info ?? "Copy"}`,
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$IconContainer, {
                    className: "icon-container",
                    children: isCopied ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$24ee0e3ed5abf092$export$2e2bcd8739ae039, {
                        className: "copied-icon"
                    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($48090fca70e3183a$var$$a5329119b99a1727$export$2e2bcd8739ae039, {
                        className: "copy-icon",
                        onClick: handleCopy
                    })
                })
            })
        ]
    });
};
var $48090fca70e3183a$var$$f9cf7fe05b87a0bc$export$2e2bcd8739ae039 = $48090fca70e3183a$var$$f9cf7fe05b87a0bc$var$Copiable;
const $48090fca70e3183a$var$$18386f08588a981e$export$f30cb9bc4f736419 = {
    klerosUIComponentsPrimaryPurple: "#4D00B4",
    klerosUIComponentsSecondaryPurple: "#9013FE",
    klerosUIComponentsMediumPurple: "#F8F1FF",
    klerosUIComponentsLightPurple: "#FBF9FE",
    klerosUIComponentsPrimaryBlue: "#009AFF",
    klerosUIComponentsSecondaryBlue: "#7BCBFF",
    klerosUIComponentsMediumBlue: "#F0F9FF",
    klerosUIComponentsLightBlue: "#FCFEFF",
    klerosUIComponentsPrimaryText: "#333333",
    klerosUIComponentsSecondaryText: "#999999",
    klerosUIComponentsStroke: "#e5e5e5",
    klerosUIComponentsLightGrey: "#FAFAFA",
    klerosUIComponentsWhiteBackground: "#FFFFFF",
    klerosUIComponentsLightBackground: "#FAFBFC",
    klerosUIComponentsDefaultShadow: "#00000002",
    klerosUIComponentsHoveredShadow: "#00000002",
    klerosUIComponentsSuccess: "#00C42B",
    klerosUIComponentsSuccessLight: "#F0FBF2",
    klerosUIComponentsWarning: "#FF9900",
    klerosUIComponentsWarningLight: "#FFF9F0",
    klerosUIComponentsError: "#F60C36",
    klerosUIComponentsErrorLight: "#FEFF0F3",
    klerosUIComponentsTint: "#D14EFF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#F4F0FA",
    klerosUIComponentsTransitionSpeed: "0.25s"
};
const $48090fca70e3183a$var$$18386f08588a981e$export$3e936a8db52a10a0 = {
    klerosUIComponentsPrimaryPurple: "#7E1BD4",
    klerosUIComponentsSecondaryPurple: "#B45FFF",
    klerosUIComponentsMediumPurple: "#390F6C",
    klerosUIComponentsLightPurple: "#FCFBFF",
    klerosUIComponentsPrimaryBlue: "#6CC5FF",
    klerosUIComponentsSecondaryBlue: "#A5DBFF",
    klerosUIComponentsMediumBlue: "#2E206C",
    klerosUIComponentsLightBlue: "#2A1260",
    klerosUIComponentsPrimaryText: "#DAF0FF",
    klerosUIComponentsSecondaryText: "#BECCE5",
    klerosUIComponentsStroke: "#42498F",
    klerosUIComponentsLightGrey: "#2D1865",
    klerosUIComponentsWhiteBackground: "#220050",
    klerosUIComponentsLightBackground: "#1B003F",
    klerosUIComponentsDefaultShadow: "#00000000",
    klerosUIComponentsHoveredShadow: "#42498f80",
    klerosUIComponentsSuccess: "#65DC7F",
    klerosUIComponentsSuccessLight: "#32355B",
    klerosUIComponentsWarning: "#FFC46B",
    klerosUIComponentsWarningLight: "#451F54",
    klerosUIComponentsError: "#FF5A78",
    klerosUIComponentsErrorLight: "#360652",
    klerosUIComponentsTint: "#DDB6FF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#2F0960",
    klerosUIComponentsTransitionSpeed: "0.25s"
};
const $48090fca70e3183a$var$$18386f08588a981e$export$a183395ddd946500 = {
    klerosUIComponentsPrimaryPurple: "#200F47",
    klerosUIComponentsSecondaryPurple: "#B45FFF",
    klerosUIComponentsMediumPurple: "#390F6C",
    klerosUIComponentsLightPurple: "#FCFBFF",
    klerosUIComponentsPrimaryBlue: "#69C3FC",
    klerosUIComponentsSecondaryBlue: "#A5DBFF",
    klerosUIComponentsMediumBlue: "#2E206C",
    klerosUIComponentsLightBlue: "#2A1260",
    klerosUIComponentsPrimaryText: "#DAF0FF",
    klerosUIComponentsSecondaryText: "#BECCE5",
    klerosUIComponentsStroke: "#42498F",
    klerosUIComponentsLightGrey: "#2D1865",
    klerosUIComponentsWhiteBackground: "#200F47",
    klerosUIComponentsLightBackground: "#1B003F",
    klerosUIComponentsDefaultShadow: "#00000000",
    klerosUIComponentsHoveredShadow: "#42498f80",
    klerosUIComponentsSuccess: "#65DC7F",
    klerosUIComponentsSuccessLight: "#32355B",
    klerosUIComponentsWarning: "#FFC46B",
    klerosUIComponentsWarningLight: "#451F54",
    klerosUIComponentsError: "#FF5A78",
    klerosUIComponentsErrorLight: "#360652",
    klerosUIComponentsTint: "#DDB6FF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#2F0960",
    klerosUIComponentsTransitionSpeed: "0.25s"
};


const $1b611c410e894fcf$export$bca14c5b3b88a9c9 = {
    ...(0, $48090fca70e3183a$exports.veaTheme),
    color: {
        pink: "#FAD3F1",
        light: "#FFFDF5",
        dark: "#1B003F",
        white: "#FFFFFF",
        black: "#000000",
        blue: "#69C3FC",
        purple: "#1F0847",
        grey: "#E5E5E5",
        lightBlue: "#BECCE5",
        secondaryBlue: "#42498F",
        secondaryPurple: "#200F47",
        lightRed: "#FF5A78",
        lightYellow: "#FFC46B",
        turquoise: "#6CC5FF",
        lightPurple: "#B45FFF",
        darkBlue: "#7E93FF",
        smoke: "#BECCE5",
        teal: "#00B8C4",
        green: "#65DC7F",
        midnightPurple: "#2E206C"
    }
};



var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");
function $1cff464e624b80ba$export$2e2bcd8739ae039(fn, ms) {
    if (ms === void 0) ms = 0;
    var ready = (0, $9nZCP.useRef)(false);
    var timeout = (0, $9nZCP.useRef)();
    var callback = (0, $9nZCP.useRef)(fn);
    var isReady = (0, $9nZCP.useCallback)(function() {
        return ready.current;
    }, []);
    var set = (0, $9nZCP.useCallback)(function() {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function() {
            ready.current = true;
            callback.current();
        }, ms);
    }, [
        ms
    ]);
    var clear = (0, $9nZCP.useCallback)(function() {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0, $9nZCP.useEffect)(function() {
        callback.current = fn;
    }, [
        fn
    ]);
    // set on mount, clear on unmount
    (0, $9nZCP.useEffect)(function() {
        set();
        return clear;
    }, [
        ms
    ]);
    return [
        isReady,
        clear,
        set
    ];
}


function $c171e39a1b1b690a$export$2e2bcd8739ae039(fn, ms, deps) {
    if (ms === void 0) ms = 0;
    if (deps === void 0) deps = [];
    var _a = (0, $1cff464e624b80ba$export$2e2bcd8739ae039)(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0, $9nZCP.useEffect)(reset, deps);
    return [
        isReady,
        cancel
    ];
}


function $031bf8eb906204f4$export$130bc0efb3cce789(_documentNode, fragmentType) {
    return fragmentType;
}
function $031bf8eb906204f4$export$4659cb8f146075(data, _fragment) {
    return data;
}


/* eslint-disable */ /* eslint-disable */ var $2bf8839f3a24a132$export$ab21e504f34ceea6 = /*#__PURE__*/ function(Challenge_OrderBy) {
    Challenge_OrderBy["Challenger"] = "challenger";
    Challenge_OrderBy["Claim"] = "claim";
    Challenge_OrderBy["ClaimBridger"] = "claim__bridger";
    Challenge_OrderBy["ClaimChallenged"] = "claim__challenged";
    Challenge_OrderBy["ClaimEpoch"] = "claim__epoch";
    Challenge_OrderBy["ClaimHonest"] = "claim__honest";
    Challenge_OrderBy["ClaimId"] = "claim__id";
    Challenge_OrderBy["ClaimStateroot"] = "claim__stateroot";
    Challenge_OrderBy["ClaimTimestamp"] = "claim__timestamp";
    Challenge_OrderBy["ClaimTxHash"] = "claim__txHash";
    Challenge_OrderBy["ClaimVerified"] = "claim__verified";
    Challenge_OrderBy["Honest"] = "honest";
    Challenge_OrderBy["Id"] = "id";
    Challenge_OrderBy["Timestamp"] = "timestamp";
    Challenge_OrderBy["TxHash"] = "txHash";
    return Challenge_OrderBy;
}({});
var $2bf8839f3a24a132$export$360e73a0506f34a4 = /*#__PURE__*/ function(Claim_OrderBy) {
    Claim_OrderBy["Bridger"] = "bridger";
    Claim_OrderBy["Challenge"] = "challenge";
    Claim_OrderBy["ChallengeChallenger"] = "challenge__challenger";
    Claim_OrderBy["ChallengeHonest"] = "challenge__honest";
    Claim_OrderBy["ChallengeId"] = "challenge__id";
    Claim_OrderBy["ChallengeTimestamp"] = "challenge__timestamp";
    Claim_OrderBy["ChallengeTxHash"] = "challenge__txHash";
    Claim_OrderBy["Challenged"] = "challenged";
    Claim_OrderBy["Epoch"] = "epoch";
    Claim_OrderBy["Honest"] = "honest";
    Claim_OrderBy["Id"] = "id";
    Claim_OrderBy["Stateroot"] = "stateroot";
    Claim_OrderBy["Timestamp"] = "timestamp";
    Claim_OrderBy["TxHash"] = "txHash";
    Claim_OrderBy["Verification"] = "verification";
    Claim_OrderBy["VerificationCaller"] = "verification__caller";
    Claim_OrderBy["VerificationId"] = "verification__id";
    Claim_OrderBy["VerificationTimestamp"] = "verification__timestamp";
    Claim_OrderBy["VerificationTxHash"] = "verification__txHash";
    Claim_OrderBy["Verified"] = "verified";
    return Claim_OrderBy;
}({});
var $2bf8839f3a24a132$export$ccad0d1b2db8c978 = /*#__PURE__*/ function(Fallback_OrderBy) {
    Fallback_OrderBy["Executor"] = "executor";
    Fallback_OrderBy["Id"] = "id";
    Fallback_OrderBy["Snapshot"] = "snapshot";
    Fallback_OrderBy["SnapshotCaller"] = "snapshot__caller";
    Fallback_OrderBy["SnapshotEpoch"] = "snapshot__epoch";
    Fallback_OrderBy["SnapshotEpochString"] = "snapshot__epochString";
    Fallback_OrderBy["SnapshotId"] = "snapshot__id";
    Fallback_OrderBy["SnapshotNumberMessages"] = "snapshot__numberMessages";
    Fallback_OrderBy["SnapshotResolving"] = "snapshot__resolving";
    Fallback_OrderBy["SnapshotStateRoot"] = "snapshot__stateRoot";
    Fallback_OrderBy["SnapshotStateRootString"] = "snapshot__stateRootString";
    Fallback_OrderBy["SnapshotTaken"] = "snapshot__taken";
    Fallback_OrderBy["SnapshotTimestamp"] = "snapshot__timestamp";
    Fallback_OrderBy["SnapshotTxHash"] = "snapshot__txHash";
    Fallback_OrderBy["TicketId"] = "ticketId";
    Fallback_OrderBy["Timestamp"] = "timestamp";
    Fallback_OrderBy["TxHash"] = "txHash";
    return Fallback_OrderBy;
}({});
var $2bf8839f3a24a132$export$7a57d8e085da290 = /*#__PURE__*/ function(Message_OrderBy) {
    Message_OrderBy["Data"] = "data";
    Message_OrderBy["From"] = "from";
    Message_OrderBy["Id"] = "id";
    Message_OrderBy["Proof"] = "proof";
    Message_OrderBy["Relayer"] = "relayer";
    Message_OrderBy["Snapshot"] = "snapshot";
    Message_OrderBy["SnapshotCaller"] = "snapshot__caller";
    Message_OrderBy["SnapshotEpoch"] = "snapshot__epoch";
    Message_OrderBy["SnapshotEpochString"] = "snapshot__epochString";
    Message_OrderBy["SnapshotId"] = "snapshot__id";
    Message_OrderBy["SnapshotNumberMessages"] = "snapshot__numberMessages";
    Message_OrderBy["SnapshotResolving"] = "snapshot__resolving";
    Message_OrderBy["SnapshotStateRoot"] = "snapshot__stateRoot";
    Message_OrderBy["SnapshotStateRootString"] = "snapshot__stateRootString";
    Message_OrderBy["SnapshotTaken"] = "snapshot__taken";
    Message_OrderBy["SnapshotTimestamp"] = "snapshot__timestamp";
    Message_OrderBy["SnapshotTxHash"] = "snapshot__txHash";
    Message_OrderBy["Timestamp"] = "timestamp";
    Message_OrderBy["To"] = "to";
    Message_OrderBy["TxHash"] = "txHash";
    return Message_OrderBy;
}({});
var $2bf8839f3a24a132$export$6576b9de878968d6 = /*#__PURE__*/ function(OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
    return OrderDirection;
}({});
var $2bf8839f3a24a132$export$b0d48e1184eac70d = /*#__PURE__*/ function(Ref_OrderBy) {
    Ref_OrderBy["CurrentSnapshotIndex"] = "currentSnapshotIndex";
    Ref_OrderBy["Id"] = "id";
    Ref_OrderBy["NextMessageIndex"] = "nextMessageIndex";
    Ref_OrderBy["TotalChallenges"] = "totalChallenges";
    Ref_OrderBy["TotalClaims"] = "totalClaims";
    Ref_OrderBy["TotalMessages"] = "totalMessages";
    return Ref_OrderBy;
}({});
var $2bf8839f3a24a132$export$f4df7d3385133029 = /*#__PURE__*/ function(Snapshot_OrderBy) {
    Snapshot_OrderBy["Caller"] = "caller";
    Snapshot_OrderBy["Epoch"] = "epoch";
    Snapshot_OrderBy["EpochString"] = "epochString";
    Snapshot_OrderBy["Fallback"] = "fallback";
    Snapshot_OrderBy["Id"] = "id";
    Snapshot_OrderBy["Messages"] = "messages";
    Snapshot_OrderBy["NumberMessages"] = "numberMessages";
    Snapshot_OrderBy["Resolving"] = "resolving";
    Snapshot_OrderBy["StateRoot"] = "stateRoot";
    Snapshot_OrderBy["StateRootString"] = "stateRootString";
    Snapshot_OrderBy["Taken"] = "taken";
    Snapshot_OrderBy["Timestamp"] = "timestamp";
    Snapshot_OrderBy["TxHash"] = "txHash";
    return Snapshot_OrderBy;
}({});
var $2bf8839f3a24a132$export$33fd1948388e1327 = /*#__PURE__*/ function(Verification_OrderBy) {
    Verification_OrderBy["Caller"] = "caller";
    Verification_OrderBy["Claim"] = "claim";
    Verification_OrderBy["ClaimBridger"] = "claim__bridger";
    Verification_OrderBy["ClaimChallenged"] = "claim__challenged";
    Verification_OrderBy["ClaimEpoch"] = "claim__epoch";
    Verification_OrderBy["ClaimHonest"] = "claim__honest";
    Verification_OrderBy["ClaimId"] = "claim__id";
    Verification_OrderBy["ClaimStateroot"] = "claim__stateroot";
    Verification_OrderBy["ClaimTimestamp"] = "claim__timestamp";
    Verification_OrderBy["ClaimTxHash"] = "claim__txHash";
    Verification_OrderBy["ClaimVerified"] = "claim__verified";
    Verification_OrderBy["Id"] = "id";
    Verification_OrderBy["Timestamp"] = "timestamp";
    Verification_OrderBy["TxHash"] = "txHash";
    return Verification_OrderBy;
}({});
var $2bf8839f3a24a132$export$ac48b316845cbda1 = /*#__PURE__*/ function(_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */ _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */ _SubgraphErrorPolicy_["Deny"] = "deny";
    return _SubgraphErrorPolicy_;
}({});
const $2bf8839f3a24a132$export$2da192d422e27a44 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getSnapshot"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "epoch"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "snapshots"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "epoch"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "epoch"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "caller"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateRoot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberMessages"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "taken"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "resolving"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fallback"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderBy"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "timestamp"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderDirection"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "desc"
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "executor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "ticketId"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $2bf8839f3a24a132$export$661c79e1579025a1 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "snapshots"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "caller"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateRoot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberMessages"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "taken"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "resolving"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fallback"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderBy"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "timestamp"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderDirection"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "desc"
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "executor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "ticketId"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "ref"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "0",
                                    block: false
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "currentSnapshotIndex"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $2bf8839f3a24a132$export$f00557595eb44af0 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getResolvingSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "resolving"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Boolean"
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "snapshots"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "resolving"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "resolving"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "caller"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateRoot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberMessages"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "taken"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "resolving"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fallback"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderBy"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "timestamp"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderDirection"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "desc"
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "executor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "ticketId"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "ref"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "0",
                                    block: false
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "currentSnapshotIndex"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $2bf8839f3a24a132$export$f02dcd6965c925b3 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "searchSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "value"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "snapshotQuery"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "text"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "value"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "caller"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateRoot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberMessages"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "taken"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "resolving"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fallback"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderBy"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "timestamp"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderDirection"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "desc"
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "executor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "ticketId"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $2bf8839f3a24a132$export$9ef9a9e5468b4145 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getMessages"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "skip"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshot"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotID"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "messages"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "5"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "skip"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "skip"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "snapshot"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "snapshot"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "from"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "to"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "snapshot"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotID"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberMessages"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $2bf8839f3a24a132$export$1b2b78f6cf8e0aa9 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getClaim"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "epoch"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "claims"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "epoch"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "epoch"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateroot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bridger"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenged"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenge"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "challenger"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honest"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verification"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "caller"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $2bf8839f3a24a132$export$295d5fe4e44dcaf9 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getClaimedSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "claims"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "verified"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: false
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "challenged"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: false
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateroot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bridger"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenged"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenge"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "challenger"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honest"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verification"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "caller"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $2bf8839f3a24a132$export$6cf6d16829b07a05 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getChallengedSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "claims"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "verified"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: false
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "challenged"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: true
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateroot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bridger"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenged"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenge"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "challenger"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honest"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verification"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "caller"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $2bf8839f3a24a132$export$7f90a767e154c062 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getVerifiedSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "claims"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "verified"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: true
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "challenged"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: false
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateroot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bridger"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenged"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenge"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "challenger"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honest"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verification"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "caller"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $2bf8839f3a24a132$export$d8931e5a8edc5f3 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getResolvedSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "claims"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "verified"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: true
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "challenged"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: true
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateroot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bridger"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenged"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenge"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "challenger"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honest"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verification"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "caller"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $2bf8839f3a24a132$export$7c3db7ddc7684a8c = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getRelay"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "message"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "relayer"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "proof"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 */ const $350dfc1de15a315a$var$documents = {
    "\n  query getSnapshot($epoch: BigInt!) {\n    snapshots(where: { epoch: $epoch }) {\n      id\n      epoch\n      caller\n      txHash\n      timestamp\n      stateRoot\n      numberMessages\n      taken\n      resolving\n      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {\n        executor\n        timestamp\n        txHash\n        ticketId\n      }\n    }\n  }\n": $2bf8839f3a24a132$export$2da192d422e27a44,
    '\n  query getSnapshots($snapshotsPerPage: Int, $lastTimestamp: BigInt!) {\n    snapshots(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: { timestamp_lte: $lastTimestamp }\n    ) {\n      id\n      epoch\n      caller\n      txHash\n      timestamp\n      stateRoot\n      numberMessages\n      taken\n      resolving\n      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {\n        executor\n        timestamp\n        txHash\n        ticketId\n      }\n    }\n    ref(id: "0") {\n      currentSnapshotIndex\n    }\n  }\n': $2bf8839f3a24a132$export$661c79e1579025a1,
    '\n  query getResolvingSnapshots(\n    $snapshotsPerPage: Int\n    $lastTimestamp: BigInt!\n    $resolving: Boolean\n  ) {\n    snapshots(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: { timestamp_lte: $lastTimestamp, resolving: $resolving }\n    ) {\n      id\n      epoch\n      caller\n      txHash\n      timestamp\n      stateRoot\n      numberMessages\n      taken\n      resolving\n      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {\n        executor\n        timestamp\n        txHash\n        ticketId\n      }\n    }\n    ref(id: "0") {\n      currentSnapshotIndex\n    }\n  }\n': $2bf8839f3a24a132$export$f00557595eb44af0,
    "\n  query searchSnapshots($snapshotsPerPage: Int, $value: String!) {\n    snapshotQuery(text: $value, first: $snapshotsPerPage) {\n      id\n      epoch\n      caller\n      txHash\n      timestamp\n      stateRoot\n      numberMessages\n      taken\n      resolving\n      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {\n        executor\n        timestamp\n        txHash\n        ticketId\n      }\n    }\n  }\n": $2bf8839f3a24a132$export$f02dcd6965c925b3,
    "\n  query getMessages($skip: Int!, $snapshot: String!, $snapshotID: ID!) {\n    messages(\n      first: 5\n      skip: $skip\n      orderBy: timestamp\n      orderDirection: desc\n      where: { snapshot: $snapshot }\n    ) {\n      id\n      txHash\n      timestamp\n      from\n      to\n      data\n    }\n    snapshot(id: $snapshotID) {\n      numberMessages\n    }\n  }\n": $2bf8839f3a24a132$export$9ef9a9e5468b4145,
    "\n  query getClaim($epoch: BigInt!) {\n    claims(where: { epoch: $epoch }) {\n      id\n      epoch\n      timestamp\n      stateroot\n      bridger\n      challenged\n      verified\n      txHash\n      challenge {\n        id\n        timestamp\n        challenger\n        honest\n        txHash\n      }\n      verification {\n        timestamp\n        caller\n        txHash\n      }\n    }\n  }\n": $2bf8839f3a24a132$export$1b2b78f6cf8e0aa9,
    "\n  query getClaimedSnapshots($snapshotsPerPage: Int, $lastTimestamp: BigInt!) {\n    claims(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: {\n        timestamp_lte: $lastTimestamp\n        verified: false\n        challenged: false\n      }\n    ) {\n      id\n      epoch\n      timestamp\n      stateroot\n      bridger\n      challenged\n      verified\n      txHash\n      challenge {\n        id\n        timestamp\n        challenger\n        honest\n        txHash\n      }\n      verification {\n        timestamp\n        caller\n        txHash\n      }\n    }\n  }\n": $2bf8839f3a24a132$export$295d5fe4e44dcaf9,
    "\n  query getChallengedSnapshots(\n    $snapshotsPerPage: Int\n    $lastTimestamp: BigInt!\n  ) {\n    claims(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: {\n        timestamp_lte: $lastTimestamp\n        verified: false\n        challenged: true\n      }\n    ) {\n      id\n      epoch\n      timestamp\n      stateroot\n      bridger\n      challenged\n      verified\n      txHash\n      challenge {\n        id\n        timestamp\n        challenger\n        honest\n        txHash\n      }\n      verification {\n        timestamp\n        caller\n        txHash\n      }\n    }\n  }\n": $2bf8839f3a24a132$export$6cf6d16829b07a05,
    "\n  query getVerifiedSnapshots($snapshotsPerPage: Int, $lastTimestamp: BigInt!) {\n    claims(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: {\n        timestamp_lte: $lastTimestamp\n        verified: true\n        challenged: false\n      }\n    ) {\n      id\n      epoch\n      timestamp\n      stateroot\n      bridger\n      challenged\n      verified\n      txHash\n      challenge {\n        id\n        timestamp\n        challenger\n        honest\n        txHash\n      }\n      verification {\n        timestamp\n        caller\n        txHash\n      }\n    }\n  }\n": $2bf8839f3a24a132$export$7f90a767e154c062,
    "\n  query getResolvedSnapshots($snapshotsPerPage: Int, $lastTimestamp: BigInt!) {\n    claims(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: { timestamp_lte: $lastTimestamp, verified: true, challenged: true }\n    ) {\n      id\n      epoch\n      timestamp\n      stateroot\n      bridger\n      challenged\n      verified\n      txHash\n      challenge {\n        id\n        timestamp\n        challenger\n        honest\n        txHash\n      }\n      verification {\n        timestamp\n        caller\n        txHash\n      }\n    }\n  }\n": $2bf8839f3a24a132$export$d8931e5a8edc5f3,
    "\n  query getRelay($id: ID!) {\n    message(id: $id) {\n      timestamp\n      txHash\n      relayer\n      proof\n    }\n  }\n": $2bf8839f3a24a132$export$7c3db7ddc7684a8c
};
function $350dfc1de15a315a$export$1eb4e7c0ed67b035(source) {
    return $350dfc1de15a315a$var$documents[source] ?? {};
}




const $a03d6ffb912da58e$export$2532f3c0a33feede = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query getSnapshot($epoch: BigInt!) {
    snapshots(where: { epoch: $epoch }) {
      id
      epoch
      caller
      txHash
      timestamp
      stateRoot
      numberMessages
      taken
      resolving
      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {
        executor
        timestamp
        txHash
        ticketId
      }
    }
  }
`);
const $a03d6ffb912da58e$export$2c215692068227d4 = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query getSnapshots($snapshotsPerPage: Int, $lastTimestamp: BigInt!) {
    snapshots(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: { timestamp_lte: $lastTimestamp }
    ) {
      id
      epoch
      caller
      txHash
      timestamp
      stateRoot
      numberMessages
      taken
      resolving
      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {
        executor
        timestamp
        txHash
        ticketId
      }
    }
    ref(id: "0") {
      currentSnapshotIndex
    }
  }
`);
const $a03d6ffb912da58e$export$1e6b7e1acb4f66ff = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query getResolvingSnapshots(
    $snapshotsPerPage: Int
    $lastTimestamp: BigInt!
    $resolving: Boolean
  ) {
    snapshots(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: { timestamp_lte: $lastTimestamp, resolving: $resolving }
    ) {
      id
      epoch
      caller
      txHash
      timestamp
      stateRoot
      numberMessages
      taken
      resolving
      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {
        executor
        timestamp
        txHash
        ticketId
      }
    }
    ref(id: "0") {
      currentSnapshotIndex
    }
  }
`);
const $a03d6ffb912da58e$export$a92bfde441f2bbcc = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query searchSnapshots($snapshotsPerPage: Int, $value: String!) {
    snapshotQuery(text: $value, first: $snapshotsPerPage) {
      id
      epoch
      caller
      txHash
      timestamp
      stateRoot
      numberMessages
      taken
      resolving
      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {
        executor
        timestamp
        txHash
        ticketId
      }
    }
  }
`);



const $73d2804eda3376a0$export$4f062a25be074082 = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query getClaim($epoch: BigInt!) {
    claims(where: { epoch: $epoch }) {
      id
      epoch
      timestamp
      stateroot
      bridger
      challenged
      verified
      txHash
      challenge {
        id
        timestamp
        challenger
        honest
        txHash
      }
      verification {
        timestamp
        caller
        txHash
      }
    }
  }
`);
const $73d2804eda3376a0$export$88ae1b33958ad484 = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query getClaimedSnapshots($snapshotsPerPage: Int, $lastTimestamp: BigInt!) {
    claims(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: {
        timestamp_lte: $lastTimestamp
        verified: false
        challenged: false
      }
    ) {
      id
      epoch
      timestamp
      stateroot
      bridger
      challenged
      verified
      txHash
      challenge {
        id
        timestamp
        challenger
        honest
        txHash
      }
      verification {
        timestamp
        caller
        txHash
      }
    }
  }
`);
const $73d2804eda3376a0$export$1353c1ff75d0de84 = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query getChallengedSnapshots(
    $snapshotsPerPage: Int
    $lastTimestamp: BigInt!
  ) {
    claims(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: {
        timestamp_lte: $lastTimestamp
        verified: false
        challenged: true
      }
    ) {
      id
      epoch
      timestamp
      stateroot
      bridger
      challenged
      verified
      txHash
      challenge {
        id
        timestamp
        challenger
        honest
        txHash
      }
      verification {
        timestamp
        caller
        txHash
      }
    }
  }
`);
const $73d2804eda3376a0$export$b7a4a1257ef277eb = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query getVerifiedSnapshots($snapshotsPerPage: Int, $lastTimestamp: BigInt!) {
    claims(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: {
        timestamp_lte: $lastTimestamp
        verified: true
        challenged: false
      }
    ) {
      id
      epoch
      timestamp
      stateroot
      bridger
      challenged
      verified
      txHash
      challenge {
        id
        timestamp
        challenger
        honest
        txHash
      }
      verification {
        timestamp
        caller
        txHash
      }
    }
  }
`);
const $73d2804eda3376a0$export$a098f315450cf75c = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query getResolvedSnapshots($snapshotsPerPage: Int, $lastTimestamp: BigInt!) {
    claims(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: { timestamp_lte: $lastTimestamp, verified: true, challenged: true }
    ) {
      id
      epoch
      timestamp
      stateroot
      bridger
      challenged
      verified
      txHash
      challenge {
        id
        timestamp
        challenger
        honest
        txHash
      }
      verification {
        timestamp
        caller
        txHash
      }
    }
  }
`);


const $e2024cd18f4cfc15$var$InboxQueries = [
    (0, $a03d6ffb912da58e$export$2c215692068227d4),
    (0, $a03d6ffb912da58e$export$1e6b7e1acb4f66ff)
];
const $e2024cd18f4cfc15$export$219a9e7e4111be17 = (query)=>$e2024cd18f4cfc15$var$InboxQueries.includes(query);
const $e2024cd18f4cfc15$var$OutboxQueries = [
    (0, $73d2804eda3376a0$export$88ae1b33958ad484),
    (0, $73d2804eda3376a0$export$a098f315450cf75c),
    (0, $73d2804eda3376a0$export$b7a4a1257ef277eb),
    (0, $73d2804eda3376a0$export$1353c1ff75d0de84)
];
const $e2024cd18f4cfc15$export$e37e4333115c69c8 = (query)=>$e2024cd18f4cfc15$var$OutboxQueries.includes(query);
var $e2024cd18f4cfc15$export$11e75bce9f7ea886 = /*#__PURE__*/ function(ORDER) {
    ORDER[ORDER["firstInbox"] = 0] = "firstInbox";
    ORDER[ORDER["firstOutbox"] = 1] = "firstOutbox";
    return ORDER;
}({});
const $e2024cd18f4cfc15$var$STATUS_FILTERS = [
    {
        item: {
            text: "All",
            dot: (0, $1b611c410e894fcf$export$bca14c5b3b88a9c9).color.white,
            value: 0
        },
        queryInfo: {
            order: 0,
            query: (0, $a03d6ffb912da58e$export$2c215692068227d4)
        }
    },
    {
        item: {
            text: "Claimed",
            dot: (0, $1b611c410e894fcf$export$bca14c5b3b88a9c9).color.turquoise,
            value: 1
        },
        queryInfo: {
            order: 1,
            query: (0, $73d2804eda3376a0$export$88ae1b33958ad484)
        }
    },
    {
        item: {
            text: "Challenged",
            dot: (0, $1b611c410e894fcf$export$bca14c5b3b88a9c9).color.lightPurple,
            value: 2
        },
        queryInfo: {
            order: 1,
            query: (0, $73d2804eda3376a0$export$1353c1ff75d0de84)
        }
    },
    {
        item: {
            text: "Verified",
            dot: (0, $1b611c410e894fcf$export$bca14c5b3b88a9c9).color.darkBlue,
            value: 3
        },
        queryInfo: {
            order: 1,
            query: (0, $73d2804eda3376a0$export$b7a4a1257ef277eb)
        }
    },
    {
        item: {
            text: "Resolving",
            dot: (0, $1b611c410e894fcf$export$bca14c5b3b88a9c9).color.teal,
            value: 4
        },
        queryInfo: {
            order: 0,
            query: (0, $a03d6ffb912da58e$export$1e6b7e1acb4f66ff)
        }
    },
    {
        item: {
            text: "Resolved",
            dot: (0, $1b611c410e894fcf$export$bca14c5b3b88a9c9).color.green,
            value: 5
        },
        queryInfo: {
            order: 1,
            query: (0, $73d2804eda3376a0$export$a098f315450cf75c)
        }
    }
];
const $e2024cd18f4cfc15$var$Context = /*#__PURE__*/ (0, $9nZCP.createContext)({
    search: "",
    setSearch: ()=>{
    //
    },
    debouncedSearch: "",
    fromChain: 0,
    toChain: 0,
    statusFilter: 0,
    setFromChain: ()=>{
    //
    },
    setToChain: ()=>{
    //
    },
    setStatusFilter: ()=>{
    //
    },
    statusItems: [],
    queryInfo: {
        order: 0,
        query: (0, $a03d6ffb912da58e$export$2c215692068227d4)
    }
});
const $e2024cd18f4cfc15$export$2e3feefe77201a07 = ({ children: children })=>{
    const [fromChain, setFromChain] = (0, $9nZCP.useState)(0);
    const [toChain, setToChain] = (0, $9nZCP.useState)(0);
    const [statusFilter, setStatusFilter] = (0, $9nZCP.useState)(0);
    const [search, setSearch] = (0, $9nZCP.useState)("");
    const [debouncedSearch, setDebouncedSearch] = (0, $9nZCP.useState)("");
    (0, $c171e39a1b1b690a$export$2e2bcd8739ae039)(()=>setDebouncedSearch(search), 500, [
        search
    ]);
    const value = (0, $9nZCP.useMemo)(()=>({
            search: search,
            setSearch: setSearch,
            debouncedSearch: debouncedSearch,
            fromChain: fromChain,
            toChain: toChain,
            setFromChain: setFromChain,
            setToChain: setToChain,
            statusItems: $e2024cd18f4cfc15$var$STATUS_FILTERS.map((filter)=>filter.item),
            statusFilter: statusFilter,
            setStatusFilter: setStatusFilter,
            queryInfo: $e2024cd18f4cfc15$var$STATUS_FILTERS.find((filter)=>filter.item.value === statusFilter).queryInfo
        }), [
        search,
        debouncedSearch,
        fromChain,
        toChain,
        statusFilter
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($e2024cd18f4cfc15$var$Context.Provider, {
        value: value,
        children: [
            " ",
            children,
            " "
        ]
    });
};
const $e2024cd18f4cfc15$export$616ead5bf0ef583b = ()=>(0, $9nZCP.useContext)($e2024cd18f4cfc15$var$Context);





var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");
var $f9b717cc6867bacb$var$updateReducer = function(num) {
    return (num + 1) % 1000000;
};
function $f9b717cc6867bacb$export$2e2bcd8739ae039() {
    var _a = (0, $9nZCP.useReducer)($f9b717cc6867bacb$var$updateReducer, 0), update = _a[1];
    return update;
}


function $e903ffae55adc4ca$export$efbb6b4f12b20b5e(nextState, currentState) {
    if (typeof nextState === 'function') return nextState.length ? nextState(currentState) : nextState();
    return nextState;
}


function $32382191dee5902a$var$useList(initialList) {
    if (initialList === void 0) initialList = [];
    var list = (0, $9nZCP.useRef)((0, $e903ffae55adc4ca$export$efbb6b4f12b20b5e)(initialList));
    var update = (0, $f9b717cc6867bacb$export$2e2bcd8739ae039)();
    var actions = (0, $9nZCP.useMemo)(function() {
        var a = {
            set: function(newList) {
                list.current = (0, $e903ffae55adc4ca$export$efbb6b4f12b20b5e)(newList, list.current);
                update();
            },
            push: function() {
                var items = [];
                for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                items.length && actions.set(function(curr) {
                    return curr.concat(items);
                });
            },
            updateAt: function(index, item) {
                actions.set(function(curr) {
                    var arr = curr.slice();
                    arr[index] = item;
                    return arr;
                });
            },
            insertAt: function(index, item) {
                actions.set(function(curr) {
                    var arr = curr.slice();
                    index > arr.length ? arr[index] = item : arr.splice(index, 0, item);
                    return arr;
                });
            },
            update: function(predicate, newItem) {
                actions.set(function(curr) {
                    return curr.map(function(item) {
                        return predicate(item, newItem) ? newItem : item;
                    });
                });
            },
            updateFirst: function(predicate, newItem) {
                var index = list.current.findIndex(function(item) {
                    return predicate(item, newItem);
                });
                index >= 0 && actions.updateAt(index, newItem);
            },
            upsert: function(predicate, newItem) {
                var index = list.current.findIndex(function(item) {
                    return predicate(item, newItem);
                });
                index >= 0 ? actions.updateAt(index, newItem) : actions.push(newItem);
            },
            sort: function(compareFn) {
                actions.set(function(curr) {
                    return curr.slice().sort(compareFn);
                });
            },
            filter: function(callbackFn, thisArg) {
                actions.set(function(curr) {
                    return curr.slice().filter(callbackFn, thisArg);
                });
            },
            removeAt: function(index) {
                actions.set(function(curr) {
                    var arr = curr.slice();
                    arr.splice(index, 1);
                    return arr;
                });
            },
            clear: function() {
                actions.set([]);
            },
            reset: function() {
                actions.set((0, $e903ffae55adc4ca$export$efbb6b4f12b20b5e)(initialList).slice());
            }
        };
        /**
         * @deprecated Use removeAt method instead
         */ a.remove = a.removeAt;
        return a;
    }, []);
    return [
        list.current,
        actions
    ];
}
var $32382191dee5902a$export$2e2bcd8739ae039 = $32382191dee5902a$var$useList;




parcelRequire("9nZCP");



var $9nZCP = parcelRequire("9nZCP");



var $9nZCP = parcelRequire("9nZCP");


var $9nZCP = parcelRequire("9nZCP");
var $934ed287249205c1$export$8793edee2d425525 = function() {};
function $934ed287249205c1$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $934ed287249205c1$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $934ed287249205c1$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $934ed287249205c1$export$42e7ac6120dd324e = typeof navigator !== 'undefined';


var $0aa9c5ea5f98ac89$var$defaultEvents = [
    'mousedown',
    'touchstart'
];
var $0aa9c5ea5f98ac89$var$useClickAway = function(ref, onClickAway, events) {
    if (events === void 0) events = $0aa9c5ea5f98ac89$var$defaultEvents;
    var savedCallback = (0, $9nZCP.useRef)(onClickAway);
    (0, $9nZCP.useEffect)(function() {
        savedCallback.current = onClickAway;
    }, [
        onClickAway
    ]);
    (0, $9nZCP.useEffect)(function() {
        var handler = function(event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
            var eventName = events_1[_i];
            (0, $934ed287249205c1$export$af631764ddc44097)(document, eventName, handler);
        }
        return function() {
            for(var _i = 0, events_2 = events; _i < events_2.length; _i++){
                var eventName = events_2[_i];
                (0, $934ed287249205c1$export$8c8705df4a2dcec9)(document, eventName, handler);
            }
        };
    }, [
        events,
        ref
    ]);
};
var $0aa9c5ea5f98ac89$export$2e2bcd8739ae039 = $0aa9c5ea5f98ac89$var$useClickAway;


var $9nZCP = parcelRequire("9nZCP");
var $b2e41656ab938cc0$var$toggleReducer = function(state, nextValue) {
    return typeof nextValue === 'boolean' ? nextValue : !state;
};
var $b2e41656ab938cc0$var$useToggle = function(initialValue) {
    return (0, $9nZCP.useReducer)($b2e41656ab938cc0$var$toggleReducer, initialValue);
};
var $b2e41656ab938cc0$export$2e2bcd8739ae039 = $b2e41656ab938cc0$var$useToggle;



parcelRequire("9nZCP");

const $fb430e72b34fb485$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).a`
  display: block;
  font-family: "Open Sans";
  color: ${({ theme: theme })=>theme.color.lightBlue};
  text-decoration: none;
  svg {
    max-height: 16px;
    max-width: 16px;
    margin-right: 8px;
    fill: ${({ theme: theme })=>theme.color.lightBlue};
  }
  transition: fill 0.25s ease;

  :hover {
    cursor: pointer;
    color: ${({ theme: theme })=>theme.color.blue};
    transform: scale(1.0025);

    svg {
      fill: ${({ theme: theme })=>theme.color.blue};
    }
  }
`;
const $fb430e72b34fb485$var$MenuLink = ({ text: text, url: url, Icon: Icon })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($fb430e72b34fb485$var$Container, {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                children: text
            })
        ]
    });
};
var $fb430e72b34fb485$export$2e2bcd8739ae039 = $fb430e72b34fb485$var$MenuLink;



parcelRequire("9nZCP");
const $1a7d73f520054657$var$SvgQuestion = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#becce5",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
                clipPath: "url(#question_svg__a)",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    d: "M8 0a8.001 8.001 0 0 0 0 16A8.001 8.001 0 0 0 8 0m0 14.452A6.45 6.45 0 0 1 1.548 8 6.45 6.45 0 0 1 8 1.548 6.45 6.45 0 0 1 14.452 8 6.45 6.45 0 0 1 8 14.452m3.46-8.233c0 2.163-2.337 2.197-2.337 2.996v.204a.387.387 0 0 1-.387.387H7.264a.387.387 0 0 1-.387-.387V9.14c0-1.153.874-1.614 1.534-1.984.567-.318.914-.534.914-.955 0-.556-.71-.925-1.283-.925-.748 0-1.094.354-1.579.967a.387.387 0 0 1-.538.068l-.897-.68a.39.39 0 0 1-.085-.528c.762-1.12 1.732-1.748 3.244-1.748 1.583 0 3.273 1.235 3.273 2.864m-2.105 5.394c0 .747-.608 1.355-1.355 1.355a1.356 1.356 0 0 1-1.355-1.355c0-.747.608-1.355 1.355-1.355s1.355.608 1.355 1.355"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "question_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $1a7d73f520054657$export$2e2bcd8739ae039 = $1a7d73f520054657$var$SvgQuestion;



parcelRequire("9nZCP");
const $995ef6b5b1cded36$var$SvgBug = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
                clipPath: "url(#bug_svg__a)",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    d: "M16 9.028a1.013 1.013 0 0 1-1.02.972h-1.73v.5c0 .683-.153 1.33-.425 1.91l1.882 1.883a1 1 0 0 1-1.414 1.414l-1.71-1.71A4.48 4.48 0 0 1 8.75 15V7.375A.375.375 0 0 0 8.375 7h-.75a.375.375 0 0 0-.375.375V15a4.48 4.48 0 0 1-2.832-1.003l-1.71 1.71a1 1 0 0 1-1.415-1.414l1.882-1.882A4.5 4.5 0 0 1 2.75 10.5V10H1.02A1.014 1.014 0 0 1 0 9.028 1 1 0 0 1 1 8h1.75V6.164L1.293 4.707a1 1 0 0 1 1.414-1.414L4.414 5h7.172l1.707-1.707a1 1 0 0 1 1.414 1.414L13.25 6.164V8H15a1 1 0 0 1 1 1.028M8.03 0a3.5 3.5 0 0 0-3.5 3.5h7a3.5 3.5 0 0 0-3.5-3.5"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "bug_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $995ef6b5b1cded36$export$2e2bcd8739ae039 = $995ef6b5b1cded36$var$SvgBug;



parcelRequire("9nZCP");
const $02b4c994588d4394$var$SvgBook = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M14.838 11.25V.75c0-.416-.33-.75-.741-.75H3.965C2.328 0 1 1.344 1 3v10c0 1.656 1.328 3 2.965 3h10.132c.41 0 .74-.334.74-.75v-.5a.76.76 0 0 0-.274-.584c-.13-.482-.13-1.854 0-2.335a.75.75 0 0 0 .275-.581M4.954 4.188c0-.104.083-.188.185-.188h6.548c.102 0 .186.084.186.188v.625a.187.187 0 0 1-.186.187H5.14a.187.187 0 0 1-.185-.187zm0 2c0-.104.083-.188.185-.188h6.548c.102 0 .186.084.186.188v.625a.187.187 0 0 1-.186.187H5.14a.187.187 0 0 1-.185-.187zM12.78 14H3.965a.993.993 0 0 1-.988-1c0-.55.445-1 .988-1h8.816a11.4 11.4 0 0 0 0 2"
        })
    });
var $02b4c994588d4394$export$2e2bcd8739ae039 = $02b4c994588d4394$var$SvgBook;



parcelRequire("9nZCP");
const $6ac8f6d1288631cd$var$SvgOpenBook = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M15.062 2.002c-1.523.087-4.548.405-6.416 1.563a.43.43 0 0 0-.202.37V14.17c0 .325.351.53.647.38 1.922-.98 4.7-1.247 6.075-1.32a.87.87 0 0 0 .834-.862V2.865a.875.875 0 0 0-.938-.863M7.354 3.565C5.486 2.407 2.46 2.089.938 2.002A.876.876 0 0 0 0 2.865v9.502c0 .457.365.838.834.862 1.375.073 4.155.34 6.077 1.32.295.151.645-.054.645-.378V3.931a.43.43 0 0 0-.202-.366"
        })
    });
var $6ac8f6d1288631cd$export$2e2bcd8739ae039 = $6ac8f6d1288631cd$var$SvgOpenBook;



const $2aa32c57b589a954$var$ITEMS = [
    {
        text: "FAQ",
        Icon: (0, $1a7d73f520054657$export$2e2bcd8739ae039),
        url: "https://docs.vea.ninja/faq"
    },
    {
        text: "Report a Bug",
        Icon: (0, $995ef6b5b1cded36$export$2e2bcd8739ae039),
        url: "https://github.com/kleros/vea/issues"
    },
    {
        text: "Documentation",
        Icon: (0, $02b4c994588d4394$export$2e2bcd8739ae039),
        url: "https://docs.vea.ninja"
    },
    {
        text: "Devs Tutorial",
        Icon: (0, $6ac8f6d1288631cd$export$2e2bcd8739ae039),
        url: "https://docs.vea.ninja/build-xchain-dapps/getting-started"
    },
    {
        text: "Validators Tutorial",
        Icon: (0, $6ac8f6d1288631cd$export$2e2bcd8739ae039),
        url: "https://docs.vea.ninja/run-a-validator/getting-started"
    }
];
const $2aa32c57b589a954$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 32px;
  padding-left: 32px;

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    padding-left: 24px;
  `)}
`;
const $2aa32c57b589a954$var$Wrapper = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  line-height: 0;
  position: relative;
`;
const $2aa32c57b589a954$var$MenuContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  line-height: normal;
  position: absolute;
  min-width: 248px;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1;
  background-color: ${({ theme: theme })=>theme.color.secondaryPurple};
  border: 1px solid ${({ theme: theme })=>theme.color.grey};
  box-shadow: 0px 2px 3px ${({ theme: theme })=>theme.color.black + "03"};
  border-color: ${({ theme: theme })=>theme.color.secondaryBlue};
  display: ${({ isOpen: isOpen })=>isOpen ? "flex" : "none"};
  flex-direction: column;
  gap: 24px;
  padding: 28px 16px;
`;
const $2aa32c57b589a954$var$StyledQuestion = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $1a7d73f520054657$export$2e2bcd8739ae039))`
  height: 16px;
  transition: fill 0.25s ease;

  :hover {
    cursor: pointer;
    transform: scale(1.07);
    fill: ${({ theme: theme })=>theme.color.blue};
  }
`;
const $2aa32c57b589a954$var$Menu = ()=>{
    const ref = (0, $9nZCP.useRef)(null);
    (0, $0aa9c5ea5f98ac89$export$2e2bcd8739ae039)(ref, ()=>{
        toggle(false);
    });
    const [isOpen, toggle] = (0, $b2e41656ab938cc0$export$2e2bcd8739ae039)(false);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($2aa32c57b589a954$var$Container, {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($2aa32c57b589a954$var$Wrapper, {
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($2aa32c57b589a954$var$StyledQuestion, {
                    onClick: ()=>toggle()
                }),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($2aa32c57b589a954$var$MenuContainer, {
                    isOpen: isOpen,
                    children: $2aa32c57b589a954$var$ITEMS.map((item)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $fb430e72b34fb485$export$2e2bcd8739ae039), {
                            ...item
                        }, item.text))
                })
            ]
        })
    });
};
var $2aa32c57b589a954$export$2e2bcd8739ae039 = $2aa32c57b589a954$var$Menu;




var $9nZCP = parcelRequire("9nZCP");



parcelRequire("9nZCP");
const $85ef0ef8f6b7b2ed$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fill: "#DAF0FF",
            d: "m15.78 13.833-3.116-3.115a.75.75 0 0 0-.53-.219h-.51a6.47 6.47 0 0 0 1.375-4c0-3.59-2.91-6.499-6.5-6.499S0 2.91 0 6.5s2.91 6.499 6.5 6.499c1.509 0 2.896-.513 3.999-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 0 0 1.06 0l.884-.885a.753.753 0 0 0 .003-1.062M6.5 10.499c-2.21 0-4-1.787-4-4 0-2.209 1.787-4 4-4 2.209 0 3.999 1.788 3.999 4 0 2.21-1.787 4-4 4"
        })
    });
var $85ef0ef8f6b7b2ed$export$2e2bcd8739ae039 = $85ef0ef8f6b7b2ed$var$SvgSearch;



const $b5984bd1d8808d68$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  height: 45px;
  margin-top: 9px;
  margin-bottom: 10px;
  display: flex;
  background-color: transparent;
  color: ${({ theme: theme })=>theme.color.lightBlue};
  border: 1px solid #42498f;
  border-radius: 3px;
  align-items: center;
  width: 33.5vw;

  ::placeholder {
    color: ${({ theme: theme })=>theme.color.lightBlue};
  }
  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    width: 77.46vw;
  `)}
`;
const $b5984bd1d8808d68$var$StyledInput = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).input`
  position: relative;
  background-color: transparent;
  color: ${({ theme: theme })=>theme.color.lightBlue};
  border: none;
  width: 33.5vw;
  margin-left: 4px;

  font-family: "Oxanium";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;

  ::placeholder {
    color: ${({ theme: theme })=>theme.color.lightBlue};
  }

  :focus {
    outline: none;
  }

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    width: 77.46vw;
  `)}
`;
const $b5984bd1d8808d68$var$SearchIcon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).svg`
  height: 16px;
  margin-left: 16px;
  margin-top: 14px;
  margin-bottom: 15px;
`;
const $b5984bd1d8808d68$var$SearchIconContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  height: 45px;
`;
const $b5984bd1d8808d68$var$SearchBar = ()=>{
    const [placeholder, setPlaceholder] = (0, $9nZCP.useState)("");
    const { search: search, setSearch: setSearch } = (0, $e2024cd18f4cfc15$export$616ead5bf0ef583b)();
    (0, $9nZCP.useEffect)(()=>{
        const handleResize = ()=>{
            if (window.innerWidth <= 500) setPlaceholder("Search");
            else setPlaceholder("Search by Epoch ID / State Root");
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($b5984bd1d8808d68$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($b5984bd1d8808d68$var$SearchIconContainer, {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($b5984bd1d8808d68$var$SearchIcon, {
                    as: (0, $85ef0ef8f6b7b2ed$export$2e2bcd8739ae039)
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($b5984bd1d8808d68$var$StyledInput, {
                type: "text",
                value: search,
                onChange: (e)=>setSearch(e.target.value),
                placeholder: placeholder
            })
        ]
    });
};
var $b5984bd1d8808d68$export$2e2bcd8739ae039 = $b5984bd1d8808d68$var$SearchBar;



const $0bfafeeba8b81561$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  height: 68px;
  position: sticky;
  top: 0px;
  z-index: 2;
  background-color: ${({ theme: theme })=>theme.color.secondaryPurple};
  padding: 0 8%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 4px solid;
  border-image-slice: 1;
  ${({ theme: theme })=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    border-image-source: linear-gradient(
      to right,
      ${theme.color.blue},
      ${theme.color.pink}
    );
  `}

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    height: 136px;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 0 6%;
  `)}
`;
const $0bfafeeba8b81561$var$StyledTitle = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h5`
  font-size: 31.5px;
  margin-top: 20px;
  margin-bottom: 20px;

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    margin-bottom: 10px;
  `)}
`;
const $0bfafeeba8b81561$var$StyledSubtitle = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h5`
  color: ${({ theme: theme })=>theme.color.lightBlue};
  font-size: 15.5px;
  padding-left: 14px;
  margin-top: 26.5px;
  margin-bottom: 24px;

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    margin-bottom: 14px;
  `)}
`;
const $0bfafeeba8b81561$var$StyledLogo = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
`;
const $0bfafeeba8b81561$var$Navbar = /*#__PURE__*/ (0, $9nZCP.forwardRef)((_, ref)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($0bfafeeba8b81561$var$Container, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($0bfafeeba8b81561$var$StyledLogo, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($0bfafeeba8b81561$var$StyledTitle, {
                        children: "VeA"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($0bfafeeba8b81561$var$StyledSubtitle, {
                        children: "explorer"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($0bfafeeba8b81561$var$StyledLogo, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $b5984bd1d8808d68$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $2aa32c57b589a954$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    }));
$0bfafeeba8b81561$var$Navbar.displayName = "Navbar";
var $0bfafeeba8b81561$export$2e2bcd8739ae039 = $0bfafeeba8b81561$var$Navbar;



parcelRequire("9nZCP");


parcelRequire("9nZCP");


parcelRequire("9nZCP");
const $902ac185bb91f391$var$SvgBuiltByKleros = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 151 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
                fill: "#fff",
                fillRule: "evenodd",
                clipPath: "url(#built-by-kleros_svg__a)",
                clipRule: "evenodd",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    d: "m63.528 0 13.588.607 5.502 12.223L74.856 24l-13.662-.875-5.601-13.243zm9.962 7.045-9.848 4.303 8.419 6.509zM72.35 4.89l-7.87-3.388-1.654 7.124zm-1.995 14.605-8.553-6.107.206 8.276zm10.897-6.691-5.829-5.914-1.539 11.372zm-8.892 8.022-7.213 1.885 8.483.543zm7.752-5.34-6.314 4.704 1.255 2.452zm-2.986-13.17-1.227 2.518 4.565 4.64zM75.598 1.11 67.581.785l6.613 2.892zm-13.24 1.164-5.616 7.09 3.754.795zM60.27 11.55l-3.772-.799 3.936 9.272zM91.975 11.154h-.456V7.095h-1.222v9.525h1.222v-4.46h.42l3.849 4.698.93-.786-3.703-4.48L96.17 7.59l-.931-.731zm10.636-4.059h-1.223v9.525h6.201v-1.097h-4.978zm9.483 0h5.928v1.097h-4.706v2.852h3.885v1.097h-3.885v3.382h4.706v1.097h-5.928zm14.027 0h-3.229v9.525h1.223v-4.077h1.769l2.425 4.315 1.058-.64-2.334-3.858c1.148-.347 1.932-1.499 1.932-2.669 0-1.846-1.258-2.596-2.844-2.596m1.567 2.596c0 1.08-.784 1.755-1.968 1.755h-1.605V8.192h1.968c1.095 0 1.605.64 1.605 1.5m12.278 2.175c0 .768-.055 4.918-3.375 4.918-1.532 0-3.374-1.096-3.374-4.918 0-3.802 1.806-4.936 3.374-4.936 1.514 0 3.375 1.097 3.375 4.936m-5.472 0c0 1.39.255 3.767 2.097 3.767s2.098-2.377 2.098-3.767c0-1.407-.255-3.784-2.098-3.784s-2.097 2.377-2.097 3.784m13.133 3.767c-1.277 0-1.843-.86-2.08-2.03l-1.094.348c.292 1.7 1.404 2.833 3.174 2.833 1.751 0 3.01-1.024 3.01-2.833 0-.988-.457-1.756-1.314-2.23l-2.025-.897c-.729-.329-1.277-.585-1.277-1.48 0-.86.767-1.262 1.551-1.262 1.04 0 1.532.658 1.751 1.59l1.168-.347c-.383-1.48-1.314-2.395-2.901-2.395-1.496 0-2.791.896-2.791 2.505 0 1.634 1.093 2.082 2.337 2.592l.363.15q.114.048.229.093c.856.345 1.686.68 1.686 1.754 0 1.06-.784 1.609-1.787 1.609"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fill: "#fff",
                d: "M1.415 6.643h2.741q1.853 0 2.721.628.868.63.868 1.9 0 .87-.533 1.45-.527.575-1.545.738v.041q1.197.178 1.757.76.567.573.567 1.606 0 1.38-.916 2.126-.915.744-2.597.745H1.415zm.697 4.45h2.201q1.409 0 2.044-.465Q7 10.156 7 9.158q0-.997-.725-1.449-.717-.45-2.146-.451H2.112zm0 .615v4.313h2.352q2.775 0 2.775-2.255 0-2.058-2.926-2.058zM10.61 9.206v4.813q0 1.12.471 1.633.472.507 1.463.506 1.327 0 1.948-.67.63-.67.63-2.18V9.206h.669v7.43h-.574l-.123-1.025h-.041q-.725 1.162-2.577 1.162-2.537 0-2.537-2.713V9.206zM18.956 16.637h-.677V9.206h.677zm-.772-9.495q0-.657.43-.657.212 0 .328.171.123.171.123.486 0 .307-.123.485a.37.37 0 0 1-.328.178q-.43 0-.43-.663M22.128 16.637h-.677V6h.677zM26.585 16.172q.642 0 1.121-.11v.547q-.492.165-1.135.164-.984 0-1.456-.526-.465-.526-.465-1.654V9.794h-1.1v-.397l1.1-.307.342-1.682h.349v1.798h2.18v.588h-2.18v4.703q0 .854.3 1.265.302.41.944.41M36.087 9.063q1.558 0 2.345.984.792.977.793 2.864 0 1.853-.834 2.858-.828 1.005-2.331 1.004-.794 0-1.43-.328a2.5 2.5 0 0 1-1.004-.93h-.061l-.192 1.122h-.424V6h.677v2.673q0 .6-.027 1.107l-.02.581h.047q.423-.669 1.019-.984.6-.315 1.442-.315m-.014.615q-1.312 0-1.88.752t-.567 2.481v.116q0 1.682.588 2.413.595.732 1.846.732 1.215 0 1.832-.848.615-.854.615-2.426 0-3.22-2.434-3.22M40.045 9.206h.697l1.573 4.17q.717 1.92.909 2.59h.04a76 76 0 0 1 .937-2.631l1.572-4.129h.698l-3.33 8.634q-.403 1.053-.676 1.422a1.8 1.8 0 0 1-.643.553q-.361.185-.882.185-.39 0-.868-.144v-.587q.397.11.855.109.348 0 .615-.164t.478-.513q.22-.341.5-1.094.286-.745.369-.97z"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "built-by-kleros_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M55 0h96v24H55z"
                    })
                })
            })
        ]
    });
var $902ac185bb91f391$export$2e2bcd8739ae039 = $902ac185bb91f391$var$SvgBuiltByKleros;


const $6a197427a1b629f9$var$StyledKlerosLink = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).a`
  width: fit-content;
  height: fit-content;
  line-height: 0;
  display: block;
  > svg {
    width: 150px;
    transition: transform 0.25s ease;

    :hover {
      transform: scale(1.05);
    }
  }
`;
const $6a197427a1b629f9$var$BuiltByKleros = ({ className: className })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($6a197427a1b629f9$var$StyledKlerosLink, {
        href: "https://www.kleros.io",
        target: "_blank",
        rel: "noopener noreferrer",
        className: className,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $902ac185bb91f391$export$2e2bcd8739ae039), {})
    });
var $6a197427a1b629f9$export$2e2bcd8739ae039 = $6a197427a1b629f9$var$BuiltByKleros;



parcelRequire("9nZCP");
const $2cdefa6bb2a12f37$var$SvgLines = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1440 149",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                fill: "url(#lines_svg__a)",
                fillRule: "evenodd",
                d: "M348.963 129.469h744.567L1439.3 0l.35.937-345.85 129.5-.09.032H348.784l-.085-.032L.349.937.696 0zm0 9.499h744.567L1439.3 9.5l.35.937-345.85 129.5-.09.031H348.784l-.085-.031L.349 10.437.696 9.5zm744.567 9H348.963L.697 18.5l-.349.937 348.351 129.5.085.031h744.926l.09-.031 345.85-129.5-.35-.937z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("linearGradient", {
                    id: "lines_svg__a",
                    x1: 719.998,
                    x2: 719.998,
                    y1: 0,
                    y2: 148.968,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("stop", {
                            stopColor: "#FFFDF5"
                        }),
                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("stop", {
                            offset: 1,
                            stopColor: "#69C3FC"
                        })
                    ]
                })
            })
        ]
    });
var $2cdefa6bb2a12f37$export$2e2bcd8739ae039 = $2cdefa6bb2a12f37$var$SvgLines;



parcelRequire("9nZCP");
const $b9fe1bf6a5b8f9f7$var$SvgGithub = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 17",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M5.352 13.026c0 .062-.075.111-.168.111-.107.01-.18-.04-.18-.11 0-.062.073-.111.167-.111.097-.01.18.04.18.11m-1.004-.138c-.022.062.042.132.14.15.083.031.18 0 .2-.06.018-.062-.043-.133-.14-.16-.083-.022-.177.009-.2.07m1.426-.052c-.093.021-.158.08-.148.15.01.062.093.102.19.08.094-.021.158-.08.149-.141-.01-.058-.097-.098-.19-.09M7.897 1.062C3.423 1.062 0 4.297 0 8.559c0 3.407 2.252 6.323 5.468 7.35.413.07.558-.173.558-.372 0-.19-.01-1.242-.01-1.887 0 0-2.258.461-2.732-.915 0 0-.368-.895-.897-1.125 0 0-.739-.482.052-.473 0 0 .803.061 1.245.793.706 1.186 1.89.845 2.351.642.075-.492.284-.833.517-1.036-1.804-.19-3.623-.44-3.623-3.395 0-.845.245-1.269.761-1.81-.084-.2-.358-1.023.084-2.086.674-.2 2.226.83 2.226.83a8 8 0 0 1 2.026-.261c.687 0 1.38.089 2.026.26 0 0 1.551-1.032 2.225-.829.442 1.066.168 1.887.084 2.086.516.544.832.968.832 1.81 0 2.965-1.9 3.202-3.703 3.395.297.243.549.704.549 1.426 0 1.035-.01 2.317-.01 2.569 0 .2.148.442.558.371C13.813 14.882 16 11.966 16 8.56c0-4.262-3.629-7.497-8.103-7.497M3.135 11.659c-.041.03-.032.101.023.16.052.05.126.07.168.03.042-.03.032-.1-.023-.16-.051-.048-.126-.07-.168-.03m-.348-.249c-.022.04.01.09.074.12.052.03.116.022.139-.021.023-.04-.01-.09-.074-.12-.065-.019-.116-.01-.139.021m1.045 1.094c-.051.04-.032.132.042.19.074.071.168.08.21.031.042-.04.022-.132-.042-.19-.071-.07-.168-.08-.21-.03m-.367-.452c-.052.031-.052.111 0 .182.051.07.138.101.18.07.052-.04.052-.12 0-.19-.045-.07-.129-.102-.18-.062"
        })
    });
var $b9fe1bf6a5b8f9f7$export$2e2bcd8739ae039 = $b9fe1bf6a5b8f9f7$var$SvgGithub;



parcelRequire("9nZCP");
const $db155075c7426d2e$var$SvgTelegram = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 14",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "m15.954 1.197-2.414 11.16c-.182.787-.657.983-1.332.612l-3.68-2.657-1.774 1.673c-.197.193-.361.354-.74.354l.265-3.672 6.818-6.038c.297-.26-.064-.403-.46-.144l-8.43 5.202L.578 6.574c-.79-.242-.804-.774.164-1.145L14.937.07c.657-.241 1.232.144 1.017 1.127"
        })
    });
var $db155075c7426d2e$export$2e2bcd8739ae039 = $db155075c7426d2e$var$SvgTelegram;



parcelRequire("9nZCP");
const $39e8d737777c1440$var$SvgTwitter = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 17",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            d: "M14.355 5.155c.01.136.01.272.01.407 0 4.14-3.299 8.912-9.33 8.912A9.6 9.6 0 0 1 0 13.068c.264.029.518.039.792.039a6.77 6.77 0 0 0 4.071-1.339c-1.442-.029-2.65-.93-3.066-2.172.203.03.406.049.62.049.294 0 .588-.039.862-.107C1.777 9.248.65 7.987.65 6.464v-.038a3.4 3.4 0 0 0 1.483.397C1.249 6.261.67 5.301.67 4.215c0-.582.162-1.115.447-1.58 1.614 1.9 4.04 3.14 6.761 3.277a3.4 3.4 0 0 1-.081-.718c0-1.726 1.462-3.132 3.28-3.132.943 0 1.796.378 2.395.99a6.6 6.6 0 0 0 2.081-.757 3.15 3.15 0 0 1-1.441 1.726c.66-.068 1.3-.243 1.888-.485a6.9 6.9 0 0 1-1.645 1.62"
        })
    });
var $39e8d737777c1440$export$2e2bcd8739ae039 = $39e8d737777c1440$var$SvgTwitter;



const $643953020955b261$var$LINKS = [
    {
        Icon: (0, $39e8d737777c1440$export$2e2bcd8739ae039),
        href: "https://www.twitter.com/vea_eth"
    },
    {
        Icon: (0, $b9fe1bf6a5b8f9f7$export$2e2bcd8739ae039),
        href: "https://www.github.com/kleros/vea"
    },
    {
        Icon: (0, $db155075c7426d2e$export$2e2bcd8739ae039),
        href: "https://t.me/veabridge"
    }
];
const $643953020955b261$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  border-bottom: 16px solid;
  border-image-slice: 1;
  ${({ theme: theme })=>(0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    border-image-source: linear-gradient(
      to right,
      ${theme.color.blue},
      ${theme.color.pink}
    );
  `}
`;
const $643953020955b261$var$InnerContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    margin-bottom: 32px;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 10px;
  `)}
`;
const $643953020955b261$var$Logo = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h2`
  text-align: center;
  margin: 20px;

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    position: relative;
    font-size: 46px;
  `)}
`;
const $643953020955b261$var$StyledLink = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).a`
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    fill: ${({ theme: theme })=>theme.color.lightBlue};
    width: 32px;
    transition: fill 0.25s ease, transform 0.25s ease;
    :hover {
      fill: ${({ theme: theme })=>theme.color.blue};
      transform: scale(1.05);
    }
  }
`;
const $643953020955b261$var$SocialMedia = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 50%;
  right: 5%;
  transform: translateY(-50%);
  display: flex;
  gap: 16px;

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    position: relative;
    right: 0%;
    margin-top: 30px;
  `)}
`;
const $643953020955b261$var$StyledBuiltByKleros = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $6a197427a1b629f9$export$2e2bcd8739ae039))`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5%;
  display: flex;
  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    top: 100%;
    position: relative;
    left: 0%;
  `)}
`;
const $643953020955b261$var$Footer = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($643953020955b261$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $2cdefa6bb2a12f37$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($643953020955b261$var$InnerContainer, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($643953020955b261$var$StyledBuiltByKleros, {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($643953020955b261$var$Logo, {
                        children: "VeA"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($643953020955b261$var$SocialMedia, {
                        children: $643953020955b261$var$LINKS.map(({ href: href, Icon: Icon })=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($643953020955b261$var$StyledLink, {
                                href: href,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)(Icon, {})
                            }, href))
                    })
                ]
            })
        ]
    });
var $643953020955b261$export$2e2bcd8739ae039 = $643953020955b261$var$Footer;




var $9nZCP = parcelRequire("9nZCP");
const $62de33b7a65ee1e6$export$c30087714757f312 = ()=>{
    const [ref, setRef] = (0, $9nZCP.useState)(null);
    const [position, setPosition] = (0, $9nZCP.useState)({
        width: 0,
        height: 0,
        offsetTop: 0,
        offsetLeft: 0
    });
    const handleResize = (0, $9nZCP.useCallback)(()=>{
        setPosition({
            width: ref?.offsetWidth || 0,
            height: ref?.offsetHeight || 0,
            offsetTop: ref?.offsetTop || 0,
            offsetLeft: ref?.offsetLeft || 0
        });
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth,
        ref?.offsetTop,
        ref?.offsetLeft
    ]);
    (0, $9nZCP.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    });
    (0, $9nZCP.useLayoutEffect)(()=>{
        handleResize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth,
        ref?.offsetTop,
        ref?.offsetLeft
    ]);
    return [
        setRef,
        position
    ];
};


const $aa09a620890829e8$var$MiddleContent = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    margin: 0 5%;
  `)}
  max-width: 1120px;
`;
const $aa09a620890829e8$var$Content = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  min-height: calc(100vh - ${({ navbarHeight: navbarHeight })=>navbarHeight}px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $aa09a620890829e8$var$Layout = ({ children: children })=>{
    const [ref, { height: navbarHeight }] = (0, $62de33b7a65ee1e6$export$c30087714757f312)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $0bfafeeba8b81561$export$2e2bcd8739ae039), {
                ref: ref
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($aa09a620890829e8$var$Content, {
                navbarHeight: navbarHeight,
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($aa09a620890829e8$var$MiddleContent, {
                        children: [
                            " ",
                            children,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $643953020955b261$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $aa09a620890829e8$export$2e2bcd8739ae039 = $aa09a620890829e8$var$Layout;



parcelRequire("9nZCP");





var $9nZCP = parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");




var $9nZCP = parcelRequire("9nZCP");

parcelRequire("9nZCP");


parcelRequire("9nZCP");
const $cf8608501fd2484f$var$SvgDocument = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
                clipPath: "url(#document_svg__a)",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    fill: "#69C3FC",
                    d: "M11.23 8.25v.875a.38.38 0 0 1-.384.375H5.462a.38.38 0 0 1-.385-.375V8.25c0-.206.173-.375.385-.375h5.384c.212 0 .385.169.385.375m-.384 2.25H5.462a.38.38 0 0 0-.385.375v.875c0 .206.173.375.385.375h5.384a.38.38 0 0 0 .385-.375v-.875a.38.38 0 0 0-.385-.375m3.462-5.878V15c0 .828-.69 1.5-1.539 1.5H3.54C2.688 16.5 2 15.828 2 15V2C2 1.172 2.69.5 3.538.5h6.542c.407 0 .798.16 1.087.44l2.689 2.623c.288.278.452.662.452 1.059m-4.103-2.5V4.5h2.44zM12.77 15V6H9.436a.76.76 0 0 1-.77-.75V2H3.539v13z"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "document_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 .5h16v16H0z"
                    })
                })
            })
        ]
    });
var $cf8608501fd2484f$export$2e2bcd8739ae039 = $cf8608501fd2484f$var$SvgDocument;


const $ec842c1673aca056$var$Icon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).svg`
  width: 16px;
  height: 16px;
  fill: none;
`;
const $ec842c1673aca056$var$Status = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  align-items: center;
  small {
    color: ${({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue} !important;
    font-weight: 600;
    line-height: 20px;
    font-size: 16px;
  }
  margin-top: 46px;
`;
const $ec842c1673aca056$var$MessageHeader = ({ messageNumber: messageNumber, status: status })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($ec842c1673aca056$var$Status, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($ec842c1673aca056$var$Icon, {
                as: (0, $cf8608501fd2484f$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("small", {
                children: [
                    "Message #",
                    messageNumber,
                    " - ",
                    status
                ]
            })
        ]
    });
};
var $ec842c1673aca056$export$2e2bcd8739ae039 = $ec842c1673aca056$var$MessageHeader;



parcelRequire("9nZCP");

var $ecaa896c7e83291b$exports = {};
"use strict";
var $8e4f8949dc758986$exports = {};
$8e4f8949dc758986$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $ecaa896c7e83291b$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $ecaa896c7e83291b$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $ecaa896c7e83291b$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $ecaa896c7e83291b$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $8e4f8949dc758986$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $ecaa896c7e83291b$var$clipboardToIE11Formatting[options.format] || $ecaa896c7e83291b$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $ecaa896c7e83291b$var$format("message" in options ? options.message : $ecaa896c7e83291b$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$ecaa896c7e83291b$exports = $ecaa896c7e83291b$var$copy;



var $9nZCP = parcelRequire("9nZCP");

var $9nZCP = parcelRequire("9nZCP");
function $c5f5c5af4d54119c$export$2e2bcd8739ae039() {
    var mountedRef = (0, $9nZCP.useRef)(false);
    var get = (0, $9nZCP.useCallback)(function() {
        return mountedRef.current;
    }, []);
    (0, $9nZCP.useEffect)(function() {
        mountedRef.current = true;
        return function() {
            mountedRef.current = false;
        };
    }, []);
    return get;
}



var $9nZCP = parcelRequire("9nZCP");
var $aa17918f6d5f6705$var$useSetState = function(initialState) {
    if (initialState === void 0) initialState = {};
    var _a = (0, $9nZCP.useState)(initialState), state = _a[0], set = _a[1];
    var setState = (0, $9nZCP.useCallback)(function(patch) {
        set(function(prevState) {
            return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch);
        });
    }, []);
    return [
        state,
        setState
    ];
};
var $aa17918f6d5f6705$export$2e2bcd8739ae039 = $aa17918f6d5f6705$var$useSetState;


var $be80732420e01f0f$var$useCopyToClipboard = function() {
    var isMounted = (0, $c5f5c5af4d54119c$export$2e2bcd8739ae039)();
    var _a = (0, $aa17918f6d5f6705$export$2e2bcd8739ae039)({
        value: undefined,
        error: undefined,
        noUserInteraction: true
    }), state = _a[0], setState = _a[1];
    var copyToClipboard = (0, $9nZCP.useCallback)(function(value) {
        if (!isMounted()) return;
        var noUserInteraction;
        var normalizedValue;
        try {
            // only strings and numbers casted to strings can be copied to clipboard
            if (typeof value !== 'string' && typeof value !== 'number') {
                var error = new Error("Cannot copy typeof " + typeof value + " to clipboard, must be a string");
                setState({
                    value: value,
                    error: error,
                    noUserInteraction: true
                });
                return;
            } else if (value === '') {
                var error = new Error("Cannot copy empty string to clipboard.");
                setState({
                    value: value,
                    error: error,
                    noUserInteraction: true
                });
                return;
            }
            normalizedValue = value.toString();
            noUserInteraction = (0, (/*@__PURE__*/$parcel$interopDefault($ecaa896c7e83291b$exports)))(normalizedValue);
            setState({
                value: normalizedValue,
                error: undefined,
                noUserInteraction: noUserInteraction
            });
        } catch (error) {
            setState({
                value: normalizedValue,
                error: error,
                noUserInteraction: noUserInteraction
            });
        }
    }, []);
    return [
        state,
        copyToClipboard
    ];
};
var $be80732420e01f0f$export$2e2bcd8739ae039 = $be80732420e01f0f$var$useCopyToClipboard;



parcelRequire("9nZCP");
const $52816e44f2501d69$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fill: "#69C3FC",
            d: "M14.776 2.06 13.129.44A1.54 1.54 0 0 0 12.05 0H6.587c-.841 0-1.524.672-1.524 1.5V3h-2.54C1.684 3 1 3.672 1 4.5v10c0 .828.682 1.5 1.524 1.5h7.11c.842 0 1.525-.672 1.525-1.5V13h2.54c.841 0 1.523-.672 1.523-1.5V3.121c0-.398-.16-.779-.446-1.06M9.444 14.5h-6.73a.2.2 0 0 1-.134-.055.19.19 0 0 1-.056-.133V4.688c0-.05.02-.098.056-.133a.2.2 0 0 1 .134-.055h2.35v7c0 .828.682 1.5 1.523 1.5h3.048v1.313c0 .05-.02.097-.056.132a.2.2 0 0 1-.135.055m4.064-3h-6.73a.2.2 0 0 1-.135-.055.19.19 0 0 1-.056-.133V1.688c0-.05.02-.098.056-.133a.2.2 0 0 1 .135-.055h3.365v2.75c0 .414.341.75.762.75h2.793v6.313c0 .05-.02.097-.055.132a.2.2 0 0 1-.135.055m.19-8h-2.031v-2h.305c.051 0 .1.02.135.055l1.536 1.511a.19.19 0 0 1 .055.133z"
        })
    });
var $52816e44f2501d69$export$2e2bcd8739ae039 = $52816e44f2501d69$var$SvgCopy;


var $90e0f3a1bff47fae$exports = {};
$90e0f3a1bff47fae$exports = JSON.parse("{\"address\":\"0xF6C5640de593fEf76129F1F1A863F7ddc65776C9\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"_veaOutboxArbToEth\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes\",\"name\":\"_nodeData\",\"type\":\"bytes\"}],\"name\":\"MessageSent\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_snapshot\",\"type\":\"bytes32\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_count\",\"type\":\"uint64\"}],\"name\":\"SnapshotSaved\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epochSent\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_ticketId\",\"type\":\"bytes32\"}],\"name\":\"SnapshotSent\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"count\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochFinalized\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"saveSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"bytes4\",\"name\":\"_fnSelector\",\"type\":\"bytes4\"},{\"internalType\":\"bytes\",\"name\":\"_data\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"sendSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"snapshots\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"veaOutboxArbToEth\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"}],\"transactionHash\":\"0x125f717c4127a8cd53667887d4fb8572b500d1036e071aa6f7b4c7d9772c0d41\",\"receipt\":{\"to\":null,\"from\":\"0xFa00D29d378EDC57AA1006946F0fc6230a5E3288\",\"contractAddress\":\"0xF6C5640de593fEf76129F1F1A863F7ddc65776C9\",\"transactionIndex\":3,\"gasUsed\":\"738227\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0x288f0a278c562336e29920935758ecebc0056acfb5d8806cd155f6a89dd9057e\",\"transactionHash\":\"0x125f717c4127a8cd53667887d4fb8572b500d1036e071aa6f7b4c7d9772c0d41\",\"logs\":[],\"blockNumber\":129093493,\"cumulativeGasUsed\":\"1458003\",\"status\":1,\"byzantium\":true},\"args\":[1800,\"0xb1f5125b52CE23D3763AC1C9ACEf0668825A66c0\"],\"numDeployments\":4,\"solcInputHash\":\"c9b5f40be4cc59cdaa11ec8b822d1bfe\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.24+commit.e11b9ed9\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_veaOutboxArbToEth\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_nodeData\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"MessageSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_snapshot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_count\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"SnapshotSaved\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochSent\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_ticketId\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"SnapshotSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"count\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochFinalized\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"saveSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes4\\\",\\\"name\\\":\\\"_fnSelector\\\",\\\"type\\\":\\\"bytes4\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_data\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"sendSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"snapshots\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"veaOutboxArbToEth\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Inbox From Arbitrum to Ethereum. Note: This contract is deployed on Arbitrum.\\\",\\\"events\\\":{\\\"MessageSent(bytes)\\\":{\\\"details\\\":\\\"Relayers watch for these events to construct merkle proofs to execute transactions on Ethereum.\\\",\\\"params\\\":{\\\"_nodeData\\\":\\\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\"}},\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"params\\\":{\\\"_count\\\":\\\"The count of messages in the merkle tree.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot.\\\",\\\"_snapshot\\\":\\\"The snapshot of the merkle tree state root.\\\"}},\\\"SnapshotSent(uint256,bytes32)\\\":{\\\"details\\\":\\\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\",\\\"params\\\":{\\\"_epochSent\\\":\\\"The epoch of the snapshot.\\\",\\\"_ticketId\\\":\\\"The ticketId of the L2->L1 message.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"constructor\\\":{\\\"details\\\":\\\"Constructor. Note: epochPeriod must match the VeaOutboxArbToEth contract deployment on Ethereum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\",\\\"params\\\":{\\\"_epochPeriod\\\":\\\"The duration in seconds between epochs.\\\",\\\"_veaOutboxArbToEth\\\":\\\"The veaOutbox on ethereum.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the epoch from the inbox's point of view using timestamp.\\\",\\\"params\\\":{\\\"_timestamp\\\":\\\"The timestamp to calculate the epoch from.\\\"},\\\"returns\\\":{\\\"epoch\\\":\\\"The calculated epoch.\\\"}},\\\"epochFinalized()\\\":{\\\"details\\\":\\\"Get the most recent epoch for which snapshots are finalized.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"saveSnapshot()\\\":{\\\"details\\\":\\\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\\\"},\\\"sendMessage(address,bytes4,bytes)\\\":{\\\"details\\\":\\\"Sends an arbitrary message to Ethereum.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\\\",\\\"params\\\":{\\\"_data\\\":\\\"The message calldata, abi.encode(param1, param2, ...)\\\",\\\"_fnSelector\\\":\\\"The function selector of the receiving contract.\\\",\\\"_to\\\":\\\"The address of the contract on the receiving chain which receives the calldata.\\\"},\\\"returns\\\":{\\\"_0\\\":\\\"msgId The zero based index of the message in the inbox.\\\"}},\\\"sendSnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the state root snapshot using Arbitrum's canonical bridge.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot requested to send.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"events\\\":{\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"notice\\\":\\\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\"}},\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/arbitrumToEth/VeaInboxArbToEth.sol\\\":\\\"VeaInboxArbToEth\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":200},\\\"remappings\\\":[]},\\\"sources\\\":{\\\"src/arbitrumToEth/VeaInboxArbToEth.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/arbitrum/IArbSys.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/inboxes/IVeaInbox.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/outboxes/IVeaOutboxOnL1.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Inbox From Arbitrum to Ethereum.\\\\n/// Note: This contract is deployed on Arbitrum.\\\\ncontract VeaInboxArbToEth is IVeaInbox {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    // Arbitrum precompile ArbSys for L2->L1 messaging: https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n    IArbSys internal constant ARB_SYS = IArbSys(address(100));\\\\n\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    address public immutable veaOutboxArbToEth; // The vea outbox on ethereum.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public snapshots; // epoch => state root snapshot\\\\n\\\\n    // Inbox represents minimum data availability to maintain incremental merkle tree.\\\\n    // Supports a max of 2^64 - 1 messages. See merkle tree docs for details how inbox manages state.\\\\n\\\\n    bytes32[64] internal inbox; // stores minimal set of complete subtree roots of the merkle tree to increment.\\\\n    uint64 public count; // count of messages in the merkle tree\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Relayers watch for these events to construct merkle proofs to execute transactions on Ethereum.\\\\n    /// @param _nodeData The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\\n    event MessageSent(bytes _nodeData);\\\\n\\\\n    /// The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\\n    /// @param _snapshot The snapshot of the merkle tree state root.\\\\n    /// @param _epoch The epoch of the snapshot.\\\\n    /// @param _count The count of messages in the merkle tree.\\\\n    event SnapshotSaved(bytes32 _snapshot, uint256 _epoch, uint64 _count);\\\\n\\\\n    /// @dev The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\\n    /// @param _epochSent The epoch of the snapshot.\\\\n    /// @param _ticketId The ticketId of the L2->L1 message.\\\\n    event SnapshotSent(uint256 indexed _epochSent, bytes32 _ticketId);\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaOutboxArbToEth contract deployment on Ethereum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _epochPeriod The duration in seconds between epochs.\\\\n    /// @param _veaOutboxArbToEth The veaOutbox on ethereum.\\\\n    constructor(uint256 _epochPeriod, address _veaOutboxArbToEth) {\\\\n        epochPeriod = _epochPeriod;\\\\n        veaOutboxArbToEth = _veaOutboxArbToEth;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Sends an arbitrary message to Ethereum.\\\\n    ///      `O(log(count))` where count is the number of messages already sent.\\\\n    ///      Amortized cost is constant.\\\\n    /// Note: See docs for details how inbox manages merkle tree state.\\\\n    /// @param _to The address of the contract on the receiving chain which receives the calldata.\\\\n    /// @param _fnSelector The function selector of the receiving contract.\\\\n    /// @param _data The message calldata, abi.encode(param1, param2, ...)\\\\n    /// @return msgId The zero based index of the message in the inbox.\\\\n    function sendMessage(address _to, bytes4 _fnSelector, bytes memory _data) external override returns (uint64) {\\\\n        uint64 oldCount = count;\\\\n\\\\n        // Given arbitrum's speed limit of 7 million gas / second, it would take atleast 8 million years of full blocks to overflow.\\\\n        // It *should* be impossible to overflow, but we check to be safe when appending to the tree.\\\\n        require(oldCount < type(uint64).max, \\\\\\\"Inbox is full.\\\\\\\");\\\\n\\\\n        bytes memory nodeData = abi.encodePacked(\\\\n            oldCount,\\\\n            _to,\\\\n            // _data is abi.encode(param1, param2, ...), we need to encode it again to get the correct leaf data\\\\n            abi.encodePacked( // equivalent to abi.encodeWithSelector(fnSelector, msg.sender, param1, param2, ...)\\\\n                _fnSelector,\\\\n                bytes32(uint256(uint160(msg.sender))), // big endian padded encoding of msg.sender, simulating abi.encodeWithSelector\\\\n                _data\\\\n            )\\\\n        );\\\\n\\\\n        // single hashed leaf\\\\n        bytes32 newInboxNode = keccak256(nodeData);\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            // efficient hash using EVM scratch space\\\\n            mstore(0x00, newInboxNode)\\\\n            newInboxNode := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        // increment merkle tree calculating minimal number of hashes\\\\n        unchecked {\\\\n            uint256 height;\\\\n\\\\n            // x = oldCount + 1; acts as a bit mask to determine if a hash is needed\\\\n            // note: x is always non-zero, and x is bit shifted to the right each loop\\\\n            // hence this loop will always terminate in a maximum of log_2(oldCount + 1) iterations\\\\n            for (uint64 x = oldCount + 1; x & 1 == 0; x = x >> 1) {\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                newInboxNode = sortConcatAndHash(inbox[height], newInboxNode);\\\\n                height++;\\\\n            }\\\\n\\\\n            inbox[height] = newInboxNode;\\\\n\\\\n            // finally increment count\\\\n            count = oldCount + 1;\\\\n        }\\\\n\\\\n        emit MessageSent(nodeData);\\\\n\\\\n        // old count is the zero indexed leaf position in the tree, acts as a msgId\\\\n        // gateways should index these msgIds to later relay proofs\\\\n        return oldCount;\\\\n    }\\\\n\\\\n    /// @dev Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    /// Note: See merkle tree docs for details how inbox manages state.\\\\n    function saveSnapshot() external {\\\\n        uint256 epoch;\\\\n        bytes32 stateRoot;\\\\n\\\\n        unchecked {\\\\n            epoch = block.timestamp / epochPeriod;\\\\n\\\\n            // calculate the current root of the incremental merkle tree encoded in the inbox\\\\n\\\\n            uint256 height;\\\\n\\\\n            // x acts as a bit mask to determine if the hash stored in the inbox contributes to the root\\\\n            uint256 x;\\\\n\\\\n            // x is bit shifted to the right each loop, hence this loop will always terminate in a maximum of log_2(count) iterations\\\\n            for (x = uint256(count); x > 0; x = x >> 1) {\\\\n                if ((x & 1) == 1) {\\\\n                    // first hash is special case\\\\n                    // inbox stores the root of complete subtrees\\\\n                    // eg if count = 4 = 0b100, then the first complete subtree is inbox[2]\\\\n                    // inbox = [H(3), H(1,2), H(1,4)], we read inbox[2] directly\\\\n\\\\n                    stateRoot = inbox[height];\\\\n                    break;\\\\n                }\\\\n                height++;\\\\n            }\\\\n\\\\n            // after the first hash, we can calculate the root incrementally\\\\n            for (x = x >> 1; x > 0; x = x >> 1) {\\\\n                height++;\\\\n                if ((x & 1) == 1) {\\\\n                    // sort sibling hashes as a convention for efficient proof validation\\\\n                    stateRoot = sortConcatAndHash(inbox[height], stateRoot);\\\\n                }\\\\n            }\\\\n        }\\\\n\\\\n        snapshots[epoch] = stateRoot;\\\\n\\\\n        emit SnapshotSaved(stateRoot, epoch, count);\\\\n    }\\\\n\\\\n    /// @dev Helper function to calculate merkle tree interior nodes by sorting and concatenating and hashing a pair of children nodes, left and right.\\\\n    /// Note: EVM scratch space is used to efficiently calculate hashes.\\\\n    /// @param _left The left hash.\\\\n    /// @param _right The right hash.\\\\n    /// @return parent The parent hash.\\\\n    function sortConcatAndHash(bytes32 _left, bytes32 _right) internal pure returns (bytes32 parent) {\\\\n        // sort sibling hashes as a convention for efficient proof validation\\\\n        if (_left < _right) {\\\\n            // efficient hash using EVM scratch space\\\\n            assembly {\\\\n                mstore(0x00, _left)\\\\n                mstore(0x20, _right)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        } else {\\\\n            assembly {\\\\n                mstore(0x00, _right)\\\\n                mstore(0x20, _left)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the state root snapshot using Arbitrum's canonical bridge.\\\\n    /// @param _epoch The epoch of the snapshot requested to send.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function sendSnapshot(uint256 _epoch, Claim memory _claim) external virtual {\\\\n        unchecked {\\\\n            require(_epoch < block.timestamp / epochPeriod, \\\\\\\"Can only send past epoch snapshot.\\\\\\\");\\\\n        }\\\\n\\\\n        bytes memory data = abi.encodeCall(IVeaOutboxOnL1.resolveDisputedClaim, (_epoch, snapshots[_epoch], _claim));\\\\n\\\\n        // Arbitrum -> Ethereum message with native bridge\\\\n        // docs: https://developer.arbitrum.io/for-devs/cross-chain-messsaging#arbitrum-to-ethereum-messaging\\\\n        // example: https://github.com/OffchainLabs/arbitrum-tutorials/blob/2c1b7d2db8f36efa496e35b561864c0f94123a5f/packages/greeter/contracts/arbitrum/GreeterL2.sol#L25\\\\n        bytes32 ticketID = bytes32(ARB_SYS.sendTxToL1(veaOutboxArbToEth, data));\\\\n\\\\n        emit SnapshotSent(_epoch, ticketID);\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the most recent epoch for which snapshots are finalized.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochFinalized() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    /// @dev Get the epoch from the inbox's point of view using timestamp.\\\\n    /// @param _timestamp The timestamp to calculate the epoch from.\\\\n    /// @return epoch The calculated epoch.\\\\n    function epochAt(uint256 _timestamp) external view returns (uint256 epoch) {\\\\n        epoch = _timestamp / epochPeriod;\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xe3fdd0cc51b541482e72b8cf37981499dc301556f77b78666c5b3b22237dd05e\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/arbitrum/IArbSys.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/39ea5a163afc637e2706d9be29cf7a289c300d00/src/precompiles/ArbSys.sol\\\\n// https://arbiscan.io/address/0x0000000000000000000000000000000000000064#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\n///@title System level functionality\\\\n///@notice For use by contracts to interact with core L2-specific functionality.\\\\n///Precompiled contract that exists in every Arbitrum chain at address(100), 0x0000000000000000000000000000000000000064.\\\\ninterface IArbSys {\\\\n    /// @notice Send a transaction to L1\\\\n    /// @dev it is not possible to execute on the L1 any L2-to-L1 transaction which contains data\\\\n    /// to a contract address without any code (as enforced by the Bridge contract).\\\\n    /// @param destination recipient address on L1\\\\n    /// @param data (optional) calldata for L1 contract call\\\\n    /// @return a unique identifier for this L2-to-L1 transaction.\\\\n    function sendTxToL1(address destination, bytes calldata data) external payable returns (uint256);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x5ae1fd0267552160821402b9bc50b2551b086904436e5abe838599179b279420\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/interfaces/inboxes/IVeaInbox.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\ninterface IVeaInbox {\\\\n    /// @dev Sends an arbitrary message to receiving chain.\\\\n    /// Note: Calls authenticated by receiving gateway checking the sender argument.\\\\n    /// @param _to The cross-domain contract address which receives the calldata.\\\\n    /// @param _fnSelection The function selector of the receiving contract.\\\\n    /// @param _data The message calldata, abi.encode(...)\\\\n    /// @return msgId The index of the message in the inbox, as a message Id, needed to relay the message.\\\\n    function sendMessage(address _to, bytes4 _fnSelection, bytes memory _data) external returns (uint64 msgId);\\\\n\\\\n    /// @dev Snapshots can be saved a maximum of once per epoch.\\\\n    ///      Saves snapshot of state root.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    function saveSnapshot() external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xa8e2f65b7596235422f39933af80f02473493d2b15b398d7e34b81c82bd24a29\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/outboxes/IVeaOutboxOnL1.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Outbox on L1 chains like Ethereum, Gnosis, Polygon POS where storage is expensive.\\\\ninterface IVeaOutboxOnL1 {\\\\n    /// @dev Verifies and relays the message.\\\\n    /// Note: Gateways expect first argument of message call to be the arbitrum message sender, used for authentication.\\\\n    /// @param _proof The merkle proof to prove the message.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address to send the message to.\\\\n    /// @param _message The message to relay.\\\\n    function sendMessage(bytes32[] calldata _proof, uint64 _msgId, address _to, bytes calldata _message) external;\\\\n\\\\n    /// @dev Resolves any challenge of the optimistic claim for 'epoch' using the canonical bridge.\\\\n    /// Note: Access restricted to canonical bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(uint256 _epoch, bytes32 _stateRoot, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xf1d52e289e790088502b7909f11f47bc33ddd3fc545636b7fb29c01ed00d3ff3\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xfef781e359c97aebbe8dbfcb75edb7cb962139fd9ea538b8b89a3f2e13a05bfe\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"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\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Inbox From Arbitrum to Ethereum. Note: This contract is deployed on Arbitrum.\",\"events\":{\"MessageSent(bytes)\":{\"details\":\"Relayers watch for these events to construct merkle proofs to execute transactions on Ethereum.\",\"params\":{\"_nodeData\":\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\"}},\"SnapshotSaved(bytes32,uint256,uint64)\":{\"params\":{\"_count\":\"The count of messages in the merkle tree.\",\"_epoch\":\"The epoch of the snapshot.\",\"_snapshot\":\"The snapshot of the merkle tree state root.\"}},\"SnapshotSent(uint256,bytes32)\":{\"details\":\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\",\"params\":{\"_epochSent\":\"The epoch of the snapshot.\",\"_ticketId\":\"The ticketId of the L2->L1 message.\"}}},\"kind\":\"dev\",\"methods\":{\"constructor\":{\"details\":\"Constructor. Note: epochPeriod must match the VeaOutboxArbToEth contract deployment on Ethereum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\",\"params\":{\"_epochPeriod\":\"The duration in seconds between epochs.\",\"_veaOutboxArbToEth\":\"The veaOutbox on ethereum.\"}},\"epochAt(uint256)\":{\"details\":\"Get the epoch from the inbox's point of view using timestamp.\",\"params\":{\"_timestamp\":\"The timestamp to calculate the epoch from.\"},\"returns\":{\"epoch\":\"The calculated epoch.\"}},\"epochFinalized()\":{\"details\":\"Get the most recent epoch for which snapshots are finalized.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"saveSnapshot()\":{\"details\":\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\"},\"sendMessage(address,bytes4,bytes)\":{\"details\":\"Sends an arbitrary message to Ethereum.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\",\"params\":{\"_data\":\"The message calldata, abi.encode(param1, param2, ...)\",\"_fnSelector\":\"The function selector of the receiving contract.\",\"_to\":\"The address of the contract on the receiving chain which receives the calldata.\"},\"returns\":{\"_0\":\"msgId The zero based index of the message in the inbox.\"}},\"sendSnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the state root snapshot using Arbitrum's canonical bridge.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the snapshot requested to send.\"}}},\"version\":1},\"userdoc\":{\"events\":{\"SnapshotSaved(bytes32,uint256,uint64)\":{\"notice\":\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\"}},\"kind\":\"user\",\"methods\":{},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":24,\"contract\":\"src/arbitrumToEth/VeaInboxArbToEth.sol:VeaInboxArbToEth\",\"label\":\"snapshots\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":28,\"contract\":\"src/arbitrumToEth/VeaInboxArbToEth.sol:VeaInboxArbToEth\",\"label\":\"inbox\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_array(t_bytes32)64_storage\"},{\"astId\":30,\"contract\":\"src/arbitrumToEth/VeaInboxArbToEth.sol:VeaInboxArbToEth\",\"label\":\"count\",\"offset\":0,\"slot\":\"65\",\"type\":\"t_uint64\"}],\"types\":{\"t_array(t_bytes32)64_storage\":{\"base\":\"t_bytes32\",\"encoding\":\"inplace\",\"label\":\"bytes32[64]\",\"numberOfBytes\":\"2048\"},\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"},\"t_uint64\":{\"encoding\":\"inplace\",\"label\":\"uint64\",\"numberOfBytes\":\"8\"}}}}");


var $0e44798a3778a7db$exports = {};
$0e44798a3778a7db$exports = JSON.parse("{\"address\":\"0xb1f5125b52CE23D3763AC1C9ACEf0668825A66c0\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_deposit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_minChallengePeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_timeoutEpochs\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"_veaInboxArbToEthDevnet\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_bridge\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_maxMissingBlocks\",\"type\":\"uint256\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_challenger\",\"type\":\"address\"}],\"name\":\"Challenged\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_claimer\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"Claimed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"}],\"name\":\"MessageRelayed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_requestedSequencerDelayLimit\",\"type\":\"uint256\"}],\"name\":\"SequencerDelayLimitDecreaseRequested\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_newSequencerDelayLimit\",\"type\":\"uint256\"}],\"name\":\"SequencerDelayLimitUpdated\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"VerificationStarted\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"Verified\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"BURN_ADDRESS\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"bridge\",\"outputs\":[{\"internalType\":\"contract IBridge\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"burn\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"censorshipTestStatus\",\"outputs\":[{\"internalType\":\"enum VeaOutboxArbToEth.CensorshipTestStatus\",\"name\":\"status\",\"type\":\"uint8\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"challenge\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"},{\"internalType\":\"address\",\"name\":\"_withdrawalAddress\",\"type\":\"address\"}],\"name\":\"challenge\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_devnetOperator\",\"type\":\"address\"}],\"name\":\"changeDevnetOperator\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"claim\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"claimHashes\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"deposit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"depositPlusReward\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateroot\",\"type\":\"bytes32\"}],\"name\":\"devnetAdvanceState\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"devnetOperator\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"executeSequencerDelayLimitDecreaseRequest\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"hashClaim\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"hashedClaim\",\"type\":\"bytes32\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_msgId\",\"type\":\"uint256\"}],\"name\":\"isMsgRelayed\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"isRelayed\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"latestVerifiedEpoch\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"maxMissingBlocks\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"minChallengePeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"resolveDisputedClaim\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"bytes32[]\",\"name\":\"_proof\",\"type\":\"bytes32[]\"},{\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"},{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"bytes\",\"name\":\"_message\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"sequencerDelayLimit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"sequencerDelayLimitDecreaseRequest\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"requestedsequencerDelayLimit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"startVerification\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"stateRoot\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timeoutEpochs\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"updateSequencerDelayLimit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"veaInboxArbToEth\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"verifySnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengeDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"transactionHash\":\"0x669126daa957cf567430de4482e98bc7341f2ff2d20c385dd365a3dd7af2a768\",\"receipt\":{\"to\":null,\"from\":\"0xFa00D29d378EDC57AA1006946F0fc6230a5E3288\",\"contractAddress\":\"0xb1f5125b52CE23D3763AC1C9ACEf0668825A66c0\",\"transactionIndex\":117,\"gasUsed\":\"2311907\",\"logsBloom\":\"0x00000000000000000000000000000008000000000000000000000000000000000000000000000000100080000000000000000000000002000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000040000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0xc6bd2cc9de617dd127e8f6fc0ffcbcf0edfe7529c391b1f55228ef11eafbb7f0\",\"transactionHash\":\"0x669126daa957cf567430de4482e98bc7341f2ff2d20c385dd365a3dd7af2a768\",\"logs\":[{\"transactionIndex\":117,\"blockNumber\":7825233,\"transactionHash\":\"0x669126daa957cf567430de4482e98bc7341f2ff2d20c385dd365a3dd7af2a768\",\"address\":\"0xb1f5125b52CE23D3763AC1C9ACEf0668825A66c0\",\"topics\":[\"0x823e4a64a225e5e0cfa0d1aae07413331b43ea819eecd97f2cb0293ea048140d\"],\"data\":\"0x0000000000000000000000000000000000000000000000000000000000015180\",\"logIndex\":188,\"blockHash\":\"0xc6bd2cc9de617dd127e8f6fc0ffcbcf0edfe7529c391b1f55228ef11eafbb7f0\"}],\"blockNumber\":7825233,\"cumulativeGasUsed\":\"12365707\",\"status\":1,\"byzantium\":true},\"args\":[\"1000000000000000\",1800,0,10000000000000,\"0xF6C5640de593fEf76129F1F1A863F7ddc65776C9\",\"0x38f918D0E9F1b721EDaA41302E399fa1B79333a9\",10000000000000],\"numDeployments\":4,\"solcInputHash\":\"51b873e2d80b78ffb160c3bb515132de\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.24+commit.e11b9ed9\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_deposit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_minChallengePeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timeoutEpochs\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_veaInboxArbToEthDevnet\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_bridge\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_maxMissingBlocks\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"Challenged\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"Claimed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"MessageRelayed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_requestedSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"SequencerDelayLimitDecreaseRequested\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_newSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"SequencerDelayLimitUpdated\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"VerificationStarted\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"Verified\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"BURN_ADDRESS\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"bridge\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"contract IBridge\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"burn\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"censorshipTestStatus\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"enum VeaOutboxArbToEth.CensorshipTestStatus\\\",\\\"name\\\":\\\"status\\\",\\\"type\\\":\\\"uint8\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"challenge\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_withdrawalAddress\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"challenge\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_devnetOperator\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"changeDevnetOperator\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"claim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"claimHashes\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"deposit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"depositPlusReward\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateroot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"devnetAdvanceState\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"devnetOperator\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"executeSequencerDelayLimitDecreaseRequest\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"hashClaim\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"hashedClaim\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"pure\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"isMsgRelayed\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bool\\\",\\\"name\\\":\\\"isRelayed\\\",\\\"type\\\":\\\"bool\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"latestVerifiedEpoch\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"maxMissingBlocks\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"minChallengePeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"resolveDisputedClaim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"bytes32[]\\\",\\\"name\\\":\\\"_proof\\\",\\\"type\\\":\\\"bytes32[]\\\"},{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_message\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"sequencerDelayLimit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"sequencerDelayLimitDecreaseRequest\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"requestedsequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"startVerification\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"stateRoot\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"timeoutEpochs\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"updateSequencerDelayLimit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"veaInboxArbToEth\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"verifySnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengeDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Outbox From arbitrumSepolia to Sepolia. Note: This contract is deployed on Sepolia. Note: This contract is permissioned for developer testing (devnet).\\\",\\\"events\\\":{\\\"Challenged(uint256,address)\\\":{\\\"details\\\":\\\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\",\\\"params\\\":{\\\"_challenger\\\":\\\"The address of the challenger.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenged claim.\\\"}},\\\"Claimed(address,uint256,bytes32)\\\":{\\\"details\\\":\\\"Watchers check this event to challenge fraud.\\\",\\\"params\\\":{\\\"_claimer\\\":\\\"The address of the claimer.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim.\\\",\\\"_stateRoot\\\":\\\"The state root of the claim.\\\"}},\\\"MessageRelayed(uint64)\\\":{\\\"details\\\":\\\"This event indicates that a message has been relayed.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId of the message that was relayed.\\\"}},\\\"SequencerDelayLimitDecreaseRequested(uint256)\\\":{\\\"details\\\":\\\"This event indicates that a request to decrease the sequencer limit has been made.\\\",\\\"params\\\":{\\\"_requestedSequencerDelayLimit\\\":\\\"The new sequencer delay limit requested.\\\"}},\\\"SequencerDelayLimitUpdated(uint256)\\\":{\\\"details\\\":\\\"This event indicates the sequencer limit updated.\\\",\\\"params\\\":{\\\"_newSequencerDelayLimit\\\":\\\"The new sequencer delay limit.\\\"}},\\\"VerificationStarted(uint256)\\\":{\\\"details\\\":\\\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that started verification.\\\"}},\\\"Verified(uint256)\\\":{\\\"details\\\":\\\"This events indicates that verification has succeeded. The messages are ready to be relayed.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that was verified.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Gets the status of the censorship test for claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to test.\\\"},\\\"returns\\\":{\\\"status\\\":\\\"True if the claim passed the censorship test.\\\"}},\\\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address),address)\\\":{\\\"details\\\":\\\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.Allows proxy contracts to batch challenges.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\",\\\"_withdrawalAddress\\\":\\\"The address to withdraw the deposit + reward to.\\\"}},\\\"changeDevnetOperator(address)\\\":{\\\"details\\\":\\\"Changes the devnet operator.\\\",\\\"params\\\":{\\\"_devnetOperator\\\":\\\"The new testnet operator.\\\"}},\\\"claim(uint256,bytes32)\\\":{\\\"details\\\":\\\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which the claim is made.\\\",\\\"_stateRoot\\\":\\\"The state root to claim.\\\"}},\\\"constructor\\\":{\\\"details\\\":\\\"Constructor.\\\",\\\"params\\\":{\\\"_deposit\\\":\\\"The deposit amount to submit a claim in wei.\\\",\\\"_epochPeriod\\\":\\\"The duration of each epoch.\\\",\\\"_maxMissingBlocks\\\":\\\"The maximum number of blocks that can be missing in a challenge period.\\\",\\\"_minChallengePeriod\\\":\\\"The minimum time window to challenge a claim.\\\",\\\"_timeoutEpochs\\\":\\\"The epochs before the bridge is considered shutdown.\\\",\\\"_veaInboxArbToEthDevnet\\\":\\\"The address of the inbox contract on Arbitrum.\\\"}},\\\"devnetAdvanceState(uint256,bytes32)\\\":{\\\"details\\\":\\\"Testnet operator utility function to claim, validate and withdraw.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which the claim is made.\\\",\\\"_stateroot\\\":\\\"The state root to claim.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"executeSequencerDelayLimitDecreaseRequest()\\\":{\\\"details\\\":\\\"execute sequencerDelayLimitDecreaseRequest\\\"},\\\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Hashes the claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to hash.\\\"},\\\"returns\\\":{\\\"hashedClaim\\\":\\\"The hash of the claim.\\\"}},\\\"isMsgRelayed(uint256)\\\":{\\\"details\\\":\\\"Get the msg relayed status.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId to check.\\\"},\\\"returns\\\":{\\\"isRelayed\\\":\\\"True if the msg was relayed.\\\"}},\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves any challenge of the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch to verify.\\\",\\\"_stateRoot\\\":\\\"The true state root for the epoch.\\\"}},\\\"sendMessage(bytes32[],uint64,address,bytes)\\\":{\\\"details\\\":\\\"Verifies and relays the message. UNTRUSTED.\\\",\\\"params\\\":{\\\"_message\\\":\\\"The message encoded in the vea inbox as abi.encodeWithSelector(fnSelector, msg.sender, param1, param2, ...)\\\",\\\"_msgId\\\":\\\"The zero based index of the message in the inbox.\\\",\\\"_proof\\\":\\\"The merkle proof to prove the message inclusion in the inbox state root.\\\",\\\"_to\\\":\\\"The address of the contract on Ethereum to call.\\\"}},\\\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Start verification for claim for 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"updateSequencerDelayLimit()\\\":{\\\"details\\\":\\\"Request to decrease the sequencerDelayLimit.\\\"},\\\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the optimistic claim.\\\"}},\\\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenge deposit to withraw.\\\"}},\\\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Bridger if their claim is not successfully challenged. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"notice\\\":\\\"Note: Access restricted to arbitrum  bridge.\\\"}},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol\\\":\\\"VeaOutboxArbToEthDevnet\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":200},\\\"remappings\\\":[]},\\\"sources\\\":{\\\"src/arbitrumToEth/VeaOutboxArbToEth.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/arbitrum/ISequencerInbox.sol\\\\\\\";\\\\nimport \\\\\\\"../canonical/arbitrum/IBridge.sol\\\\\\\";\\\\nimport \\\\\\\"../canonical/arbitrum/IOutbox.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/outboxes/IVeaOutboxOnL1.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Outbox From Arbitrum to Ethereum.\\\\n/// Note: This contract is deployed on Ethereum.\\\\ncontract VeaOutboxArbToEth is IVeaOutboxOnL1 {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    IBridge public immutable bridge; // The address of the Arbitrum bridge contract.\\\\n    address public immutable veaInboxArbToEth; // The address of the vea inbox on arbitrum.\\\\n\\\\n    uint256 public immutable deposit; // The deposit in wei required to submit a claim or challenge\\\\n    uint256 public immutable burn; // The amount of wei to burn. deposit / 2\\\\n    uint256 public immutable depositPlusReward; // 2 * deposit - burn\\\\n\\\\n    address public constant BURN_ADDRESS = address(0); // Address to send burned eth\\\\n    uint256 internal constant SLOT_TIME = 12; // Ethereum 12 second slot time\\\\n\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    uint256 public immutable minChallengePeriod; // Minimum time window to challenge a claim, even with a malicious sequencer.\\\\n\\\\n    uint256 public immutable timeoutEpochs; // The number of epochs without forward progress before the bridge is considered shutdown.\\\\n    uint256 public immutable maxMissingBlocks; // The maximum number of blocks that can be missing in a challenge period.\\\\n\\\\n    bytes32 public stateRoot; // merkle root of the outbox state\\\\n    uint256 public latestVerifiedEpoch; // The latest epoch that has been verified.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public claimHashes; // epoch => claim\\\\n    mapping(uint256 messageId => bytes32) internal relayed; // msgId/256 => packed replay bitmap, preferred over a simple boolean mapping to save 15k gas per message\\\\n\\\\n    uint256 public sequencerDelayLimit; // This is MaxTimeVariation.delaySeconds from the arbitrum sequencer inbox, it is the maximum seconds the sequencer can backdate L2 txns relative to the L1 clock.\\\\n    SequencerDelayLimitDecreaseRequest public sequencerDelayLimitDecreaseRequest; // Decreasing the sequencerDelayLimit requires a delay to avoid griefing by sequencer, so we keep track of the request here.\\\\n\\\\n    struct SequencerDelayLimitDecreaseRequest {\\\\n        uint256 requestedsequencerDelayLimit;\\\\n        uint256 timestamp;\\\\n    }\\\\n\\\\n    enum CensorshipTestStatus {\\\\n        Failed,\\\\n        Passed,\\\\n        NotStarted,\\\\n        InProgress\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Watchers check this event to challenge fraud.\\\\n    /// @param _claimer The address of the claimer.\\\\n    /// @param _epoch The epoch associated with the claim.\\\\n    /// @param _stateRoot The state root of the claim.\\\\n    event Claimed(address indexed _claimer, uint256 indexed _epoch, bytes32 _stateRoot);\\\\n\\\\n    /// @dev This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\\n    /// @param _epoch The epoch associated with the challenged claim.\\\\n    /// @param _challenger The address of the challenger.\\\\n    event Challenged(uint256 indexed _epoch, address indexed _challenger);\\\\n\\\\n    /// @dev This event indicates that a message has been relayed.\\\\n    /// @param _msgId The msgId of the message that was relayed.\\\\n    event MessageRelayed(uint64 _msgId);\\\\n\\\\n    /// @dev This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\\n    /// @param _epoch The epoch that started verification.\\\\n    event VerificationStarted(uint256 indexed _epoch);\\\\n\\\\n    /// @dev This events indicates that verification has succeeded. The messages are ready to be relayed.\\\\n    /// @param _epoch The epoch that was verified.\\\\n    event Verified(uint256 _epoch);\\\\n\\\\n    /// @dev This event indicates the sequencer limit updated.\\\\n    /// @param _newSequencerDelayLimit The new sequencer delay limit.\\\\n    event SequencerDelayLimitUpdated(uint256 _newSequencerDelayLimit);\\\\n\\\\n    /// @dev This event indicates that a request to decrease the sequencer limit has been made.\\\\n    /// @param _requestedSequencerDelayLimit The new sequencer delay limit requested.\\\\n    event SequencerDelayLimitDecreaseRequested(uint256 _requestedSequencerDelayLimit);\\\\n\\\\n    // ************************************* //\\\\n    // *        Function Modifiers         * //\\\\n    // ************************************* //\\\\n\\\\n    modifier OnlyBridgeRunning() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch <= timeoutEpochs, \\\\\\\"Bridge Shutdown.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    modifier OnlyBridgeShutdown() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch > timeoutEpochs, \\\\\\\"Bridge Running.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaInboxArbToEth contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _deposit The deposit amount to submit a claim in wei.\\\\n    /// @param _epochPeriod The duration of each epoch.\\\\n    /// @param _minChallengePeriod The minimum time window to challenge a claim.\\\\n    /// @param _timeoutEpochs The epochs before the bridge is considered shutdown.\\\\n    /// @param _veaInboxArbToEth The address of the inbox contract on Arbitrum.\\\\n    /// @param _maxMissingBlocks The maximum number of blocks that can be missing in a challenge period.\\\\n    constructor(\\\\n        uint256 _deposit,\\\\n        uint256 _epochPeriod,\\\\n        uint256 _minChallengePeriod,\\\\n        uint256 _timeoutEpochs,\\\\n        address _veaInboxArbToEth,\\\\n        address _bridge,\\\\n        uint256 _maxMissingBlocks\\\\n    ) {\\\\n        deposit = _deposit;\\\\n        // epochPeriod must match the VeaInboxArbToEth contract deployment epochPeriod value.\\\\n        epochPeriod = _epochPeriod;\\\\n        minChallengePeriod = _minChallengePeriod;\\\\n        timeoutEpochs = _timeoutEpochs;\\\\n        veaInboxArbToEth = _veaInboxArbToEth;\\\\n        bridge = IBridge(_bridge);\\\\n        maxMissingBlocks = _maxMissingBlocks;\\\\n\\\\n        updateSequencerDelayLimit();\\\\n\\\\n        // claimant and challenger are not sybil resistant\\\\n        // must burn half deposit to prevent zero cost griefing\\\\n        burn = _deposit / 2;\\\\n        depositPlusReward = 2 * _deposit - burn;\\\\n\\\\n        latestVerifiedEpoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *        Parameter Updates          * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Request to decrease the sequencerDelayLimit.\\\\n    function updateSequencerDelayLimit() public {\\\\n        // the maximum asynchronous lag between the L2 and L1 clocks\\\\n        (, , uint256 newSequencerDelayLimit, ) = ISequencerInbox(bridge.sequencerInbox()).maxTimeVariation();\\\\n\\\\n        if (newSequencerDelayLimit > sequencerDelayLimit) {\\\\n            // For sequencerDelayLimit / epochPeriod > timeoutEpochs, claims cannot be verified by the timeout period and the bridge will shutdown.\\\\n            sequencerDelayLimit = newSequencerDelayLimit;\\\\n            emit SequencerDelayLimitUpdated(newSequencerDelayLimit);\\\\n        } else if (newSequencerDelayLimit < sequencerDelayLimit) {\\\\n            require(\\\\n                sequencerDelayLimitDecreaseRequest.timestamp == 0,\\\\n                \\\\\\\"Sequencer limit decrease request already pending.\\\\\\\"\\\\n            );\\\\n\\\\n            sequencerDelayLimitDecreaseRequest = SequencerDelayLimitDecreaseRequest({\\\\n                requestedsequencerDelayLimit: newSequencerDelayLimit,\\\\n                timestamp: block.timestamp\\\\n            });\\\\n\\\\n            emit SequencerDelayLimitDecreaseRequested(newSequencerDelayLimit);\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev execute sequencerDelayLimitDecreaseRequest\\\\n    function executeSequencerDelayLimitDecreaseRequest() external {\\\\n        require(sequencerDelayLimitDecreaseRequest.timestamp != 0, \\\\\\\"No pending sequencer limit decrease request.\\\\\\\");\\\\n        require(\\\\n            block.timestamp > sequencerDelayLimitDecreaseRequest.timestamp + sequencerDelayLimit,\\\\n            \\\\\\\"Sequencer limit decrease request is still pending.\\\\\\\"\\\\n        );\\\\n\\\\n        uint256 requestedsequencerDelayLimit = sequencerDelayLimitDecreaseRequest.requestedsequencerDelayLimit;\\\\n        delete sequencerDelayLimitDecreaseRequest;\\\\n\\\\n        (, , uint256 currentsequencerDelayLimit, ) = ISequencerInbox(bridge.sequencerInbox()).maxTimeVariation();\\\\n\\\\n        // check the request is still consistent with the arbiturm bridge\\\\n        if (currentsequencerDelayLimit == requestedsequencerDelayLimit) {\\\\n            sequencerDelayLimit = requestedsequencerDelayLimit;\\\\n            emit SequencerDelayLimitUpdated(requestedsequencerDelayLimit);\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateRoot The state root to claim.\\\\n    function claim(uint256 _epoch, bytes32 _stateRoot) external payable virtual {\\\\n        require(msg.value >= deposit, \\\\\\\"Insufficient claim deposit.\\\\\\\");\\\\n        unchecked {\\\\n            require(_epoch == block.timestamp / epochPeriod - 1, \\\\\\\"Invalid epoch.\\\\\\\");\\\\n        }\\\\n        require(_stateRoot != bytes32(0), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(claimHashes[_epoch] == bytes32(0), \\\\\\\"Claim already made.\\\\\\\");\\\\n\\\\n        claimHashes[_epoch] = hashClaim(\\\\n            Claim({\\\\n                stateRoot: _stateRoot,\\\\n                claimer: msg.sender,\\\\n                timestampClaimed: uint32(block.timestamp),\\\\n                timestampVerification: uint32(0),\\\\n                blocknumberVerification: uint32(0),\\\\n                honest: Party.None,\\\\n                challenger: address(0)\\\\n            })\\\\n        );\\\\n\\\\n        emit Claimed(msg.sender, _epoch, _stateRoot);\\\\n\\\\n        // Refund overpayment.\\\\n        if (msg.value > deposit) {\\\\n            uint256 refund = msg.value - deposit;\\\\n            payable(msg.sender).send(refund); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function challenge(uint256 _epoch, Claim memory _claim) external payable {\\\\n        _challenge(_epoch, _claim, msg.sender);\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @dev Allows proxy contracts to batch challenges.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    /// @param _withdrawalAddress The address to withdraw the deposit + reward to.\\\\n    function challenge(uint256 _epoch, Claim memory _claim, address _withdrawalAddress) external payable {\\\\n        _challenge(_epoch, _claim, _withdrawalAddress);\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    /// @param _withdrawAddress The address to withdraw the deposit + reward to.\\\\n    function _challenge(uint256 _epoch, Claim memory _claim, address _withdrawAddress) internal {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(msg.value >= deposit, \\\\\\\"Insufficient challenge deposit.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim already challenged.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim already verified.\\\\\\\");\\\\n\\\\n        _claim.challenger = _withdrawAddress;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Challenged(_epoch, _withdrawAddress);\\\\n\\\\n        // Refund overpayment.\\\\n        if (msg.value > deposit) {\\\\n            uint256 refund = msg.value - deposit;\\\\n            payable(msg.sender).send(refund); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Start verification for claim for 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function startVerification(uint256 _epoch, Claim memory _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n\\\\n        // sequencerDelayLimit + epochPeriod is the worst case time to sync the L2 state compared to L1 clock.\\\\n        // using checked arithmetic incase arbitrum governance sets sequencerDelayLimit to a large value\\\\n        require(\\\\n            block.timestamp - uint256(_claim.timestampClaimed) >= sequencerDelayLimit + epochPeriod,\\\\n            \\\\\\\"Claim must wait atleast maxL2StateSyncDelay.\\\\\\\"\\\\n        );\\\\n\\\\n        CensorshipTestStatus _censorshipTestStatus = censorshipTestStatus(_claim);\\\\n        require(\\\\n            _censorshipTestStatus == CensorshipTestStatus.NotStarted ||\\\\n                _censorshipTestStatus == CensorshipTestStatus.Failed,\\\\n            \\\\\\\"Claim verification in progress or already completed.\\\\\\\"\\\\n        );\\\\n\\\\n        _claim.timestampVerification = uint32(block.timestamp);\\\\n        _claim.blocknumberVerification = uint32(block.number);\\\\n\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit VerificationStarted(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Resolves the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch of the optimistic claim.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function verifySnapshot(uint256 _epoch, Claim memory _claim) external virtual OnlyBridgeRunning {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n        require(censorshipTestStatus(_claim) == CensorshipTestStatus.Passed, \\\\\\\"Censorship test not passed.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _claim.stateRoot;\\\\n        }\\\\n\\\\n        _claim.honest = Party.Claimer;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// Note: Access restricted to arbitrum  bridge.\\\\n    /// @dev Resolves any challenge of the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(\\\\n        uint256 _epoch,\\\\n        bytes32 _stateRoot,\\\\n        Claim memory _claim\\\\n    ) external virtual OnlyBridgeRunning {\\\\n        // Arbitrum -> Ethereum message sender authentication\\\\n        // docs: https://developer.arbitrum.io/arbos/l2-to-l1-messaging/\\\\n        // example: https://github.com/OpenZeppelin/openzeppelin-contracts/blob/dfef6a68ee18dbd2e1f5a099061a3b8a0e404485/contracts/crosschain/arbitrum/LibArbitrumL1.sol#L34\\\\n        // example: https://github.com/OffchainLabs/arbitrum-tutorials/blob/2c1b7d2db8f36efa496e35b561864c0f94123a5f/packages/greeter/contracts/ethereum/GreeterL1.sol#L50\\\\n        // note: we call the bridge for the activeOutbox address\\\\n\\\\n        require(msg.sender == address(bridge), \\\\\\\"Not from native arbitrum bridge.\\\\\\\");\\\\n        require(IOutbox(bridge.activeOutbox()).l2ToL1Sender() == veaInboxArbToEth, \\\\\\\"veaInboxArbToEth only.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch && _stateRoot != bytes32(0)) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _stateRoot;\\\\n        }\\\\n\\\\n        if (claimHashes[_epoch] == hashClaim(_claim)) {\\\\n            if (_claim.stateRoot == _stateRoot) {\\\\n                _claim.honest = Party.Claimer;\\\\n            } else if (_claim.challenger != address(0)) {\\\\n                _claim.honest = Party.Challenger;\\\\n            }\\\\n            claimHashes[_epoch] = hashClaim(_claim);\\\\n        }\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Verifies and relays the message. UNTRUSTED.\\\\n    /// @param _proof The merkle proof to prove the message inclusion in the inbox state root.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address of the contract on Ethereum to call.\\\\n    /// @param _message The message encoded in the vea inbox as abi.encodeWithSelector(fnSelector, msg.sender, param1, param2, ...)\\\\n    function sendMessage(bytes32[] calldata _proof, uint64 _msgId, address _to, bytes calldata _message) external {\\\\n        require(_proof.length < 64, \\\\\\\"Proof too long.\\\\\\\");\\\\n\\\\n        bytes32 nodeHash = keccak256(abi.encodePacked(_msgId, _to, _message));\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            mstore(0x00, nodeHash)\\\\n            nodeHash := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        unchecked {\\\\n            for (uint256 i = 0; i < _proof.length; i++) {\\\\n                bytes32 proofElement = _proof[i];\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                if (proofElement > nodeHash)\\\\n                    assembly {\\\\n                        mstore(0x00, nodeHash)\\\\n                        mstore(0x20, proofElement)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n                else\\\\n                    assembly {\\\\n                        mstore(0x00, proofElement)\\\\n                        mstore(0x20, nodeHash)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n            }\\\\n        }\\\\n\\\\n        require(stateRoot == nodeHash, \\\\\\\"Invalid proof.\\\\\\\");\\\\n\\\\n        // msgId is the zero-based index of the message in the inbox.\\\\n        // msgId is also used as an index in the relayed bitmap to prevent replay.\\\\n        // Note: a bitmap is used instead of a simple boolean mapping to save 15k gas per message.\\\\n\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        require(((replay >> offset) & bytes32(uint256(1))) == bytes32(0), \\\\\\\"Message already relayed\\\\\\\");\\\\n        relayed[relayIndex] = replay | bytes32(1 << offset);\\\\n\\\\n        // UNTRUSTED.\\\\n        (bool success, ) = _to.call(_message);\\\\n        require(success, \\\\\\\"Failed to call contract\\\\\\\");\\\\n\\\\n        emit MessageRelayed(_msgId);\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimDeposit(uint256 _epoch, Claim calldata _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Claimer, \\\\\\\"Claim failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            payable(BURN_ADDRESS).send(burn);\\\\n            payable(_claim.claimer).send(depositPlusReward); // User is responsible for accepting ETH.\\\\n        } else {\\\\n            payable(_claim.claimer).send(deposit); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\\n    /// @param _epoch The epoch associated with the challenge deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengeDeposit(uint256 _epoch, Claim calldata _claim) external {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Challenger, \\\\\\\"Challenge failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        payable(BURN_ADDRESS).send(burn); // half burnt\\\\n        payable(_claim.challenger).send(depositPlusReward); // User is responsible for accepting ETH.\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.claimer != address(0)) {\\\\n            if (_claim.challenger == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                payable(_claim.claimer).send(deposit); // User is responsible for accepting ETH.\\\\n            } else {\\\\n                address claimer = _claim.claimer;\\\\n                _claim.claimer = address(0);\\\\n                claimHashes[_epoch] = hashClaim(_claim);\\\\n                payable(claimer).send(deposit); // User is responsible for accepting ETH.\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            if (_claim.claimer == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                payable(_claim.challenger).send(deposit); // User is responsible for accepting ETH.\\\\n            } else {\\\\n                address challenger = _claim.challenger;\\\\n                _claim.challenger = address(0);\\\\n                claimHashes[_epoch] == hashClaim(_claim);\\\\n                payable(challenger).send(deposit); // User is responsible for accepting ETH.\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Hashes the claim.\\\\n    /// @param _claim The claim to hash.\\\\n    /// @return hashedClaim The hash of the claim.\\\\n    function hashClaim(Claim memory _claim) public pure returns (bytes32 hashedClaim) {\\\\n        return\\\\n            hashedClaim = keccak256(\\\\n                abi.encodePacked(\\\\n                    _claim.stateRoot,\\\\n                    _claim.claimer,\\\\n                    _claim.timestampClaimed,\\\\n                    _claim.timestampVerification,\\\\n                    _claim.blocknumberVerification,\\\\n                    _claim.honest,\\\\n                    _claim.challenger\\\\n                )\\\\n            );\\\\n    }\\\\n\\\\n    /// @dev Gets the status of the censorship test for claim.\\\\n    /// @param _claim The claim to test.\\\\n    /// @return status True if the claim passed the censorship test.\\\\n    function censorshipTestStatus(Claim memory _claim) public view returns (CensorshipTestStatus status) {\\\\n        unchecked {\\\\n            if (uint256(_claim.timestampVerification) == 0) {\\\\n                status = CensorshipTestStatus.NotStarted;\\\\n            } else if (block.timestamp - uint256(_claim.timestampVerification) < minChallengePeriod) {\\\\n                status = CensorshipTestStatus.InProgress;\\\\n            } else {\\\\n                uint256 expectedBlocks = uint256(_claim.blocknumberVerification) +\\\\n                    (block.timestamp - uint256(_claim.timestampVerification)) /\\\\n                    SLOT_TIME;\\\\n                uint256 actualBlocks = block.number;\\\\n                if (expectedBlocks - actualBlocks <= maxMissingBlocks) {\\\\n                    status = CensorshipTestStatus.Passed;\\\\n                } else {\\\\n                    status = CensorshipTestStatus.Failed;\\\\n                }\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochAt(uint256 timestamp) external view returns (uint256 epoch) {\\\\n        epoch = timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the msg relayed status.\\\\n    /// @param _msgId The msgId to check.\\\\n    /// @return isRelayed True if the msg was relayed.\\\\n    function isMsgRelayed(uint256 _msgId) external view returns (bool isRelayed) {\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        isRelayed = (replay >> offset) & bytes32(uint256(1)) == bytes32(uint256(1));\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x6383e84fd3d531b95493fe35f3158aaaa7361f1c378cf6e0fe473d049f19d1d2\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/arbitrum/IBridge.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/08ac127e966fa87a4d5ba3d23cd3132b57701132/src/bridge/IBridge.sol\\\\n// proxy: https://etherscan.io/address/0x8315177aB297bA92A06054cE80a67Ed4DBd7ed3a\\\\n// implementation: https://etherscan.io/address/0x1066cecc8880948fe55e427e94f1ff221d626591#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\ninterface IBridge {\\\\n    function activeOutbox() external view returns (address);\\\\n\\\\n    function sequencerInbox() external view returns (address);\\\\n\\\\n    function allowedDelayedInboxList(uint256) external returns (address);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x0e7981b3e9b179caa0085d1ad900b19e88e29fec65923f41fde0315773fa9a3c\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/canonical/arbitrum/IOutbox.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/08ac127e966fa87a4d5ba3d23cd3132b57701132/src/bridge/IBridge.sol\\\\n// proxy: https://etherscan.io/address/0x0B9857ae2D4A3DBe74ffE1d7DF045bb7F96E4840#code\\\\n// implementation: https://etherscan.io/address/0x0ea7372338a589e7f0b00e463a53aa464ef04e17#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\ninterface IOutbox {\\\\n    /// @notice When l2ToL1Sender returns a nonzero address, the message was originated by an L2 account\\\\n    ///         When the return value is zero, that means this is a system message\\\\n    /// @dev the l2ToL1Sender behaves as the tx.origin, the msg.sender should be validated to protect against reentrancies\\\\n    function l2ToL1Sender() external view returns (address);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x4d815542262727a2a3182332a7c16b0b1d33c031997de91c12e67e87e748b8ca\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/canonical/arbitrum/ISequencerInbox.sol\\\":{\\\"content\\\":\\\"// Copyright 2021-2022, Offchain Labs, Inc.\\\\n// For license information, see https://github.com/nitro/blob/master/LICENSE\\\\n// SPDX-License-Identifier: BUSL-1.1\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/08ac127e966fa87a4d5ba3d23cd3132b57701132/src/bridge/ISequencerInbox.sol\\\\n// proxy: https://etherscan.io/address/0x1c479675ad559DC151F6Ec7ed3FbF8ceE79582B6#code\\\\n// implementation: https://etherscan.io/address/0xD03bFe2CE83632F4E618a97299cc91B1335BB2d9#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"./IBridge.sol\\\\\\\";\\\\n\\\\ninterface ISequencerInbox {\\\\n    struct MaxTimeVariation {\\\\n        uint256 delayBlocks;\\\\n        uint256 futureBlocks;\\\\n        uint256 delaySeconds;\\\\n        uint256 futureSeconds;\\\\n    }\\\\n\\\\n    function maxTimeVariation() external view returns (uint256, uint256, uint256, uint256);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xf972282dbad5eae92a352e0de6b588000bf4c58f45d90a30ef8863d5878313bc\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"../../arbitrumToEth/VeaOutboxArbToEth.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Outbox From arbitrumSepolia to Sepolia.\\\\n/// Note: This contract is deployed on Sepolia.\\\\n/// Note: This contract is permissioned for developer testing (devnet).\\\\ncontract VeaOutboxArbToEthDevnet is VeaOutboxArbToEth {\\\\n    address public devnetOperator; // permissioned devnet operator\\\\n\\\\n    /// @dev Requires that the sender is the devnet operator.\\\\n    modifier onlyByDevnetOperator() {\\\\n        require(devnetOperator == msg.sender);\\\\n        _;\\\\n    }\\\\n\\\\n    /// @dev Changes the devnet operator.\\\\n    /// @param _devnetOperator The new testnet operator.\\\\n    function changeDevnetOperator(address _devnetOperator) external onlyByDevnetOperator {\\\\n        require(msg.sender == devnetOperator, \\\\\\\"Invalid Testnet Operator\\\\\\\");\\\\n        devnetOperator = _devnetOperator;\\\\n    }\\\\n\\\\n    /// @dev Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateRoot The state root to claim.\\\\n    function claim(uint256 _epoch, bytes32 _stateRoot) public payable override onlyByDevnetOperator {\\\\n        require(msg.value >= deposit, \\\\\\\"Insufficient claim deposit.\\\\\\\");\\\\n        require(_stateRoot != bytes32(0), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(claimHashes[_epoch] == bytes32(0), \\\\\\\"Claim already made.\\\\\\\");\\\\n\\\\n        claimHashes[_epoch] = hashClaim(\\\\n            Claim({\\\\n                stateRoot: _stateRoot,\\\\n                claimer: msg.sender,\\\\n                timestampClaimed: uint32(block.timestamp),\\\\n                timestampVerification: uint32(0),\\\\n                blocknumberVerification: uint32(0),\\\\n                honest: Party.None,\\\\n                challenger: address(0)\\\\n            })\\\\n        );\\\\n\\\\n        emit Claimed(msg.sender, _epoch, _stateRoot);\\\\n\\\\n        // Refund overpayment.\\\\n        if (msg.value > deposit) {\\\\n            uint256 refund = msg.value - deposit;\\\\n            payable(msg.sender).send(refund); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Start verification for claim for 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function startVerification(uint256 _epoch, Claim memory _claim) public override onlyByDevnetOperator {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n\\\\n        _claim.timestampVerification = uint32(block.timestamp);\\\\n        _claim.blocknumberVerification = uint32(block.number);\\\\n\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit VerificationStarted(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Bridger if their claim is not successfully challenged. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    function withdrawClaimDeposit(uint256 _epoch, Claim memory _claim) public override {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Claimer, \\\\\\\"Claim failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            payable(BURN_ADDRESS).send(burn);\\\\n            payable(_claim.claimer).send(depositPlusReward); // User is responsible for accepting ETH.\\\\n        } else {\\\\n            payable(_claim.claimer).send(deposit); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Resolves the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch of the optimistic claim.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function verifySnapshot(uint256 _epoch, Claim memory _claim) public override OnlyBridgeRunning {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _claim.stateRoot;\\\\n        }\\\\n\\\\n        _claim.honest = Party.Claimer;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Testnet operator utility function to claim, validate and withdraw.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateroot The state root to claim.\\\\n    function devnetAdvanceState(uint256 _epoch, bytes32 _stateroot) external payable {\\\\n        claim(_epoch, _stateroot);\\\\n        Claim memory claim = Claim({\\\\n            stateRoot: _stateroot,\\\\n            claimer: msg.sender,\\\\n            timestampClaimed: uint32(block.timestamp),\\\\n            timestampVerification: uint32(0),\\\\n            blocknumberVerification: uint32(0),\\\\n            honest: Party.None,\\\\n            challenger: address(0)\\\\n        });\\\\n        claim.timestampClaimed = uint32(block.timestamp);\\\\n        startVerification(_epoch, claim);\\\\n        claim.timestampVerification = uint32(block.timestamp);\\\\n        claim.blocknumberVerification = uint32(block.number);\\\\n        verifySnapshot(_epoch, claim);\\\\n        claim.honest = Party.Claimer;\\\\n        withdrawClaimDeposit(_epoch, claim);\\\\n    }\\\\n\\\\n    /// @dev Constructor.\\\\n    /// @param _deposit The deposit amount to submit a claim in wei.\\\\n    /// @param _epochPeriod The duration of each epoch.\\\\n    /// @param _minChallengePeriod The minimum time window to challenge a claim.\\\\n    /// @param _timeoutEpochs The epochs before the bridge is considered shutdown.\\\\n    /// @param _veaInboxArbToEthDevnet The address of the inbox contract on Arbitrum.\\\\n    /// @param _maxMissingBlocks The maximum number of blocks that can be missing in a challenge period.\\\\n    constructor(\\\\n        uint256 _deposit,\\\\n        uint256 _epochPeriod,\\\\n        uint256 _minChallengePeriod,\\\\n        uint256 _timeoutEpochs,\\\\n        address _veaInboxArbToEthDevnet,\\\\n        address _bridge,\\\\n        uint256 _maxMissingBlocks\\\\n    )\\\\n        VeaOutboxArbToEth(\\\\n            _deposit,\\\\n            _epochPeriod,\\\\n            _minChallengePeriod,\\\\n            _timeoutEpochs,\\\\n            _veaInboxArbToEthDevnet,\\\\n            _bridge,\\\\n            _maxMissingBlocks\\\\n        )\\\\n    {\\\\n        devnetOperator = msg.sender;\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xa3a373420a43cd2fcea7cfdbf4cf87d1d61921bcdb71ed2f214a3b73ac6def7f\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/outboxes/IVeaOutboxOnL1.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Outbox on L1 chains like Ethereum, Gnosis, Polygon POS where storage is expensive.\\\\ninterface IVeaOutboxOnL1 {\\\\n    /// @dev Verifies and relays the message.\\\\n    /// Note: Gateways expect first argument of message call to be the arbitrum message sender, used for authentication.\\\\n    /// @param _proof The merkle proof to prove the message.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address to send the message to.\\\\n    /// @param _message The message to relay.\\\\n    function sendMessage(bytes32[] calldata _proof, uint64 _msgId, address _to, bytes calldata _message) external;\\\\n\\\\n    /// @dev Resolves any challenge of the optimistic claim for 'epoch' using the canonical bridge.\\\\n    /// Note: Access restricted to canonical bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(uint256 _epoch, bytes32 _stateRoot, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xf1d52e289e790088502b7909f11f47bc33ddd3fc545636b7fb29c01ed00d3ff3\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xfef781e359c97aebbe8dbfcb75edb7cb962139fd9ea538b8b89a3f2e13a05bfe\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"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\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Outbox From arbitrumSepolia to Sepolia. Note: This contract is deployed on Sepolia. Note: This contract is permissioned for developer testing (devnet).\",\"events\":{\"Challenged(uint256,address)\":{\"details\":\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\",\"params\":{\"_challenger\":\"The address of the challenger.\",\"_epoch\":\"The epoch associated with the challenged claim.\"}},\"Claimed(address,uint256,bytes32)\":{\"details\":\"Watchers check this event to challenge fraud.\",\"params\":{\"_claimer\":\"The address of the claimer.\",\"_epoch\":\"The epoch associated with the claim.\",\"_stateRoot\":\"The state root of the claim.\"}},\"MessageRelayed(uint64)\":{\"details\":\"This event indicates that a message has been relayed.\",\"params\":{\"_msgId\":\"The msgId of the message that was relayed.\"}},\"SequencerDelayLimitDecreaseRequested(uint256)\":{\"details\":\"This event indicates that a request to decrease the sequencer limit has been made.\",\"params\":{\"_requestedSequencerDelayLimit\":\"The new sequencer delay limit requested.\"}},\"SequencerDelayLimitUpdated(uint256)\":{\"details\":\"This event indicates the sequencer limit updated.\",\"params\":{\"_newSequencerDelayLimit\":\"The new sequencer delay limit.\"}},\"VerificationStarted(uint256)\":{\"details\":\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\",\"params\":{\"_epoch\":\"The epoch that started verification.\"}},\"Verified(uint256)\":{\"details\":\"This events indicates that verification has succeeded. The messages are ready to be relayed.\",\"params\":{\"_epoch\":\"The epoch that was verified.\"}}},\"kind\":\"dev\",\"methods\":{\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Gets the status of the censorship test for claim.\",\"params\":{\"_claim\":\"The claim to test.\"},\"returns\":{\"status\":\"True if the claim passed the censorship test.\"}},\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address),address)\":{\"details\":\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.Allows proxy contracts to batch challenges.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\",\"_withdrawalAddress\":\"The address to withdraw the deposit + reward to.\"}},\"changeDevnetOperator(address)\":{\"details\":\"Changes the devnet operator.\",\"params\":{\"_devnetOperator\":\"The new testnet operator.\"}},\"claim(uint256,bytes32)\":{\"details\":\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\",\"params\":{\"_epoch\":\"The epoch for which the claim is made.\",\"_stateRoot\":\"The state root to claim.\"}},\"constructor\":{\"details\":\"Constructor.\",\"params\":{\"_deposit\":\"The deposit amount to submit a claim in wei.\",\"_epochPeriod\":\"The duration of each epoch.\",\"_maxMissingBlocks\":\"The maximum number of blocks that can be missing in a challenge period.\",\"_minChallengePeriod\":\"The minimum time window to challenge a claim.\",\"_timeoutEpochs\":\"The epochs before the bridge is considered shutdown.\",\"_veaInboxArbToEthDevnet\":\"The address of the inbox contract on Arbitrum.\"}},\"devnetAdvanceState(uint256,bytes32)\":{\"details\":\"Testnet operator utility function to claim, validate and withdraw.\",\"params\":{\"_epoch\":\"The epoch for which the claim is made.\",\"_stateroot\":\"The state root to claim.\"}},\"epochAt(uint256)\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"executeSequencerDelayLimitDecreaseRequest()\":{\"details\":\"execute sequencerDelayLimitDecreaseRequest\"},\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Hashes the claim.\",\"params\":{\"_claim\":\"The claim to hash.\"},\"returns\":{\"hashedClaim\":\"The hash of the claim.\"}},\"isMsgRelayed(uint256)\":{\"details\":\"Get the msg relayed status.\",\"params\":{\"_msgId\":\"The msgId to check.\"},\"returns\":{\"isRelayed\":\"True if the msg was relayed.\"}},\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves any challenge of the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch to verify.\",\"_stateRoot\":\"The true state root for the epoch.\"}},\"sendMessage(bytes32[],uint64,address,bytes)\":{\"details\":\"Verifies and relays the message. UNTRUSTED.\",\"params\":{\"_message\":\"The message encoded in the vea inbox as abi.encodeWithSelector(fnSelector, msg.sender, param1, param2, ...)\",\"_msgId\":\"The zero based index of the message in the inbox.\",\"_proof\":\"The merkle proof to prove the message inclusion in the inbox state root.\",\"_to\":\"The address of the contract on Ethereum to call.\"}},\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Start verification for claim for 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"updateSequencerDelayLimit()\":{\"details\":\"Request to decrease the sequencerDelayLimit.\"},\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the optimistic claim.\"}},\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the challenge deposit to withraw.\"}},\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Bridger if their claim is not successfully challenged. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"notice\":\"Note: Access restricted to arbitrum  bridge.\"}},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":38,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"stateRoot\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_bytes32\"},{\"astId\":40,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"latestVerifiedEpoch\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_uint256\"},{\"astId\":44,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"claimHashes\",\"offset\":0,\"slot\":\"2\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":48,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"relayed\",\"offset\":0,\"slot\":\"3\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":50,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"sequencerDelayLimit\",\"offset\":0,\"slot\":\"4\",\"type\":\"t_uint256\"},{\"astId\":53,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"sequencerDelayLimitDecreaseRequest\",\"offset\":0,\"slot\":\"5\",\"type\":\"t_struct(SequencerDelayLimitDecreaseRequest)58_storage\"},{\"astId\":3040,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"devnetOperator\",\"offset\":0,\"slot\":\"7\",\"type\":\"t_address\"}],\"types\":{\"t_address\":{\"encoding\":\"inplace\",\"label\":\"address\",\"numberOfBytes\":\"20\"},\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_struct(SequencerDelayLimitDecreaseRequest)58_storage\":{\"encoding\":\"inplace\",\"label\":\"struct VeaOutboxArbToEth.SequencerDelayLimitDecreaseRequest\",\"members\":[{\"astId\":55,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"requestedsequencerDelayLimit\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_uint256\"},{\"astId\":57,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"timestamp\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_uint256\"}],\"numberOfBytes\":\"64\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"}}}}");


var $e5ebe9d8b4c021eb$exports = {};
$e5ebe9d8b4c021eb$exports = JSON.parse("{\"address\":\"0xF6286b9C6c7F1B33Ea976FA43434027c7b8421A7\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"_routerArbToGnosis\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes\",\"name\":\"_nodeData\",\"type\":\"bytes\"}],\"name\":\"MessageSent\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_snapshot\",\"type\":\"bytes32\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_count\",\"type\":\"uint64\"}],\"name\":\"SnapshotSaved\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epochSent\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_ticketId\",\"type\":\"bytes32\"}],\"name\":\"SnapshotSent\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"count\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochFinalized\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"routerArbToGnosis\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"saveSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"bytes4\",\"name\":\"_fnSelector\",\"type\":\"bytes4\"},{\"internalType\":\"bytes\",\"name\":\"_data\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_gasLimit\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"sendSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"snapshots\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"}],\"transactionHash\":\"0xf186de78aabed11b83ca56695ccb9577f508e6ca8f0accf26dde67a0a6ea29bc\",\"receipt\":{\"to\":null,\"from\":\"0xFa00D29d378EDC57AA1006946F0fc6230a5E3288\",\"contractAddress\":\"0xF6286b9C6c7F1B33Ea976FA43434027c7b8421A7\",\"transactionIndex\":3,\"gasUsed\":\"743079\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0x742f408ced15302cf99c0943fb9017ced28e825460581ad03b09ab92ad9150dc\",\"transactionHash\":\"0xf186de78aabed11b83ca56695ccb9577f508e6ca8f0accf26dde67a0a6ea29bc\",\"logs\":[],\"blockNumber\":129093812,\"cumulativeGasUsed\":\"1723667\",\"status\":1,\"byzantium\":true},\"args\":[1800,\"0xE24B2838962207F585F4fa5C5bE3e1AcA43a1a1B\"],\"numDeployments\":2,\"solcInputHash\":\"c9b5f40be4cc59cdaa11ec8b822d1bfe\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.24+commit.e11b9ed9\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_routerArbToGnosis\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_nodeData\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"MessageSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_snapshot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_count\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"SnapshotSaved\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochSent\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_ticketId\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"SnapshotSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"count\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochFinalized\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"routerArbToGnosis\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"saveSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes4\\\",\\\"name\\\":\\\"_fnSelector\\\",\\\"type\\\":\\\"bytes4\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_data\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_gasLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"sendSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"snapshots\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Inbox From Arbitrum to Gnosis. Note: This contract is deployed on the Arbitrum.\\\",\\\"events\\\":{\\\"MessageSent(bytes)\\\":{\\\"details\\\":\\\"Relayers watch for these events to construct merkle proofs to execute transactions on Gnosis.\\\",\\\"params\\\":{\\\"_nodeData\\\":\\\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\"}},\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"params\\\":{\\\"_count\\\":\\\"The count of messages in the merkle tree.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot.\\\",\\\"_snapshot\\\":\\\"The snapshot of the merkle tree state root.\\\"}},\\\"SnapshotSent(uint256,bytes32)\\\":{\\\"details\\\":\\\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\",\\\"params\\\":{\\\"_epochSent\\\":\\\"The epoch of the snapshot.\\\",\\\"_ticketId\\\":\\\"The ticketId of the L2->L1 message.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"constructor\\\":{\\\"details\\\":\\\"Constructor. Note: epochPeriod must match the VeaOutboxArbToGnosis contract deployment on Gnosis, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\",\\\"params\\\":{\\\"_epochPeriod\\\":\\\"The duration in seconds between epochs.\\\",\\\"_routerArbToGnosis\\\":\\\"The router on Ethereum that routes from Arbitrum to Gnosis.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the epoch from the inbox's point of view using timestamp.\\\",\\\"params\\\":{\\\"_timestamp\\\":\\\"The timestamp to calculate the epoch from.\\\"},\\\"returns\\\":{\\\"epoch\\\":\\\"The calculated epoch.\\\"}},\\\"epochFinalized()\\\":{\\\"details\\\":\\\"Get the most recent epoch for which snapshots are finalized.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"saveSnapshot()\\\":{\\\"details\\\":\\\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\\\"},\\\"sendMessage(address,bytes4,bytes)\\\":{\\\"details\\\":\\\"Sends an arbitrary message to Gnosis.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\\\",\\\"params\\\":{\\\"_data\\\":\\\"The message calldata, abi.encode(param1, param2, ...)\\\",\\\"_fnSelector\\\":\\\"The function selector of the receiving contract.\\\",\\\"_to\\\":\\\"The address of the contract on the receiving chain which receives the calldata.\\\"},\\\"returns\\\":{\\\"_0\\\":\\\"msgId The zero based index of the message in the inbox.\\\"}},\\\"sendSnapshot(uint256,uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the state root snapshot using Arbitrum's canonical bridge.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot requested to send.\\\",\\\"_gasLimit\\\":\\\"The gas limit for the AMB transaction on Gnosis.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"events\\\":{\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"notice\\\":\\\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\"}},\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol\\\":\\\"VeaInboxArbToGnosis\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":200},\\\"remappings\\\":[]},\\\"sources\\\":{\\\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/arbitrum/IArbSys.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/inboxes/IVeaInbox.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/routers/IRouterToGnosis.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Inbox From Arbitrum to Gnosis.\\\\n/// Note: This contract is deployed on the Arbitrum.\\\\ncontract VeaInboxArbToGnosis is IVeaInbox {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    // Arbitrum precompile ArbSys for L2->L1 messaging: https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n    IArbSys internal constant ARB_SYS = IArbSys(address(100));\\\\n\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    address public immutable routerArbToGnosis; // The router on ethereum.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public snapshots; // epoch => state root snapshot\\\\n\\\\n    // Inbox represents minimum data availability to maintain incremental merkle tree.\\\\n    // Supports a max of 2^64 - 1 messages. See merkle tree docs for details how inbox manages state.\\\\n\\\\n    bytes32[64] internal inbox; // stores minimal set of complete subtree roots of the merkle tree to increment.\\\\n    uint64 public count; // count of messages in the merkle tree\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Relayers watch for these events to construct merkle proofs to execute transactions on Gnosis.\\\\n    /// @param _nodeData The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\\n    event MessageSent(bytes _nodeData);\\\\n\\\\n    /// The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\\n    /// @param _snapshot The snapshot of the merkle tree state root.\\\\n    /// @param _epoch The epoch of the snapshot.\\\\n    /// @param _count The count of messages in the merkle tree.\\\\n    event SnapshotSaved(bytes32 _snapshot, uint256 _epoch, uint64 _count);\\\\n\\\\n    /// @dev The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\\n    /// @param _epochSent The epoch of the snapshot.\\\\n    /// @param _ticketId The ticketId of the L2->L1 message.\\\\n    event SnapshotSent(uint256 indexed _epochSent, bytes32 _ticketId);\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaOutboxArbToGnosis contract deployment on Gnosis, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _epochPeriod The duration in seconds between epochs.\\\\n    /// @param _routerArbToGnosis The router on Ethereum that routes from Arbitrum to Gnosis.\\\\n    constructor(uint256 _epochPeriod, address _routerArbToGnosis) {\\\\n        epochPeriod = _epochPeriod;\\\\n        routerArbToGnosis = _routerArbToGnosis;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Sends an arbitrary message to Gnosis.\\\\n    ///      `O(log(count))` where count is the number of messages already sent.\\\\n    ///      Amortized cost is constant.\\\\n    /// Note: See docs for details how inbox manages merkle tree state.\\\\n    /// @param _to The address of the contract on the receiving chain which receives the calldata.\\\\n    /// @param _fnSelector The function selector of the receiving contract.\\\\n    /// @param _data The message calldata, abi.encode(param1, param2, ...)\\\\n    /// @return msgId The zero based index of the message in the inbox.\\\\n    function sendMessage(address _to, bytes4 _fnSelector, bytes memory _data) external override returns (uint64) {\\\\n        uint64 oldCount = count;\\\\n\\\\n        // Given arbitrum's speed limit of 7 million gas / second, it would take atleast 8 million years of full blocks to overflow.\\\\n        // It *should* be impossible to overflow, but we check to be safe when appending to the tree.\\\\n        require(oldCount < type(uint64).max, \\\\\\\"Inbox is full.\\\\\\\");\\\\n\\\\n        bytes memory nodeData = abi.encodePacked(\\\\n            oldCount,\\\\n            _to,\\\\n            // _data is abi.encode(param1, param2, ...), we need to encode it again to get the correct leaf data\\\\n            abi.encodePacked( // equivalent to abi.encodeWithSelector(fnSelector, msg.sender, param1, param2, ...)\\\\n                _fnSelector,\\\\n                bytes32(uint256(uint160(msg.sender))), // big endian padded encoding of msg.sender, simulating abi.encodeWithSelector\\\\n                _data\\\\n            )\\\\n        );\\\\n\\\\n        // single hashed leaf\\\\n        bytes32 newInboxNode = keccak256(nodeData);\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            // efficient hash using EVM scratch space\\\\n            mstore(0x00, newInboxNode)\\\\n            newInboxNode := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        // increment merkle tree calculating minimal number of hashes\\\\n        unchecked {\\\\n            uint256 height;\\\\n\\\\n            // x = oldCount + 1; acts as a bit mask to determine if a hash is needed\\\\n            // note: x is always non-zero, and x is bit shifted to the right each loop\\\\n            // hence this loop will always terminate in a maximum of log_2(oldCount + 1) iterations\\\\n            for (uint64 x = oldCount + 1; x & 1 == 0; x = x >> 1) {\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                newInboxNode = sortConcatAndHash(inbox[height], newInboxNode);\\\\n                height++;\\\\n            }\\\\n\\\\n            inbox[height] = newInboxNode;\\\\n\\\\n            // finally increment count\\\\n            count = oldCount + 1;\\\\n        }\\\\n\\\\n        emit MessageSent(nodeData);\\\\n\\\\n        // old count is the zero indexed leaf position in the tree, acts as a msgId\\\\n        // gateways should index these msgIds to later relay proofs\\\\n        return oldCount;\\\\n    }\\\\n\\\\n    /// @dev Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    /// Note: See merkle tree docs for details how inbox manages state.\\\\n    function saveSnapshot() external {\\\\n        uint256 epoch;\\\\n        bytes32 stateRoot;\\\\n\\\\n        unchecked {\\\\n            epoch = block.timestamp / epochPeriod;\\\\n\\\\n            // calculate the current root of the incremental merkle tree encoded in the inbox\\\\n\\\\n            uint256 height;\\\\n\\\\n            // x acts as a bit mask to determine if the hash stored in the inbox contributes to the root\\\\n            uint256 x;\\\\n\\\\n            // x is bit shifted to the right each loop, hence this loop will always terminate in a maximum of log_2(count) iterations\\\\n            for (x = uint256(count); x > 0; x = x >> 1) {\\\\n                if ((x & 1) == 1) {\\\\n                    // first hash is special case\\\\n                    // inbox stores the root of complete subtrees\\\\n                    // eg if count = 4 = 0b100, then the first complete subtree is inbox[2]\\\\n                    // inbox = [H(3), H(1,2), H(1,4)], we read inbox[2] directly\\\\n\\\\n                    stateRoot = inbox[height];\\\\n                    break;\\\\n                }\\\\n                height++;\\\\n            }\\\\n\\\\n            // after the first hash, we can calculate the root incrementally\\\\n            for (x = x >> 1; x > 0; x = x >> 1) {\\\\n                height++;\\\\n                if ((x & 1) == 1) {\\\\n                    // sort sibling hashes as a convention for efficient proof validation\\\\n                    stateRoot = sortConcatAndHash(inbox[height], stateRoot);\\\\n                }\\\\n            }\\\\n        }\\\\n\\\\n        snapshots[epoch] = stateRoot;\\\\n\\\\n        emit SnapshotSaved(stateRoot, epoch, count);\\\\n    }\\\\n\\\\n    /// @dev Helper function to calculate merkle tree interior nodes by sorting and concatenating and hashing a pair of children nodes, left and right.\\\\n    /// Note: EVM scratch space is used to efficiently calculate hashes.\\\\n    /// @param _left The left hash.\\\\n    /// @param _right The right hash.\\\\n    /// @return parent The parent hash.\\\\n    function sortConcatAndHash(bytes32 _left, bytes32 _right) internal pure returns (bytes32 parent) {\\\\n        // sort sibling hashes as a convention for efficient proof validation\\\\n        if (_left < _right) {\\\\n            // efficient hash using EVM scratch space\\\\n            assembly {\\\\n                mstore(0x00, _left)\\\\n                mstore(0x20, _right)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        } else {\\\\n            assembly {\\\\n                mstore(0x00, _right)\\\\n                mstore(0x20, _left)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the state root snapshot using Arbitrum's canonical bridge.\\\\n    /// @param _epoch The epoch of the snapshot requested to send.\\\\n    /// @param _gasLimit The gas limit for the AMB transaction on Gnosis.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function sendSnapshot(uint256 _epoch, uint256 _gasLimit, Claim memory _claim) external virtual {\\\\n        unchecked {\\\\n            require(_epoch < block.timestamp / epochPeriod, \\\\\\\"Can only send past epoch snapshot.\\\\\\\");\\\\n        }\\\\n\\\\n        bytes memory data = abi.encodeCall(IRouterToGnosis.route, (_epoch, snapshots[_epoch], _gasLimit, _claim));\\\\n\\\\n        // Arbitrum -> Ethereum message with native bridge\\\\n        // docs: https://developer.arbitrum.io/for-devs/cross-chain-messsaging#arbitrum-to-ethereum-messaging\\\\n        // example: https://github.com/OffchainLabs/arbitrum-tutorials/blob/2c1b7d2db8f36efa496e35b561864c0f94123a5f/packages/greeter/contracts/arbitrum/GreeterL2.sol#L25\\\\n        bytes32 ticketID = bytes32(ARB_SYS.sendTxToL1(routerArbToGnosis, data));\\\\n\\\\n        emit SnapshotSent(_epoch, ticketID);\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the most recent epoch for which snapshots are finalized.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochFinalized() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    /// @dev Get the epoch from the inbox's point of view using timestamp.\\\\n    /// @param _timestamp The timestamp to calculate the epoch from.\\\\n    /// @return epoch The calculated epoch.\\\\n    function epochAt(uint256 _timestamp) external view returns (uint256 epoch) {\\\\n        epoch = _timestamp / epochPeriod;\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xf5706fefe86eb3bf49a130df2b54030f325327729e9ade1a94be9132eb77e333\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/arbitrum/IArbSys.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/39ea5a163afc637e2706d9be29cf7a289c300d00/src/precompiles/ArbSys.sol\\\\n// https://arbiscan.io/address/0x0000000000000000000000000000000000000064#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\n///@title System level functionality\\\\n///@notice For use by contracts to interact with core L2-specific functionality.\\\\n///Precompiled contract that exists in every Arbitrum chain at address(100), 0x0000000000000000000000000000000000000064.\\\\ninterface IArbSys {\\\\n    /// @notice Send a transaction to L1\\\\n    /// @dev it is not possible to execute on the L1 any L2-to-L1 transaction which contains data\\\\n    /// to a contract address without any code (as enforced by the Bridge contract).\\\\n    /// @param destination recipient address on L1\\\\n    /// @param data (optional) calldata for L1 contract call\\\\n    /// @return a unique identifier for this L2-to-L1 transaction.\\\\n    function sendTxToL1(address destination, bytes calldata data) external payable returns (uint256);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x5ae1fd0267552160821402b9bc50b2551b086904436e5abe838599179b279420\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/interfaces/inboxes/IVeaInbox.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\ninterface IVeaInbox {\\\\n    /// @dev Sends an arbitrary message to receiving chain.\\\\n    /// Note: Calls authenticated by receiving gateway checking the sender argument.\\\\n    /// @param _to The cross-domain contract address which receives the calldata.\\\\n    /// @param _fnSelection The function selector of the receiving contract.\\\\n    /// @param _data The message calldata, abi.encode(...)\\\\n    /// @return msgId The index of the message in the inbox, as a message Id, needed to relay the message.\\\\n    function sendMessage(address _to, bytes4 _fnSelection, bytes memory _data) external returns (uint64 msgId);\\\\n\\\\n    /// @dev Snapshots can be saved a maximum of once per epoch.\\\\n    ///      Saves snapshot of state root.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    function saveSnapshot() external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xa8e2f65b7596235422f39933af80f02473493d2b15b398d7e34b81c82bd24a29\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/routers/IRouterToGnosis.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Router which routes messages to Gnosis through the AMB.\\\\n/// @dev eg. L2 on Ethereum -> Ethereum (L1) -> Gnosis (L1), the IRouterToL1 will be deployed on Ethereum (L1) routing messages to Gnosis (L1).\\\\ninterface IRouterToGnosis {\\\\n    /// @dev Routes state root snapshots through intermediary chains to the final destination L1 chain.\\\\n    /// Note: Access restricted to canonical sending-chain bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _gasLimit The gas limit for the AMB message.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function route(uint256 _epoch, bytes32 _stateRoot, uint256 _gasLimit, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x9d78c7872bd2bc3b206fc6d6dfa8f8b2dab4122b10bfe0d0ab1f76bec92613b6\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xfef781e359c97aebbe8dbfcb75edb7cb962139fd9ea538b8b89a3f2e13a05bfe\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"0x60c060405234801561001057600080fd5b50604051610c49380380610c4983398101604081905261002f91610046565b6080919091526001600160a01b031660a052610083565b6000806040838503121561005957600080fd5b825160208401519092506001600160a01b038116811461007857600080fd5b809150509250929050565b60805160a051610b776100d26000396000818161014f01526105e3015260008181610128015281816101c3015281816101f60152818161022c0152818161025c01526104ee0152610b776000f3fe608060405234801561001057600080fd5b506004361061009e5760003560e01c80635f85896c116100665780635f85896c14610110578063b5b7a18414610123578063d5e6a9df1461014a578063d6565a2d14610189578063dc881a72146101a957600080fd5b806306661abd146100a3578063222ae786146100d55780633ac3b6b6146100eb5780634a439cfe146100f35780635192053514610106575b600080fd5b6041546100b79067ffffffffffffffff1681565b60405167ffffffffffffffff90911681526020015b60405180910390f35b6100dd6101bc565b6040519081526020016100cc565b6100dd6101ed565b6100dd6101013660046106c0565b610225565b61010e610257565b005b6100b761011e366004610765565b61037b565b6100dd7f000000000000000000000000000000000000000000000000000000000000000081565b6101717f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b0390911681526020016100cc565b6100dd6101973660046106c0565b60006020819052908152604090205481565b61010e6101b736600461083e565b6104ec565b60006101e87f000000000000000000000000000000000000000000000000000000000000000042610910565b905090565b6000600161021b7f000000000000000000000000000000000000000000000000000000000000000042610910565b6101e89190610932565b60006102517f000000000000000000000000000000000000000000000000000000000000000083610910565b92915050565b6000807f00000000000000000000000000000000000000000000000000000000000000004281610289576102896108fa565b604154919004925060009067ffffffffffffffff165b80156102d857806001166001036102cc57600182604081106102c3576102c3610953565b015492506102d8565b6001918201911c61029f565b60011c5b801561031a5760019182019181811690036103125761030f6001836040811061030757610307610953565b01548461068f565b92505b60011c6102dc565b505060008281526020818152604091829020839055604154825184815291820185905267ffffffffffffffff168183015290517f592424eb1d6135501bd20833f15fd127c29d08eed4f03872f6f75182126b1e489181900360600190a15050565b60415460009067ffffffffffffffff9081169081106103d25760405162461bcd60e51b815260206004820152600e60248201526d24b73137bc1034b990333ab6361760911b60448201526064015b60405180910390fd5b604051600090829087906103ee9088903390899060200161098d565b60408051601f198184030181529082905261040d9392916020016109c3565b60408051601f1981840301815291905280516020808301919091206000908152908120919250600184015b60018116600003610471576104596001836040811061030757610307610953565b92506001918201911c677fffffffffffffff16610438565b50816001826040811061048657610486610953565b0155506041805467ffffffffffffffff19166001850167ffffffffffffffff161790556040517f8c5261668696ce22758910d05bab8f186d6eb247ceac2af2e82c7dc17669b036906104d9908490610a3e565b60405180910390a1509095945050505050565b7f0000000000000000000000000000000000000000000000000000000000000000428161051b5761051b6108fa565b0483106105755760405162461bcd60e51b815260206004820152602260248201527f43616e206f6e6c792073656e6420706173742065706f636820736e617073686f6044820152613a1760f11b60648201526084016103c9565b60008381526020819052604080822054905161059991869186908690602401610a58565b60408051601f198184030181529181526020820180516001600160e01b031663b1126dad60e01b179052516349460b4d60e11b815290915060009060649063928c169a9061060d907f0000000000000000000000000000000000000000000000000000000000000000908690600401610afc565b6020604051808303816000875af115801561062c573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106509190610b28565b60405181815290915085907f6fdd49f435101fc7b6ebdec7c8972932a926d18f6cb78a8891dfe950743b6b829060200160405180910390a25050505050565b6000818310156106ad57826000528160205260406000209050610251565b5060009081526020919091526040902090565b6000602082840312156106d257600080fd5b5035919050565b80356001600160a01b03811681146106f057600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60405160e0810167ffffffffffffffff8111828210171561072e5761072e6106f5565b60405290565b604051601f8201601f1916810167ffffffffffffffff8111828210171561075d5761075d6106f5565b604052919050565b60008060006060848603121561077a57600080fd5b610783846106d9565b92506020848101356001600160e01b0319811681146107a157600080fd5b9250604085013567ffffffffffffffff808211156107be57600080fd5b818701915087601f8301126107d257600080fd5b8135818111156107e4576107e46106f5565b6107f6601f8201601f19168501610734565b9150808252888482850101111561080c57600080fd5b80848401858401376000848284010152508093505050509250925092565b803563ffffffff811681146106f057600080fd5b600080600083850361012081121561085557600080fd5b843593506020850135925060e0603f198201121561087257600080fd5b5061087b61070b565b6040850135815261088e606086016106d9565b602082015261089f6080860161082a565b60408201526108b060a0860161082a565b60608201526108c160c0860161082a565b608082015260e0850135600381106108d857600080fd5b60a08201526108ea61010086016106d9565b60c0820152809150509250925092565b634e487b7160e01b600052601260045260246000fd5b60008261092d57634e487b7160e01b600052601260045260246000fd5b500490565b8181038181111561025157634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052603260045260246000fd5b60005b8381101561098457818101518382015260200161096c565b50506000910152565b63ffffffff60e01b84168152826004820152600082516109b4816024850160208701610969565b91909101602401949350505050565b67ffffffffffffffff60c01b8460c01b1681526bffffffffffffffffffffffff198360601b16600882015260008251610a0381601c850160208701610969565b91909101601c01949350505050565b60008151808452610a2a816020860160208601610969565b601f01601f19169290920160200192915050565b602081526000610a516020830184610a12565b9392505050565b6000610140820190508582528460208301528360408301528251606083015260018060a01b036020840151166080830152604083015163ffffffff80821660a08501528060608601511660c08501528060808601511660e0850152505060a083015160038110610ad857634e487b7160e01b600052602160045260246000fd5b61010083015260c092909201516001600160a01b0316610120909101529392505050565b6001600160a01b0383168152604060208201819052600090610b2090830184610a12565b949350505050565b600060208284031215610b3a57600080fd5b505191905056fea26469706673582212206e073cc2af8950a36b1dfe2a006001f1fe2108beb2ff1e9bb925969fe49b51ea64736f6c63430008180033\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Inbox From Arbitrum to Gnosis. Note: This contract is deployed on the Arbitrum.\",\"events\":{\"MessageSent(bytes)\":{\"details\":\"Relayers watch for these events to construct merkle proofs to execute transactions on Gnosis.\",\"params\":{\"_nodeData\":\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\"}},\"SnapshotSaved(bytes32,uint256,uint64)\":{\"params\":{\"_count\":\"The count of messages in the merkle tree.\",\"_epoch\":\"The epoch of the snapshot.\",\"_snapshot\":\"The snapshot of the merkle tree state root.\"}},\"SnapshotSent(uint256,bytes32)\":{\"details\":\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\",\"params\":{\"_epochSent\":\"The epoch of the snapshot.\",\"_ticketId\":\"The ticketId of the L2->L1 message.\"}}},\"kind\":\"dev\",\"methods\":{\"constructor\":{\"details\":\"Constructor. Note: epochPeriod must match the VeaOutboxArbToGnosis contract deployment on Gnosis, since it's on a different chain, we can't read it and trust the deployer to set a correct value\",\"params\":{\"_epochPeriod\":\"The duration in seconds between epochs.\",\"_routerArbToGnosis\":\"The router on Ethereum that routes from Arbitrum to Gnosis.\"}},\"epochAt(uint256)\":{\"details\":\"Get the epoch from the inbox's point of view using timestamp.\",\"params\":{\"_timestamp\":\"The timestamp to calculate the epoch from.\"},\"returns\":{\"epoch\":\"The calculated epoch.\"}},\"epochFinalized()\":{\"details\":\"Get the most recent epoch for which snapshots are finalized.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"saveSnapshot()\":{\"details\":\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\"},\"sendMessage(address,bytes4,bytes)\":{\"details\":\"Sends an arbitrary message to Gnosis.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\",\"params\":{\"_data\":\"The message calldata, abi.encode(param1, param2, ...)\",\"_fnSelector\":\"The function selector of the receiving contract.\",\"_to\":\"The address of the contract on the receiving chain which receives the calldata.\"},\"returns\":{\"_0\":\"msgId The zero based index of the message in the inbox.\"}},\"sendSnapshot(uint256,uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the state root snapshot using Arbitrum's canonical bridge.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the snapshot requested to send.\",\"_gasLimit\":\"The gas limit for the AMB transaction on Gnosis.\"}}},\"version\":1},\"userdoc\":{\"events\":{\"SnapshotSaved(bytes32,uint256,uint64)\":{\"notice\":\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\"}},\"kind\":\"user\",\"methods\":{},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":2245,\"contract\":\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol:VeaInboxArbToGnosis\",\"label\":\"snapshots\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":2249,\"contract\":\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol:VeaInboxArbToGnosis\",\"label\":\"inbox\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_array(t_bytes32)64_storage\"},{\"astId\":2251,\"contract\":\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol:VeaInboxArbToGnosis\",\"label\":\"count\",\"offset\":0,\"slot\":\"65\",\"type\":\"t_uint64\"}],\"types\":{\"t_array(t_bytes32)64_storage\":{\"base\":\"t_bytes32\",\"encoding\":\"inplace\",\"label\":\"bytes32[64]\",\"numberOfBytes\":\"2048\"},\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"},\"t_uint64\":{\"encoding\":\"inplace\",\"label\":\"uint64\",\"numberOfBytes\":\"8\"}}}}");


var $4f9665f727a8e7dc$exports = {};
$4f9665f727a8e7dc$exports = JSON.parse("{\"address\":\"0xE24B2838962207F585F4fa5C5bE3e1AcA43a1a1B\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_deposit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_minChallengePeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_timeoutEpochs\",\"type\":\"uint256\"},{\"internalType\":\"contract IAMB\",\"name\":\"_amb\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_routerArbToGnosis\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_sequencerDelayLimit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_maxMissingBlocks\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_routerChainId\",\"type\":\"uint256\"},{\"internalType\":\"contract IWETH\",\"name\":\"_weth\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_challenger\",\"type\":\"address\"}],\"name\":\"Challenged\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_claimer\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"Claimed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"}],\"name\":\"MessageRelayed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_newSequencerDelayLimit\",\"type\":\"uint256\"}],\"name\":\"SequencerDelayLimitUpdateReceived\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"VerificationStarted\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"Verified\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"amb\",\"outputs\":[{\"internalType\":\"contract IAMB\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"burn\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"censorshipTestStatus\",\"outputs\":[{\"internalType\":\"enum VeaOutboxArbToGnosis.CensorshipTestStatus\",\"name\":\"status\",\"type\":\"uint8\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"challenge\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_devnetOperator\",\"type\":\"address\"}],\"name\":\"changeDevnetOperator\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"claim\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"claimHashes\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"deposit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"depositPlusReward\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateroot\",\"type\":\"bytes32\"}],\"name\":\"devnetAdvanceState\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"devnetOperator\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"hashClaim\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"hashedClaim\",\"type\":\"bytes32\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_msgId\",\"type\":\"uint256\"}],\"name\":\"isMsgRelayed\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"isRelayed\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"latestVerifiedEpoch\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"maxMissingBlocks\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"minChallengePeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"resolveDisputedClaim\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"routerArbToGnosis\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"routerChainId\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"bytes32[]\",\"name\":\"_proof\",\"type\":\"bytes32[]\"},{\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"},{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"bytes\",\"name\":\"_message\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"sequencerDelayLimit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"startVerification\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"stateRoot\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timeoutEpochs\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timestampDelayUpdated\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_newSequencerDelayLimit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_timestamp\",\"type\":\"uint256\"}],\"name\":\"updateSequencerDelayLimit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"verifySnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"weth\",\"outputs\":[{\"internalType\":\"contract IWETH\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengeDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"transactionHash\":\"0x1d0c62b69fff64da78d1cd5352dc3084b861a22ce630af07c4d5376d0905f817\",\"receipt\":{\"to\":null,\"from\":\"0xFa00D29d378EDC57AA1006946F0fc6230a5E3288\",\"contractAddress\":\"0xE24B2838962207F585F4fa5C5bE3e1AcA43a1a1B\",\"transactionIndex\":1,\"gasUsed\":\"2362205\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0xd65228a44d3dfaedd894ff646874b8a12274d350a47f80b5f08dbe9b4a1fb6db\",\"transactionHash\":\"0x1d0c62b69fff64da78d1cd5352dc3084b861a22ce630af07c4d5376d0905f817\",\"logs\":[],\"blockNumber\":14598540,\"cumulativeGasUsed\":\"2391494\",\"status\":1,\"byzantium\":true},\"args\":[\"100000000000000000\",1800,0,10000000000000,\"0x8448E15d0e706C0298dECA99F0b4744030e59d7d\",\"0xbD6c557295cBDd57e0efC408b20096f3fe55C8a6\",86400,10000000000000,11155111,\"0x8d74e5e4DA11629537C4575cB0f33b4F0Dfa42EB\"],\"numDeployments\":11,\"solcInputHash\":\"51b873e2d80b78ffb160c3bb515132de\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.24+commit.e11b9ed9\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_deposit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_minChallengePeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timeoutEpochs\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"contract IAMB\\\",\\\"name\\\":\\\"_amb\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_routerArbToGnosis\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_sequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_maxMissingBlocks\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_routerChainId\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"contract IWETH\\\",\\\"name\\\":\\\"_weth\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"Challenged\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"Claimed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"MessageRelayed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_newSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"SequencerDelayLimitUpdateReceived\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"VerificationStarted\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"Verified\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"amb\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"contract IAMB\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"burn\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"censorshipTestStatus\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"enum VeaOutboxArbToGnosis.CensorshipTestStatus\\\",\\\"name\\\":\\\"status\\\",\\\"type\\\":\\\"uint8\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"challenge\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_devnetOperator\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"changeDevnetOperator\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"claim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"claimHashes\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"deposit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"depositPlusReward\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateroot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"devnetAdvanceState\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"devnetOperator\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"hashClaim\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"hashedClaim\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"pure\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"isMsgRelayed\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bool\\\",\\\"name\\\":\\\"isRelayed\\\",\\\"type\\\":\\\"bool\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"latestVerifiedEpoch\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"maxMissingBlocks\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"minChallengePeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"resolveDisputedClaim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"routerArbToGnosis\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"routerChainId\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"bytes32[]\\\",\\\"name\\\":\\\"_proof\\\",\\\"type\\\":\\\"bytes32[]\\\"},{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_message\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"sequencerDelayLimit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"startVerification\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"stateRoot\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"timeoutEpochs\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"timestampDelayUpdated\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_newSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"updateSequencerDelayLimit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"verifySnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"weth\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"contract IWETH\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengeDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Outbox From Arbitrum to Chiado. Note: This contract is deployed on Chiado. Note: This contract is permissioned for developer testing (devnet).\\\",\\\"events\\\":{\\\"Challenged(uint256,address)\\\":{\\\"details\\\":\\\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\",\\\"params\\\":{\\\"_challenger\\\":\\\"The address of the challenger.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenged claim.\\\"}},\\\"Claimed(address,uint256,bytes32)\\\":{\\\"details\\\":\\\"Watchers check this event to challenge fraud.\\\",\\\"params\\\":{\\\"_claimer\\\":\\\"The address of the claimer.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim.\\\",\\\"_stateRoot\\\":\\\"The state root of the claim.\\\"}},\\\"MessageRelayed(uint64)\\\":{\\\"details\\\":\\\"This event indicates that a message has been relayed.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId of the message that was relayed.\\\"}},\\\"SequencerDelayLimitUpdateReceived(uint256)\\\":{\\\"details\\\":\\\"This event indicates the sequencer limit updated.\\\",\\\"params\\\":{\\\"_newSequencerDelayLimit\\\":\\\"The new sequencer delay limit.\\\"}},\\\"VerificationStarted(uint256)\\\":{\\\"details\\\":\\\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that started verification.\\\"}},\\\"Verified(uint256)\\\":{\\\"details\\\":\\\"This events indicates that verification has succeeded. The messages are ready to be relayed.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that was verified.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Gets the status of the censorship test for claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to test.\\\"},\\\"returns\\\":{\\\"status\\\":\\\"True if the claim passed the censorship test.\\\"}},\\\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"changeDevnetOperator(address)\\\":{\\\"details\\\":\\\"Changes the devnet operator.\\\",\\\"params\\\":{\\\"_devnetOperator\\\":\\\"The new testnet operator.\\\"}},\\\"claim(uint256,bytes32)\\\":{\\\"details\\\":\\\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which the claim is made.\\\",\\\"_stateRoot\\\":\\\"The state root to claim.\\\"}},\\\"constructor\\\":{\\\"details\\\":\\\"Constructor. Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\",\\\"params\\\":{\\\"_amb\\\":\\\"The address of the AMB contract on Gnosis.\\\",\\\"_deposit\\\":\\\"The deposit amount to submit a claim in wei.\\\",\\\"_epochPeriod\\\":\\\"The duration of each epoch.\\\",\\\"_maxMissingBlocks\\\":\\\"The maximum number of blocks that can be missing in a challenge period.\\\",\\\"_minChallengePeriod\\\":\\\"The minimum time window to challenge a claim.\\\",\\\"_routerArbToGnosis\\\":\\\"The address of the router on Ethereum that routes from Arbitrum to Gnosis.\\\",\\\"_routerChainId\\\":\\\"The chain id of the routerArbToGnosis.\\\",\\\"_sequencerDelayLimit\\\":\\\"The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\\\",\\\"_timeoutEpochs\\\":\\\"The epochs before the bridge is considered shutdown.\\\",\\\"_weth\\\":\\\"The address of the WETH contract on Gnosis.\\\"}},\\\"devnetAdvanceState(uint256,bytes32)\\\":{\\\"details\\\":\\\"Testnet operator utility function to claim, validate and withdraw.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which the claim is made.\\\",\\\"_stateroot\\\":\\\"The state root to claim.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Hashes the claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to hash.\\\"},\\\"returns\\\":{\\\"hashedClaim\\\":\\\"The hash of the claim.\\\"}},\\\"isMsgRelayed(uint256)\\\":{\\\"details\\\":\\\"Get the msg relayed status.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId to check.\\\"},\\\"returns\\\":{\\\"isRelayed\\\":\\\"True if the msg was relayed.\\\"}},\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves any challenge of the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch to verify.\\\",\\\"_stateRoot\\\":\\\"The true state root for the epoch.\\\"}},\\\"sendMessage(bytes32[],uint64,address,bytes)\\\":{\\\"details\\\":\\\"Verifies and relays the message. UNTRUSTED.\\\",\\\"params\\\":{\\\"_message\\\":\\\"The message encoded in the vea inbox as abi.encodeWithSelector(fnSelector, msg.sender, param1, param2, ...)\\\",\\\"_msgId\\\":\\\"The zero based index of the message in the inbox.\\\",\\\"_proof\\\":\\\"The merkle proof to prove the message inclusion in the inbox state root.\\\",\\\"_to\\\":\\\"The address of the contract on Gnosis to call.\\\"}},\\\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Start verification for claim for 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"updateSequencerDelayLimit(uint256,uint256)\\\":{\\\"details\\\":\\\"Set the sequencerDelayLimit by receiving a message from the AMB.\\\",\\\"params\\\":{\\\"_newSequencerDelayLimit\\\":\\\"The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\\\",\\\"_timestamp\\\":\\\"The timestamp of the message.\\\"}},\\\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the optimistic claim.\\\"}},\\\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenge deposit to withraw.\\\"}},\\\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"notice\\\":\\\"Note: Access restricted to AMB.\\\"}},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol\\\":\\\"VeaOutboxArbToGnosisDevnet\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":200},\\\"remappings\\\":[]},\\\"sources\\\":{\\\"src/arbitrumToGnosis/VeaOutboxArbToGnosis.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/gnosis-chain/IAMB.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/outboxes/IVeaOutboxOnL1.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/updaters/ISequencerDelayUpdatable.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/tokens/gnosis/IWETH.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Outbox From Arbitrum to Gnosis.\\\\n/// Note: This contract is deployed on Gnosis.\\\\ncontract VeaOutboxArbToGnosis is IVeaOutboxOnL1, ISequencerDelayUpdatable {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    IAMB public immutable amb; // The address of the AMB contract on Gnosis.\\\\n    address public immutable routerArbToGnosis; // The address of the router from Arbitrum to Gnosis on ethereum.\\\\n\\\\n    IWETH public immutable weth; // The address of the WETH contract on Gnosis.\\\\n    uint256 public immutable deposit; // The deposit in wei required to submit a claim or challenge\\\\n    uint256 public immutable burn; // The amount of wei to burn. deposit / 2\\\\n    uint256 public immutable depositPlusReward; // 2 * deposit - burn\\\\n\\\\n    uint256 internal constant SLOT_TIME = 5; // Gnosis 5 second slot time\\\\n\\\\n    uint256 public immutable routerChainId; // Router chain id for authentication of messages from the AMB.\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    uint256 public immutable minChallengePeriod; // Minimum time window to challenge a claim, even with a malicious sequencer.\\\\n\\\\n    uint256 public immutable timeoutEpochs; // The number of epochs without forward progress before the bridge is considered shutdown.\\\\n    uint256 public immutable maxMissingBlocks; // The maximum number of blocks that can be missing in a challenge period.\\\\n\\\\n    bytes32 public stateRoot; // merkle root of the outbox state\\\\n    uint256 public latestVerifiedEpoch; // The latest epoch that has been verified.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public claimHashes; // epoch => claim\\\\n    mapping(uint256 messageId => bytes32) internal relayed; // msgId/256 => packed replay bitmap, preferred over a simple boolean mapping to save 15k gas per message\\\\n\\\\n    uint256 public sequencerDelayLimit; // This is MaxTimeVariation.delaySeconds from the arbitrum sequencer inbox, it is the maximum seconds the sequencer can backdate L2 txns relative to the L1 clock.\\\\n    uint256 public timestampDelayUpdated; // The timestamp of the last sequencer delay update.\\\\n\\\\n    enum CensorshipTestStatus {\\\\n        Failed,\\\\n        Passed,\\\\n        NotStarted,\\\\n        InProgress\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Watchers check this event to challenge fraud.\\\\n    /// @param _claimer The address of the claimer.\\\\n    /// @param _epoch The epoch associated with the claim.\\\\n    /// @param _stateRoot The state root of the claim.\\\\n    event Claimed(address indexed _claimer, uint256 indexed _epoch, bytes32 _stateRoot);\\\\n\\\\n    /// @dev This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\\n    /// @param _epoch The epoch associated with the challenged claim.\\\\n    /// @param _challenger The address of the challenger.\\\\n    event Challenged(uint256 indexed _epoch, address indexed _challenger);\\\\n\\\\n    /// @dev This event indicates that a message has been relayed.\\\\n    /// @param _msgId The msgId of the message that was relayed.\\\\n    event MessageRelayed(uint64 _msgId);\\\\n\\\\n    /// @dev This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\\n    /// @param _epoch The epoch that started verification.\\\\n    event VerificationStarted(uint256 indexed _epoch);\\\\n\\\\n    /// @dev This events indicates that verification has succeeded. The messages are ready to be relayed.\\\\n    /// @param _epoch The epoch that was verified.\\\\n    event Verified(uint256 _epoch);\\\\n\\\\n    /// @dev This event indicates the sequencer limit updated.\\\\n    /// @param _newSequencerDelayLimit The new sequencer delay limit.\\\\n    event SequencerDelayLimitUpdateReceived(uint256 _newSequencerDelayLimit);\\\\n\\\\n    // ************************************* //\\\\n    // *        Function Modifiers         * //\\\\n    // ************************************* //\\\\n\\\\n    modifier OnlyBridgeRunning() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch <= timeoutEpochs, \\\\\\\"Bridge Shutdown.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    modifier OnlyBridgeShutdown() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch > timeoutEpochs, \\\\\\\"Bridge Running.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _deposit The deposit amount to submit a claim in wei.\\\\n    /// @param _epochPeriod The duration of each epoch.\\\\n    /// @param _minChallengePeriod The minimum time window to challenge a claim.\\\\n    /// @param _timeoutEpochs The epochs before the bridge is considered shutdown.\\\\n    /// @param _amb The address of the AMB contract on Gnosis.\\\\n    /// @param _routerArbToGnosis The address of the router on Ethereum that routes from Arbitrum to Gnosis.\\\\n    /// @param _sequencerDelayLimit The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\\\\n    /// @param _maxMissingBlocks The maximum number of blocks that can be missing in a challenge period.\\\\n    /// @param _routerChainId The chain id of the routerArbToGnosis.\\\\n    /// @param _weth The address of the WETH contract on Gnosis.\\\\n    constructor(\\\\n        uint256 _deposit,\\\\n        uint256 _epochPeriod,\\\\n        uint256 _minChallengePeriod,\\\\n        uint256 _timeoutEpochs,\\\\n        IAMB _amb,\\\\n        address _routerArbToGnosis,\\\\n        uint256 _sequencerDelayLimit,\\\\n        uint256 _maxMissingBlocks,\\\\n        uint256 _routerChainId,\\\\n        IWETH _weth\\\\n    ) {\\\\n        deposit = _deposit;\\\\n        // epochPeriod must match the VeaInboxArbToGnosis contract deployment epochPeriod value.\\\\n        epochPeriod = _epochPeriod;\\\\n        timeoutEpochs = _timeoutEpochs;\\\\n        minChallengePeriod = _minChallengePeriod;\\\\n        amb = _amb;\\\\n        routerArbToGnosis = _routerArbToGnosis;\\\\n        // This value is on another chain, so we can't read it, we trust the deployer to set a correct value.\\\\n        sequencerDelayLimit = _sequencerDelayLimit; // MaxTimeVariation.delaySeconds from the arbitrum sequencer inbox\\\\n        maxMissingBlocks = _maxMissingBlocks;\\\\n        routerChainId = _routerChainId;\\\\n        weth = _weth;\\\\n\\\\n        // claimant and challenger are not sybil resistant\\\\n        // must burn half deposit to prevent zero cost griefing\\\\n        burn = _deposit / 2;\\\\n        depositPlusReward = 2 * _deposit - burn;\\\\n\\\\n        latestVerifiedEpoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *        Parameter Updates          * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Set the sequencerDelayLimit by receiving a message from the AMB.\\\\n    /// @param _newSequencerDelayLimit The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\\\\n    /// @param _timestamp The timestamp of the message.\\\\n    function updateSequencerDelayLimit(uint256 _newSequencerDelayLimit, uint256 _timestamp) external {\\\\n        require(msg.sender == address(amb), \\\\\\\"Not from bridge.\\\\\\\");\\\\n        require(bytes32(routerChainId) == amb.messageSourceChainId(), \\\\\\\"Invalid chain id.\\\\\\\");\\\\n        require(routerArbToGnosis == amb.messageSender(), \\\\\\\"Not from router.\\\\\\\");\\\\n        require(timestampDelayUpdated < _timestamp, \\\\\\\"Message is outdated.\\\\\\\");\\\\n\\\\n        if (sequencerDelayLimit != _newSequencerDelayLimit) {\\\\n            // If _newSequencerDelayLimit > timeout * epochPeriod, then the bridge will shutdown.\\\\n            sequencerDelayLimit = _newSequencerDelayLimit;\\\\n            timestampDelayUpdated = _timestamp;\\\\n            emit SequencerDelayLimitUpdateReceived(_newSequencerDelayLimit);\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateRoot The state root to claim.\\\\n    function claim(uint256 _epoch, bytes32 _stateRoot) external virtual {\\\\n        require(weth.transferFrom(msg.sender, address(this), deposit), \\\\\\\"Failed WETH transfer.\\\\\\\");\\\\n        unchecked {\\\\n            require(_epoch == block.timestamp / epochPeriod - 1, \\\\\\\"Epoch has not yet passed.\\\\\\\");\\\\n        }\\\\n\\\\n        require(_stateRoot != bytes32(0), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(claimHashes[_epoch] == bytes32(0), \\\\\\\"Claim already made.\\\\\\\");\\\\n\\\\n        claimHashes[_epoch] = hashClaim(\\\\n            Claim({\\\\n                stateRoot: _stateRoot,\\\\n                claimer: msg.sender,\\\\n                timestampClaimed: uint32(block.timestamp),\\\\n                timestampVerification: uint32(0),\\\\n                blocknumberVerification: uint32(0),\\\\n                honest: Party.None,\\\\n                challenger: address(0)\\\\n            })\\\\n        );\\\\n\\\\n        emit Claimed(msg.sender, _epoch, _stateRoot);\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function challenge(uint256 _epoch, Claim memory _claim) external {\\\\n        require(weth.transferFrom(msg.sender, address(this), deposit), \\\\\\\"Failed WETH transfer.\\\\\\\");\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim already challenged.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim already verified.\\\\\\\");\\\\n\\\\n        _claim.challenger = msg.sender;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Challenged(_epoch, msg.sender);\\\\n    }\\\\n\\\\n    /// @dev Start verification for claim for 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function startVerification(uint256 _epoch, Claim memory _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n\\\\n        // sequencerDelayLimit + epochPeriod is the worst case time to sync the L2 state compared to L1 clock.\\\\n        // using checked arithmetic incase arbitrum governance sets sequencerDelayLimit to a large value\\\\n        require(\\\\n            block.timestamp - uint256(_claim.timestampClaimed) >= sequencerDelayLimit + epochPeriod,\\\\n            \\\\\\\"Claim must wait atleast maxL2StateSyncDelay.\\\\\\\"\\\\n        );\\\\n\\\\n        CensorshipTestStatus _censorshipTestStatus = censorshipTestStatus(_claim);\\\\n        require(\\\\n            _censorshipTestStatus == CensorshipTestStatus.NotStarted ||\\\\n                _censorshipTestStatus == CensorshipTestStatus.Failed,\\\\n            \\\\\\\"Claim verification in progress or already completed.\\\\\\\"\\\\n        );\\\\n\\\\n        _claim.timestampVerification = uint32(block.timestamp);\\\\n        _claim.blocknumberVerification = uint32(block.number);\\\\n\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit VerificationStarted(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Resolves the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch of the optimistic claim.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function verifySnapshot(uint256 _epoch, Claim memory _claim) external virtual OnlyBridgeRunning {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n        require(censorshipTestStatus(_claim) == CensorshipTestStatus.Passed, \\\\\\\"Censorship test not passed.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _claim.stateRoot;\\\\n        }\\\\n\\\\n        _claim.honest = Party.Claimer;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// Note: Access restricted to AMB.\\\\n    /// @dev Resolves any challenge of the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(\\\\n        uint256 _epoch,\\\\n        bytes32 _stateRoot,\\\\n        Claim memory _claim\\\\n    ) external virtual OnlyBridgeRunning {\\\\n        // Ethereum -> Gnosis message authentication with the AMB, the canonical Ethereum <-> Gnosis bridge.\\\\n        // https://docs.tokenbridge.net/amb-bridge/development-of-a-cross-chain-application/how-to-develop-xchain-apps-by-amb#receive-a-method-call-from-the-amb-bridge\\\\n\\\\n        require(msg.sender == address(amb), \\\\\\\"Not from native Gnosis AMB bridge.\\\\\\\");\\\\n        require(bytes32(routerChainId) == amb.messageSourceChainId(), \\\\\\\"Invalid chain id.\\\\\\\");\\\\n        require(routerArbToGnosis == amb.messageSender(), \\\\\\\"Not from router.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch && _stateRoot != bytes32(0)) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _stateRoot;\\\\n        }\\\\n\\\\n        if (claimHashes[_epoch] == hashClaim(_claim)) {\\\\n            if (_claim.stateRoot == _stateRoot) {\\\\n                _claim.honest = Party.Claimer;\\\\n            } else if (_claim.challenger != address(0)) {\\\\n                _claim.honest = Party.Challenger;\\\\n            }\\\\n            claimHashes[_epoch] = hashClaim(_claim);\\\\n        }\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Verifies and relays the message. UNTRUSTED.\\\\n    /// @param _proof The merkle proof to prove the message inclusion in the inbox state root.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address of the contract on Gnosis to call.\\\\n    /// @param _message The message encoded in the vea inbox as abi.encodeWithSelector(fnSelector, msg.sender, param1, param2, ...)\\\\n    function sendMessage(bytes32[] calldata _proof, uint64 _msgId, address _to, bytes calldata _message) external {\\\\n        require(_proof.length < 64, \\\\\\\"Proof too long.\\\\\\\");\\\\n\\\\n        bytes32 nodeHash = keccak256(abi.encodePacked(_msgId, _to, _message));\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            mstore(0x00, nodeHash)\\\\n            nodeHash := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        unchecked {\\\\n            for (uint256 i = 0; i < _proof.length; i++) {\\\\n                bytes32 proofElement = _proof[i];\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                if (proofElement > nodeHash)\\\\n                    assembly {\\\\n                        mstore(0x00, nodeHash)\\\\n                        mstore(0x20, proofElement)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n                else\\\\n                    assembly {\\\\n                        mstore(0x00, proofElement)\\\\n                        mstore(0x20, nodeHash)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n            }\\\\n        }\\\\n\\\\n        require(stateRoot == nodeHash, \\\\\\\"Invalid proof.\\\\\\\");\\\\n\\\\n        // msgId is the zero-based index of the message in the inbox.\\\\n        // msgId is also used as an index in the relayed bitmap to prevent replay.\\\\n        // Note: a bitmap is used instead of a simple boolean mapping to save 15k gas per message.\\\\n\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        require(((replay >> offset) & bytes32(uint256(1))) == bytes32(0), \\\\\\\"Message already relayed\\\\\\\");\\\\n        relayed[relayIndex] = replay | bytes32(1 << offset);\\\\n\\\\n        // UNTRUSTED.\\\\n        (bool success, ) = _to.call(_message);\\\\n        require(success, \\\\\\\"Failed to call contract\\\\\\\");\\\\n\\\\n        emit MessageRelayed(_msgId);\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimDeposit(uint256 _epoch, Claim calldata _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Claimer, \\\\\\\"Claim failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            weth.burn(burn); // no return value to check\\\\n            require(weth.transfer(_claim.claimer, depositPlusReward), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n        } else {\\\\n            require(weth.transfer(_claim.claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\\n    /// @param _epoch The epoch associated with the challenge deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengeDeposit(uint256 _epoch, Claim calldata _claim) external {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Challenger, \\\\\\\"Challenge failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        weth.burn(burn); // no return value to check\\\\n        require(weth.transfer(_claim.challenger, depositPlusReward), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.claimer != address(0)) {\\\\n            if (_claim.challenger == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                require(weth.transfer(_claim.claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            } else {\\\\n                address claimer = _claim.claimer;\\\\n                _claim.claimer = address(0);\\\\n                claimHashes[_epoch] = hashClaim(_claim);\\\\n                require(weth.transfer(claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            if (_claim.claimer == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                require(weth.transfer(_claim.challenger, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            } else {\\\\n                address challenger = _claim.challenger;\\\\n                _claim.challenger = address(0);\\\\n                claimHashes[_epoch] == hashClaim(_claim);\\\\n                require(weth.transfer(challenger, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Hashes the claim.\\\\n    /// @param _claim The claim to hash.\\\\n    /// @return hashedClaim The hash of the claim.\\\\n    function hashClaim(Claim memory _claim) public pure returns (bytes32 hashedClaim) {\\\\n        return\\\\n            hashedClaim = keccak256(\\\\n                abi.encodePacked(\\\\n                    _claim.stateRoot,\\\\n                    _claim.claimer,\\\\n                    _claim.timestampClaimed,\\\\n                    _claim.timestampVerification,\\\\n                    _claim.blocknumberVerification,\\\\n                    _claim.honest,\\\\n                    _claim.challenger\\\\n                )\\\\n            );\\\\n    }\\\\n\\\\n    /// @dev Gets the status of the censorship test for claim.\\\\n    /// @param _claim The claim to test.\\\\n    /// @return status True if the claim passed the censorship test.\\\\n    function censorshipTestStatus(Claim memory _claim) public view returns (CensorshipTestStatus status) {\\\\n        unchecked {\\\\n            if (uint256(_claim.timestampVerification) == 0) {\\\\n                status = CensorshipTestStatus.NotStarted;\\\\n            } else if (block.timestamp - uint256(_claim.timestampVerification) < minChallengePeriod) {\\\\n                status = CensorshipTestStatus.InProgress;\\\\n            } else {\\\\n                uint256 expectedBlocks = uint256(_claim.blocknumberVerification) +\\\\n                    (block.timestamp - uint256(_claim.timestampVerification)) /\\\\n                    SLOT_TIME;\\\\n                uint256 actualBlocks = block.number;\\\\n                if (expectedBlocks - actualBlocks <= maxMissingBlocks) {\\\\n                    status = CensorshipTestStatus.Passed;\\\\n                } else {\\\\n                    status = CensorshipTestStatus.Failed;\\\\n                }\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochAt(uint256 timestamp) external view returns (uint256 epoch) {\\\\n        epoch = timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the msg relayed status.\\\\n    /// @param _msgId The msgId to check.\\\\n    /// @return isRelayed True if the msg was relayed.\\\\n    function isMsgRelayed(uint256 _msgId) external view returns (bool isRelayed) {\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        isRelayed = (replay >> offset) & bytes32(uint256(1)) == bytes32(uint256(1));\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x783cb745dcd07b3576146a1649dfe93f3fdba1a9d80b5ee36f331141bd1e12f4\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/gnosis-chain/IAMB.sol\\\":{\\\"content\\\":\\\"// https://docs.gnosischain.com/bridges/tokenbridge/amb-bridge#gnosis\\\\n// https://github.com/omni/tokenbridge-contracts/blob/908a48107919d4ab127f9af07d44d47eac91547e/contracts/interfaces/IAMB.sol\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\ninterface IAMB {\\\\n    function requireToPassMessage(address _contract, bytes memory _data, uint256 _gas) external returns (bytes32);\\\\n\\\\n    function maxGasPerTx() external view returns (uint256);\\\\n\\\\n    function messageSender() external view returns (address);\\\\n\\\\n    function messageSourceChainId() external view returns (bytes32);\\\\n\\\\n    event AffirmationCompleted(\\\\n        address indexed sender,\\\\n        address indexed executor,\\\\n        bytes32 indexed messageId,\\\\n        bool status\\\\n    );\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x2639860b13972492cc59610e95b54e7d3e75cacb2dcdacf07bb2d52c2b183d67\\\"},\\\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"../../arbitrumToGnosis/VeaOutboxArbToGnosis.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Outbox From Arbitrum to Chiado.\\\\n/// Note: This contract is deployed on Chiado.\\\\n/// Note: This contract is permissioned for developer testing (devnet).\\\\ncontract VeaOutboxArbToGnosisDevnet is VeaOutboxArbToGnosis {\\\\n    address public devnetOperator; // permissioned devnet operator\\\\n\\\\n    /// @dev Requires that the sender is the devnet operator.\\\\n    modifier onlyByDevnetOperator() {\\\\n        require(devnetOperator == msg.sender);\\\\n        _;\\\\n    }\\\\n\\\\n    /// @dev Changes the devnet operator.\\\\n    /// @param _devnetOperator The new testnet operator.\\\\n    function changeDevnetOperator(address _devnetOperator) external onlyByDevnetOperator {\\\\n        require(msg.sender == devnetOperator, \\\\\\\"Invalid Testnet Operator\\\\\\\");\\\\n        devnetOperator = _devnetOperator;\\\\n    }\\\\n\\\\n    /// @dev Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateRoot The state root to claim.\\\\n    function claim(uint256 _epoch, bytes32 _stateRoot) public override onlyByDevnetOperator {\\\\n        require(weth.transferFrom(msg.sender, address(this), deposit), \\\\\\\"Failed WETH transfer.\\\\\\\");\\\\n        require(_stateRoot != bytes32(0), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(claimHashes[_epoch] == bytes32(0), \\\\\\\"Claim already made.\\\\\\\");\\\\n\\\\n        claimHashes[_epoch] = hashClaim(\\\\n            Claim({\\\\n                stateRoot: _stateRoot,\\\\n                claimer: msg.sender,\\\\n                timestampClaimed: uint32(block.timestamp),\\\\n                timestampVerification: uint32(0),\\\\n                blocknumberVerification: uint32(0),\\\\n                honest: Party.None,\\\\n                challenger: address(0)\\\\n            })\\\\n        );\\\\n\\\\n        emit Claimed(msg.sender, _epoch, _stateRoot);\\\\n    }\\\\n\\\\n    /// @dev Start verification for claim for 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function startVerification(uint256 _epoch, Claim memory _claim) public override onlyByDevnetOperator {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n\\\\n        _claim.timestampVerification = uint32(block.timestamp);\\\\n        _claim.blocknumberVerification = uint32(block.number);\\\\n\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit VerificationStarted(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimDeposit(uint256 _epoch, Claim memory _claim) public override {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Claimer, \\\\\\\"Claim failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            weth.burn(burn); // no return value to check\\\\n            require(weth.transfer(_claim.claimer, depositPlusReward), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n        } else {\\\\n            require(weth.transfer(_claim.claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Resolves the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch of the optimistic claim.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function verifySnapshot(uint256 _epoch, Claim memory _claim) public override OnlyBridgeRunning {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _claim.stateRoot;\\\\n        }\\\\n\\\\n        _claim.honest = Party.Claimer;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Testnet operator utility function to claim, validate and withdraw.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateroot The state root to claim.\\\\n    function devnetAdvanceState(uint256 _epoch, bytes32 _stateroot) external payable {\\\\n        claim(_epoch, _stateroot);\\\\n        Claim memory claim = Claim({\\\\n            stateRoot: _stateroot,\\\\n            claimer: msg.sender,\\\\n            timestampClaimed: uint32(block.timestamp),\\\\n            timestampVerification: uint32(0),\\\\n            blocknumberVerification: uint32(0),\\\\n            honest: Party.None,\\\\n            challenger: address(0)\\\\n        });\\\\n        claim.timestampClaimed = uint32(block.timestamp);\\\\n        startVerification(_epoch, claim);\\\\n        claim.timestampVerification = uint32(block.timestamp);\\\\n        claim.blocknumberVerification = uint32(block.number);\\\\n        verifySnapshot(_epoch, claim);\\\\n        claim.honest = Party.Claimer;\\\\n        withdrawClaimDeposit(_epoch, claim);\\\\n    }\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _deposit The deposit amount to submit a claim in wei.\\\\n    /// @param _epochPeriod The duration of each epoch.\\\\n    /// @param _minChallengePeriod The minimum time window to challenge a claim.\\\\n    /// @param _timeoutEpochs The epochs before the bridge is considered shutdown.\\\\n    /// @param _amb The address of the AMB contract on Gnosis.\\\\n    /// @param _routerArbToGnosis The address of the router on Ethereum that routes from Arbitrum to Gnosis.\\\\n    /// @param _sequencerDelayLimit The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\\\\n    /// @param _maxMissingBlocks The maximum number of blocks that can be missing in a challenge period.\\\\n    /// @param _routerChainId The chain id of the routerArbToGnosis.\\\\n    /// @param _weth The address of the WETH contract on Gnosis.\\\\n    constructor(\\\\n        uint256 _deposit,\\\\n        uint256 _epochPeriod,\\\\n        uint256 _minChallengePeriod,\\\\n        uint256 _timeoutEpochs,\\\\n        IAMB _amb,\\\\n        address _routerArbToGnosis,\\\\n        uint256 _sequencerDelayLimit,\\\\n        uint256 _maxMissingBlocks,\\\\n        uint256 _routerChainId,\\\\n        IWETH _weth\\\\n    )\\\\n        VeaOutboxArbToGnosis(\\\\n            _deposit,\\\\n            _epochPeriod,\\\\n            _minChallengePeriod,\\\\n            _timeoutEpochs,\\\\n            _amb,\\\\n            _routerArbToGnosis,\\\\n            _sequencerDelayLimit,\\\\n            _maxMissingBlocks,\\\\n            _routerChainId,\\\\n            _weth\\\\n        )\\\\n    {\\\\n        devnetOperator = msg.sender;\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xa6d51475aa68c65ae30436feac0586511d9b71300cde0ff0b6db156416545512\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/outboxes/IVeaOutboxOnL1.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Outbox on L1 chains like Ethereum, Gnosis, Polygon POS where storage is expensive.\\\\ninterface IVeaOutboxOnL1 {\\\\n    /// @dev Verifies and relays the message.\\\\n    /// Note: Gateways expect first argument of message call to be the arbitrum message sender, used for authentication.\\\\n    /// @param _proof The merkle proof to prove the message.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address to send the message to.\\\\n    /// @param _message The message to relay.\\\\n    function sendMessage(bytes32[] calldata _proof, uint64 _msgId, address _to, bytes calldata _message) external;\\\\n\\\\n    /// @dev Resolves any challenge of the optimistic claim for 'epoch' using the canonical bridge.\\\\n    /// Note: Access restricted to canonical bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(uint256 _epoch, bytes32 _stateRoot, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xf1d52e289e790088502b7909f11f47bc33ddd3fc545636b7fb29c01ed00d3ff3\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/tokens/gnosis/IWETH.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\npragma solidity ^0.8.0;\\\\n\\\\n// https://github.com/OpenZeppelin/openzeppelin-contracts/blob/5daaf60d11ee2075260d0f3adfb22b1c536db983/contracts/token/ERC20/StandardBurnableToken.sol\\\\n// implementation: https://gnosisscan.io/address/0xf8d1677c8a0c961938bf2f9adc3f3cfda759a9d9#code\\\\n// proxy: https://gnosisscan.io/token/0x6a023ccd1ff6f2045c3309768ead9e68f978f6e1#readProxyContract\\\\n\\\\n/**\\\\n * @title Standard Burnable Token\\\\n * @dev Token that can be irreversibly burned (destroyed).\\\\n */\\\\ninterface IWETH {\\\\n    /**\\\\n     * @dev Burns a specific amount of tokens.\\\\n     * @param _value The amount of token to be burned.\\\\n     */\\\\n    function burn(uint256 _value) external;\\\\n\\\\n    /**\\\\n     * @dev Gets the balance of the specified address.\\\\n     * @param _owner The address to query the the balance of.\\\\n     * @return An uint256 representing the amount owned by the passed address.\\\\n     */\\\\n    function balanceOf(address _owner) external view returns (uint256);\\\\n\\\\n    /**\\\\n     * @dev Transfer tokens from one address to another\\\\n     * @param _from address The address which you want to send tokens from\\\\n     * @param _to address The address which you want to transfer to\\\\n     * @param _value uint256 the amount of tokens to be transferred\\\\n     */\\\\n    function transferFrom(address _from, address _to, uint256 _value) external returns (bool);\\\\n\\\\n    /**\\\\n     * @dev Transfer token for a specified address\\\\n     * @param _to The address to transfer to.\\\\n     * @param _value The amount to be transferred.\\\\n     */\\\\n    function transfer(address _to, uint256 _value) external returns (bool);\\\\n\\\\n    /**\\\\n     * @dev Function to check the amount of tokens that an owner allowed to a spender.\\\\n     * @param _owner address The address which owns the funds.\\\\n     * @param _spender address The address which will spend the funds.\\\\n     * @return A uint256 specifying the amount of tokens still available for the spender.\\\\n     */\\\\n    function allowance(address _owner, address _spender) external view returns (uint256);\\\\n\\\\n    /**\\\\n     * @dev Approve the passed address to spend the specified amount of tokens on behalf of msg.sender.\\\\n     * Beware that changing an allowance with this method brings the risk that someone may use both the old\\\\n     * and the new allowance by unfortunate transaction ordering. One possible solution to mitigate this\\\\n     * race condition is to first reduce the spender's allowance to 0 and set the desired value afterwards:\\\\n     * https://github.com/ethereum/EIPs/issues/20#issuecomment-263524729\\\\n     * @param _spender The address which will spend the funds.\\\\n     * @param _value The amount of tokens to be spent.\\\\n     */\\\\n    function approve(address _spender, uint256 _value) external returns (bool);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xbdda7697ab9595ad33056b937c120f23ab64bd2aac8c2f7e54bf3afd2cdd7a31\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xfef781e359c97aebbe8dbfcb75edb7cb962139fd9ea538b8b89a3f2e13a05bfe\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/updaters/ISequencerDelayUpdatable.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity 0.8.24;\\\\n\\\\n/// @dev Interface of a contract which is updatable, receiving parameter updates from an L1 contract through a cross-chain call.\\\\n/// @dev eg. Arbitrum (L2) -> Ethereum (L1) -> Gnosis (L1), the veaOutbox on Gnosis will be an ISequencerDelayUpdatable contract which receives updates from the router on Ethereum.\\\\ninterface ISequencerDelayUpdatable {\\\\n    /// @dev Updates the sequencer limit.\\\\n    /// Note: Access restricted to ensure the argument is passed from the Sequencer contract.\\\\n    /// @param _newSequencerDelayLimit The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\\\\n    /// @param _timestamp The timestamp of the message.\\\\n    function updateSequencerDelayLimit(uint256 _newSequencerDelayLimit, uint256 _timestamp) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x95ca3cc0dfaddee5c94a7e6b68bb9a90ce6d1b9cdd3b59241f5b1b5831ed89ec\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"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\",\"deployedBytecode\":\"0x6080604052600436106102045760003560e01c80637ffc2a6e11610118578063b5b7a184116100a0578063d5e6a9df1161006f578063d5e6a9df146106cf578063da2b7bc414610703578063df19e6ff14610723578063e813a75514610750578063eedcf2a91461076657600080fd5b8063b5b7a18414610613578063b633b94414610647578063c2114a1614610667578063d0e30db01461069b57600080fd5b80638d96fdea116100e75780638d96fdea14610541578063930f28af146105755780639588eca214610595578063aa22a1c6146105ab578063b044397e146105df57600080fd5b80637ffc2a6e146104b7578063836e344b146104cd5780638a619a71146105015780638ad3a8f71461052157600080fd5b806331ddf7431161019b57806344df8e701161016a57806344df8e70146104035780634788cb381461043757806349b4299e146104575780634a439cfe14610477578063541adcca1461049757600080fd5b806331ddf743146103425780633ce43cfd146103625780633fc8cef31461038257806343b066d5146103b657600080fd5b80632639c060116101d75780632639c060146102bf57806327ee6bdd146102ec5780632c1925191461030257806331d144571461032257600080fd5b806301139b68146102095780630f0adca51461022b5780631062b39a1461024b578063222ae7861461029c575b600080fd5b34801561021557600080fd5b5061022961022436600461240c565b610779565b005b34801561023757600080fd5b5061022961024636600461243a565b610999565b34801561025757600080fd5b5061027f7f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b0390911681526020015b60405180910390f35b3480156102a857600080fd5b506102b1610d49565b604051908152602001610293565b3480156102cb57600080fd5b506102b16102da366004612471565b60026020526000908152604090205481565b3480156102f857600080fd5b506102b160015481565b34801561030e57600080fd5b5061022961031d36600461248a565b610d7a565b34801561032e57600080fd5b5061022961033d36600461248a565b611052565b34801561034e57600080fd5b5061022961035d36600461250d565b61123d565b34801561036e57600080fd5b5061022961037d3660046125cf565b6114dd565b34801561038e57600080fd5b5061027f7f000000000000000000000000000000000000000000000000000000000000000081565b3480156103c257600080fd5b506103f36103d1366004612471565b600881901c600090815260036020526040902054600160ff9092161c81161490565b6040519015158152602001610293565b34801561040f57600080fd5b506102b17f000000000000000000000000000000000000000000000000000000000000000081565b34801561044357600080fd5b5061022961045236600461240c565b611717565b34801561046357600080fd5b5061022961047236600461240c565b611952565b34801561048357600080fd5b506102b1610492366004612471565b6119f9565b3480156104a357600080fd5b506102b16104b2366004612608565b611a2b565b3480156104c357600080fd5b506102b160055481565b3480156104d957600080fd5b506102b17f000000000000000000000000000000000000000000000000000000000000000081565b34801561050d57600080fd5b5061022961051c36600461262b565b611a7d565b34801561052d57600080fd5b5060065461027f906001600160a01b031681565b34801561054d57600080fd5b506102b17f000000000000000000000000000000000000000000000000000000000000000081565b34801561058157600080fd5b5061022961059036600461240c565b611b10565b3480156105a157600080fd5b506102b160005481565b3480156105b757600080fd5b506102b17f000000000000000000000000000000000000000000000000000000000000000081565b3480156105eb57600080fd5b506102b17f000000000000000000000000000000000000000000000000000000000000000081565b34801561061f57600080fd5b506102b17f000000000000000000000000000000000000000000000000000000000000000081565b34801561065357600080fd5b5061022961066236600461240c565b611c94565b34801561067357600080fd5b506102b17f000000000000000000000000000000000000000000000000000000000000000081565b3480156106a757600080fd5b506102b17f000000000000000000000000000000000000000000000000000000000000000081565b3480156106db57600080fd5b5061027f7f000000000000000000000000000000000000000000000000000000000000000081565b34801561070f57600080fd5b5061022961071e36600461240c565b611f59565b34801561072f57600080fd5b5061074361073e366004612608565b6121c5565b604051610293919061265e565b34801561075c57600080fd5b506102b160045481565b61022961077436600461248a565b61228c565b6040516323b872dd60e01b81523360048201523060248201527f000000000000000000000000000000000000000000000000000000000000000060448201527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906323b872dd906064016020604051808303816000875af115801561080b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061082f9190612678565b6108545760405162461bcd60e51b815260040161084b9061269a565b60405180910390fd5b61085d81611a2b565b600083815260026020526040902054146108895760405162461bcd60e51b815260040161084b906126c9565b60c08101516001600160a01b0316156108e45760405162461bcd60e51b815260206004820152601960248201527f436c61696d20616c7265616479206368616c6c656e6765642e00000000000000604482015260640161084b565b60008160a0015160028111156108fc576108fc612648565b146109495760405162461bcd60e51b815260206004820152601760248201527f436c61696d20616c72656164792076657269666965642e000000000000000000604482015260640161084b565b3360c082015261095881611a2b565b600083815260026020526040808220929092559051339184917fcfe09ca25f55d949baba5e280f5750c9ba4b9048fca5532f916067d433afe4d79190a35050565b7f00000000000000000000000000000000000000000000000000000000000000006001547f000000000000000000000000000000000000000000000000000000000000000042816109ec576109ec6126f1565b04031115610a2f5760405162461bcd60e51b815260206004820152601060248201526f213934b233b29029b43aba3237bbb71760811b604482015260640161084b565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610ab25760405162461bcd60e51b815260206004820152602260248201527f4e6f742066726f6d206e617469766520476e6f73697320414d42206272696467604482015261329760f11b606482015260840161084b565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316639e307dff6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610b10573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b349190612707565b7f000000000000000000000000000000000000000000000000000000000000000014610b965760405162461bcd60e51b815260206004820152601160248201527024b73b30b634b21031b430b4b71034b21760791b604482015260640161084b565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663d67bdd256040518163ffffffff1660e01b8152600401602060405180830381865afa158015610bf4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c189190612720565b6001600160a01b03167f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031614610c8b5760405162461bcd60e51b815260206004820152601060248201526f2737ba10333937b6903937baba32b91760811b604482015260640161084b565b60015483118015610c9b57508115155b15610cab57600183905560008290555b610cb481611a2b565b60008481526002602052604090205403610d11578051829003610cdd57600160a0820152610cf8565b60c08101516001600160a01b031615610cf857600260a08201525b610d0181611a2b565b6000848152600260205260409020555b6040518381527ff786e7f77ede00a02a5464f8f0555798f42ba99a4a920ef2778db8d75e4656f79060200160405180910390a1505050565b6000610d757f00000000000000000000000000000000000000000000000000000000000000004261273d565b905090565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610de55760405162461bcd60e51b815260206004820152601060248201526f2737ba10333937b690313934b233b29760811b604482015260640161084b565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316639e307dff6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610e43573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e679190612707565b7f000000000000000000000000000000000000000000000000000000000000000014610ec95760405162461bcd60e51b815260206004820152601160248201527024b73b30b634b21031b430b4b71034b21760791b604482015260640161084b565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663d67bdd256040518163ffffffff1660e01b8152600401602060405180830381865afa158015610f27573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f4b9190612720565b6001600160a01b03167f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031614610fbe5760405162461bcd60e51b815260206004820152601060248201526f2737ba10333937b6903937baba32b91760811b604482015260640161084b565b80600554106110065760405162461bcd60e51b815260206004820152601460248201527326b2b9b9b0b3b29034b99037baba3230ba32b21760611b604482015260640161084b565b816004541461104e57600482905560058190556040518281527f9c5113f22fcac086268c71488477822578ad93bd46c1993c9ce908d65e6fb2fe906020015b60405180910390a15b5050565b6006546001600160a01b0316331461106957600080fd5b6040516323b872dd60e01b81523360048201523060248201527f000000000000000000000000000000000000000000000000000000000000000060448201527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906323b872dd906064016020604051808303816000875af11580156110fb573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061111f9190612678565b61113b5760405162461bcd60e51b815260040161084b9061269a565b806111585760405162461bcd60e51b815260040161084b906126c9565b600082815260026020526040902054156111aa5760405162461bcd60e51b815260206004820152601360248201527221b630b4b69030b63932b0b23c9036b0b2329760691b604482015260640161084b565b6040805160e0810182528281523360208201524263ffffffff16918101919091526000606082018190526080820181905260a0820181905260c08201526111f090611a2b565b6000838152600260209081526040918290209290925551828152839133917fd95107f4584744c6c893a04c43058aadd1ce8aac8ca5d64140eaf277de6c1d57910160405180910390a35050565b6040851061127f5760405162461bcd60e51b815260206004820152600f60248201526e283937b7b3103a37b7903637b7339760891b604482015260640161084b565b600084848484604051602001611298949392919061275f565b604051602081830303815290604052805190602001209050806000526020600020905060005b868110156113185760008888838181106112da576112da6127a1565b905060200201359050828111156112ff5782600052806020526040600020925061130f565b8060005282602052604060002092505b506001016112be565b50806000541461135b5760405162461bcd60e51b815260206004820152600e60248201526d24b73b30b634b210383937b7b31760911b604482015260640161084b565b600885901c66ffffffffffffff1660008181526003602052604090205460ff87169080821c600116156113d05760405162461bcd60e51b815260206004820152601760248201527f4d65737361676520616c72656164792072656c61796564000000000000000000604482015260640161084b565b6000838152600360205260408082206001851b84179055516001600160a01b0389169061140090899089906127b7565b6000604051808303816000865af19150503d806000811461143d576040519150601f19603f3d011682016040523d82523d6000602084013e611442565b606091505b50509050806114935760405162461bcd60e51b815260206004820152601760248201527f4661696c656420746f2063616c6c20636f6e7472616374000000000000000000604482015260640161084b565b60405167ffffffffffffffff8a1681527f54303fab361bc52c2f1f56ace7351189582264f74ce47a6e7c3f478d64c429439060200160405180910390a15050505050505050505050565b6114ef6104b236839003830183612608565b6000838152600260205260409020541461151b5760405162461bcd60e51b815260040161084b906126c9565b600261152d60c0830160a084016127c7565b600281111561153e5761153e612648565b1461157f5760405162461bcd60e51b815260206004820152601160248201527021b430b63632b733b2903330b4b632b21760791b604482015260640161084b565b6000828152600260205260408082209190915551630852cd8d60e31b81527f000000000000000000000000000000000000000000000000000000000000000060048201527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906342966c6890602401600060405180830381600087803b15801561161157600080fd5b505af1158015611625573d6000803e3d6000fd5b50506001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016915063a9059cbb905061166a60e0840160c0850161262b565b6040516001600160e01b031960e084901b1681526001600160a01b0390911660048201527f000000000000000000000000000000000000000000000000000000000000000060248201526044015b6020604051808303816000875af11580156116d7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116fb9190612678565b61104e5760405162461bcd60e51b815260040161084b9061269a565b61172081611a2b565b6000838152600260205260409020541461174c5760405162461bcd60e51b815260040161084b906126c9565b60018160a00151600281111561176457611764612648565b146117a15760405162461bcd60e51b815260206004820152600d60248201526c21b630b4b6903330b4b632b21760991b604482015260640161084b565b60008281526002602052604081205560c08101516001600160a01b0316156118d757604051630852cd8d60e31b81527f000000000000000000000000000000000000000000000000000000000000000060048201527f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906342966c6890602401600060405180830381600087803b15801561184457600080fd5b505af1158015611858573d6000803e3d6000fd5b50505050602081015160405163a9059cbb60e01b81526001600160a01b0391821660048201527f000000000000000000000000000000000000000000000000000000000000000060248201527f00000000000000000000000000000000000000000000000000000000000000009091169063a9059cbb906044016116b8565b602081015160405163a9059cbb60e01b81526001600160a01b0391821660048201527f000000000000000000000000000000000000000000000000000000000000000060248201527f00000000000000000000000000000000000000000000000000000000000000009091169063a9059cbb906044016116b8565b6006546001600160a01b0316331461196957600080fd5b61197281611a2b565b6000838152600260205260409020541461199e5760405162461bcd60e51b815260040161084b906126c9565b63ffffffff4281166060830152431660808201526119bb81611a2b565b60008381526002602052604080822092909255905183917f37b700b61b9b4710dddb0c3316b2be7ef6088ed4b1d7bfe0fb98be8f9a163e1691a25050565b6000611a257f00000000000000000000000000000000000000000000000000000000000000008361273d565b92915050565b80516020808301516040808501516060860151608087015160a088015160c08901519451600098611a609890979691016127e2565b604051602081830303815290604052805190602001209050919050565b6006546001600160a01b03163314611a9457600080fd5b6006546001600160a01b03163314611aee5760405162461bcd60e51b815260206004820152601860248201527f496e76616c696420546573746e6574204f70657261746f720000000000000000604482015260640161084b565b600680546001600160a01b0319166001600160a01b0392909216919091179055565b7f00000000000000000000000000000000000000000000000000000000000000006001547f00000000000000000000000000000000000000000000000000000000000000004281611b6357611b636126f1565b04031115611ba65760405162461bcd60e51b815260206004820152601060248201526f213934b233b29029b43aba3237bbb71760811b604482015260640161084b565b611baf81611a2b565b60008381526002602052604090205414611bdb5760405162461bcd60e51b815260040161084b906126c9565b60c08101516001600160a01b031615611c2d5760405162461bcd60e51b815260206004820152601460248201527321b630b4b69034b99031b430b63632b733b2b21760611b604482015260640161084b565b600154821115611c4257600182905580516000555b600160a0820152611c5281611a2b565b60008381526002602090815260409182902092909255518381527ff786e7f77ede00a02a5464f8f0555798f42ba99a4a920ef2778db8d75e4656f79101611045565b7f00000000000000000000000000000000000000000000000000000000000000006001547f00000000000000000000000000000000000000000000000000000000000000004281611ce757611ce76126f1565b040311611d285760405162461bcd60e51b815260206004820152600f60248201526e213934b233b290293ab73734b7339760891b604482015260640161084b565b611d3181611a2b565b60008381526002602052604090205414611d5d5760405162461bcd60e51b815260040161084b906126c9565b60008160a001516002811115611d7557611d75612648565b14611db45760405162461bcd60e51b815260206004820152600f60248201526e21b630b4b6903932b9b7b63b32b21760891b604482015260640161084b565b60c08101516001600160a01b03161561104e5760208101516001600160a01b0316611e66576000828152600260205260408082209190915560c0820151905163a9059cbb60e01b81526001600160a01b0391821660048201527f000000000000000000000000000000000000000000000000000000000000000060248201527f00000000000000000000000000000000000000000000000000000000000000009091169063a9059cbb906044016116b8565b60c0810180516000909152611e7a82611a2b565b506000839052600260205260405163a9059cbb60e01b81526001600160a01b0382811660048301527f000000000000000000000000000000000000000000000000000000000000000060248301527f0000000000000000000000000000000000000000000000000000000000000000169063a9059cbb906044015b6020604051808303816000875af1158015611f14573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611f389190612678565b611f545760405162461bcd60e51b815260040161084b9061269a565b505050565b7f00000000000000000000000000000000000000000000000000000000000000006001547f00000000000000000000000000000000000000000000000000000000000000004281611fac57611fac6126f1565b040311611fed5760405162461bcd60e51b815260206004820152600f60248201526e213934b233b290293ab73734b7339760891b604482015260640161084b565b611ff681611a2b565b600083815260026020526040902054146120225760405162461bcd60e51b815260040161084b906126c9565b60008160a00151600281111561203a5761203a612648565b146120795760405162461bcd60e51b815260206004820152600f60248201526e21b630b4b6903932b9b7b63b32b21760891b604482015260640161084b565b60208101516001600160a01b03161561104e5760c08101516001600160a01b031661212b57600082815260026020908152604080832092909255820151905163a9059cbb60e01b81526001600160a01b0391821660048201527f000000000000000000000000000000000000000000000000000000000000000060248201527f00000000000000000000000000000000000000000000000000000000000000009091169063a9059cbb906044016116b8565b602081018051600090915261213f82611a2b565b60008481526002602052604090819020919091555163a9059cbb60e01b81526001600160a01b0382811660048301527f000000000000000000000000000000000000000000000000000000000000000060248301527f0000000000000000000000000000000000000000000000000000000000000000169063a9059cbb90604401611ef5565b6000816060015163ffffffff166000036121e157506002919050565b7f0000000000000000000000000000000000000000000000000000000000000000826060015163ffffffff164203101561221d57506003919050565b60006005836060015163ffffffff1642038161223b5761223b6126f1565b608085015163ffffffff16919004019050437f00000000000000000000000000000000000000000000000000000000000000008183031161227f5760019250612284565b600092505b50505b919050565b6122968282611052565b6040805160e0810182528281523360208201524263ffffffff16918101919091526000606082018190526080820181905260a0820181905260c08201526122dd8382611952565b63ffffffff4281166060830152431660808201526122fb8382611b10565b600160a0820152611f548382611717565b6001600160a01b038116811461232157600080fd5b50565b80356122878161230c565b803563ffffffff8116811461228757600080fd5b80356003811061228757600080fd5b600060e0828403121561236457600080fd5b60405160e0810181811067ffffffffffffffff8211171561239557634e487b7160e01b600052604160045260246000fd5b604052823581529050806123ab60208401612324565b60208201526123bc6040840161232f565b60408201526123cd6060840161232f565b60608201526123de6080840161232f565b60808201526123ef60a08401612343565b60a082015261240060c08401612324565b60c08201525092915050565b600080610100838503121561242057600080fd5b823591506124318460208501612352565b90509250929050565b6000806000610120848603121561245057600080fd5b83359250602084013591506124688560408601612352565b90509250925092565b60006020828403121561248357600080fd5b5035919050565b6000806040838503121561249d57600080fd5b50508035926020909101359150565b803567ffffffffffffffff8116811461228757600080fd5b60008083601f8401126124d657600080fd5b50813567ffffffffffffffff8111156124ee57600080fd5b60208301915083602082850101111561250657600080fd5b9250929050565b6000806000806000806080878903121561252657600080fd5b863567ffffffffffffffff8082111561253e57600080fd5b818901915089601f83011261255257600080fd5b81358181111561256157600080fd5b8a60208260051b850101111561257657600080fd5b6020830198508097505061258c60208a016124ac565b955061259a60408a01612324565b945060608901359150808211156125b057600080fd5b506125bd89828a016124c4565b979a9699509497509295939492505050565b6000808284036101008112156125e457600080fd5b8335925060e0601f19820112156125fa57600080fd5b506020830190509250929050565b600060e0828403121561261a57600080fd5b6126248383612352565b9392505050565b60006020828403121561263d57600080fd5b81356126248161230c565b634e487b7160e01b600052602160045260246000fd5b602081016004831061267257612672612648565b91905290565b60006020828403121561268a57600080fd5b8151801515811461262457600080fd5b6020808252601590820152742330b4b632b2102ba2aa24103a3930b739b332b91760591b604082015260600190565b6020808252600e908201526d24b73b30b634b21031b630b4b69760911b604082015260600190565b634e487b7160e01b600052601260045260246000fd5b60006020828403121561271957600080fd5b5051919050565b60006020828403121561273257600080fd5b81516126248161230c565b60008261275a57634e487b7160e01b600052601260045260246000fd5b500490565b60c085901b6001600160c01b0319168152606084901b6bffffffffffffffffffffffff191660088201528183601c83013760009101601c019081529392505050565b634e487b7160e01b600052603260045260246000fd5b8183823760009101908152919050565b6000602082840312156127d957600080fd5b61262482612343565b87815260006bffffffffffffffffffffffff19808960601b16602084015263ffffffff60e01b808960e01b166034850152808860e01b166038850152808760e01b16603c850152506003851061283a5761283a612648565b60f89490941b60408301525060609190911b90911660418201526055019594505050505056fea2646970667358221220661b042c42e0ee09ab53acf28ff4a8b3ceef7ce45b555567962aeea61ccc187f64736f6c63430008180033\",\"devdoc\":{\"details\":\"Vea Outbox From Arbitrum to Chiado. Note: This contract is deployed on Chiado. Note: This contract is permissioned for developer testing (devnet).\",\"events\":{\"Challenged(uint256,address)\":{\"details\":\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\",\"params\":{\"_challenger\":\"The address of the challenger.\",\"_epoch\":\"The epoch associated with the challenged claim.\"}},\"Claimed(address,uint256,bytes32)\":{\"details\":\"Watchers check this event to challenge fraud.\",\"params\":{\"_claimer\":\"The address of the claimer.\",\"_epoch\":\"The epoch associated with the claim.\",\"_stateRoot\":\"The state root of the claim.\"}},\"MessageRelayed(uint64)\":{\"details\":\"This event indicates that a message has been relayed.\",\"params\":{\"_msgId\":\"The msgId of the message that was relayed.\"}},\"SequencerDelayLimitUpdateReceived(uint256)\":{\"details\":\"This event indicates the sequencer limit updated.\",\"params\":{\"_newSequencerDelayLimit\":\"The new sequencer delay limit.\"}},\"VerificationStarted(uint256)\":{\"details\":\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\",\"params\":{\"_epoch\":\"The epoch that started verification.\"}},\"Verified(uint256)\":{\"details\":\"This events indicates that verification has succeeded. The messages are ready to be relayed.\",\"params\":{\"_epoch\":\"The epoch that was verified.\"}}},\"kind\":\"dev\",\"methods\":{\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Gets the status of the censorship test for claim.\",\"params\":{\"_claim\":\"The claim to test.\"},\"returns\":{\"status\":\"True if the claim passed the censorship test.\"}},\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"changeDevnetOperator(address)\":{\"details\":\"Changes the devnet operator.\",\"params\":{\"_devnetOperator\":\"The new testnet operator.\"}},\"claim(uint256,bytes32)\":{\"details\":\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\",\"params\":{\"_epoch\":\"The epoch for which the claim is made.\",\"_stateRoot\":\"The state root to claim.\"}},\"constructor\":{\"details\":\"Constructor. Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\",\"params\":{\"_amb\":\"The address of the AMB contract on Gnosis.\",\"_deposit\":\"The deposit amount to submit a claim in wei.\",\"_epochPeriod\":\"The duration of each epoch.\",\"_maxMissingBlocks\":\"The maximum number of blocks that can be missing in a challenge period.\",\"_minChallengePeriod\":\"The minimum time window to challenge a claim.\",\"_routerArbToGnosis\":\"The address of the router on Ethereum that routes from Arbitrum to Gnosis.\",\"_routerChainId\":\"The chain id of the routerArbToGnosis.\",\"_sequencerDelayLimit\":\"The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\",\"_timeoutEpochs\":\"The epochs before the bridge is considered shutdown.\",\"_weth\":\"The address of the WETH contract on Gnosis.\"}},\"devnetAdvanceState(uint256,bytes32)\":{\"details\":\"Testnet operator utility function to claim, validate and withdraw.\",\"params\":{\"_epoch\":\"The epoch for which the claim is made.\",\"_stateroot\":\"The state root to claim.\"}},\"epochAt(uint256)\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Hashes the claim.\",\"params\":{\"_claim\":\"The claim to hash.\"},\"returns\":{\"hashedClaim\":\"The hash of the claim.\"}},\"isMsgRelayed(uint256)\":{\"details\":\"Get the msg relayed status.\",\"params\":{\"_msgId\":\"The msgId to check.\"},\"returns\":{\"isRelayed\":\"True if the msg was relayed.\"}},\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves any challenge of the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch to verify.\",\"_stateRoot\":\"The true state root for the epoch.\"}},\"sendMessage(bytes32[],uint64,address,bytes)\":{\"details\":\"Verifies and relays the message. UNTRUSTED.\",\"params\":{\"_message\":\"The message encoded in the vea inbox as abi.encodeWithSelector(fnSelector, msg.sender, param1, param2, ...)\",\"_msgId\":\"The zero based index of the message in the inbox.\",\"_proof\":\"The merkle proof to prove the message inclusion in the inbox state root.\",\"_to\":\"The address of the contract on Gnosis to call.\"}},\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Start verification for claim for 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"updateSequencerDelayLimit(uint256,uint256)\":{\"details\":\"Set the sequencerDelayLimit by receiving a message from the AMB.\",\"params\":{\"_newSequencerDelayLimit\":\"The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\",\"_timestamp\":\"The timestamp of the message.\"}},\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the optimistic claim.\"}},\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the challenge deposit to withraw.\"}},\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"notice\":\"Note: Access restricted to AMB.\"}},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":1530,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"stateRoot\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_bytes32\"},{\"astId\":1532,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"latestVerifiedEpoch\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_uint256\"},{\"astId\":1536,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"claimHashes\",\"offset\":0,\"slot\":\"2\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":1540,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"relayed\",\"offset\":0,\"slot\":\"3\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":1542,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"sequencerDelayLimit\",\"offset\":0,\"slot\":\"4\",\"type\":\"t_uint256\"},{\"astId\":1544,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"timestampDelayUpdated\",\"offset\":0,\"slot\":\"5\",\"type\":\"t_uint256\"},{\"astId\":3507,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"devnetOperator\",\"offset\":0,\"slot\":\"6\",\"type\":\"t_address\"}],\"types\":{\"t_address\":{\"encoding\":\"inplace\",\"label\":\"address\",\"numberOfBytes\":\"20\"},\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"}}}}");


function $8932c7f61f098658$export$b6380ff64616a4fb(chain) {
    return {
        formatters: undefined,
        fees: undefined,
        serializers: undefined,
        ...chain
    };
}


const $6a02c0f0c34d6c61$export$21799e7ae6cc115 = /*#__PURE__*/ (0, $8932c7f61f098658$export$b6380ff64616a4fb)({
    id: 421614,
    name: 'Arbitrum Sepolia',
    nativeCurrency: {
        name: 'Arbitrum Sepolia Ether',
        symbol: 'ETH',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://sepolia-rollup.arbitrum.io/rpc'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Arbiscan',
            url: 'https://sepolia.arbiscan.io',
            apiUrl: 'https://sepolia.arbiscan.io/api'
        }
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 81930
        }
    },
    testnet: true
});


const $29073ff13918eb95$export$7a430fb03087826a = /*#__PURE__*/ (0, $8932c7f61f098658$export$b6380ff64616a4fb)({
    id: 10200,
    name: 'Gnosis Chiado',
    nativeCurrency: {
        decimals: 18,
        name: 'Gnosis',
        symbol: 'xDAI'
    },
    rpcUrls: {
        default: {
            http: [
                'https://rpc.chiadochain.net'
            ],
            webSocket: [
                'wss://rpc.chiadochain.net/wss'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://blockscout.chiadochain.net',
            apiUrl: 'https://blockscout.chiadochain.net/api'
        }
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 4967313
        }
    },
    testnet: true
});


const $3819d1b9799f3613$export$31254237fd28c61a = /*#__PURE__*/ (0, $8932c7f61f098658$export$b6380ff64616a4fb)({
    id: 11155111,
    name: 'Sepolia',
    nativeCurrency: {
        name: 'Sepolia Ether',
        symbol: 'SEP',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://rpc.sepolia.org'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://sepolia.etherscan.io',
            apiUrl: 'https://api-sepolia.etherscan.io/api'
        }
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 751532
        },
        ensRegistry: {
            address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'
        },
        ensUniversalResolver: {
            address: '0xBaBC7678D7A63104f1658c11D6AE9A21cdA09725',
            blockCreated: 5043334
        }
    },
    testnet: true
});



parcelRequire("9nZCP");
const $6e8b4c8f89314f65$var$SvgArbitrum = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                clipPath: "url(#arbitrum_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("mask", {
                        id: "arbitrum_svg__b",
                        width: 15,
                        height: 16,
                        x: 1,
                        y: 0,
                        maskUnits: "userSpaceOnUse",
                        style: {
                            maskType: "luminance"
                        },
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M15.184 0H1v16h14.184z"
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                        mask: "url(#arbitrum_svg__b)",
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                fill: "#213147",
                                d: "M1.539 4.864v6.272c0 .4.214.771.56.97l5.434 3.138c.347.2.773.2 1.12 0l5.433-3.137c.347-.2.561-.57.561-.97V4.863c0-.4-.214-.771-.56-.97L8.653.755c-.347-.2-.773-.2-1.12 0L2.098 3.893c-.347.2-.56.57-.56.97"
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                fill: "#69C3FC",
                                d: "m9.278 9.217-.774 2.124a.27.27 0 0 0 0 .183l1.333 3.655 1.542-.89-1.851-5.072a.133.133 0 0 0-.25 0M10.832 5.644a.133.133 0 0 0-.25 0l-.775 2.124a.27.27 0 0 0 0 .183l2.184 5.985 1.542-.89z"
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                fill: "#9DCCED",
                                d: "M8.092.991q.058 0 .11.03l5.88 3.394c.069.039.11.113.11.19v6.787a.22.22 0 0 1-.11.19l-5.88 3.395a.2.2 0 0 1-.11.029.23.23 0 0 1-.11-.029l-5.88-3.392a.22.22 0 0 1-.11-.19V4.606a.22.22 0 0 1 .11-.19l5.88-3.394a.2.2 0 0 1 .11-.03m0-.991a1.2 1.2 0 0 0-.607.163L1.607 3.556A1.21 1.21 0 0 0 1 4.606v6.788c0 .433.231.833.607 1.05l5.88 3.394a1.22 1.22 0 0 0 1.213 0l5.88-3.394c.376-.217.607-.617.607-1.05V4.606c0-.433-.231-.833-.607-1.05L8.7.163A1.2 1.2 0 0 0 8.092 0"
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                fill: "#213147",
                                d: "m4.203 13.944.541-1.482 1.089.905-1.018.93z"
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                                fill: "#fff",
                                d: "M7.597 4.12h-1.49a.265.265 0 0 0-.25.175L2.66 13.053l1.542.89L7.722 4.3a.132.132 0 0 0-.125-.179M10.206 4.12H8.715a.265.265 0 0 0-.25.175l-3.648 10 1.542.89L10.33 4.3a.133.133 0 0 0-.124-.179"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "arbitrum_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M1 0h14.184v16H1z"
                    })
                })
            })
        ]
    });
var $6e8b4c8f89314f65$export$2e2bcd8739ae039 = $6e8b4c8f89314f65$var$SvgArbitrum;



parcelRequire("9nZCP");
const $15a9fb1094c783e0$var$SvgEthereum = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fill: "#DAF0FF",
            d: "m12.446 8.15-4.722 2.9L3 8.15 7.724 0zm-4.722 3.831L3 9.081 7.724 16l4.725-6.919z"
        })
    });
var $15a9fb1094c783e0$export$2e2bcd8739ae039 = $15a9fb1094c783e0$var$SvgEthereum;



parcelRequire("9nZCP");
const $8aa9d8d182c68dea$var$SvgGnosis = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("g", {
                fill: "#00A6C4",
                clipPath: "url(#gnosis_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M4.703 9.11c.46 0 .908-.153 1.27-.433L3.059 5.76a2.083 2.083 0 0 0 .374 2.92c.366.276.811.43 1.27.43M13.376 7.028c0-.46-.154-.908-.434-1.271l-2.916 2.916a2.078 2.078 0 0 0 3.35-1.645"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "m14.845 3.854-1.29 1.29a2.939 2.939 0 0 1-4.138 4.138L8 10.7 6.587 9.286a2.94 2.94 0 0 1-4.138-4.138l-.662-.662-.628-.632A8 8 0 0 0 8 16a8 8 0 0 0 8-8 8 8 0 0 0-1.155-4.146"
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        d: "M13.787 2.479a7.996 7.996 0 0 0-12.135.654L8 9.484l6.348-6.351a8 8 0 0 0-.561-.654M8 1.047c1.87 0 3.611.721 4.92 2.037L8 8.004l-4.92-4.92A6.88 6.88 0 0 1 8 1.047"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "gnosis_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $8aa9d8d182c68dea$export$2e2bcd8739ae039 = $8aa9d8d182c68dea$var$SvgGnosis;


const $09cf9302bcaa1e97$export$65f4d498acfedc7c = [
    {
        ...(0, $6a02c0f0c34d6c61$export$21799e7ae6cc115),
        logo: (0, $6e8b4c8f89314f65$export$2e2bcd8739ae039)
    },
    {
        ...(0, $3819d1b9799f3613$export$31254237fd28c61a),
        logo: (0, $15a9fb1094c783e0$export$2e2bcd8739ae039)
    },
    {
        ...(0, $29073ff13918eb95$export$7a430fb03087826a),
        logo: (0, $8aa9d8d182c68dea$export$2e2bcd8739ae039)
    }
];
const $09cf9302bcaa1e97$export$f4608058c83a1dc2 = (id)=>$09cf9302bcaa1e97$export$65f4d498acfedc7c.find((chain)=>chain.id === id);
const $09cf9302bcaa1e97$export$4cc9423ec3f21f7c = [
    {
        id: 0,
        from: (0, $6a02c0f0c34d6c61$export$21799e7ae6cc115).id,
        to: (0, $3819d1b9799f3613$export$31254237fd28c61a).id,
        inboxAddress: (0, (/*@__PURE__*/$parcel$interopDefault($90e0f3a1bff47fae$exports))).address,
        inboxEndpoint: `https://api.studio.thegraph.com/query/${undefined}`,
        outboxAddress: (0, (/*@__PURE__*/$parcel$interopDefault($0e44798a3778a7db$exports))).address,
        outboxEndpoint: `https://api.studio.thegraph.com/query/${undefined}`
    },
    {
        id: 1,
        from: (0, $6a02c0f0c34d6c61$export$21799e7ae6cc115).id,
        to: (0, $29073ff13918eb95$export$7a430fb03087826a).id,
        inboxAddress: (0, (/*@__PURE__*/$parcel$interopDefault($e5ebe9d8b4c021eb$exports))).address,
        inboxEndpoint: `https://api.studio.thegraph.com/query/${undefined}`,
        outboxAddress: (0, (/*@__PURE__*/$parcel$interopDefault($4f9665f727a8e7dc$exports))).address,
        outboxEndpoint: `https://api.studio.thegraph.com/query/${undefined}`
    }
];
const $09cf9302bcaa1e97$export$f55bcf30472c04eb = (id)=>$09cf9302bcaa1e97$export$4cc9423ec3f21f7c.find((bridge)=>bridge.id === id);



const $62d48f2d8050b0a1$var$StyledDiv = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  width: auto;

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    width: 100%;
    word-wrap: break-word;
    margin-left: 2px;
  `)}

  .border {
    margin: 24px 0px;
    border: 1px solid ${({ theme: theme })=>theme.klerosUIComponentsStroke};
    height: 0px;
  }
`;
const $62d48f2d8050b0a1$var$InfoDiv = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    gap: 16px;
  `)}
  width: fit-content;
`;
const $62d48f2d8050b0a1$var$DataContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: grid;
  grid-row: 2;
  gap: 108px;
  width: fit-content;

  ${({ section: section })=>section === "Chain" ? (0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          display: flex;
          flex-direction: row;
          gap: 16px;
        `) : (0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          display: flex;
          flex-direction: column;
          gap: 4px;
        `)}
`;
const $62d48f2d8050b0a1$var$InfoText = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).small`
  grid-column-start: 1;
  display: inline-block;
  width: 12vw;
  gap: 4px;
  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    width: auto;
  `)}
  color: ${({ theme: theme })=>theme.color.smoke};
`;
const $62d48f2d8050b0a1$var$DataText = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).small`
  ${({ url: url })=>url ? (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          color: ${({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue} !important;
          text-decoration: none;
        ` : (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          color: ${({ theme: theme })=>theme.klerosUIComponentsPrimaryText};
        `}
`;
const $62d48f2d8050b0a1$var$ValueDiv = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    width: 100%;
    gap: 4px;
    word-break: break-all;
  `)}

  ${({ section: section })=>section === "Chain" ? (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          gap: 4px;
        ` : (0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
          gap: 9px;
        `}
`;
const $62d48f2d8050b0a1$var$Icon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).svg`
  width: 16px;
  height: 16px;
  fill: none;
  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)``)}
`;
const $62d48f2d8050b0a1$var$Header = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).label`
  margin: 36px 0px 24px;
  width: fit-content;
  display: block;
`;
const $62d48f2d8050b0a1$var$DataDiv = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  grid-column-start: 2;
  display: flex;
  flex-direction: column;
  width: auto;
  gap: 4px;
`;
const $62d48f2d8050b0a1$var$CopyableDiv = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 9px;
  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    display: block;
  `)}
`;
const $62d48f2d8050b0a1$var$TxCard = ({ title: title, chain: chain, txHash: txHash, timestamp: timestamp, caller: caller, extraFields: extraFields })=>{
    const chainObject = (0, $09cf9302bcaa1e97$export$f4608058c83a1dc2)(chain);
    const fields = [
        {
            key: "Chain",
            value: chainObject?.name,
            isCopy: false
        },
        {
            key: "Transaction ID",
            value: txHash,
            isCopy: true,
            url: `${chainObject?.blockExplorers?.default.url}/tx/${txHash}`
        },
        {
            key: "Timestamp",
            value: timestamp,
            isCopy: false
        },
        {
            key: "Caller",
            value: caller,
            isCopy: true,
            url: `${chainObject?.blockExplorers?.default.url}/address/${caller}`
        }
    ].concat(extraFields ?? []);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($62d48f2d8050b0a1$var$StyledDiv, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$var$Header, {
                children: title
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$var$InfoDiv, {
                children: fields.map((section, index)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($62d48f2d8050b0a1$var$DataContainer, {
                        section: section.key,
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$var$InfoText, {
                                children: section.key
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$var$DataDiv, {
                                children: section.key === "Chain" ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($62d48f2d8050b0a1$var$ValueDiv, {
                                    section: section.key,
                                    children: [
                                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$var$Icon, {
                                            as: chainObject?.logo
                                        }),
                                        /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$var$DataText, {
                                            children: section.value
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$var$ValueDiv, {
                                    section: section.key,
                                    children: section.url ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($62d48f2d8050b0a1$var$CopyableDiv, {
                                        children: [
                                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("a", {
                                                href: section.url,
                                                target: "_blank",
                                                style: {
                                                    textDecoration: "none"
                                                },
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$var$DataText, {
                                                    url: section.url,
                                                    children: section.value
                                                })
                                            }),
                                            " ",
                                            section.isCopy && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$export$4f2558dd25106ae2, {
                                                value: section.value
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($62d48f2d8050b0a1$var$CopyableDiv, {
                                        children: [
                                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($62d48f2d8050b0a1$var$DataText, {
                                                children: [
                                                    section.value,
                                                    " "
                                                ]
                                            }),
                                            section.isCopy && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$export$4f2558dd25106ae2, {
                                                value: section.value
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }, section.key))
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("hr", {
                className: "border"
            })
        ]
    });
};
const $62d48f2d8050b0a1$export$4f2558dd25106ae2 = ({ value: value })=>{
    const [_, copyToClipboard] = (0, $be80732420e01f0f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("button", {
        onClick: ()=>copyToClipboard(value),
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($62d48f2d8050b0a1$var$Icon, {
            as: (0, $52816e44f2501d69$export$2e2bcd8739ae039)
        })
    });
};
var $62d48f2d8050b0a1$export$2e2bcd8739ae039 = $62d48f2d8050b0a1$var$TxCard;



const $f5f6e6fed34aad3a$export$fc7b06d6a4abcacf = (timestamp)=>{
    timestamp = Number(timestamp);
    const date = new Date(timestamp * 1000);
    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    const year = date.getFullYear();
    const month = months[date.getMonth()];
    const day = date.getDate();
    const hour = date.getHours();
    const minute = "0" + date.getMinutes();
    const second = "0" + date.getSeconds();
    const formattedDate = `${month} ${day}, ${year} ${hour}:${minute.slice(-2)}:${second.slice(-2)} ${hour >= 12 ? "pm" : "am"}`;
    return formattedDate;
};


const $9fcd162faef4056c$var$messageStatusRoles = {
    Inboxed: "Sender",
    Relayed: "Relayer"
};
const $9fcd162faef4056c$var$Message = ({ messageInboxData: messageInboxData, messageOutboxData: messageOutboxData, bridgeId: bridgeId })=>{
    const [messageStatus, setMessageStatus] = (0, $9nZCP.useState)("");
    const bridgeInfo = (0, $09cf9302bcaa1e97$export$f55bcf30472c04eb)(bridgeId);
    (0, $9nZCP.useEffect)(()=>{
        calculateMessageStatus(messageOutboxData);
    }, [
        messageOutboxData
    ]);
    const calculateMessageStatus = (messageOutboxData)=>{
        if (!messageOutboxData) setMessageStatus("Inboxed");
        else setMessageStatus("Relayed");
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $ec842c1673aca056$export$2e2bcd8739ae039), {
                status: messageStatus,
                messageNumber: parseInt(messageInboxData?.id)
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $62d48f2d8050b0a1$export$2e2bcd8739ae039), {
                title: $9fcd162faef4056c$var$messageStatusRoles[messageStatus],
                chain: bridgeInfo?.from,
                txHash: messageInboxData?.txHash,
                timestamp: (0, $f5f6e6fed34aad3a$export$fc7b06d6a4abcacf)(messageInboxData?.timestamp),
                caller: messageInboxData?.from
            })
        ]
    }, messageInboxData?.id);
};
var $9fcd162faef4056c$export$2e2bcd8739ae039 = $9fcd162faef4056c$var$Message;





var $9nZCP = parcelRequire("9nZCP");
var $b0ae823c4f90987a$exports = {};
'use strict';

$b0ae823c4f90987a$exports = (parcelRequire("fbg6f"));



var $9nZCP = parcelRequire("9nZCP");
// Shared state between server components and client components
const $234c3b928832a7b5$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $234c3b928832a7b5$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $234c3b928832a7b5$export$8793edee2d425525();
const $234c3b928832a7b5$export$8b8a958a7f6f130c = Object;
const $234c3b928832a7b5$export$fce6876652108ab = (v)=>v === $234c3b928832a7b5$export$6db089fe7b26f5b6;
const $234c3b928832a7b5$export$f6e2535fb5126e54 = (v)=>typeof v == 'function';
const $234c3b928832a7b5$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $234c3b928832a7b5$export$ae936b9d47e5870e = (x)=>$234c3b928832a7b5$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $234c3b928832a7b5$var$table = new WeakMap();
// counter of the key
let $234c3b928832a7b5$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $234c3b928832a7b5$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($234c3b928832a7b5$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $234c3b928832a7b5$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$234c3b928832a7b5$var$counter + '~';
        $234c3b928832a7b5$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $234c3b928832a7b5$export$e9a4e06c7dfb0bd4(arg[index]) + ',';
            $234c3b928832a7b5$var$table.set(arg, result);
        }
        if (constructor == $234c3b928832a7b5$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = '#';
            const keys = $234c3b928832a7b5$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$234c3b928832a7b5$export$fce6876652108ab(index = keys.pop()))if (!$234c3b928832a7b5$export$fce6876652108ab(arg[index])) result += index + ':' + $234c3b928832a7b5$export$e9a4e06c7dfb0bd4(arg[index]) + ',';
            $234c3b928832a7b5$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $234c3b928832a7b5$export$b94ca9901c60634 = new WeakMap();
const $234c3b928832a7b5$var$EMPTY_CACHE = {};
const $234c3b928832a7b5$var$INITIAL_CACHE = {};
const $234c3b928832a7b5$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $234c3b928832a7b5$export$6e85fd745dc51282 = typeof window != $234c3b928832a7b5$var$STR_UNDEFINED;
const $234c3b928832a7b5$export$842dfe7a9f24298 = typeof document != $234c3b928832a7b5$var$STR_UNDEFINED;
const $234c3b928832a7b5$export$a9116928c9d15917 = ()=>$234c3b928832a7b5$export$6e85fd745dc51282 && typeof window['requestAnimationFrame'] != $234c3b928832a7b5$var$STR_UNDEFINED;
const $234c3b928832a7b5$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $234c3b928832a7b5$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$234c3b928832a7b5$export$fce6876652108ab(key) && cache.get(key) || $234c3b928832a7b5$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$234c3b928832a7b5$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $234c3b928832a7b5$var$INITIAL_CACHE)) $234c3b928832a7b5$var$INITIAL_CACHE[key] = prev;
                state[5](key, $234c3b928832a7b5$export$2321aea138b44780(prev, info), prev || $234c3b928832a7b5$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$234c3b928832a7b5$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $234c3b928832a7b5$var$INITIAL_CACHE) return $234c3b928832a7b5$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$234c3b928832a7b5$export$fce6876652108ab(key) && cache.get(key) || $234c3b928832a7b5$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $234c3b928832a7b5$var$online = true;
const $234c3b928832a7b5$var$isOnline = ()=>$234c3b928832a7b5$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$234c3b928832a7b5$var$onWindowEvent, $234c3b928832a7b5$var$offWindowEvent] = $234c3b928832a7b5$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $234c3b928832a7b5$export$8793edee2d425525,
    $234c3b928832a7b5$export$8793edee2d425525
];
const $234c3b928832a7b5$var$isVisible = ()=>{
    const visibilityState = $234c3b928832a7b5$export$842dfe7a9f24298 && document.visibilityState;
    return $234c3b928832a7b5$export$fce6876652108ab(visibilityState) || visibilityState !== 'hidden';
};
const $234c3b928832a7b5$var$initFocus = (callback)=>{
    // focus revalidate
    if ($234c3b928832a7b5$export$842dfe7a9f24298) document.addEventListener('visibilitychange', callback);
    $234c3b928832a7b5$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($234c3b928832a7b5$export$842dfe7a9f24298) document.removeEventListener('visibilitychange', callback);
        $234c3b928832a7b5$var$offWindowEvent('focus', callback);
    };
};
const $234c3b928832a7b5$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $234c3b928832a7b5$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $234c3b928832a7b5$var$online = false;
    };
    $234c3b928832a7b5$var$onWindowEvent('online', onOnline);
    $234c3b928832a7b5$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $234c3b928832a7b5$var$offWindowEvent('online', onOnline);
        $234c3b928832a7b5$var$offWindowEvent('offline', onOffline);
    };
};
const $234c3b928832a7b5$export$f5ab8217e0edff04 = {
    isOnline: $234c3b928832a7b5$var$isOnline,
    isVisible: $234c3b928832a7b5$var$isVisible
};
const $234c3b928832a7b5$export$b1857f3440a65373 = {
    initFocus: $234c3b928832a7b5$var$initFocus,
    initReconnect: $234c3b928832a7b5$var$initReconnect
};
const $234c3b928832a7b5$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).useId;
const $234c3b928832a7b5$export$d2f4d8e74279c212 = !$234c3b928832a7b5$export$6e85fd745dc51282 || 'Deno' in window;
// Polyfill requestAnimationFrame
const $234c3b928832a7b5$export$eba6076d3d7d0c06 = (f)=>$234c3b928832a7b5$export$a9116928c9d15917() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $234c3b928832a7b5$export$700979bc83e7db82 = $234c3b928832a7b5$export$d2f4d8e74279c212 ? (0, $9nZCP.useEffect) : (0, $9nZCP.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $234c3b928832a7b5$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $234c3b928832a7b5$export$3723beb60427dc52 = !$234c3b928832a7b5$export$d2f4d8e74279c212 && $234c3b928832a7b5$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($234c3b928832a7b5$var$navigatorConnection.effectiveType) || $234c3b928832a7b5$var$navigatorConnection.saveData);
const $234c3b928832a7b5$export$dfdc1655ccc5b9cb = (key)=>{
    if ($234c3b928832a7b5$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $234c3b928832a7b5$export$e9a4e06c7dfb0bd4(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $234c3b928832a7b5$var$__timestamp = 0;
const $234c3b928832a7b5$export$3c95c4c8b671ef0 = ()=>++$234c3b928832a7b5$var$__timestamp;
const $234c3b928832a7b5$var$FOCUS_EVENT = 0;
const $234c3b928832a7b5$var$RECONNECT_EVENT = 1;
const $234c3b928832a7b5$var$MUTATE_EVENT = 2;
const $234c3b928832a7b5$var$ERROR_REVALIDATE_EVENT = 3;
var $234c3b928832a7b5$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $234c3b928832a7b5$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $234c3b928832a7b5$var$FOCUS_EVENT,
    MUTATE_EVENT: $234c3b928832a7b5$var$MUTATE_EVENT,
    RECONNECT_EVENT: $234c3b928832a7b5$var$RECONNECT_EVENT
};
async function $234c3b928832a7b5$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $234c3b928832a7b5$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($234c3b928832a7b5$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $234c3b928832a7b5$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $234c3b928832a7b5$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $234c3b928832a7b5$export$b94ca9901c60634.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $234c3b928832a7b5$export$f6e2535fb5126e54(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($234c3b928832a7b5$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $234c3b928832a7b5$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$234c3b928832a7b5$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $234c3b928832a7b5$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $234c3b928832a7b5$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($234c3b928832a7b5$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $234c3b928832a7b5$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $234c3b928832a7b5$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($234c3b928832a7b5$export$f6e2535fb5126e54(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $234c3b928832a7b5$export$6db089fe7b26f5b6,
                        _c: $234c3b928832a7b5$export$6db089fe7b26f5b6
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $234c3b928832a7b5$export$6db089fe7b26f5b6,
                    _c: $234c3b928832a7b5$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $234c3b928832a7b5$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $234c3b928832a7b5$export$6db089fe7b26f5b6
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $234c3b928832a7b5$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $234c3b928832a7b5$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$234c3b928832a7b5$export$b94ca9901c60634.has(provider)) {
        const opts = $234c3b928832a7b5$export$2321aea138b44780($234c3b928832a7b5$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $234c3b928832a7b5$export$c9d44e5bea4509be.bind($234c3b928832a7b5$export$6db089fe7b26f5b6, provider);
        let unmount = $234c3b928832a7b5$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$234c3b928832a7b5$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $234c3b928832a7b5$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$234c3b928832a7b5$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($234c3b928832a7b5$export$6db089fe7b26f5b6, $234c3b928832a7b5$var$revalidateAllKeys.bind($234c3b928832a7b5$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $234c3b928832a7b5$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($234c3b928832a7b5$export$6db089fe7b26f5b6, $234c3b928832a7b5$var$revalidateAllKeys.bind($234c3b928832a7b5$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $234c3b928832a7b5$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $234c3b928832a7b5$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $234c3b928832a7b5$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $234c3b928832a7b5$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$234c3b928832a7b5$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $234c3b928832a7b5$export$398604a469f7de9a = (currentData, newData)=>$234c3b928832a7b5$export$e9a4e06c7dfb0bd4(currentData) == $234c3b928832a7b5$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$234c3b928832a7b5$export$69a3209f1a06c04d, $234c3b928832a7b5$export$57e795267c26e600] = $234c3b928832a7b5$export$4008f5b66f9e0b3c(new Map());
// Default config
const $234c3b928832a7b5$export$f84bd70098573c5c = $234c3b928832a7b5$export$2321aea138b44780({
    // events
    onLoadingSlow: $234c3b928832a7b5$export$8793edee2d425525,
    onSuccess: $234c3b928832a7b5$export$8793edee2d425525,
    onError: $234c3b928832a7b5$export$8793edee2d425525,
    onErrorRetry: $234c3b928832a7b5$var$onErrorRetry,
    onDiscarded: $234c3b928832a7b5$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $234c3b928832a7b5$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $234c3b928832a7b5$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $234c3b928832a7b5$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $234c3b928832a7b5$export$69a3209f1a06c04d,
    mutate: $234c3b928832a7b5$export$57e795267c26e600,
    fallback: {}
}, $234c3b928832a7b5$export$f5ab8217e0edff04);
const $234c3b928832a7b5$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $234c3b928832a7b5$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $234c3b928832a7b5$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $234c3b928832a7b5$var$SWRConfigContext = (0, $9nZCP.createContext)({});
const $234c3b928832a7b5$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $9nZCP.useContext)($234c3b928832a7b5$var$SWRConfigContext);
    const isFunctionalConfig = $234c3b928832a7b5$export$f6e2535fb5126e54(value);
    const config = (0, $9nZCP.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $9nZCP.useMemo)(()=>isFunctionalConfig ? config : $234c3b928832a7b5$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $9nZCP.useRef)($234c3b928832a7b5$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $234c3b928832a7b5$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $234c3b928832a7b5$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $234c3b928832a7b5$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $9nZCP.createElement)($234c3b928832a7b5$var$SWRConfigContext.Provider, $234c3b928832a7b5$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
const $234c3b928832a7b5$export$8667f065faedc62c = '$inf$';
// @ts-expect-error
const $234c3b928832a7b5$var$enableDevtools = $234c3b928832a7b5$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $234c3b928832a7b5$var$use = $234c3b928832a7b5$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $234c3b928832a7b5$var$setupDevTools = ()=>{
    if ($234c3b928832a7b5$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP)));
};
const $234c3b928832a7b5$export$a3295358bff77e = (args)=>{
    return $234c3b928832a7b5$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $234c3b928832a7b5$export$f1dc0e282d4c1c0 = ()=>{
    return $234c3b928832a7b5$export$2321aea138b44780($234c3b928832a7b5$export$f84bd70098573c5c, (0, $9nZCP.useContext)($234c3b928832a7b5$var$SWRConfigContext));
};
const $234c3b928832a7b5$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $234c3b928832a7b5$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $234c3b928832a7b5$export$b94ca9901c60634.get($234c3b928832a7b5$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $234c3b928832a7b5$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $234c3b928832a7b5$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $234c3b928832a7b5$export$b94ca9901c60634.get($234c3b928832a7b5$export$69a3209f1a06c04d);
            if (key.startsWith($234c3b928832a7b5$export$8667f065faedc62c)) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ($234c3b928832a7b5$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $234c3b928832a7b5$var$BUILT_IN_MIDDLEWARE = $234c3b928832a7b5$var$use.concat($234c3b928832a7b5$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $234c3b928832a7b5$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $234c3b928832a7b5$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $234c3b928832a7b5$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $234c3b928832a7b5$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($234c3b928832a7b5$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $234c3b928832a7b5$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $234c3b928832a7b5$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $234c3b928832a7b5$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$234c3b928832a7b5$var$setupDevTools();


const $41c5ca5e5d716b88$export$dbab534a48e651ef = (key)=>(0, $234c3b928832a7b5$export$dfdc1655ccc5b9cb)(key)[0];
/// <reference types="react/experimental" />
const $41c5ca5e5d716b88$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).use || ((promise)=>{
    if (promise.status === 'pending') throw promise;
    else if (promise.status === 'fulfilled') return promise.value;
    else if (promise.status === 'rejected') throw promise.reason;
    else {
        promise.status = 'pending';
        promise.then((v)=>{
            promise.status = 'fulfilled';
            promise.value = v;
        }, (e)=>{
            promise.status = 'rejected';
            promise.reason = e;
        });
        throw promise;
    }
});
const $41c5ca5e5d716b88$var$WITH_DEDUPE = {
    dedupe: true
};
const $41c5ca5e5d716b88$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $234c3b928832a7b5$export$b94ca9901c60634).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $234c3b928832a7b5$export$dfdc1655ccc5b9cb)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $9nZCP.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $9nZCP.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $9nZCP.useRef)(key);
    const fetcherRef = (0, $9nZCP.useRef)(fetcher);
    const configRef = (0, $9nZCP.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $234c3b928832a7b5$export$1251d51d9c571b45)(cache, key);
    const stateDependencies = (0, $9nZCP.useRef)({}).current;
    const fallback = (0, $234c3b928832a7b5$export$fce6876652108ab)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $234c3b928832a7b5$export$fce6876652108ab)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $9nZCP.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $234c3b928832a7b5$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $234c3b928832a7b5$export$fce6876652108ab)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $234c3b928832a7b5$export$2321aea138b44780)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $b0ae823c4f90987a$exports.useSyncExternalStore)((0, $9nZCP.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $234c3b928832a7b5$export$fce6876652108ab)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $9nZCP.useRef)(data);
    const returnedData = keepPreviousData ? (0, $234c3b928832a7b5$export$fce6876652108ab)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $234c3b928832a7b5$export$fce6876652108ab)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $234c3b928832a7b5$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $234c3b928832a7b5$export$fce6876652108ab)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $234c3b928832a7b5$export$fce6876652108ab)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $234c3b928832a7b5$export$fce6876652108ab)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $234c3b928832a7b5$export$fce6876652108ab)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $9nZCP.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $234c3b928832a7b5$export$ddb64fe6466374f7) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $234c3b928832a7b5$export$fce6876652108ab)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $234c3b928832a7b5$export$fce6876652108ab)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $234c3b928832a7b5$export$3c95c4c8b671ef0)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $234c3b928832a7b5$export$6db089fe7b26f5b6);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $234c3b928832a7b5$export$fce6876652108ab)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $234c3b928832a7b5$export$f6e2535fb5126e54)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $234c3b928832a7b5$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $9nZCP.useCallback)((...args)=>{
        return (0, $234c3b928832a7b5$export$c9d44e5bea4509be)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $234c3b928832a7b5$export$700979bc83e7db82)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $234c3b928832a7b5$export$fce6876652108ab)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $234c3b928832a7b5$export$700979bc83e7db82)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $234c3b928832a7b5$export$6db089fe7b26f5b6), $41c5ca5e5d716b88$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $234c3b928832a7b5$export$10213d6aa5ce32e6).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $234c3b928832a7b5$export$10213d6aa5ce32e6).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $234c3b928832a7b5$export$10213d6aa5ce32e6).MUTATE_EVENT) return revalidate();
            else if (type == (0, $234c3b928832a7b5$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $234c3b928832a7b5$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $234c3b928832a7b5$export$fce6876652108ab)(data) || (0, $234c3b928832a7b5$export$d2f4d8e74279c212)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $234c3b928832a7b5$export$eba6076d3d7d0c06)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $234c3b928832a7b5$export$700979bc83e7db82)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $234c3b928832a7b5$export$f6e2535fb5126e54)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($41c5ca5e5d716b88$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $9nZCP.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $234c3b928832a7b5$export$fce6876652108ab)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $234c3b928832a7b5$export$ddb64fe6466374f7) && (0, $234c3b928832a7b5$export$d2f4d8e74279c212)) throw new Error('Fallback data is required when using suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $234c3b928832a7b5$export$fce6876652108ab)(req)) {
            const promise = boundMutate(req);
            $41c5ca5e5d716b88$var$use(promise);
        }
        if ((0, $234c3b928832a7b5$export$fce6876652108ab)(error)) {
            const promise = revalidate($41c5ca5e5d716b88$var$WITH_DEDUPE);
            if (!(0, $234c3b928832a7b5$export$fce6876652108ab)(returnedData)) {
                promise.status = 'fulfilled';
                promise.value = true;
            }
            $41c5ca5e5d716b88$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $41c5ca5e5d716b88$export$4c7bbecdacc3ca2c = (0, $234c3b928832a7b5$export$8b8a958a7f6f130c).defineProperty((0, $234c3b928832a7b5$export$4c7bbecdacc3ca2c), 'defaultValue', {
    value: (0, $234c3b928832a7b5$export$f84bd70098573c5c)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $41c5ca5e5d716b88$export$2e2bcd8739ae039 = (0, $234c3b928832a7b5$export$84d44e54e14b0133)($41c5ca5e5d716b88$var$useSWRHandler);




const $8e73454a44a07c3f$export$b2a21208083dec7 = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query getMessages($skip: Int!, $snapshot: String!, $snapshotID: ID!) {
    messages(
      first: 5
      skip: $skip
      orderBy: timestamp
      orderDirection: desc
      where: { snapshot: $snapshot }
    ) {
      id
      txHash
      timestamp
      from
      to
      data
    }
    snapshot(id: $snapshotID) {
      numberMessages
    }
  }
`);



const $7a8013277b32324a$export$48d78797c81f126d = (0, $350dfc1de15a315a$export$1eb4e7c0ed67b035)(`
  query getRelay($id: ID!) {
    message(id: $id) {
      timestamp
      txHash
      relayer
      proof
    }
  }
`);


var $749779f5335cf90b$exports = {};
"use strict";
var $749779f5335cf90b$var$__createBinding = $749779f5335cf90b$exports && $749779f5335cf90b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $749779f5335cf90b$var$__setModuleDefault = $749779f5335cf90b$exports && $749779f5335cf90b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $749779f5335cf90b$var$__importStar = $749779f5335cf90b$exports && $749779f5335cf90b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $749779f5335cf90b$var$__createBinding(result, mod, k);
    }
    $749779f5335cf90b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($749779f5335cf90b$exports, "__esModule", {
    value: true
});
$749779f5335cf90b$exports.request = $749779f5335cf90b$exports.rawRequest = $749779f5335cf90b$exports.GraphQLClient = $749779f5335cf90b$exports.ClientError = $749779f5335cf90b$exports.batchRequests = $749779f5335cf90b$exports.resolveRequestDocument = $749779f5335cf90b$exports.GraphQLWebSocketClient = $749779f5335cf90b$exports.gql = void 0;
var $82d862471288a54b$exports = {};
"use strict";
Object.defineProperty($82d862471288a54b$exports, "__esModule", {
    value: true
});
$82d862471288a54b$exports.defaultJsonSerializer = void 0;
$82d862471288a54b$exports.defaultJsonSerializer = JSON;


var $5adad46b3f5b0a29$exports = {};
"use strict";
Object.defineProperty($5adad46b3f5b0a29$exports, "__esModule", {
    value: true
});
$5adad46b3f5b0a29$exports.HeadersInstanceToPlainObject = $5adad46b3f5b0a29$exports.uppercase = void 0;
const $5adad46b3f5b0a29$var$uppercase = (str)=>str.toUpperCase();
$5adad46b3f5b0a29$exports.uppercase = $5adad46b3f5b0a29$var$uppercase;
/**
 * Convert Headers instance into regular object
 */ const $5adad46b3f5b0a29$var$HeadersInstanceToPlainObject = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};
$5adad46b3f5b0a29$exports.HeadersInstanceToPlainObject = $5adad46b3f5b0a29$var$HeadersInstanceToPlainObject;


var $5daee54a55c14e05$exports = {};
"use strict";
Object.defineProperty($5daee54a55c14e05$exports, "__esModule", {
    value: true
});
$5daee54a55c14e05$exports.parseRawRequestExtendedArgs = $5daee54a55c14e05$exports.parseRequestExtendedArgs = $5daee54a55c14e05$exports.parseBatchRequestArgs = $5daee54a55c14e05$exports.parseRawRequestArgs = $5daee54a55c14e05$exports.parseRequestArgs = void 0;
const $5daee54a55c14e05$var$parseRequestArgs = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$5daee54a55c14e05$exports.parseRequestArgs = $5daee54a55c14e05$var$parseRequestArgs;
const $5daee54a55c14e05$var$parseRawRequestArgs = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$5daee54a55c14e05$exports.parseRawRequestArgs = $5daee54a55c14e05$var$parseRawRequestArgs;
const $5daee54a55c14e05$var$parseBatchRequestArgs = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$5daee54a55c14e05$exports.parseBatchRequestArgs = $5daee54a55c14e05$var$parseBatchRequestArgs;
const $5daee54a55c14e05$var$parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$5daee54a55c14e05$exports.parseRequestExtendedArgs = $5daee54a55c14e05$var$parseRequestExtendedArgs;
const $5daee54a55c14e05$var$parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$5daee54a55c14e05$exports.parseRawRequestExtendedArgs = $5daee54a55c14e05$var$parseRawRequestExtendedArgs;


var $28880f85c8a42137$exports = {};
"use strict";
Object.defineProperty($28880f85c8a42137$exports, "__esModule", {
    value: true
});
$28880f85c8a42137$exports.resolveRequestDocument = void 0;
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $1e2fef5e264bd00f$export$c10d0b04eaa80a43(value) {
    return typeof value == 'object' && value !== null;
}


function $15d0c7a69cd3af1f$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


const $9ab59479d005d1b6$var$LineRegExp = /\r\n|[\n\r]/g;
function $9ab59479d005d1b6$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($9ab59479d005d1b6$var$LineRegExp)){
        typeof match.index === 'number' || (0, $15d0c7a69cd3af1f$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $23f6c544316a2d5d$export$96a9681e539deed(location) {
    return $23f6c544316a2d5d$export$867940333fd9f869(location.source, (0, $9ab59479d005d1b6$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $23f6c544316a2d5d$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = ''.padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $23f6c544316a2d5d$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    '|',
                    subLine
                ]),
            [
                '|',
                '^'.padStart(subLineColumnNum)
            ],
            [
                '|',
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $23f6c544316a2d5d$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            '|',
            '^'.padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $23f6c544316a2d5d$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? ' ' + line : '')).join('\n');
}


function $3ed540063397e65b$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $3ed540063397e65b$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $3ed540063397e65b$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = 'GraphQLError';
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $3ed540063397e65b$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $3ed540063397e65b$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $9ab59479d005d1b6$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $9ab59479d005d1b6$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $1e2fef5e264bd00f$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $3ed540063397e65b$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return 'GraphQLError';
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += '\n\n' + (0, $23f6c544316a2d5d$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += '\n\n' + (0, $23f6c544316a2d5d$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $3ed540063397e65b$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $3ed540063397e65b$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $3ed540063397e65b$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $8ba58f28d15a114b$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $3ed540063397e65b$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $d9046b8c989e4522$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $d9046b8c989e4522$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $d9046b8c989e4522$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $d9046b8c989e4522$var$kindValues = new Set(Object.keys($d9046b8c989e4522$export$4fcd777a40ccf407));
function $d9046b8c989e4522$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $d9046b8c989e4522$var$kindValues.has(maybeKind);
}
/** Name */ var $d9046b8c989e4522$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($d9046b8c989e4522$export$f58c50edb4aef9d4 || ($d9046b8c989e4522$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed directive location values.
 */ var $f9d53977918cb7ab$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation['QUERY'] = 'QUERY';
    DirectiveLocation['MUTATION'] = 'MUTATION';
    DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
    DirectiveLocation['FIELD'] = 'FIELD';
    DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
    DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
    DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
    DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
    DirectiveLocation['SCHEMA'] = 'SCHEMA';
    DirectiveLocation['SCALAR'] = 'SCALAR';
    DirectiveLocation['OBJECT'] = 'OBJECT';
    DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
    DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
    DirectiveLocation['INTERFACE'] = 'INTERFACE';
    DirectiveLocation['UNION'] = 'UNION';
    DirectiveLocation['ENUM'] = 'ENUM';
    DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
    DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
    DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})($f9d53977918cb7ab$export$b45ffd2948484c41 || ($f9d53977918cb7ab$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 

/**
 * The set of allowed kind values for AST nodes.
 */ var $d60c070bf0c85158$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($d60c070bf0c85158$export$a84bdc57c5122798 || ($d60c070bf0c85158$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $ebe4940248925047$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $ebe4940248925047$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $ebe4940248925047$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $ebe4940248925047$export$45a677ea7cb6d5c8(code) {
    return $ebe4940248925047$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $ebe4940248925047$export$d3f406ff46035894(code) {
    return $ebe4940248925047$export$79c5d5217943d6a7(code) || $ebe4940248925047$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $4dcd914c56cc3651$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $4dcd914c56cc3651$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $4dcd914c56cc3651$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $ebe4940248925047$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $4dcd914c56cc3651$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $4dcd914c56cc3651$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $ebe4940248925047$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $ebe4940248925047$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $9a9b48308b55bec1$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind['SOF'] = '<SOF>';
    TokenKind['EOF'] = '<EOF>';
    TokenKind['BANG'] = '!';
    TokenKind['DOLLAR'] = '$';
    TokenKind['AMP'] = '&';
    TokenKind['PAREN_L'] = '(';
    TokenKind['PAREN_R'] = ')';
    TokenKind['SPREAD'] = '...';
    TokenKind['COLON'] = ':';
    TokenKind['EQUALS'] = '=';
    TokenKind['AT'] = '@';
    TokenKind['BRACKET_L'] = '[';
    TokenKind['BRACKET_R'] = ']';
    TokenKind['BRACE_L'] = '{';
    TokenKind['PIPE'] = '|';
    TokenKind['BRACE_R'] = '}';
    TokenKind['NAME'] = 'Name';
    TokenKind['INT'] = 'Int';
    TokenKind['FLOAT'] = 'Float';
    TokenKind['STRING'] = 'String';
    TokenKind['BLOCK_STRING'] = 'BlockString';
    TokenKind['COMMENT'] = 'Comment';
})($9a9b48308b55bec1$export$8b9d26ab11394711 || ($9a9b48308b55bec1$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $7c9a258a88804120$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $d9046b8c989e4522$export$50792b0e93539fde)((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return 'Lexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $7c9a258a88804120$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $7c9a258a88804120$export$59ac0f4da287406a(kind) {
    return kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BANG || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).DOLLAR || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).AMP || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_L || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_R || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).SPREAD || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EQUALS || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).AT || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_L || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_R || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PIPE || kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $7c9a258a88804120$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $7c9a258a88804120$var$isSupplementaryCodePoint(body, location) {
    return $7c9a258a88804120$var$isLeadingSurrogate(body.charCodeAt(location)) && $7c9a258a88804120$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $7c9a258a88804120$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $7c9a258a88804120$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $7c9a258a88804120$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */ function $7c9a258a88804120$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $d9046b8c989e4522$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $7c9a258a88804120$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $7c9a258a88804120$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $7c9a258a88804120$var$readBlockString(lexer, position);
                return $7c9a258a88804120$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $ebe4940248925047$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $7c9a258a88804120$var$readNumber(lexer, position, code);
         // Name
        if ((0, $ebe4940248925047$export$45a677ea7cb6d5c8)(code)) return $7c9a258a88804120$var$readName(lexer, position);
        throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?' : $7c9a258a88804120$var$isUnicodeScalarValue(code) || $7c9a258a88804120$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.`);
    }
    return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $7c9a258a88804120$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($7c9a258a88804120$var$isUnicodeScalarValue(code)) ++position;
        else if ($7c9a258a88804120$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $7c9a258a88804120$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $ebe4940248925047$export$727d9dbc4fbb948f)(code)) throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $7c9a258a88804120$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $7c9a258a88804120$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $7c9a258a88804120$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $ebe4940248925047$export$45a677ea7cb6d5c8)(code)) throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.`);
    return $7c9a258a88804120$var$createToken(lexer, isFloat ? (0, $9a9b48308b55bec1$export$8b9d26ab11394711).FLOAT : (0, $9a9b48308b55bec1$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $7c9a258a88804120$var$readDigits(lexer, start, firstCode) {
    if (!(0, $ebe4940248925047$export$727d9dbc4fbb948f)(firstCode)) throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$7c9a258a88804120$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $ebe4940248925047$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $7c9a258a88804120$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = '';
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $7c9a258a88804120$var$readEscapedUnicodeVariableWidth(lexer, position) : $7c9a258a88804120$var$readEscapedUnicodeFixedWidth(lexer, position) : $7c9a258a88804120$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($7c9a258a88804120$var$isUnicodeScalarValue(code)) ++position;
        else if ($7c9a258a88804120$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.
function $7c9a258a88804120$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$7c9a258a88804120$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $7c9a258a88804120$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $7c9a258a88804120$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $7c9a258a88804120$var$read16BitHexCode(body, position + 2);
    if ($7c9a258a88804120$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($7c9a258a88804120$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $7c9a258a88804120$var$read16BitHexCode(body, position + 8);
            if ($7c9a258a88804120$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $7c9a258a88804120$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $7c9a258a88804120$var$readHexDigit(body.charCodeAt(position)) << 12 | $7c9a258a88804120$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $7c9a258a88804120$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $7c9a258a88804120$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $7c9a258a88804120$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $7c9a258a88804120$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '\u0022',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: '\u005c',
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: '\u002f',
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: '\u0008',
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: '\u000c',
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: '\u000a',
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: '\u000d',
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: '\u0009',
                size: 2
            };
    }
    throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $7c9a258a88804120$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = '';
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $4dcd914c56cc3651$export$d5ee19b441e8d2ae)(blockLines).join('\n'));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = '';
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($7c9a258a88804120$var$isUnicodeScalarValue(code)) ++position;
        else if ($7c9a258a88804120$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$7c9a258a88804120$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $7c9a258a88804120$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $ebe4940248925047$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $7c9a258a88804120$var$createToken(lexer, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}


function $689afe97a6658f18$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $5a5c92f504a86580$var$MAX_ARRAY_LENGTH = 10;
const $5a5c92f504a86580$var$MAX_RECURSIVE_DEPTH = 2;
function $5a5c92f504a86580$export$9dec5d1b3b6a130d(value) {
    return $5a5c92f504a86580$var$formatValue(value, []);
}
function $5a5c92f504a86580$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $5a5c92f504a86580$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $5a5c92f504a86580$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($5a5c92f504a86580$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $5a5c92f504a86580$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $5a5c92f504a86580$var$formatArray(value, seenValues);
    return $5a5c92f504a86580$var$formatObject(value, seenValues);
}
function $5a5c92f504a86580$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $5a5c92f504a86580$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $5a5c92f504a86580$var$MAX_RECURSIVE_DEPTH) return '[' + $5a5c92f504a86580$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $5a5c92f504a86580$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $5a5c92f504a86580$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $5a5c92f504a86580$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($5a5c92f504a86580$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($5a5c92f504a86580$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $5a5c92f504a86580$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}



/* c8 ignore next 3 */ const $f3806e602269e159$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $f3806e602269e159$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$f3806e602269e159$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === 'object' && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $5a5c92f504a86580$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $606ad5282415c685$export$1d2df86270c81ecb {
    constructor(body, name = 'GraphQL request', locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === 'string' || (0, $689afe97a6658f18$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $5a5c92f504a86580$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $689afe97a6658f18$export$b6cb5906f04696c8)(false, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $689afe97a6658f18$export$b6cb5906f04696c8)(false, 'column in locationOffset is 1-indexed and must be positive.');
    }
    get [Symbol.toStringTag]() {
        return 'Source';
    }
}
function $606ad5282415c685$export$75135ee9ed6e435b(source) {
    return (0, $f3806e602269e159$export$ca03416d6c9e029e)(source, $606ad5282415c685$export$1d2df86270c81ecb);
}



function $b37fb2fe3b4f0cfc$export$98e6a39c04603d36(source, options) {
    const parser = new $b37fb2fe3b4f0cfc$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $b37fb2fe3b4f0cfc$export$5303528d1070ff6f(source, options) {
    const parser = new $b37fb2fe3b4f0cfc$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF);
    return value;
}
function $b37fb2fe3b4f0cfc$export$e14c466bd0916f7a(source, options) {
    const parser = new $b37fb2fe3b4f0cfc$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF);
    return value;
}
function $b37fb2fe3b4f0cfc$export$28b8f402ccc88182(source, options) {
    const parser = new $b37fb2fe3b4f0cfc$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF);
    return type;
}
class $b37fb2fe3b4f0cfc$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $606ad5282415c685$export$75135ee9ed6e435b)(source) ? source : new (0, $606ad5282415c685$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $7c9a258a88804120$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, descriptions are supported only on type definitions.');
            switch(keywordToken.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $d9046b8c989e4522$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return (0, $d9046b8c989e4522$export$f58c50edb4aef9d4).QUERY;
            case 'mutation':
                return (0, $d9046b8c989e4522$export$f58c50edb4aef9d4).MUTATION;
            case 'subscription':
                return (0, $d9046b8c989e4522$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_L, item, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).STRING:
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case 'true':
                        return this.node(token, {
                            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case 'false':
                        return this.node(token, {
                            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case 'null':
                        return this.node(token, {
                            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $9a9b48308b55bec1$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).LIST,
            values: this.any((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_L, item, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, item, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).STRING) || this.peek((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword('implements') ? this.delimitedMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === 'true' || this._lexer.token.value === 'false' || this._lexer.token.value === 'null') throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$b37fb2fe3b4f0cfc$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $9a9b48308b55bec1$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $9a9b48308b55bec1$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $d60c070bf0c85158$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $9a9b48308b55bec1$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $f9d53977918cb7ab$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $d9046b8c989e4522$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$b37fb2fe3b4f0cfc$var$getTokenKindDesc(kind)}, found ${$b37fb2fe3b4f0cfc$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$b37fb2fe3b4f0cfc$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $9a9b48308b55bec1$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$b37fb2fe3b4f0cfc$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $9a9b48308b55bec1$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $8ba58f28d15a114b$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $b37fb2fe3b4f0cfc$var$getTokenDesc(token) {
    const value = token.value;
    return $b37fb2fe3b4f0cfc$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $b37fb2fe3b4f0cfc$var$getTokenKindDesc(kind) {
    return (0, $7c9a258a88804120$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $1c10e15c8a3a4a77$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($1c10e15c8a3a4a77$var$escapedRegExp, $1c10e15c8a3a4a77$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $1c10e15c8a3a4a77$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $1c10e15c8a3a4a77$var$escapedReplacer(str) {
    return $1c10e15c8a3a4a77$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $1c10e15c8a3a4a77$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];






const $059788b5609f37ed$export$a89c95c098ac2a58 = Object.freeze({});
function $059788b5609f37ed$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $d9046b8c989e4522$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $d60c070bf0c85158$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $059788b5609f37ed$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $d9046b8c989e4522$export$8ee0fc9ee280b4ee)(node) || (0, $689afe97a6658f18$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $5a5c92f504a86580$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $059788b5609f37ed$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $d9046b8c989e4522$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $059788b5609f37ed$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $d60c070bf0c85158$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $059788b5609f37ed$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $059788b5609f37ed$export$a89c95c098ac2a58) skipping[i] = $059788b5609f37ed$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $059788b5609f37ed$export$a89c95c098ac2a58) skipping[i] = $059788b5609f37ed$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $059788b5609f37ed$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $059788b5609f37ed$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $059788b5609f37ed$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $51a1e65338c15420$export$c2d084dc44961371(ast) {
    return (0, $059788b5609f37ed$export$bf638b60ea8b89b7)(ast, $51a1e65338c15420$var$printDocASTReducer);
}
const $51a1e65338c15420$var$MAX_LINE_LENGTH = 80;
const $51a1e65338c15420$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$51a1e65338c15420$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $51a1e65338c15420$var$wrap('(', $51a1e65338c15420$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $51a1e65338c15420$var$join([
                node.operation,
                $51a1e65338c15420$var$join([
                    node.name,
                    varDefs
                ]),
                $51a1e65338c15420$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $51a1e65338c15420$var$wrap(' = ', defaultValue) + $51a1e65338c15420$var$wrap(' ', $51a1e65338c15420$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$51a1e65338c15420$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $51a1e65338c15420$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $51a1e65338c15420$var$wrap('(', $51a1e65338c15420$var$join(args, ', '), ')');
            if (argsLine.length > $51a1e65338c15420$var$MAX_LINE_LENGTH) argsLine = prefix + $51a1e65338c15420$var$wrap('(\n', $51a1e65338c15420$var$indent($51a1e65338c15420$var$join(args, '\n')), '\n)');
            return $51a1e65338c15420$var$join([
                argsLine,
                $51a1e65338c15420$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $51a1e65338c15420$var$wrap(' ', $51a1e65338c15420$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$51a1e65338c15420$var$join([
                '...',
                $51a1e65338c15420$var$wrap('on ', typeCondition),
                $51a1e65338c15420$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$51a1e65338c15420$var$wrap('(', $51a1e65338c15420$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$51a1e65338c15420$var$wrap('', $51a1e65338c15420$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $4dcd914c56cc3651$export$adb6ca997eeb1f45)(value) : (0, $1c10e15c8a3a4a77$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $51a1e65338c15420$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $51a1e65338c15420$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $51a1e65338c15420$var$wrap('(', $51a1e65338c15420$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$51a1e65338c15420$var$wrap('', description, '\n') + $51a1e65338c15420$var$join([
                'schema',
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$51a1e65338c15420$var$wrap('', description, '\n') + $51a1e65338c15420$var$join([
                'scalar',
                name,
                $51a1e65338c15420$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$51a1e65338c15420$var$wrap('', description, '\n') + $51a1e65338c15420$var$join([
                'type',
                name,
                $51a1e65338c15420$var$wrap('implements ', $51a1e65338c15420$var$join(interfaces, ' & ')),
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$51a1e65338c15420$var$wrap('', description, '\n') + name + ($51a1e65338c15420$var$hasMultilineItems(args) ? $51a1e65338c15420$var$wrap('(\n', $51a1e65338c15420$var$indent($51a1e65338c15420$var$join(args, '\n')), '\n)') : $51a1e65338c15420$var$wrap('(', $51a1e65338c15420$var$join(args, ', '), ')')) + ': ' + type + $51a1e65338c15420$var$wrap(' ', $51a1e65338c15420$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$51a1e65338c15420$var$wrap('', description, '\n') + $51a1e65338c15420$var$join([
                name + ': ' + type,
                $51a1e65338c15420$var$wrap('= ', defaultValue),
                $51a1e65338c15420$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$51a1e65338c15420$var$wrap('', description, '\n') + $51a1e65338c15420$var$join([
                'interface',
                name,
                $51a1e65338c15420$var$wrap('implements ', $51a1e65338c15420$var$join(interfaces, ' & ')),
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$51a1e65338c15420$var$wrap('', description, '\n') + $51a1e65338c15420$var$join([
                'union',
                name,
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$wrap('= ', $51a1e65338c15420$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$51a1e65338c15420$var$wrap('', description, '\n') + $51a1e65338c15420$var$join([
                'enum',
                name,
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$51a1e65338c15420$var$wrap('', description, '\n') + $51a1e65338c15420$var$join([
                name,
                $51a1e65338c15420$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$51a1e65338c15420$var$wrap('', description, '\n') + $51a1e65338c15420$var$join([
                'input',
                name,
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$51a1e65338c15420$var$wrap('', description, '\n') + 'directive @' + name + ($51a1e65338c15420$var$hasMultilineItems(args) ? $51a1e65338c15420$var$wrap('(\n', $51a1e65338c15420$var$indent($51a1e65338c15420$var$join(args, '\n')), '\n)') : $51a1e65338c15420$var$wrap('(', $51a1e65338c15420$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $51a1e65338c15420$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$51a1e65338c15420$var$join([
                'extend schema',
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$51a1e65338c15420$var$join([
                'extend scalar',
                name,
                $51a1e65338c15420$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$51a1e65338c15420$var$join([
                'extend type',
                name,
                $51a1e65338c15420$var$wrap('implements ', $51a1e65338c15420$var$join(interfaces, ' & ')),
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$51a1e65338c15420$var$join([
                'extend interface',
                name,
                $51a1e65338c15420$var$wrap('implements ', $51a1e65338c15420$var$join(interfaces, ' & ')),
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$51a1e65338c15420$var$join([
                'extend union',
                name,
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$wrap('= ', $51a1e65338c15420$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$51a1e65338c15420$var$join([
                'extend enum',
                name,
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$51a1e65338c15420$var$join([
                'extend input',
                name,
                $51a1e65338c15420$var$join(directives, ' '),
                $51a1e65338c15420$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $51a1e65338c15420$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $51a1e65338c15420$var$block(array) {
    return $51a1e65338c15420$var$wrap('{\n', $51a1e65338c15420$var$indent($51a1e65338c15420$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $51a1e65338c15420$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $51a1e65338c15420$var$indent(str) {
    return $51a1e65338c15420$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $51a1e65338c15420$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


/**
 * helpers
 */ const $28880f85c8a42137$var$extractOperationName = (document)=>{
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = operationDefinitions[0]?.name?.value;
    return operationName;
};
const $28880f85c8a42137$var$resolveRequestDocument = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $b37fb2fe3b4f0cfc$export$98e6a39c04603d36)(document);
            operationName = $28880f85c8a42137$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $28880f85c8a42137$var$extractOperationName(document);
    return {
        query: (0, $51a1e65338c15420$export$c2d084dc44961371)(document),
        operationName: operationName
    };
};
$28880f85c8a42137$exports.resolveRequestDocument = $28880f85c8a42137$var$resolveRequestDocument;


var $5d0956dd4df4ae1f$exports = {};
"use strict";
Object.defineProperty($5d0956dd4df4ae1f$exports, "__esModule", {
    value: true
});
$5d0956dd4df4ae1f$exports.ClientError = void 0;
class $5d0956dd4df4ae1f$var$ClientError extends Error {
    constructor(response, request){
        const message = `${$5d0956dd4df4ae1f$var$ClientError.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $5d0956dd4df4ae1f$var$ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $5d0956dd4df4ae1f$var$ClientError);
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
$5d0956dd4df4ae1f$exports.ClientError = $5d0956dd4df4ae1f$var$ClientError;


Object.defineProperty($749779f5335cf90b$exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $5d0956dd4df4ae1f$exports.ClientError;
    }
});

const $749779f5335cf90b$var$cross_fetch_1 = $749779f5335cf90b$var$__importStar((parcelRequire("a141p"))), $749779f5335cf90b$var$CrossFetch = $749779f5335cf90b$var$cross_fetch_1;
/**
 * Convert the given headers configuration into a plain object.
 */ const $749779f5335cf90b$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $749779f5335cf90b$var$CrossFetch && $749779f5335cf90b$var$CrossFetch.Headers && headers instanceof $749779f5335cf90b$var$CrossFetch.Headers) oHeaders = (0, $5adad46b3f5b0a29$exports.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $749779f5335cf90b$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $749779f5335cf90b$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($749779f5335cf90b$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $749779f5335cf90b$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $749779f5335cf90b$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = {
            ...params.headers
        };
        let queryParams = ``;
        let body = undefined;
        if (method === `POST`) {
            body = $749779f5335cf90b$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $749779f5335cf90b$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? $82d862471288a54b$exports.defaultJsonSerializer
        });
        const init = {
            method: method,
            headers: headers,
            body: body,
            ...fetchOptions
        };
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware({
                ...init,
                url: url,
                operationName: operationName,
                variables: variables
            }));
            const { url: urlNew, ...initNew } = result;
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $749779f5335cf90b$var$GraphQLClient {
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $5daee54a55c14e05$exports.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers: headers, fetch: fetch = $749779f5335cf90b$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $28880f85c8a42137$exports.resolveRequestDocument)(rawRequestOptions.query);
            return $749779f5335cf90b$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...$749779f5335cf90b$var$resolveHeaders($749779f5335cf90b$var$callOrIdentity(headers)),
                    ...$749779f5335cf90b$var$resolveHeaders(rawRequestOptions.requestHeaders)
                },
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $5daee54a55c14e05$exports.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers: headers, fetch: fetch = $749779f5335cf90b$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $28880f85c8a42137$exports.resolveRequestDocument)(requestOptions.document);
        return $749779f5335cf90b$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: {
                ...$749779f5335cf90b$var$resolveHeaders($749779f5335cf90b$var$callOrIdentity(headers)),
                ...$749779f5335cf90b$var$resolveHeaders(requestOptions.requestHeaders)
            },
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $5daee54a55c14e05$exports.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers: headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $28880f85c8a42137$exports.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        return $749779f5335cf90b$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...$749779f5335cf90b$var$resolveHeaders($749779f5335cf90b$var$callOrIdentity(headers)),
                ...$749779f5335cf90b$var$resolveHeaders(batchRequestOptions.requestHeaders)
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? $749779f5335cf90b$var$cross_fetch_1.default,
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
}
$749779f5335cf90b$exports.GraphQLClient = $749779f5335cf90b$var$GraphQLClient;
const $749779f5335cf90b$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    const fetcher = $749779f5335cf90b$var$createHttpMethodFetcher((0, $5adad46b3f5b0a29$exports.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await $749779f5335cf90b$var$getResult(response, fetchOptions.jsonSerializer ?? $82d862471288a54b$exports.defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status
        };
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new $5d0956dd4df4ae1f$exports.ClientError(// @ts-expect-error TODO
        {
            ...errorResult,
            status: response.status,
            headers: response.headers
        }, {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $749779f5335cf90b$var$rawRequest = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $5daee54a55c14e05$exports.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $749779f5335cf90b$var$GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions
    });
};
$749779f5335cf90b$exports.rawRequest = $749779f5335cf90b$var$rawRequest;
// prettier-ignore
// eslint-disable-next-line
async function $749779f5335cf90b$var$request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $5daee54a55c14e05$exports.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $749779f5335cf90b$var$GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions
    });
}
$749779f5335cf90b$exports.request = $749779f5335cf90b$var$request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $749779f5335cf90b$var$batchRequests = async (...args)=>{
    const params = $749779f5335cf90b$var$parseBatchRequestsArgsExtended(args);
    const client = new $749779f5335cf90b$var$GraphQLClient(params.url);
    return client.batchRequests(params);
};
$749779f5335cf90b$exports.batchRequests = $749779f5335cf90b$var$batchRequests;
const $749779f5335cf90b$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $749779f5335cf90b$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer ?? $82d862471288a54b$exports.defaultJsonSerializer;
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $749779f5335cf90b$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $749779f5335cf90b$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ const $749779f5335cf90b$var$gql = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
$749779f5335cf90b$exports.gql = $749779f5335cf90b$var$gql;
var $b76a6b00e0fbcee9$exports = {};
"use strict";
Object.defineProperty($b76a6b00e0fbcee9$exports, "__esModule", {
    value: true
});
$b76a6b00e0fbcee9$exports.GraphQLWebSocketClient = void 0;


// import type WebSocket from 'ws'
const $b76a6b00e0fbcee9$var$CONNECTION_INIT = `connection_init`;
const $b76a6b00e0fbcee9$var$CONNECTION_ACK = `connection_ack`;
const $b76a6b00e0fbcee9$var$PING = `ping`;
const $b76a6b00e0fbcee9$var$PONG = `pong`;
const $b76a6b00e0fbcee9$var$SUBSCRIBE = `subscribe`;
const $b76a6b00e0fbcee9$var$NEXT = `next`;
const $b76a6b00e0fbcee9$var$ERROR = `error`;
const $b76a6b00e0fbcee9$var$COMPLETE = `complete`;
class $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class $b76a6b00e0fbcee9$var$GraphQLWebSocketClient {
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($b76a6b00e0fbcee9$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $b76a6b00e0fbcee9$var$parseMessage(e.data);
                switch(message.type){
                    case $b76a6b00e0fbcee9$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $b76a6b00e0fbcee9$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($b76a6b00e0fbcee9$var$Pong(r).text));
                        else socket.send($b76a6b00e0fbcee9$var$Pong(null).text);
                        return;
                    case $b76a6b00e0fbcee9$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $b76a6b00e0fbcee9$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new $5d0956dd4df4ae1f$exports.ClientError({
                            ...message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b76a6b00e0fbcee9$var$ERROR:
                        subscriber.error && subscriber.error(new $5d0956dd4df4ae1f$exports.ClientError({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b76a6b00e0fbcee9$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($b76a6b00e0fbcee9$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($b76a6b00e0fbcee9$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $28880f85c8a42137$exports.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($b76a6b00e0fbcee9$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
$b76a6b00e0fbcee9$var$GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
$b76a6b00e0fbcee9$exports.GraphQLWebSocketClient = $b76a6b00e0fbcee9$var$GraphQLWebSocketClient;
// Helper functions
function $b76a6b00e0fbcee9$var$parseMessage(data, f = (a)=>a) {
    const m = $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $b76a6b00e0fbcee9$var$ConnectionInit(payload) {
    return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage($b76a6b00e0fbcee9$var$CONNECTION_INIT, payload);
}
function $b76a6b00e0fbcee9$var$Ping(payload) {
    return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage($b76a6b00e0fbcee9$var$PING, payload, undefined);
}
function $b76a6b00e0fbcee9$var$Pong(payload) {
    return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage($b76a6b00e0fbcee9$var$PONG, payload, undefined);
}
function $b76a6b00e0fbcee9$var$Subscribe(id, payload) {
    return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage($b76a6b00e0fbcee9$var$SUBSCRIBE, payload, id);
}
function $b76a6b00e0fbcee9$var$Complete(id) {
    return new $b76a6b00e0fbcee9$var$GraphQLWebSocketMessage($b76a6b00e0fbcee9$var$COMPLETE, undefined, id);
}


Object.defineProperty($749779f5335cf90b$exports, "GraphQLWebSocketClient", {
    enumerable: true,
    get: function() {
        return $b76a6b00e0fbcee9$exports.GraphQLWebSocketClient;
    }
});

Object.defineProperty($749779f5335cf90b$exports, "resolveRequestDocument", {
    enumerable: true,
    get: function() {
        return $28880f85c8a42137$exports.resolveRequestDocument;
    }
});
$749779f5335cf90b$exports.default = $749779f5335cf90b$var$request;


const $a87bb715d9ada524$export$4d17e2d9c5348842 = (snapshot, bridgeId, skip, getRelays)=>{
    return (0, $41c5ca5e5d716b88$export$2e2bcd8739ae039)(`${snapshot}-${bridgeId}-${skip}-${getRelays}`, async ()=>{
        const { inboxEndpoint: inboxEndpoint, outboxEndpoint: outboxEndpoint } = (0, $09cf9302bcaa1e97$export$4cc9423ec3f21f7c)[bridgeId];
        const [messages, totalMessages] = await (0, $749779f5335cf90b$exports.request)(inboxEndpoint, (0, $8e73454a44a07c3f$export$b2a21208083dec7), {
            skip: skip,
            snapshot: snapshot,
            snapshotID: snapshot
        }).then((result)=>[
                result.messages,
                result.snapshot?.numberMessages
            ]);
        return {
            messages: await Promise.all(messages.map(async (message)=>{
                return [
                    message,
                    getRelays ? await (0, $749779f5335cf90b$exports.request)(outboxEndpoint, (0, $7a8013277b32324a$export$48d78797c81f126d), {
                        id: message.id
                    }).then((result)=>result.message) : null
                ];
            })),
            totalMessages: totalMessages
        };
    });
};


const $77da61817b09e6da$var$MESSAGES_PER_PAGE = 5;
const $77da61817b09e6da$var$PaginationContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  margin: 24px 12px;
`;
const $77da61817b09e6da$var$DisplayMessages = ({ snapshotId: snapshotId, bridgeId: bridgeId })=>{
    const [currentPage, setCurrentPage] = (0, $9nZCP.useState)(1);
    const { data: data } = (0, $a87bb715d9ada524$export$4d17e2d9c5348842)(snapshotId, bridgeId, (currentPage - 1) * $77da61817b09e6da$var$MESSAGES_PER_PAGE, false);
    const totalMessages = parseInt(data?.totalMessages);
    const pageCount = Math.ceil(totalMessages / $77da61817b09e6da$var$MESSAGES_PER_PAGE);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($77da61817b09e6da$var$PaginationContainer, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("small", {
                        children: [
                            "Page ",
                            currentPage
                        ]
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.CompactPagination), {
                        currentPage: currentPage,
                        callback: setCurrentPage,
                        numPages: pageCount ? pageCount : currentPage
                    })
                ]
            }),
            data?.messages.map(([messageInboxData, messageOutboxData])=>{
                return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $9fcd162faef4056c$export$2e2bcd8739ae039), {
                    messageInboxData: messageInboxData,
                    messageOutboxData: messageOutboxData,
                    bridgeId: bridgeId
                }, messageInboxData?.id);
            })
        ]
    });
};
var $77da61817b09e6da$export$2e2bcd8739ae039 = $77da61817b09e6da$var$DisplayMessages;



parcelRequire("9nZCP");

const $3bfd3f4af444c518$var$SnapshotDetails = ({ transactions: transactions })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $dde41420777b5d34$exports.Fragment), {
        children: Object.values(transactions).map((txInfo)=>txInfo && /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $62d48f2d8050b0a1$export$2e2bcd8739ae039), {
                ...txInfo
            }, txInfo.title))
    });
};
var $3bfd3f4af444c518$export$2e2bcd8739ae039 = $3bfd3f4af444c518$var$SnapshotDetails;


const $c153625b6a77c81d$var$StyledSnapshotDetailsButton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Button))`
  background-color: ${({ theme: theme })=>theme.color.midnightPurple};
  width: 141px;
  height: 31px;
  text-align: center;
  p {
    color: ${({ theme: theme })=>theme.color.blue} !important;
    font-size: 14px !important;
    line-height: 17.5px !important;
    font-weight: normal !important;
  }
  :hover {
    background-color: ${({ theme: theme })=>theme.color.midnightPurple};
  }
  border-radius: 300px;
  border: ${({ theme: theme, snapshotDetailsVisible: snapshotDetailsVisible })=>snapshotDetailsVisible ? "1px solid " + theme.color.blue : "none"};
`;
const $c153625b6a77c81d$var$StyledNewMessagesButton = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.Button))`
  background-color: ${({ theme: theme })=>theme.color.midnightPurple};
  width: 130px;
  height: 31px;
  text-align: center;
  p {
    color: ${({ theme: theme })=>theme.color.blue} !important;
    font-size: 14px !important;
    line-height: 17.5px !important;
    font-weight: normal !important;
  }

  :hover {
    background-color: ${({ theme: theme })=>theme.color.midnightPurple};
  }

  margin-left: 8px;
  border-radius: 300px;
  border: ${({ theme: theme, snapshotDetailsVisible: snapshotDetailsVisible })=>!snapshotDetailsVisible ? "1px solid " + theme.color.blue : "none"};
`;
const $c153625b6a77c81d$var$StyledButtonsContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  padding-bottom: 12px;
`;
const $c153625b6a77c81d$var$AccordionBody = ({ bridgeId: bridgeId, snapshotId: snapshotId, transactions: transactions })=>{
    const [snapshotDetailsVisible, setSnapshotDetailsVisible] = (0, $9nZCP.useState)(true);
    const handleClickSnapshotDetails = ()=>{
        setSnapshotDetailsVisible(true);
    };
    const handleClickNewMessages = ()=>{
        setSnapshotDetailsVisible(false);
    };
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($c153625b6a77c81d$var$StyledButtonsContainer, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($c153625b6a77c81d$var$StyledSnapshotDetailsButton, {
                        text: "Snapshot Details",
                        snapshotDetailsVisible: snapshotDetailsVisible,
                        onClick: handleClickSnapshotDetails
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($c153625b6a77c81d$var$StyledNewMessagesButton, {
                        text: "New Messages",
                        snapshotDetailsVisible: snapshotDetailsVisible,
                        onClick: handleClickNewMessages
                    })
                ]
            }),
            snapshotDetailsVisible ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $3bfd3f4af444c518$export$2e2bcd8739ae039), {
                transactions: transactions
            }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $77da61817b09e6da$export$2e2bcd8739ae039), {
                snapshotId: snapshotId,
                bridgeId: bridgeId
            })
        ]
    });
};
var $c153625b6a77c81d$export$2e2bcd8739ae039 = $c153625b6a77c81d$var$AccordionBody;



parcelRequire("9nZCP");


parcelRequire("9nZCP");

const $361241985471fc83$var$StyledChainAndAddress = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  flex-direction: row;
`;
const $361241985471fc83$var$StyledTruncatedAddress = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).a`
  display: flex;
  padding-top: 3.5px;
  color: ${({ theme: theme })=>theme.color.blue};
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;
const $361241985471fc83$var$ChainIcon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).svg`
  position: relative;
  width: 24px;
  height: 28px;
  fill: none;
  margin-right: 8px;
  padding-bottom: 2px;
`;
const $361241985471fc83$var$ChainAndAddress = ({ chainObject: chainObject, address: address })=>{
    const truncatedAddress = `${address.slice(0, 6)}...${address.slice(-4)}`;
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($361241985471fc83$var$StyledChainAndAddress, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($361241985471fc83$var$ChainIcon, {
                as: chainObject?.logo
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($361241985471fc83$var$StyledTruncatedAddress, {
                onClick: (event)=>event.stopPropagation(),
                href: `${chainObject?.blockExplorers?.default.url}/address/${address}`,
                target: "_blank",
                rel: "noreferrer",
                children: truncatedAddress
            })
        ]
    });
};
var $361241985471fc83$export$2e2bcd8739ae039 = $361241985471fc83$var$ChainAndAddress;



parcelRequire("9nZCP");


const $a0c3dd82c1066879$export$300a21b9577a7e8c = {
    Invalid: "lightRed",
    Taken: "lightYellow",
    Claimed: "turquoise",
    Challenged: "lightPurple",
    Verified: "darkBlue",
    Expired: "smoke",
    Resolving: "teal",
    Resolved: "green"
};
const $a0c3dd82c1066879$var$ColorWrapper = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  div {
    background-color: ${({ theme: theme, variant: variant })=>theme.color[$a0c3dd82c1066879$export$300a21b9577a7e8c[variant]]};
    pointer-events: none;
    p {
      color: ${({ theme: theme })=>theme.color.secondaryPurple};
      font-size: 14px;
      line-height: 17.5px;
    }
    width: 100px;
  }
`;
const $a0c3dd82c1066879$var$ColoredLabel = ({ text: text, variant: variant, ...props })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($a0c3dd82c1066879$var$ColorWrapper, {
        variant: variant,
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $48090fca70e3183a$exports.Tag), {
            as: "div",
            text: text
        })
    });
};
var $a0c3dd82c1066879$export$2e2bcd8739ae039 = $a0c3dd82c1066879$var$ColoredLabel;



parcelRequire("9nZCP");

const $6f58e40ae37406fb$var$StyledEpoch = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.color.lightBlue};
  width: 35%;
`;
const $6f58e40ae37406fb$var$Epoch = ({ epoch: epoch })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($6f58e40ae37406fb$var$StyledEpoch, {
        children: [
            epoch,
            " "
        ]
    });
};
var $6f58e40ae37406fb$export$2e2bcd8739ae039 = $6f58e40ae37406fb$var$Epoch;



parcelRequire("9nZCP");

const $90b4dd7079db3fe4$var$StyledTimestamp = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.color.lightBlue};
  white-space: nowrap;
`;
const $90b4dd7079db3fe4$var$Timestamp = ({ timestamp: timestamp })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($90b4dd7079db3fe4$var$StyledTimestamp, {
        children: [
            timestamp,
            " "
        ]
    });
};
var $90b4dd7079db3fe4$export$2e2bcd8739ae039 = $90b4dd7079db3fe4$var$Timestamp;



parcelRequire("9nZCP");
const $42625400cd5f5eea$var$SvgRightArrow = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 17 8",
        ...props,
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
            fill: "#DAF0FF",
            d: "M11.712 2.504H.93a.43.43 0 0 0-.429.428v2c0 .237.192.429.429.429h10.783v1.645c0 .764.923 1.146 1.463.606l3.074-3.074a.857.857 0 0 0 0-1.212L13.175.253c-.54-.54-1.463-.158-1.463.606z"
        })
    });
var $42625400cd5f5eea$export$2e2bcd8739ae039 = $42625400cd5f5eea$var$SvgRightArrow;



const $80147e58118402bc$var$StyledSnapshotAccordionTitle = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  width: 95%;
`;
const $80147e58118402bc$var$StyledChainsAndAddressesContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  color: ${({ theme: theme })=>theme.color.blue};
`;
const $80147e58118402bc$var$ArrowContainer = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  position: relative;
  padding-left: 18px;
  padding-right: 10px;
  padding-top: 3.5px;
`;
const $80147e58118402bc$var$StyledRightArrowIcon = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).svg`
  position: relative;
  width: 17px;
  height: 17px;
  fill: none;
`;
const $80147e58118402bc$var$StyledColoredLabel = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $a0c3dd82c1066879$export$2e2bcd8739ae039))`
  margin-left: auto;
  padding-right: calc(12px - (12) * (100vw - 370px) / (1250 - 370));
`;
const $80147e58118402bc$var$StyledEpochAndTimestamp = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: start;
  gap: 24px;
  margin-right: auto;
`;
const $80147e58118402bc$var$SnapshotAccordionTitle = ({ epoch: epoch, bridgeId: bridgeId, timestamp: timestamp, status: status })=>{
    const bridgeInfo = (0, $09cf9302bcaa1e97$export$f55bcf30472c04eb)(bridgeId);
    const titleParams = {
        epoch: epoch,
        timestamp: timestamp,
        fromChain: bridgeInfo.from,
        fromAddress: bridgeInfo.inboxAddress,
        toChain: bridgeInfo.to,
        toAddress: bridgeInfo.outboxAddress
    };
    const fromChainObject = (0, $09cf9302bcaa1e97$export$f4608058c83a1dc2)(titleParams.fromChain);
    const toChainObject = (0, $09cf9302bcaa1e97$export$f4608058c83a1dc2)(titleParams.toChain);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($80147e58118402bc$var$StyledSnapshotAccordionTitle, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($80147e58118402bc$var$StyledEpochAndTimestamp, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $6f58e40ae37406fb$export$2e2bcd8739ae039), {
                        epoch: epoch
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $90b4dd7079db3fe4$export$2e2bcd8739ae039), {
                        timestamp: titleParams.timestamp
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($80147e58118402bc$var$StyledChainsAndAddressesContainer, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $361241985471fc83$export$2e2bcd8739ae039), {
                        chainObject: fromChainObject,
                        address: titleParams.fromAddress
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($80147e58118402bc$var$ArrowContainer, {
                        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($80147e58118402bc$var$StyledRightArrowIcon, {
                            as: (0, $42625400cd5f5eea$export$2e2bcd8739ae039)
                        })
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $361241985471fc83$export$2e2bcd8739ae039), {
                        chainObject: toChainObject,
                        address: titleParams.toAddress
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($80147e58118402bc$var$StyledColoredLabel, {
                text: $80147e58118402bc$var$parseStatus(status),
                variant: $80147e58118402bc$var$parseStatus(status)
            })
        ]
    });
};
const $80147e58118402bc$var$parseStatus = ({ resolved: resolved, resolving: resolving, challenged: challenged, verified: verified, claimed: claimed })=>{
    if (resolved) return "Resolved";
    if (resolving) return "Resolving";
    if (challenged) return "Challenged";
    if (verified) return "Verified";
    if (claimed) return "Claimed";
    return "Taken";
};
var $80147e58118402bc$export$2e2bcd8739ae039 = $80147e58118402bc$var$SnapshotAccordionTitle;


const $e5f799b2a2d42e5b$var$StyledSnapshotAccordionGlobal = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.CustomAccordion))`
  display: flex;
  width: 100%;
  justify-content: center;

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    padding: 0px;
  `)}

  .accordion-button {
    border: 1px solid ${({ theme: theme })=>theme.color.secondaryBlue};
    border-radius: 3px;
    padding: 16px;
    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      padding: 16px calc(6px + (10) * (100vw - 370px) / (1250 - 370));
    `)}
  }

  .accordion-svg {
    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      align-self: end;
      margin-bottom: 9px;
    `)}
  }

  .accordion-item__Body-sc-17yp2l-2 {
    background-color: ${({ theme: theme })=>theme.color.secondaryPurple};
    border-right: 1px solid ${({ theme: theme })=>theme.color.secondaryBlue};
    border-left: 1px solid ${({ theme: theme })=>theme.color.secondaryBlue};
    border-bottom: 1px solid ${({ theme: theme })=>theme.color.secondaryBlue};
    border-radius: 3px;

    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      width: 100%;
      padding-left: 16px;
      padding-right: 16px;
    `)}
  }

  svg.accordion-svg path {
    fill: ${({ theme: theme })=>theme.color.blue};
  }
`;
const $e5f799b2a2d42e5b$var$SnapshotAccordion = ({ items: items })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($e5f799b2a2d42e5b$var$StyledSnapshotAccordionGlobal, {
        items: items.map(({ epoch: epoch, bridgeId: bridgeId, snapshotId: snapshotId, status: status, transactions: transactions }, index)=>({
                key: index,
                title: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $80147e58118402bc$export$2e2bcd8739ae039), {
                    epoch: epoch,
                    bridgeId: bridgeId,
                    timestamp: transactions[0].timestamp,
                    status: status
                }),
                body: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $c153625b6a77c81d$export$2e2bcd8739ae039), {
                    transactions: transactions,
                    snapshotId: snapshotId,
                    bridgeId: bridgeId,
                    epoch: epoch
                })
            }))
    });
};
var $e5f799b2a2d42e5b$export$2e2bcd8739ae039 = $e5f799b2a2d42e5b$var$SnapshotAccordion;



parcelRequire("9nZCP");




parcelRequire("9nZCP");



const $efe3c71ca462c92f$var$FilterItem = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.DropdownSelect))`
  .item-icon {
    margin-right: 8px;
    width: 16px;
    height: 16px;
  }
  h1 {
    font-family: "Oxanium";
    font-size: 14px;
    font-weight: 400;
    line-height: 17.5px;
  }
  svg {
    height: 8px;
    width: 8px;
  }

  p {
    font-family: "Open Sans";
  }

  .cOGsRq {
    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      right: auto;
    `)}
  }

  .iVPRzL {
    ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
      right: auto;
    `)}
  }
`;
const $efe3c71ca462c92f$export$d21937a90300cd7a = ({ isSimpleButton: isSimpleButton, isAlignRight: isAlignRight, itemData: itemData, value: value, callback: callback })=>{
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($efe3c71ca462c92f$var$FilterItem, {
        items: itemData,
        defaultValue: value,
        simpleButton: isSimpleButton,
        alignRight: isAlignRight,
        callback: callback
    });
};



parcelRequire("9nZCP");





parcelRequire("9nZCP");
const $6ae87482d2826a82$var$SvgGlobe = (props)=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("g", {
                clipPath: "url(#globe_svg__a)",
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                    fill: "#69C3FC",
                    d: "M7.946 0C3.565 0 0 3.589 0 8s3.565 8 7.946 8 7.946-3.589 7.946-8-3.565-8-7.946-8m7.079 8c0 .686-.097 1.35-.278 1.979h-2.95c.064-.648.101-1.312.101-1.975 0-.664-.037-1.327-.1-1.976h2.951c.18.627.276 1.288.276 1.972m-.64-2.96h-2.71c-.215-1.392-.583-2.668-1.1-3.657 1.688.682 3.056 2 3.81 3.658m-3.47 2.964c0 .685-.038 1.342-.102 1.975h-5.68a19.5 19.5 0 0 1 0-3.95h5.68c.064.632.101 1.29.101 1.975M9.138.974c.697.783 1.255 2.245 1.548 4.067H5.262c.295-1.83.856-3.298 1.558-4.078a7 7 0 0 1 2.32.011m-3.754.382c-.524.992-.897 2.279-1.11 3.685H1.506a7.14 7.14 0 0 1 3.879-3.685M4.149 9.979H1.145A7.2 7.2 0 0 1 .867 8c0-.684.096-1.345.275-1.972h3.01a20 20 0 0 0-.101 1.976c0 .663.037 1.327.098 1.975m-2.64.988h2.766c.215 1.402.587 2.685 1.109 3.677a7.14 7.14 0 0 1-3.874-3.677m5.303 4.069c-.698-.782-1.256-2.246-1.55-4.07h5.425c-.292 1.816-.847 3.274-1.54 4.058a7 7 0 0 1-2.335.012m3.772-.423c.514-.987.88-2.259 1.094-3.646h2.704a7.14 7.14 0 0 1-3.798 3.646"
                })
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("clipPath", {
                    id: "globe_svg__a",
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $6ae87482d2826a82$export$2e2bcd8739ae039 = $6ae87482d2826a82$var$SvgGlobe;



const $6eac17a8430cf77f$var$Container = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 50px;
  position: relative;
  right: 40px;
  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    right: 0px;
  `)}
`;
const $6eac17a8430cf77f$var$DropdownTag = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 4px;
  align-items: center;
  min-width: 140px;
  white-space: nowrap;
  small {
    font-size: 14px;
    line-height: 17.5px;
    color: ${({ theme: theme })=>theme.color.blue} !important;
  }
`;
const { toChains: $6eac17a8430cf77f$var$toChains, fromChains: $6eac17a8430cf77f$var$fromChains } = (0, $09cf9302bcaa1e97$export$4cc9423ec3f21f7c).reduce(({ toChains: toChains, fromChains: fromChains, uniqueToChains: uniqueToChains, uniqueFromChains: uniqueFromChains }, { to: to, from: from })=>{
    if (!uniqueFromChains.has(from)) {
        const fromChain = (0, $09cf9302bcaa1e97$export$f4608058c83a1dc2)(from);
        fromChains.push({
            text: fromChain.name,
            Icon: fromChain.logo,
            value: fromChain.id
        });
        uniqueFromChains.add(fromChain.id);
    }
    if (!uniqueToChains.has(to)) {
        const toChain = (0, $09cf9302bcaa1e97$export$f4608058c83a1dc2)(to);
        toChains.push({
            text: toChain.name,
            Icon: toChain.logo,
            value: toChain.id
        });
        uniqueToChains.add(toChain.id);
    }
    return {
        toChains: toChains,
        fromChains: fromChains,
        uniqueToChains: uniqueToChains,
        uniqueFromChains: uniqueFromChains
    };
}, {
    toChains: [
        {
            text: "All Networks",
            Icon: (0, $6ae87482d2826a82$export$2e2bcd8739ae039),
            value: 0
        }
    ],
    fromChains: [
        {
            text: "All Networks",
            Icon: (0, $6ae87482d2826a82$export$2e2bcd8739ae039),
            value: 0
        }
    ],
    uniqueToChains: new Set(),
    uniqueFromChains: new Set()
});
const $6eac17a8430cf77f$var$NetworkFilters = ()=>{
    const { fromChain: fromChain, setFromChain: setFromChain, toChain: toChain, setToChain: setToChain } = (0, $e2024cd18f4cfc15$export$616ead5bf0ef583b)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($6eac17a8430cf77f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($6eac17a8430cf77f$var$DropdownTag, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                        children: "From: "
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $efe3c71ca462c92f$export$d21937a90300cd7a), {
                        isAlignRight: false,
                        isSimpleButton: true,
                        itemData: $6eac17a8430cf77f$var$fromChains,
                        value: fromChain,
                        callback: setFromChain
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($6eac17a8430cf77f$var$DropdownTag, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                        children: "To: "
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $efe3c71ca462c92f$export$d21937a90300cd7a), {
                        isAlignRight: false,
                        isSimpleButton: true,
                        itemData: $6eac17a8430cf77f$var$toChains,
                        value: toChain,
                        callback: setToChain
                    })
                ]
            })
        ]
    });
};
var $6eac17a8430cf77f$export$2e2bcd8739ae039 = $6eac17a8430cf77f$var$NetworkFilters;


const $bda924adf6122334$var$HeaderText = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).h5`
  font-size: 24px;
  text-transform: lowercase;
  color: ${({ theme: theme })=>theme.color.lightBlue};
  line-height: 24px;
`;
const $bda924adf6122334$var$SnapshotHeader = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 64px;
  margin: 76px auto 24px auto;
  width: 100%;

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    margin-top: 60px;
  `)}
`;
const $bda924adf6122334$var$FilterHeader = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  margin-left: 33px;
  align-items: start;
  flex-wrap: wrap;
  justify-content: space-between;
  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    margin-left: calc(0px + (33) * (100vw - 370px) / (1250 - 370));
    gap: 12px;
  `)}
`;
const $bda924adf6122334$var$DropdownTag = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 4px;
  align-items: center;
  min-width: 140px;
  white-space: nowrap;
  small {
    font-size: 14px;
    line-height: 17.5px;
    color: ${({ theme: theme })=>theme.color.blue} !important;
  }
`;
const $bda924adf6122334$var$EpochAndTimeTag = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 30px;
  margin-right: 180px;
  small {
    font-family: "Oxanium";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme: theme })=>theme.color.lightBlue} !important;
  }

  ${(0, $108e5c20d852b43b$export$863f8b1efd907ec3)((0, $1d9bd5c523349ec4$export$dbf350e5966cf602)`
    display: none;
  `)}
`;
const $bda924adf6122334$var$TxFilterHeader = ()=>{
    const { statusItems: statusItems, statusFilter: statusFilter, setStatusFilter: setStatusFilter } = (0, $e2024cd18f4cfc15$export$616ead5bf0ef583b)();
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($bda924adf6122334$var$SnapshotHeader, {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($bda924adf6122334$var$HeaderText, {
                children: "Latest Snapshots"
            }),
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($bda924adf6122334$var$FilterHeader, {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($bda924adf6122334$var$EpochAndTimeTag, {
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                                children: "Epoch ID"
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                                children: "Timestamp"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $6eac17a8430cf77f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)($bda924adf6122334$var$DropdownTag, {
                        children: [
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("small", {
                                children: "Status: "
                            }),
                            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $efe3c71ca462c92f$export$d21937a90300cd7a), {
                                value: statusFilter,
                                isAlignRight: true,
                                isSimpleButton: true,
                                itemData: statusItems,
                                callback: setStatusFilter
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $bda924adf6122334$export$2e2bcd8739ae039 = $bda924adf6122334$var$TxFilterHeader;








const $8c6c9fa16133974c$export$b48399ba0dc32743 = (shownSnapshots = new Set(), lastTimestamp = "99999999999999", snapshotsPerPage = 5)=>{
    const { debouncedSearch: debouncedSearch, fromChain: fromChain, toChain: toChain, queryInfo: queryInfo, statusFilter: statusFilter } = (0, $e2024cd18f4cfc15$export$616ead5bf0ef583b)();
    return (0, $41c5ca5e5d716b88$export$2e2bcd8739ae039)(`${fromChain}${toChain}${lastTimestamp}${statusFilter}${debouncedSearch}`, async ()=>{
        const { sortedSnapshots: sortedSnapshots } = await $8c6c9fa16133974c$var$getSortedSnapshots(lastTimestamp, debouncedSearch, fromChain, toChain, snapshotsPerPage, queryInfo.query);
        const filteredSnapshots = sortedSnapshots.filter((snapshot)=>!shownSnapshots.has($8c6c9fa16133974c$export$62d6658c8a4d60c4(snapshot)));
        const pageSnapshots = filteredSnapshots.slice(0, snapshotsPerPage);
        return {
            snapshots: await Promise.all(pageSnapshots.map((snapshot)=>$8c6c9fa16133974c$var$getSecondaryData(snapshot, debouncedSearch, queryInfo.order))),
            isMorePages: filteredSnapshots.length > snapshotsPerPage
        };
    });
};
const $8c6c9fa16133974c$var$getSortedSnapshots = async (lastTimestamp, debouncedSearch, from, to, snapshotsPerPage, query)=>{
    const filteredBridges = (0, $09cf9302bcaa1e97$export$4cc9423ec3f21f7c).filter((bridge)=>{
        if (from > 0 && bridge.from !== from) return false;
        if (to > 0 && bridge.to !== to) return false;
        return true;
    });
    const queryQueue = filteredBridges.map((bridge)=>(0, $749779f5335cf90b$exports.request)($8c6c9fa16133974c$var$getEndpoint(query, bridge, debouncedSearch), $8c6c9fa16133974c$var$getQueryDocument(query, debouncedSearch), {
            lastTimestamp: lastTimestamp,
            snapshotsPerPage: snapshotsPerPage + 1,
            value: debouncedSearch
        }).then((queryResult)=>{
            const getSnapshots = ()=>{
                if (debouncedSearch) return queryResult.snapshotQuery;
                else if ((0, $e2024cd18f4cfc15$export$219a9e7e4111be17)(query)) return queryResult.snapshots;
                else return queryResult.claims;
            };
            return getSnapshots().map((snapshot)=>({
                    ...snapshot,
                    bridgeId: bridge.id
                }));
        }));
    const snapshotsWithBridgeId = await Promise.all(queryQueue).then((result)=>result.flat());
    return {
        sortedSnapshots: snapshotsWithBridgeId.sort((a, b)=>parseInt(b.timestamp) - parseInt(a.timestamp))
    };
};
const $8c6c9fa16133974c$var$getEndpoint = (query, bridge, debouncedSearch)=>(0, $e2024cd18f4cfc15$export$219a9e7e4111be17)(query) || debouncedSearch ? bridge.inboxEndpoint : bridge.outboxEndpoint;
const $8c6c9fa16133974c$var$getQueryDocument = (query, debouncedSearch)=>debouncedSearch ? (0, $a03d6ffb912da58e$export$a92bfde441f2bbcc) : query;
const $8c6c9fa16133974c$var$getSecondaryData = async (snapshot, debouncedSearch, order)=>{
    const isFirstInbox = order === (0, $e2024cd18f4cfc15$export$11e75bce9f7ea886).firstInbox;
    const secondaryData = await (0, $749779f5335cf90b$exports.request)(isFirstInbox || debouncedSearch !== "" ? (0, $09cf9302bcaa1e97$export$f55bcf30472c04eb)(snapshot.bridgeId).outboxEndpoint : (0, $09cf9302bcaa1e97$export$f55bcf30472c04eb)(snapshot.bridgeId).inboxEndpoint, isFirstInbox ? (0, $73d2804eda3376a0$export$4f062a25be074082) : (0, $a03d6ffb912da58e$export$2532f3c0a33feede), {
        epoch: snapshot.epoch.toString()
    }).then((result)=>isFirstInbox ? result.claims[0] : result.snapshots[0]);
    return isFirstInbox ? [
        snapshot,
        secondaryData
    ] : [
        {
            ...secondaryData,
            bridgeId: snapshot.bridgeId
        },
        snapshot
    ];
};
const $8c6c9fa16133974c$export$62d6658c8a4d60c4 = ({ bridgeId: bridgeId, epoch: epoch })=>`${bridgeId.toString() + epoch}`;




const $bd373448a29de4ba$export$5387f0ecb238326e = (snapshotsData)=>{
    return snapshotsData.map(([inboxData, outboxData])=>{
        const bridgeInfo = (0, $09cf9302bcaa1e97$export$4cc9423ec3f21f7c)[inboxData?.bridgeId];
        return {
            bridgeId: inboxData.bridgeId,
            epoch: inboxData.epoch,
            snapshotId: inboxData.id,
            status: {
                claimed: typeof outboxData?.txHash !== "undefined",
                verified: !outboxData?.challenged && outboxData?.verified,
                challenged: outboxData?.challenged,
                resolving: inboxData.resolving,
                resolved: outboxData?.challenged && outboxData?.verified
            },
            transactions: [
                {
                    title: "Creator",
                    chain: bridgeInfo?.from,
                    txHash: inboxData?.txHash,
                    timestamp: (0, $f5f6e6fed34aad3a$export$fc7b06d6a4abcacf)(inboxData?.timestamp),
                    caller: inboxData?.caller,
                    extraFields: [
                        {
                            key: "State Root",
                            value: inboxData?.stateRoot,
                            isCopy: true
                        }
                    ]
                },
                outboxData?.txHash && {
                    title: "Oracle",
                    chain: bridgeInfo?.to,
                    txHash: outboxData?.txHash,
                    timestamp: (0, $f5f6e6fed34aad3a$export$fc7b06d6a4abcacf)(outboxData?.timestamp),
                    caller: outboxData?.bridger,
                    extraFields: [
                        {
                            key: "State Root",
                            value: outboxData?.stateroot,
                            isCopy: true
                        }
                    ]
                },
                outboxData?.challenge?.txHash && {
                    title: "Challenger",
                    chain: bridgeInfo?.to,
                    txHash: outboxData?.challenge?.txHash,
                    timestamp: (0, $f5f6e6fed34aad3a$export$fc7b06d6a4abcacf)(outboxData?.challenge?.timestamp),
                    caller: outboxData?.challenge?.challenger
                },
                inboxData?.fallback[0]?.txHash && {
                    title: "Fallback Sender",
                    chain: bridgeInfo?.from,
                    txHash: inboxData?.fallback[0]?.txHash,
                    timestamp: (0, $f5f6e6fed34aad3a$export$fc7b06d6a4abcacf)(inboxData?.fallback[0]?.timestamp),
                    caller: inboxData?.fallback[0]?.executor
                },
                outboxData?.verification?.txHash && {
                    title: outboxData?.challenge?.txHash ? "Fallback Executor" : "Verifier",
                    chain: bridgeInfo?.to,
                    txHash: outboxData?.verification?.txHash,
                    timestamp: (0, $f5f6e6fed34aad3a$export$fc7b06d6a4abcacf)(outboxData?.verification?.timestamp),
                    caller: outboxData?.verification?.caller
                }
            ]
        };
    });
};



const $942d8e03bd4ba460$var$SNAPSHOTS_PER_PAGE = 5;
const $942d8e03bd4ba460$var$StyledPagination = (0, $1d9bd5c523349ec4$export$2e2bcd8739ae039)((0, $48090fca70e3183a$exports.StandardPagination))`
  margin-top: 32px;
  margin-left: auto;
`;
const $942d8e03bd4ba460$var$App = ()=>{
    const [currentPage, setCurrentPage] = (0, $9nZCP.useState)(1);
    const [pageTracking, { push: pushPageTracking, removeAt: removeAtPageTracking, clear: clearPageTracking }] = (0, $32382191dee5902a$export$2e2bcd8739ae039)();
    const { data: data } = (0, $8c6c9fa16133974c$export$b48399ba0dc32743)(pageTracking.at(-1)?.shownSnapshots, pageTracking.at(-1)?.timestamp, $942d8e03bd4ba460$var$SNAPSHOTS_PER_PAGE);
    const { fromChain: fromChain, toChain: toChain, statusFilter: statusFilter } = (0, $e2024cd18f4cfc15$export$616ead5bf0ef583b)();
    (0, $9nZCP.useEffect)(()=>{
        if (currentPage !== 1) {
            clearPageTracking();
            setCurrentPage(1);
        }
    }, [
        fromChain,
        toChain,
        statusFilter
    ]);
    const handlePageChange = (0, $9nZCP.useCallback)((newPage)=>{
        if (newPage > currentPage) pushPageTracking({
            timestamp: data?.snapshots.at(-1)?.[0].timestamp,
            shownSnapshots: new Set(data?.snapshots.map((snapshot)=>(0, $8c6c9fa16133974c$export$62d6658c8a4d60c4)(snapshot[0])))
        });
        else removeAtPageTracking(-1);
        setCurrentPage(newPage);
    }, [
        data,
        currentPage,
        pushPageTracking,
        removeAtPageTracking
    ]);
    return /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $aa09a620890829e8$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $bda924adf6122334$export$2e2bcd8739ae039), {}),
            data ? /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $dde41420777b5d34$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e5f799b2a2d42e5b$export$2e2bcd8739ae039), {
                        items: (0, $bd373448a29de4ba$export$5387f0ecb238326e)(data.snapshots)
                    }, currentPage),
                    /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($942d8e03bd4ba460$var$StyledPagination, {
                        numPages: data.isMorePages ? currentPage + 1 : currentPage,
                        currentPage: currentPage,
                        callback: handlePageChange,
                        hideNumbers: true
                    })
                ]
            }) : /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)("p", {
                children: "loading..."
            })
        ]
    });
};
var $942d8e03bd4ba460$export$2e2bcd8739ae039 = $942d8e03bd4ba460$var$App;


const $e5f162b07668c77b$var$WebApp = ()=>/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9nZCP))).StrictMode, {
        children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsxs)((0, $1d9bd5c523349ec4$export$d8964aec282183a3), {
            theme: $1b611c410e894fcf$export$bca14c5b3b88a9c9,
            children: [
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $12dd8b97d88addd6$export$f05794e648629f6c), {}),
                /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $e2024cd18f4cfc15$export$2e3feefe77201a07), {
                    children: /*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)((0, $942d8e03bd4ba460$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
const $e5f162b07668c77b$var$container = document.getElementById("app");
if ($e5f162b07668c77b$var$container) {
    const root = (0, $d6d573f2d6b6d1f8$export$882461b6382ed46c)($e5f162b07668c77b$var$container);
    root.render(/*#__PURE__*/ (0, $dde41420777b5d34$exports.jsx)($e5f162b07668c77b$var$WebApp, {}));
}

})();
//# sourceMappingURL=index.1380191f.js.map
